var HO = Object.defineProperty;
var BO = (e, t, n) => t in e ? HO(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ce = (e, t, n) => (BO(e, typeof t != "symbol" ? t + "" : t, n), n);
import * as b from "react";
import Oe, { createElement as it, useLayoutEffect as ii, forwardRef as pn, useRef as et, useEffect as st, useCallback as ot, Children as Hs, isValidElement as ic, cloneElement as Zc, Fragment as zO, useState as Vt, useMemo as Ar, createContext as ac, useContext as _h, useReducer as Dy, Component as YO } from "react";
import * as Xn from "react-dom";
import jO, { flushSync as Sh } from "react-dom";
function UO(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var xf = { exports: {} }, vi = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _m;
function GO() {
  if (_m)
    return vi;
  _m = 1;
  var e = Oe, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(a, l, c) {
    var u, d = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      r.call(l, u) && !s.hasOwnProperty(u) && (d[u] = l[u]);
    if (a && a.defaultProps)
      for (u in l = a.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: a, key: f, ref: h, props: d, _owner: o.current };
  }
  return vi.Fragment = n, vi.jsx = i, vi.jsxs = i, vi;
}
var yi = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Sm;
function KO() {
  return Sm || (Sm = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Oe, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = Symbol.iterator, g = "@@iterator";
    function m(z) {
      if (z === null || typeof z != "object")
        return null;
      var ue = p && z[p] || z[g];
      return typeof ue == "function" ? ue : null;
    }
    var v = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(z) {
      {
        for (var ue = arguments.length, Te = new Array(ue > 1 ? ue - 1 : 0), Ve = 1; Ve < ue; Ve++)
          Te[Ve - 1] = arguments[Ve];
        x("error", z, Te);
      }
    }
    function x(z, ue, Te) {
      {
        var Ve = v.ReactDebugCurrentFrame, Se = Ve.getStackAddendum();
        Se !== "" && (ue += "%s", Te = Te.concat([Se]));
        var lt = Te.map(function(rt) {
          return String(rt);
        });
        lt.unshift("Warning: " + ue), Function.prototype.apply.call(console[z], console, lt);
      }
    }
    var C = !1, w = !1, E = !1, S = !1, O = !1, M;
    M = Symbol.for("react.module.reference");
    function T(z) {
      return !!(typeof z == "string" || typeof z == "function" || z === r || z === s || O || z === o || z === c || z === u || S || z === h || C || w || E || typeof z == "object" && z !== null && (z.$$typeof === f || z.$$typeof === d || z.$$typeof === i || z.$$typeof === a || z.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      z.$$typeof === M || z.getModuleId !== void 0));
    }
    function P(z, ue, Te) {
      var Ve = z.displayName;
      if (Ve)
        return Ve;
      var Se = ue.displayName || ue.name || "";
      return Se !== "" ? Te + "(" + Se + ")" : Te;
    }
    function I(z) {
      return z.displayName || "Context";
    }
    function R(z) {
      if (z == null)
        return null;
      if (typeof z.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof z == "function")
        return z.displayName || z.name || null;
      if (typeof z == "string")
        return z;
      switch (z) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case o:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof z == "object")
        switch (z.$$typeof) {
          case a:
            var ue = z;
            return I(ue) + ".Consumer";
          case i:
            var Te = z;
            return I(Te._context) + ".Provider";
          case l:
            return P(z, z.render, "ForwardRef");
          case d:
            var Ve = z.displayName || null;
            return Ve !== null ? Ve : R(z.type) || "Memo";
          case f: {
            var Se = z, lt = Se._payload, rt = Se._init;
            try {
              return R(rt(lt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var D = Object.assign, k = 0, $, L, A, F, N, V, K;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function U() {
      {
        if (k === 0) {
          $ = console.log, L = console.info, A = console.warn, F = console.error, N = console.group, V = console.groupCollapsed, K = console.groupEnd;
          var z = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: z,
            log: z,
            warn: z,
            error: z,
            group: z,
            groupCollapsed: z,
            groupEnd: z
          });
        }
        k++;
      }
    }
    function j() {
      {
        if (k--, k === 0) {
          var z = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: D({}, z, {
              value: $
            }),
            info: D({}, z, {
              value: L
            }),
            warn: D({}, z, {
              value: A
            }),
            error: D({}, z, {
              value: F
            }),
            group: D({}, z, {
              value: N
            }),
            groupCollapsed: D({}, z, {
              value: V
            }),
            groupEnd: D({}, z, {
              value: K
            })
          });
        }
        k < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var H = v.ReactCurrentDispatcher, q;
    function B(z, ue, Te) {
      {
        if (q === void 0)
          try {
            throw Error();
          } catch (Se) {
            var Ve = Se.stack.trim().match(/\n( *(at )?)/);
            q = Ve && Ve[1] || "";
          }
        return `
` + q + z;
      }
    }
    var X = !1, te;
    {
      var J = typeof WeakMap == "function" ? WeakMap : Map;
      te = new J();
    }
    function G(z, ue) {
      if (!z || X)
        return "";
      {
        var Te = te.get(z);
        if (Te !== void 0)
          return Te;
      }
      var Ve;
      X = !0;
      var Se = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var lt;
      lt = H.current, H.current = null, U();
      try {
        if (ue) {
          var rt = function() {
            throw Error();
          };
          if (Object.defineProperty(rt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(rt, []);
            } catch (Pn) {
              Ve = Pn;
            }
            Reflect.construct(z, [], rt);
          } else {
            try {
              rt.call();
            } catch (Pn) {
              Ve = Pn;
            }
            z.call(rt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Pn) {
            Ve = Pn;
          }
          z();
        }
      } catch (Pn) {
        if (Pn && Ve && typeof Pn.stack == "string") {
          for (var Je = Pn.stack.split(`
`), Gt = Ve.stack.split(`
`), Ft = Je.length - 1, zt = Gt.length - 1; Ft >= 1 && zt >= 0 && Je[Ft] !== Gt[zt]; )
            zt--;
          for (; Ft >= 1 && zt >= 0; Ft--, zt--)
            if (Je[Ft] !== Gt[zt]) {
              if (Ft !== 1 || zt !== 1)
                do
                  if (Ft--, zt--, zt < 0 || Je[Ft] !== Gt[zt]) {
                    var Mn = `
` + Je[Ft].replace(" at new ", " at ");
                    return z.displayName && Mn.includes("<anonymous>") && (Mn = Mn.replace("<anonymous>", z.displayName)), typeof z == "function" && te.set(z, Mn), Mn;
                  }
                while (Ft >= 1 && zt >= 0);
              break;
            }
        }
      } finally {
        X = !1, H.current = lt, j(), Error.prepareStackTrace = Se;
      }
      var Hn = z ? z.displayName || z.name : "", yr = Hn ? B(Hn) : "";
      return typeof z == "function" && te.set(z, yr), yr;
    }
    function ne(z, ue, Te) {
      return G(z, !1);
    }
    function Q(z) {
      var ue = z.prototype;
      return !!(ue && ue.isReactComponent);
    }
    function re(z, ue, Te) {
      if (z == null)
        return "";
      if (typeof z == "function")
        return G(z, Q(z));
      if (typeof z == "string")
        return B(z);
      switch (z) {
        case c:
          return B("Suspense");
        case u:
          return B("SuspenseList");
      }
      if (typeof z == "object")
        switch (z.$$typeof) {
          case l:
            return ne(z.render);
          case d:
            return re(z.type, ue, Te);
          case f: {
            var Ve = z, Se = Ve._payload, lt = Ve._init;
            try {
              return re(lt(Se), ue, Te);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, le = {}, Ee = v.ReactDebugCurrentFrame;
    function se(z) {
      if (z) {
        var ue = z._owner, Te = re(z.type, z._source, ue ? ue.type : null);
        Ee.setExtraStackFrame(Te);
      } else
        Ee.setExtraStackFrame(null);
    }
    function _e(z, ue, Te, Ve, Se) {
      {
        var lt = Function.call.bind(fe);
        for (var rt in z)
          if (lt(z, rt)) {
            var Je = void 0;
            try {
              if (typeof z[rt] != "function") {
                var Gt = Error((Ve || "React class") + ": " + Te + " type `" + rt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof z[rt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Gt.name = "Invariant Violation", Gt;
              }
              Je = z[rt](ue, rt, Ve, Te, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ft) {
              Je = Ft;
            }
            Je && !(Je instanceof Error) && (se(Se), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ve || "React class", Te, rt, typeof Je), se(null)), Je instanceof Error && !(Je.message in le) && (le[Je.message] = !0, se(Se), y("Failed %s type: %s", Te, Je.message), se(null));
          }
      }
    }
    var xe = Array.isArray;
    function ge(z) {
      return xe(z);
    }
    function ae(z) {
      {
        var ue = typeof Symbol == "function" && Symbol.toStringTag, Te = ue && z[Symbol.toStringTag] || z.constructor.name || "Object";
        return Te;
      }
    }
    function W(z) {
      try {
        return Z(z), !1;
      } catch {
        return !0;
      }
    }
    function Z(z) {
      return "" + z;
    }
    function me(z) {
      if (W(z))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ae(z)), Z(z);
    }
    var ie = v.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, he, Re, Ae;
    Ae = {};
    function Ue(z) {
      if (fe.call(z, "ref")) {
        var ue = Object.getOwnPropertyDescriptor(z, "ref").get;
        if (ue && ue.isReactWarning)
          return !1;
      }
      return z.ref !== void 0;
    }
    function Ke(z) {
      if (fe.call(z, "key")) {
        var ue = Object.getOwnPropertyDescriptor(z, "key").get;
        if (ue && ue.isReactWarning)
          return !1;
      }
      return z.key !== void 0;
    }
    function Be(z, ue) {
      if (typeof z.ref == "string" && ie.current && ue && ie.current.stateNode !== ue) {
        var Te = R(ie.current.type);
        Ae[Te] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', R(ie.current.type), z.ref), Ae[Te] = !0);
      }
    }
    function nt(z, ue) {
      {
        var Te = function() {
          he || (he = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ue));
        };
        Te.isReactWarning = !0, Object.defineProperty(z, "key", {
          get: Te,
          configurable: !0
        });
      }
    }
    function at(z, ue) {
      {
        var Te = function() {
          Re || (Re = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ue));
        };
        Te.isReactWarning = !0, Object.defineProperty(z, "ref", {
          get: Te,
          configurable: !0
        });
      }
    }
    var Wt = function(z, ue, Te, Ve, Se, lt, rt) {
      var Je = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: z,
        key: ue,
        ref: Te,
        props: rt,
        // Record the component responsible for creating this element.
        _owner: lt
      };
      return Je._store = {}, Object.defineProperty(Je._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Je, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ve
      }), Object.defineProperty(Je, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Se
      }), Object.freeze && (Object.freeze(Je.props), Object.freeze(Je)), Je;
    };
    function Mt(z, ue, Te, Ve, Se) {
      {
        var lt, rt = {}, Je = null, Gt = null;
        Te !== void 0 && (me(Te), Je = "" + Te), Ke(ue) && (me(ue.key), Je = "" + ue.key), Ue(ue) && (Gt = ue.ref, Be(ue, Se));
        for (lt in ue)
          fe.call(ue, lt) && !oe.hasOwnProperty(lt) && (rt[lt] = ue[lt]);
        if (z && z.defaultProps) {
          var Ft = z.defaultProps;
          for (lt in Ft)
            rt[lt] === void 0 && (rt[lt] = Ft[lt]);
        }
        if (Je || Gt) {
          var zt = typeof z == "function" ? z.displayName || z.name || "Unknown" : z;
          Je && nt(rt, zt), Gt && at(rt, zt);
        }
        return Wt(z, Je, Gt, Se, Ve, ie.current, rt);
      }
    }
    var Bt = v.ReactCurrentOwner, Qt = v.ReactDebugCurrentFrame;
    function Pe(z) {
      if (z) {
        var ue = z._owner, Te = re(z.type, z._source, ue ? ue.type : null);
        Qt.setExtraStackFrame(Te);
      } else
        Qt.setExtraStackFrame(null);
    }
    var Ge;
    Ge = !1;
    function Le(z) {
      return typeof z == "object" && z !== null && z.$$typeof === t;
    }
    function be() {
      {
        if (Bt.current) {
          var z = R(Bt.current.type);
          if (z)
            return `

Check the render method of \`` + z + "`.";
        }
        return "";
      }
    }
    function Ye(z) {
      {
        if (z !== void 0) {
          var ue = z.fileName.replace(/^.*[\\\/]/, ""), Te = z.lineNumber;
          return `

Check your code at ` + ue + ":" + Te + ".";
        }
        return "";
      }
    }
    var Tt = {};
    function je(z) {
      {
        var ue = be();
        if (!ue) {
          var Te = typeof z == "string" ? z : z.displayName || z.name;
          Te && (ue = `

Check the top-level render call using <` + Te + ">.");
        }
        return ue;
      }
    }
    function Rt(z, ue) {
      {
        if (!z._store || z._store.validated || z.key != null)
          return;
        z._store.validated = !0;
        var Te = je(ue);
        if (Tt[Te])
          return;
        Tt[Te] = !0;
        var Ve = "";
        z && z._owner && z._owner !== Bt.current && (Ve = " It was passed a child from " + R(z._owner.type) + "."), Pe(z), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Te, Ve), Pe(null);
      }
    }
    function On(z, ue) {
      {
        if (typeof z != "object")
          return;
        if (ge(z))
          for (var Te = 0; Te < z.length; Te++) {
            var Ve = z[Te];
            Le(Ve) && Rt(Ve, ue);
          }
        else if (Le(z))
          z._store && (z._store.validated = !0);
        else if (z) {
          var Se = m(z);
          if (typeof Se == "function" && Se !== z.entries)
            for (var lt = Se.call(z), rt; !(rt = lt.next()).done; )
              Le(rt.value) && Rt(rt.value, ue);
        }
      }
    }
    function vt(z) {
      {
        var ue = z.type;
        if (ue == null || typeof ue == "string")
          return;
        var Te;
        if (typeof ue == "function")
          Te = ue.propTypes;
        else if (typeof ue == "object" && (ue.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ue.$$typeof === d))
          Te = ue.propTypes;
        else
          return;
        if (Te) {
          var Ve = R(ue);
          _e(Te, z.props, "prop", Ve, z);
        } else if (ue.PropTypes !== void 0 && !Ge) {
          Ge = !0;
          var Se = R(ue);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Se || "Unknown");
        }
        typeof ue.getDefaultProps == "function" && !ue.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function er(z) {
      {
        for (var ue = Object.keys(z.props), Te = 0; Te < ue.length; Te++) {
          var Ve = ue[Te];
          if (Ve !== "children" && Ve !== "key") {
            Pe(z), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ve), Pe(null);
            break;
          }
        }
        z.ref !== null && (Pe(z), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    function Jt(z, ue, Te, Ve, Se, lt) {
      {
        var rt = T(z);
        if (!rt) {
          var Je = "";
          (z === void 0 || typeof z == "object" && z !== null && Object.keys(z).length === 0) && (Je += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Gt = Ye(Se);
          Gt ? Je += Gt : Je += be();
          var Ft;
          z === null ? Ft = "null" : ge(z) ? Ft = "array" : z !== void 0 && z.$$typeof === t ? (Ft = "<" + (R(z.type) || "Unknown") + " />", Je = " Did you accidentally export a JSX literal instead of a component?") : Ft = typeof z, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ft, Je);
        }
        var zt = Mt(z, ue, Te, Se, lt);
        if (zt == null)
          return zt;
        if (rt) {
          var Mn = ue.children;
          if (Mn !== void 0)
            if (Ve)
              if (ge(Mn)) {
                for (var Hn = 0; Hn < Mn.length; Hn++)
                  On(Mn[Hn], z);
                Object.freeze && Object.freeze(Mn);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              On(Mn, z);
        }
        return z === r ? er(zt) : vt(zt), zt;
      }
    }
    function vn(z, ue, Te) {
      return Jt(z, ue, Te, !0);
    }
    function ho(z, ue, Te) {
      return Jt(z, ue, Te, !1);
    }
    var po = ho, vr = vn;
    yi.Fragment = r, yi.jsx = po, yi.jsxs = vr;
  }()), yi;
}
process.env.NODE_ENV === "production" ? xf.exports = GO() : xf.exports = KO();
var Oh = xf.exports;
const In = Oh.Fragment, _ = Oh.jsx, ee = Oh.jsxs;
function Ny(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = Ny(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function Ay() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = Ny(e)) && (r && (r += " "), r += t);
  return r;
}
const Om = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, Mm = Ay, Qn = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return Mm(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: s } = t, i = Object.keys(o).map((c) => {
    const u = n == null ? void 0 : n[c], d = s == null ? void 0 : s[c];
    if (u === null)
      return null;
    const f = Om(u) || Om(d);
    return o[c][f];
  }), a = n && Object.entries(n).reduce((c, u) => {
    let [d, f] = u;
    return f === void 0 || (c[d] = f), c;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, u) => {
    let { class: d, className: f, ...h } = u;
    return Object.entries(h).every((p) => {
      let [g, m] = p;
      return Array.isArray(m) ? m.includes({
        ...s,
        ...a
      }[g]) : {
        ...s,
        ...a
      }[g] === m;
    }) ? [
      ...c,
      d,
      f
    ] : c;
  }, []);
  return Mm(e, i, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function qO(e, t) {
  return function(r, ...o) {
    const s = new URL(e);
    return s.searchParams.set("code", r.toString()), o.forEach((i) => s.searchParams.append("args[]", i)), `${t} error #${r}; visit ${s} for the full message.`;
  };
}
const XO = qO("https://base-ui.com/production-error", "Base UI"), tt = XO, Tm = {};
function bn(e, t) {
  const n = b.useRef(Tm);
  return n.current === Tm && (n.current = e(t)), n;
}
function ar(e, t, n, r) {
  const o = bn($y).current;
  return QO(o, e, t, n, r) && Fy(o, [e, t, n, r]), o.callback;
}
function ZO(e) {
  const t = bn($y).current;
  return JO(t, e) && Fy(t, e), t.callback;
}
function $y() {
  return {
    callback: null,
    cleanup: null,
    refs: []
  };
}
function QO(e, t, n, r, o) {
  return e.refs[0] !== t || e.refs[1] !== n || e.refs[2] !== r || e.refs[3] !== o;
}
function JO(e, t) {
  return e.refs.length !== t.length || e.refs.some((n, r) => n !== t[r]);
}
function Fy(e, t) {
  if (e.refs = t, t.every((n) => n == null)) {
    e.callback = null;
    return;
  }
  e.callback = (n) => {
    if (e.cleanup && (e.cleanup(), e.cleanup = null), n != null) {
      const r = Array(t.length).fill(null);
      for (let o = 0; o < t.length; o += 1) {
        const s = t[o];
        if (s != null)
          switch (typeof s) {
            case "function": {
              const i = s(n);
              typeof i == "function" && (r[o] = i);
              break;
            }
            case "object": {
              s.current = n;
              break;
            }
          }
      }
      e.cleanup = () => {
        for (let o = 0; o < t.length; o += 1) {
          const s = t[o];
          if (s != null)
            switch (typeof s) {
              case "function": {
                const i = r[o];
                typeof i == "function" ? i() : s(null);
                break;
              }
              case "object": {
                s.current = null;
                break;
              }
            }
        }
      };
    }
  };
}
const eM = parseInt(b.version, 10);
function Mh(e) {
  return eM >= e;
}
function Rm(e) {
  if (!/* @__PURE__ */ b.isValidElement(e))
    return null;
  const t = e, n = t.props;
  return (Mh(19) ? n == null ? void 0 : n.ref : t.ref) ?? null;
}
function wf(e, t) {
  if (e && !t)
    return e;
  if (!e && t)
    return t;
  if (e || t)
    return {
      ...e,
      ...t
    };
}
let Cf;
process.env.NODE_ENV !== "production" && (Cf = /* @__PURE__ */ new Set());
function Qc(...e) {
  if (process.env.NODE_ENV !== "production") {
    const t = e.join(" ");
    Cf.has(t) || (Cf.add(t), console.warn(`Base UI: ${t}`));
  }
}
function Nt() {
}
const Gn = Object.freeze([]), At = Object.freeze({});
function tM(e, t) {
  const n = {};
  for (const r in e) {
    const o = e[r];
    if (t != null && t.hasOwnProperty(r)) {
      const s = t[r](o);
      s != null && Object.assign(n, s);
      continue;
    }
    o === !0 ? n[`data-${r.toLowerCase()}`] = "" : o && (n[`data-${r.toLowerCase()}`] = o.toString());
  }
  return n;
}
function nM(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ly(e, t) {
  return typeof e == "function" ? e(t) : e;
}
const Th = {};
function _n(e, t, n, r, o) {
  if (!n && !r && !o && !e)
    return lc(t);
  let s = lc(e);
  return t && (s = Li(s, t)), n && (s = Li(s, n)), r && (s = Li(s, r)), o && (s = Li(s, o)), s;
}
function rM(e) {
  if (e.length === 0)
    return Th;
  if (e.length === 1)
    return lc(e[0]);
  let t = lc(e[0]);
  for (let n = 1; n < e.length; n += 1)
    t = Li(t, e[n]);
  return t;
}
function lc(e) {
  return Rh(e) ? {
    ...Wy(e, Th)
  } : oM(e);
}
function Li(e, t) {
  return Rh(t) ? Wy(t, e) : sM(e, t);
}
function oM(e) {
  const t = {
    ...e
  };
  for (const n in t) {
    const r = t[n];
    Vy(n, r) && (t[n] = Hy(r));
  }
  return t;
}
function sM(e, t) {
  if (!t)
    return e;
  for (const n in t) {
    const r = t[n];
    switch (n) {
      case "style": {
        e[n] = wf(e.style, r);
        break;
      }
      case "className": {
        e[n] = By(e.className, r);
        break;
      }
      default:
        Vy(n, r) ? e[n] = iM(e[n], r) : e[n] = r;
    }
  }
  return e;
}
function Vy(e, t) {
  const n = e.charCodeAt(0), r = e.charCodeAt(1), o = e.charCodeAt(2);
  return n === 111 && r === 110 && o >= 65 && o <= 90 && (typeof t == "function" || typeof t > "u");
}
function Rh(e) {
  return typeof e == "function";
}
function Wy(e, t) {
  return Rh(e) ? e(t) : e ?? Th;
}
function iM(e, t) {
  return t ? e ? (...n) => {
    const r = n[0];
    if (zy(r)) {
      const s = r;
      cc(s);
      const i = t(...n);
      return s.baseUIHandlerPrevented || e == null || e(...n), i;
    }
    const o = t(...n);
    return e == null || e(...n), o;
  } : Hy(t) : e;
}
function Hy(e) {
  return e && ((...t) => {
    const n = t[0];
    return zy(n) && cc(n), e(...t);
  });
}
function cc(e) {
  return e.preventBaseUIHandler = () => {
    e.baseUIHandlerPrevented = !0;
  }, e;
}
function By(e, t) {
  return t ? e ? t + " " + e : t : e;
}
function zy(e) {
  return e != null && typeof e == "object" && "nativeEvent" in e;
}
function We(e, t, n = {}) {
  const r = t.render, o = aM(t, n);
  if (n.enabled === !1)
    return null;
  const s = n.state ?? At;
  return fM(e, r, o, s);
}
function aM(e, t = {}) {
  const {
    className: n,
    style: r,
    render: o
  } = e, {
    state: s = At,
    ref: i,
    props: a,
    stateAttributesMapping: l,
    enabled: c = !0
  } = t, u = c ? nM(n, s) : void 0, d = c ? Ly(r, s) : void 0, f = c ? tM(s, l) : At, h = c && a ? lM(a) : void 0, p = c ? wf(f, h) ?? {} : At;
  return typeof document < "u" && (c ? Array.isArray(i) ? p.ref = ZO([p.ref, Rm(o), ...i]) : p.ref = ar(p.ref, Rm(o), i) : ar(null, null)), c ? (u !== void 0 && (p.className = By(p.className, u)), d !== void 0 && (p.style = wf(p.style, d)), p) : At;
}
function lM(e) {
  return Array.isArray(e) ? rM(e) : _n(void 0, e);
}
const cM = Symbol.for("react.lazy"), uM = /^[A-Z][A-Za-z0-9$]*$/, dM = /[a-z]/;
function fM(e, t, n, r) {
  if (t) {
    if (typeof t == "function")
      return process.env.NODE_ENV !== "production" && hM(t), t(n, r);
    const o = _n(n, t.props);
    o.ref = n.ref;
    let s = t;
    if ((s == null ? void 0 : s.$$typeof) === cM && (s = b.Children.toArray(t)[0]), process.env.NODE_ENV !== "production" && !/* @__PURE__ */ b.isValidElement(s))
      throw new Error(["Base UI: The `render` prop was provided an invalid React element as `React.isValidElement(render)` is `false`.", "A valid React element must be provided to the `render` prop because it is cloned with props to replace the default element.", "https://base-ui.com/r/invalid-render-prop"].join(`
`));
    return /* @__PURE__ */ b.cloneElement(s, o);
  }
  if (e && typeof e == "string")
    return pM(e, n);
  throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: Render element or function are not defined." : tt(8));
}
function hM(e) {
  const t = e.name;
  t.length !== 0 && uM.test(t) && dM.test(t) && Qc(`The \`render\` prop received a function named \`${t}\` that starts with an uppercase letter.`, "This usually means a React component was passed directly as `render={Component}`.", "Base UI calls `render` as a plain function, which can break the Rules of Hooks during reconciliation.", "If this is an intentional render callback, rename it to start with a lowercase letter.", "Use `render={<Component />}` or `render={(props) => <Component {...props} />}` instead.", "https://base-ui.com/r/invalid-render-prop");
}
function pM(e, t) {
  return e === "button" ? /* @__PURE__ */ it("button", {
    type: "button",
    ...t,
    key: t.key
  }) : e === "img" ? /* @__PURE__ */ it("img", {
    alt: "",
    ...t,
    key: t.key
  }) : /* @__PURE__ */ b.createElement(e, t);
}
function ai(e) {
  return We(e.defaultTagName ?? "div", e, e);
}
function gM() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = Yy(t)) && (r && (r += " "), r += n);
  return r;
}
function Yy(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", r = 0; r < e.length; r++)
    e[r] && (t = Yy(e[r])) && (n && (n += " "), n += t);
  return n;
}
var Ph = "-";
function mM(e) {
  var t = vM(e), n = e.conflictingClassGroups, r = e.conflictingClassGroupModifiers, o = r === void 0 ? {} : r;
  function s(a) {
    var l = a.split(Ph);
    return l[0] === "" && l.length !== 1 && l.shift(), jy(l, t) || bM(a);
  }
  function i(a, l) {
    var c = n[a] || [];
    return l && o[a] ? [].concat(c, o[a]) : c;
  }
  return {
    getClassGroupId: s,
    getConflictingClassGroupIds: i
  };
}
function jy(e, t) {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], r = t.nextPart.get(n), o = r ? jy(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length !== 0) {
    var s = e.join(Ph);
    return (i = t.validators.find(function(a) {
      var l = a.validator;
      return l(s);
    })) == null ? void 0 : i.classGroupId;
  }
}
var Pm = /^\[(.+)\]$/;
function bM(e) {
  if (Pm.test(e)) {
    var t = Pm.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function vM(e) {
  var t = e.theme, n = e.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, o = xM(Object.entries(e.classGroups), n);
  return o.forEach(function(s) {
    var i = s[0], a = s[1];
    Ef(a, r, i, t);
  }), r;
}
function Ef(e, t, n, r) {
  e.forEach(function(o) {
    if (typeof o == "string") {
      var s = o === "" ? t : Im(t, o);
      s.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (yM(o)) {
        Ef(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(function(i) {
      var a = i[0], l = i[1];
      Ef(l, Im(t, a), n, r);
    });
  });
}
function Im(e, t) {
  var n = e;
  return t.split(Ph).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function yM(e) {
  return e.isThemeGetter;
}
function xM(e, t) {
  return t ? e.map(function(n) {
    var r = n[0], o = n[1], s = o.map(function(i) {
      return typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(function(a) {
        var l = a[0], c = a[1];
        return [t + l, c];
      })) : i;
    });
    return [r, s];
  }) : e;
}
function wM(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function o(s, i) {
    n.set(s, i), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(i) {
      var a = n.get(i);
      if (a !== void 0)
        return a;
      if ((a = r.get(i)) !== void 0)
        return o(i, a), a;
    },
    set: function(i, a) {
      n.has(i) ? n.set(i, a) : o(i, a);
    }
  };
}
var Uy = "!";
function CM(e) {
  var t = e.separator || ":", n = t.length === 1, r = t[0], o = t.length;
  return function(i) {
    for (var a = [], l = 0, c = 0, u, d = 0; d < i.length; d++) {
      var f = i[d];
      if (l === 0) {
        if (f === r && (n || i.slice(d, d + o) === t)) {
          a.push(i.slice(c, d)), c = d + o;
          continue;
        }
        if (f === "/") {
          u = d;
          continue;
        }
      }
      f === "[" ? l++ : f === "]" && l--;
    }
    var h = a.length === 0 ? i : i.substring(c), p = h.startsWith(Uy), g = p ? h.substring(1) : h, m = u && u > c ? u - c : void 0;
    return {
      modifiers: a,
      hasImportantModifier: p,
      baseClassName: g,
      maybePostfixModifierPosition: m
    };
  };
}
function EM(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(r) {
    var o = r[0] === "[";
    o ? (t.push.apply(t, n.sort().concat([r])), n = []) : n.push(r);
  }), t.push.apply(t, n.sort()), t;
}
function _M(e) {
  return {
    cache: wM(e.cacheSize),
    splitModifiers: CM(e),
    ...mM(e)
  };
}
var SM = /\s+/;
function OM(e, t) {
  var n = t.splitModifiers, r = t.getClassGroupId, o = t.getConflictingClassGroupIds, s = /* @__PURE__ */ new Set();
  return e.trim().split(SM).map(function(i) {
    var a = n(i), l = a.modifiers, c = a.hasImportantModifier, u = a.baseClassName, d = a.maybePostfixModifierPosition, f = r(d ? u.substring(0, d) : u), h = !!d;
    if (!f) {
      if (!d)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      if (f = r(u), !f)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      h = !1;
    }
    var p = EM(l).join(":"), g = c ? p + Uy : p;
    return {
      isTailwindClass: !0,
      modifierId: g,
      classGroupId: f,
      originalClassName: i,
      hasPostfixModifier: h
    };
  }).reverse().filter(function(i) {
    if (!i.isTailwindClass)
      return !0;
    var a = i.modifierId, l = i.classGroupId, c = i.hasPostfixModifier, u = a + l;
    return s.has(u) ? !1 : (s.add(u), o(l, c).forEach(function(d) {
      return s.add(a + d);
    }), !0);
  }).reverse().map(function(i) {
    return i.originalClassName;
  }).join(" ");
}
function MM() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, o, s, i = a;
  function a(c) {
    var u = t[0], d = t.slice(1), f = d.reduce(function(h, p) {
      return p(h);
    }, u());
    return r = _M(f), o = r.cache.get, s = r.cache.set, i = l, l(c);
  }
  function l(c) {
    var u = o(c);
    if (u)
      return u;
    var d = OM(c, r);
    return s(c, d), d;
  }
  return function() {
    return i(gM.apply(null, arguments));
  };
}
function Yt(e) {
  var t = function(r) {
    return r[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var Gy = /^\[(?:([a-z-]+):)?(.+)\]$/i, TM = /^\d+\/\d+$/, RM = /* @__PURE__ */ new Set(["px", "full", "screen"]), PM = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, IM = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, kM = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function fr(e) {
  return rs(e) || RM.has(e) || TM.test(e) || _f(e);
}
function _f(e) {
  return ms(e, "length", LM);
}
function DM(e) {
  return ms(e, "size", Ky);
}
function NM(e) {
  return ms(e, "position", Ky);
}
function AM(e) {
  return ms(e, "url", VM);
}
function ol(e) {
  return ms(e, "number", rs);
}
function rs(e) {
  return !Number.isNaN(Number(e));
}
function $M(e) {
  return e.endsWith("%") && rs(e.slice(0, -1));
}
function xi(e) {
  return km(e) || ms(e, "number", km);
}
function ct(e) {
  return Gy.test(e);
}
function wi() {
  return !0;
}
function go(e) {
  return PM.test(e);
}
function FM(e) {
  return ms(e, "", WM);
}
function ms(e, t, n) {
  var r = Gy.exec(e);
  return r ? r[1] ? r[1] === t : n(r[2]) : !1;
}
function LM(e) {
  return IM.test(e);
}
function Ky() {
  return !1;
}
function VM(e) {
  return e.startsWith("url(");
}
function km(e) {
  return Number.isInteger(Number(e));
}
function WM(e) {
  return kM.test(e);
}
function HM() {
  var e = Yt("colors"), t = Yt("spacing"), n = Yt("blur"), r = Yt("brightness"), o = Yt("borderColor"), s = Yt("borderRadius"), i = Yt("borderSpacing"), a = Yt("borderWidth"), l = Yt("contrast"), c = Yt("grayscale"), u = Yt("hueRotate"), d = Yt("invert"), f = Yt("gap"), h = Yt("gradientColorStops"), p = Yt("gradientColorStopPositions"), g = Yt("inset"), m = Yt("margin"), v = Yt("opacity"), y = Yt("padding"), x = Yt("saturate"), C = Yt("scale"), w = Yt("sepia"), E = Yt("skew"), S = Yt("space"), O = Yt("translate"), M = function() {
    return ["auto", "contain", "none"];
  }, T = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, P = function() {
    return ["auto", ct, t];
  }, I = function() {
    return [ct, t];
  }, R = function() {
    return ["", fr];
  }, D = function() {
    return ["auto", rs, ct];
  }, k = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, $ = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, L = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, A = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, F = function() {
    return ["", "0", ct];
  }, N = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, V = function() {
    return [rs, ol];
  }, K = function() {
    return [rs, ct];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [wi],
      spacing: [fr],
      blur: ["none", "", go, ct],
      brightness: V(),
      borderColor: [e],
      borderRadius: ["none", "", "full", go, ct],
      borderSpacing: I(),
      borderWidth: R(),
      contrast: V(),
      grayscale: F(),
      hueRotate: K(),
      invert: F(),
      gap: I(),
      gradientColorStops: [e],
      gradientColorStopPositions: [$M, _f],
      inset: P(),
      margin: P(),
      opacity: V(),
      padding: I(),
      saturate: V(),
      scale: V(),
      sepia: F(),
      skew: K(),
      space: I(),
      translate: I()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", ct]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [go]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": N()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": N()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(k(), [ct])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: T()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": T()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": T()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: M()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": M()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": M()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", xi]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: P()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", ct]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: F()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: F()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", xi]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [wi]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", xi]
        }, ct]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": D()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": D()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [wi]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [xi]
        }, ct]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": D()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": D()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", ct]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", ct]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(A())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(A(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(A(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [y]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [y]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [y]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [y]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [y]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [y]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [y]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [y]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [y]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [S]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [S]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", ct, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", ct, fr]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [go]
        }, go, ct]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [ct, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", ct, fr]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [ct, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", go, _f]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", ol]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [wi]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", ct]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", rs, ol]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", ct, fr]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ct]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", ct]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [v]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [v]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat($(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", fr]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", ct, fr]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: I()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ct]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ct]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [v]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(k(), [NM])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", DM]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, AM]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [p]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [s]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [s]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [s]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [s]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [s]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [s]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [s]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [s]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [s]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [s]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [s]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [s]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [s]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [s]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [s]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [v]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat($(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [v]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: $()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat($())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [ct, fr]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [fr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: R()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [v]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [fr]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", go, FM]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [wi]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [v]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": L()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": L()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", go, ct]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [w]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [v]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [w]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", ct]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: K()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", ct]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: K()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", ct]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [C]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [C]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [C]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [xi, ct]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [O]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [O]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [E]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [E]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ct]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ct]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": I()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": I()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": I()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": I()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": I()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": I()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": I()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": I()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": I()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": I()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": I()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": I()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": I()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": I()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": I()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": I()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": I()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": I()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ct]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [fr, ol]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var BM = /* @__PURE__ */ MM(HM);
function de(...e) {
  return BM(Ay(e));
}
const Ih = Qn(
  "relative inline-flex select-none items-center justify-center gap-2 overflow-hidden rounded-md border border-transparent font-medium transition-colors duration-75 focus-visible:outline-none focus-visible:ring-1 disabled:pointer-events-none disabled:cursor-not-allowed",
  {
    variants: {
      variant: {
        primary: "border-info-bolder bg-info-bold text-foundations-inverse hover:border-info-boldest hover:bg-info-bolder hover:shadow-sm focus-visible:border-info-boldest focus-visible:shadow-sm focus-visible:ring-info-boldest active:bg-info-boldest [&_[data-slot=spinner-container]]:bg-foundations-subtlest [&_[data-slot=spinner-icon]]:border-info-boldest [&_[data-slot=spinner-icon]]:border-r-info-subtle",
        secondary: "border-foundations-bold bg-foundations-default text-foundations-subtle hover:bg-foundations-subtlest hover:text-foundations-bold hover:shadow-sm focus-visible:border-info-bold focus-visible:shadow-sm focus-visible:ring-info-bold active:bg-foundations-subtler active:text-foundations-bold [&_[data-slot=spinner-container]]:bg-foundations-default [&_[data-slot=spinner-icon]]:border-info-boldest [&_[data-slot=spinner-icon]]:border-r-info-subtle",
        tertiary: "text-foundations-subtle hover:bg-foundations-subtlest hover:text-foundations-bold hover:shadow-sm focus-visible:border-info-bold focus-visible:shadow-sm focus-visible:ring-info-bold active:bg-foundations-subtler active:text-foundations-bold  [&_[data-slot=spinner-container]]:bg-foundations-default [&_[data-slot=spinner-icon]]:border-info-boldest [&_[data-slot=spinner-icon]]:border-r-info-subtle"
      },
      size: {
        xs: "px-4 py-1.5 text-xs [&_[data-slot=spinner-icon]]:size-5 [&_svg:not([class*='size-'])]:size-5",
        sm: "px-6 py-2.5 text-sm [&_[data-slot=spinner-icon]]:size-5 [&_svg:not([class*='size-'])]:size-5",
        md: "px-6 py-3 text-base [&_[data-slot=spinner-icon]]:size-6 [&_svg:not([class*='size-'])]:size-6",
        lg: "px-8 py-4 text-base [&_[data-slot=spinner-icon]]:size-6 [&_svg:not([class*='size-'])]:size-6"
      },
      disabled: {
        true: ""
      },
      colorScheme: {
        danger: "",
        success: "",
        inverse: ""
      }
    },
    compoundVariants: [
      {
        variant: "primary",
        colorScheme: "danger",
        className: "border-danger-bolder bg-danger-bold hover:border-danger-boldest hover:bg-danger-bolder focus-visible:border-danger-boldest focus-visible:ring-danger-boldest active:bg-danger-boldest [&_[data-slot=spinner-icon]]:border-red-700 [&_[data-slot=spinner-icon]]:border-r-red-300"
      },
      {
        variant: "primary",
        colorScheme: "success",
        className: "border-success-bolder bg-success-bold hover:border-success-boldest hover:bg-success-bolder focus-visible:border-success-boldest focus-visible:ring-success-boldest active:bg-success-boldest [&_[data-slot=spinner-icon]]:border-green-700 [&_[data-slot=spinner-icon]]:border-r-green-300"
      },
      {
        variant: "primary",
        colorScheme: "inverse",
        className: "border-info-bold bg-foundations-default text-info hover:border-info-bold hover:bg-info-subtler focus-visible:border-info-bold focus-visible:ring-info-bold active:bg-info-subtler active:text-info disabled:text-foundations-subtler "
      },
      {
        variant: "secondary",
        colorScheme: "danger",
        className: "border border-danger-subtle text-danger hover:bg-danger-subtler hover:text-danger focus-visible:border-danger-subtle focus-visible:ring-danger-subtle active:border-danger-subtler active:bg-danger-subtler active:text-danger"
      },
      {
        variant: "secondary",
        colorScheme: "success",
        className: "border border-success-subtle text-success hover:bg-success-subtler hover:text-success focus-visible:border-success-subtle focus-visible:ring-success-subtle active:border-success-subtler active:bg-success-subtler active:text-success"
      },
      {
        variant: "primary",
        disabled: !0,
        className: "disabled:border-foundations-subtle disabled:bg-foundations-subtler disabled:text-foundations-subtler"
      },
      {
        variant: "secondary",
        disabled: !0,
        className: "disabled:border-foundations-subtle disabled:bg-foundations-subtlest disabled:text-foundations-subtler"
      },
      {
        variant: "tertiary",
        disabled: !0,
        className: "disabled:text-foundations-subtler"
      },
      {
        colorScheme: "inverse",
        disabled: !0,
        className: "disabled:border-foundations-bold disabled:bg-foundations-subtler disabled:!text-foundations-subtler"
      }
    ],
    defaultVariants: {
      variant: "primary",
      size: "sm"
    }
  }
), uc = b.forwardRef(
  ({
    className: e,
    variant: t,
    size: n,
    isLoading: r,
    colorScheme: o,
    children: s,
    render: i,
    ...a
  }, l) => {
    const c = {
      type: "button",
      className: de(
        Ih({
          variant: t,
          size: n,
          colorScheme: o,
          disabled: a.disabled || r,
          className: e
        })
      ),
      disabled: a.disabled || r,
      children: /* @__PURE__ */ ee(In, { children: [
        s,
        r && /* @__PURE__ */ _(qy, {})
      ] }),
      "data-slot": "button"
    };
    return ai({
      defaultTagName: "button",
      render: i,
      ref: l,
      props: _n(c, a)
    });
  }
);
uc.displayName = "Button";
const qy = () => /* @__PURE__ */ _(
  "div",
  {
    "data-slot": "spinner-container",
    className: "absolute inset-0 flex items-center justify-center",
    children: /* @__PURE__ */ _(
      "div",
      {
        "data-slot": "spinner-icon",
        className: " animate-spin rounded-full border-4"
      }
    )
  }
), zM = Oe.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "div",
  {
    role: "group",
    ref: n,
    className: de(
      "flex [&>button:focus]:z-10 [&>button:not(:first-of-type)]:rounded-l-none [&>button:not(:focus-visible):not(:last-of-type)]:border-r-transparent [&>button:not(:last-of-type)]:rounded-r-none",
      e
    ),
    ...t
  }
));
zM.displayName = "ButtonGroup";
const YM = Qn("", {
  variants: {
    size: {
      xs: "p-1 [&_svg:not([class*='size-'])]:size-4",
      sm: "p-2.5 [&_svg:not([class*='size-'])]:size-5",
      md: "p-3 [&_svg:not([class*='size-'])]:size-6",
      lg: "p-4 [&_svg:not([class*='size-'])]:size-6"
    },
    shape: {
      circle: "rounded-full"
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), ia = b.forwardRef(
  ({
    className: e,
    variant: t,
    size: n,
    isLoading: r,
    colorScheme: o,
    shape: s,
    render: i,
    children: a,
    ...l
  }, c) => {
    const u = {
      type: "button",
      className: de(
        Ih({
          variant: t,
          size: n,
          colorScheme: o,
          disabled: l.disabled || r
        }),
        YM({
          size: n,
          shape: s,
          className: e
        })
      ),
      disabled: l.disabled || r,
      children: /* @__PURE__ */ ee(In, { children: [
        a,
        r && /* @__PURE__ */ _(qy, {})
      ] }),
      "data-slot": "icon-button"
    };
    return ai({
      defaultTagName: "button",
      render: i,
      ref: c,
      props: _n(u, l)
    });
  }
);
ia.displayName = "IconButton";
const Sf = [];
let Of;
function jM() {
  return Of;
}
function UM(e) {
  Sf.push(e);
}
function kh(e) {
  const t = (n, r) => {
    const o = bn(GM).current;
    let s;
    try {
      Of = o;
      for (const i of Sf)
        i.before(o);
      s = e(n, r);
      for (const i of Sf)
        i.after(o);
      o.didInitialize = !0;
    } finally {
      Of = void 0;
    }
    return s;
  };
  return t.displayName = e.displayName || e.name, t;
}
function Xy(e) {
  return /* @__PURE__ */ b.forwardRef(kh(e));
}
function GM() {
  return {
    didInitialize: !1
  };
}
const KM = () => {
}, pe = typeof document < "u" ? b.useLayoutEffect : KM, Dh = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Dh.displayName = "TooltipRootContext");
function Oa(e) {
  const t = b.useContext(Dh);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipRootContext is missing. Tooltip parts must be placed within <Tooltip.Root>." : tt(72));
  return t;
}
function Jc(e) {
  b.useEffect(e, Gn);
}
const Ci = 0;
class Ln {
  constructor() {
    ce(this, "currentId", Ci);
    ce(this, "clear", () => {
      this.currentId !== Ci && (clearTimeout(this.currentId), this.currentId = Ci);
    });
    ce(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new Ln();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = Ci, n();
    }, t);
  }
  isStarted() {
    return this.currentId !== Ci;
  }
}
function Sn() {
  const e = bn(Ln.create).current;
  return Jc(e.disposeEffect), e;
}
function qM() {
  if (typeof navigator > "u")
    return {
      userAgent: "",
      platform: "",
      maxTouchPoints: 0
    };
  if (process.env.NODE_ENV !== "production") {
    const e = navigator.userAgentData;
    if (e && Array.isArray(e.brands))
      return {
        userAgent: e.brands.map(({
          brand: t,
          version: n
        }) => `${t}/${n}`).join(" "),
        platform: e.platform ?? navigator.platform ?? "",
        maxTouchPoints: navigator.maxTouchPoints ?? 0
      };
  }
  return {
    userAgent: navigator.userAgent,
    platform: navigator.platform ?? "",
    maxTouchPoints: navigator.maxTouchPoints ?? 0
  };
}
const {
  userAgent: XM,
  platform: ZM,
  maxTouchPoints: QM
} = qM(), eu = XM.toLowerCase(), aa = ZM.toLowerCase(), Ma = /^i(os$|p)/.test(aa) || aa === "macintel" && QM > 1, Dm = "android", dc = aa === Dm || eu.includes(Dm), Nh = !Ma && aa.startsWith("mac");
aa.startsWith("win");
const JM = Nh || Ma;
var ky;
const Lo = typeof CSS < "u" && !!((ky = CSS.supports) != null && ky.call(CSS, "-webkit-backdrop-filter:none")), Nm = !Lo && eu.includes("firefox");
!Lo && eu.includes("chrom");
const Zy = JM, Ah = /jsdom|happydom/.test(eu);
function wn(e) {
  e.preventDefault(), e.stopPropagation();
}
function eT(e) {
  return "nativeEvent" in e;
}
function Qy(e) {
  return e.pointerType === "" && e.isTrusted ? !0 : dc && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function $h(e) {
  return Ah ? !1 : !dc && e.width === 0 && e.height === 0 || dc && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function _o(e, t) {
  const n = ["mouse", "pen"];
  return t || n.push("", void 0), n.includes(e);
}
function tT(e) {
  const t = e.type;
  return t === "click" || t === "mousedown" || t === "keydown" || t === "keyup";
}
function tu() {
  return typeof window < "u";
}
function Rn(e) {
  return Fh(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Ht(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function lo(e) {
  var t;
  return (t = (Fh(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Fh(e) {
  return tu() ? e instanceof Node || e instanceof Ht(e).Node : !1;
}
function Qe(e) {
  return tu() ? e instanceof Element || e instanceof Ht(e).Element : !1;
}
function wt(e) {
  return tu() ? e instanceof HTMLElement || e instanceof Ht(e).HTMLElement : !1;
}
function qs(e) {
  return !tu() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Ht(e).ShadowRoot;
}
function Ta(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Vn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && o !== "inline" && o !== "contents";
}
function nT(e) {
  return /^(table|td|th)$/.test(Rn(e));
}
function nu(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const rT = /transform|translate|scale|rotate|perspective|filter/, oT = /paint|layout|strict|content/, Go = (e) => !!e && e !== "none";
let md;
function Lh(e) {
  const t = Qe(e) ? Vn(e) : e;
  return Go(t.transform) || Go(t.translate) || Go(t.scale) || Go(t.rotate) || Go(t.perspective) || !Vh() && (Go(t.backdropFilter) || Go(t.filter)) || rT.test(t.willChange || "") || oT.test(t.contain || "");
}
function sT(e) {
  let t = ro(e);
  for (; wt(t) && !Jr(t); ) {
    if (Lh(t))
      return t;
    if (nu(t))
      return null;
    t = ro(t);
  }
  return null;
}
function Vh() {
  return md == null && (md = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), md;
}
function Jr(e) {
  return /^(html|body|#document)$/.test(Rn(e));
}
function Vn(e) {
  return Ht(e).getComputedStyle(e);
}
function ru(e) {
  return Qe(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ro(e) {
  if (Rn(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    qs(e) && e.host || // Fallback.
    lo(e)
  );
  return qs(t) ? t.host : t;
}
function Jy(e) {
  const t = ro(e);
  return Jr(t) ? (e.ownerDocument || e).body : wt(t) && Ta(t) ? t : Jy(t);
}
function Xs(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Jy(e), s = o === ((r = e.ownerDocument) == null ? void 0 : r.body), i = Ht(o);
  if (s) {
    const a = Mf(i);
    return t.concat(i, i.visualViewport || [], Ta(o) ? o : [], a && n ? Xs(a) : []);
  } else
    return t.concat(o, Xs(o, [], n));
}
function Mf(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
const Tf = "data-base-ui-focusable", e1 = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])", as = "ArrowLeft", ls = "ArrowRight", Wh = "ArrowUp", ou = "ArrowDown";
function fn(e) {
  var n;
  let t = e.activeElement;
  for (; ((n = t == null ? void 0 : t.shadowRoot) == null ? void 0 : n.activeElement) != null; )
    t = t.shadowRoot.activeElement;
  return t;
}
function Ie(e, t) {
  var r;
  if (!e || !t)
    return !1;
  const n = (r = t.getRootNode) == null ? void 0 : r.call(t);
  if (e.contains(t))
    return !0;
  if (n && qs(n)) {
    let o = t;
    for (; o; ) {
      if (e === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function Ot(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
function fc(e, t) {
  if (!Qe(e))
    return !1;
  const n = e;
  if (t.hasElement(n))
    return !n.hasAttribute("data-trigger-disabled");
  for (const [, r] of t.entries())
    if (Ie(r, n))
      return !r.hasAttribute("data-trigger-disabled");
  return !1;
}
function bd(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function iT(e) {
  return e.matches("html,body");
}
function su(e) {
  return wt(e) && e.matches(e1);
}
function t1(e) {
  return (e == null ? void 0 : e.closest(`button,a[href],[role="button"],select,[tabindex]:not([tabindex="-1"]),${e1}`)) != null;
}
function Rf(e) {
  return e ? e.getAttribute("role") === "combobox" && su(e) : !1;
}
function hc(e) {
  if (!e || Ah)
    return !0;
  try {
    return e.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function Pf(e) {
  return e ? e.hasAttribute(Tf) ? e : e.querySelector(`[${Tf}]`) || e : null;
}
function aT(e, t) {
  return t != null && !_o(t) ? 0 : typeof e == "function" ? e() : e;
}
function To(e, t, n) {
  const r = aT(e, n);
  return typeof r == "number" ? r : r == null ? void 0 : r[t];
}
function Am(e) {
  return typeof e == "function" ? e() : e;
}
function n1(e, t) {
  return t || e === "click" || e === "mousedown";
}
function lT(e) {
  return (e == null ? void 0 : e.includes("mouse")) && e !== "mousedown";
}
const Cn = "none", Lr = "trigger-press", qt = "trigger-hover", Bs = "trigger-focus", iu = "outside-press", Ra = "item-press", Hh = "close-press", qi = "input-change", Sr = "input-clear", r1 = "input-press", Ro = "focus-out", bs = "escape-key", la = "list-navigation", o1 = "keyboard", s1 = "pointer", i1 = "cancel-open", Vi = "sibling-open", a1 = "disabled", $m = "missing", Fm = "initial", au = "imperative-action";
function Ne(e, t, n, r) {
  let o = !1, s = !1;
  const i = r ?? At;
  return {
    reason: e,
    event: t ?? new Event("base-ui"),
    cancel() {
      o = !0;
    },
    allowPropagation() {
      s = !0;
    },
    get isCanceled() {
      return o;
    },
    get isPropagationAllowed() {
      return s;
    },
    trigger: n,
    ...i
  };
}
function cT(e, t, n) {
  const r = n ?? At;
  return {
    reason: e,
    event: t ?? new Event("base-ui"),
    ...r
  };
}
const Bh = /* @__PURE__ */ b.createContext({
  hasProvider: !1,
  timeoutMs: 0,
  delayRef: {
    current: 0
  },
  initialDelayRef: {
    current: 0
  },
  timeout: new Ln(),
  currentIdRef: {
    current: null
  },
  currentContextRef: {
    current: null
  }
});
process.env.NODE_ENV !== "production" && (Bh.displayName = "FloatingDelayGroupContext");
function uT(e, t) {
  e.current = t.current;
}
function dT(e) {
  const {
    children: t,
    delay: n,
    timeoutMs: r = 0
  } = e, o = b.useRef(n), s = b.useRef(n), i = b.useRef(null), a = b.useRef(null), l = Sn();
  return pe(() => {
    if (s.current = n, !i.current) {
      o.current = n;
      return;
    }
    o.current = {
      open: To(o.current, "open"),
      close: To(n, "close")
    };
  }, [n, i, o, s]), /* @__PURE__ */ _(Bh.Provider, {
    value: b.useMemo(() => ({
      hasProvider: !0,
      delayRef: o,
      initialDelayRef: s,
      currentIdRef: i,
      timeoutMs: r,
      currentContextRef: a,
      timeout: l
    }), [r, l]),
    children: t
  });
}
function fT(e, t = {
  open: !1
}) {
  const {
    open: n
  } = t, r = "rootStore" in e ? e.rootStore : e, o = r.useState("floatingId"), s = b.useContext(Bh), {
    currentIdRef: i,
    delayRef: a,
    timeoutMs: l,
    initialDelayRef: c,
    currentContextRef: u,
    hasProvider: d,
    timeout: f
  } = s, [h, p] = b.useState(!1), g = b.useRef(n);
  return pe(() => {
    g.current = n;
  }, [n]), pe(() => {
    function m() {
      var v;
      (v = u.current) == null || v.setIsInstantPhase(!1), i.current = null, u.current = null, a.current = c.current, f.clear();
    }
    if (i.current && !n && i.current === o) {
      if (p(!1), l) {
        const v = o;
        return f.start(l, () => {
          r.select("open") || i.current && i.current !== v || m();
        }), () => {
          (g.current || i.current !== v) && f.clear();
        };
      }
      m();
    }
  }, [n, o, i, a, l, c, u, f, r]), pe(() => {
    if (!n)
      return;
    const m = u.current, v = i.current;
    f.clear(), u.current = {
      onOpenChange: r.setOpen,
      setIsInstantPhase: p
    }, i.current = o, a.current = {
      open: 0,
      close: To(c.current, "close")
    }, v !== null && v !== o ? (p(!0), m == null || m.setIsInstantPhase(!0), m == null || m.onOpenChange(!1, Ne(Cn))) : (p(!1), m == null || m.setIsInstantPhase(!1));
  }, [n, o, r, i, a, c, u, f]), pe(() => () => {
    if (i.current === o) {
      if (u.current = null, !g.current)
        return;
      i.current = null, uT(a, c), f.clear();
    }
  }, [u, i, a, o, c, f]), b.useMemo(() => ({
    hasProvider: d,
    delayRef: a,
    isInstantPhase: h
  }), [d, a, h]);
}
function qe(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function mr(...e) {
  return () => {
    for (let t = 0; t < e.length; t += 1) {
      const n = e[t];
      n && n();
    }
  };
}
function rn(e) {
  const t = bn(hT, e).current;
  return t.next = e, pe(t.effect), t;
}
function hT(e) {
  const t = {
    current: e,
    next: e,
    effect: () => {
      t.current = t.next;
    }
  };
  return t;
}
const or = {
  ...b
}, vd = or.useInsertionEffect, pT = (
  // React 17 doesn't have useInsertionEffect.
  vd && // Preact replaces useInsertionEffect with useLayoutEffect and fires too late.
  vd !== or.useLayoutEffect ? vd : (e) => e()
);
function ye(e) {
  const t = bn(gT).current;
  return t.next = e, pT(t.effect), t.trampoline;
}
function gT() {
  const e = {
    next: void 0,
    callback: mT,
    trampoline: (...t) => {
      var n;
      return (n = e.callback) == null ? void 0 : n.call(e, ...t);
    },
    effect: () => {
      e.callback = e.next;
    }
  };
  return e;
}
function mT() {
  if (process.env.NODE_ENV !== "production")
    throw (
      /* minify-error-disabled */
      new Error("Base UI: Cannot call an event handler while rendering.")
    );
}
const sl = null;
let Lm = globalThis.requestAnimationFrame;
class bT {
  constructor() {
    /* This implementation uses an array as a backing data-structure for frame callbacks.
     * It allows `O(1)` callback cancelling by inserting a `null` in the array, though it
     * never calls the native `cancelAnimationFrame` if there are no frames left. This can
     * be much more efficient if there is a call pattern that alterns as
     * "request-cancel-request-cancel-…".
     * But in the case of "request-request-…-cancel-cancel-…", it leaves the final animation
     * frame to run anyway. We turn that frame into a `O(1)` no-op via `callbacksCount`. */
    ce(this, "callbacks", []);
    ce(this, "callbacksCount", 0);
    ce(this, "nextId", 1);
    ce(this, "startId", 1);
    ce(this, "isScheduled", !1);
    ce(this, "tick", (t) => {
      var o;
      this.isScheduled = !1;
      const n = this.callbacks, r = this.callbacksCount;
      if (this.callbacks = [], this.callbacksCount = 0, this.startId = this.nextId, r > 0)
        for (let s = 0; s < n.length; s += 1)
          (o = n[s]) == null || o.call(n, t);
    });
  }
  request(t) {
    const n = this.nextId;
    this.nextId += 1, this.callbacks.push(t), this.callbacksCount += 1;
    const r = process.env.NODE_ENV !== "production" && Lm !== requestAnimationFrame && (Lm = requestAnimationFrame, !0);
    return (!this.isScheduled || r) && (requestAnimationFrame(this.tick), this.isScheduled = !0), n;
  }
  cancel(t) {
    const n = t - this.startId;
    n < 0 || n >= this.callbacks.length || (this.callbacks[n] = null, this.callbacksCount -= 1);
  }
}
let il = new bT();
class An {
  constructor() {
    ce(this, "currentId", sl);
    ce(this, "cancel", () => {
      this.currentId !== sl && (il.cancel(this.currentId), this.currentId = sl);
    });
    ce(this, "disposeEffect", () => this.cancel);
  }
  static create() {
    return new An();
  }
  static request(t) {
    return il.request(t);
  }
  static cancel(t) {
    return il.cancel(t);
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  request(t) {
    this.cancel(), this.currentId = il.request(() => {
      this.currentId = sl, t();
    });
  }
}
function ca() {
  const e = bn(An.create).current;
  return Jc(e.disposeEffect), e;
}
function Ze(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
const l1 = {
  clipPath: "inset(50%)",
  overflow: "hidden",
  whiteSpace: "nowrap",
  border: 0,
  padding: 0,
  width: 1,
  height: 1,
  margin: -1
}, Pa = {
  ...l1,
  position: "fixed",
  top: 0,
  left: 0
}, zh = {
  ...l1,
  position: "absolute"
}, Vr = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const [r, o] = b.useState();
  return pe(() => {
    Zy && Lo && o("button");
  }, []), /* @__PURE__ */ _("span", {
    ...t,
    ref: n,
    style: Pa,
    "aria-hidden": r ? void 0 : !0,
    ...{
      tabIndex: 0,
      // Role is only for VoiceOver
      role: r
    },
    "data-base-ui-focus-guard": ""
  });
});
process.env.NODE_ENV !== "production" && (Vr.displayName = "FocusGuard");
const Zs = Math.min, eo = Math.max, pc = Math.round, os = Math.floor, to = (e) => ({
  x: e,
  y: e
}), vT = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function c1(e, t, n) {
  return eo(e, Zs(t, n));
}
function Po(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ir(e) {
  return e.split("-")[0];
}
function Vo(e) {
  return e.split("-")[1];
}
function Yh(e) {
  return e === "x" ? "y" : "x";
}
function jh(e) {
  return e === "y" ? "height" : "width";
}
function sr(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function Uh(e) {
  return Yh(sr(e));
}
function yT(e, t, n) {
  n === void 0 && (n = !1);
  const r = Vo(e), o = Uh(e), s = jh(o);
  let i = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (i = gc(i)), [i, gc(i)];
}
function xT(e) {
  const t = gc(e);
  return [If(e), t, If(t)];
}
function If(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const Vm = ["left", "right"], Wm = ["right", "left"], wT = ["top", "bottom"], CT = ["bottom", "top"];
function ET(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Wm : Vm : t ? Vm : Wm;
    case "left":
    case "right":
      return t ? wT : CT;
    default:
      return [];
  }
}
function _T(e, t, n, r) {
  const o = Vo(e);
  let s = ET(ir(e), n === "start", r);
  return o && (s = s.map((i) => i + "-" + o), t && (s = s.concat(s.map(If)))), s;
}
function gc(e) {
  const t = ir(e);
  return vT[t] + e.slice(t.length);
}
function ST(e) {
  var t, n, r, o;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (n = e.right) != null ? n : 0,
    bottom: (r = e.bottom) != null ? r : 0,
    left: (o = e.left) != null ? o : 0
  };
}
function u1(e) {
  return typeof e != "number" ? ST(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function mc(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function al(e, t, n) {
  return Math.floor(e / t) !== n;
}
function So(e, t) {
  return t < 0 || t >= e.length;
}
function jl(e, t) {
  return xn(e.current, {
    disabledIndices: t
  });
}
function kf(e, t) {
  return xn(e.current, {
    decrement: !0,
    startingIndex: e.current.length,
    disabledIndices: t
  });
}
function xn(e, {
  startingIndex: t = -1,
  decrement: n = !1,
  disabledIndices: r,
  amount: o = 1
} = {}) {
  let s = t;
  do
    s += n ? -o : o;
  while (s >= 0 && s <= e.length - 1 && Qs(e, s, r));
  return s;
}
function OT(e, {
  event: t,
  orientation: n,
  loopFocus: r,
  onLoop: o,
  rtl: s,
  cols: i,
  disabledIndices: a,
  minIndex: l,
  maxIndex: c,
  prevIndex: u,
  stopEvent: d = !1
}) {
  let f = u, h;
  if (t.key === Wh ? h = "up" : t.key === ou && (h = "down"), h) {
    const p = [], g = [];
    let m = !1, v = 0;
    {
      let M = null, T = -1;
      e.forEach((P, I) => {
        if (P == null)
          return;
        v += 1;
        const R = P.closest('[role="row"]');
        R && (m = !0), (R !== M || T === -1) && (M = R, T += 1, p[T] = []), p[T].push(I), g[I] = T;
      });
    }
    let y = !1, x = 0;
    if (m)
      for (const M of p) {
        const T = M.length;
        T > x && (x = T), T !== i && (y = !0);
      }
    const C = y && v < e.length, w = x || i, E = (M) => {
      if (!y || u === -1)
        return;
      const T = g[u];
      if (T == null)
        return;
      const P = p[T].indexOf(u), I = M === "up" ? -1 : 1;
      for (let R = T + I, D = 0; D < p.length; D += 1, R += I) {
        if (R < 0 || R >= p.length) {
          if (!r || C)
            return;
          if (R = R < 0 ? p.length - 1 : 0, o) {
            const $ = Math.min(P, p[R].length - 1), L = p[R][$] ?? p[R][0], A = o(t, u, L);
            R = g[A] ?? R;
          }
        }
        const k = p[R];
        for (let $ = Math.min(P, k.length - 1); $ >= 0; $ -= 1) {
          const L = k[$];
          if (!Qs(e, L, a))
            return L;
        }
      }
    }, S = (M) => {
      if (!C || u === -1)
        return;
      const T = u % w, P = M === "up" ? -w : w, I = c - c % w, R = os(c / w) + 1;
      for (let D = u - T + P, k = 0; k < R; k += 1, D += P) {
        if (D < 0 || D > c) {
          if (!r)
            return;
          D = D < 0 ? I : 0;
        }
        const $ = Math.min(D + w - 1, c);
        for (let L = Math.min(D + T, $); L >= D; L -= 1)
          if (!Qs(e, L, a))
            return L;
      }
    };
    d && wn(t);
    const O = E(h) ?? S(h);
    if (O !== void 0)
      f = O;
    else if (u === -1)
      f = h === "up" ? c : l;
    else if (f = xn(e, {
      startingIndex: u,
      amount: w,
      decrement: h === "up",
      disabledIndices: a
    }), r) {
      if (h === "up" && (u - w < l || f < 0)) {
        const M = u % w, T = c % w, P = c - (T - M);
        T === M ? f = c : f = T > M ? P : P - w, o && (f = o(t, u, f));
      }
      h === "down" && u + w > c && (f = xn(e, {
        startingIndex: u % w - w,
        amount: w,
        disabledIndices: a
      }), o && (f = o(t, u, f)));
    }
    So(e, f) && (f = u);
  }
  if (n === "both") {
    const p = os(u / i);
    t.key === (s ? as : ls) && (d && wn(t), u % i !== i - 1 ? (f = xn(e, {
      startingIndex: u,
      disabledIndices: a
    }), r && al(f, i, p) && (f = xn(e, {
      startingIndex: u - u % i - 1,
      disabledIndices: a
    }), o && (f = o(t, u, f)))) : r && (f = xn(e, {
      startingIndex: u - u % i - 1,
      disabledIndices: a
    }), o && (f = o(t, u, f))), al(f, i, p) && (f = u)), t.key === (s ? ls : as) && (d && wn(t), u % i !== 0 ? (f = xn(e, {
      startingIndex: u,
      decrement: !0,
      disabledIndices: a
    }), r && al(f, i, p) && (f = xn(e, {
      startingIndex: u + (i - u % i),
      decrement: !0,
      disabledIndices: a
    }), o && (f = o(t, u, f)))) : r && (f = xn(e, {
      startingIndex: u + (i - u % i),
      decrement: !0,
      disabledIndices: a
    }), o && (f = o(t, u, f))), al(f, i, p) && (f = u));
    const g = os(c / i) === p;
    So(e, f) && (r && g ? (f = t.key === (s ? ls : as) ? c : xn(e, {
      startingIndex: u - u % i - 1,
      disabledIndices: a
    }), o && (f = o(t, u, f))) : f = u);
  }
  return f;
}
function Qs(e, t, n) {
  if (typeof n == "function" ? n(t) : (n == null ? void 0 : n.includes(t)) ?? !1)
    return !0;
  const o = e[t];
  return o ? !lu(o) || o.matches(":disabled") ? !0 : !n && (o.hasAttribute("disabled") || o.getAttribute("aria-disabled") === "true") : !1;
}
function MT(e) {
  return e.visibility === "hidden" || e.visibility === "collapse";
}
function lu(e, t = e ? Vn(e) : null) {
  return !e || !e.isConnected || !t || MT(t) ? !1 : typeof e.checkVisibility == "function" ? e.checkVisibility() : t.display !== "none" && t.display !== "contents";
}
const TT = 'a[href],button,input,select,textarea,summary,details,iframe,object,embed,[tabindex],[contenteditable]:not([contenteditable="false"]),audio[controls],video[controls]';
function RT(e) {
  const t = e.assignedSlot;
  if (t)
    return t;
  if (e.parentElement)
    return e.parentElement;
  const n = e.getRootNode();
  return qs(n) ? n.host : null;
}
function Df(e) {
  for (const t of Array.from(e.children))
    if (Rn(t) === "summary")
      return t;
  return null;
}
function PT(e, t) {
  const n = Df(t);
  return !!n && (e === n || Ie(n, e));
}
function d1(e) {
  const t = e ? Rn(e) : "";
  return e != null && e.matches(TT) && (t !== "summary" || e.parentElement != null && Rn(e.parentElement) === "details" && Df(e.parentElement) === e) && (t !== "details" || Df(e) == null) && (t !== "input" || e.type !== "hidden");
}
function f1(e) {
  if (!d1(e) || !e.isConnected || e.matches(":disabled"))
    return !1;
  for (let t = e; t; t = RT(t)) {
    const n = t !== e, r = Rn(t) === "slot";
    if (t.hasAttribute("inert") || n && Rn(t) === "details" && !t.open && !PT(e, t) || t.hasAttribute("hidden") || !r && !IT(t, n))
      return !1;
  }
  return !0;
}
function IT(e, t) {
  const n = Vn(e);
  return t ? n.display !== "none" : lu(e, n);
}
function h1(e) {
  const t = e.tabIndex;
  if (t < 0) {
    const n = Rn(e);
    if (n === "details" || n === "audio" || n === "video" || wt(e) && e.isContentEditable)
      return 0;
  }
  return t;
}
function yd(e) {
  if (Rn(e) !== "input")
    return null;
  const t = e;
  return t.type === "radio" && t.name !== "" ? t : null;
}
function kT(e, t) {
  const n = yd(e);
  if (!n)
    return !0;
  const r = t.find((o) => {
    const s = yd(o);
    return (s == null ? void 0 : s.name) === n.name && s.form === n.form && s.checked;
  });
  return r ? r === n : t.find((o) => {
    const s = yd(o);
    return (s == null ? void 0 : s.name) === n.name && s.form === n.form;
  }) === n;
}
function p1(e) {
  if (wt(e) && Rn(e) === "slot") {
    const t = e.assignedElements({
      flatten: !0
    });
    if (t.length > 0)
      return t;
  }
  return wt(e) && e.shadowRoot ? Array.from(e.shadowRoot.children) : Array.from(e.children);
}
function g1(e, t) {
  p1(e).forEach((n) => {
    d1(n) && t.push(n), g1(n, t);
  });
}
function m1(e, t, n) {
  p1(e).forEach((r) => {
    wt(r) && r.matches(t) && n.push(r), m1(r, t, n);
  });
}
function Gh(e) {
  return f1(e) && h1(e) >= 0;
}
function b1(e) {
  const t = [];
  return g1(e, t), t.filter(f1);
}
function Ia(e) {
  const t = b1(e);
  return t.filter((n) => h1(n) >= 0 && kT(n, t));
}
function v1(e, t) {
  const n = Ia(e), r = n.length;
  if (r === 0)
    return;
  const o = fn(Ze(e)), s = n.indexOf(o), i = s === -1 ? t === 1 ? 0 : r - 1 : s + t;
  return n[i];
}
function Kh(e) {
  return v1(Ze(e).body, 1) || e;
}
function y1(e) {
  return v1(Ze(e).body, -1) || e;
}
function x1(e, t) {
  if (!e)
    return null;
  const n = Ia(Ze(e).body), r = n.length;
  if (r === 0)
    return null;
  const o = n.indexOf(e);
  if (o === -1)
    return null;
  const s = (o + t + r) % r;
  return n[s];
}
function DT(e) {
  return x1(e, 1);
}
function NT(e) {
  return x1(e, -1);
}
function zs(e, t) {
  const n = t || e.currentTarget, r = e.relatedTarget;
  return !r || !Ie(n, r);
}
function AT(e) {
  Ia(e).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function Hm(e) {
  const t = [];
  m1(e, "[data-tabindex]", t), t.forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
function Io(e, t, n = !0) {
  return e.filter((o) => o.parentId === t).flatMap((o) => {
    var s;
    return [...!n || (s = o.context) != null && s.open ? [o] : [], ...Io(e, o.id, n)];
  });
}
function Bm(e, t) {
  var o;
  let n = [], r = (o = e.find((s) => s.id === t)) == null ? void 0 : o.parentId;
  for (; r; ) {
    const s = e.find((i) => i.id === r);
    r = s == null ? void 0 : s.parentId, s && (n = n.concat(s));
  }
  return n;
}
function ua(e) {
  return `data-base-ui-${e}`;
}
let ll = 0;
function Ul(e, t = {}) {
  const {
    preventScroll: n = !1,
    sync: r = !1,
    shouldFocus: o
  } = t;
  cancelAnimationFrame(ll);
  function s() {
    o && !o() || e == null || e.focus({
      preventScroll: n
    });
  }
  if (r)
    return s(), Nt;
  const i = requestAnimationFrame(s);
  return ll = i, () => {
    ll === i && (cancelAnimationFrame(i), ll = 0);
  };
}
const xd = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap()
}, zm = "data-base-ui-inert", Nf = {
  inert: /* @__PURE__ */ new WeakSet(),
  "aria-hidden": /* @__PURE__ */ new WeakSet()
};
let Ei = /* @__PURE__ */ new WeakMap(), wd = 0;
function $T(e) {
  return Nf[e];
}
function w1(e) {
  return e ? qs(e) ? e.host : w1(e.parentNode) : null;
}
const Ym = (e, t) => t.map((n) => {
  if (e.contains(n))
    return n;
  const r = w1(n);
  return e.contains(r) ? r : null;
}).filter((n) => n != null), jm = (e) => {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((n) => {
    let r = n;
    for (; r && !t.has(r); )
      t.add(r), r = r.parentNode;
  }), t;
}, Um = (e, t, n) => {
  const r = [], o = (s) => {
    !s || n.has(s) || Array.from(s.children).forEach((i) => {
      Rn(i) !== "script" && (t.has(i) ? o(i) : r.push(i));
    });
  };
  return o(e), r;
};
function FT(e, t, n, r, {
  mark: o = !0
}) {
  let s = null;
  r ? s = "inert" : n && (s = "aria-hidden");
  let i = null, a = null;
  const l = Ym(t, e), c = o ? Um(t, jm(l), new Set(l)) : [], u = [], d = [];
  if (s) {
    const f = xd[s], h = $T(s);
    a = h, i = f;
    const p = Ym(t, Array.from(t.querySelectorAll("[aria-live]"))), g = l.concat(p);
    Um(t, jm(g), new Set(g)).forEach((v) => {
      const y = v.getAttribute(s), x = y !== null && y !== "false", C = (f.get(v) || 0) + 1;
      f.set(v, C), u.push(v), C === 1 && x && h.add(v), x || v.setAttribute(s, s === "inert" ? "" : "true");
    });
  }
  return o && c.forEach((f) => {
    const h = (Ei.get(f) || 0) + 1;
    Ei.set(f, h), d.push(f), h === 1 && f.setAttribute(zm, "");
  }), wd += 1, () => {
    i && u.forEach((f) => {
      const p = (i.get(f) || 0) - 1;
      i.set(f, p), p || (!(a != null && a.has(f)) && s && f.removeAttribute(s), a == null || a.delete(f));
    }), o && d.forEach((f) => {
      const h = (Ei.get(f) || 0) - 1;
      Ei.set(f, h), h || f.removeAttribute(zm);
    }), wd -= 1, wd || (xd.inert = /* @__PURE__ */ new WeakMap(), xd["aria-hidden"] = /* @__PURE__ */ new WeakMap(), Nf.inert = /* @__PURE__ */ new WeakSet(), Nf["aria-hidden"] = /* @__PURE__ */ new WeakSet(), Ei = /* @__PURE__ */ new WeakMap());
  };
}
function Gm(e, t = {}) {
  const {
    ariaHidden: n = !1,
    inert: r = !1,
    mark: o = !0
  } = t, s = Ze(e[0]).body;
  return FT(e, s, n, r, {
    mark: o
  });
}
let Km = 0;
function LT(e, t = "mui") {
  const [n, r] = b.useState(e), o = e || n;
  return b.useEffect(() => {
    n == null && (Km += 1, r(`${t}-${Km}`));
  }, [n, t]), o;
}
const qm = or.useId;
function ko(e, t) {
  if (qm !== void 0) {
    const n = qm();
    return e ?? (t ? `${t}-${n}` : n);
  }
  return LT(e, t);
}
const VT = 500, C1 = 500, WT = {
  style: {
    transition: "none"
  }
}, qh = "data-base-ui-click-trigger", HT = "data-base-ui-swipe-ignore", BT = "data-swipe-ignore", zT = `[${HT}]`, YT = `[${BT}]`, E1 = {
  fallbackAxisSide: "none"
}, Xh = {
  fallbackAxisSide: "end"
}, jT = {
  clipPath: "inset(50%)",
  position: "fixed",
  top: 0,
  left: 0
}, Zh = /* @__PURE__ */ b.createContext(null);
process.env.NODE_ENV !== "production" && (Zh.displayName = "PortalContext");
const _1 = () => b.useContext(Zh), UT = ua("portal");
function S1(e = {}) {
  const {
    ref: t,
    container: n,
    componentProps: r = At,
    elementProps: o
  } = e, s = ko(), i = _1(), a = i == null ? void 0 : i.portalNode, [l, c] = b.useState(null), [u, d] = b.useState(null), f = ye((m) => {
    m !== null && d(m);
  }), h = b.useRef(null);
  pe(() => {
    if (n === null) {
      h.current && (h.current = null, d(null), c(null));
      return;
    }
    const m = (n && (Fh(n) ? n : n.current)) ?? a ?? document.body;
    if (m == null) {
      h.current && (h.current = null, d(null), c(null));
      return;
    }
    h.current !== m && (h.current = m, d(null), c(m));
  }, [n, a]);
  const p = We("div", r, {
    ref: [t, f],
    props: [{
      id: s,
      [UT]: ""
    }, o]
  }), g = l && p ? /* @__PURE__ */ Xn.createPortal(p, l) : null;
  return {
    node: u,
    // `id` and `render` props can override or remove the generated ID. Use the exact
    // rendered value so `aria-owns` never points at an ID absent from the DOM.
    nodeId: /* @__PURE__ */ b.isValidElement(p) ? p.props.id : void 0,
    subtree: g
  };
}
const ka = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    children: i,
    container: a,
    ...l
  } = t, {
    node: c,
    nodeId: u,
    subtree: d
  } = S1({
    container: a,
    ref: n,
    componentProps: t,
    elementProps: l
  }), f = b.useRef(null), h = b.useRef(null), p = b.useRef(null), g = b.useRef(null), [m, v] = b.useState(null), y = b.useRef(!1), x = m == null ? void 0 : m.modal, C = m == null ? void 0 : m.open, w = !!m && !m.modal && m.open && !!c;
  b.useEffect(() => {
    if (!c || x)
      return;
    function S(O) {
      c && O.relatedTarget && zs(O) && (O.type === "focusin" ? y.current && (Hm(c), y.current = !1) : (AT(c), y.current = !0));
    }
    return mr(qe(c, "focusin", S, !0), qe(c, "focusout", S, !0));
  }, [c, x]), pe(() => {
    !c || C !== !0 || !y.current || (Hm(c), y.current = !1);
  }, [C, c]);
  const E = b.useMemo(() => ({
    beforeOutsideRef: f,
    afterOutsideRef: h,
    beforeInsideRef: p,
    afterInsideRef: g,
    portalNode: c,
    setFocusManagerState: v
  }), [c]);
  return /* @__PURE__ */ ee(b.Fragment, {
    children: [d, /* @__PURE__ */ ee(Zh.Provider, {
      value: E,
      children: [w && c && /* @__PURE__ */ _(Vr, {
        "data-type": "outside",
        ref: f,
        onFocus: (S) => {
          var O;
          if (zs(S, c))
            (O = p.current) == null || O.focus();
          else {
            const M = m ? m.domReference : null, T = y1(M);
            T == null || T.focus();
          }
        }
      }), w && c && /* @__PURE__ */ _("span", {
        "aria-owns": u,
        style: jT
      }), c && /* @__PURE__ */ Xn.createPortal(i, c), w && c && /* @__PURE__ */ _(Vr, {
        "data-type": "outside",
        ref: h,
        onFocus: (S) => {
          var O;
          if (zs(S, c))
            (O = g.current) == null || O.focus();
          else {
            const M = m ? m.domReference : null, T = Kh(M);
            T == null || T.focus(), m != null && m.closeOnFocusOut && (m == null || m.onOpenChange(!1, Ne(Ro, S.nativeEvent)));
          }
        }
      })]
    })]
  });
});
process.env.NODE_ENV !== "production" && (ka.displayName = "FloatingPortal");
function O1() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((o) => o(n));
    },
    on(t, n) {
      e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n);
    },
    off(t, n) {
      var r;
      (r = e.get(t)) == null || r.delete(n);
    }
  };
}
class Qh {
  constructor() {
    ce(this, "nodesRef", {
      current: []
    });
    ce(this, "events", O1());
  }
  addNode(t) {
    this.nodesRef.current.push(t);
  }
  removeNode(t) {
    const n = this.nodesRef.current.findIndex((r) => r === t);
    n !== -1 && this.nodesRef.current.splice(n, 1);
  }
}
const Jh = /* @__PURE__ */ b.createContext(null);
process.env.NODE_ENV !== "production" && (Jh.displayName = "FloatingNodeContext");
const ep = /* @__PURE__ */ b.createContext(null);
process.env.NODE_ENV !== "production" && (ep.displayName = "FloatingTreeContext");
const Wo = () => {
  var e;
  return ((e = b.useContext(Jh)) == null ? void 0 : e.id) || null;
}, Ho = (e) => {
  const t = b.useContext(ep);
  return e ?? t;
};
function tp(e) {
  const t = ko(), n = Ho(e), r = Wo();
  return pe(() => {
    if (!t)
      return;
    const o = {
      id: t,
      parentId: r
    };
    return n == null || n.addNode(o), () => {
      n == null || n.removeNode(o);
    };
  }, [n, t, r]), t;
}
function M1(e) {
  const {
    children: t,
    id: n
  } = e, r = Wo();
  return /* @__PURE__ */ _(Jh.Provider, {
    value: b.useMemo(() => ({
      id: n,
      parentId: r
    }), [n, r]),
    children: t
  });
}
function T1(e) {
  const {
    children: t,
    externalTree: n
  } = e, r = bn(() => n ?? new Qh()).current;
  return /* @__PURE__ */ _(ep.Provider, {
    value: r,
    children: t
  });
}
function Yr(e) {
  return e == null ? e : "current" in e ? e.current : e;
}
function GT(e, t) {
  const n = Ht(Ot(e));
  return e instanceof n.KeyboardEvent ? "keyboard" : e instanceof n.FocusEvent ? t || "keyboard" : "pointerType" in e ? e.pointerType || "keyboard" : "touches" in e ? "touch" : e instanceof n.MouseEvent ? t || (e.detail === 0 ? "keyboard" : "mouse") : "";
}
const Xm = 20;
let xo = [];
function np() {
  xo = xo.filter((e) => {
    var t;
    return (t = e.deref()) == null ? void 0 : t.isConnected;
  });
}
function Zm(e) {
  np(), e && Rn(e) !== "body" && (xo.push(new WeakRef(e)), xo.length > Xm && (xo = xo.slice(-Xm)));
}
function Qm() {
  var e;
  return np(), (e = xo[xo.length - 1]) == null ? void 0 : e.deref();
}
function KT(e) {
  return e ? Gh(e) ? e : Ia(e)[0] || e : null;
}
function Jm(e) {
  var o;
  if (e.hasAttribute("tabindex") && !e.hasAttribute("data-tabindex") || !((o = e.getAttribute("role")) != null && o.includes("dialog")))
    return;
  const n = b1(e).filter((s) => {
    const i = s.getAttribute("data-tabindex") || "";
    return Gh(s) || s.hasAttribute("data-tabindex") && !i.startsWith("-");
  }), r = e.getAttribute("tabindex");
  n.length === 0 ? r !== "0" && (e.setAttribute("tabindex", "0"), e.setAttribute("data-tabindex", "0")) : (r !== "-1" || e.hasAttribute("data-tabindex") && e.getAttribute("data-tabindex") !== "-1") && (e.setAttribute("tabindex", "-1"), e.setAttribute("data-tabindex", "-1"));
}
function cu(e) {
  const {
    context: t,
    children: n,
    disabled: r = !1,
    initialFocus: o = !0,
    returnFocus: s = !0,
    restoreFocus: i = !1,
    modal: a = !0,
    closeOnFocusOut: l = !0,
    openInteractionType: c = "",
    nextFocusableElement: u,
    previousFocusableElement: d,
    beforeContentFocusGuardRef: f,
    externalTree: h,
    getInsideElements: p
  } = e, g = "rootStore" in t ? t.rootStore : t, m = g.useState("open"), v = g.useState("domReferenceElement"), y = g.useState("floatingElement"), {
    events: x,
    dataRef: C
  } = g.context, w = ye(() => {
    var G;
    return (G = C.current.floatingContext) == null ? void 0 : G.nodeId;
  }), E = o === !1, S = Rf(v) && E, O = rn(o), M = rn(s), T = rn(c), P = rn(m), I = Ho(h), R = _1(), D = b.useRef(!1), k = b.useRef(!1), $ = b.useRef(!1), L = b.useRef(null), A = b.useRef(""), F = b.useRef(""), N = b.useRef(null), V = b.useRef(null), K = ar(N, f, R == null ? void 0 : R.beforeInsideRef), Y = ar(V, R == null ? void 0 : R.afterInsideRef), U = Sn(), j = Sn(), H = ca(), q = R != null, B = Pf(y), X = ye((G = B) => G ? Ia(G) : []), te = ye(() => (p == null ? void 0 : p().filter((G) => G != null)) ?? []);
  b.useEffect(() => {
    if (r || !a)
      return;
    function G(Q) {
      Q.key === "Tab" && Ie(B, fn(Ze(B))) && X().length === 0 && !S && wn(Q);
    }
    const ne = Ze(B);
    return qe(ne, "keydown", G);
  }, [r, B, a, S, X]), b.useEffect(() => {
    if (r || !m)
      return;
    const G = Ze(B);
    function ne() {
      $.current = !1;
    }
    function Q(fe) {
      const le = Ot(fe), Ee = te(), se = Ie(y, le) || Ie(v, le) || Ie(R == null ? void 0 : R.portalNode, le) || Ee.some((_e) => _e === le || Ie(_e, le));
      $.current = !se, F.current = fe.pointerType || "keyboard", le != null && le.closest(`[${qh}]`) && (k.current = !0, j.start(0, () => {
        k.current = !1;
      }));
    }
    function re() {
      F.current = "keyboard";
    }
    return mr(
      qe(G, "pointerdown", Q, !0),
      qe(G, "pointerup", ne, !0),
      qe(G, "pointercancel", ne, !0),
      qe(G, "keydown", re, !0),
      // Avoid a stale `true` leaking into the next open (e.g. keep-mounted popups)
      // if the popup dismissed between pointerdown and pointerup.
      ne
    );
  }, [r, y, v, B, m, R, j, te]), b.useEffect(() => {
    if (r || !l)
      return;
    const G = Ze(B);
    function ne() {
      k.current = !0, j.start(0, () => {
        k.current = !1;
      });
    }
    function Q(Ee) {
      const se = Ot(Ee);
      Gh(se) && (L.current = se);
    }
    function re(Ee) {
      const se = Ee.relatedTarget, _e = Ee.currentTarget, xe = Ot(Ee);
      a && se == null && xe != null && Ie(y, xe) && Zm(xe), queueMicrotask(() => {
        const ge = w(), ae = g.context.triggerElements, W = te(), Z = (se == null ? void 0 : se.hasAttribute(ua("focus-guard"))) && [N.current, V.current, R == null ? void 0 : R.beforeInsideRef.current, R == null ? void 0 : R.afterInsideRef.current, R == null ? void 0 : R.beforeOutsideRef.current, R == null ? void 0 : R.afterOutsideRef.current, Yr(d), Yr(u)].includes(se), me = !(Ie(v, se) || Ie(y, se) || Ie(se, y) || Ie(R == null ? void 0 : R.portalNode, se) || W.some((ie) => ie === se || Ie(ie, se)) || ae.hasMatchingElement((ie) => Ie(ie, se)) || Z || I && (Io(I.nodesRef.current, ge).find((ie) => {
          var oe, he;
          return Ie((oe = ie.context) == null ? void 0 : oe.elements.floating, se) || Ie((he = ie.context) == null ? void 0 : he.elements.domReference, se);
        }) || Bm(I.nodesRef.current, ge).find((ie) => {
          var oe, he, Re;
          return [(oe = ie.context) == null ? void 0 : oe.elements.floating, Pf((he = ie.context) == null ? void 0 : he.elements.floating)].includes(se) || ((Re = ie.context) == null ? void 0 : Re.elements.domReference) === se;
        })));
        if (_e === v && B && Jm(B), i && _e !== v && !lu(xe) && fn(G) === G.body) {
          if (wt(B) && (B.focus(), i === "popup")) {
            H.request(() => {
              B.focus();
            });
            return;
          }
          const ie = X(), oe = L.current, he = (oe && ie.includes(oe) ? oe : null) || ie[ie.length - 1] || B;
          wt(he) && he.focus();
        }
        if (C.current.insideReactTree) {
          C.current.insideReactTree = !1;
          return;
        }
        (S || !a) && se && me && !k.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        // For an "untrapped" typeable combobox (input role=combobox with
        // initialFocus=false), re-opening the popup and tabbing out should still close it even
        // when the previously focused element (e.g. the next tabbable outside the popup) is
        // focused again. Otherwise, the popup remains open on the second Tab sequence:
        // click input -> Tab (closes) -> click input -> Tab.
        // Allow closing when `isUntrappedTypeableCombobox` regardless of the previously focused element.
        (S || se !== Qm()) && (D.current = !0, g.setOpen(!1, Ne(Ro, Ee)));
      });
    }
    function fe() {
      $.current || (C.current.insideReactTree = !0, U.start(0, () => {
        C.current.insideReactTree = !1;
      }));
    }
    const le = wt(v) ? v : null;
    if (!(!y && !le))
      return mr(le && qe(le, "focusout", re), le && qe(le, "pointerdown", ne), y && qe(y, "focusin", Q), y && qe(y, "focusout", re), y && R && qe(y, "focusout", fe, !0));
  }, [r, v, y, B, a, I, R, g, l, i, X, S, w, C, U, j, H, u, d, te]), b.useEffect(() => {
    var _e, xe, ge;
    if (r || !y || !m)
      return;
    const G = Array.from(((_e = R == null ? void 0 : R.portalNode) == null ? void 0 : _e.querySelectorAll(`[${ua("portal")}]`)) || []), Q = (ge = (xe = (I ? Bm(I.nodesRef.current, w()) : []).find((ae) => {
      var W;
      return Rf(((W = ae.context) == null ? void 0 : W.elements.domReference) || null);
    })) == null ? void 0 : xe.context) == null ? void 0 : ge.elements.domReference, fe = [...[y, ...G, N.current, V.current, R == null ? void 0 : R.beforeOutsideRef.current, R == null ? void 0 : R.afterOutsideRef.current, ...te()], Q, Yr(d), Yr(u), S ? v : null].filter((ae) => ae != null), le = Gm(fe, {
      ariaHidden: a || S,
      mark: !1
    }), Ee = [y, ...G].filter((ae) => ae != null), se = Gm(Ee);
    return () => {
      se(), le();
    };
  }, [m, r, v, y, a, R, S, I, w, u, d, te]), pe(() => {
    if (!m || r || !wt(B))
      return;
    A.current = "", F.current = "";
    const G = Ze(B), ne = fn(G);
    queueMicrotask(() => {
      const Q = O.current, re = typeof Q == "function" ? Q(T.current || "") : Q;
      if (re === void 0 || re === !1 || Ie(B, ne))
        return;
      let le = null;
      const Ee = () => (le == null && (le = X(B)), le[0] || B);
      let se;
      re === !0 || re === null ? se = Ee() : se = Yr(re), se = se || Ee();
      const _e = Ie(B, fn(G));
      Ul(se, {
        preventScroll: se === B,
        shouldFocus() {
          if (!P.current)
            return !1;
          if (_e)
            return !0;
          const xe = fn(G);
          return !(xe !== se && Ie(B, xe));
        }
      });
    });
  }, [r, m, B, X, O, T, P]), pe(() => {
    if (r || !B)
      return;
    const G = Ze(B), ne = fn(G), Q = T.current == null;
    Zm(ne);
    function re(le) {
      if (le.open || (A.current = GT(le.nativeEvent, F.current)), le.reason === qt && le.nativeEvent.type === "mouseleave" && (D.current = !0), le.reason === iu)
        if (le.nested)
          D.current = !1;
        else if (Qy(le.nativeEvent) || $h(le.nativeEvent))
          D.current = !1;
        else {
          let Ee = !1;
          Ze(B).createElement("div").focus({
            get preventScroll() {
              return Ee = !0, !1;
            }
          }), Ee ? D.current = !1 : D.current = !0;
        }
    }
    x.on("openchange", re);
    function fe(le) {
      const Ee = M.current;
      let se = typeof Ee == "function" ? Ee(le) : Ee;
      if (se === void 0 || se === !1)
        return null;
      se === null && (se = !0);
      const _e = v != null && v.isConnected ? v : null, xe = ne != null && ne.isConnected && Rn(ne) !== "body" ? ne : null;
      let ge = Q ? xe || _e : _e || xe;
      return ge || (ge = Qm() || null), typeof se == "boolean" ? ge : Yr(se) || ge || null;
    }
    return () => {
      x.off("openchange", re);
      const le = fn(G), Ee = te(), se = Ie(y, le) || Ee.some((ae) => ae === le || Ie(ae, le)) || I && Io(I.nodesRef.current, w(), !1).some((ae) => {
        var W;
        return Ie((W = ae.context) == null ? void 0 : W.elements.floating, le);
      }), _e = M.current, xe = A.current, ge = fe(xe);
      queueMicrotask(() => {
        const ae = KT(ge), W = typeof _e != "boolean";
        if (_e && !D.current && wt(ae) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(!W && ae !== le && le !== G.body) || se)) {
          const Z = {
            preventScroll: !0
          };
          xe === "keyboard" && (Z.focusVisible = !0), ae.focus(Z);
        }
        D.current = !1;
      });
    };
  }, [r, y, B, M, T, x, I, v, w, te]), pe(() => {
    if (!Lo || m || !y)
      return;
    const G = fn(Ze(y));
    !wt(G) || !su(G) || Ie(y, G) && G.blur();
  }, [m, y]), pe(() => {
    if (!(r || !R))
      return R.setFocusManagerState({
        modal: a,
        closeOnFocusOut: l,
        open: m,
        onOpenChange: g.setOpen,
        domReference: v
      }), () => {
        R.setFocusManagerState(null);
      };
  }, [r, R, a, m, g, l, v]), pe(() => {
    if (!(r || !B))
      return Jm(B), () => {
        queueMicrotask(np);
      };
  }, [r, B]);
  const J = !r && (a ? !S : !0) && (q || a);
  return /* @__PURE__ */ ee(b.Fragment, {
    children: [J && /* @__PURE__ */ _(Vr, {
      "data-type": "inside",
      ref: K,
      onFocus: (G) => {
        var ne;
        if (a) {
          const Q = X();
          Ul(Q[Q.length - 1]);
        } else if (R != null && R.portalNode)
          if (D.current = !1, zs(G, R.portalNode)) {
            const Q = Kh(v);
            Q == null || Q.focus();
          } else
            (ne = Yr(d ?? R.beforeOutsideRef)) == null || ne.focus();
      }
    }), n, J && /* @__PURE__ */ _(Vr, {
      "data-type": "inside",
      ref: Y,
      onFocus: (G) => {
        var ne;
        if (a)
          Ul(X()[0]);
        else if (R != null && R.portalNode)
          if (l && (D.current = !0), zs(G, R.portalNode)) {
            const Q = y1(v);
            Q == null || Q.focus();
          } else
            (ne = Yr(u ?? R.afterOutsideRef)) == null || ne.focus();
      }
    })]
  });
}
function li(e, t = {}) {
  const {
    enabled: n = !0,
    event: r = "click",
    toggle: o = !0,
    ignoreMouse: s = !1,
    stickIfOpen: i = !0,
    touchOpenDelay: a = 0,
    reason: l = Lr
  } = t, c = "rootStore" in e ? e.rootStore : e, u = c.context.dataRef, d = b.useRef(void 0), f = ca(), h = Sn(), p = b.useMemo(() => {
    function g(v, y, x, C) {
      const w = Ne(l, y, x);
      v && C === "touch" && a > 0 ? h.start(a, () => {
        c.setOpen(!0, w);
      }) : c.setOpen(v, w);
    }
    function m(v, y, x) {
      const C = u.current.openEvent, w = c.select("domReferenceElement") !== y;
      return v && w || !v || !o ? !0 : C && i ? !x(C.type) : !1;
    }
    return {
      onPointerDown(v) {
        d.current = _o(v.pointerType, !0) && $h(v.nativeEvent) ? "virtual" : v.pointerType;
      },
      onMouseDown(v) {
        const y = d.current, x = v.nativeEvent, C = c.select("open");
        if (v.button !== 0 || r === "click" || _o(y, !0) && s)
          return;
        const w = m(C, v.currentTarget, (O) => O === "click" || O === "mousedown"), E = Ot(x);
        if (su(E)) {
          g(w, x, E, y);
          return;
        }
        const S = v.currentTarget;
        f.request(() => {
          g(w, x, S, y);
        });
      },
      onClick(v) {
        if (r === "mousedown-only")
          return;
        const y = d.current;
        if (r === "mousedown" && y) {
          d.current = void 0;
          return;
        }
        if (_o(y, !0) && s)
          return;
        const x = c.select("open"), C = m(x, v.currentTarget, (w) => w === "click" || w === "mousedown" || w === "keydown" || w === "keyup");
        g(C, v.nativeEvent, v.currentTarget, y);
      },
      onKeyDown() {
        d.current = void 0;
      }
    };
  }, [u, r, s, l, c, i, o, f, h, a]);
  return b.useMemo(() => n ? {
    reference: p
  } : At, [n, p]);
}
function qT(e, t) {
  let n = null, r = null, o = !1;
  return {
    contextElement: e || void 0,
    getBoundingClientRect() {
      var h;
      const s = (e == null ? void 0 : e.getBoundingClientRect()) || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      }, i = t.axis === "x" || t.axis === "both", a = t.axis === "y" || t.axis === "both", l = ["mouseenter", "mousemove"].includes(((h = t.dataRef.current.openEvent) == null ? void 0 : h.type) || "") && t.pointerType !== "touch";
      let c = s.width, u = s.height, d = s.x, f = s.y;
      return n == null && t.x && i && (n = s.x - t.x), r == null && t.y && a && (r = s.y - t.y), d -= n || 0, f -= r || 0, c = 0, u = 0, !o || l ? (c = t.axis === "y" ? s.width : 0, u = t.axis === "x" ? s.height : 0, d = i && t.x != null ? t.x : d, f = a && t.y != null ? t.y : f) : o && !l && (u = t.axis === "x" ? s.height : u, c = t.axis === "y" ? s.width : c), o = !0, {
        width: c,
        height: u,
        x: d,
        y: f,
        top: f,
        right: d + c,
        bottom: f + u,
        left: d
      };
    }
  };
}
function eb(e) {
  return e != null && e.clientX != null;
}
function XT(e, t = {}) {
  const {
    enabled: n = !0,
    axis: r = "both"
  } = t, o = "rootStore" in e ? e.rootStore : e, s = o.useState("open"), i = o.useState("floatingElement"), a = o.useState("domReferenceElement"), l = o.context.dataRef, c = b.useRef(!1), u = b.useRef(null), [d, f] = b.useState(), [h, p] = b.useState([]), g = ye((C) => {
    o.set("positionReference", C);
  }), m = ye((C, w, E) => {
    c.current || l.current.openEvent && !eb(l.current.openEvent) || o.set("positionReference", qT(E ?? a, {
      x: C,
      y: w,
      axis: r,
      dataRef: l,
      pointerType: d
    }));
  }), v = ye((C) => {
    s ? u.current || (m(C.clientX, C.clientY, C.currentTarget), p([])) : m(C.clientX, C.clientY, C.currentTarget);
  }), y = _o(d) ? i : s;
  b.useEffect(() => {
    if (!n) {
      g(a);
      return;
    }
    if (!y)
      return;
    function C() {
      var S;
      (S = u.current) == null || S.call(u), u.current = null;
    }
    const w = Ht(i);
    function E(S) {
      const O = Ot(S);
      Ie(i, O) ? C() : m(S.clientX, S.clientY);
    }
    return !l.current.openEvent || eb(l.current.openEvent) ? u.current = qe(w, "mousemove", E) : g(a), C;
  }, [y, n, i, l, a, o, m, g, h]), b.useEffect(() => () => {
    o.set("positionReference", null);
  }, [o]), b.useEffect(() => {
    n && !i && (c.current = !1);
  }, [n, i]), b.useEffect(() => {
    !n && s && (c.current = !0);
  }, [n, s]);
  const x = b.useMemo(() => {
    function C(w) {
      f(w.pointerType);
    }
    return {
      onPointerDown: C,
      onPointerEnter: C,
      onMouseMove: v,
      onMouseEnter: v
    };
  }, [v]);
  return b.useMemo(() => n ? {
    reference: x,
    trigger: x
  } : {}, [n, x]);
}
function ZT() {
  return !1;
}
function QT(e) {
  return {
    escapeKey: typeof e == "boolean" ? e : (e == null ? void 0 : e.escapeKey) ?? !1,
    outsidePress: typeof e == "boolean" ? e : (e == null ? void 0 : e.outsidePress) ?? !0
  };
}
function Da(e, t = {}) {
  const {
    enabled: n = !0,
    escapeKey: r = !0,
    outsidePress: o = !0,
    outsidePressEvent: s = "sloppy",
    referencePress: i = ZT,
    bubbles: a,
    externalTree: l
  } = t, c = "rootStore" in e ? e.rootStore : e, u = c.useState("open"), d = c.useState("floatingElement"), {
    dataRef: f
  } = c.context, h = Ho(l), p = ye(typeof o == "function" ? o : () => !1), g = typeof o == "function" ? p : o, m = g !== !1, v = ye(() => s), {
    escapeKey: y,
    outsidePress: x
  } = QT(a), C = b.useRef(!1), w = b.useRef(!1), E = b.useRef(!1), S = b.useRef(!1), O = b.useRef(""), M = b.useRef(null), T = Sn(), P = Sn(), I = ye(() => {
    P.clear(), f.current.insideReactTree = !1;
  }), R = ye((K) => {
    var j;
    const Y = (j = f.current.floatingContext) == null ? void 0 : j.nodeId;
    return (h ? Io(h.nodesRef.current, Y) : []).some((H) => {
      var q;
      return ((q = H.context) == null ? void 0 : q.open) && !H.context.dataRef.current[K];
    });
  }), D = ye((K) => bd(K, c.select("floatingElement")) || bd(K, c.select("domReferenceElement"))), k = ye((K) => {
    i() && c.setOpen(!1, Ne(Lr, K.nativeEvent));
  }), $ = ye((K) => {
    if (!u || !n || !r || K.key !== "Escape" || S.current || !y && R("__escapeKeyBubbles"))
      return;
    const Y = eT(K) ? K.nativeEvent : K, U = Ne(bs, Y);
    c.setOpen(!1, U), U.isCanceled || K.preventDefault(), !y && !U.isPropagationAllowed && K.stopPropagation();
  }), L = ye(() => {
    f.current.insideReactTree = !0, P.start(0, I);
  }), A = ye((K) => {
    if (!u || !n || K.button !== 0)
      return;
    const Y = Ot(K.nativeEvent);
    Ie(c.select("floatingElement"), Y) && (C.current || (C.current = !0, w.current = !1));
  }), F = ye((K) => {
    !u || !n || (K.defaultPrevented || K.nativeEvent.defaultPrevented) && C.current && (w.current = !0);
  });
  b.useEffect(() => {
    if (!u || !n)
      return I;
    f.current.__escapeKeyBubbles = y, f.current.__outsidePressBubbles = x;
    const K = new Ln(), Y = new Ln();
    function U() {
      K.clear(), S.current = !0;
    }
    function j() {
      K.start(
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        Lo ? 5 : 0,
        () => {
          S.current = !1;
        }
      );
    }
    function H() {
      E.current = !0, Y.start(0, () => {
        E.current = !1;
      });
    }
    function q() {
      C.current = !1, w.current = !1;
    }
    function B() {
      const W = O.current, Z = W === "pen" || !W ? "mouse" : W, me = v(), ie = typeof me == "function" ? me() : me;
      return typeof ie == "string" ? ie : ie[Z];
    }
    function X(W) {
      const Z = B();
      return Z === "intentional" && W.type !== "click" || Z === "sloppy" && W.type === "click";
    }
    function te(W) {
      var ie;
      const Z = (ie = f.current.floatingContext) == null ? void 0 : ie.nodeId, me = h && Io(h.nodesRef.current, Z).some((oe) => {
        var he;
        return bd(W, (he = oe.context) == null ? void 0 : he.elements.floating);
      });
      return D(W) || me;
    }
    function J(W) {
      if (X(W)) {
        W.type !== "click" && !D(W) && (Y.clear(), E.current = !1), I();
        return;
      }
      if (f.current.insideReactTree) {
        I();
        return;
      }
      const Z = Ot(W), me = `[${ua("inert")}]`, ie = Qe(Z) ? Z.getRootNode() : null, oe = Array.from((qs(ie) ? ie : Ze(c.select("floatingElement"))).querySelectorAll(me)), he = c.context.triggerElements;
      if (Z && (he.hasElement(Z) || he.hasMatchingElement((Ae) => Ie(Ae, Z))))
        return;
      let Re = Qe(Z) ? Z : null;
      for (; Re && !Jr(Re); ) {
        const Ae = ro(Re);
        if (Jr(Ae) || !Qe(Ae))
          break;
        Re = Ae;
      }
      if (!(oe.length && Qe(Z) && !iT(Z) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
      !Ie(Z, c.select("floatingElement")) && // If the target root element contains none of the markers, then the
      // element was injected after the floating element rendered.
      oe.every((Ae) => !Ie(Re, Ae)))) {
        if (wt(Z) && !("touches" in W)) {
          const Ae = Jr(Z), Ue = Vn(Z), Ke = /auto|scroll/, Be = Ae || Ke.test(Ue.overflowX), nt = Ae || Ke.test(Ue.overflowY), at = Be && Z.clientWidth > 0 && Z.scrollWidth > Z.clientWidth, Wt = nt && Z.clientHeight > 0 && Z.scrollHeight > Z.clientHeight, Mt = Ue.direction === "rtl", Bt = Wt && (Mt ? W.offsetX <= Z.offsetWidth - Z.clientWidth : W.offsetX > Z.clientWidth), Qt = at && W.offsetY > Z.clientHeight;
          if (Bt || Qt)
            return;
        }
        if (!te(W)) {
          if (B() === "intentional" && E.current) {
            Y.clear(), E.current = !1;
            return;
          }
          typeof g == "function" && !g(W) || R("__outsidePressBubbles") || (c.setOpen(!1, Ne(iu, W)), I());
        }
      }
    }
    function G(W) {
      B() !== "sloppy" || W.pointerType === "touch" || !c.select("open") || !n || D(W) || J(W);
    }
    function ne(W) {
      if (B() !== "sloppy" || !c.select("open") || !n || D(W))
        return;
      const Z = W.touches[0];
      Z && (M.current = {
        startTime: Date.now(),
        startX: Z.clientX,
        startY: Z.clientY,
        dismissOnTouchEnd: !1,
        dismissOnMouseDown: !0
      }, T.start(1e3, () => {
        M.current && (M.current.dismissOnTouchEnd = !1, M.current.dismissOnMouseDown = !1);
      }));
    }
    function Q(W, Z) {
      const me = Ot(W);
      if (!me)
        return;
      const ie = qe(me, W.type, () => {
        Z(W), ie();
      });
    }
    function re(W) {
      O.current = "touch", Q(W, ne);
    }
    function fe(W) {
      T.clear(), W.type === "pointerdown" && (O.current = W.pointerType), !(W.type === "mousedown" && M.current && !M.current.dismissOnMouseDown) && Q(W, (Z) => {
        Z.type === "pointerdown" ? G(Z) : J(Z);
      });
    }
    function le(W) {
      if (!C.current)
        return;
      const Z = w.current;
      if (q(), B() === "intentional") {
        if (W.type === "pointercancel") {
          Z && H();
          return;
        }
        if (!te(W)) {
          if (Z) {
            H();
            return;
          }
          typeof g == "function" && !g(W) || (Y.clear(), E.current = !0, I());
        }
      }
    }
    function Ee(W) {
      if (B() !== "sloppy" || !M.current || D(W))
        return;
      const Z = W.touches[0];
      if (!Z)
        return;
      const me = Math.abs(Z.clientX - M.current.startX), ie = Math.abs(Z.clientY - M.current.startY), oe = Math.sqrt(me * me + ie * ie);
      oe > 5 && (M.current.dismissOnTouchEnd = !0), oe > 10 && (J(W), T.clear(), M.current = null);
    }
    function se(W) {
      Q(W, Ee);
    }
    function _e(W) {
      B() !== "sloppy" || !M.current || D(W) || (M.current.dismissOnTouchEnd && J(W), T.clear(), M.current = null);
    }
    function xe(W) {
      Q(W, _e);
    }
    const ge = Ze(d), ae = mr(r && mr(qe(ge, "keydown", $), qe(ge, "compositionstart", U), qe(ge, "compositionend", j)), m && mr(qe(ge, "click", fe, !0), qe(ge, "pointerdown", fe, !0), qe(ge, "pointerup", le, !0), qe(ge, "pointercancel", le, !0), qe(ge, "mousedown", fe, !0), qe(ge, "mouseup", le, !0), qe(ge, "touchstart", re, !0), qe(ge, "touchmove", se, !0), qe(ge, "touchend", xe, !0)));
    return () => {
      ae(), K.clear(), Y.clear(), q(), E.current = !1, I();
    };
  }, [f, d, r, m, g, u, n, y, x, $, I, v, R, D, h, c, T]);
  const N = b.useMemo(() => ({
    onKeyDown: $,
    onPointerDown: k,
    onClick: k
  }), [$, k]), V = b.useMemo(() => ({
    onKeyDown: $,
    // `onMouseDown` may be blocked if `event.preventDefault()` is called in
    // `onPointerDown`, such as with <NumberField.ScrubArea>.
    // See https://github.com/mui/base-ui/pull/3379
    onPointerDown: F,
    onMouseDown: F,
    onClickCapture: L,
    onMouseDownCapture(K) {
      L(), A(K);
    },
    onPointerDownCapture(K) {
      L(), A(K);
    },
    onMouseUpCapture: L,
    onTouchEndCapture: L,
    onTouchMoveCapture: L
  }), [$, L, A, F]);
  return b.useMemo(() => n ? {
    reference: N,
    floating: V,
    trigger: N
  } : {}, [n, N, V]);
}
function tb(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const s = sr(t), i = Uh(t), a = jh(i), l = ir(t), c = s === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[a] / 2 - o[a] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  const p = Vo(t);
  return p && (h[i] += f * (p === "end" ? 1 : -1) * (n && c ? -1 : 1)), h;
}
async function JT(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: s,
    rects: i,
    elements: a,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = Po(t, e), p = u1(h), m = a[f ? d === "floating" ? "reference" : "floating" : d], v = mc(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(m))) == null || n ? m : m.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), y = d === "floating" ? {
    x: r,
    y: o,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, x = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a.floating)), C = await (s.isElement == null ? void 0 : s.isElement(x)) && await (s.getScale == null ? void 0 : s.getScale(x)) || {
    x: 1,
    y: 1
  }, w = mc(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: y,
    offsetParent: x,
    strategy: l
  }) : y);
  return {
    top: (v.top - w.top + p.top) / C.y,
    bottom: (w.bottom - v.bottom + p.bottom) / C.y,
    left: (v.left - w.left + p.left) / C.x,
    right: (w.right - v.right + p.right) / C.x
  };
}
const eR = 50, tR = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: s = [],
    platform: i
  } = n, a = i.detectOverflow ? i : {
    ...i,
    detectOverflow: JT
  }, l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let c = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = tb(c, r, l), f = r, h = 0;
  const p = {};
  for (let g = 0; g < s.length; g++) {
    const m = s[g];
    if (!m)
      continue;
    const {
      name: v,
      fn: y
    } = m, {
      x,
      y: C,
      data: w,
      reset: E
    } = await y({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: p,
      rects: c,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = x ?? u, d = C ?? d, p[v] = {
      ...p[v],
      ...w
    }, E && h < eR && (h++, typeof E == "object" && (E.placement && (f = E.placement), E.rects && (c = E.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : E.rects), {
      x: u,
      y: d
    } = tb(c, f, l)), g = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: p
  };
}, nR = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: s,
        rects: i,
        initialPlacement: a,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: g = !0,
        ...m
      } = Po(e, t);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const v = ir(o), y = sr(a), x = ir(a) === a, C = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), w = f || (x || !g ? [gc(a)] : xT(a)), E = p !== "none";
      !f && E && w.push(..._T(a, g, p, C));
      const S = [a, ...w], O = await l.detectOverflow(t, m), M = [];
      let T = ((r = s.flip) == null ? void 0 : r.overflows) || [];
      if (u && M.push(O[v]), d) {
        const D = yT(o, i, C);
        M.push(O[D[0]], O[D[1]]);
      }
      if (T = [...T, {
        placement: o,
        overflows: M
      }], !M.every((D) => D <= 0)) {
        var P, I;
        const D = (((P = s.flip) == null ? void 0 : P.index) || 0) + 1, k = S[D];
        if (k && (!(d === "alignment" ? y !== sr(k) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        T.every((A) => sr(A.placement) === y ? A.overflows[0] > 0 : !0)))
          return {
            data: {
              index: D,
              overflows: T
            },
            reset: {
              placement: k
            }
          };
        let $ = (I = T.filter((L) => L.overflows[0] <= 0).sort((L, A) => L.overflows[1] - A.overflows[1])[0]) == null ? void 0 : I.placement;
        if (!$)
          switch (h) {
            case "bestFit": {
              var R;
              const L = (R = T.filter((A) => {
                if (E) {
                  const F = sr(A.placement);
                  return F === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  F === "y";
                }
                return !0;
              }).map((A) => [A.placement, A.overflows.filter((F) => F > 0).reduce((F, N) => F + N, 0)]).sort((A, F) => A[1] - F[1])[0]) == null ? void 0 : R[0];
              L && ($ = L);
              break;
            }
            case "initialPlacement":
              $ = a;
              break;
          }
        if (o !== $)
          return {
            reset: {
              placement: $
            }
          };
      }
      return {};
    }
  };
}, R1 = /* @__PURE__ */ new Set(["left", "top"]);
async function rR(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, s = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), i = ir(n), a = Vo(n), l = sr(n) === "y", c = R1.has(i) ? -1 : 1, u = s && l ? -1 : 1, d = Po(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: p
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return a && typeof p == "number" && (h = a === "end" ? p * -1 : p), l ? {
    x: h * u,
    y: f * c
  } : {
    x: f * c,
    y: h * u
  };
}
const oR = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: s,
        placement: i,
        middlewareData: a
      } = t, l = await rR(t, e);
      return i === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: s + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, sR = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        platform: s
      } = t, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: l = {
          fn: (y) => {
            let {
              x,
              y: C
            } = y;
            return {
              x,
              y: C
            };
          }
        },
        ...c
      } = Po(e, t), u = {
        x: n,
        y: r
      }, d = await s.detectOverflow(t, c), f = sr(o), h = Yh(f);
      let p = u[h], g = u[f];
      const m = (y, x) => c1(x + d[y === "y" ? "top" : "left"], x, x - d[y === "y" ? "bottom" : "right"]);
      i && (p = m(h, p)), a && (g = m(f, g));
      const v = l.fn({
        ...t,
        [h]: p,
        [f]: g
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - r,
          enabled: {
            [h]: i,
            [f]: a
          }
        }
      };
    }
  };
}, iR = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      var n, r;
      const {
        x: o,
        y: s,
        placement: i,
        rects: a,
        middlewareData: l
      } = t, {
        offset: c = 0,
        mainAxis: u = !0,
        crossAxis: d = !0
      } = Po(e, t), f = {
        x: o,
        y: s
      }, h = sr(i), p = Yh(h);
      let g = f[p], m = f[h];
      const v = Po(c, t), y = typeof v == "number" ? {
        mainAxis: v,
        crossAxis: 0
      } : {
        mainAxis: (n = v.mainAxis) != null ? n : 0,
        crossAxis: (r = v.crossAxis) != null ? r : 0
      };
      if (u) {
        const w = p === "y" ? "height" : "width", E = a.reference[p] - a.floating[w] + y.mainAxis, S = a.reference[p] + a.reference[w] - y.mainAxis;
        g < E ? g = E : g > S && (g = S);
      }
      if (d) {
        var x, C;
        const w = p === "y" ? "width" : "height", E = R1.has(ir(i)), S = a.reference[h] - a.floating[w] + (E && ((x = l.offset) == null ? void 0 : x[h]) || 0) + (E ? 0 : y.crossAxis), O = a.reference[h] + a.reference[w] + (E ? 0 : ((C = l.offset) == null ? void 0 : C[h]) || 0) - (E ? y.crossAxis : 0);
        m < S ? m = S : m > O && (m = O);
      }
      return {
        [p]: g,
        [h]: m
      };
    }
  };
}, aR = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: s
      } = t, {
        apply: i = () => {
        },
        ...a
      } = Po(e, t), l = await o.detectOverflow(t, a), c = ir(n), u = Vo(n), d = sr(n) === "y", {
        width: f,
        height: h
      } = r.floating;
      let p, g;
      c === "top" || c === "bottom" ? (p = c, g = u === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (g = c, p = u === "end" ? "top" : "bottom");
      const m = h - l.top - l.bottom, v = f - l.left - l.right, y = Zs(h - l[p], m), x = Zs(f - l[g], v), C = t.middlewareData.shift, w = !C;
      let E = y, S = x;
      C != null && C.enabled.x && (S = v), C != null && C.enabled.y && (E = m), w && !u && (d ? S = f - 2 * eo(l.left, l.right) : E = h - 2 * eo(l.top, l.bottom)), await i({
        ...t,
        availableWidth: S,
        availableHeight: E
      });
      const O = await o.getDimensions(s.floating);
      return f !== O.width || h !== O.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function P1(e) {
  const t = Vn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = wt(e), s = o ? e.offsetWidth : n, i = o ? e.offsetHeight : r, a = pc(n) !== s || pc(r) !== i;
  return a && (n = s, r = i), {
    width: n,
    height: r,
    $: a
  };
}
function rp(e) {
  return Qe(e) ? e : e.contextElement;
}
function Ys(e) {
  const t = rp(e);
  if (!wt(t))
    return to(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: s
  } = P1(t);
  let i = (s ? pc(n.width) : n.width) / r, a = (s ? pc(n.height) : n.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: i,
    y: a
  };
}
const lR = /* @__PURE__ */ to(0);
function I1(e) {
  const t = Ht(e);
  return !Vh() || !t.visualViewport ? lR : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function cR(e, t, n) {
  return t === void 0 && (t = !1), !!n && t && n === Ht(e);
}
function ds(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), s = rp(e);
  let i = to(1);
  t && (r ? Qe(r) && (i = Ys(r)) : i = Ys(e));
  const a = cR(s, n, r) ? I1(s) : to(0);
  let l = (o.left + a.x) / i.x, c = (o.top + a.y) / i.y, u = o.width / i.x, d = o.height / i.y;
  if (s && r) {
    const f = Ht(s), h = Qe(r) ? Ht(r) : r;
    let p = f, g = Mf(p);
    for (; g && h !== p; ) {
      const m = Ys(g), v = g.getBoundingClientRect(), y = Vn(g), x = v.left + (g.clientLeft + parseFloat(y.paddingLeft)) * m.x, C = v.top + (g.clientTop + parseFloat(y.paddingTop)) * m.y;
      l *= m.x, c *= m.y, u *= m.x, d *= m.y, l += x, c += C, p = Ht(g), g = Mf(p);
    }
  }
  return mc({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function uu(e, t) {
  const n = ru(e).scrollLeft;
  return t ? t.left + n : ds(lo(e)).left + n;
}
function k1(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - uu(e, n), o = n.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function uR(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const s = o === "fixed", i = lo(r), a = t ? nu(t.floating) : !1;
  if (r === i || a && s)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = to(1);
  const u = to(0), d = wt(r);
  if ((d || !s) && ((Rn(r) !== "body" || Ta(i)) && (l = ru(r)), d)) {
    const h = ds(r);
    c = Ys(r), u.x = h.x + r.clientLeft, u.y = h.y + r.clientTop;
  }
  const f = i && !d && !s ? k1(i, l) : to(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x + f.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y + f.y
  };
}
function dR(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function fR(e) {
  const t = ru(e), n = e.ownerDocument.body, r = eo(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), o = eo(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let s = -t.scrollLeft + uu(e);
  const i = -t.scrollTop;
  return Vn(n).direction === "rtl" && (s += eo(e.clientWidth, n.clientWidth) - r), {
    width: r,
    height: o,
    x: s,
    y: i
  };
}
const hR = 25;
function pR(e, t, n) {
  n === void 0 && (n = "viewport");
  const r = n === "layoutViewport", o = Ht(e), s = lo(e), i = o.visualViewport;
  let a = s.clientWidth, l = s.clientHeight, c = 0, u = 0;
  if (i) {
    const f = !Vh() || t === "fixed";
    r ? f || (c = -i.offsetLeft, u = -i.offsetTop) : (a = i.width, l = i.height, f && (c = i.offsetLeft, u = i.offsetTop));
  }
  if (uu(s) <= 0) {
    const f = s.ownerDocument, h = f.body, p = getComputedStyle(h), g = f.compatMode === "CSS1Compat" && parseFloat(p.marginLeft) + parseFloat(p.marginRight) || 0, m = Math.abs(s.clientWidth - h.clientWidth - g), v = getComputedStyle(s).scrollbarGutter === "stable both-edges" ? m / 2 : m;
    v <= hR && (a -= v);
  }
  return {
    width: a,
    height: l,
    x: c,
    y: u
  };
}
function gR(e, t) {
  const n = ds(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, s = Ys(e), i = e.clientWidth * s.x, a = e.clientHeight * s.y, l = o * s.x, c = r * s.y;
  return {
    width: i,
    height: a,
    x: l,
    y: c
  };
}
function nb(e, t, n) {
  let r;
  if (t === "viewport" || t === "layoutViewport")
    r = pR(e, n, t);
  else if (t === "document")
    r = fR(lo(e));
  else if (Qe(t))
    r = gR(t, n);
  else {
    const o = I1(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return mc(r);
}
function mR(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Xs(e, [], !1).filter((a) => Qe(a) && Rn(a) !== "body"), o = null;
  const s = Vn(e).position === "fixed";
  let i = s ? ro(e) : e;
  for (; Qe(i) && !Jr(i); ) {
    const a = Vn(i), l = Lh(i), c = o ? o.position : s ? "fixed" : "";
    !l && (c === "fixed" || c === "absolute" && a.position === "static") ? r = r.filter((d) => d !== i) : o = a, i = ro(i);
  }
  return t.set(e, r), r;
}
function bR(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const i = [...n === "clippingAncestors" ? nu(t) ? [] : mR(t, this._c) : [].concat(n), r], a = nb(t, i[0], o);
  let l = a.top, c = a.right, u = a.bottom, d = a.left;
  for (let f = 1; f < i.length; f++) {
    const h = nb(t, i[f], o);
    l = eo(h.top, l), c = Zs(h.right, c), u = Zs(h.bottom, u), d = eo(h.left, d);
  }
  return {
    width: c - d,
    height: u - l,
    x: d,
    y: l
  };
}
function vR(e) {
  const {
    width: t,
    height: n
  } = P1(e);
  return {
    width: t,
    height: n
  };
}
function yR(e, t, n) {
  const r = wt(t), o = lo(t), s = n === "fixed", i = ds(e, !0, s, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = to(0);
  if ((r || !s) && ((Rn(t) !== "body" || Ta(o)) && (a = ru(t)), r)) {
    const f = ds(t, !0, s, t);
    l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
  }
  !r && o && (l.x = uu(o));
  const c = o && !r && !s ? k1(o, a) : to(0), u = i.left + a.scrollLeft - l.x - c.x, d = i.top + a.scrollTop - l.y - c.y;
  return {
    x: u,
    y: d,
    width: i.width,
    height: i.height
  };
}
function Cd(e) {
  return Vn(e).position === "static";
}
function rb(e, t) {
  if (!wt(e) || Vn(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return lo(e) === n && (n = n.ownerDocument.body), n;
}
function D1(e, t) {
  const n = Ht(e);
  if (nu(e))
    return n;
  if (!wt(e)) {
    let o = ro(e);
    for (; o && !Jr(o); ) {
      if (Qe(o) && !Cd(o))
        return o;
      o = ro(o);
    }
    return n;
  }
  let r = rb(e, t);
  for (; r && nT(r) && Cd(r); )
    r = rb(r, t);
  return r && Jr(r) && Cd(r) && !Lh(r) ? n : r || sT(e) || n;
}
const xR = async function(e) {
  const t = this.getOffsetParent || D1, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: yR(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function wR(e) {
  return Vn(e).direction === "rtl";
}
const CR = {
  convertOffsetParentRelativeRectToViewportRelativeRect: uR,
  getDocumentElement: lo,
  getClippingRect: bR,
  getOffsetParent: D1,
  getElementRects: xR,
  getClientRects: dR,
  getDimensions: vR,
  getScale: Ys,
  isElement: Qe,
  isRTL: wR
};
function N1(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function ER(e, t, n) {
  let r = null, o;
  const s = lo(e);
  function i() {
    var u;
    clearTimeout(o), (u = r) == null || u.disconnect(), r = null;
  }
  function a(u, d) {
    u === void 0 && (u = !1), d === void 0 && (d = 1), i();
    const f = e.getBoundingClientRect(), {
      left: h,
      top: p,
      width: g,
      height: m
    } = f;
    if (u || t(), !g || !m)
      return;
    const v = os(p), y = os(s.clientWidth - (h + g)), x = os(s.clientHeight - (p + m)), C = os(h), E = {
      rootMargin: -v + "px " + -y + "px " + -x + "px " + -C + "px",
      threshold: eo(0, Zs(1, d)) || 1
    };
    let S = !0;
    function O(M) {
      const T = M[0].intersectionRatio;
      if (!N1(f, e.getBoundingClientRect()))
        return a();
      if (T !== d) {
        if (!S)
          return a();
        T ? a(!1, T) : o = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      S = !1;
    }
    try {
      r = new IntersectionObserver(O, {
        ...E,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(O, E);
    }
    r.observe(e);
  }
  const l = Ht(e), c = () => a(n);
  return l.addEventListener("resize", c), a(!0), () => {
    l.removeEventListener("resize", c), i();
  };
}
function ob(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: s = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = rp(e), u = o || s ? [...c ? Xs(c) : [], ...t ? Xs(t) : []] : [];
  u.forEach((v) => {
    o && v.addEventListener("scroll", n), s && v.addEventListener("resize", n);
  });
  const d = c && a ? ER(c, n, s) : null;
  let f = -1, h = null;
  i && (h = new ResizeObserver((v) => {
    let [y] = v;
    y && y.target === c && h && t && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var x;
      (x = h) == null || x.observe(t);
    })), n();
  }), c && !l && h.observe(c), t && h.observe(t));
  let p, g = l ? ds(e) : null;
  l && m();
  function m() {
    const v = ds(e);
    g && !N1(g, v) && n(), g = v, p = requestAnimationFrame(m);
  }
  return n(), () => {
    var v;
    u.forEach((y) => {
      o && y.removeEventListener("scroll", n), s && y.removeEventListener("resize", n);
    }), d == null || d(), (v = h) == null || v.disconnect(), h = null, l && cancelAnimationFrame(p);
  };
}
const _R = oR, SR = sR, OR = nR, MR = aR, TR = iR, RR = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = n ?? {}, s = {
    ...CR,
    ...o.platform,
    _c: r
  };
  return tR(e, t, {
    ...o,
    platform: s
  });
};
var PR = typeof document < "u", IR = function() {
}, Gl = PR ? ii : IR;
function bc(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!bc(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const s = o[r];
      if (!(s === "_owner" && e.$$typeof) && !bc(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function A1(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function sb(e, t) {
  const n = A1(e);
  return Math.round(t * n) / n;
}
function Ed(e) {
  const t = b.useRef(e);
  return Gl(() => {
    t.current = e;
  }), t;
}
function kR(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: s,
      floating: i
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = b.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = b.useState(r);
  bc(f, r) || h(r);
  const [p, g] = b.useState(null), [m, v] = b.useState(null), y = b.useCallback((A) => {
    A !== E.current && (E.current = A, g(A));
  }, []), x = b.useCallback((A) => {
    A !== S.current && (S.current = A, v(A));
  }, []), C = s || p, w = i || m, E = b.useRef(null), S = b.useRef(null), O = b.useRef(u), M = l != null, T = Ed(l), P = Ed(o), I = Ed(c), R = b.useCallback(() => {
    if (!E.current || !S.current)
      return;
    const A = {
      placement: t,
      strategy: n,
      middleware: f
    };
    P.current && (A.platform = P.current), RR(E.current, S.current, A).then((F) => {
      const N = {
        ...F,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: I.current !== !1
      };
      D.current && !bc(O.current, N) && (O.current = N, Xn.flushSync(() => {
        d(N);
      }));
    });
  }, [f, t, n, P, I]);
  Gl(() => {
    c === !1 && O.current.isPositioned && (O.current.isPositioned = !1, d((A) => ({
      ...A,
      isPositioned: !1
    })));
  }, [c]);
  const D = b.useRef(!1);
  Gl(() => (D.current = !0, () => {
    D.current = !1;
  }), []), Gl(() => {
    if (C && (E.current = C), w && (S.current = w), C && w) {
      if (T.current)
        return T.current(C, w, R);
      R();
    }
  }, [C, w, R, T, M]);
  const k = b.useMemo(() => ({
    reference: E,
    floating: S,
    setReference: y,
    setFloating: x
  }), [y, x]), $ = b.useMemo(() => ({
    reference: C,
    floating: w
  }), [C, w]), L = b.useMemo(() => {
    const A = {
      position: n,
      left: 0,
      top: 0
    };
    if (!$.floating)
      return A;
    const F = sb($.floating, u.x), N = sb($.floating, u.y);
    return a ? {
      ...A,
      transform: "translate(" + F + "px, " + N + "px)",
      ...A1($.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: F,
      top: N
    };
  }, [n, a, $.floating, u.x, u.y]);
  return b.useMemo(() => ({
    ...u,
    update: R,
    refs: k,
    elements: $,
    floatingStyles: L
  }), [u, R, k, $, L]);
}
const DR = (e, t) => {
  const n = _R(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, NR = (e, t) => {
  const n = SR(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, AR = (e, t) => ({
  fn: TR(e).fn,
  options: [e, t]
}), $R = (e, t) => {
  const n = OR(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, FR = (e, t) => {
  const n = MR(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
};
var Af = { exports: {} }, _d = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ib;
function LR() {
  if (ib)
    return _d;
  ib = 1;
  var e = Oe;
  function t(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, s = e.useLayoutEffect, i = e.useDebugValue;
  function a(d, f) {
    var h = f(), p = r({ inst: { value: h, getSnapshot: f } }), g = p[0].inst, m = p[1];
    return s(
      function() {
        g.value = h, g.getSnapshot = f, l(g) && m({ inst: g });
      },
      [d, h, f]
    ), o(
      function() {
        return l(g) && m({ inst: g }), d(function() {
          l(g) && m({ inst: g });
        });
      },
      [d]
    ), i(h), h;
  }
  function l(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var h = f();
      return !n(d, h);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : a;
  return _d.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, _d;
}
var Sd = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ab;
function VR() {
  return ab || (ab = 1, process.env.NODE_ENV !== "production" && function() {
    function e(h, p) {
      return h === p && (h !== 0 || 1 / h === 1 / p) || h !== h && p !== p;
    }
    function t(h, p) {
      u || o.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var g = p();
      if (!d) {
        var m = p();
        s(g, m) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      m = i({
        inst: { value: g, getSnapshot: p }
      });
      var v = m[0].inst, y = m[1];
      return l(
        function() {
          v.value = g, v.getSnapshot = p, n(v) && y({ inst: v });
        },
        [h, g, p]
      ), a(
        function() {
          return n(v) && y({ inst: v }), h(function() {
            n(v) && y({ inst: v });
          });
        },
        [h]
      ), c(g), g;
    }
    function n(h) {
      var p = h.getSnapshot;
      h = h.value;
      try {
        var g = p();
        return !s(h, g);
      } catch {
        return !0;
      }
    }
    function r(h, p) {
      return p();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = Oe, s = typeof Object.is == "function" ? Object.is : e, i = o.useState, a = o.useEffect, l = o.useLayoutEffect, c = o.useDebugValue, u = !1, d = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    Sd.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Sd;
}
process.env.NODE_ENV === "production" ? Af.exports = LR() : Af.exports = VR();
var du = Af.exports, $f = { exports: {} }, Od = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lb;
function WR() {
  if (lb)
    return Od;
  lb = 1;
  var e = Oe, t = du;
  function n(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : n, o = t.useSyncExternalStore, s = e.useRef, i = e.useEffect, a = e.useMemo, l = e.useDebugValue;
  return Od.useSyncExternalStoreWithSelector = function(c, u, d, f, h) {
    var p = s(null);
    if (p.current === null) {
      var g = { hasValue: !1, value: null };
      p.current = g;
    } else
      g = p.current;
    p = a(
      function() {
        function v(E) {
          if (!y) {
            if (y = !0, x = E, E = f(E), h !== void 0 && g.hasValue) {
              var S = g.value;
              if (h(S, E))
                return C = S;
            }
            return C = E;
          }
          if (S = C, r(x, E))
            return S;
          var O = f(E);
          return h !== void 0 && h(S, O) ? (x = E, S) : (x = E, C = O);
        }
        var y = !1, x, C, w = d === void 0 ? null : d;
        return [
          function() {
            return v(u());
          },
          w === null ? void 0 : function() {
            return v(w());
          }
        ];
      },
      [u, d, f, h]
    );
    var m = o(c, p[0], p[1]);
    return i(
      function() {
        g.hasValue = !0, g.value = m;
      },
      [m]
    ), l(m), m;
  }, Od;
}
var Md = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cb;
function HR() {
  return cb || (cb = 1, process.env.NODE_ENV !== "production" && function() {
    function e(c, u) {
      return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = Oe, n = du, r = typeof Object.is == "function" ? Object.is : e, o = n.useSyncExternalStore, s = t.useRef, i = t.useEffect, a = t.useMemo, l = t.useDebugValue;
    Md.useSyncExternalStoreWithSelector = function(c, u, d, f, h) {
      var p = s(null);
      if (p.current === null) {
        var g = { hasValue: !1, value: null };
        p.current = g;
      } else
        g = p.current;
      p = a(
        function() {
          function v(E) {
            if (!y) {
              if (y = !0, x = E, E = f(E), h !== void 0 && g.hasValue) {
                var S = g.value;
                if (h(S, E))
                  return C = S;
              }
              return C = E;
            }
            if (S = C, r(x, E))
              return S;
            var O = f(E);
            return h !== void 0 && h(S, O) ? (x = E, S) : (x = E, C = O);
          }
          var y = !1, x, C, w = d === void 0 ? null : d;
          return [
            function() {
              return v(u());
            },
            w === null ? void 0 : function() {
              return v(w());
            }
          ];
        },
        [u, d, f, h]
      );
      var m = o(c, p[0], p[1]);
      return i(
        function() {
          g.hasValue = !0, g.value = m;
        },
        [m]
      ), l(m), m;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Md;
}
process.env.NODE_ENV === "production" ? $f.exports = WR() : $f.exports = HR();
var BR = $f.exports;
const zR = Mh(19), YR = zR ? UR : GR;
function we(e, t, n, r, o) {
  return YR(e, t, n, r, o);
}
function jR(e, t, n, r, o) {
  const s = b.useCallback(() => t(e.getSnapshot(), n, r, o), [e, t, n, r, o]);
  return du.useSyncExternalStore(e.subscribe, s, s);
}
UM({
  before(e) {
    e.syncIndex = 0, e.didInitialize || (e.syncTick = 1, e.syncHooks = [], e.didChangeStore = !0, e.getSnapshot = () => {
      let t = !1;
      for (let n = 0; n < e.syncHooks.length; n += 1) {
        const r = e.syncHooks[n], o = r.selector(r.store.state, r.a1, r.a2, r.a3);
        Object.is(r.value, o) || (t = !0, r.value = o);
      }
      return t && (e.syncTick += 1), e.syncTick;
    });
  },
  after(e) {
    e.syncHooks.length > 0 && (e.didChangeStore && (e.didChangeStore = !1, e.subscribe = (t) => {
      const n = /* @__PURE__ */ new Set();
      for (const o of e.syncHooks)
        n.add(o.store);
      const r = [];
      for (const o of n)
        r.push(o.subscribe(t));
      return () => {
        for (const o of r)
          o();
      };
    }), du.useSyncExternalStore(e.subscribe, e.getSnapshot, e.getSnapshot));
  }
});
function UR(e, t, n, r, o) {
  const s = jM();
  if (!s)
    return jR(e, t, n, r, o);
  const i = s.syncIndex;
  s.syncIndex += 1;
  let a;
  return s.didInitialize ? (a = s.syncHooks[i], (a.store !== e || a.selector !== t || !Object.is(a.a1, n) || !Object.is(a.a2, r) || !Object.is(a.a3, o)) && (a.store !== e && (s.didChangeStore = !0), a.store = e, a.selector = t, a.a1 = n, a.a2 = r, a.a3 = o, a.value = t(e.getSnapshot(), n, r, o))) : (a = {
    store: e,
    selector: t,
    a1: n,
    a2: r,
    a3: o,
    value: t(e.getSnapshot(), n, r, o)
  }, s.syncHooks.push(a)), a.value;
}
function GR(e, t, n, r, o) {
  return BR.useSyncExternalStoreWithSelector(e.subscribe, e.getSnapshot, e.getSnapshot, (s) => t(s, n, r, o));
}
class $1 {
  /**
   * The current state of the store.
   * This property is updated immediately when the state changes as a result of calling {@link setState}, {@link update}, or {@link set}.
   * To subscribe to state changes, use the {@link useState} method. The value returned by {@link useState} is updated after the component renders (similarly to React's useState).
   * The values can be used directly (to avoid subscribing to the store) in effects or event handlers.
   *
   * Do not modify properties in state directly. Instead, use the provided methods to ensure proper state management and listener notification.
   */
  // Internal state to handle recursive `setState()` calls
  constructor(t) {
    /**
     * Registers a listener that will be called whenever the store's state changes.
     *
     * @param fn The listener function to be called on state changes.
     * @returns A function to unsubscribe the listener.
     */
    ce(this, "subscribe", (t) => (this.listeners.add(t), () => {
      this.listeners.delete(t);
    }));
    /**
     * Returns the current state of the store.
     */
    ce(this, "getSnapshot", () => this.state);
    this.state = t, this.listeners = /* @__PURE__ */ new Set(), this.updateTick = 0;
  }
  /**
   * Updates the entire store's state and notifies all registered listeners.
   *
   * @param newState The new state to set for the store.
   */
  setState(t) {
    if (this.state === t)
      return;
    this.state = t, this.updateTick += 1;
    const n = this.updateTick;
    for (const r of this.listeners) {
      if (n !== this.updateTick)
        return;
      r(t);
    }
  }
  /**
   * Merges the provided changes into the current state and notifies listeners if there are changes.
   *
   * @param changes An object containing the changes to apply to the current state.
   */
  update(t) {
    for (const n in t)
      if (!Object.is(this.state[n], t[n])) {
        this.setState({
          ...this.state,
          ...t
        });
        return;
      }
  }
  /**
   * Sets a specific key in the store's state to a new value and notifies listeners if the value has changed.
   *
   * @param key The key in the store's state to update.
   * @param value The new value to set for the specified key.
   */
  set(t, n) {
    Object.is(this.state[t], n) || this.setState({
      ...this.state,
      [t]: n
    });
  }
  /**
   * Gives the state a new reference and updates all registered listeners.
   */
  notifyAll() {
    const t = {
      ...this.state
    };
    this.setState(t);
  }
  use(t, n, r, o) {
    return we(this, t, n, r, o);
  }
}
class ci extends $1 {
  /**
   * Creates a new ReactStore instance.
   *
   * @param state Initial state of the store.
   * @param context Non-reactive context values.
   * @param selectors Optional selectors for use with `useState`.
   */
  constructor(t, n = {}, r) {
    super(t), this.context = n, this.selectors = r;
  }
  /**
   * Non-reactive values such as refs, callbacks, etc.
   */
  /**
   * Synchronizes a single external value into the store.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValue(t, n) {
    b.useDebugValue(t);
    const r = this;
    pe(() => {
      r.state[t] !== n && r.set(t, n);
    }, [r, t, n]);
  }
  /**
   * Synchronizes a single external value into the store and
   * cleans it up (sets to `undefined`) on unmount.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValueWithCleanup(t, n) {
    const r = this;
    pe(() => (r.state[t] !== n && r.set(t, n), () => {
      r.set(t, void 0);
    }), [r, t, n]);
  }
  /**
   * Synchronizes multiple external values into the store.
   *
   * Note that the while the values in `state` are updated immediately, the values returned
   * by `useState` are updated before the next render (similarly to React's `useState`).
   */
  useSyncedValues(t) {
    const n = this;
    if (process.env.NODE_ENV !== "production") {
      b.useDebugValue(t, (i) => Object.keys(i));
      const o = b.useRef(Object.keys(t)).current, s = Object.keys(t);
      (o.length !== s.length || o.some((i, a) => i !== s[a])) && console.error("ReactStore.useSyncedValues expects the same prop keys on every render. Keys should be stable.");
    }
    const r = Object.values(t);
    pe(() => {
      n.update(t);
    }, [n, ...r]);
  }
  /**
   * Registers a controllable prop pair (`controlled`, `defaultValue`) for a specific key. If `controlled`
   * is non-undefined, the store's state at `key` is updated to match `controlled`.
   */
  useControlledProp(t, n) {
    b.useDebugValue(t);
    const r = this, o = n !== void 0;
    if (pe(() => {
      o && !Object.is(r.state[t], n) && r.setState({
        ...r.state,
        [t]: n
      });
    }, [r, t, n, o]), process.env.NODE_ENV !== "production") {
      const s = this.controlledValues ?? (this.controlledValues = /* @__PURE__ */ new Map());
      s.has(t) || s.set(t, o);
      const i = s.get(t);
      i !== void 0 && i !== o && console.error(`A component is changing the ${o ? "" : "un"}controlled state of ${t.toString()} to be ${o ? "un" : ""}controlled. Elements should not switch from uncontrolled to controlled (or vice versa).`);
    }
  }
  /** Gets the current value from the store using a selector with the provided key.
   *
   * @param key Key of the selector to use.
   */
  select(t, n, r, o) {
    const s = this.selectors[t];
    return s(this.state, n, r, o);
  }
  /**
   * Returns a value from the store's state using a selector function.
   * Used to subscribe to specific parts of the state.
   * This methods causes a rerender whenever the selected state changes.
   *
   * @param key Key of the selector to use.
   */
  useState(t, n, r, o) {
    return b.useDebugValue(t), we(this, this.selectors[t], n, r, o);
  }
  /**
   * Wraps a function with `useStableCallback` to ensure it has a stable reference
   * and assigns it to the context.
   *
   * @param key Key of the event callback. Must be a function in the context.
   * @param fn Function to assign.
   */
  useContextCallback(t, n) {
    b.useDebugValue(t);
    const r = ye(n ?? Nt);
    this.context[t] = r;
  }
  /**
   * Returns a stable setter function for a specific key in the store's state.
   * It's commonly used to pass as a ref callback to React elements.
   *
   * @param key Key of the state to set.
   */
  useStateSetter(t) {
    const n = b.useRef(void 0);
    return n.current === void 0 && (n.current = (r) => {
      this.set(t, r);
    }), n.current;
  }
  /**
   * Observes changes derived from the store's selectors and calls the listener when the selected value changes.
   *
   * @param key Key of the selector to observe.
   * @param listener Listener function called when the selector result changes.
   */
  observe(t, n) {
    let r;
    typeof t == "function" ? r = t : r = this.selectors[t];
    let o = r(this.state);
    return n(o, o, this), this.subscribe((s) => {
      const i = r(s);
      if (!Object.is(o, i)) {
        const a = o;
        o = i, n(i, a, this);
      }
    });
  }
}
const KR = {
  open: (e) => e.open,
  transitionStatus: (e) => e.transitionStatus,
  domReferenceElement: (e) => e.domReferenceElement,
  referenceElement: (e) => e.positionReference ?? e.referenceElement,
  floatingElement: (e) => e.floatingElement,
  floatingId: (e) => e.floatingId
};
class fu extends ci {
  constructor(n) {
    const {
      syncOnly: r,
      nested: o,
      onOpenChange: s,
      triggerElements: i,
      ...a
    } = n;
    super({
      ...a,
      positionReference: a.referenceElement,
      domReferenceElement: a.referenceElement
    }, {
      onOpenChange: s,
      dataRef: {
        current: {}
      },
      events: O1(),
      nested: o,
      triggerElements: i
    }, KR);
    /**
     * Syncs the event used by hover logic to distinguish hover-open from click-like interaction.
     */
    ce(this, "syncOpenEvent", (n, r) => {
      (!n || !this.state.open || // Prevent a pending hover-open from overwriting a click-open event, while allowing
      // click events to upgrade a hover-open.
      r != null && tT(r)) && (this.context.dataRef.current.openEvent = n ? r : void 0);
    });
    /**
     * Runs the root-owned side effects for an open state change.
     */
    ce(this, "dispatchOpenChange", (n, r) => {
      this.syncOpenEvent(n, r.event);
      const o = {
        open: n,
        reason: r.reason,
        nativeEvent: r.event,
        nested: this.context.nested,
        triggerElement: r.trigger
      };
      this.context.events.emit("openchange", o);
    });
    /**
     * Emits the `openchange` event through the internal event emitter and calls the `onOpenChange` handler with the provided arguments.
     *
     * @param newOpen The new open state.
     * @param eventDetails Details about the event that triggered the open state change.
     */
    ce(this, "setOpen", (n, r) => {
      var o, s, i, a;
      if (this.syncOnly) {
        (s = (o = this.context).onOpenChange) == null || s.call(o, n, r);
        return;
      }
      this.dispatchOpenChange(n, r), (a = (i = this.context).onOpenChange) == null || a.call(i, n, r);
    });
    this.syncOnly = r;
  }
}
function F1(e) {
  const {
    popupStore: t,
    treatPopupAsFloatingElement: n = !1,
    floatingRootContext: r,
    floatingId: o,
    nested: s,
    onOpenChange: i
  } = e, a = t.useState("open"), l = t.useState("activeTriggerElement"), c = t.useState(n ? "popupElement" : "positionerElement"), u = t.context.triggerElements, d = i, f = b.useRef(null);
  r === void 0 && f.current === null && (f.current = new fu({
    open: a,
    transitionStatus: void 0,
    referenceElement: l,
    floatingElement: c,
    triggerElements: u,
    onOpenChange: d,
    floatingId: o,
    syncOnly: !0,
    nested: s
  }));
  const h = r ?? f.current;
  return t.useSyncedValue("floatingId", o), pe(() => {
    const p = {
      open: a,
      floatingId: o,
      referenceElement: l,
      floatingElement: c
    };
    Qe(l) && (p.domReferenceElement = l), h.state.positionReference === h.state.referenceElement && (p.positionReference = l), h.update(p);
  }, [a, o, l, c, h]), h.context.onOpenChange = d, h.context.nested = s, h;
}
function vs(e, t = !1, n = !1) {
  const [r, o] = b.useState(e && t ? "idle" : void 0), [s, i] = b.useState(e);
  return e && !s && (i(!0), o("starting")), !e && s && r !== "ending" && !n && o("ending"), !e && !s && r === "ending" && o(void 0), pe(() => {
    if (!e && s && r !== "ending" && n) {
      const a = An.request(() => {
        o("ending");
      });
      return () => {
        An.cancel(a);
      };
    }
  }, [e, s, r, n]), pe(() => {
    if (!e || t)
      return;
    const a = An.request(() => {
      o(void 0);
    });
    return () => {
      An.cancel(a);
    };
  }, [t, e]), pe(() => {
    if (!e || !t)
      return;
    e && s && r !== "idle" && o("starting");
    const a = An.request(() => {
      o("idle");
    });
    return () => {
      An.cancel(a);
    };
  }, [t, e, s, r]), {
    mounted: s,
    setMounted: i,
    transitionStatus: r
  };
}
function hu(e, t = !1) {
  const n = ca();
  return ye((r, o = null) => {
    n.cancel();
    const s = Yr(e);
    if (s == null)
      return;
    const i = s, a = () => {
      Xn.flushSync(r);
    };
    if (typeof i.getAnimations != "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED) {
      r();
      return;
    }
    function l() {
      Promise.all(i.getAnimations().map((c) => c.finished)).then(() => {
        o != null && o.aborted || a();
      }, () => {
        if (o != null && o.aborted)
          return;
        if (i.getAnimations().some((u) => u.pending || u.playState !== "finished")) {
          l();
          return;
        }
        a();
      });
    }
    if (t) {
      const c = "data-starting-style";
      if (!i.hasAttribute(c)) {
        n.request(l);
        return;
      }
      const u = new MutationObserver(() => {
        i.hasAttribute(c) || (u.disconnect(), l());
      });
      u.observe(i, {
        attributes: !0,
        attributeFilter: [c]
      }), o == null || o.addEventListener("abort", () => u.disconnect(), {
        once: !0
      });
      return;
    }
    n.request(l);
  });
}
function Jn(e) {
  const {
    enabled: t = !0,
    open: n,
    ref: r,
    onComplete: o
  } = e, s = ye(o), i = hu(r, n);
  b.useEffect(() => {
    if (!t)
      return;
    const a = new AbortController();
    return i(s, a.signal), () => {
      a.abort();
    };
  }, [t, n, s, i]);
}
const Na = {
  tabIndex: -1,
  [Tf]: ""
};
function L1(e) {
  return (t) => t === "touch" ? e.current : !0;
}
function op(e, t = !1) {
  const n = ko(), r = Wo() != null, o = bn(() => e(n, r)).current;
  return F1({
    popupStore: o,
    treatPopupAsFloatingElement: t,
    floatingRootContext: o.state.floatingRootContext,
    floatingId: n,
    nested: r,
    onOpenChange: o.setOpen
  }), o;
}
function pu({
  handle: e,
  store: t
}) {
  return pe(() => e.attachStore(t), [e, t]), null;
}
function V1(e, t) {
  const n = b.useRef(null), r = b.useRef(null);
  return b.useCallback((o) => {
    if (e === void 0)
      return;
    let s = !1;
    if (n.current !== null) {
      const i = n.current, a = r.current, l = t.context.triggerElements.getById(i);
      a && l === a && (t.context.triggerElements.delete(i), s = !0), n.current = null, r.current = null;
    }
    if (o !== null && (n.current = e, r.current = o, t.context.triggerElements.add(e, o), s = !0), s) {
      const i = t.context.triggerElements.size;
      t.select("open") && t.state.triggerCount !== i && t.set("triggerCount", i);
    }
  }, [t, e]);
}
function gu(e, t, n, r = !1) {
  t ? e.preventUnmountingOnClose = !1 : r && (e.preventUnmountingOnClose = !0);
  const o = (n == null ? void 0 : n.id) ?? null;
  (o || t) && (e.activeTriggerId = o, e.activeTriggerElement = n ?? null);
}
function sp(e) {
  let t = !1;
  return e.preventUnmountOnClose = () => {
    t = !0;
  }, () => t;
}
function qR(e, t, n, r = {}) {
  var u, d, f;
  const o = n.reason, s = o === qt, i = t && o === Bs, a = !t && (o === Lr || o === bs), l = sp(n);
  if ((d = (u = e.context).onOpenChange) == null || d.call(u, t, n), n.isCanceled)
    return;
  (f = r.onBeforeDispatch) == null || f.call(r), e.state.floatingRootContext.dispatchOpenChange(t, n);
  const c = () => {
    const h = {
      ...r.extraState,
      open: t
    };
    i ? h.instantType = "focus" : a ? h.instantType = "dismiss" : s && (h.instantType = void 0), gu(h, t, n.trigger, l()), e.update(h);
  };
  s ? Xn.flushSync(c) : c();
}
function mu(e, t, n, r) {
  const o = n.useState("isMountedByTrigger", e), s = V1(e, n), i = ye((l) => {
    const c = n.select("open"), u = n.select("activeTriggerId");
    if (u === e) {
      n.update({
        activeTriggerElement: l,
        ...c ? r : null
      });
      return;
    }
    u == null && c && n.update({
      activeTriggerId: e,
      activeTriggerElement: l,
      ...r
    });
  }), a = b.useCallback((l) => {
    s(l), l && i(l);
  }, [s, i]);
  return pe(() => {
    o && n.update({
      activeTriggerElement: t.current,
      ...r
    });
  }, [o, n, t, ...Object.values(r)]), {
    registerTrigger: a,
    isMountedByThisTrigger: o
  };
}
function bu(e, t = {}) {
  const {
    closeOnActiveTriggerUnmount: n = !1
  } = t, r = b.useRef(null), o = e.useState("open"), s = e.useState("triggerCount"), i = e.useState("activeTriggerId"), a = e.useState("activeTriggerElement");
  pe(() => {
    if (!o) {
      r.current = null, e.state.triggerCount !== 0 && e.set("triggerCount", 0);
      return;
    }
    const l = e.context.triggerElements.size, c = {};
    e.state.triggerCount !== l && (c.triggerCount = l);
    const u = e.select("activeTriggerId");
    let d = null;
    if (u) {
      const f = e.context.triggerElements.getById(u);
      if (f)
        r.current = u, f !== e.state.activeTriggerElement && (c.activeTriggerElement = f);
      else {
        for (const [h, p] of e.context.triggerElements.entries())
          if (p === e.state.activeTriggerElement) {
            c.activeTriggerId = h, c.activeTriggerElement = p, r.current = h;
            break;
          }
        c.activeTriggerId === void 0 && (r.current === u ? d = u : r.current = null);
      }
    } else
      r.current = null;
    if (!d && !u && l === 1) {
      const f = e.context.triggerElements.entries().next();
      if (!f.done) {
        const [h, p] = f.value;
        c.activeTriggerId = h, c.activeTriggerElement = p, r.current = h;
      }
    }
    (c.triggerCount !== void 0 || c.activeTriggerId !== void 0 || c.activeTriggerElement !== void 0) && e.update(c), d && n && queueMicrotask(() => {
      if (e.select("open") && e.select("activeTriggerId") === d && !e.context.triggerElements.getById(d)) {
        const f = Ne(Cn);
        e.setOpen(!1, f), f.isCanceled || e.update({
          activeTriggerId: null,
          activeTriggerElement: null
        });
      }
    });
  }, [o, e, s, i, a, n]);
}
function vu(e, t, n) {
  const {
    mounted: r,
    setMounted: o,
    transitionStatus: s
  } = vs(e), i = t.useState("preventUnmountingOnClose"), a = e ? !1 : i;
  t.useSyncedValues({
    mounted: r,
    transitionStatus: s,
    preventUnmountingOnClose: a
  });
  const l = ye(() => {
    var c, u;
    o(!1), t.update({
      activeTriggerId: null,
      activeTriggerElement: null,
      mounted: !1,
      preventUnmountingOnClose: !1
    }), n == null || n(), (u = (c = t.context).onOpenChangeComplete) == null || u.call(c, !1);
  });
  return Jn({
    enabled: r && !e && !a,
    open: e,
    ref: t.context.popupRef,
    onComplete() {
      e || l();
    }
  }), {
    forceUnmount: l,
    transitionStatus: s
  };
}
function yu(e, t) {
  e.useSyncedValues(t), pe(() => () => {
    e.update({
      activeTriggerProps: At,
      inactiveTriggerProps: At,
      popupProps: At
    });
  }, [e]);
}
function W1(e, t) {
  pe(() => {
    !t && e.state.openMethod !== null && e.set("openMethod", null);
  }, [t, e]), pe(() => () => {
    e.state.openMethod !== null && e.set("openMethod", null);
  }, [e]);
}
let js;
function XR(e) {
  js ?? (js = /* @__PURE__ */ new WeakMap());
  let t = js.get(e);
  return t || (t = /* @__PURE__ */ new WeakMap(), js.set(e, t)), t;
}
class ui {
  constructor() {
    this.idMap = /* @__PURE__ */ new Map();
  }
  /**
   * Adds a trigger element with the given ID.
   *
   * Note: The provided element is assumed to not be registered under multiple IDs.
   */
  add(t, n) {
    if (process.env.NODE_ENV !== "production") {
      const r = XR(this), o = r.get(n);
      if (o !== void 0 && o !== t)
        throw new Error("Base UI: A trigger element cannot be registered under multiple IDs in PopupTriggerMap.");
      const s = this.idMap.get(t);
      s !== void 0 && s !== n && r.delete(s), r.set(n, t);
    }
    this.idMap.set(t, n);
  }
  /**
   * Removes the trigger element with the given ID.
   */
  delete(t) {
    var n;
    if (process.env.NODE_ENV !== "production") {
      const r = this.idMap.get(t);
      r !== void 0 && ((n = js == null ? void 0 : js.get(this)) == null || n.delete(r));
    }
    this.idMap.delete(t);
  }
  /**
   * Whether the given element is registered as a trigger.
   */
  hasElement(t) {
    for (const n of this.idMap.values())
      if (n === t)
        return !0;
    return !1;
  }
  /**
   * Whether there is a registered trigger element matching the given predicate.
   */
  hasMatchingElement(t) {
    for (const n of this.idMap.values())
      if (t(n))
        return !0;
    return !1;
  }
  /**
   * Returns the trigger element associated with the given ID, or undefined if no such element exists.
   */
  getById(t) {
    return this.idMap.get(t);
  }
  /**
   * Returns an iterable of all registered trigger entries, where each entry is a tuple of [id, element].
   */
  entries() {
    return this.idMap.entries();
  }
  /**
   * Returns an iterable of all registered trigger elements.
   */
  elements() {
    return this.idMap.values();
  }
  /**
   * Returns the number of registered trigger elements.
   */
  get size() {
    return this.idMap.size;
  }
}
function ZR() {
  return new fu({
    open: !1,
    transitionStatus: void 0,
    floatingElement: null,
    referenceElement: null,
    triggerElements: new ui(),
    floatingId: void 0,
    syncOnly: !1,
    nested: !1,
    onOpenChange: void 0
  });
}
function xu() {
  return {
    open: !1,
    openProp: void 0,
    mounted: !1,
    transitionStatus: void 0,
    floatingRootContext: ZR(),
    floatingId: void 0,
    triggerCount: 0,
    preventUnmountingOnClose: !1,
    payload: void 0,
    activeTriggerId: null,
    activeTriggerElement: null,
    triggerIdProp: void 0,
    popupElement: null,
    positionerElement: null,
    activeTriggerProps: At,
    inactiveTriggerProps: At,
    popupProps: At
  };
}
function ip(e, t, n = !1) {
  return new fu({
    open: !1,
    transitionStatus: void 0,
    floatingElement: null,
    referenceElement: null,
    triggerElements: e,
    floatingId: t,
    syncOnly: !0,
    nested: n,
    onOpenChange: void 0
  });
}
const Xi = (e) => e.triggerIdProp ?? e.activeTriggerId, ap = (e) => e.openProp ?? e.open, ub = (e) => {
  var n;
  return (((n = e.popupElement) == null ? void 0 : n.id) ?? e.floatingId) || void 0;
};
function H1(e, t) {
  return t !== void 0 && ap(e) && Xi(e) === t;
}
function QR(e, t) {
  return H1(e, t) ? !0 : t !== void 0 && ap(e) && Xi(e) == null && e.triggerCount === 1;
}
const wu = {
  open: ap,
  mounted: (e) => e.mounted,
  transitionStatus: (e) => e.transitionStatus,
  floatingRootContext: (e) => e.floatingRootContext,
  triggerCount: (e) => e.triggerCount,
  preventUnmountingOnClose: (e) => e.preventUnmountingOnClose,
  payload: (e) => e.payload,
  activeTriggerId: Xi,
  activeTriggerElement: (e) => e.mounted ? e.activeTriggerElement : null,
  popupId: ub,
  /**
   * Whether the trigger with the given ID was used to open the popup.
   */
  isTriggerActive: (e, t) => t !== void 0 && Xi(e) === t,
  /**
   * Whether the popup is open and was activated by a trigger with the given ID.
   */
  isOpenedByTrigger: (e, t) => H1(e, t),
  /**
   * Whether the popup is mounted and was activated by a trigger with the given ID.
   */
  isMountedByTrigger: (e, t) => t !== void 0 && Xi(e) === t && e.mounted,
  triggerProps: (e, t) => t ? e.activeTriggerProps : e.inactiveTriggerProps,
  /**
   * Popup id for the trigger that currently owns the open popup.
   */
  triggerPopupId: (e, t) => QR(e, t) ? ub(e) : void 0,
  popupProps: (e) => e.popupProps,
  popupElement: (e) => e.popupElement,
  positionerElement: (e) => e.positionerElement
};
var Ff = { exports: {} }, Td = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var db;
function JR() {
  if (db)
    return Td;
  db = 1;
  var e = Oe;
  function t(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, s = e.useLayoutEffect, i = e.useDebugValue;
  function a(d, f) {
    var h = f(), p = r({ inst: { value: h, getSnapshot: f } }), g = p[0].inst, m = p[1];
    return s(
      function() {
        g.value = h, g.getSnapshot = f, l(g) && m({ inst: g });
      },
      [d, h, f]
    ), o(
      function() {
        return l(g) && m({ inst: g }), d(function() {
          l(g) && m({ inst: g });
        });
      },
      [d]
    ), i(h), h;
  }
  function l(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var h = f();
      return !n(d, h);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : a;
  return Td.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, Td;
}
var Rd = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fb;
function eP() {
  return fb || (fb = 1, process.env.NODE_ENV !== "production" && function() {
    function e(h, p) {
      return h === p && (h !== 0 || 1 / h === 1 / p) || h !== h && p !== p;
    }
    function t(h, p) {
      u || o.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var g = p();
      if (!d) {
        var m = p();
        s(g, m) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      m = i({
        inst: { value: g, getSnapshot: p }
      });
      var v = m[0].inst, y = m[1];
      return l(
        function() {
          v.value = g, v.getSnapshot = p, n(v) && y({ inst: v });
        },
        [h, g, p]
      ), a(
        function() {
          return n(v) && y({ inst: v }), h(function() {
            n(v) && y({ inst: v });
          });
        },
        [h]
      ), c(g), g;
    }
    function n(h) {
      var p = h.getSnapshot;
      h = h.value;
      try {
        var g = p();
        return !s(h, g);
      } catch {
        return !0;
      }
    }
    function r(h, p) {
      return p();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = Oe, s = typeof Object.is == "function" ? Object.is : e, i = o.useState, a = o.useEffect, l = o.useLayoutEffect, c = o.useDebugValue, u = !1, d = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    Rd.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Rd;
}
process.env.NODE_ENV === "production" ? Ff.exports = JR() : Ff.exports = eP();
var tP = Ff.exports;
function Cu(e) {
  const t = b.useCallback((r) => e === void 0 ? Nt : e.subscribeStore(r), [e]), n = b.useCallback(() => e === void 0 ? void 0 : e.store, [e]);
  return tP.useSyncExternalStore(t, n, () => e == null ? void 0 : e.serverStore);
}
function nP(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r = {}
  } = e, o = ko(), s = Wo() != null;
  if (process.env.NODE_ENV !== "production") {
    const a = r.reference;
    a && !Qe(a) && console.error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `context.setPositionReference()`", "instead.");
  }
  const i = bn(() => new fu({
    open: t,
    transitionStatus: void 0,
    onOpenChange: n,
    referenceElement: r.reference ?? null,
    floatingElement: r.floating ?? null,
    triggerElements: new ui(),
    floatingId: o,
    syncOnly: !1,
    nested: s
  })).current;
  return pe(() => {
    const a = {
      open: t,
      floatingId: o
    };
    r.reference !== void 0 && (a.referenceElement = r.reference, a.domReferenceElement = Qe(r.reference) ? r.reference : null), r.floating !== void 0 && (a.floatingElement = r.floating), i.update(a);
  }, [t, o, r.reference, r.floating, i]), i.context.onOpenChange = n, i.context.nested = s, i;
}
function rP(e) {
  return oP(e, e.rootContext);
}
function oP(e, t) {
  const {
    nodeId: n,
    externalTree: r
  } = e, o = t.useState("referenceElement"), s = t.useState("floatingElement"), i = t.useState("domReferenceElement"), a = t.useState("open"), l = t.useState("floatingId"), [c, u] = b.useState(null), [d, f] = b.useState(void 0), [h, p] = b.useState(void 0), g = b.useRef(null), m = Ho(r), v = b.useMemo(() => ({
    reference: o,
    floating: s,
    domReference: i
  }), [o, s, i]), y = kR({
    ...e,
    elements: {
      ...v,
      ...c && {
        reference: c
      }
    }
  }), x = Qe(d) ? d : null, C = h === void 0 ? t.state.floatingElement : h;
  t.useSyncedValue("referenceElement", d ?? null), t.useSyncedValue("domReferenceElement", d === void 0 ? i : x), t.useSyncedValue("floatingElement", C);
  const w = b.useCallback((P) => {
    const I = Qe(P) ? {
      getBoundingClientRect: () => P.getBoundingClientRect(),
      getClientRects: () => P.getClientRects(),
      contextElement: P
    } : P;
    u(I), y.refs.setReference(I);
  }, [y.refs]), E = b.useCallback((P) => {
    (Qe(P) || P === null) && (g.current = P, f(P)), (Qe(y.refs.reference.current) || y.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    P !== null && !Qe(P)) && y.refs.setReference(P);
  }, [y.refs, f]), S = b.useCallback((P) => {
    p(P), y.refs.setFloating(P);
  }, [y.refs]), O = b.useMemo(() => ({
    ...y.refs,
    setReference: E,
    setFloating: S,
    setPositionReference: w,
    domReference: g
  }), [y.refs, E, S, w]), M = b.useMemo(() => ({
    ...y.elements,
    domReference: i
  }), [y.elements, i]), T = b.useMemo(() => ({
    ...y,
    dataRef: t.context.dataRef,
    open: a,
    onOpenChange: t.setOpen,
    events: t.context.events,
    floatingId: l,
    refs: O,
    elements: M,
    nodeId: n,
    rootStore: t
  }), [y, O, M, n, t, a, l]);
  return pe(() => {
    i && (g.current = i);
  }, [i]), pe(() => {
    t.context.dataRef.current.floatingContext = T;
    const P = m == null ? void 0 : m.nodesRef.current.find((I) => I.id === n);
    P && (P.context = T);
  }), b.useMemo(() => ({
    ...y,
    context: T,
    refs: O,
    elements: M,
    rootStore: t
  }), [y, O, M, T, t]);
}
const Pd = Nh && Lo;
function B1(e, t = {}) {
  const {
    enabled: n = !0,
    delay: r
  } = t, o = "rootStore" in e ? e.rootStore : e, {
    events: s,
    dataRef: i
  } = o.context, a = b.useRef(!1), l = b.useRef(null), c = b.useRef(!0), u = Sn();
  b.useEffect(() => {
    const f = o.select("domReferenceElement");
    if (!n)
      return;
    const h = Ht(f);
    function p() {
      const v = o.select("domReferenceElement");
      !o.select("open") && wt(v) && v === fn(Ze(v)) && (a.current = !0);
    }
    function g() {
      c.current = !0;
    }
    function m() {
      c.current = !1;
    }
    return mr(qe(h, "blur", p), Pd && qe(h, "keydown", g, !0), Pd && qe(h, "pointerdown", m, !0));
  }, [o, n]), b.useEffect(() => {
    if (!n)
      return;
    function f(h) {
      if (h.reason === Lr || h.reason === bs) {
        const p = o.select("domReferenceElement");
        Qe(p) && (l.current = p, a.current = !0);
      }
    }
    return s.on("openchange", f), () => {
      s.off("openchange", f);
    };
  }, [s, n, o]);
  const d = b.useMemo(() => {
    function f() {
      a.current = !1, l.current = null;
    }
    return {
      onMouseLeave() {
        f();
      },
      onFocus(h) {
        const p = h.currentTarget;
        if (a.current) {
          if (l.current === p)
            return;
          f();
        }
        const g = Ot(h.nativeEvent);
        if (Qe(g)) {
          if (Pd && !h.relatedTarget) {
            if (!c.current && !su(g))
              return;
          } else if (!hc(g))
            return;
        }
        const m = fc(h.relatedTarget, o.context.triggerElements), {
          nativeEvent: v,
          currentTarget: y
        } = h, x = typeof r == "function" ? r() : r;
        if (o.select("open") && m || x === 0 || x === void 0) {
          o.setOpen(!0, Ne(Bs, v, y));
          return;
        }
        u.start(x, () => {
          a.current || o.setOpen(!0, Ne(Bs, v, y));
        });
      },
      onBlur(h) {
        f();
        const p = h.relatedTarget, g = h.nativeEvent, m = Qe(p) && p.hasAttribute(ua("focus-guard")) && p.getAttribute("data-type") === "outside";
        u.start(0, () => {
          var C;
          const v = o.select("domReferenceElement"), y = fn(Ze(v));
          !p && y === v || Ie((C = i.current.floatingContext) == null ? void 0 : C.refs.floating.current, y) || Ie(v, y) || m || fc(p ?? y, o.context.triggerElements) || o.setOpen(!1, Ne(Bs, g));
        });
      }
    };
  }, [i, r, o, u]);
  return b.useMemo(() => n ? {
    reference: d,
    trigger: d
  } : {}, [n, d]);
}
class lp {
  constructor() {
    ce(this, "dispose", () => {
      this.openChangeTimeout.clear(), this.restTimeout.clear();
    });
    ce(this, "disposeEffect", () => this.dispose);
    this.pointerType = void 0, this.interactedInside = !1, this.handler = void 0, this.blockMouseMove = !0, this.performedPointerEventsMutation = !1, this.pointerEventsScopeElement = null, this.pointerEventsReferenceElement = null, this.pointerEventsFloatingElement = null, this.restTimeoutPending = !1, this.openChangeTimeout = new Ln(), this.restTimeout = new Ln(), this.handleCloseOptions = void 0;
  }
  static create() {
    return new lp();
  }
}
const vc = /* @__PURE__ */ new WeakMap();
function yc(e) {
  var n, r, o;
  if (!e.performedPointerEventsMutation)
    return;
  const t = e.pointerEventsScopeElement;
  t && vc.get(t) === e && ((n = e.pointerEventsScopeElement) == null || n.style.removeProperty("pointer-events"), (r = e.pointerEventsReferenceElement) == null || r.style.removeProperty("pointer-events"), (o = e.pointerEventsFloatingElement) == null || o.style.removeProperty("pointer-events"), vc.delete(t)), e.performedPointerEventsMutation = !1, e.pointerEventsScopeElement = null, e.pointerEventsReferenceElement = null, e.pointerEventsFloatingElement = null;
}
function z1(e, t) {
  const {
    scopeElement: n,
    referenceElement: r,
    floatingElement: o
  } = t, s = vc.get(n);
  s && s !== e && yc(s), yc(e), e.performedPointerEventsMutation = !0, e.pointerEventsScopeElement = n, e.pointerEventsReferenceElement = r, e.pointerEventsFloatingElement = o, vc.set(n, e), n.style.pointerEvents = "none", r.style.pointerEvents = "auto", o.style.pointerEvents = "auto";
}
function cp(e) {
  const t = e.context.dataRef.current, n = bn(() => t.hoverInteractionState ?? lp.create()).current;
  return t.hoverInteractionState || (t.hoverInteractionState = n), Jc(t.hoverInteractionState.disposeEffect), t.hoverInteractionState;
}
function up(e, t = {}) {
  const {
    enabled: n = !0,
    closeDelay: r = 0,
    nodeId: o
  } = t, s = "rootStore" in e ? e.rootStore : e, i = s.useState("open"), a = s.useState("floatingElement"), l = s.useState("domReferenceElement"), {
    dataRef: c
  } = s.context, u = Ho(), d = Wo(), f = cp(s), h = Sn(), p = ye(() => {
    var v;
    return n1((v = c.current.openEvent) == null ? void 0 : v.type, f.interactedInside);
  }), g = ye(() => {
    var v;
    return lT((v = c.current.openEvent) == null ? void 0 : v.type);
  }), m = ye(() => {
    yc(f);
  });
  pe(() => {
    i || (f.pointerType = void 0, f.restTimeoutPending = !1, f.interactedInside = !1, m());
  }, [i, f, m]), b.useEffect(() => m, [m]), pe(() => {
    var v, y, x, C, w;
    if (n && i && (v = f.handleCloseOptions) != null && v.blockPointerEvents && g() && Qe(l) && a) {
      const E = l, S = a, O = Ze(a), M = (x = (y = u == null ? void 0 : u.nodesRef.current.find((R) => R.id === d)) == null ? void 0 : y.context) == null ? void 0 : x.elements.floating;
      M && (M.style.pointerEvents = "");
      const T = f.pointerEventsScopeElement !== S ? f.pointerEventsScopeElement : null, P = M !== S ? M : null, I = ((w = (C = f.handleCloseOptions) == null ? void 0 : C.getScope) == null ? void 0 : w.call(C)) ?? T ?? P ?? E.closest("[data-rootownerid]") ?? O.body;
      return z1(f, {
        scopeElement: I,
        referenceElement: E,
        floatingElement: S
      }), () => {
        m();
      };
    }
  }, [n, i, l, a, f, g, u, d, m]), b.useEffect(() => {
    if (!n)
      return;
    function v() {
      return !!(u && d && Io(u.nodesRef.current, d).length > 0);
    }
    function y(O) {
      const M = To(r, "close", f.pointerType), T = () => {
        s.setOpen(!1, Ne(qt, O)), u == null || u.events.emit("floating.closed", O);
      };
      M ? f.openChangeTimeout.start(M, T) : (f.openChangeTimeout.clear(), T());
    }
    function x(O) {
      const M = Ot(O);
      if (!t1(M)) {
        f.interactedInside = !1;
        return;
      }
      f.interactedInside = (M == null ? void 0 : M.closest("[aria-haspopup]")) != null;
    }
    function C() {
      f.openChangeTimeout.clear(), h.clear(), u == null || u.events.off("floating.closed", E), m();
    }
    function w(O) {
      var I;
      if (v() && u) {
        u.events.on("floating.closed", E);
        return;
      }
      if (fc(O.relatedTarget, s.context.triggerElements))
        return;
      const M = ((I = c.current.floatingContext) == null ? void 0 : I.nodeId) ?? o, T = O.relatedTarget;
      if (!(u && M && Qe(T) && Io(u.nodesRef.current, M, !1).some((R) => {
        var D;
        return Ie((D = R.context) == null ? void 0 : D.elements.floating, T);
      }))) {
        if (f.handler) {
          f.handler(O);
          return;
        }
        m(), g() && !p() && y(O);
      }
    }
    function E(O) {
      !u || !d || v() || h.start(0, () => {
        u.events.off("floating.closed", E), s.setOpen(!1, Ne(qt, O)), u.events.emit("floating.closed", O);
      });
    }
    const S = a;
    return mr(S && qe(S, "mouseenter", C), S && qe(S, "mouseleave", w), S && qe(S, "pointerdown", x, !0), () => {
      u == null || u.events.off("floating.closed", E);
    });
  }, [n, a, s, c, r, o, g, p, m, f, u, d, h]);
}
const sP = {
  current: null
};
function Eu(e, t = {}) {
  var $;
  const {
    enabled: n = !0,
    delay: r = 0,
    handleClose: o = null,
    mouseOnly: s = !1,
    restMs: i = 0,
    move: a = !0,
    triggerElementRef: l = sP,
    externalTree: c,
    isActiveTrigger: u = !0,
    getHandleCloseContext: d,
    isClosing: f,
    shouldOpen: h,
    guardStaleOpen: p = !1
  } = t, g = "rootStore" in e ? e.rootStore : e, {
    dataRef: m,
    events: v
  } = g.context, y = Ho(c), x = cp(g), C = b.useRef(!1), w = rn(o), E = rn(r), S = rn(i), O = rn(n), M = rn(h), T = rn(f), P = ye(() => {
    var L;
    return n1((L = m.current.openEvent) == null ? void 0 : L.type, x.interactedInside);
  }), I = ye(() => {
    var L;
    return ((L = M.current) == null ? void 0 : L.call(M)) !== !1;
  }), R = ye((L, A, F) => {
    const N = g.context.triggerElements;
    if (N.hasElement(A))
      return !L || !Ie(L, A);
    if (!Qe(F))
      return !1;
    const V = F;
    return N.hasMatchingElement((K) => Ie(K, V)) && (!L || !Ie(L, V));
  }), D = ye(() => {
    if (!x.handler)
      return;
    Ze(g.select("domReferenceElement")).removeEventListener("mousemove", x.handler), x.handler = void 0;
  }), k = ye(() => {
    yc(x);
  });
  return u && (x.handleCloseOptions = ($ = w.current) == null ? void 0 : $.__options), b.useEffect(() => D, [D]), b.useEffect(() => {
    if (!n)
      return;
    function L(A) {
      A.open ? C.current = !1 : (C.current = A.reason === qt, D(), x.openChangeTimeout.clear(), x.restTimeout.clear(), x.blockMouseMove = !0, x.restTimeoutPending = !1);
    }
    return v.on("openchange", L), () => {
      v.off("openchange", L);
    };
  }, [n, v, x, D]), b.useEffect(() => {
    if (!n)
      return;
    function L(Y, U = !0) {
      const j = To(E.current, "close", x.pointerType);
      j ? x.openChangeTimeout.start(j, () => {
        g.setOpen(!1, Ne(qt, Y)), y == null || y.events.emit("floating.closed", Y);
      }) : U && (x.openChangeTimeout.clear(), g.setOpen(!1, Ne(qt, Y)), y == null || y.events.emit("floating.closed", Y));
    }
    const A = l.current ?? (u ? g.select("domReferenceElement") : null);
    if (!Qe(A))
      return;
    function F(Y) {
      var Ee;
      if (x.openChangeTimeout.clear(), x.blockMouseMove = !1, s && !_o(x.pointerType))
        return;
      const U = Am(S.current), j = To(E.current, "open", x.pointerType), H = Ot(Y), q = Y.currentTarget ?? null, B = g.select("domReferenceElement");
      let X = q;
      if (Qe(H) && !g.context.triggerElements.hasElement(H)) {
        for (const se of g.context.triggerElements.elements())
          if (Ie(se, H)) {
            X = se;
            break;
          }
      }
      Qe(q) && Qe(B) && !g.context.triggerElements.hasElement(q) && Ie(q, B) && (X = B);
      const te = X == null ? !1 : R(B, X, H), J = g.select("open"), G = ((Ee = T.current) == null ? void 0 : Ee.call(T)) ?? g.select("transitionStatus") === "ending", ne = !J && G && C.current, Q = !te && Qe(X) && Qe(B) && Ie(B, X) && ne, re = U > 0 && !j, fe = te && (J || ne) || Q, le = !J || te;
      if (fe) {
        I() && g.setOpen(!0, Ne(qt, Y, X));
        return;
      }
      re || (j ? x.openChangeTimeout.start(j, () => {
        le && I() && g.setOpen(!0, Ne(qt, Y, X));
      }) : le && I() && g.setOpen(!0, Ne(qt, Y, X)));
    }
    function N(Y) {
      if (P()) {
        k();
        return;
      }
      D();
      const U = g.select("domReferenceElement"), j = Ze(U);
      x.restTimeout.clear(), x.restTimeoutPending = !1;
      const H = m.current.floatingContext ?? (d == null ? void 0 : d());
      if (fc(Y.relatedTarget, g.context.triggerElements))
        return;
      if (w.current && H) {
        g.select("open") || x.openChangeTimeout.clear();
        const B = l.current;
        x.handler = w.current({
          ...H,
          tree: y,
          x: Y.clientX,
          y: Y.clientY,
          onClose() {
            k(), D(), O.current && !P() && B === g.select("domReferenceElement") && L(Y, !0);
          }
        }), j.addEventListener("mousemove", x.handler), x.handler(Y);
        return;
      }
      (x.pointerType === "touch" ? !Ie(g.select("floatingElement"), Y.relatedTarget) : !0) && L(Y);
    }
    function V(Y) {
      Ie(A, Y.relatedTarget) || (x.openChangeTimeout.clear(), x.restTimeout.clear(), x.restTimeoutPending = !1);
    }
    const K = p ? qe(A, "mouseout", V) : void 0;
    return a ? mr(qe(A, "mousemove", F, {
      once: !0
    }), qe(A, "mouseenter", F), qe(A, "mouseleave", N), K) : mr(qe(A, "mouseenter", F), qe(A, "mouseleave", N), K);
  }, [D, k, m, E, g, n, w, x, u, R, P, s, a, S, l, y, O, d, T, I, p]), b.useMemo(() => {
    if (!n)
      return;
    function L(A) {
      x.pointerType = A.pointerType;
    }
    return {
      onPointerDown: L,
      onPointerEnter: L,
      onMouseMove(A) {
        var H, q, B;
        const {
          nativeEvent: F
        } = A, N = A.currentTarget, V = g.select("domReferenceElement"), K = g.select("open"), Y = R(V, N, A.target);
        if (s && !_o(x.pointerType))
          return;
        if (K && Y && ((H = x.handleCloseOptions) != null && H.blockPointerEvents)) {
          const X = g.select("floatingElement");
          if (X) {
            const te = ((B = (q = x.handleCloseOptions) == null ? void 0 : q.getScope) == null ? void 0 : B.call(q)) ?? N.ownerDocument.body;
            z1(x, {
              scopeElement: te,
              referenceElement: N,
              floatingElement: X
            });
          }
        }
        const U = Am(S.current);
        if (K && !Y || U === 0 || !Y && x.restTimeoutPending && A.movementX ** 2 + A.movementY ** 2 < 2)
          return;
        x.restTimeout.clear();
        function j() {
          if (x.restTimeoutPending = !1, P())
            return;
          const X = g.select("open");
          !x.blockMouseMove && (!X || Y) && I() && g.setOpen(!0, Ne(qt, F, N));
        }
        x.pointerType === "touch" ? Xn.flushSync(() => {
          j();
        }) : Y && K ? j() : (x.restTimeoutPending = !0, x.restTimeout.start(U, j));
      }
    };
  }, [n, x, P, R, s, g, S, I]);
}
const iP = "Escape";
function hb(e) {
  return Lo && e.movementX === 0 && e.movementY === 0;
}
function _u(e, t, n) {
  switch (e) {
    case "vertical":
      return t;
    case "horizontal":
      return n;
    default:
      return t || n;
  }
}
function cl(e, t) {
  return _u(t, e === Wh || e === ou, e === as || e === ls);
}
function Id(e, t, n) {
  return _u(t, e === ou, n ? e === as : e === ls) || e === "Enter" || e === " " || e === "";
}
function aP(e, t, n) {
  return _u(t, n ? e === as : e === ls, e === ou);
}
function lP(e, t, n, r) {
  const o = n ? e === ls : e === as, s = e === Wh;
  return t === "both" || t === "horizontal" && r ? e === iP : _u(t, o, s);
}
function Y1(e, t) {
  const {
    listRef: n,
    activeIndex: r,
    onNavigate: o = () => {
    },
    enabled: s = !0,
    selectedIndex: i = null,
    allowEscape: a = !1,
    loopFocus: l = !1,
    nested: c = !1,
    rtl: u = !1,
    virtual: d = !1,
    focusItemOnOpen: f = "auto",
    focusItemOnHover: h = !0,
    openOnArrowKeyDown: p = !0,
    disabledIndices: g = void 0,
    orientation: m = "vertical",
    parentOrientation: v,
    id: y,
    resetOnPointerLeave: x = !0,
    externalTree: C,
    grid: w
  } = t, E = w != null;
  process.env.NODE_ENV !== "production" && (a && (l || console.warn("`useListNavigation` looping must be enabled to allow escaping."), d || console.warn("`useListNavigation` must be virtual to allow escaping.")), m === "vertical" && E && console.warn("In grid list navigation mode, the `orientation` should", 'be either "horizontal" or "both".'));
  const S = "rootStore" in e ? e.rootStore : e, O = S.useState("open"), M = S.useState("floatingElement"), T = S.useState("domReferenceElement"), P = S.context.dataRef, I = Pf(M), R = Rf(T), D = rn(I), k = Wo(), $ = Ho(C), L = b.useRef(f), A = b.useRef(i ?? -1), F = b.useRef(null), N = b.useRef(!0), V = ye((W) => {
    o(A.current === -1 ? null : A.current, W);
  }), K = b.useRef(!!M), Y = b.useRef(O), U = b.useRef(!1), j = b.useRef(!1), H = b.useRef(null), q = rn(g), B = rn(O), X = rn(i), te = rn(x), J = ca(), G = ca(), ne = ye(() => {
    function W(oe) {
      d ? $ == null || $.events.emit("virtualfocus", oe) : H.current = Ul(oe, {
        sync: U.current,
        preventScroll: !0
      });
    }
    const Z = n.current[A.current], me = j.current;
    Z && W(Z), (U.current ? (oe) => oe() : (oe) => J.request(oe))(() => {
      var Re;
      const oe = n.current[A.current] || Z;
      if (!oe)
        return;
      Z || W(oe), // eslint-disable-next-line @typescript-eslint/no-use-before-define
      se && (me || !N.current) && ((Re = oe.scrollIntoView) == null || Re.call(oe, {
        block: "nearest",
        inline: "nearest"
      }));
    });
  });
  pe(() => {
    P.current.orientation = m;
  }, [P, m]), pe(() => {
    s && (O && M ? (A.current = i ?? -1, L.current && i != null && (j.current = !0, V())) : K.current && (A.current = -1, V()));
  }, [s, O, M, i, V]), pe(() => {
    if (s) {
      if (!O) {
        U.current = !1;
        return;
      }
      if (M)
        if (r == null) {
          if (U.current = !1, X.current != null)
            return;
          if (K.current && (A.current = -1, ne()), (!Y.current || !K.current) && L.current && (F.current != null || L.current === !0 && F.current == null)) {
            let W = 0;
            const Z = () => {
              n.current[0] == null ? (W < 2 && (W ? (ie) => G.request(ie) : queueMicrotask)(Z), W += 1) : (A.current = F.current == null || Id(F.current, m, u) || c ? jl(n) : kf(n), F.current = null, V());
            };
            Z();
          }
        } else
          So(n.current, r) || (A.current = r, ne(), j.current = !1);
    }
  }, [s, O, M, r, X, c, n, m, u, V, ne, G]), pe(() => {
    var oe, he;
    if (!s || M || !$ || d || !K.current)
      return;
    const W = $.nodesRef.current, Z = (he = (oe = W.find((Re) => Re.id === k)) == null ? void 0 : oe.context) == null ? void 0 : he.elements.floating, me = fn(Ze(T ?? Z ?? null)), ie = W.some((Re) => Re.context && Ie(Re.context.elements.floating, me));
    Z && !ie && N.current && Z.focus({
      preventScroll: !0
    });
  }, [s, M, T, $, k, d]), pe(() => {
    Y.current = O, K.current = !!M;
  }), pe(() => {
    O || (F.current = null, L.current = f);
  }, [O, f]);
  const Q = r != null, re = ye((W) => {
    if (!B.current)
      return;
    const Z = n.current.indexOf(W.currentTarget);
    Z !== -1 && (A.current !== Z || r !== Z) && (A.current = Z, V(W));
  }), fe = ye(() => {
    var W, Z, me;
    return v ?? ((me = (Z = (W = $ == null ? void 0 : $.nodesRef.current.find((ie) => ie.id === k)) == null ? void 0 : W.context) == null ? void 0 : Z.dataRef) == null ? void 0 : me.current.orientation);
  }), le = ye(() => jl(n, q.current)), Ee = ye((W) => {
    if (N.current = !1, U.current = !0, W.which === 229 || !B.current && W.currentTarget === D.current)
      return;
    if (c && lP(W.key, m, u, E)) {
      cl(W.key, fe()) || wn(W), S.setOpen(!1, Ne(la, W.nativeEvent)), wt(T) && (d ? $ == null || $.events.emit("virtualfocus", T) : T.focus());
      return;
    }
    const Z = A.current, me = jl(n, g), ie = kf(n, g);
    if (R || (W.key === "Home" && (wn(W), A.current = me, V(W)), W.key === "End" && (wn(W), A.current = ie, V(W))), w != null) {
      const oe = w(W, A.current, n, m, l, u, g, me, ie);
      if (oe != null && (A.current = oe, V(W)), m === "both")
        return;
    }
    if (cl(W.key, m)) {
      if (wn(W), O && !d && fn(W.currentTarget.ownerDocument) === W.currentTarget) {
        A.current = Id(W.key, m, u) ? me : ie, V(W);
        return;
      }
      Id(W.key, m, u) ? l ? Z >= ie ? a && Z !== n.current.length ? A.current = -1 : (U.current = !1, A.current = me) : A.current = xn(n.current, {
        startingIndex: Z,
        disabledIndices: g
      }) : A.current = Math.min(ie, xn(n.current, {
        startingIndex: Z,
        disabledIndices: g
      })) : l ? Z <= me ? a && Z !== -1 ? A.current = n.current.length : (U.current = !1, A.current = ie) : A.current = xn(n.current, {
        startingIndex: Z,
        decrement: !0,
        disabledIndices: g
      }) : A.current = Math.max(me, xn(n.current, {
        startingIndex: Z,
        decrement: !0,
        disabledIndices: g
      })), So(n.current, A.current) && (A.current = -1), V(W);
    }
  }), se = b.useMemo(() => ({
    onFocus(Z) {
      U.current = !0, re(Z);
    },
    onClick: ({
      currentTarget: Z
    }) => Z.focus({
      preventScroll: !0
    }),
    // Safari
    onMouseMove(Z) {
      hb(Z) || (U.current = !0, j.current = !1, h && re(Z));
    },
    onPointerLeave(Z) {
      var ie;
      if (!B.current || !N.current || Z.pointerType === "touch")
        return;
      U.current = !0;
      const me = Z.relatedTarget;
      if (!(!h || n.current.includes(me)) && te.current && ((ie = H.current) == null || ie.call(H), H.current = null, A.current = -1, V(Z), !d)) {
        const oe = D.current, he = fn(Ze(oe));
        oe && Ie(oe, he) && oe.focus({
          preventScroll: !0
        });
      }
    }
  }), [re, B, D, h, n, V, te, d]), _e = b.useMemo(() => d && O && Q && {
    "aria-activedescendant": `${y}-${r}`
  }, [d, O, Q, y, r]), xe = b.useMemo(() => ({
    "aria-orientation": m === "both" ? void 0 : m,
    ...R ? {} : _e,
    onKeyDown(W) {
      if (W.key === "Tab" && W.shiftKey && O && !d) {
        const Z = Ot(W.nativeEvent);
        if (Z && !Ie(D.current, Z))
          return;
        wn(W), S.setOpen(!1, Ne(Ro, W.nativeEvent)), wt(T) && T.focus();
        return;
      }
      Ee(W);
    },
    onPointerMove(W) {
      hb(W) || (N.current = !0);
    }
  }), [_e, Ee, D, m, R, S, O, d, T]), ge = b.useMemo(() => {
    function W(ie) {
      S.setOpen(!0, Ne(la, ie.nativeEvent, ie.currentTarget));
    }
    function Z(ie) {
      f === "auto" && Qy(ie.nativeEvent) && (L.current = !d);
    }
    function me(ie) {
      L.current = f, f === "auto" && $h(ie.nativeEvent) && (L.current = !0);
    }
    return {
      onKeyDown(ie) {
        const oe = S.select("open");
        N.current = !1;
        const he = ie.key.startsWith("Arrow"), Re = aP(ie.key, fe(), u), Ae = cl(ie.key, m), Ue = (c ? Re : Ae) || ie.key === "Enter" || ie.key.trim() === "";
        if (d && oe)
          return Ee(ie);
        if (!(!oe && !p && he)) {
          if (Ue) {
            const Ke = cl(ie.key, fe());
            F.current = c && Ke ? null : ie.key;
          }
          if (c) {
            Re && (wn(ie), oe ? (A.current = le(), V(ie)) : W(ie));
            return;
          }
          Ae && (X.current != null && (A.current = X.current), wn(ie), !oe && p ? W(ie) : Ee(ie), oe && V(ie));
        }
      },
      onFocus(ie) {
        S.select("open") && !d && (A.current = -1, V(ie));
      },
      onPointerDown: me,
      onPointerEnter: me,
      onMouseDown: Z,
      onClick: Z
    };
  }, [Ee, f, le, c, V, S, p, m, fe, u, X, d]), ae = b.useMemo(() => ({
    ..._e,
    ...ge
  }), [_e, ge]);
  return b.useMemo(() => s ? {
    reference: ae,
    floating: xe,
    item: se,
    trigger: ge
  } : {}, [s, ae, xe, ge, se]);
}
function j1(e, t) {
  const {
    listRef: n,
    elementsRef: r,
    activeIndex: o,
    onMatch: s,
    disabledIndices: i,
    onTyping: a,
    enabled: l = !0,
    resetMs: c = 750,
    selectedIndex: u = null
  } = t, d = "rootStore" in e ? e.rootStore : e, f = d.useState("open"), h = Sn(), p = b.useRef(""), g = b.useRef(u ?? o ?? -1), m = b.useRef(null), v = ye((C) => {
    function w(D) {
      return r == null ? void 0 : r.current[D];
    }
    function E(D) {
      const k = w(D);
      return k && !lu(k) || k != null && k.matches(":disabled") ? !1 : i == null || !Qs(Gn, D, i);
    }
    function S(D, k, $ = 0) {
      if (D.length === 0)
        return -1;
      const L = ($ % D.length + D.length) % D.length, A = k.toLowerCase();
      for (let F = 0; F < D.length; F += 1) {
        const N = (L + F) % D.length, V = D[N];
        if (!(!(V != null && V.toLowerCase().startsWith(A)) || !E(N)))
          return N;
      }
      return -1;
    }
    const O = n.current;
    if (p.current.length > 0 && C.key === " " && (wn(C), a == null || a(!0)), p.current.length > 0 && p.current[0] !== " " && S(O, p.current) === -1 && C.key !== " " && (a == null || a(!1)), O == null || // Character key.
    C.key.length !== 1 || // Modifier key.
    C.ctrlKey || C.metaKey || C.altKey)
      return;
    f && C.key !== " " && (wn(C), a == null || a(!0));
    const M = p.current === "";
    M && (g.current = u ?? o ?? -1), O.every((D, k) => {
      var $, L;
      return D && E(k) ? (($ = D[0]) == null ? void 0 : $.toLowerCase()) !== ((L = D[1]) == null ? void 0 : L.toLowerCase()) : !0;
    }) && p.current === C.key && (p.current = "", g.current = m.current), p.current += C.key, h.start(c, () => {
      p.current = "", g.current = m.current, a == null || a(!1);
    });
    const I = ((M ? u ?? o ?? -1 : g.current) ?? 0) + 1, R = S(O, p.current, I);
    R !== -1 ? (s == null || s(R), m.current = R) : C.key !== " " && (p.current = "", a == null || a(!1));
  }), y = ye((C) => {
    const w = C.relatedTarget, E = d.select("domReferenceElement"), S = d.select("floatingElement");
    Ie(E, w) || Ie(S, w) || (h.clear(), p.current = "", g.current = m.current, a == null || a(!1));
  });
  pe(() => {
    !f && u !== null || (h.clear(), m.current = null, p.current !== "" && (p.current = ""));
  }, [f, u, h]);
  const x = b.useMemo(() => ({
    onKeyDown: v,
    onBlur: y
  }), [v, y]);
  return b.useMemo(() => l ? {
    reference: x,
    floating: x
  } : {}, [l, x]);
}
const pb = 0.1, cP = pb * pb, It = 0.5;
function ul(e, t, n, r, o, s) {
  return r >= t != s >= t && e <= (o - n) * (t - r) / (s - r) + n;
}
function dl(e, t, n, r, o, s, i, a, l, c) {
  let u = !1;
  return ul(e, t, n, r, o, s) && (u = !u), ul(e, t, o, s, i, a) && (u = !u), ul(e, t, i, a, l, c) && (u = !u), ul(e, t, l, c, n, r) && (u = !u), u;
}
function uP(e, t, n) {
  return e >= n.x && e <= n.x + n.width && t >= n.y && t <= n.y + n.height;
}
function fl(e, t, n, r, o, s) {
  const i = Math.min(n, o), a = Math.max(n, o), l = Math.min(r, s), c = Math.max(r, s);
  return e >= i && e <= a && t >= l && t <= c;
}
function Su(e = {}) {
  const {
    blockPointerEvents: t = !1
  } = e, n = new Ln(), r = ({
    x: o,
    y: s,
    placement: i,
    elements: a,
    onClose: l,
    nodeId: c,
    tree: u
  }) => {
    const d = i == null ? void 0 : i.split("-")[0];
    let f = !1, h = null, p = null, g = typeof performance < "u" ? performance.now() : 0;
    function m(y, x) {
      const C = performance.now(), w = C - g;
      if (h === null || p === null || w === 0)
        return h = y, p = x, g = C, !1;
      const E = y - h, S = x - p, O = E * E + S * S, M = w * w * cP;
      return h = y, p = x, g = C, O < M;
    }
    function v() {
      n.clear(), l();
    }
    return function(x) {
      n.clear();
      const C = a.domReference, w = a.floating;
      if (!C || !w || d == null || o == null || s == null)
        return;
      const {
        clientX: E,
        clientY: S
      } = x, O = Ot(x), M = x.type === "mouseleave", T = Ie(w, O), P = Ie(C, O);
      if (T && (f = !0, !M))
        return;
      if (P && (f = !1, !M)) {
        f = !0;
        return;
      }
      if (M && Qe(x.relatedTarget) && Ie(w, x.relatedTarget))
        return;
      function I() {
        return !!(u && Io(u.nodesRef.current, c).length > 0);
      }
      function R() {
        I() || v();
      }
      if (I())
        return;
      const D = C.getBoundingClientRect(), k = w.getBoundingClientRect(), $ = o > k.right - k.width / 2, L = s > k.bottom - k.height / 2, A = k.width > D.width, F = k.height > D.height, N = (A ? D : k).left, V = (A ? D : k).right, K = (F ? D : k).top, Y = (F ? D : k).bottom;
      if (d === "top" && s >= D.bottom - 1 || d === "bottom" && s <= D.top + 1 || d === "left" && o >= D.right - 1 || d === "right" && o <= D.left + 1) {
        R();
        return;
      }
      let U = !1;
      switch (d) {
        case "top":
          U = fl(E, S, N, D.top + 1, V, k.bottom - 1);
          break;
        case "bottom":
          U = fl(E, S, N, k.top + 1, V, D.bottom - 1);
          break;
        case "left":
          U = fl(E, S, k.right - 1, Y, D.left + 1, K);
          break;
        case "right":
          U = fl(E, S, D.right - 1, Y, k.left + 1, K);
          break;
      }
      if (U)
        return;
      if (f && !uP(E, S, D)) {
        R();
        return;
      }
      if (!M && m(E, S)) {
        R();
        return;
      }
      let j = !1;
      switch (d) {
        case "top": {
          const H = A ? It / 2 : It * 4, q = A || $ ? o + H : o - H, B = A ? o - H : $ ? o + H : o - H, X = s + It + 1, te = $ || A ? k.bottom - It : k.top, J = $ ? A ? k.bottom - It : k.top : k.bottom - It;
          j = dl(E, S, q, X, B, X, k.left, te, k.right, J);
          break;
        }
        case "bottom": {
          const H = A ? It / 2 : It * 4, q = A || $ ? o + H : o - H, B = A ? o - H : $ ? o + H : o - H, X = s - It, te = $ || A ? k.top + It : k.bottom, J = $ ? A ? k.top + It : k.bottom : k.top + It;
          j = dl(E, S, q, X, B, X, k.left, te, k.right, J);
          break;
        }
        case "left": {
          const H = F ? It / 2 : It * 4, q = F || L ? s + H : s - H, B = F ? s - H : L ? s + H : s - H, X = o + It + 1, te = L || F ? k.right - It : k.left, J = L ? F ? k.right - It : k.left : k.right - It;
          j = dl(E, S, te, k.top, J, k.bottom, X, q, X, B);
          break;
        }
        case "right": {
          const H = F ? It / 2 : It * 4, q = F || L ? s + H : s - H, B = F ? s - H : L ? s + H : s - H, X = o - It, te = L || F ? k.left + It : k.right, J = L ? F ? k.left + It : k.right : k.left + It;
          j = dl(E, S, X, q, X, B, te, k.top, J, k.bottom);
          break;
        }
      }
      j ? f || n.start(40, R) : R();
    };
  };
  return r.__options = {
    ...e,
    blockPointerEvents: t
  }, r;
}
const dP = {
  ...wu,
  disabled: (e) => e.disabled,
  instantType: (e) => e.instantType,
  isInstantPhase: (e) => e.isInstantPhase,
  trackCursorAxis: (e) => e.trackCursorAxis,
  disableHoverablePopup: (e) => e.disableHoverablePopup,
  lastOpenChangeReason: (e) => e.openChangeReason,
  closeOnClick: (e) => e.closeOnClick,
  closeDelay: (e) => e.closeDelay,
  adaptiveOrigin: (e) => e.adaptiveOrigin
};
class fP extends ci {
  constructor(n, r, o) {
    const s = new ui();
    super(hP(n, s, r, o), pP(s), dP);
    ce(this, "setOpen", (n, r) => {
      qR(this, n, r, {
        extraState: {
          openChangeReason: r.reason
        }
      });
    });
  }
  // Used by trigger clicks to clear a delayed hover open without reporting a public open-state change.
  cancelPendingOpen(n) {
    this.state.floatingRootContext.dispatchOpenChange(!1, Ne(Lr, n));
  }
}
function hP(e, t, n, r = !1) {
  const o = {
    ...xu(),
    disabled: !1,
    instantType: void 0,
    isInstantPhase: !1,
    trackCursorAxis: "none",
    disableHoverablePopup: !1,
    openChangeReason: null,
    closeOnClick: !0,
    closeDelay: 0,
    adaptiveOrigin: void 0,
    ...e
  };
  return o.floatingRootContext = ip(t, n, r), o;
}
function pP(e) {
  return {
    popupRef: /* @__PURE__ */ b.createRef(),
    onOpenChange: void 0,
    onOpenChangeComplete: void 0,
    triggerElements: e
  };
}
const U1 = kh(function(t) {
  const {
    disabled: n = !1,
    defaultOpen: r = !1,
    open: o,
    disableHoverablePopup: s = !1,
    trackCursorAxis: i = "none",
    actionsRef: a,
    onOpenChange: l,
    onOpenChangeComplete: c,
    handle: u,
    triggerId: d,
    defaultTriggerId: f = null,
    children: h
  } = t, p = op((P, I) => new fP({
    open: r,
    openProp: o,
    activeTriggerId: f,
    triggerIdProp: d
  }, P, I));
  p.useControlledProp("openProp", o), p.useControlledProp("triggerIdProp", d), p.useContextCallback("onOpenChange", l), p.useContextCallback("onOpenChangeComplete", c);
  const g = p.useState("open"), m = !n && g, v = p.useState("activeTriggerId"), y = p.useState("mounted"), x = p.useState("payload");
  p.useSyncedValues({
    trackCursorAxis: i,
    disableHoverablePopup: s,
    disabled: n
  }), bu(p, {
    closeOnActiveTriggerUnmount: !0
  });
  const {
    forceUnmount: C,
    transitionStatus: w
  } = vu(m, p), E = p.useState("isInstantPhase"), S = p.useState("instantType"), O = p.useState("lastOpenChangeReason"), M = b.useRef(null);
  pe(() => {
    g && n && p.setOpen(!1, Ne(a1));
  }, [g, n, p]), pe(() => {
    w === "ending" && O === Cn || w !== "ending" && E ? (S !== "delay" && (M.current = S), p.set("instantType", "delay")) : M.current !== null && (p.set("instantType", M.current), M.current = null);
  }, [w, E, O, S, p]), pe(() => {
    m && v == null && p.set("payload", void 0);
  }, [p, v, m]), b.useImperativeHandle(a, () => ({
    unmount: C,
    close: () => p.setOpen(!1, Ne(au))
  }), [C, p]);
  const T = m || y || !n && i !== "none";
  return /* @__PURE__ */ ee(Dh.Provider, {
    value: p,
    children: [u && /* @__PURE__ */ _(pu, {
      handle: u,
      store: p
    }), T && /* @__PURE__ */ _(gP, {
      store: p,
      disabled: n,
      trackCursorAxis: i
    }), typeof h == "function" ? h({
      payload: x
    }) : h]
  });
});
process.env.NODE_ENV !== "production" && (U1.displayName = "TooltipRoot");
function gP({
  store: e,
  disabled: t,
  trackCursorAxis: n
}) {
  const r = e.useState("floatingRootContext"), o = Da(r, {
    enabled: !t,
    referencePress: () => e.select("closeOnClick")
  }), s = XT(r, {
    enabled: !t && n !== "none",
    axis: n === "none" ? void 0 : n
  }), i = b.useMemo(() => _n(s.reference, o.reference), [s.reference, o.reference]);
  return yu(e, {
    activeTriggerProps: i,
    inactiveTriggerProps: i,
    popupProps: o.floating ?? At
  }), null;
}
let xc = /* @__PURE__ */ function(e) {
  return e.startingStyle = "data-starting-style", e.endingStyle = "data-ending-style", e;
}({});
const mP = {
  "data-starting-style": ""
}, bP = {
  "data-ending-style": ""
}, co = {
  transitionStatus(e) {
    return e === "starting" ? mP : e === "ending" ? bP : null;
  }
};
(function(e) {
  return e.open = "data-open", e.closed = "data-closed", e[e.startingStyle = xc.startingStyle] = "startingStyle", e[e.endingStyle = xc.endingStyle] = "endingStyle", e.anchorHidden = "data-anchor-hidden", e.side = "data-side", e.align = "data-align", e;
})({});
const vP = {
  "data-popup-open": ""
}, yP = {
  "data-popup-open": "",
  "data-pressed": ""
}, xP = {
  "data-open": ""
}, wP = {
  "data-closed": ""
}, CP = {
  "data-anchor-hidden": ""
}, Ou = {
  open(e) {
    return e ? vP : null;
  }
}, wc = {
  open(e) {
    return e ? yP : null;
  }
}, Aa = {
  open(e) {
    return e ? xP : wP;
  },
  anchorHidden(e) {
    return e ? CP : null;
  }
}, $a = {
  ...Aa,
  ...co
};
function gn(e) {
  return ko(e, "base-ui");
}
const dp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (dp.displayName = "TooltipProviderContext");
function EP() {
  return b.useContext(dp);
}
const gb = 600, G1 = "data-base-ui-tooltip-trigger";
function mb(e) {
  if ("composedPath" in e) {
    const n = e.composedPath();
    for (let r = 0; r < n.length; r += 1) {
      const o = n[r];
      if (Qe(o))
        return o;
    }
  }
  const t = e.target;
  return Qe(t) ? t : null;
}
function _P(e) {
  let t = e;
  for (; t; ) {
    const n = t.closest(`[${G1}]`);
    if (n)
      return n;
    const r = t.getRootNode();
    t = "host" in r && Qe(r.host) ? r.host : null;
  }
  return null;
}
const K1 = Xy(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    handle: i,
    payload: a,
    disabled: l,
    delay: c,
    closeOnClick: u = !0,
    closeDelay: d,
    id: f,
    ...h
  } = t, p = Oa(!0), m = Cu(i) ?? p;
  if (!m)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Trigger> must be either used within a <Tooltip.Root> component or provided with a handle." : tt(82));
  const v = gn(f), y = m.useState("isTriggerActive", v), x = m.useState("isOpenedByTrigger", v), C = m.useState("floatingRootContext"), w = b.useRef(null), E = c ?? gb, S = d ?? 0, {
    registerTrigger: O,
    isMountedByThisTrigger: M
  } = mu(v, w, m, {
    payload: a,
    closeOnClick: u,
    closeDelay: S
  }), T = EP(), {
    delayRef: P,
    isInstantPhase: I,
    hasProvider: R
  } = fT(C, {
    open: x
  }), D = cp(C);
  m.useSyncedValue("isInstantPhase", I);
  const k = m.useState("disabled"), $ = l ?? k, L = rn($), A = m.useState("trackCursorAxis"), F = m.useState("disableHoverablePopup"), N = b.useRef(!1), V = Sn(), K = b.useRef(void 0);
  function Y() {
    return R ? To(P.current, "open") === 0 ? 0 : c ?? T ?? gb : E;
  }
  function U(ne) {
    const Q = w.current;
    if (!Q || !ne)
      return !1;
    const re = _P(ne);
    return re !== null && re !== Q && Ie(Q, re);
  }
  function j(ne) {
    const Q = U(ne);
    return N.current = Q, Q && (D.openChangeTimeout.clear(), D.restTimeout.clear(), D.restTimeoutPending = !1, V.clear()), Q;
  }
  const H = Eu(C, {
    enabled: !$,
    mouseOnly: !0,
    move: !1,
    handleClose: !F && A !== "both" ? Su() : null,
    restMs: Y,
    delay() {
      return d == null && R ? {
        close: To(P.current, "close")
      } : {
        close: S
      };
    },
    triggerElementRef: w,
    isActiveTrigger: y,
    isClosing: () => m.select("transitionStatus") === "ending",
    shouldOpen() {
      return !N.current;
    }
  }), q = B1(C, {
    enabled: !$
  }).reference, B = (ne) => {
    const Q = N.current, re = mb(ne), fe = j(re), le = w.current, Ee = le && re && Ie(le, re);
    if (fe && m.select("open") && m.select("lastOpenChangeReason") === qt) {
      m.setOpen(!1, Ne(qt, ne));
      return;
    }
    if (Q && !fe && Ee && !L.current && !m.select("open") && le && // Match the hover hook's non-strict mouse fallback for mouse-only event sequences.
    _o(K.current)) {
      const se = () => {
        !N.current && !L.current && !m.select("open") && m.setOpen(!0, Ne(qt, ne, le));
      }, _e = Y();
      _e === 0 ? (V.clear(), se()) : V.start(_e, se);
    }
  }, X = m.useState("triggerProps", M);
  return We("button", t, {
    state: {
      open: x
    },
    ref: [n, O, w],
    props: [H, q, M || A !== "none" ? X : void 0, {
      onMouseOver(ne) {
        B(ne.nativeEvent);
      },
      onFocus(ne) {
        U(mb(ne.nativeEvent)) && ne.preventBaseUIHandler();
      },
      onMouseLeave() {
        N.current = !1, V.clear(), K.current = void 0;
      },
      onPointerEnter(ne) {
        K.current = ne.pointerType;
      },
      onPointerDown(ne) {
        K.current = ne.pointerType, m.set("closeOnClick", u), u && !m.select("open") && m.cancelPendingOpen(ne.nativeEvent);
      },
      onClick(ne) {
        u && !m.select("open") && m.cancelPendingOpen(ne.nativeEvent);
      },
      id: v,
      "data-trigger-disabled": $ ? "" : void 0,
      [G1]: $ ? void 0 : ""
    }, h],
    stateAttributesMapping: Ou
  });
});
process.env.NODE_ENV !== "production" && (K1.displayName = "TooltipTrigger");
const fp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (fp.displayName = "TooltipPortalContext");
function SP() {
  const e = b.useContext(fp);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Portal> is missing." : tt(70));
  return e;
}
const hp = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    children: r,
    container: o,
    className: s,
    render: i,
    style: a,
    ...l
  } = t, {
    node: c,
    subtree: u
  } = S1({
    container: o,
    ref: n,
    componentProps: t,
    elementProps: l
  });
  return !u && !c ? null : /* @__PURE__ */ ee(b.Fragment, {
    children: [u, c && /* @__PURE__ */ Xn.createPortal(r, c)]
  });
});
process.env.NODE_ENV !== "production" && (hp.displayName = "FloatingPortalLite");
const q1 = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    keepMounted: r = !1,
    ...o
  } = t;
  return Oa().useState("mounted") || r ? /* @__PURE__ */ _(fp.Provider, {
    value: r,
    children: /* @__PURE__ */ _(hp, {
      ref: n,
      ...o
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (q1.displayName = "TooltipPortal");
const pp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (pp.displayName = "TooltipPositionerContext");
function X1() {
  const e = b.useContext(pp);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipPositionerContext is missing. TooltipPositioner parts must be placed within <Tooltip.Positioner>." : tt(71));
  return e;
}
const Z1 = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Z1.displayName = "DirectionContext");
function Fa() {
  const e = b.useContext(Z1);
  return (e == null ? void 0 : e.direction) ?? "ltr";
}
const OP = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    var F, N;
    const {
      x: n,
      y: r,
      placement: o,
      rects: s,
      platform: i,
      elements: a,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0,
      offsetParent: d = "real"
    } = Po(e, t) || {};
    if (c == null)
      return {};
    const f = u1(u), h = {
      x: n,
      y: r
    }, p = Uh(o), g = jh(p), m = await i.getDimensions(c), v = p === "y", y = v ? "top" : "left", x = v ? "bottom" : "right", C = v ? "clientHeight" : "clientWidth", w = s.reference[g] + s.reference[p] - h[p] - s.floating[g], E = h[p] - s.reference[p], S = d === "real" ? await ((F = i.getOffsetParent) == null ? void 0 : F.call(i, c)) : a.floating;
    let O = a.floating[C] || s.floating[g];
    (!O || !await ((N = i.isElement) == null ? void 0 : N.call(i, S))) && (O = a.floating[C] || s.floating[g]);
    const M = w / 2 - E / 2, T = O / 2 - m[g] / 2 - 1, P = Math.min(f[y], T), I = Math.min(f[x], T), R = P, D = O - m[g] - I, k = O / 2 - m[g] / 2 + M, $ = c1(R, k, D), L = !l.arrow && Vo(o) != null && k !== $ && s.reference[g] / 2 - (k < R ? P : I) - m[g] / 2 < 0, A = L ? k < R ? k - R : k - D : 0;
    return {
      [p]: h[p] + A,
      data: {
        [p]: $,
        centerOffset: k - $ - A,
        ...L && {
          alignmentOffset: A
        }
      },
      reset: L
    };
  }
}), MP = (e, t) => ({
  ...OP(e),
  options: [e, t]
}), TP = {
  name: "hide",
  async fn(e) {
    const {
      width: t,
      height: n,
      x: r,
      y: o
    } = e.rects.reference, s = t === 0 && n === 0 && r === 0 && o === 0, i = await e.platform.detectOverflow(e, {
      elementContext: "reference"
    });
    return {
      data: {
        referenceHidden: i.top - n >= 0 || i.right - t >= 0 || i.bottom - n >= 0 || i.left - t >= 0 || s
      }
    };
  }
}, RP = {
  sideX: "left",
  sideY: "top"
}, bb = "--available-width", vb = "--available-height";
function Q1(e, t, n) {
  const r = e === "inline-start" || e === "inline-end";
  return {
    top: "top",
    right: r ? n ? "inline-start" : "inline-end" : "right",
    bottom: "bottom",
    left: r ? n ? "inline-end" : "inline-start" : "left"
  }[t];
}
function yb(e, t, n) {
  const {
    rects: r,
    placement: o
  } = e;
  return {
    side: Q1(t, ir(o), n),
    align: Vo(o) || "center",
    anchor: {
      width: r.reference.width,
      height: r.reference.height
    },
    positioner: {
      width: r.floating.width,
      height: r.floating.height
    }
  };
}
function Mu(e) {
  return PP(e, rP);
}
function PP(e, t) {
  var Ge, Le;
  const {
    // Public parameters
    anchor: n,
    positionMethod: r = "absolute",
    side: o = "bottom",
    sideOffset: s = 0,
    align: i = "center",
    alignOffset: a = 0,
    collisionBoundary: l,
    collisionPadding: c = 5,
    sticky: u = !1,
    arrowPadding: d = 5,
    disableAnchorTracking: f = !1,
    inline: h,
    // Private parameters
    keepMounted: p = !1,
    floatingRootContext: g,
    mounted: m,
    collisionAvoidance: v,
    shift: y,
    nodeId: x,
    adaptiveOrigin: C,
    lazyFlip: w = !1,
    externalTree: E
  } = e, [S, O] = b.useState(null);
  !m && S !== null && O(null);
  const M = v.side || "flip", T = v.align || "flip", P = v.fallbackAxisSide || "end", I = (y == null ? void 0 : y.crossAxis) ?? !1, R = y == null ? void 0 : y.rootBoundary, D = typeof n == "function" ? n : void 0, k = ye(D), $ = D ? k : n, L = rn(n), A = rn(m), N = Fa() === "rtl", V = S || {
    top: "top",
    right: "right",
    bottom: "bottom",
    left: "left",
    "inline-end": N ? "left" : "right",
    "inline-start": N ? "right" : "left"
  }[o], K = i === "center" ? V : `${V}-${i}`;
  let Y = c;
  typeof Y == "number" ? Y = {
    top: Y,
    right: Y,
    bottom: Y,
    left: Y
  } : Y && (Y = {
    top: Y.top || 0,
    right: Y.right || 0,
    bottom: Y.bottom || 0,
    left: Y.left || 0
  });
  const U = 1, j = o === "bottom" ? U : 0, H = o === "top" ? U : 0, q = o === "right" ? U : 0, B = o === "left" ? U : 0, X = {
    boundary: l === "clipping-ancestors" ? "clippingAncestors" : l,
    padding: Y
  }, te = b.useRef(null), J = rn(s), G = rn(a), ne = typeof s != "function" ? s : 0, Q = typeof a != "function" ? a : 0, re = [];
  h && re.push(h), re.push(DR((be) => {
    const Ye = yb(be, o, N), Tt = typeof J.current == "function" ? J.current(Ye) : J.current, je = typeof G.current == "function" ? G.current(Ye) : G.current;
    return {
      mainAxis: Tt,
      crossAxis: je,
      alignmentAxis: je
    };
  }, [ne, Q, N, o]));
  const fe = T === "none" && M !== "shift", le = !fe && (u || I || M === "shift"), Ee = M === "none" ? null : $R({
    ...X,
    // Ensure the popup flips if it's been limited by its --available-height and it resizes.
    // Since the size() padding is smaller than the flip() padding, flip() will take precedence.
    padding: {
      top: Y.top + U + j,
      right: Y.right + U + B,
      bottom: Y.bottom + U + H,
      left: Y.left + U + q
    },
    mainAxis: !I && M === "flip",
    crossAxis: T === "flip" ? "alignment" : !1,
    fallbackAxisSideDirection: P
  }), se = fe ? null : NR({
    ...X,
    // Use the Layout Viewport to avoid shifting around when pinch-zooming.
    rootBoundary: R,
    mainAxis: T !== "none",
    crossAxis: le,
    limiter: u || I ? void 0 : AR((be) => {
      if (!te.current)
        return {};
      const {
        width: Ye,
        height: Tt
      } = te.current.getBoundingClientRect(), je = sr(ir(be.placement)), Rt = je === "y" ? Ye : Tt, On = je === "y" ? Y.left + Y.right : Y.top + Y.bottom;
      return {
        offset: Rt / 2 + On / 2
      };
    })
  }, [X, u, I, R, Y, T]);
  M === "shift" || T === "shift" || i === "center" ? re.push(se, Ee) : re.push(Ee, se), re.push(FR({
    ...X,
    apply({
      elements: {
        floating: be
      },
      availableWidth: Ye,
      availableHeight: Tt,
      rects: je
    }) {
      if (!A.current)
        return;
      const Rt = be.style;
      Rt.setProperty(bb, `${Ye}px`), Rt.setProperty(vb, `${Tt}px`);
      const On = Ht(be).devicePixelRatio || 1, {
        x: vt,
        y: er,
        width: Jt,
        height: vn
      } = je.reference, ho = (Math.round((vt + Jt) * On) - Math.round(vt * On)) / On, po = (Math.round((er + vn) * On) - Math.round(er * On)) / On;
      Rt.setProperty("--anchor-width", `${ho}px`), Rt.setProperty("--anchor-height", `${po}px`);
    }
  }), MP((be) => ({
    // `transform-origin` calculations rely on an element existing. If the arrow hasn't been set,
    // we'll create a fake element.
    element: te.current || Ze(be.elements.floating).createElement("div"),
    padding: d,
    offsetParent: "floating"
  }), [d]), {
    name: "transformOrigin",
    fn(be) {
      var Gt, Ft, zt;
      const {
        elements: Ye,
        middlewareData: Tt,
        placement: je,
        rects: Rt,
        y: On
      } = be, vt = ir(je), er = sr(vt), Jt = te.current, vn = ((Gt = Tt.arrow) == null ? void 0 : Gt.x) || 0, ho = ((Ft = Tt.arrow) == null ? void 0 : Ft.y) || 0, po = (Jt == null ? void 0 : Jt.clientWidth) || 0, vr = (Jt == null ? void 0 : Jt.clientHeight) || 0, z = vn + po / 2, ue = ho + vr / 2, Te = Math.abs(((zt = Tt.shift) == null ? void 0 : zt.y) || 0), Ve = Rt.reference.height / 2, Se = typeof s == "function" ? s(yb(be, o, N)) : s, lt = Te > Se, rt = {
        top: `${z}px calc(100% + ${Se}px)`,
        bottom: `${z}px ${-Se}px`,
        left: `calc(100% + ${Se}px) ${ue}px`,
        right: `${-Se}px ${ue}px`
      }[vt], Je = `${z}px ${Rt.reference.y + Ve - On}px`;
      return Ye.floating.style.setProperty("--transform-origin", le && er === "y" && lt ? Je : rt), {};
    }
  }, TP, C), pe(() => {
    !m && g && g.update({
      referenceElement: null,
      floatingElement: null,
      domReferenceElement: null,
      positionReference: null
    });
  }, [m, g]);
  const _e = b.useMemo(() => ({
    elementResize: !f && typeof ResizeObserver < "u",
    layoutShift: !f && typeof IntersectionObserver < "u"
  }), [f]), {
    refs: xe,
    elements: ge,
    x: ae,
    y: W,
    middlewareData: Z,
    update: me,
    placement: ie,
    context: oe,
    isPositioned: he,
    floatingStyles: Re
  } = t({
    rootContext: g,
    open: p ? m : void 0,
    placement: K,
    middleware: re,
    strategy: r,
    whileElementsMounted: p ? void 0 : (...be) => ob(...be, _e),
    nodeId: x,
    externalTree: E
  }), {
    sideX: Ae,
    sideY: Ue
  } = Z.adaptiveOrigin || RP, Ke = he ? r : "fixed", Be = b.useMemo(() => {
    let be;
    return he ? C ? be = {
      position: Ke,
      [Ae]: ae,
      [Ue]: W
    } : be = {
      ...Re,
      position: Ke
    } : be = {
      position: Ke,
      top: 0,
      left: 0
    }, be[bb] = "100vw", be[vb] = "100vh", he || (be.opacity = 0), be;
  }, [C, Ke, Ae, ae, Ue, W, Re, he]), nt = b.useRef(null);
  pe(() => {
    if (!m)
      return;
    const be = L.current, Ye = typeof be == "function" ? be() : be, je = (xb(Ye) ? Ye.current : Ye) || null || null;
    je !== nt.current && (xe.setPositionReference(je), nt.current = je);
  }, [m, xe, $, L]), b.useEffect(() => {
    if (!m)
      return;
    const be = L.current;
    typeof be != "function" && xb(be) && be.current !== nt.current && (xe.setPositionReference(be.current), nt.current = be.current);
  }, [m, xe, $, L]), b.useEffect(() => {
    if (p && m && ge.reference && ge.floating)
      return ob(ge.reference, ge.floating, me, _e);
  }, [p, m, ge, me, _e]);
  const at = ir(ie), Wt = Q1(o, at, N), Mt = Vo(ie) || "center", Bt = !!((Ge = Z.hide) != null && Ge.referenceHidden);
  pe(() => {
    w && m && he && at !== V && O(at);
  }, [w, m, he, at, V]);
  const Qt = b.useMemo(() => {
    var be, Ye;
    return {
      position: "absolute",
      top: (be = Z.arrow) == null ? void 0 : be.y,
      left: (Ye = Z.arrow) == null ? void 0 : Ye.x
    };
  }, [Z.arrow]), Pe = ((Le = Z.arrow) == null ? void 0 : Le.centerOffset) !== 0;
  return b.useMemo(() => ({
    positionerStyles: Be,
    arrowStyles: Qt,
    arrowRef: te,
    arrowUncentered: Pe,
    side: Wt,
    align: Mt,
    physicalSide: at,
    anchorHidden: Bt,
    refs: xe,
    context: oe,
    isPositioned: he,
    update: me
  }), [Be, Qt, te, Pe, Wt, Mt, at, Bt, xe, oe, he, me]);
}
function xb(e) {
  return e != null && "current" in e;
}
function La(e) {
  return e === "starting" ? WT : At;
}
function Tu(e, t, {
  styles: n,
  transitionStatus: r,
  props: o,
  refs: s,
  hidden: i,
  inert: a = !1
}) {
  const l = {
    ...n
  };
  return a && (l.pointerEvents = "none"), We("div", e, {
    state: t,
    ref: s,
    props: [{
      role: "presentation",
      hidden: i,
      style: l
    }, La(r), o],
    stateAttributesMapping: Aa
  });
}
const J1 = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    anchor: s,
    positionMethod: i = "absolute",
    side: a = "top",
    align: l = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: h = 5,
    sticky: p = !1,
    disableAnchorTracking: g = !1,
    collisionAvoidance: m = Xh,
    style: v,
    ...y
  } = t, x = Oa(), C = SP(), w = x.useState("open"), E = x.useState("mounted"), S = x.useState("trackCursorAxis"), O = x.useState("disableHoverablePopup"), M = x.useState("floatingRootContext"), T = x.useState("instantType"), P = x.useState("transitionStatus"), I = x.useState("adaptiveOrigin"), R = Mu({
    anchor: s,
    positionMethod: i,
    floatingRootContext: M,
    mounted: E,
    side: a,
    sideOffset: c,
    align: l,
    alignOffset: u,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: p,
    arrowPadding: h,
    disableAnchorTracking: g,
    keepMounted: C,
    collisionAvoidance: m,
    adaptiveOrigin: I
  }), D = b.useMemo(() => ({
    open: w,
    side: R.side,
    align: R.align,
    anchorHidden: R.anchorHidden,
    instant: S !== "none" ? "tracking-cursor" : T
  }), [w, R.side, R.align, R.anchorHidden, S, T]), k = Tu(t, D, {
    styles: R.positionerStyles,
    transitionStatus: P,
    props: y,
    refs: [n, x.useStateSetter("positionerElement")],
    hidden: !E,
    inert: !w || S === "both" || O
  });
  return /* @__PURE__ */ _(pp.Provider, {
    value: R,
    children: k
  });
});
process.env.NODE_ENV !== "production" && (J1.displayName = "TooltipPositioner");
const ex = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, a = Oa(), {
    side: l,
    align: c
  } = X1(), u = a.useState("open"), d = a.useState("instantType"), f = a.useState("transitionStatus"), h = a.useState("popupProps"), p = a.useState("floatingRootContext"), g = a.useState("disabled"), m = a.useState("closeDelay");
  Jn({
    open: u,
    ref: a.context.popupRef,
    onComplete() {
      var C, w;
      u && ((w = (C = a.context).onOpenChangeComplete) == null || w.call(C, !0));
    }
  }), up(p, {
    enabled: !g,
    closeDelay: m
  });
  const v = a.useStateSetter("popupElement");
  return We("div", t, {
    state: {
      open: u,
      side: l,
      align: c,
      instant: d,
      transitionStatus: f
    },
    ref: [n, a.context.popupRef, v],
    props: [Na, h, La(f), i],
    stateAttributesMapping: $a
  });
});
process.env.NODE_ENV !== "production" && (ex.displayName = "TooltipPopup");
const tx = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, a = Oa(), {
    arrowRef: l,
    side: c,
    align: u,
    arrowUncentered: d,
    arrowStyles: f
  } = X1(), h = a.useState("open"), p = a.useState("instantType");
  return We("div", t, {
    state: {
      open: h,
      side: c,
      align: u,
      uncentered: d,
      instant: p
    },
    ref: [n, l],
    props: [{
      style: f,
      "aria-hidden": !0
    }, i],
    stateAttributesMapping: Aa
  });
});
process.env.NODE_ENV !== "production" && (tx.displayName = "TooltipArrow");
const nx = function(t) {
  const {
    delay: n,
    closeDelay: r,
    timeout: o = 400
  } = t, s = b.useMemo(() => ({
    open: n,
    close: r
  }), [n, r]);
  return /* @__PURE__ */ _(dp.Provider, {
    value: n,
    children: /* @__PURE__ */ _(dT, {
      delay: s,
      timeoutMs: o,
      children: t.children
    })
  });
};
process.env.NODE_ENV !== "production" && (nx.displayName = "TooltipProvider");
function di(e) {
  return Mh(19) ? e : e ? "true" : void 0;
}
const IP = Qn(
  "max-w-lg origin-[--transform-origin] rounded-lg bg-clip-padding outline outline-1 -outline-offset-1 outline-[theme(borderColor.foundations-subtle)] transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[starting-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0 data-[instant]:duration-0",
  {
    variants: {
      variant: {
        dark: "bg-foundations-inverse text-foundations-inverse outline-transparent [&_[data-slot=arrow-bg]]:fill-[theme(backgroundColor.foundations-inverse)]",
        light: "bg-foundations-default text-foundations-boldest [&_[data-slot=arrow-bg]]:fill-[theme(backgroundColor.foundations-default)] [&_[data-slot=arrow-border]]:fill-[theme(borderColor.foundations-subtle)]"
      },
      size: {
        default: "p-2 text-sm lg:p-3 lg:[&_.tooltip-arrow]:h-4 lg:[&_.tooltip-arrow]:w-8",
        sm: "px-2.5 py-1.5 text-xs"
      }
    },
    defaultVariants: {
      variant: "dark",
      size: "default"
    }
  }
), wb = (e) => /* @__PURE__ */ _(nx, { delay: 350, ...e }), kP = U1, DP = b.forwardRef((e, t) => /* @__PURE__ */ _(K1, { "data-slot": "tooltip-trigger", ...e })), NP = b.forwardRef(
  ({
    side: e = "top",
    sideOffset: t = 10,
    collisionPadding: n = 4,
    collisionBoundary: r,
    align: o,
    alignOffset: s = 0,
    className: i,
    hideArrow: a = !1,
    variant: l,
    size: c,
    children: u
  }, d) => /* @__PURE__ */ _(q1, { children: /* @__PURE__ */ _(
    J1,
    {
      "data-slot": "tooltip-positioner",
      side: e,
      sideOffset: t,
      collisionPadding: n,
      align: o,
      alignOffset: s,
      collisionBoundary: r,
      className: "z-50",
      children: /* @__PURE__ */ ee(
        ex,
        {
          "data-slot": "tooltip-content",
          ref: d,
          className: de(
            "break-words",
            IP({ variant: l, size: c }),
            i
          ),
          children: [
            u,
            !a && /* @__PURE__ */ _(
              tx,
              {
                "data-slot": "tooltip-arrow",
                className: "z-50 data-[side=bottom]:top-[-8px] data-[side=left]:right-[-13px] data-[side=right]:left-[-13px] data-[side=top]:bottom-[-8px] data-[side=left]:rotate-90 data-[side=right]:-rotate-90 data-[side=top]:rotate-180",
                children: /* @__PURE__ */ _(AP, {})
              }
            )
          ]
        }
      )
    }
  ) })
), Lt = Object.assign(kP, {
  Trigger: DP,
  Popup: NP
});
function AP(e) {
  return /* @__PURE__ */ ee("svg", { width: "20", height: "10", viewBox: "0 0 20 10", fill: "none", ...e, children: [
    /* @__PURE__ */ _(
      "path",
      {
        "data-slot": "arrow-bg",
        d: "M9.66437 2.60207L4.80758 6.97318C4.07308 7.63423 3.11989 8 2.13172 8H0V10H20V8H18.5349C17.5468 8 16.5936 7.63423 15.8591 6.97318L11.0023 2.60207C10.622 2.2598 10.0447 2.25979 9.66437 2.60207Z"
      }
    ),
    /* @__PURE__ */ _(
      "path",
      {
        "data-slot": "arrow-border",
        d: "M10.3333 3.34539L5.47654 7.71648C4.55842 8.54279 3.36693 9 2.13172 9H0V8H2.13172C3.11989 8 4.07308 7.63423 4.80758 6.97318L9.66437 2.60207C10.0447 2.25979 10.622 2.2598 11.0023 2.60207L15.8591 6.97318C16.5936 7.63423 17.5468 8 18.5349 8H20V9H18.5349C17.2998 9 16.1083 8.54278 15.1901 7.71648L10.3333 3.34539Z"
      }
    )
  ] });
}
const rx = ({
  children: e,
  render: t,
  content: n,
  hoverable: r,
  size: o,
  variant: s,
  disabled: i,
  ...a
}) => {
  const [l, c] = b.useState(null), [u, d] = b.useState(!1);
  b.useEffect(() => {
    if (!l)
      return;
    const p = () => {
      d(l.scrollWidth > l.clientWidth);
    }, g = new ResizeObserver((m) => {
      requestAnimationFrame(() => {
        for (const v of m)
          v.contentBoxSize && p();
      });
    });
    return g.observe(l), () => g.unobserve(l);
  }, [l]);
  const h = ai({
    defaultTagName: "p",
    render: t,
    ref: c,
    props: _n({
      className: "truncate",
      "data-slot": "overflow-text"
    }, a)
  });
  return /* @__PURE__ */ ee(
    Lt,
    {
      disabled: i || !u,
      disableHoverablePopup: !r,
      children: [
        /* @__PURE__ */ _(Lt.Trigger, { render: h, children: e }),
        /* @__PURE__ */ _(Lt.Popup, { size: o, variant: s, children: n ?? (l == null ? void 0 : l.textContent) })
      ]
    }
  );
}, $P = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "div",
  {
    ref: n,
    className: de(
      "h-3.5 animate-pulse rounded-lg bg-foundations-subtlest",
      e
    ),
    ...t
  }
));
$P.displayName = "Skeleton";
const gp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (gp.displayName = "DialogRootContext");
function uo(e) {
  const t = b.useContext(gp);
  if (!e && t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: DialogRootContext is missing. Dialog parts must be placed within <Dialog.Root>." : tt(27));
  return t;
}
const mp = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    forceRender: i = !1,
    ...a
  } = t, l = uo(), c = l.useState("open"), u = l.useState("nested"), d = l.useState("mounted"), f = l.useState("transitionStatus");
  return We("div", t, {
    state: {
      open: c,
      transitionStatus: f
    },
    ref: [l.context.backdropRef, n],
    stateAttributesMapping: $a,
    props: [{
      role: "presentation",
      hidden: !d,
      style: {
        userSelect: "none",
        WebkitUserSelect: "none"
      }
    }, a],
    enabled: i || !u
  });
});
process.env.NODE_ENV !== "production" && (mp.displayName = "DialogBackdrop");
let Lf;
process.env.NODE_ENV !== "production" && (Lf = /* @__PURE__ */ new Set());
function da(...e) {
  if (process.env.NODE_ENV !== "production") {
    const t = e.join(" ");
    Lf.has(t) || (Lf.add(t), console.error(`Base UI: ${t}`));
  }
}
const bp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (bp.displayName = "CompositeRootContext");
function Ru(e = !1) {
  const t = b.useContext(bp);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CompositeRootContext is missing. Composite parts must be placed within <Composite.Root>." : tt(16));
  return t;
}
function FP(e) {
  const {
    focusableWhenDisabled: t,
    disabled: n,
    composite: r = !1,
    tabIndex: o = 0,
    isNativeButton: s
  } = e, i = r && t !== !1, a = r && t === !1;
  return {
    props: b.useMemo(() => {
      const c = {
        // allow Tabbing away from focusableWhenDisabled elements
        onKeyDown(u) {
          n && t && u.key !== "Tab" && u.preventDefault();
        }
      };
      return r || (c.tabIndex = o, !s && n && (c.tabIndex = t ? o : -1)), (s && (t || i) || !s && n) && (c["aria-disabled"] = n), s && (!t || a) && (c.disabled = n), c;
    }, [r, n, t, i, a, s, o])
  };
}
function Zi(e, t, {
  detail: n = 0
} = {}) {
  e.dispatchEvent(new (Ht(e)).PointerEvent("click", {
    bubbles: !0,
    cancelable: !0,
    composed: !0,
    detail: n,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    altKey: t.altKey,
    metaKey: t.metaKey
  }));
}
function Wn(e = {}) {
  const {
    disabled: t = !1,
    focusableWhenDisabled: n,
    tabIndex: r = 0,
    native: o = !0,
    composite: s
  } = e, i = b.useRef(null), a = Ru(!0), l = s ?? a !== void 0, {
    props: c
  } = FP({
    focusableWhenDisabled: n,
    disabled: t,
    composite: l,
    tabIndex: r,
    isNativeButton: o
  });
  process.env.NODE_ENV !== "production" && b.useEffect(() => {
    var p, g;
    if (!i.current)
      return;
    const h = hl(i.current);
    if (o) {
      if (!h) {
        const m = ((p = or.captureOwnerStack) == null ? void 0 : p.call(or)) || "";
        da(`A component that acts as a button expected a native <button> because the \`nativeButton\` prop is true. Rendering a non-<button> removes native button semantics, which can impact forms and accessibility. Use a real <button> in the \`render\` prop, or set \`nativeButton\` to \`false\`.${m}`);
      }
    } else if (h) {
      const m = ((g = or.captureOwnerStack) == null ? void 0 : g.call(or)) || "";
      da(`A component that acts as a button expected a non-<button> because the \`nativeButton\` prop is false. Rendering a <button> keeps native behavior while Base UI applies non-native attributes and handlers, which can add unintended extra attributes (such as \`role\` or \`aria-disabled\`). Use a non-<button> in the \`render\` prop, or set \`nativeButton\` to \`true\`.${m}`);
    }
  }, [o]);
  const u = b.useCallback(() => {
    const h = i.current;
    hl(h) && l && t && c.disabled === void 0 && h.disabled && (h.disabled = !1);
  }, [t, c.disabled, l]);
  pe(u, [u]);
  const d = b.useCallback((h = {}) => {
    const {
      onClick: p,
      onMouseDown: g,
      onKeyUp: m,
      onKeyDown: v,
      onPointerDown: y,
      ...x
    } = h;
    return _n({
      onClick(C) {
        if (t) {
          C.preventDefault();
          return;
        }
        p == null || p(C);
      },
      onMouseDown(C) {
        t || g == null || g(C);
      },
      onKeyDown(C) {
        if (t || (cc(C), v == null || v(C), C.baseUIHandlerPrevented))
          return;
        const w = C.target === C.currentTarget, E = C.currentTarget, S = hl(E), O = !o && LP(E), M = w && (o ? S : !O), T = C.key === "Enter", P = C.key === " ", I = E.getAttribute("role"), R = (I == null ? void 0 : I.startsWith("menuitem")) || I === "option" || I === "gridcell";
        if (w && l && P) {
          if (C.defaultPrevented && R)
            return;
          C.preventDefault(), (!o || S) && (C.preventBaseUIHandler(), Zi(E, C));
          return;
        }
        if (!M || o || !P && !T) {
          w && O && P && C.preventDefault();
          return;
        }
        C.defaultPrevented || (C.preventDefault(), T && (C.preventBaseUIHandler(), Zi(E, C)));
      },
      onKeyUp(C) {
        if (!t) {
          if (cc(C), m == null || m(C), C.target === C.currentTarget && o && l && hl(C.currentTarget) && C.key === " ") {
            C.preventDefault();
            return;
          }
          C.baseUIHandlerPrevented || C.target === C.currentTarget && !o && !l && !C.defaultPrevented && C.key === " " && (C.preventBaseUIHandler(), Zi(C.currentTarget, C));
        }
      },
      onPointerDown(C) {
        if (t) {
          C.preventDefault();
          return;
        }
        y == null || y(C);
      }
    }, o ? {
      type: "button"
    } : {
      role: "button"
    }, c, x);
  }, [t, c, l, o]), f = ye((h) => {
    i.current = h, u();
  });
  return {
    getButtonProps: d,
    buttonRef: f
  };
}
function hl(e) {
  return wt(e) && e.tagName === "BUTTON";
}
function LP(e) {
  return wt(e) && e.tagName === "A" && !!e.href;
}
const Pu = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    disabled: i = !1,
    nativeButton: a = !0,
    ...l
  } = t, c = uo(), u = c.useState("open"), {
    getButtonProps: d,
    buttonRef: f
  } = Wn({
    disabled: i,
    native: a
  }), h = {
    disabled: i
  };
  function p(g) {
    u && c.setOpen(!1, Ne(Hh, g.nativeEvent));
  }
  return We("button", t, {
    state: h,
    ref: [n, f],
    props: [{
      onClick: p
    }, l, d]
  });
});
process.env.NODE_ENV !== "production" && (Pu.displayName = "DialogClose");
const vp = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    id: i,
    ...a
  } = t, l = uo(), c = gn(i);
  return l.useSyncedValueWithCleanup("descriptionElementId", c), We("p", t, {
    ref: n,
    props: [{
      id: c
    }, a]
  });
});
process.env.NODE_ENV !== "production" && (vp.displayName = "DialogDescription");
const yp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (yp.displayName = "DialogPortalContext");
function ox() {
  const e = b.useContext(yp);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Portal> is missing." : tt(26));
  return e;
}
const Vf = "ArrowUp", Wf = "ArrowDown", Hf = "ArrowLeft", Bf = "ArrowRight", zf = "Home", Yf = "End", Iu = /* @__PURE__ */ new Set([Vf, Wf, Hf, Bf, zf, Yf]), VP = "Shift", WP = [VP, "Control", "Alt", "Meta"];
function HP(e) {
  return wt(e) && e.tagName === "INPUT";
}
function Cb(e) {
  return !!(HP(e) && e.selectionStart != null || wt(e) && e.tagName === "TEXTAREA");
}
function Eb(e, t, n, r) {
  if (!e || !t || !t.scrollTo)
    return;
  let o = e.scrollLeft, s = e.scrollTop;
  const i = e.clientWidth < e.scrollWidth, a = e.clientHeight < e.scrollHeight;
  if (i && r !== "vertical") {
    const l = _b(e, t, "left"), c = pl(e), u = pl(t);
    n === "ltr" && (l + t.offsetWidth + u.scrollMarginRight > e.scrollLeft + e.clientWidth - c.scrollPaddingRight ? o = l + t.offsetWidth + u.scrollMarginRight - e.clientWidth + c.scrollPaddingRight : l - u.scrollMarginLeft < e.scrollLeft + c.scrollPaddingLeft && (o = l - u.scrollMarginLeft - c.scrollPaddingLeft)), n === "rtl" && (l - u.scrollMarginLeft < e.scrollLeft + c.scrollPaddingLeft ? o = l - u.scrollMarginLeft - c.scrollPaddingLeft : l + t.offsetWidth + u.scrollMarginRight > e.scrollLeft + e.clientWidth - c.scrollPaddingRight && (o = l + t.offsetWidth + u.scrollMarginRight - e.clientWidth + c.scrollPaddingRight));
  }
  if (a && r !== "horizontal") {
    const l = _b(e, t, "top"), c = pl(e), u = pl(t);
    l - u.scrollMarginTop < e.scrollTop + c.scrollPaddingTop ? s = l - u.scrollMarginTop - c.scrollPaddingTop : l + t.offsetHeight + u.scrollMarginBottom > e.scrollTop + e.clientHeight - c.scrollPaddingBottom && (s = l + t.offsetHeight + u.scrollMarginBottom - e.clientHeight + c.scrollPaddingBottom);
  }
  e.scrollTo({
    left: o,
    top: s,
    behavior: "auto"
  });
}
function _b(e, t, n) {
  const r = n === "left" ? "offsetLeft" : "offsetTop";
  let o = 0;
  for (; t.offsetParent && (o += t[r], t.offsetParent !== e); )
    t = t.offsetParent;
  return o;
}
function pl(e) {
  const t = getComputedStyle(e);
  return {
    scrollMarginTop: parseFloat(t.scrollMarginTop) || 0,
    scrollMarginRight: parseFloat(t.scrollMarginRight) || 0,
    scrollMarginBottom: parseFloat(t.scrollMarginBottom) || 0,
    scrollMarginLeft: parseFloat(t.scrollMarginLeft) || 0,
    scrollPaddingTop: parseFloat(t.scrollPaddingTop) || 0,
    scrollPaddingRight: parseFloat(t.scrollPaddingRight) || 0,
    scrollPaddingBottom: parseFloat(t.scrollPaddingBottom) || 0,
    scrollPaddingLeft: parseFloat(t.scrollPaddingLeft) || 0
  };
}
const sx = {
  ...Aa,
  ...co,
  nestedDialogOpen(e) {
    return e ? {
      "data-nested-dialog-open": ""
    } : null;
  }
}, xp = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    finalFocus: i,
    initialFocus: a,
    ...l
  } = t, c = uo(), u = c.useState("descriptionElementId"), d = c.useState("disablePointerDismissal"), f = c.useState("floatingRootContext"), h = c.useState("popupProps"), p = c.useState("modal"), g = c.useState("mounted"), m = c.useState("nested"), v = c.useState("nestedOpenDialogCount"), y = c.useState("open"), x = c.useState("openMethod"), C = c.useState("titleElementId"), w = c.useState("transitionStatus"), E = c.useState("role"), S = f.useState("floatingId");
  ox(), Jn({
    open: y,
    ref: c.context.popupRef,
    onComplete() {
      var R, D;
      y && ((D = (R = c.context).onOpenChangeComplete) == null || D.call(R, !0));
    }
  });
  const O = a === void 0 ? L1(c.context.popupRef) : a, M = v > 0, T = c.useStateSetter("popupElement"), I = We("div", t, {
    state: {
      open: y,
      nested: m,
      transitionStatus: w,
      nestedDialogOpen: M
    },
    props: [h, {
      id: S,
      "aria-labelledby": C,
      "aria-describedby": u,
      role: E,
      ...Na,
      hidden: !g,
      onKeyDown(R) {
        Iu.has(R.key) && R.stopPropagation();
      },
      style: {
        "--nested-dialogs": v
      }
    }, l],
    ref: [n, c.context.popupRef, T],
    stateAttributesMapping: sx
  });
  return /* @__PURE__ */ _(cu, {
    context: f,
    openInteractionType: x,
    disabled: !g,
    closeOnFocusOut: !d,
    initialFocus: O,
    returnFocus: i,
    modal: p !== !1,
    restoreFocus: "popup",
    children: I
  });
});
process.env.NODE_ENV !== "production" && (xp.displayName = "DialogPopup");
const Va = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    cutout: r,
    ...o
  } = t;
  let s;
  if (r) {
    const i = r.getBoundingClientRect();
    s = `polygon(0% 0%,100% 0%,100% 100%,0% 100%,0% 0%,${i.left}px ${i.top}px,${i.left}px ${i.bottom}px,${i.right}px ${i.bottom}px,${i.right}px ${i.top}px,${i.left}px ${i.top}px)`;
  }
  return /* @__PURE__ */ _("div", {
    ref: n,
    role: "presentation",
    "data-base-ui-inert": "",
    ...o,
    style: {
      position: "fixed",
      inset: 0,
      userSelect: "none",
      WebkitUserSelect: "none",
      clipPath: s
    }
  });
});
process.env.NODE_ENV !== "production" && (Va.displayName = "InternalBackdrop");
const wp = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    keepMounted: r = !1,
    ...o
  } = t, s = uo(), i = s.useState("mounted"), a = s.useState("modal"), l = s.useState("open");
  return i || r ? /* @__PURE__ */ _(yp.Provider, {
    value: r,
    children: /* @__PURE__ */ ee(ka, {
      ref: n,
      ...o,
      children: [i && a === !0 && /* @__PURE__ */ _(Va, {
        ref: s.context.internalBackdropRef,
        inert: di(!l)
      }), t.children]
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (wp.displayName = "DialogPortal");
let Sb = {}, Ob = {}, Mb = "";
function ku(e, t) {
  return Ta(e) ? e : t;
}
function Tb(e, t, n) {
  return /hidden|clip/.test(e.getComputedStyle(ku(t, n)).overflowY);
}
function BP(e) {
  if (typeof document > "u")
    return !1;
  const t = Ze(e);
  return Ht(t).innerWidth - t.documentElement.clientWidth > 0;
}
function zP(e) {
  if (!(typeof CSS < "u" && CSS.supports && CSS.supports("scrollbar-gutter", "stable")) || typeof document > "u")
    return !1;
  const n = Ze(e), r = n.documentElement, o = n.body, s = ku(r, o), i = s.style.overflowY, a = r.style.scrollbarGutter;
  r.style.scrollbarGutter = "stable", s.style.overflowY = "scroll";
  const l = s.offsetWidth;
  s.style.overflowY = "hidden";
  const c = s.offsetWidth;
  return s.style.overflowY = i, r.style.scrollbarGutter = a, l === c;
}
function YP(e) {
  const t = Ze(e), n = t.documentElement, r = t.body, o = ku(n, r), s = {
    overflowY: o.style.overflowY,
    overflowX: o.style.overflowX
  };
  return Object.assign(o.style, {
    overflowY: "hidden",
    overflowX: "hidden"
  }), () => {
    Object.assign(o.style, s);
  };
}
function jP(e) {
  var h;
  const t = Ze(e), n = t.documentElement, r = t.body, o = Ht(n);
  let s = 0, i = 0, a = !1;
  const l = An.create();
  if (Lo && (((h = o.visualViewport) == null ? void 0 : h.scale) ?? 1) !== 1)
    return () => {
    };
  function c() {
    const p = o.getComputedStyle(n), g = o.getComputedStyle(r), y = (p.scrollbarGutter || "").includes("both-edges") ? "stable both-edges" : "stable";
    s = n.scrollTop, i = n.scrollLeft, Sb = {
      scrollbarGutter: n.style.scrollbarGutter,
      overflowY: n.style.overflowY,
      overflowX: n.style.overflowX
    }, Mb = n.style.scrollBehavior, Ob = {
      position: r.style.position,
      height: r.style.height,
      width: r.style.width,
      boxSizing: r.style.boxSizing,
      overflowY: r.style.overflowY,
      overflowX: r.style.overflowX,
      scrollBehavior: r.style.scrollBehavior
    };
    const x = n.scrollHeight > n.clientHeight, C = n.scrollWidth > n.clientWidth, w = p.overflowY === "scroll" || g.overflowY === "scroll", E = p.overflowX === "scroll" || g.overflowX === "scroll", S = Math.max(0, o.innerWidth - r.clientWidth), O = Math.max(0, o.innerHeight - r.clientHeight), M = parseFloat(g.marginTop) + parseFloat(g.marginBottom), T = parseFloat(g.marginLeft) + parseFloat(g.marginRight), P = ku(n, r);
    if (a = zP(e), a) {
      n.style.scrollbarGutter = y, P.style.overflowY = "hidden", P.style.overflowX = "hidden";
      return;
    }
    Object.assign(n.style, {
      scrollbarGutter: y,
      overflowY: "hidden",
      overflowX: "hidden"
    }), (x || w) && (n.style.overflowY = "scroll"), (C || E) && (n.style.overflowX = "scroll"), Object.assign(r.style, {
      position: "relative",
      height: M || O ? `calc(100dvh - ${M + O}px)` : "100dvh",
      width: T || S ? `calc(100vw - ${T + S}px)` : "100vw",
      boxSizing: "border-box",
      // Assign the longhands that `cleanup` restores, so nothing is left behind.
      overflowY: "hidden",
      overflowX: "hidden",
      scrollBehavior: "unset"
    }), r.scrollTop = s, r.scrollLeft = i, n.setAttribute("data-base-ui-scroll-locked", ""), n.style.scrollBehavior = "unset";
  }
  function u() {
    Object.assign(n.style, Sb), Object.assign(r.style, Ob), a || (n.scrollTop = s, n.scrollLeft = i, n.removeAttribute("data-base-ui-scroll-locked"), n.style.scrollBehavior = Mb);
  }
  function d() {
    u(), l.request(c);
  }
  c();
  const f = qe(o, "resize", d);
  return () => {
    l.cancel(), u(), typeof o.removeEventListener == "function" && f();
  };
}
class UP {
  constructor() {
    ce(this, "lockCount", 0);
    ce(this, "restore", null);
    ce(this, "timeoutLock", Ln.create());
    ce(this, "timeoutUnlock", Ln.create());
    ce(this, "release", () => {
      this.lockCount -= 1, this.lockCount === 0 && this.restore && this.timeoutUnlock.start(0, this.unlock);
    });
    ce(this, "unlock", () => {
      var t;
      this.lockCount === 0 && this.restore && ((t = this.restore) == null || t.call(this), this.restore = null);
    });
  }
  acquire(t) {
    return this.lockCount += 1, this.lockCount === 1 && this.restore === null && this.timeoutLock.start(0, () => this.lock(t)), this.release;
  }
  lock(t) {
    if (this.lockCount === 0 || this.restore !== null)
      return;
    const n = Ze(t), r = n.documentElement, o = n.body, s = Ht(r);
    if (Tb(s, r, o)) {
      const a = new s.MutationObserver(() => {
        Tb(s, r, o) || (a.disconnect(), this.restore = null, this.lock(t));
      }), l = {
        attributes: !0
      };
      a.observe(r, l), a.observe(o, l), this.restore = () => a.disconnect();
      return;
    }
    const i = Ma || !BP(t);
    this.restore = i ? YP(t) : jP(t);
  }
}
const GP = new UP();
function ix(e = !0, t = null) {
  pe(() => {
    if (e)
      return GP.acquire(t);
  }, [e, t]);
}
function KP({
  store: e,
  parentContext: t,
  isDrawer: n
}) {
  const r = e.useState("open"), o = e.useState("disablePointerDismissal"), s = e.useState("modal"), i = e.useState("popupElement"), a = e.useState("floatingRootContext"), [l, c] = b.useState(0), [u, d] = b.useState(0), f = l === 0, h = Da(a, {
    outsidePressEvent() {
      return e.context.internalBackdropRef.current || e.context.backdropRef.current ? "intentional" : {
        mouse: s === "trap-focus" ? "sloppy" : "intentional",
        touch: "sloppy"
      };
    },
    outsidePress(p) {
      if (!e.context.outsidePressEnabledRef.current || "button" in p && p.button !== 0)
        return !1;
      if ("touches" in p) {
        if (p.type === "touchend") {
          if (p.changedTouches.length !== 1 || p.touches.length !== 0)
            return !1;
        } else if (p.touches.length !== 1)
          return !1;
      }
      const g = Ot(p);
      if (f && !o) {
        if (s) {
          const m = e.context.internalBackdropRef.current, v = e.context.backdropRef.current;
          return m || v ? m === g || v === g || Ie(g, i) && !(g != null && g.hasAttribute("data-base-ui-portal")) : !0;
        }
        return !0;
      }
      return !1;
    },
    escapeKey: f
  });
  return ix(r && s === !0, i), e.useContextCallback("onNestedDialogOpen", (p, g) => {
    c(p), d(g);
  }), pe(() => (t != null && t.onNestedDialogOpen && (r ? t.onNestedDialogOpen(l + 1, u + (n ? 1 : 0)) : t.onNestedDialogOpen(0, 0)), () => {
    t != null && t.onNestedDialogOpen && r && t.onNestedDialogOpen(0, 0);
  }), [n, r, l, u, t]), yu(e, {
    // `enabled` is not passed to `useDismiss`, so its props are always defined,
    // and `trigger` is the same object as `reference`.
    activeTriggerProps: h.reference,
    inactiveTriggerProps: h.trigger,
    // DialogPopup and DrawerPopup spread `FOCUSABLE_POPUP_PROPS` directly, so
    // this only needs to carry the dismiss handlers.
    popupProps: h.floating,
    nestedOpenDialogCount: l,
    nestedOpenDrawerCount: u
  }), null;
}
const qP = {
  ...wu,
  modal: (e) => e.modal,
  nested: (e) => e.nested,
  nestedOpenDialogCount: (e) => e.nestedOpenDialogCount,
  nestedOpenDrawerCount: (e) => e.nestedOpenDrawerCount,
  disablePointerDismissal: (e) => e.disablePointerDismissal,
  openMethod: (e) => e.openMethod,
  descriptionElementId: (e) => e.descriptionElementId,
  titleElementId: (e) => e.titleElementId,
  viewportElement: (e) => e.viewportElement,
  role: (e) => e.role
};
class XP extends ci {
  constructor(n, r, o) {
    const s = new ui(), i = ZP(n, s, r, o);
    super(i, QP(s), qP);
    ce(this, "setOpen", (n, r) => {
      var s, i;
      if (r.preventUnmountOnClose = () => {
        this.set("preventUnmountingOnClose", !0);
      }, !n && r.trigger == null && this.state.activeTriggerId != null && (r.trigger = this.state.activeTriggerElement ?? void 0), (i = (s = this.context).onOpenChange) == null || i.call(s, n, r), r.isCanceled)
        return;
      this.state.floatingRootContext.dispatchOpenChange(n, r);
      const o = {
        open: n
      };
      gu(o, n, r.trigger), this.update(o);
    });
  }
}
function ZP(e, t, n, r = !1) {
  const o = {
    ...xu(),
    modal: !0,
    disablePointerDismissal: !1,
    viewportElement: null,
    descriptionElementId: void 0,
    titleElementId: void 0,
    openMethod: null,
    nested: !1,
    nestedOpenDialogCount: 0,
    nestedOpenDrawerCount: 0,
    role: "dialog",
    ...e
  };
  return o.floatingRootContext = ip(t, n, r), o;
}
function QP(e) {
  return {
    popupRef: /* @__PURE__ */ b.createRef(),
    backdropRef: /* @__PURE__ */ b.createRef(),
    internalBackdropRef: /* @__PURE__ */ b.createRef(),
    outsidePressEnabledRef: {
      current: !0
    },
    triggerElements: e,
    onOpenChange: void 0,
    onOpenChangeComplete: void 0
  };
}
function JP(e, t) {
  const {
    children: n,
    open: r,
    defaultOpen: o = !1,
    onOpenChange: s,
    onOpenChangeComplete: i,
    disablePointerDismissal: a = !1,
    modal: l = !0,
    actionsRef: c,
    handle: u,
    triggerId: d,
    defaultTriggerId: f = null
  } = t, h = e === "drawer", p = e === "alert-dialog", g = p ? !0 : l, m = p || a, v = p ? "alertdialog" : "dialog", y = uo(!0), x = y != null, C = {
    modal: g,
    disablePointerDismissal: m,
    nested: x,
    role: v
  }, w = op((P, I) => new XP({
    open: o,
    openProp: r,
    activeTriggerId: f,
    triggerIdProp: d,
    ...C
  }, P, I), !0);
  w.useControlledProp("openProp", r), w.useControlledProp("triggerIdProp", d), w.useSyncedValues(C), w.useContextCallback("onOpenChange", s), w.useContextCallback("onOpenChangeComplete", i);
  const E = w.useState("open"), S = w.useState("mounted"), O = w.useState("payload");
  W1(w, E), bu(w);
  const {
    forceUnmount: M
  } = vu(E, w);
  b.useImperativeHandle(c, () => ({
    unmount: M,
    close: () => w.setOpen(!1, Ne(au))
  }), [M, w]);
  const T = E || S;
  return /* @__PURE__ */ ee(gp.Provider, {
    value: w,
    children: [u && /* @__PURE__ */ _(pu, {
      handle: u,
      store: w
    }), T && /* @__PURE__ */ _(KP, {
      store: w,
      parentContext: y == null ? void 0 : y.context,
      isDrawer: h
    }), typeof n == "function" ? n({
      payload: O
    }) : n]
  });
}
function ax(e) {
  return JP("dialog", e);
}
const Cp = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    children: i,
    ...a
  } = t, l = ox(), c = uo(), u = c.useState("open"), d = c.useState("nested"), f = c.useState("transitionStatus"), h = c.useState("nestedOpenDialogCount"), p = c.useState("mounted"), g = c.useStateSetter("viewportElement"), m = h > 0;
  return We("div", t, {
    enabled: l || p,
    state: {
      open: u,
      nested: d,
      transitionStatus: f,
      nestedDialogOpen: m
    },
    ref: [n, g],
    stateAttributesMapping: sx,
    props: [{
      role: "presentation",
      hidden: !p,
      style: {
        pointerEvents: u ? void 0 : "none"
      },
      children: i
    }, a]
  });
});
process.env.NODE_ENV !== "production" && (Cp.displayName = "DialogViewport");
const Ep = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    id: i,
    ...a
  } = t, l = uo(), c = gn(i);
  return l.useSyncedValueWithCleanup("titleElementId", c), We("h2", t, {
    ref: n,
    props: [{
      id: c
    }, a]
  });
});
process.env.NODE_ENV !== "production" && (Ep.displayName = "DialogTitle");
function eI(e) {
  const t = b.useRef(""), n = b.useCallback((o) => {
    o.defaultPrevented || (t.current = o.pointerType, e(o, o.pointerType));
  }, [e]);
  return {
    onClick: b.useCallback((o) => {
      if (o.detail === 0) {
        e(o, "keyboard");
        return;
      }
      "pointerType" in o ? e(o, o.pointerType) : e(o, t.current), t.current = "";
    }, [e]),
    onPointerDown: n
  };
}
function Ls(e, t) {
  const n = b.useRef(e), r = ye(t);
  pe(() => {
    n.current !== e && r(n.current), n.current = e;
  }, [e, r]);
}
function _p(e, t) {
  const n = ye((s, i) => {
    (typeof e == "function" ? e() : e) || t(i || // On iOS Safari, the hitslop around touch targets means tapping outside an element's
    // bounds does not fire `pointerdown` but does fire `mousedown`. The `interactionType`
    // will be "" in that case.
    (Ma ? "touch" : ""));
  }), {
    onClick: r,
    onPointerDown: o
  } = eI(n);
  return b.useMemo(() => ({
    onClick: r,
    onPointerDown: o
  }), [r, o]);
}
function lx(e) {
  const [t, n] = b.useState(null), r = _p(e, n);
  return Ls(e, (o) => {
    o && !e && n(null);
  }), b.useMemo(() => ({
    openMethod: t,
    triggerProps: r
  }), [t, r]);
}
const Sp = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    disabled: i = !1,
    nativeButton: a = !0,
    id: l,
    payload: c,
    handle: u,
    ...d
  } = t, f = uo(!0), p = Cu(u) ?? f;
  if (!p)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Trigger> must be used within <Dialog.Root> or provided with a handle." : tt(79));
  const g = gn(l), m = p.useState("floatingRootContext"), v = p.useState("isOpenedByTrigger", g), y = p.useState("triggerPopupId", g), x = b.useRef(null), {
    registerTrigger: C,
    isMountedByThisTrigger: w
  } = mu(g, x, p, {
    payload: c
  }), {
    getButtonProps: E,
    buttonRef: S
  } = Wn({
    disabled: i,
    native: a
  }), O = li(m), M = _p(() => p.select("open"), (I) => {
    p.set("openMethod", I);
  }), T = {
    disabled: i,
    open: v
  }, P = p.useState("triggerProps", w);
  return We("button", t, {
    state: T,
    ref: [S, n, C, x],
    props: [O.reference, P, M, {
      [qh]: "",
      id: g,
      "aria-haspopup": "dialog",
      "aria-expanded": v,
      "aria-controls": y
    }, d, E],
    stateAttributesMapping: Ou
  });
});
process.env.NODE_ENV !== "production" && (Sp.displayName = "DialogTrigger");
const tI = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Calendar/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2Z"
})), nI = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "CheckCircle/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m9 12 2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), ys = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Check/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m5 13 4 4L19 7"
})), Rb = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronDown/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m19 9-7 7-7-7"
})), rI = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronLeft/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m15 19-7-7 7-7"
})), Op = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronRight/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m9 5 7 7-7 7"
})), cx = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Copy/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M6.667 13.333H5c-.92 0-1.667-.746-1.667-1.666V5c0-.92.746-1.667 1.667-1.667h6.667c.92 0 1.666.746 1.666 1.667v1.667m-5 10H15c.92 0 1.667-.747 1.667-1.667V8.333c0-.92-.747-1.666-1.667-1.666H8.333c-.92 0-1.666.746-1.666 1.666V15c0 .92.746 1.667 1.666 1.667Z"
})), oI = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "DotsHorizontal/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
})), kd = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ExclamationCircle/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12 8v4m0 4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), sI = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Exclamation/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3Z"
})), iI = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ExternalLink/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M10 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4M14 4h6m0 0v6m0-6L10 14"
})), Pb = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "EyeOff/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m3 3 3.59 3.59M21 21l-3.589-3.589m-3.536 1.414A10.05 10.05 0 0 1 12 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 0 1 1.563-3.029m5.858.908a3 3 0 1 1 4.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532L6.59 6.59m7.532 7.532 3.29 3.29M6.59 6.59A9.953 9.953 0 0 1 12 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 0 1-4.132 5.411"
})), Ib = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Eye/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
}), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M2.458 12C3.733 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.543 7-1.275 4.057-5.065 7-9.542 7-4.478 0-8.268-2.943-9.543-7Z"
})), kb = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "FolderDownload/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12 10v6m0 0-3-3m3 3 3-3M3 17V7a2 2 0 0 1 2-2h6l2 2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"
})), Mp = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "InformationCircle/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), aI = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "QuestionMarkCircle/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), lI = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Refresh/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M4 4v5h.582m15.356 2A8.001 8.001 0 0 0 4.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 0 1-15.357-2m15.357 2H15"
})), cI = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Search/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
})), Tp = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "XCircle/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m10 14 2-2m0 0 2-2m-2 2-2-2m2 2 2 2m7-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), Du = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "X/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M6 18 18 6M6 6l12 12"
}));
function uI(e) {
  return /* @__PURE__ */ _(ax, { ...e });
}
function ux(e) {
  return /* @__PURE__ */ _(wp, { ...e });
}
function dI(e) {
  return /* @__PURE__ */ _(Sp, { "data-slot": "dialog-trigger", ...e });
}
function fI({ className: e, ...t }) {
  return /* @__PURE__ */ ee(
    Pu,
    {
      "data-slot": "dialog-close",
      className: de("shrink-0", e),
      ...t,
      children: [
        /* @__PURE__ */ _(Du, { className: "h-5 w-5 text-foundations-subtler" }),
        /* @__PURE__ */ _("span", { className: "sr-only", children: "Close" })
      ]
    }
  );
}
function dx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ _(
    mp,
    {
      className: de(
        "fixed inset-0 z-50 bg-[rgba(0,0,0,0.5)] transition-opacity duration-300",
        "data-[ending-style]:opacity-0 data-[starting-style]:opacity-0",
        "data-[ending-style]:ease-in data-[starting-style]:ease-out",
        e
      ),
      "data-slot": "dialog-backdrop",
      ...t
    }
  );
}
function fx({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ _(
    Cp,
    {
      className: de(
        "fixed inset-0 z-50 grid grid-rows-[1fr_auto_1fr] justify-items-center p-4",
        e
      ),
      "data-slot": "dialog-viewport",
      ...t
    }
  );
}
function hI({
  className: e,
  children: t,
  backdropClassName: n,
  showCloseButton: r = !1,
  ...o
}) {
  return /* @__PURE__ */ ee(ux, { children: [
    /* @__PURE__ */ _(dx, { className: n }),
    /* @__PURE__ */ _(fx, { children: /* @__PURE__ */ ee(
      xp,
      {
        className: de(
          "relative row-start-2 flex max-h-full min-h-0 w-full min-w-0 flex-col rounded-lg border border-foundations-subtle bg-foundations-default bg-clip-padding shadow-xl transition-all duration-300 ease-in-out will-change-transform",
          "opacity-[calc(1-0.1*var(--nested-dialogs))] data-[nested-dialog-open]:origin-top",
          "before:pointer-events-none before:absolute before:inset-0 before:rounded-[calc(var(--radius-lg)-1px)] before:shadow-[0_1px_--theme(--color-black/4%)]",
          "data-[ending-style]:opacity-0 data-[starting-style]:opacity-0",
          "max-sm:opacity-[calc(1-min(var(--nested-dialogs),1))] max-sm:before:hidden max-sm:data-[ending-style]:translate-y-4 max-sm:data-[starting-style]:translate-y-4",
          "sm:my-8 sm:w-full sm:max-w-lg sm:-translate-y-[calc(1.25rem*var(--nested-dialogs))] sm:scale-[calc(1-0.1*var(--nested-dialogs))] sm:data-[nested]:data-[ending-style]:translate-y-8 sm:data-[nested]:data-[starting-style]:translate-y-8",
          "sm:data-[ending-style]:scale-95 sm:data-[starting-style]:scale-95",
          e
        ),
        "data-slot": "dialog-popup",
        ...o,
        children: [
          t,
          r && /* @__PURE__ */ ee(Pu, { className: "opacity-72 pointer-coarse:after:absolute pointer-coarse:after:size-full pointer-coarse:after:min-h-11 pointer-coarse:after:min-w-11 focus-visible:ring-ring focus-visible:ring-offset-background absolute end-2 top-2 inline-flex shrink-0 cursor-pointer items-center justify-center rounded-md border border-transparent outline-none transition-[color,background-color,box-shadow,opacity] size-7 hover:opacity-100 focus-visible:ring-2 focus-visible:ring-offset-1 [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0", children: [
            /* @__PURE__ */ _(Du, {}),
            /* @__PURE__ */ _("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    ) })
  ] });
}
function pI({ className: e, ...t }) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: de(
        "in-[[data-slot=dialog-popup]:has([data-slot=dialog-panel])]:pb-3 flex items-center justify-between gap-2 p-6 pb-4 max-sm:pb-4",
        e
      ),
      "data-slot": "dialog-header",
      ...t
    }
  );
}
function gI({
  className: e,
  variant: t = "default",
  ...n
}) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: de(
        "flex flex-col gap-2 sm:flex-row-reverse",
        t === "default" && "border-t border-t-foundations-subtle px-12 py-4",
        t === "bare" && "border-t-0 p-0",
        e
      ),
      "data-slot": "dialog-footer",
      ...n
    }
  );
}
function mI({
  className: e,
  render: t,
  ref: n,
  ...r
}) {
  return /* @__PURE__ */ _(
    Ep,
    {
      ref: n,
      render: t || /* @__PURE__ */ _("h3", {}),
      className: de(
        "text-lg font-medium leading-6 text-foundations-boldest",
        e
      ),
      "data-slot": "dialog-title",
      ...r
    }
  );
}
function bI({
  className: e,
  ref: t,
  ...n
}) {
  return /* @__PURE__ */ _(
    vp,
    {
      ref: t,
      className: de("text-sm text-foundations-subtle", e),
      "data-slot": "dialog-description",
      ...n
    }
  );
}
function vI({ className: e, ...t }) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: de("px-6 py-4", e),
      "data-slot": "dialog-panel",
      ...t
    }
  );
}
const QH = Object.assign(uI, {
  Trigger: dI,
  Portal: ux,
  Close: fI,
  Backdrop: dx,
  Popup: hI,
  Header: pI,
  Footer: gI,
  Title: mI,
  Description: bI,
  Panel: vI,
  Viewport: fx
});
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function Wa(e) {
  return e + 0.5 | 0;
}
const wo = (e, t, n) => Math.max(Math.min(e, n), t);
function Wi(e) {
  return wo(Wa(e * 2.55), 0, 255);
}
function Oo(e) {
  return wo(Wa(e * 255), 0, 255);
}
function Gr(e) {
  return wo(Wa(e / 2.55) / 100, 0, 1);
}
function Db(e) {
  return wo(Wa(e * 100), 0, 100);
}
const nr = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, jf = [..."0123456789ABCDEF"], yI = (e) => jf[e & 15], xI = (e) => jf[(e & 240) >> 4] + jf[e & 15], gl = (e) => (e & 240) >> 4 === (e & 15), wI = (e) => gl(e.r) && gl(e.g) && gl(e.b) && gl(e.a);
function CI(e) {
  var t = e.length, n;
  return e[0] === "#" && (t === 4 || t === 5 ? n = {
    r: 255 & nr[e[1]] * 17,
    g: 255 & nr[e[2]] * 17,
    b: 255 & nr[e[3]] * 17,
    a: t === 5 ? nr[e[4]] * 17 : 255
  } : (t === 7 || t === 9) && (n = {
    r: nr[e[1]] << 4 | nr[e[2]],
    g: nr[e[3]] << 4 | nr[e[4]],
    b: nr[e[5]] << 4 | nr[e[6]],
    a: t === 9 ? nr[e[7]] << 4 | nr[e[8]] : 255
  })), n;
}
const EI = (e, t) => e < 255 ? t(e) : "";
function _I(e) {
  var t = wI(e) ? yI : xI;
  return e ? "#" + t(e.r) + t(e.g) + t(e.b) + EI(e.a, t) : void 0;
}
const SI = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hx(e, t, n) {
  const r = t * Math.min(n, 1 - n), o = (s, i = (s + e / 30) % 12) => n - r * Math.max(Math.min(i - 3, 9 - i, 1), -1);
  return [o(0), o(8), o(4)];
}
function OI(e, t, n) {
  const r = (o, s = (o + e / 60) % 6) => n - n * t * Math.max(Math.min(s, 4 - s, 1), 0);
  return [r(5), r(3), r(1)];
}
function MI(e, t, n) {
  const r = hx(e, 1, 0.5);
  let o;
  for (t + n > 1 && (o = 1 / (t + n), t *= o, n *= o), o = 0; o < 3; o++)
    r[o] *= 1 - t - n, r[o] += t;
  return r;
}
function TI(e, t, n, r, o) {
  return e === o ? (t - n) / r + (t < n ? 6 : 0) : t === o ? (n - e) / r + 2 : (e - t) / r + 4;
}
function Rp(e) {
  const n = e.r / 255, r = e.g / 255, o = e.b / 255, s = Math.max(n, r, o), i = Math.min(n, r, o), a = (s + i) / 2;
  let l, c, u;
  return s !== i && (u = s - i, c = a > 0.5 ? u / (2 - s - i) : u / (s + i), l = TI(n, r, o, u, s), l = l * 60 + 0.5), [l | 0, c || 0, a];
}
function Pp(e, t, n, r) {
  return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, r)).map(Oo);
}
function Ip(e, t, n) {
  return Pp(hx, e, t, n);
}
function RI(e, t, n) {
  return Pp(MI, e, t, n);
}
function PI(e, t, n) {
  return Pp(OI, e, t, n);
}
function px(e) {
  return (e % 360 + 360) % 360;
}
function II(e) {
  const t = SI.exec(e);
  let n = 255, r;
  if (!t)
    return;
  t[5] !== r && (n = t[6] ? Wi(+t[5]) : Oo(+t[5]));
  const o = px(+t[2]), s = +t[3] / 100, i = +t[4] / 100;
  return t[1] === "hwb" ? r = RI(o, s, i) : t[1] === "hsv" ? r = PI(o, s, i) : r = Ip(o, s, i), {
    r: r[0],
    g: r[1],
    b: r[2],
    a: n
  };
}
function kI(e, t) {
  var n = Rp(e);
  n[0] = px(n[0] + t), n = Ip(n), e.r = n[0], e.g = n[1], e.b = n[2];
}
function DI(e) {
  if (!e)
    return;
  const t = Rp(e), n = t[0], r = Db(t[1]), o = Db(t[2]);
  return e.a < 255 ? `hsla(${n}, ${r}%, ${o}%, ${Gr(e.a)})` : `hsl(${n}, ${r}%, ${o}%)`;
}
const Nb = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, Ab = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function NI() {
  const e = {}, t = Object.keys(Ab), n = Object.keys(Nb);
  let r, o, s, i, a;
  for (r = 0; r < t.length; r++) {
    for (i = a = t[r], o = 0; o < n.length; o++)
      s = n[o], a = a.replace(s, Nb[s]);
    s = parseInt(Ab[i], 16), e[a] = [s >> 16 & 255, s >> 8 & 255, s & 255];
  }
  return e;
}
let ml;
function AI(e) {
  ml || (ml = NI(), ml.transparent = [0, 0, 0, 0]);
  const t = ml[e.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const $I = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function FI(e) {
  const t = $I.exec(e);
  let n = 255, r, o, s;
  if (t) {
    if (t[7] !== r) {
      const i = +t[7];
      n = t[8] ? Wi(i) : wo(i * 255, 0, 255);
    }
    return r = +t[1], o = +t[3], s = +t[5], r = 255 & (t[2] ? Wi(r) : wo(r, 0, 255)), o = 255 & (t[4] ? Wi(o) : wo(o, 0, 255)), s = 255 & (t[6] ? Wi(s) : wo(s, 0, 255)), {
      r,
      g: o,
      b: s,
      a: n
    };
  }
}
function LI(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${Gr(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
const Dd = (e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, Ms = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function VI(e, t, n) {
  const r = Ms(Gr(e.r)), o = Ms(Gr(e.g)), s = Ms(Gr(e.b));
  return {
    r: Oo(Dd(r + n * (Ms(Gr(t.r)) - r))),
    g: Oo(Dd(o + n * (Ms(Gr(t.g)) - o))),
    b: Oo(Dd(s + n * (Ms(Gr(t.b)) - s))),
    a: e.a + n * (t.a - e.a)
  };
}
function bl(e, t, n) {
  if (e) {
    let r = Rp(e);
    r[t] = Math.max(0, Math.min(r[t] + r[t] * n, t === 0 ? 360 : 1)), r = Ip(r), e.r = r[0], e.g = r[1], e.b = r[2];
  }
}
function gx(e, t) {
  return e && Object.assign(t || {}, e);
}
function $b(e) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (t = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (t.a = Oo(e[3]))) : (t = gx(e, { r: 0, g: 0, b: 0, a: 1 }), t.a = Oo(t.a)), t;
}
function WI(e) {
  return e.charAt(0) === "r" ? FI(e) : II(e);
}
class fa {
  constructor(t) {
    if (t instanceof fa)
      return t;
    const n = typeof t;
    let r;
    n === "object" ? r = $b(t) : n === "string" && (r = CI(t) || AI(t) || WI(t)), this._rgb = r, this._valid = !!r;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = gx(this._rgb);
    return t && (t.a = Gr(t.a)), t;
  }
  set rgb(t) {
    this._rgb = $b(t);
  }
  rgbString() {
    return this._valid ? LI(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? _I(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? DI(this._rgb) : void 0;
  }
  mix(t, n) {
    if (t) {
      const r = this.rgb, o = t.rgb;
      let s;
      const i = n === s ? 0.5 : n, a = 2 * i - 1, l = r.a - o.a, c = ((a * l === -1 ? a : (a + l) / (1 + a * l)) + 1) / 2;
      s = 1 - c, r.r = 255 & c * r.r + s * o.r + 0.5, r.g = 255 & c * r.g + s * o.g + 0.5, r.b = 255 & c * r.b + s * o.b + 0.5, r.a = i * r.a + (1 - i) * o.a, this.rgb = r;
    }
    return this;
  }
  interpolate(t, n) {
    return t && (this._rgb = VI(this._rgb, t._rgb, n)), this;
  }
  clone() {
    return new fa(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = Oo(t), this;
  }
  clearer(t) {
    const n = this._rgb;
    return n.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, n = Wa(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = n, this;
  }
  opaquer(t) {
    const n = this._rgb;
    return n.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return bl(this._rgb, 2, t), this;
  }
  darken(t) {
    return bl(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return bl(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return bl(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return kI(this._rgb, t), this;
  }
}
/*!
 * Chart.js v4.3.3
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
function zr() {
}
const HI = (() => {
  let e = 0;
  return () => e++;
})();
function St(e) {
  return e === null || typeof e > "u";
}
function Xt(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function ht(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function En(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function Bn(e, t) {
  return En(e) ? e : t;
}
function mt(e, t) {
  return typeof e > "u" ? t : e;
}
const BI = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : +e / t, mx = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function nn(e, t, n) {
  if (e && typeof e.call == "function")
    return e.apply(n, t);
}
function _t(e, t, n, r) {
  let o, s, i;
  if (Xt(e))
    if (s = e.length, r)
      for (o = s - 1; o >= 0; o--)
        t.call(n, e[o], o);
    else
      for (o = 0; o < s; o++)
        t.call(n, e[o], o);
  else if (ht(e))
    for (i = Object.keys(e), s = i.length, o = 0; o < s; o++)
      t.call(n, e[i[o]], i[o]);
}
function Cc(e, t) {
  let n, r, o, s;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (n = 0, r = e.length; n < r; ++n)
    if (o = e[n], s = t[n], o.datasetIndex !== s.datasetIndex || o.index !== s.index)
      return !1;
  return !0;
}
function Ec(e) {
  if (Xt(e))
    return e.map(Ec);
  if (ht(e)) {
    const t = /* @__PURE__ */ Object.create(null), n = Object.keys(e), r = n.length;
    let o = 0;
    for (; o < r; ++o)
      t[n[o]] = Ec(e[n[o]]);
    return t;
  }
  return e;
}
function bx(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
function zI(e, t, n, r) {
  if (!bx(e))
    return;
  const o = t[e], s = n[e];
  ht(o) && ht(s) ? ha(o, s, r) : t[e] = Ec(s);
}
function ha(e, t, n) {
  const r = Xt(t) ? t : [
    t
  ], o = r.length;
  if (!ht(e))
    return e;
  n = n || {};
  const s = n.merger || zI;
  let i;
  for (let a = 0; a < o; ++a) {
    if (i = r[a], !ht(i))
      continue;
    const l = Object.keys(i);
    for (let c = 0, u = l.length; c < u; ++c)
      s(l[c], e, i, n);
  }
  return e;
}
function Qi(e, t) {
  return ha(e, t, {
    merger: YI
  });
}
function YI(e, t, n) {
  if (!bx(e))
    return;
  const r = t[e], o = n[e];
  ht(r) && ht(o) ? Qi(r, o) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = Ec(o));
}
const Fb = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: (e) => e.x,
  y: (e) => e.y
};
function jI(e) {
  const t = e.split("."), n = [];
  let r = "";
  for (const o of t)
    r += o, r.endsWith("\\") ? r = r.slice(0, -1) + "." : (n.push(r), r = "");
  return n;
}
function UI(e) {
  const t = jI(e);
  return (n) => {
    for (const r of t) {
      if (r === "")
        break;
      n = n && n[r];
    }
    return n;
  };
}
function fs(e, t) {
  return (Fb[t] || (Fb[t] = UI(t)))(e);
}
function kp(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const pa = (e) => typeof e < "u", Do = (e) => typeof e == "function", Lb = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
};
function GI(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const dn = Math.PI, Ut = 2 * dn, KI = Ut + dn, _c = Number.POSITIVE_INFINITY, qI = dn / 180, on = dn / 2, Ko = dn / 4, Vb = dn * 2 / 3, Co = Math.log10, $r = Math.sign;
function Ji(e, t, n) {
  return Math.abs(e - t) < n;
}
function Wb(e) {
  const t = Math.round(e);
  e = Ji(e, t, e / 1e3) ? t : e;
  const n = Math.pow(10, Math.floor(Co(e))), r = e / n;
  return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10) * n;
}
function XI(e) {
  const t = [], n = Math.sqrt(e);
  let r;
  for (r = 1; r < n; r++)
    e % r === 0 && (t.push(r), t.push(e / r));
  return n === (n | 0) && t.push(n), t.sort((o, s) => o - s).pop(), t;
}
function ga(e) {
  return !isNaN(parseFloat(e)) && isFinite(e);
}
function ZI(e, t) {
  const n = Math.round(e);
  return n - t <= e && n + t >= e;
}
function vx(e, t, n) {
  let r, o, s;
  for (r = 0, o = e.length; r < o; r++)
    s = e[r][n], isNaN(s) || (t.min = Math.min(t.min, s), t.max = Math.max(t.max, s));
}
function kr(e) {
  return e * (dn / 180);
}
function Dp(e) {
  return e * (180 / dn);
}
function Hb(e) {
  if (!En(e))
    return;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n++;
  return n;
}
function yx(e, t) {
  const n = t.x - e.x, r = t.y - e.y, o = Math.sqrt(n * n + r * r);
  let s = Math.atan2(r, n);
  return s < -0.5 * dn && (s += Ut), {
    angle: s,
    distance: o
  };
}
function Uf(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function QI(e, t) {
  return (e - t + KI) % Ut - dn;
}
function pr(e) {
  return (e % Ut + Ut) % Ut;
}
function ma(e, t, n, r) {
  const o = pr(e), s = pr(t), i = pr(n), a = pr(s - o), l = pr(i - o), c = pr(o - s), u = pr(o - i);
  return o === s || o === i || r && s === i || a > l && c < u;
}
function kn(e, t, n) {
  return Math.max(t, Math.min(n, e));
}
function JI(e) {
  return kn(e, -32768, 32767);
}
function Sc(e, t, n, r = 1e-6) {
  return e >= Math.min(t, n) - r && e <= Math.max(t, n) + r;
}
function Np(e, t, n) {
  n = n || ((i) => e[i] < t);
  let r = e.length - 1, o = 0, s;
  for (; r - o > 1; )
    s = o + r >> 1, n(s) ? o = s : r = s;
  return {
    lo: o,
    hi: r
  };
}
const ss = (e, t, n, r) => Np(e, n, r ? (o) => {
  const s = e[o][t];
  return s < n || s === n && e[o + 1][t] === n;
} : (o) => e[o][t] < n), ek = (e, t, n) => Np(e, n, (r) => e[r][t] >= n);
function tk(e, t, n) {
  let r = 0, o = e.length;
  for (; r < o && e[r] < t; )
    r++;
  for (; o > r && e[o - 1] > n; )
    o--;
  return r > 0 || o < e.length ? e.slice(r, o) : e;
}
const xx = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function nk(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), xx.forEach((n) => {
    const r = "_onData" + kp(n), o = e[n];
    Object.defineProperty(e, n, {
      configurable: !0,
      enumerable: !1,
      value(...s) {
        const i = o.apply(this, s);
        return e._chartjs.listeners.forEach((a) => {
          typeof a[r] == "function" && a[r](...s);
        }), i;
      }
    });
  });
}
function Bb(e, t) {
  const n = e._chartjs;
  if (!n)
    return;
  const r = n.listeners, o = r.indexOf(t);
  o !== -1 && r.splice(o, 1), !(r.length > 0) && (xx.forEach((s) => {
    delete e[s];
  }), delete e._chartjs);
}
function wx(e) {
  const t = new Set(e);
  return t.size === e.length ? e : Array.from(t);
}
const Cx = function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
}();
function Ex(e, t) {
  let n = [], r = !1;
  return function(...o) {
    n = o, r || (r = !0, Cx.call(window, () => {
      r = !1, e.apply(t, n);
    }));
  };
}
function rk(e, t) {
  let n;
  return function(...r) {
    return t ? (clearTimeout(n), n = setTimeout(e, t, r)) : e.apply(this, r), t;
  };
}
const ok = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", zb = (e, t, n) => e === "start" ? t : e === "end" ? n : (t + n) / 2;
function sk(e, t, n) {
  const r = t.length;
  let o = 0, s = r;
  if (e._sorted) {
    const { iScale: i, _parsed: a } = e, l = i.axis, { min: c, max: u, minDefined: d, maxDefined: f } = i.getUserBounds();
    d && (o = kn(Math.min(
      // @ts-expect-error Need to type _parsed
      ss(a, l, c).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? r : ss(t, l, i.getPixelForValue(c)).lo
    ), 0, r - 1)), f ? s = kn(Math.max(
      // @ts-expect-error Need to type _parsed
      ss(a, i.axis, u, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? 0 : ss(t, l, i.getPixelForValue(u), !0).hi + 1
    ), o, r) - o : s = r - o;
  }
  return {
    start: o,
    count: s
  };
}
function ik(e) {
  const { xScale: t, yScale: n, _scaleRanges: r } = e, o = {
    xmin: t.min,
    xmax: t.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!r)
    return e._scaleRanges = o, !0;
  const s = r.xmin !== t.min || r.xmax !== t.max || r.ymin !== n.min || r.ymax !== n.max;
  return Object.assign(r, o), s;
}
const vl = (e) => e === 0 || e === 1, Yb = (e, t, n) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * Ut / n)), jb = (e, t, n) => Math.pow(2, -10 * e) * Math.sin((e - t) * Ut / n) + 1, ea = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * on) + 1,
  easeOutSine: (e) => Math.sin(e * on),
  easeInOutSine: (e) => -0.5 * (Math.cos(dn * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => vl(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => vl(e) ? e : Yb(e, 0.075, 0.3),
  easeOutElastic: (e) => vl(e) ? e : jb(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return vl(e) ? e : e < 0.5 ? 0.5 * Yb(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * jb(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - ea.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? ea.easeInBounce(e * 2) * 0.5 : ea.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
function Ap(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function Ub(e) {
  return Ap(e) ? e : new fa(e);
}
function Nd(e) {
  return Ap(e) ? e : new fa(e).saturate(0.5).darken(0.1).hexString();
}
const ak = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], lk = [
  "color",
  "borderColor",
  "backgroundColor"
];
function ck(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: lk
    },
    numbers: {
      type: "number",
      properties: ak
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function uk(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const Gb = /* @__PURE__ */ new Map();
function dk(e, t) {
  t = t || {};
  const n = e + JSON.stringify(t);
  let r = Gb.get(n);
  return r || (r = new Intl.NumberFormat(e, t), Gb.set(n, r)), r;
}
function Nu(e, t, n) {
  return dk(t, n).format(e);
}
const _x = {
  values(e) {
    return Xt(e) ? e : "" + e;
  },
  numeric(e, t, n) {
    if (e === 0)
      return "0";
    const r = this.chart.options.locale;
    let o, s = e;
    if (n.length > 1) {
      const c = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (c < 1e-4 || c > 1e15) && (o = "scientific"), s = fk(e, n);
    }
    const i = Co(Math.abs(s)), a = isNaN(i) ? 1 : Math.max(Math.min(-1 * Math.floor(i), 20), 0), l = {
      notation: o,
      minimumFractionDigits: a,
      maximumFractionDigits: a
    };
    return Object.assign(l, this.options.ticks.format), Nu(e, r, l);
  },
  logarithmic(e, t, n) {
    if (e === 0)
      return "0";
    const r = n[t].significand || e / Math.pow(10, Math.floor(Co(e)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(r) || t > 0.8 * n.length ? _x.numeric.call(this, e, t, n) : "";
  }
};
function fk(e, t) {
  let n = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(n) >= 1 && e !== Math.floor(e) && (n = e - Math.floor(e)), n;
}
var Au = {
  formatters: _x
};
function hk(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, n) => n.lineWidth,
      tickColor: (t, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Au.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const hs = /* @__PURE__ */ Object.create(null), Gf = /* @__PURE__ */ Object.create(null);
function ta(e, t) {
  if (!t)
    return e;
  const n = t.split(".");
  for (let r = 0, o = n.length; r < o; ++r) {
    const s = n[r];
    e = e[s] || (e[s] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function Ad(e, t, n) {
  return typeof t == "string" ? ha(ta(e, t), n) : ha(ta(e, ""), t);
}
class pk {
  constructor(t, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (r) => r.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (r, o) => Nd(o.backgroundColor), this.hoverBorderColor = (r, o) => Nd(o.borderColor), this.hoverColor = (r, o) => Nd(o.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(n);
  }
  set(t, n) {
    return Ad(this, t, n);
  }
  get(t) {
    return ta(this, t);
  }
  describe(t, n) {
    return Ad(Gf, t, n);
  }
  override(t, n) {
    return Ad(hs, t, n);
  }
  route(t, n, r, o) {
    const s = ta(this, t), i = ta(this, r), a = "_" + n;
    Object.defineProperties(s, {
      [a]: {
        value: s[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const l = this[a], c = i[o];
          return ht(l) ? Object.assign({}, c, l) : mt(l, c);
        },
        set(l) {
          this[a] = l;
        }
      }
    });
  }
  apply(t) {
    t.forEach((n) => n(this));
  }
}
var ln = /* @__PURE__ */ new pk({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  ck,
  uk,
  hk
]);
function gk(e) {
  return !e || St(e.size) || St(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function Oc(e, t, n, r, o) {
  let s = t[o];
  return s || (s = t[o] = e.measureText(o).width, n.push(o)), s > r && (r = s), r;
}
function mk(e, t, n, r) {
  r = r || {};
  let o = r.data = r.data || {}, s = r.garbageCollect = r.garbageCollect || [];
  r.font !== t && (o = r.data = {}, s = r.garbageCollect = [], r.font = t), e.save(), e.font = t;
  let i = 0;
  const a = n.length;
  let l, c, u, d, f;
  for (l = 0; l < a; l++)
    if (d = n[l], d != null && !Xt(d))
      i = Oc(e, o, s, i, d);
    else if (Xt(d))
      for (c = 0, u = d.length; c < u; c++)
        f = d[c], f != null && !Xt(f) && (i = Oc(e, o, s, i, f));
  e.restore();
  const h = s.length / 2;
  if (h > n.length) {
    for (l = 0; l < h; l++)
      delete o[s[l]];
    s.splice(0, h);
  }
  return i;
}
function qo(e, t, n) {
  const r = e.currentDevicePixelRatio, o = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((t - o) * r) / r + o;
}
function Kb(e, t) {
  t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore();
}
function Kf(e, t, n, r) {
  bk(e, t, n, r, null);
}
function bk(e, t, n, r, o) {
  let s, i, a, l, c, u, d, f;
  const h = t.pointStyle, p = t.rotation, g = t.radius;
  let m = (p || 0) * qI;
  if (h && typeof h == "object" && (s = h.toString(), s === "[object HTMLImageElement]" || s === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(n, r), e.rotate(m), e.drawImage(h, -h.width / 2, -h.height / 2, h.width, h.height), e.restore();
    return;
  }
  if (!(isNaN(g) || g <= 0)) {
    switch (e.beginPath(), h) {
      default:
        o ? e.ellipse(n, r, o / 2, g, 0, 0, Ut) : e.arc(n, r, g, 0, Ut), e.closePath();
        break;
      case "triangle":
        u = o ? o / 2 : g, e.moveTo(n + Math.sin(m) * u, r - Math.cos(m) * g), m += Vb, e.lineTo(n + Math.sin(m) * u, r - Math.cos(m) * g), m += Vb, e.lineTo(n + Math.sin(m) * u, r - Math.cos(m) * g), e.closePath();
        break;
      case "rectRounded":
        c = g * 0.516, l = g - c, i = Math.cos(m + Ko) * l, d = Math.cos(m + Ko) * (o ? o / 2 - c : l), a = Math.sin(m + Ko) * l, f = Math.sin(m + Ko) * (o ? o / 2 - c : l), e.arc(n - d, r - a, c, m - dn, m - on), e.arc(n + f, r - i, c, m - on, m), e.arc(n + d, r + a, c, m, m + on), e.arc(n - f, r + i, c, m + on, m + dn), e.closePath();
        break;
      case "rect":
        if (!p) {
          l = Math.SQRT1_2 * g, u = o ? o / 2 : l, e.rect(n - u, r - l, 2 * u, 2 * l);
          break;
        }
        m += Ko;
      case "rectRot":
        d = Math.cos(m) * (o ? o / 2 : g), i = Math.cos(m) * g, a = Math.sin(m) * g, f = Math.sin(m) * (o ? o / 2 : g), e.moveTo(n - d, r - a), e.lineTo(n + f, r - i), e.lineTo(n + d, r + a), e.lineTo(n - f, r + i), e.closePath();
        break;
      case "crossRot":
        m += Ko;
      case "cross":
        d = Math.cos(m) * (o ? o / 2 : g), i = Math.cos(m) * g, a = Math.sin(m) * g, f = Math.sin(m) * (o ? o / 2 : g), e.moveTo(n - d, r - a), e.lineTo(n + d, r + a), e.moveTo(n + f, r - i), e.lineTo(n - f, r + i);
        break;
      case "star":
        d = Math.cos(m) * (o ? o / 2 : g), i = Math.cos(m) * g, a = Math.sin(m) * g, f = Math.sin(m) * (o ? o / 2 : g), e.moveTo(n - d, r - a), e.lineTo(n + d, r + a), e.moveTo(n + f, r - i), e.lineTo(n - f, r + i), m += Ko, d = Math.cos(m) * (o ? o / 2 : g), i = Math.cos(m) * g, a = Math.sin(m) * g, f = Math.sin(m) * (o ? o / 2 : g), e.moveTo(n - d, r - a), e.lineTo(n + d, r + a), e.moveTo(n + f, r - i), e.lineTo(n - f, r + i);
        break;
      case "line":
        i = o ? o / 2 : Math.cos(m) * g, a = Math.sin(m) * g, e.moveTo(n - i, r - a), e.lineTo(n + i, r + a);
        break;
      case "dash":
        e.moveTo(n, r), e.lineTo(n + Math.cos(m) * (o ? o / 2 : g), r + Math.sin(m) * g);
        break;
      case !1:
        e.closePath();
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
function qr(e, t, n) {
  return n = n || 0.5, !t || e && e.x > t.left - n && e.x < t.right + n && e.y > t.top - n && e.y < t.bottom + n;
}
function Sx(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function Ox(e) {
  e.restore();
}
function vk(e, t, n, r, o) {
  if (!t)
    return e.lineTo(n.x, n.y);
  if (o === "middle") {
    const s = (t.x + n.x) / 2;
    e.lineTo(s, t.y), e.lineTo(s, n.y);
  } else
    o === "after" != !!r ? e.lineTo(t.x, n.y) : e.lineTo(n.x, t.y);
  e.lineTo(n.x, n.y);
}
function yk(e, t, n, r) {
  if (!t)
    return e.lineTo(n.x, n.y);
  e.bezierCurveTo(r ? t.cp1x : t.cp2x, r ? t.cp1y : t.cp2y, r ? n.cp2x : n.cp1x, r ? n.cp2y : n.cp1y, n.x, n.y);
}
function xk(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), St(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function wk(e, t, n, r, o) {
  if (o.strikethrough || o.underline) {
    const s = e.measureText(r), i = t - s.actualBoundingBoxLeft, a = t + s.actualBoundingBoxRight, l = n - s.actualBoundingBoxAscent, c = n + s.actualBoundingBoxDescent, u = o.strikethrough ? (l + c) / 2 : c;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = o.decorationWidth || 2, e.moveTo(i, u), e.lineTo(a, u), e.stroke();
  }
}
function Ck(e, t) {
  const n = e.fillStyle;
  e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = n;
}
function Mc(e, t, n, r, o, s = {}) {
  const i = Xt(t) ? t : [
    t
  ], a = s.strokeWidth > 0 && s.strokeColor !== "";
  let l, c;
  for (e.save(), e.font = o.string, xk(e, s), l = 0; l < i.length; ++l)
    c = i[l], s.backdrop && Ck(e, s.backdrop), a && (s.strokeColor && (e.strokeStyle = s.strokeColor), St(s.strokeWidth) || (e.lineWidth = s.strokeWidth), e.strokeText(c, n, r, s.maxWidth)), e.fillText(c, n, r, s.maxWidth), wk(e, n, r, c, s), r += Number(o.lineHeight);
  e.restore();
}
function Tc(e, t) {
  const { x: n, y: r, w: o, h: s, radius: i } = t;
  e.arc(n + i.topLeft, r + i.topLeft, i.topLeft, -on, dn, !0), e.lineTo(n, r + s - i.bottomLeft), e.arc(n + i.bottomLeft, r + s - i.bottomLeft, i.bottomLeft, dn, on, !0), e.lineTo(n + o - i.bottomRight, r + s), e.arc(n + o - i.bottomRight, r + s - i.bottomRight, i.bottomRight, on, 0, !0), e.lineTo(n + o, r + i.topRight), e.arc(n + o - i.topRight, r + i.topRight, i.topRight, 0, -on, !0), e.lineTo(n + i.topLeft, r);
}
const Ek = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, _k = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function Sk(e, t) {
  const n = ("" + e).match(Ek);
  if (!n || n[1] === "normal")
    return t * 1.2;
  switch (e = +n[2], n[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const Ok = (e) => +e || 0;
function $p(e, t) {
  const n = {}, r = ht(t), o = r ? Object.keys(t) : t, s = ht(e) ? r ? (i) => mt(e[i], e[t[i]]) : (i) => e[i] : () => e;
  for (const i of o)
    n[i] = Ok(s(i));
  return n;
}
function Mx(e) {
  return $p(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function Us(e) {
  return $p(e, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function lr(e) {
  const t = Mx(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function Kn(e, t) {
  e = e || {}, t = t || ln.font;
  let n = mt(e.size, t.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let r = mt(e.style, t.style);
  r && !("" + r).match(_k) && (console.warn('Invalid font style specified: "' + r + '"'), r = void 0);
  const o = {
    family: mt(e.family, t.family),
    lineHeight: Sk(mt(e.lineHeight, t.lineHeight), n),
    size: n,
    style: r,
    weight: mt(e.weight, t.weight),
    string: ""
  };
  return o.string = gk(o), o;
}
function yl(e, t, n, r) {
  let o = !0, s, i, a;
  for (s = 0, i = e.length; s < i; ++s)
    if (a = e[s], a !== void 0 && (t !== void 0 && typeof a == "function" && (a = a(t), o = !1), n !== void 0 && Xt(a) && (a = a[n % a.length], o = !1), a !== void 0))
      return r && !o && (r.cacheable = !1), a;
}
function Mk(e, t, n) {
  const { min: r, max: o } = e, s = mx(t, (o - r) / 2), i = (a, l) => n && a === 0 ? 0 : a + l;
  return {
    min: i(r, -Math.abs(s)),
    max: i(o, s)
  };
}
function Bo(e, t) {
  return Object.assign(Object.create(e), t);
}
function Fp(e, t = [
  ""
], n, r, o = () => e[0]) {
  const s = n || e;
  typeof r > "u" && (r = Ix("_fallback", e));
  const i = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: s,
    _fallback: r,
    _getTarget: o,
    override: (a) => Fp([
      a,
      ...e
    ], t, s, r)
  };
  return new Proxy(i, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(a, l) {
      return delete a[l], delete a._keys, delete e[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(a, l) {
      return Rx(a, l, () => Ak(l, t, e, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(a, l) {
      return Reflect.getOwnPropertyDescriptor(a._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(a, l) {
      return Xb(a).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(a) {
      return Xb(a);
    },
    /**
    * A trap for setting property values.
    */
    set(a, l, c) {
      const u = a._storage || (a._storage = o());
      return a[l] = u[l] = c, delete a._keys, !0;
    }
  });
}
function Js(e, t, n, r) {
  const o = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: Tx(e, r),
    setContext: (s) => Js(e, s, n, r),
    override: (s) => Js(e.override(s), t, n, r)
  };
  return new Proxy(o, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(s, i) {
      return delete s[i], delete e[i], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(s, i, a) {
      return Rx(s, i, () => Rk(s, i, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(s, i) {
      return s._descriptors.allKeys ? Reflect.has(e, i) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, i);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    /**
    * A trap for the in operator.
    */
    has(s, i) {
      return Reflect.has(e, i);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    /**
    * A trap for setting property values.
    */
    set(s, i, a) {
      return e[i] = a, delete s[i], !0;
    }
  });
}
function Tx(e, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = t.scriptable, _indexable: r = t.indexable, _allKeys: o = t.allKeys } = e;
  return {
    allKeys: o,
    scriptable: n,
    indexable: r,
    isScriptable: Do(n) ? n : () => n,
    isIndexable: Do(r) ? r : () => r
  };
}
const Tk = (e, t) => e ? e + kp(t) : t, Lp = (e, t) => ht(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function Rx(e, t, n) {
  if (Object.prototype.hasOwnProperty.call(e, t))
    return e[t];
  const r = n();
  return e[t] = r, r;
}
function Rk(e, t, n) {
  const { _proxy: r, _context: o, _subProxy: s, _descriptors: i } = e;
  let a = r[t];
  return Do(a) && i.isScriptable(t) && (a = Pk(t, a, e, n)), Xt(a) && a.length && (a = Ik(t, a, e, i.isIndexable)), Lp(t, a) && (a = Js(a, o, s && s[t], i)), a;
}
function Pk(e, t, n, r) {
  const { _proxy: o, _context: s, _subProxy: i, _stack: a } = n;
  if (a.has(e))
    throw new Error("Recursion detected: " + Array.from(a).join("->") + "->" + e);
  a.add(e);
  let l = t(s, i || r);
  return a.delete(e), Lp(e, l) && (l = Vp(o._scopes, o, e, l)), l;
}
function Ik(e, t, n, r) {
  const { _proxy: o, _context: s, _subProxy: i, _descriptors: a } = n;
  if (typeof s.index < "u" && r(e))
    return t[s.index % t.length];
  if (ht(t[0])) {
    const l = t, c = o._scopes.filter((u) => u !== l);
    t = [];
    for (const u of l) {
      const d = Vp(c, o, e, u);
      t.push(Js(d, s, i && i[e], a));
    }
  }
  return t;
}
function Px(e, t, n) {
  return Do(e) ? e(t, n) : e;
}
const kk = (e, t) => e === !0 ? t : typeof e == "string" ? fs(t, e) : void 0;
function Dk(e, t, n, r, o) {
  for (const s of t) {
    const i = kk(n, s);
    if (i) {
      e.add(i);
      const a = Px(i._fallback, n, o);
      if (typeof a < "u" && a !== n && a !== r)
        return a;
    } else if (i === !1 && typeof r < "u" && n !== r)
      return null;
  }
  return !1;
}
function Vp(e, t, n, r) {
  const o = t._rootScopes, s = Px(t._fallback, n, r), i = [
    ...e,
    ...o
  ], a = /* @__PURE__ */ new Set();
  a.add(r);
  let l = qb(a, i, n, s || n, r);
  return l === null || typeof s < "u" && s !== n && (l = qb(a, i, s, l, r), l === null) ? !1 : Fp(Array.from(a), [
    ""
  ], o, s, () => Nk(t, n, r));
}
function qb(e, t, n, r, o) {
  for (; n; )
    n = Dk(e, t, n, r, o);
  return n;
}
function Nk(e, t, n) {
  const r = e._getTarget();
  t in r || (r[t] = {});
  const o = r[t];
  return Xt(o) && ht(n) ? n : o || {};
}
function Ak(e, t, n, r) {
  let o;
  for (const s of t)
    if (o = Ix(Tk(s, e), n), typeof o < "u")
      return Lp(e, o) ? Vp(n, r, e, o) : o;
}
function Ix(e, t) {
  for (const n of t) {
    if (!n)
      continue;
    const r = n[e];
    if (typeof r < "u")
      return r;
  }
}
function Xb(e) {
  let t = e._keys;
  return t || (t = e._keys = $k(e._scopes)), t;
}
function $k(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const r of Object.keys(n).filter((o) => !o.startsWith("_")))
      t.add(r);
  return Array.from(t);
}
const Fk = Number.EPSILON || 1e-14, ei = (e, t) => t < e.length && !e[t].skip && e[t], kx = (e) => e === "x" ? "y" : "x";
function Lk(e, t, n, r) {
  const o = e.skip ? t : e, s = t, i = n.skip ? t : n, a = Uf(s, o), l = Uf(i, s);
  let c = a / (a + l), u = l / (a + l);
  c = isNaN(c) ? 0 : c, u = isNaN(u) ? 0 : u;
  const d = r * c, f = r * u;
  return {
    previous: {
      x: s.x - d * (i.x - o.x),
      y: s.y - d * (i.y - o.y)
    },
    next: {
      x: s.x + f * (i.x - o.x),
      y: s.y + f * (i.y - o.y)
    }
  };
}
function Vk(e, t, n) {
  const r = e.length;
  let o, s, i, a, l, c = ei(e, 0);
  for (let u = 0; u < r - 1; ++u)
    if (l = c, c = ei(e, u + 1), !(!l || !c)) {
      if (Ji(t[u], 0, Fk)) {
        n[u] = n[u + 1] = 0;
        continue;
      }
      o = n[u] / t[u], s = n[u + 1] / t[u], a = Math.pow(o, 2) + Math.pow(s, 2), !(a <= 9) && (i = 3 / Math.sqrt(a), n[u] = o * i * t[u], n[u + 1] = s * i * t[u]);
    }
}
function Wk(e, t, n = "x") {
  const r = kx(n), o = e.length;
  let s, i, a, l = ei(e, 0);
  for (let c = 0; c < o; ++c) {
    if (i = a, a = l, l = ei(e, c + 1), !a)
      continue;
    const u = a[n], d = a[r];
    i && (s = (u - i[n]) / 3, a[`cp1${n}`] = u - s, a[`cp1${r}`] = d - s * t[c]), l && (s = (l[n] - u) / 3, a[`cp2${n}`] = u + s, a[`cp2${r}`] = d + s * t[c]);
  }
}
function Hk(e, t = "x") {
  const n = kx(t), r = e.length, o = Array(r).fill(0), s = Array(r);
  let i, a, l, c = ei(e, 0);
  for (i = 0; i < r; ++i)
    if (a = l, l = c, c = ei(e, i + 1), !!l) {
      if (c) {
        const u = c[t] - l[t];
        o[i] = u !== 0 ? (c[n] - l[n]) / u : 0;
      }
      s[i] = a ? c ? $r(o[i - 1]) !== $r(o[i]) ? 0 : (o[i - 1] + o[i]) / 2 : o[i - 1] : o[i];
    }
  Vk(e, o, s), Wk(e, s, t);
}
function xl(e, t, n) {
  return Math.max(Math.min(e, n), t);
}
function Bk(e, t) {
  let n, r, o, s, i, a = qr(e[0], t);
  for (n = 0, r = e.length; n < r; ++n)
    i = s, s = a, a = n < r - 1 && qr(e[n + 1], t), s && (o = e[n], i && (o.cp1x = xl(o.cp1x, t.left, t.right), o.cp1y = xl(o.cp1y, t.top, t.bottom)), a && (o.cp2x = xl(o.cp2x, t.left, t.right), o.cp2y = xl(o.cp2y, t.top, t.bottom)));
}
function zk(e, t, n, r, o) {
  let s, i, a, l;
  if (t.spanGaps && (e = e.filter((c) => !c.skip)), t.cubicInterpolationMode === "monotone")
    Hk(e, o);
  else {
    let c = r ? e[e.length - 1] : e[0];
    for (s = 0, i = e.length; s < i; ++s)
      a = e[s], l = Lk(c, a, e[Math.min(s + 1, i - (r ? 0 : 1)) % i], t.tension), a.cp1x = l.previous.x, a.cp1y = l.previous.y, a.cp2x = l.next.x, a.cp2y = l.next.y, c = a;
  }
  t.capBezierPoints && Bk(e, n);
}
function Dx() {
  return typeof window < "u" && typeof document < "u";
}
function Wp(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function Rc(e, t, n) {
  let r;
  return typeof e == "string" ? (r = parseInt(e, 10), e.indexOf("%") !== -1 && (r = r / 100 * t.parentNode[n])) : r = e, r;
}
const $u = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function Yk(e, t) {
  return $u(e).getPropertyValue(t);
}
const jk = [
  "top",
  "right",
  "bottom",
  "left"
];
function cs(e, t, n) {
  const r = {};
  n = n ? "-" + n : "";
  for (let o = 0; o < 4; o++) {
    const s = jk[o];
    r[s] = parseFloat(e[t + "-" + s + n]) || 0;
  }
  return r.width = r.left + r.right, r.height = r.top + r.bottom, r;
}
const Uk = (e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot);
function Gk(e, t) {
  const n = e.touches, r = n && n.length ? n[0] : e, { offsetX: o, offsetY: s } = r;
  let i = !1, a, l;
  if (Uk(o, s, e.target))
    a = o, l = s;
  else {
    const c = t.getBoundingClientRect();
    a = r.clientX - c.left, l = r.clientY - c.top, i = !0;
  }
  return {
    x: a,
    y: l,
    box: i
  };
}
function Qo(e, t) {
  if ("native" in e)
    return e;
  const { canvas: n, currentDevicePixelRatio: r } = t, o = $u(n), s = o.boxSizing === "border-box", i = cs(o, "padding"), a = cs(o, "border", "width"), { x: l, y: c, box: u } = Gk(e, n), d = i.left + (u && a.left), f = i.top + (u && a.top);
  let { width: h, height: p } = t;
  return s && (h -= i.width + a.width, p -= i.height + a.height), {
    x: Math.round((l - d) / h * n.width / r),
    y: Math.round((c - f) / p * n.height / r)
  };
}
function Kk(e, t, n) {
  let r, o;
  if (t === void 0 || n === void 0) {
    const s = Wp(e);
    if (!s)
      t = e.clientWidth, n = e.clientHeight;
    else {
      const i = s.getBoundingClientRect(), a = $u(s), l = cs(a, "border", "width"), c = cs(a, "padding");
      t = i.width - c.width - l.width, n = i.height - c.height - l.height, r = Rc(a.maxWidth, s, "clientWidth"), o = Rc(a.maxHeight, s, "clientHeight");
    }
  }
  return {
    width: t,
    height: n,
    maxWidth: r || _c,
    maxHeight: o || _c
  };
}
const wl = (e) => Math.round(e * 10) / 10;
function qk(e, t, n, r) {
  const o = $u(e), s = cs(o, "margin"), i = Rc(o.maxWidth, e, "clientWidth") || _c, a = Rc(o.maxHeight, e, "clientHeight") || _c, l = Kk(e, t, n);
  let { width: c, height: u } = l;
  if (o.boxSizing === "content-box") {
    const f = cs(o, "border", "width"), h = cs(o, "padding");
    c -= h.width + f.width, u -= h.height + f.height;
  }
  return c = Math.max(0, c - s.width), u = Math.max(0, r ? c / r : u - s.height), c = wl(Math.min(c, i, l.maxWidth)), u = wl(Math.min(u, a, l.maxHeight)), c && !u && (u = wl(c / 2)), (t !== void 0 || n !== void 0) && r && l.height && u > l.height && (u = l.height, c = wl(Math.floor(u * r))), {
    width: c,
    height: u
  };
}
function Zb(e, t, n) {
  const r = t || 1, o = Math.floor(e.height * r), s = Math.floor(e.width * r);
  e.height = Math.floor(e.height), e.width = Math.floor(e.width);
  const i = e.canvas;
  return i.style && (n || !i.style.height && !i.style.width) && (i.style.height = `${e.height}px`, i.style.width = `${e.width}px`), e.currentDevicePixelRatio !== r || i.height !== o || i.width !== s ? (e.currentDevicePixelRatio = r, i.height = o, i.width = s, e.ctx.setTransform(r, 0, 0, r, 0, 0), !0) : !1;
}
const Xk = function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
  } catch {
  }
  return e;
}();
function Qb(e, t) {
  const n = Yk(e, t), r = n && n.match(/^(\d+)(\.\d+)?px$/);
  return r ? +r[1] : void 0;
}
function Jo(e, t, n, r) {
  return {
    x: e.x + n * (t.x - e.x),
    y: e.y + n * (t.y - e.y)
  };
}
function Zk(e, t, n, r) {
  return {
    x: e.x + n * (t.x - e.x),
    y: r === "middle" ? n < 0.5 ? e.y : t.y : r === "after" ? n < 1 ? e.y : t.y : n > 0 ? t.y : e.y
  };
}
function Qk(e, t, n, r) {
  const o = {
    x: e.cp2x,
    y: e.cp2y
  }, s = {
    x: t.cp1x,
    y: t.cp1y
  }, i = Jo(e, o, n), a = Jo(o, s, n), l = Jo(s, t, n), c = Jo(i, a, n), u = Jo(a, l, n);
  return Jo(c, u, n);
}
const Jk = function(e, t) {
  return {
    x(n) {
      return e + e + t - n;
    },
    setWidth(n) {
      t = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, r) {
      return n - r;
    },
    leftForLtr(n, r) {
      return n - r;
    }
  };
}, e2 = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
};
function $d(e, t, n) {
  return e ? Jk(t, n) : e2();
}
function t2(e, t) {
  let n, r;
  (t === "ltr" || t === "rtl") && (n = e.canvas.style, r = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", t, "important"), e.prevTextDirection = r);
}
function n2(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function Nx(e) {
  return e === "angle" ? {
    between: ma,
    compare: QI,
    normalize: pr
  } : {
    between: Sc,
    compare: (t, n) => t - n,
    normalize: (t) => t
  };
}
function Jb({ start: e, end: t, count: n, loop: r, style: o }) {
  return {
    start: e % n,
    end: t % n,
    loop: r && (t - e + 1) % n === 0,
    style: o
  };
}
function r2(e, t, n) {
  const { property: r, start: o, end: s } = n, { between: i, normalize: a } = Nx(r), l = t.length;
  let { start: c, end: u, loop: d } = e, f, h;
  if (d) {
    for (c += l, u += l, f = 0, h = l; f < h && i(a(t[c % l][r]), o, s); ++f)
      c--, u--;
    c %= l, u %= l;
  }
  return u < c && (u += l), {
    start: c,
    end: u,
    loop: d,
    style: e.style
  };
}
function o2(e, t, n) {
  if (!n)
    return [
      e
    ];
  const { property: r, start: o, end: s } = n, i = t.length, { compare: a, between: l, normalize: c } = Nx(r), { start: u, end: d, loop: f, style: h } = r2(e, t, n), p = [];
  let g = !1, m = null, v, y, x;
  const C = () => l(o, x, v) && a(o, x) !== 0, w = () => a(s, v) === 0 || l(s, x, v), E = () => g || C(), S = () => !g || w();
  for (let O = u, M = u; O <= d; ++O)
    y = t[O % i], !y.skip && (v = c(y[r]), v !== x && (g = l(v, o, s), m === null && E() && (m = a(v, o) === 0 ? O : M), m !== null && S() && (p.push(Jb({
      start: m,
      end: O,
      loop: f,
      count: i,
      style: h
    })), m = null), M = O, x = v));
  return m !== null && p.push(Jb({
    start: m,
    end: d,
    loop: f,
    count: i,
    style: h
  })), p;
}
function s2(e, t) {
  const n = [], r = e.segments;
  for (let o = 0; o < r.length; o++) {
    const s = o2(r[o], e.points, t);
    s.length && n.push(...s);
  }
  return n;
}
function i2(e, t, n, r) {
  let o = 0, s = t - 1;
  if (n && !r)
    for (; o < t && !e[o].skip; )
      o++;
  for (; o < t && e[o].skip; )
    o++;
  for (o %= t, n && (s += o); s > o && e[s % t].skip; )
    s--;
  return s %= t, {
    start: o,
    end: s
  };
}
function a2(e, t, n, r) {
  const o = e.length, s = [];
  let i = t, a = e[t], l;
  for (l = t + 1; l <= n; ++l) {
    const c = e[l % o];
    c.skip || c.stop ? a.skip || (r = !1, s.push({
      start: t % o,
      end: (l - 1) % o,
      loop: r
    }), t = i = c.stop ? l : null) : (i = l, a.skip && (t = l)), a = c;
  }
  return i !== null && s.push({
    start: t % o,
    end: i % o,
    loop: r
  }), s;
}
function l2(e, t) {
  const n = e.points, r = e.options.spanGaps, o = n.length;
  if (!o)
    return [];
  const s = !!e._loop, { start: i, end: a } = i2(n, o, s, r);
  if (r === !0)
    return ev(e, [
      {
        start: i,
        end: a,
        loop: s
      }
    ], n, t);
  const l = a < i ? a + o : a, c = !!e._fullLoop && i === 0 && a === o - 1;
  return ev(e, a2(n, i, l, c), n, t);
}
function ev(e, t, n, r) {
  return !r || !r.setContext || !n ? t : c2(e, t, n, r);
}
function c2(e, t, n, r) {
  const o = e._chart.getContext(), s = tv(e.options), { _datasetIndex: i, options: { spanGaps: a } } = e, l = n.length, c = [];
  let u = s, d = t[0].start, f = d;
  function h(p, g, m, v) {
    const y = a ? -1 : 1;
    if (p !== g) {
      for (p += l; n[p % l].skip; )
        p -= y;
      for (; n[g % l].skip; )
        g += y;
      p % l !== g % l && (c.push({
        start: p % l,
        end: g % l,
        loop: m,
        style: v
      }), u = v, d = g % l);
    }
  }
  for (const p of t) {
    d = a ? d : p.start;
    let g = n[d % l], m;
    for (f = d + 1; f <= p.end; f++) {
      const v = n[f % l];
      m = tv(r.setContext(Bo(o, {
        type: "segment",
        p0: g,
        p1: v,
        p0DataIndex: (f - 1) % l,
        p1DataIndex: f % l,
        datasetIndex: i
      }))), u2(m, u) && h(d, f - 1, p.loop, u), g = v, u = m;
    }
    d < f - 1 && h(d, f - 1, p.loop, u);
  }
  return c;
}
function tv(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
function u2(e, t) {
  if (!t)
    return !1;
  const n = [], r = function(o, s) {
    return Ap(s) ? (n.includes(s) || n.push(s), n.indexOf(s)) : s;
  };
  return JSON.stringify(e, r) !== JSON.stringify(t, r);
}
/*!
 * Chart.js v4.3.3
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
class d2 {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, n, r, o) {
    const s = n.listeners[o], i = n.duration;
    s.forEach((a) => a({
      chart: t,
      initial: n.initial,
      numSteps: i,
      currentStep: Math.min(r - n.start, i)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = Cx.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let n = 0;
    this._charts.forEach((r, o) => {
      if (!r.running || !r.items.length)
        return;
      const s = r.items;
      let i = s.length - 1, a = !1, l;
      for (; i >= 0; --i)
        l = s[i], l._active ? (l._total > r.duration && (r.duration = l._total), l.tick(t), a = !0) : (s[i] = s[s.length - 1], s.pop());
      a && (o.draw(), this._notify(o, r, t, "progress")), s.length || (r.running = !1, this._notify(o, r, t, "complete"), r.initial = !1), n += s.length;
    }), this._lastDate = t, n === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const n = this._charts;
    let r = n.get(t);
    return r || (r = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(t, r)), r;
  }
  listen(t, n, r) {
    this._getAnims(t).listeners[n].push(r);
  }
  add(t, n) {
    !n || !n.length || this._getAnims(t).items.push(...n);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const n = this._charts.get(t);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((r, o) => Math.max(r, o._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const n = this._charts.get(t);
    return !(!n || !n.running || !n.items.length);
  }
  stop(t) {
    const n = this._charts.get(t);
    if (!n || !n.items.length)
      return;
    const r = n.items;
    let o = r.length - 1;
    for (; o >= 0; --o)
      r[o].cancel();
    n.items = [], this._notify(t, n, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var jr = /* @__PURE__ */ new d2();
const nv = "transparent", f2 = {
  boolean(e, t, n) {
    return n > 0.5 ? t : e;
  },
  color(e, t, n) {
    const r = Ub(e || nv), o = r.valid && Ub(t || nv);
    return o && o.valid ? o.mix(r, n).hexString() : t;
  },
  number(e, t, n) {
    return e + (t - e) * n;
  }
};
let h2 = class {
  constructor(t, n, r, o) {
    const s = n[r];
    o = yl([
      t.to,
      o,
      s,
      t.from
    ]);
    const i = yl([
      t.from,
      s,
      o
    ]);
    this._active = !0, this._fn = t.fn || f2[t.type || typeof i], this._easing = ea[t.easing] || ea.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = n, this._prop = r, this._from = i, this._to = o, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, n, r) {
    if (this._active) {
      this._notify(!1);
      const o = this._target[this._prop], s = r - this._start, i = this._duration - s;
      this._start = r, this._duration = Math.floor(Math.max(i, t.duration)), this._total += s, this._loop = !!t.loop, this._to = yl([
        t.to,
        n,
        o,
        t.from
      ]), this._from = yl([
        t.from,
        o,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const n = t - this._start, r = this._duration, o = this._prop, s = this._from, i = this._loop, a = this._to;
    let l;
    if (this._active = s !== a && (i || n < r), !this._active) {
      this._target[o] = a, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[o] = s;
      return;
    }
    l = n / r % 2, l = i && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[o] = this._fn(s, a, l);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((n, r) => {
      t.push({
        res: n,
        rej: r
      });
    });
  }
  _notify(t) {
    const n = t ? "res" : "rej", r = this._promises || [];
    for (let o = 0; o < r.length; o++)
      r[o][n]();
  }
};
class Ax {
  constructor(t, n) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(t) {
    if (!ht(t))
      return;
    const n = Object.keys(ln.animation), r = this._properties;
    Object.getOwnPropertyNames(t).forEach((o) => {
      const s = t[o];
      if (!ht(s))
        return;
      const i = {};
      for (const a of n)
        i[a] = s[a];
      (Xt(s.properties) && s.properties || [
        o
      ]).forEach((a) => {
        (a === o || !r.has(a)) && r.set(a, i);
      });
    });
  }
  _animateOptions(t, n) {
    const r = n.options, o = g2(t, r);
    if (!o)
      return [];
    const s = this._createAnimations(o, r);
    return r.$shared && p2(t.options.$animations, r).then(() => {
      t.options = r;
    }, () => {
    }), s;
  }
  _createAnimations(t, n) {
    const r = this._properties, o = [], s = t.$animations || (t.$animations = {}), i = Object.keys(n), a = Date.now();
    let l;
    for (l = i.length - 1; l >= 0; --l) {
      const c = i[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        o.push(...this._animateOptions(t, n));
        continue;
      }
      const u = n[c];
      let d = s[c];
      const f = r.get(c);
      if (d)
        if (f && d.active()) {
          d.update(f, u, a);
          continue;
        } else
          d.cancel();
      if (!f || !f.duration) {
        t[c] = u;
        continue;
      }
      s[c] = d = new h2(f, t, c, u), o.push(d);
    }
    return o;
  }
  update(t, n) {
    if (this._properties.size === 0) {
      Object.assign(t, n);
      return;
    }
    const r = this._createAnimations(t, n);
    if (r.length)
      return jr.add(this._chart, r), !0;
  }
}
function p2(e, t) {
  const n = [], r = Object.keys(t);
  for (let o = 0; o < r.length; o++) {
    const s = e[r[o]];
    s && s.active() && n.push(s.wait());
  }
  return Promise.all(n);
}
function g2(e, t) {
  if (!t)
    return;
  let n = e.options;
  if (!n) {
    e.options = t;
    return;
  }
  return n.$shared && (e.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function rv(e, t) {
  const n = e && e.options || {}, r = n.reverse, o = n.min === void 0 ? t : 0, s = n.max === void 0 ? t : 0;
  return {
    start: r ? s : o,
    end: r ? o : s
  };
}
function m2(e, t, n) {
  if (n === !1)
    return !1;
  const r = rv(e, n), o = rv(t, n);
  return {
    top: o.end,
    right: r.end,
    bottom: o.start,
    left: r.start
  };
}
function b2(e) {
  let t, n, r, o;
  return ht(e) ? (t = e.top, n = e.right, r = e.bottom, o = e.left) : t = n = r = o = e, {
    top: t,
    right: n,
    bottom: r,
    left: o,
    disabled: e === !1
  };
}
function $x(e, t) {
  const n = [], r = e._getSortedDatasetMetas(t);
  let o, s;
  for (o = 0, s = r.length; o < s; ++o)
    n.push(r[o].index);
  return n;
}
function ov(e, t, n, r = {}) {
  const o = e.keys, s = r.mode === "single";
  let i, a, l, c;
  if (t !== null) {
    for (i = 0, a = o.length; i < a; ++i) {
      if (l = +o[i], l === n) {
        if (r.all)
          continue;
        break;
      }
      c = e.values[l], En(c) && (s || t === 0 || $r(t) === $r(c)) && (t += c);
    }
    return t;
  }
}
function v2(e) {
  const t = Object.keys(e), n = new Array(t.length);
  let r, o, s;
  for (r = 0, o = t.length; r < o; ++r)
    s = t[r], n[r] = {
      x: s,
      y: e[s]
    };
  return n;
}
function sv(e, t) {
  const n = e && e.options.stacked;
  return n || n === void 0 && t.stack !== void 0;
}
function y2(e, t, n) {
  return `${e.id}.${t.id}.${n.stack || n.type}`;
}
function x2(e) {
  const { min: t, max: n, minDefined: r, maxDefined: o } = e.getUserBounds();
  return {
    min: r ? t : Number.NEGATIVE_INFINITY,
    max: o ? n : Number.POSITIVE_INFINITY
  };
}
function w2(e, t, n) {
  const r = e[t] || (e[t] = {});
  return r[n] || (r[n] = {});
}
function iv(e, t, n, r) {
  for (const o of t.getMatchingVisibleMetas(r).reverse()) {
    const s = e[o.index];
    if (n && s > 0 || !n && s < 0)
      return o.index;
  }
  return null;
}
function av(e, t) {
  const { chart: n, _cachedMeta: r } = e, o = n._stacks || (n._stacks = {}), { iScale: s, vScale: i, index: a } = r, l = s.axis, c = i.axis, u = y2(s, i, r), d = t.length;
  let f;
  for (let h = 0; h < d; ++h) {
    const p = t[h], { [l]: g, [c]: m } = p, v = p._stacks || (p._stacks = {});
    f = v[c] = w2(o, u, g), f[a] = m, f._top = iv(f, i, !0, r.type), f._bottom = iv(f, i, !1, r.type);
    const y = f._visualValues || (f._visualValues = {});
    y[a] = m;
  }
}
function Fd(e, t) {
  const n = e.scales;
  return Object.keys(n).filter((r) => n[r].axis === t).shift();
}
function C2(e, t) {
  return Bo(e, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function E2(e, t, n) {
  return Bo(e, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: t,
    mode: "default",
    type: "data"
  });
}
function _i(e, t) {
  const n = e.controller.index, r = e.vScale && e.vScale.axis;
  if (r) {
    t = t || e._parsed;
    for (const o of t) {
      const s = o._stacks;
      if (!s || s[r] === void 0 || s[r][n] === void 0)
        return;
      delete s[r][n], s[r]._visualValues !== void 0 && s[r]._visualValues[n] !== void 0 && delete s[r]._visualValues[n];
    }
  }
}
const Ld = (e) => e === "reset" || e === "none", lv = (e, t) => t ? e : Object.assign({}, e), _2 = (e, t, n) => e && !t.hidden && t._stacked && {
  keys: $x(n, !0),
  values: null
};
class us {
  constructor(t, n) {
    this.chart = t, this._ctx = t.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = sv(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && _i(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, n = this._cachedMeta, r = this.getDataset(), o = (d, f, h, p) => d === "x" ? f : d === "r" ? p : h, s = n.xAxisID = mt(r.xAxisID, Fd(t, "x")), i = n.yAxisID = mt(r.yAxisID, Fd(t, "y")), a = n.rAxisID = mt(r.rAxisID, Fd(t, "r")), l = n.indexAxis, c = n.iAxisID = o(l, s, i, a), u = n.vAxisID = o(l, i, s, a);
    n.xScale = this.getScaleForId(s), n.yScale = this.getScaleForId(i), n.rScale = this.getScaleForId(a), n.iScale = this.getScaleForId(c), n.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const n = this._cachedMeta;
    return t === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && Bb(this._data, this), t._stacked && _i(t);
  }
  _dataCheck() {
    const t = this.getDataset(), n = t.data || (t.data = []), r = this._data;
    if (ht(n))
      this._data = v2(n);
    else if (r !== n) {
      if (r) {
        Bb(r, this);
        const o = this._cachedMeta;
        _i(o), o._parsed = [];
      }
      n && Object.isExtensible(n) && nk(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const n = this._cachedMeta, r = this.getDataset();
    let o = !1;
    this._dataCheck();
    const s = n._stacked;
    n._stacked = sv(n.vScale, n), n.stack !== r.stack && (o = !0, _i(n), n.stack = r.stack), this._resyncElements(t), (o || s !== n._stacked) && av(this, n._parsed);
  }
  configure() {
    const t = this.chart.config, n = t.datasetScopeKeys(this._type), r = t.getOptionScopes(this.getDataset(), n, !0);
    this.options = t.createResolver(r, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, n) {
    const { _cachedMeta: r, _data: o } = this, { iScale: s, _stacked: i } = r, a = s.axis;
    let l = t === 0 && n === o.length ? !0 : r._sorted, c = t > 0 && r._parsed[t - 1], u, d, f;
    if (this._parsing === !1)
      r._parsed = o, r._sorted = !0, f = o;
    else {
      Xt(o[t]) ? f = this.parseArrayData(r, o, t, n) : ht(o[t]) ? f = this.parseObjectData(r, o, t, n) : f = this.parsePrimitiveData(r, o, t, n);
      const h = () => d[a] === null || c && d[a] < c[a];
      for (u = 0; u < n; ++u)
        r._parsed[u + t] = d = f[u], l && (h() && (l = !1), c = d);
      r._sorted = l;
    }
    i && av(this, f);
  }
  parsePrimitiveData(t, n, r, o) {
    const { iScale: s, vScale: i } = t, a = s.axis, l = i.axis, c = s.getLabels(), u = s === i, d = new Array(o);
    let f, h, p;
    for (f = 0, h = o; f < h; ++f)
      p = f + r, d[f] = {
        [a]: u || s.parse(c[p], p),
        [l]: i.parse(n[p], p)
      };
    return d;
  }
  parseArrayData(t, n, r, o) {
    const { xScale: s, yScale: i } = t, a = new Array(o);
    let l, c, u, d;
    for (l = 0, c = o; l < c; ++l)
      u = l + r, d = n[u], a[l] = {
        x: s.parse(d[0], u),
        y: i.parse(d[1], u)
      };
    return a;
  }
  parseObjectData(t, n, r, o) {
    const { xScale: s, yScale: i } = t, { xAxisKey: a = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(o);
    let u, d, f, h;
    for (u = 0, d = o; u < d; ++u)
      f = u + r, h = n[f], c[u] = {
        x: s.parse(fs(h, a), f),
        y: i.parse(fs(h, l), f)
      };
    return c;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, n, r) {
    const o = this.chart, s = this._cachedMeta, i = n[t.axis], a = {
      keys: $x(o, !0),
      values: n._stacks[t.axis]._visualValues
    };
    return ov(a, i, s.index, {
      mode: r
    });
  }
  updateRangeFromParsed(t, n, r, o) {
    const s = r[n.axis];
    let i = s === null ? NaN : s;
    const a = o && r._stacks[n.axis];
    o && a && (o.values = a, i = ov(o, s, this._cachedMeta.index)), t.min = Math.min(t.min, i), t.max = Math.max(t.max, i);
  }
  getMinMax(t, n) {
    const r = this._cachedMeta, o = r._parsed, s = r._sorted && t === r.iScale, i = o.length, a = this._getOtherScale(t), l = _2(n, r, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: u, max: d } = x2(a);
    let f, h;
    function p() {
      h = o[f];
      const g = h[a.axis];
      return !En(h[t.axis]) || u > g || d < g;
    }
    for (f = 0; f < i && !(!p() && (this.updateRangeFromParsed(c, t, h, l), s)); ++f)
      ;
    if (s) {
      for (f = i - 1; f >= 0; --f)
        if (!p()) {
          this.updateRangeFromParsed(c, t, h, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(t) {
    const n = this._cachedMeta._parsed, r = [];
    let o, s, i;
    for (o = 0, s = n.length; o < s; ++o)
      i = n[o][t.axis], En(i) && r.push(i);
    return r;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = n.iScale, o = n.vScale, s = this.getParsed(t);
    return {
      label: r ? "" + r.getLabelForValue(s[r.axis]) : "",
      value: o ? "" + o.getLabelForValue(s[o.axis]) : ""
    };
  }
  _update(t) {
    const n = this._cachedMeta;
    this.update(t || "default"), n._clip = b2(mt(this.options.clip, m2(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, n = this.chart, r = this._cachedMeta, o = r.data || [], s = n.chartArea, i = [], a = this._drawStart || 0, l = this._drawCount || o.length - a, c = this.options.drawActiveElementsOnTop;
    let u;
    for (r.dataset && r.dataset.draw(t, s, a, l), u = a; u < a + l; ++u) {
      const d = o[u];
      d.hidden || (d.active && c ? i.push(d) : d.draw(t, s));
    }
    for (u = 0; u < i.length; ++u)
      i[u].draw(t, s);
  }
  getStyle(t, n) {
    const r = n ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(r) : this.resolveDataElementOptions(t || 0, r);
  }
  getContext(t, n, r) {
    const o = this.getDataset();
    let s;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const i = this._cachedMeta.data[t];
      s = i.$context || (i.$context = E2(this.getContext(), t, i)), s.parsed = this.getParsed(t), s.raw = o.data[t], s.index = s.dataIndex = t;
    } else
      s = this.$context || (this.$context = C2(this.chart.getContext(), this.index)), s.dataset = o, s.index = s.datasetIndex = this.index;
    return s.active = !!n, s.mode = r, s;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, t);
  }
  _resolveElementOptions(t, n = "default", r) {
    const o = n === "active", s = this._cachedDataOpts, i = t + "-" + n, a = s[i], l = this.enableOptionSharing && pa(r);
    if (a)
      return lv(a, l);
    const c = this.chart.config, u = c.datasetElementScopeKeys(this._type, t), d = o ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], f = c.getOptionScopes(this.getDataset(), u), h = Object.keys(ln.elements[t]), p = () => this.getContext(r, o, n), g = c.resolveNamedOptions(f, h, p, d);
    return g.$shared && (g.$shared = l, s[i] = Object.freeze(lv(g, l))), g;
  }
  _resolveAnimations(t, n, r) {
    const o = this.chart, s = this._cachedDataOpts, i = `animation-${n}`, a = s[i];
    if (a)
      return a;
    let l;
    if (o.options.animation !== !1) {
      const u = this.chart.config, d = u.datasetAnimationScopeKeys(this._type, n), f = u.getOptionScopes(this.getDataset(), d);
      l = u.createResolver(f, this.getContext(t, r, n));
    }
    const c = new Ax(o, l && l.animations);
    return l && l._cacheable && (s[i] = Object.freeze(c)), c;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, n) {
    return !n || Ld(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, n) {
    const r = this.resolveDataElementOptions(t, n), o = this._sharedOptions, s = this.getSharedOptions(r), i = this.includeOptions(n, s) || s !== o;
    return this.updateSharedOptions(s, n, r), {
      sharedOptions: s,
      includeOptions: i
    };
  }
  updateElement(t, n, r, o) {
    Ld(o) ? Object.assign(t, r) : this._resolveAnimations(n, o).update(t, r);
  }
  updateSharedOptions(t, n, r) {
    t && !Ld(n) && this._resolveAnimations(void 0, n).update(t, r);
  }
  _setStyle(t, n, r, o) {
    t.active = o;
    const s = this.getStyle(n, o);
    this._resolveAnimations(n, r, o).update(t, {
      options: !o && this.getSharedOptions(s) || s
    });
  }
  removeHoverStyle(t, n, r) {
    this._setStyle(t, r, "active", !1);
  }
  setHoverStyle(t, n, r) {
    this._setStyle(t, r, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const n = this._data, r = this._cachedMeta.data;
    for (const [a, l, c] of this._syncList)
      this[a](l, c);
    this._syncList = [];
    const o = r.length, s = n.length, i = Math.min(s, o);
    i && this.parse(0, i), s > o ? this._insertElements(o, s - o, t) : s < o && this._removeElements(s, o - s);
  }
  _insertElements(t, n, r = !0) {
    const o = this._cachedMeta, s = o.data, i = t + n;
    let a;
    const l = (c) => {
      for (c.length += n, a = c.length - 1; a >= i; a--)
        c[a] = c[a - n];
    };
    for (l(s), a = t; a < i; ++a)
      s[a] = new this.dataElementType();
    this._parsing && l(o._parsed), this.parse(t, n), r && this.updateElements(s, t, n, "reset");
  }
  updateElements(t, n, r, o) {
  }
  _removeElements(t, n) {
    const r = this._cachedMeta;
    if (this._parsing) {
      const o = r._parsed.splice(t, n);
      r._stacked && _i(r, o);
    }
    r.data.splice(t, n);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [n, r, o] = t;
      this[n](r, o);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, n) {
    n && this._sync([
      "_removeElements",
      t,
      n
    ]);
    const r = arguments.length - 2;
    r && this._sync([
      "_insertElements",
      t,
      r
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
ce(us, "defaults", {}), ce(us, "datasetElementType", null), ce(us, "dataElementType", null);
function S2(e, t) {
  if (!e._cache.$bar) {
    const n = e.getMatchingVisibleMetas(t);
    let r = [];
    for (let o = 0, s = n.length; o < s; o++)
      r = r.concat(n[o].controller.getAllParsedValues(e));
    e._cache.$bar = wx(r.sort((o, s) => o - s));
  }
  return e._cache.$bar;
}
function O2(e) {
  const t = e.iScale, n = S2(t, e.type);
  let r = t._length, o, s, i, a;
  const l = () => {
    i === 32767 || i === -32768 || (pa(a) && (r = Math.min(r, Math.abs(i - a) || r)), a = i);
  };
  for (o = 0, s = n.length; o < s; ++o)
    i = t.getPixelForValue(n[o]), l();
  for (a = void 0, o = 0, s = t.ticks.length; o < s; ++o)
    i = t.getPixelForTick(o), l();
  return r;
}
function M2(e, t, n, r) {
  const o = n.barThickness;
  let s, i;
  return St(o) ? (s = t.min * n.categoryPercentage, i = n.barPercentage) : (s = o * r, i = 1), {
    chunk: s / r,
    ratio: i,
    start: t.pixels[e] - s / 2
  };
}
function T2(e, t, n, r) {
  const o = t.pixels, s = o[e];
  let i = e > 0 ? o[e - 1] : null, a = e < o.length - 1 ? o[e + 1] : null;
  const l = n.categoryPercentage;
  i === null && (i = s - (a === null ? t.end - t.start : a - s)), a === null && (a = s + s - i);
  const c = s - (s - Math.min(i, a)) / 2 * l;
  return {
    chunk: Math.abs(a - i) / 2 * l / r,
    ratio: n.barPercentage,
    start: c
  };
}
function R2(e, t, n, r) {
  const o = n.parse(e[0], r), s = n.parse(e[1], r), i = Math.min(o, s), a = Math.max(o, s);
  let l = i, c = a;
  Math.abs(i) > Math.abs(a) && (l = a, c = i), t[n.axis] = c, t._custom = {
    barStart: l,
    barEnd: c,
    start: o,
    end: s,
    min: i,
    max: a
  };
}
function Fx(e, t, n, r) {
  return Xt(e) ? R2(e, t, n, r) : t[n.axis] = n.parse(e, r), t;
}
function cv(e, t, n, r) {
  const o = e.iScale, s = e.vScale, i = o.getLabels(), a = o === s, l = [];
  let c, u, d, f;
  for (c = n, u = n + r; c < u; ++c)
    f = t[c], d = {}, d[o.axis] = a || o.parse(i[c], c), l.push(Fx(f, d, s, c));
  return l;
}
function Vd(e) {
  return e && e.barStart !== void 0 && e.barEnd !== void 0;
}
function P2(e, t, n) {
  return e !== 0 ? $r(e) : (t.isHorizontal() ? 1 : -1) * (t.min >= n ? 1 : -1);
}
function I2(e) {
  let t, n, r, o, s;
  return e.horizontal ? (t = e.base > e.x, n = "left", r = "right") : (t = e.base < e.y, n = "bottom", r = "top"), t ? (o = "end", s = "start") : (o = "start", s = "end"), {
    start: n,
    end: r,
    reverse: t,
    top: o,
    bottom: s
  };
}
function k2(e, t, n, r) {
  let o = t.borderSkipped;
  const s = {};
  if (!o) {
    e.borderSkipped = s;
    return;
  }
  if (o === !0) {
    e.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: i, end: a, reverse: l, top: c, bottom: u } = I2(e);
  o === "middle" && n && (e.enableBorderRadius = !0, (n._top || 0) === r ? o = c : (n._bottom || 0) === r ? o = u : (s[uv(u, i, a, l)] = !0, o = c)), s[uv(o, i, a, l)] = !0, e.borderSkipped = s;
}
function uv(e, t, n, r) {
  return r ? (e = D2(e, t, n), e = dv(e, n, t)) : e = dv(e, t, n), e;
}
function D2(e, t, n) {
  return e === t ? n : e === n ? t : e;
}
function dv(e, t, n) {
  return e === "start" ? t : e === "end" ? n : e;
}
function N2(e, { inflateAmount: t }, n) {
  e.inflateAmount = t === "auto" ? n === 1 ? 0.33 : 0 : t;
}
class Kl extends us {
  parsePrimitiveData(t, n, r, o) {
    return cv(t, n, r, o);
  }
  parseArrayData(t, n, r, o) {
    return cv(t, n, r, o);
  }
  parseObjectData(t, n, r, o) {
    const { iScale: s, vScale: i } = t, { xAxisKey: a = "x", yAxisKey: l = "y" } = this._parsing, c = s.axis === "x" ? a : l, u = i.axis === "x" ? a : l, d = [];
    let f, h, p, g;
    for (f = r, h = r + o; f < h; ++f)
      g = n[f], p = {}, p[s.axis] = s.parse(fs(g, c), f), d.push(Fx(fs(g, u), p, i, f));
    return d;
  }
  updateRangeFromParsed(t, n, r, o) {
    super.updateRangeFromParsed(t, n, r, o);
    const s = r._custom;
    s && n === this._cachedMeta.vScale && (t.min = Math.min(t.min, s.min), t.max = Math.max(t.max, s.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, { iScale: r, vScale: o } = n, s = this.getParsed(t), i = s._custom, a = Vd(i) ? "[" + i.start + ", " + i.end + "]" : "" + o.getLabelForValue(s[o.axis]);
    return {
      label: "" + r.getLabelForValue(s[r.axis]),
      value: a
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const n = this._cachedMeta;
    this.updateElements(n.data, 0, n.data.length, t);
  }
  updateElements(t, n, r, o) {
    const s = o === "reset", { index: i, _cachedMeta: { vScale: a } } = this, l = a.getBasePixel(), c = a.isHorizontal(), u = this._getRuler(), { sharedOptions: d, includeOptions: f } = this._getSharedOptions(n, o);
    for (let h = n; h < n + r; h++) {
      const p = this.getParsed(h), g = s || St(p[a.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(h), m = this._calculateBarIndexPixels(h, u), v = (p._stacks || {})[a.axis], y = {
        horizontal: c,
        base: g.base,
        enableBorderRadius: !v || Vd(p._custom) || i === v._top || i === v._bottom,
        x: c ? g.head : m.center,
        y: c ? m.center : g.head,
        height: c ? m.size : Math.abs(g.size),
        width: c ? Math.abs(g.size) : m.size
      };
      f && (y.options = d || this.resolveDataElementOptions(h, t[h].active ? "active" : o));
      const x = y.options || t[h].options;
      k2(y, x, v, i), N2(y, x, u.ratio), this.updateElement(t[h], h, y, o);
    }
  }
  _getStacks(t, n) {
    const { iScale: r } = this._cachedMeta, o = r.getMatchingVisibleMetas(this._type).filter((l) => l.controller.options.grouped), s = r.options.stacked, i = [], a = (l) => {
      const c = l.controller.getParsed(n), u = c && c[l.vScale.axis];
      if (St(u) || isNaN(u))
        return !0;
    };
    for (const l of o)
      if (!(n !== void 0 && a(l)) && ((s === !1 || i.indexOf(l.stack) === -1 || s === void 0 && l.stack === void 0) && i.push(l.stack), l.index === t))
        break;
    return i.length || i.push(void 0), i;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, n, r) {
    const o = this._getStacks(t, r), s = n !== void 0 ? o.indexOf(n) : -1;
    return s === -1 ? o.length - 1 : s;
  }
  _getRuler() {
    const t = this.options, n = this._cachedMeta, r = n.iScale, o = [];
    let s, i;
    for (s = 0, i = n.data.length; s < i; ++s)
      o.push(r.getPixelForValue(this.getParsed(s)[r.axis], s));
    const a = t.barThickness;
    return {
      min: a || O2(n),
      pixels: o,
      start: r._startPixel,
      end: r._endPixel,
      stackCount: this._getStackCount(),
      scale: r,
      grouped: t.grouped,
      ratio: a ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: n, _stacked: r, index: o }, options: { base: s, minBarLength: i } } = this, a = s || 0, l = this.getParsed(t), c = l._custom, u = Vd(c);
    let d = l[n.axis], f = 0, h = r ? this.applyStack(n, l, r) : d, p, g;
    h !== d && (f = h - d, h = d), u && (d = c.barStart, h = c.barEnd - c.barStart, d !== 0 && $r(d) !== $r(c.barEnd) && (f = 0), f += d);
    const m = !St(s) && !u ? s : f;
    let v = n.getPixelForValue(m);
    if (this.chart.getDataVisibility(t) ? p = n.getPixelForValue(f + h) : p = v, g = p - v, Math.abs(g) < i) {
      g = P2(g, n, a) * i, d === a && (v -= g / 2);
      const y = n.getPixelForDecimal(0), x = n.getPixelForDecimal(1), C = Math.min(y, x), w = Math.max(y, x);
      v = Math.max(Math.min(v, w), C), p = v + g, r && !u && (l._stacks[n.axis]._visualValues[o] = n.getValueForPixel(p) - n.getValueForPixel(v));
    }
    if (v === n.getPixelForValue(a)) {
      const y = $r(g) * n.getLineWidthForValue(a) / 2;
      v += y, g -= y;
    }
    return {
      size: g,
      base: v,
      head: p,
      center: p + g / 2
    };
  }
  _calculateBarIndexPixels(t, n) {
    const r = n.scale, o = this.options, s = o.skipNull, i = mt(o.maxBarThickness, 1 / 0);
    let a, l;
    if (n.grouped) {
      const c = s ? this._getStackCount(t) : n.stackCount, u = o.barThickness === "flex" ? T2(t, n, o, c) : M2(t, n, o, c), d = this._getStackIndex(this.index, this._cachedMeta.stack, s ? t : void 0);
      a = u.start + u.chunk * d + u.chunk / 2, l = Math.min(i, u.chunk * u.ratio);
    } else
      a = r.getPixelForValue(this.getParsed(t)[r.axis], t), l = Math.min(i, n.min * n.ratio);
    return {
      base: a - l / 2,
      head: a + l / 2,
      center: a,
      size: l
    };
  }
  draw() {
    const t = this._cachedMeta, n = t.vScale, r = t.data, o = r.length;
    let s = 0;
    for (; s < o; ++s)
      this.getParsed(s)[n.axis] !== null && r[s].draw(this._ctx);
  }
}
ce(Kl, "id", "bar"), ce(Kl, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), ce(Kl, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
function A2(e, t, n) {
  let r = 1, o = 1, s = 0, i = 0;
  if (t < Ut) {
    const a = e, l = a + t, c = Math.cos(a), u = Math.sin(a), d = Math.cos(l), f = Math.sin(l), h = (x, C, w) => ma(x, a, l, !0) ? 1 : Math.max(C, C * n, w, w * n), p = (x, C, w) => ma(x, a, l, !0) ? -1 : Math.min(C, C * n, w, w * n), g = h(0, c, d), m = h(on, u, f), v = p(dn, c, d), y = p(dn + on, u, f);
    r = (g - v) / 2, o = (m - y) / 2, s = -(g + v) / 2, i = -(m + y) / 2;
  }
  return {
    ratioX: r,
    ratioY: o,
    offsetX: s,
    offsetY: i
  };
}
class Hi extends us {
  constructor(t, n) {
    super(t, n), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, n) {
    const r = this.getDataset().data, o = this._cachedMeta;
    if (this._parsing === !1)
      o._parsed = r;
    else {
      let s = (l) => +r[l];
      if (ht(r[t])) {
        const { key: l = "value" } = this._parsing;
        s = (c) => +fs(r[c], l);
      }
      let i, a;
      for (i = t, a = t + n; i < a; ++i)
        o._parsed[i] = s(i);
    }
  }
  _getRotation() {
    return kr(this.options.rotation - 90);
  }
  _getCircumference() {
    return kr(this.options.circumference);
  }
  _getRotationExtents() {
    let t = Ut, n = -Ut;
    for (let r = 0; r < this.chart.data.datasets.length; ++r)
      if (this.chart.isDatasetVisible(r) && this.chart.getDatasetMeta(r).type === this._type) {
        const o = this.chart.getDatasetMeta(r).controller, s = o._getRotation(), i = o._getCircumference();
        t = Math.min(t, s), n = Math.max(n, s + i);
      }
    return {
      rotation: t,
      circumference: n - t
    };
  }
  update(t) {
    const n = this.chart, { chartArea: r } = n, o = this._cachedMeta, s = o.data, i = this.getMaxBorderWidth() + this.getMaxOffset(s) + this.options.spacing, a = Math.max((Math.min(r.width, r.height) - i) / 2, 0), l = Math.min(BI(this.options.cutout, a), 1), c = this._getRingWeight(this.index), { circumference: u, rotation: d } = this._getRotationExtents(), { ratioX: f, ratioY: h, offsetX: p, offsetY: g } = A2(d, u, l), m = (r.width - i) / f, v = (r.height - i) / h, y = Math.max(Math.min(m, v) / 2, 0), x = mx(this.options.radius, y), C = Math.max(x * l, 0), w = (x - C) / this._getVisibleDatasetWeightTotal();
    this.offsetX = p * x, this.offsetY = g * x, o.total = this.calculateTotal(), this.outerRadius = x - w * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - w * c, 0), this.updateElements(s, 0, s.length, t);
  }
  _circumference(t, n) {
    const r = this.options, o = this._cachedMeta, s = this._getCircumference();
    return n && r.animation.animateRotate || !this.chart.getDataVisibility(t) || o._parsed[t] === null || o.data[t].hidden ? 0 : this.calculateCircumference(o._parsed[t] * s / Ut);
  }
  updateElements(t, n, r, o) {
    const s = o === "reset", i = this.chart, a = i.chartArea, c = i.options.animation, u = (a.left + a.right) / 2, d = (a.top + a.bottom) / 2, f = s && c.animateScale, h = f ? 0 : this.innerRadius, p = f ? 0 : this.outerRadius, { sharedOptions: g, includeOptions: m } = this._getSharedOptions(n, o);
    let v = this._getRotation(), y;
    for (y = 0; y < n; ++y)
      v += this._circumference(y, s);
    for (y = n; y < n + r; ++y) {
      const x = this._circumference(y, s), C = t[y], w = {
        x: u + this.offsetX,
        y: d + this.offsetY,
        startAngle: v,
        endAngle: v + x,
        circumference: x,
        outerRadius: p,
        innerRadius: h
      };
      m && (w.options = g || this.resolveDataElementOptions(y, C.active ? "active" : o)), v += x, this.updateElement(C, y, w, o);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, n = t.data;
    let r = 0, o;
    for (o = 0; o < n.length; o++) {
      const s = t._parsed[o];
      s !== null && !isNaN(s) && this.chart.getDataVisibility(o) && !n[o].hidden && (r += Math.abs(s));
    }
    return r;
  }
  calculateCircumference(t) {
    const n = this._cachedMeta.total;
    return n > 0 && !isNaN(t) ? Ut * (Math.abs(t) / n) : 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = this.chart, o = r.data.labels || [], s = Nu(n._parsed[t], r.options.locale);
    return {
      label: o[t] || "",
      value: s
    };
  }
  getMaxBorderWidth(t) {
    let n = 0;
    const r = this.chart;
    let o, s, i, a, l;
    if (!t) {
      for (o = 0, s = r.data.datasets.length; o < s; ++o)
        if (r.isDatasetVisible(o)) {
          i = r.getDatasetMeta(o), t = i.data, a = i.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (o = 0, s = t.length; o < s; ++o)
      l = a.resolveDataElementOptions(o), l.borderAlign !== "inner" && (n = Math.max(n, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return n;
  }
  getMaxOffset(t) {
    let n = 0;
    for (let r = 0, o = t.length; r < o; ++r) {
      const s = this.resolveDataElementOptions(r);
      n = Math.max(n, s.offset || 0, s.hoverOffset || 0);
    }
    return n;
  }
  _getRingWeightOffset(t) {
    let n = 0;
    for (let r = 0; r < t; ++r)
      this.chart.isDatasetVisible(r) && (n += this._getRingWeight(r));
    return n;
  }
  _getRingWeight(t) {
    return Math.max(mt(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
ce(Hi, "id", "doughnut"), ce(Hi, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), ce(Hi, "descriptors", {
  _scriptable: (t) => t !== "spacing",
  _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
}), ce(Hi, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const n = t.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: r, color: o } } = t.legend.options;
            return n.labels.map((s, i) => {
              const l = t.getDatasetMeta(0).controller.getStyle(i);
              return {
                text: s,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: o,
                lineWidth: l.borderWidth,
                pointStyle: r,
                hidden: !t.getDataVisibility(i),
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick(t, n, r) {
        r.chart.toggleDataVisibility(n.index), r.chart.update();
      }
    }
  }
});
class ql extends us {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const n = this._cachedMeta, { dataset: r, data: o = [], _dataset: s } = n, i = this.chart._animationsDisabled;
    let { start: a, count: l } = sk(n, o, i);
    this._drawStart = a, this._drawCount = l, ik(n) && (a = 0, l = o.length), r._chart = this.chart, r._datasetIndex = this.index, r._decimated = !!s._decimated, r.points = o;
    const c = this.resolveDatasetElementOptions(t);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(r, void 0, {
      animated: !i,
      options: c
    }, t), this.updateElements(o, a, l, t);
  }
  updateElements(t, n, r, o) {
    const s = o === "reset", { iScale: i, vScale: a, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: u, includeOptions: d } = this._getSharedOptions(n, o), f = i.axis, h = a.axis, { spanGaps: p, segment: g } = this.options, m = ga(p) ? p : Number.POSITIVE_INFINITY, v = this.chart._animationsDisabled || s || o === "none", y = n + r, x = t.length;
    let C = n > 0 && this.getParsed(n - 1);
    for (let w = 0; w < x; ++w) {
      const E = t[w], S = v ? E : {};
      if (w < n || w >= y) {
        S.skip = !0;
        continue;
      }
      const O = this.getParsed(w), M = St(O[h]), T = S[f] = i.getPixelForValue(O[f], w), P = S[h] = s || M ? a.getBasePixel() : a.getPixelForValue(l ? this.applyStack(a, O, l) : O[h], w);
      S.skip = isNaN(T) || isNaN(P) || M, S.stop = w > 0 && Math.abs(O[f] - C[f]) > m, g && (S.parsed = O, S.raw = c.data[w]), d && (S.options = u || this.resolveDataElementOptions(w, E.active ? "active" : o)), v || this.updateElement(E, w, S, o), C = O;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.dataset, r = n.options && n.options.borderWidth || 0, o = t.data || [];
    if (!o.length)
      return r;
    const s = o[0].size(this.resolveDataElementOptions(0)), i = o[o.length - 1].size(this.resolveDataElementOptions(o.length - 1));
    return Math.max(r, s, i) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
ce(ql, "id", "line"), ce(ql, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), ce(ql, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
function Xo() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class Hp {
  constructor(t) {
    ce(this, "options");
    this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(Hp.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return Xo();
  }
  parse() {
    return Xo();
  }
  format() {
    return Xo();
  }
  add() {
    return Xo();
  }
  diff() {
    return Xo();
  }
  startOf() {
    return Xo();
  }
  endOf() {
    return Xo();
  }
}
var Lx = {
  _date: Hp
};
function $2(e, t, n, r) {
  const { controller: o, data: s, _sorted: i } = e, a = o._cachedMeta.iScale;
  if (a && t === a.axis && t !== "r" && i && s.length) {
    const l = a._reversePixels ? ek : ss;
    if (r) {
      if (o._sharedOptions) {
        const c = s[0], u = typeof c.getRange == "function" && c.getRange(t);
        if (u) {
          const d = l(s, t, n - u), f = l(s, t, n + u);
          return {
            lo: d.lo,
            hi: f.hi
          };
        }
      }
    } else
      return l(s, t, n);
  }
  return {
    lo: 0,
    hi: s.length - 1
  };
}
function Ha(e, t, n, r, o) {
  const s = e.getSortedVisibleDatasetMetas(), i = n[t];
  for (let a = 0, l = s.length; a < l; ++a) {
    const { index: c, data: u } = s[a], { lo: d, hi: f } = $2(s[a], t, i, o);
    for (let h = d; h <= f; ++h) {
      const p = u[h];
      p.skip || r(p, c, h);
    }
  }
}
function F2(e) {
  const t = e.indexOf("x") !== -1, n = e.indexOf("y") !== -1;
  return function(r, o) {
    const s = t ? Math.abs(r.x - o.x) : 0, i = n ? Math.abs(r.y - o.y) : 0;
    return Math.sqrt(Math.pow(s, 2) + Math.pow(i, 2));
  };
}
function Wd(e, t, n, r, o) {
  const s = [];
  return !o && !e.isPointInArea(t) || Ha(e, n, t, function(a, l, c) {
    !o && !qr(a, e.chartArea, 0) || a.inRange(t.x, t.y, r) && s.push({
      element: a,
      datasetIndex: l,
      index: c
    });
  }, !0), s;
}
function L2(e, t, n, r) {
  let o = [];
  function s(i, a, l) {
    const { startAngle: c, endAngle: u } = i.getProps([
      "startAngle",
      "endAngle"
    ], r), { angle: d } = yx(i, {
      x: t.x,
      y: t.y
    });
    ma(d, c, u) && o.push({
      element: i,
      datasetIndex: a,
      index: l
    });
  }
  return Ha(e, n, t, s), o;
}
function V2(e, t, n, r, o, s) {
  let i = [];
  const a = F2(n);
  let l = Number.POSITIVE_INFINITY;
  function c(u, d, f) {
    const h = u.inRange(t.x, t.y, o);
    if (r && !h)
      return;
    const p = u.getCenterPoint(o);
    if (!(!!s || e.isPointInArea(p)) && !h)
      return;
    const m = a(t, p);
    m < l ? (i = [
      {
        element: u,
        datasetIndex: d,
        index: f
      }
    ], l = m) : m === l && i.push({
      element: u,
      datasetIndex: d,
      index: f
    });
  }
  return Ha(e, n, t, c), i;
}
function Hd(e, t, n, r, o, s) {
  return !s && !e.isPointInArea(t) ? [] : n === "r" && !r ? L2(e, t, n, o) : V2(e, t, n, r, o, s);
}
function fv(e, t, n, r, o) {
  const s = [], i = n === "x" ? "inXRange" : "inYRange";
  let a = !1;
  return Ha(e, n, t, (l, c, u) => {
    l[i](t[n], o) && (s.push({
      element: l,
      datasetIndex: c,
      index: u
    }), a = a || l.inRange(t.x, t.y, o));
  }), r && !a ? [] : s;
}
var W2 = {
  evaluateInteractionItems: Ha,
  modes: {
    index(e, t, n, r) {
      const o = Qo(t, e), s = n.axis || "x", i = n.includeInvisible || !1, a = n.intersect ? Wd(e, o, s, r, i) : Hd(e, o, s, !1, r, i), l = [];
      return a.length ? (e.getSortedVisibleDatasetMetas().forEach((c) => {
        const u = a[0].index, d = c.data[u];
        d && !d.skip && l.push({
          element: d,
          datasetIndex: c.index,
          index: u
        });
      }), l) : [];
    },
    dataset(e, t, n, r) {
      const o = Qo(t, e), s = n.axis || "xy", i = n.includeInvisible || !1;
      let a = n.intersect ? Wd(e, o, s, r, i) : Hd(e, o, s, !1, r, i);
      if (a.length > 0) {
        const l = a[0].datasetIndex, c = e.getDatasetMeta(l).data;
        a = [];
        for (let u = 0; u < c.length; ++u)
          a.push({
            element: c[u],
            datasetIndex: l,
            index: u
          });
      }
      return a;
    },
    point(e, t, n, r) {
      const o = Qo(t, e), s = n.axis || "xy", i = n.includeInvisible || !1;
      return Wd(e, o, s, r, i);
    },
    nearest(e, t, n, r) {
      const o = Qo(t, e), s = n.axis || "xy", i = n.includeInvisible || !1;
      return Hd(e, o, s, n.intersect, r, i);
    },
    x(e, t, n, r) {
      const o = Qo(t, e);
      return fv(e, o, "x", n.intersect, r);
    },
    y(e, t, n, r) {
      const o = Qo(t, e);
      return fv(e, o, "y", n.intersect, r);
    }
  }
};
const Vx = [
  "left",
  "top",
  "right",
  "bottom"
];
function Si(e, t) {
  return e.filter((n) => n.pos === t);
}
function hv(e, t) {
  return e.filter((n) => Vx.indexOf(n.pos) === -1 && n.box.axis === t);
}
function Oi(e, t) {
  return e.sort((n, r) => {
    const o = t ? r : n, s = t ? n : r;
    return o.weight === s.weight ? o.index - s.index : o.weight - s.weight;
  });
}
function H2(e) {
  const t = [];
  let n, r, o, s, i, a;
  for (n = 0, r = (e || []).length; n < r; ++n)
    o = e[n], { position: s, options: { stack: i, stackWeight: a = 1 } } = o, t.push({
      index: n,
      box: o,
      pos: s,
      horizontal: o.isHorizontal(),
      weight: o.weight,
      stack: i && s + i,
      stackWeight: a
    });
  return t;
}
function B2(e) {
  const t = {};
  for (const n of e) {
    const { stack: r, pos: o, stackWeight: s } = n;
    if (!r || !Vx.includes(o))
      continue;
    const i = t[r] || (t[r] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    i.count++, i.weight += s;
  }
  return t;
}
function z2(e, t) {
  const n = B2(e), { vBoxMaxWidth: r, hBoxMaxHeight: o } = t;
  let s, i, a;
  for (s = 0, i = e.length; s < i; ++s) {
    a = e[s];
    const { fullSize: l } = a.box, c = n[a.stack], u = c && a.stackWeight / c.weight;
    a.horizontal ? (a.width = u ? u * r : l && t.availableWidth, a.height = o) : (a.width = r, a.height = u ? u * o : l && t.availableHeight);
  }
  return n;
}
function Y2(e) {
  const t = H2(e), n = Oi(t.filter((c) => c.box.fullSize), !0), r = Oi(Si(t, "left"), !0), o = Oi(Si(t, "right")), s = Oi(Si(t, "top"), !0), i = Oi(Si(t, "bottom")), a = hv(t, "x"), l = hv(t, "y");
  return {
    fullSize: n,
    leftAndTop: r.concat(s),
    rightAndBottom: o.concat(l).concat(i).concat(a),
    chartArea: Si(t, "chartArea"),
    vertical: r.concat(o).concat(l),
    horizontal: s.concat(i).concat(a)
  };
}
function pv(e, t, n, r) {
  return Math.max(e[n], t[n]) + Math.max(e[r], t[r]);
}
function Wx(e, t) {
  e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
function j2(e, t, n, r) {
  const { pos: o, box: s } = n, i = e.maxPadding;
  if (!ht(o)) {
    n.size && (e[o] -= n.size);
    const d = r[n.stack] || {
      size: 0,
      count: 1
    };
    d.size = Math.max(d.size, n.horizontal ? s.height : s.width), n.size = d.size / d.count, e[o] += n.size;
  }
  s.getPadding && Wx(i, s.getPadding());
  const a = Math.max(0, t.outerWidth - pv(i, e, "left", "right")), l = Math.max(0, t.outerHeight - pv(i, e, "top", "bottom")), c = a !== e.w, u = l !== e.h;
  return e.w = a, e.h = l, n.horizontal ? {
    same: c,
    other: u
  } : {
    same: u,
    other: c
  };
}
function U2(e) {
  const t = e.maxPadding;
  function n(r) {
    const o = Math.max(t[r] - e[r], 0);
    return e[r] += o, o;
  }
  e.y += n("top"), e.x += n("left"), n("right"), n("bottom");
}
function G2(e, t) {
  const n = t.maxPadding;
  function r(o) {
    const s = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return o.forEach((i) => {
      s[i] = Math.max(t[i], n[i]);
    }), s;
  }
  return r(e ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function Bi(e, t, n, r) {
  const o = [];
  let s, i, a, l, c, u;
  for (s = 0, i = e.length, c = 0; s < i; ++s) {
    a = e[s], l = a.box, l.update(a.width || t.w, a.height || t.h, G2(a.horizontal, t));
    const { same: d, other: f } = j2(t, n, a, r);
    c |= d && o.length, u = u || f, l.fullSize || o.push(a);
  }
  return c && Bi(o, t, n, r) || u;
}
function Cl(e, t, n, r, o) {
  e.top = n, e.left = t, e.right = t + r, e.bottom = n + o, e.width = r, e.height = o;
}
function gv(e, t, n, r) {
  const o = n.padding;
  let { x: s, y: i } = t;
  for (const a of e) {
    const l = a.box, c = r[a.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, u = a.stackWeight / c.weight || 1;
    if (a.horizontal) {
      const d = t.w * u, f = c.size || l.height;
      pa(c.start) && (i = c.start), l.fullSize ? Cl(l, o.left, i, n.outerWidth - o.right - o.left, f) : Cl(l, t.left + c.placed, i, d, f), c.start = i, c.placed += d, i = l.bottom;
    } else {
      const d = t.h * u, f = c.size || l.width;
      pa(c.start) && (s = c.start), l.fullSize ? Cl(l, s, o.top, f, n.outerHeight - o.bottom - o.top) : Cl(l, s, t.top + c.placed, f, d), c.start = s, c.placed += d, s = l.right;
    }
  }
  t.x = s, t.y = i;
}
var El = {
  addBox(e, t) {
    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            t.draw(n);
          }
        }
      ];
    }, e.boxes.push(t);
  },
  removeBox(e, t) {
    const n = e.boxes ? e.boxes.indexOf(t) : -1;
    n !== -1 && e.boxes.splice(n, 1);
  },
  configure(e, t, n) {
    t.fullSize = n.fullSize, t.position = n.position, t.weight = n.weight;
  },
  update(e, t, n, r) {
    if (!e)
      return;
    const o = lr(e.options.layout.padding), s = Math.max(t - o.width, 0), i = Math.max(n - o.height, 0), a = Y2(e.boxes), l = a.vertical, c = a.horizontal;
    _t(e.boxes, (g) => {
      typeof g.beforeLayout == "function" && g.beforeLayout();
    });
    const u = l.reduce((g, m) => m.box.options && m.box.options.display === !1 ? g : g + 1, 0) || 1, d = Object.freeze({
      outerWidth: t,
      outerHeight: n,
      padding: o,
      availableWidth: s,
      availableHeight: i,
      vBoxMaxWidth: s / 2 / u,
      hBoxMaxHeight: i / 2
    }), f = Object.assign({}, o);
    Wx(f, lr(r));
    const h = Object.assign({
      maxPadding: f,
      w: s,
      h: i,
      x: o.left,
      y: o.top
    }, o), p = z2(l.concat(c), d);
    Bi(a.fullSize, h, d, p), Bi(l, h, d, p), Bi(c, h, d, p) && Bi(l, h, d, p), U2(h), gv(a.leftAndTop, h, d, p), h.x += h.w, h.y += h.h, gv(a.rightAndBottom, h, d, p), e.chartArea = {
      left: h.left,
      top: h.top,
      right: h.left + h.w,
      bottom: h.top + h.h,
      height: h.h,
      width: h.w
    }, _t(a.chartArea, (g) => {
      const m = g.box;
      Object.assign(m, e.chartArea), m.update(h.w, h.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class Hx {
  acquireContext(t, n) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, n, r) {
  }
  removeEventListener(t, n, r) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, n, r, o) {
    return n = Math.max(0, n || t.width), r = r || t.height, {
      width: n,
      height: Math.max(0, o ? Math.floor(n / o) : r)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class K2 extends Hx {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const Xl = "$chartjs", q2 = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, mv = (e) => e === null || e === "";
function X2(e, t) {
  const n = e.style, r = e.getAttribute("height"), o = e.getAttribute("width");
  if (e[Xl] = {
    initial: {
      height: r,
      width: o,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", mv(o)) {
    const s = Qb(e, "width");
    s !== void 0 && (e.width = s);
  }
  if (mv(r))
    if (e.style.height === "")
      e.height = e.width / (t || 2);
    else {
      const s = Qb(e, "height");
      s !== void 0 && (e.height = s);
    }
  return e;
}
const Bx = Xk ? {
  passive: !0
} : !1;
function Z2(e, t, n) {
  e.addEventListener(t, n, Bx);
}
function Q2(e, t, n) {
  e.canvas.removeEventListener(t, n, Bx);
}
function J2(e, t) {
  const n = q2[e.type] || e.type, { x: r, y: o } = Qo(e, t);
  return {
    type: n,
    chart: t,
    native: e,
    x: r !== void 0 ? r : null,
    y: o !== void 0 ? o : null
  };
}
function Pc(e, t) {
  for (const n of e)
    if (n === t || n.contains(t))
      return !0;
}
function eD(e, t, n) {
  const r = e.canvas, o = new MutationObserver((s) => {
    let i = !1;
    for (const a of s)
      i = i || Pc(a.addedNodes, r), i = i && !Pc(a.removedNodes, r);
    i && n();
  });
  return o.observe(document, {
    childList: !0,
    subtree: !0
  }), o;
}
function tD(e, t, n) {
  const r = e.canvas, o = new MutationObserver((s) => {
    let i = !1;
    for (const a of s)
      i = i || Pc(a.removedNodes, r), i = i && !Pc(a.addedNodes, r);
    i && n();
  });
  return o.observe(document, {
    childList: !0,
    subtree: !0
  }), o;
}
const ba = /* @__PURE__ */ new Map();
let bv = 0;
function zx() {
  const e = window.devicePixelRatio;
  e !== bv && (bv = e, ba.forEach((t, n) => {
    n.currentDevicePixelRatio !== e && t();
  }));
}
function nD(e, t) {
  ba.size || window.addEventListener("resize", zx), ba.set(e, t);
}
function rD(e) {
  ba.delete(e), ba.size || window.removeEventListener("resize", zx);
}
function oD(e, t, n) {
  const r = e.canvas, o = r && Wp(r);
  if (!o)
    return;
  const s = Ex((a, l) => {
    const c = o.clientWidth;
    n(a, l), c < o.clientWidth && n();
  }, window), i = new ResizeObserver((a) => {
    const l = a[0], c = l.contentRect.width, u = l.contentRect.height;
    c === 0 && u === 0 || s(c, u);
  });
  return i.observe(o), nD(e, s), i;
}
function Bd(e, t, n) {
  n && n.disconnect(), t === "resize" && rD(e);
}
function sD(e, t, n) {
  const r = e.canvas, o = Ex((s) => {
    e.ctx !== null && n(J2(s, e));
  }, e);
  return Z2(r, t, o), o;
}
class iD extends Hx {
  acquireContext(t, n) {
    const r = t && t.getContext && t.getContext("2d");
    return r && r.canvas === t ? (X2(t, n), r) : null;
  }
  releaseContext(t) {
    const n = t.canvas;
    if (!n[Xl])
      return !1;
    const r = n[Xl].initial;
    [
      "height",
      "width"
    ].forEach((s) => {
      const i = r[s];
      St(i) ? n.removeAttribute(s) : n.setAttribute(s, i);
    });
    const o = r.style || {};
    return Object.keys(o).forEach((s) => {
      n.style[s] = o[s];
    }), n.width = n.width, delete n[Xl], !0;
  }
  addEventListener(t, n, r) {
    this.removeEventListener(t, n);
    const o = t.$proxies || (t.$proxies = {}), i = {
      attach: eD,
      detach: tD,
      resize: oD
    }[n] || sD;
    o[n] = i(t, n, r);
  }
  removeEventListener(t, n) {
    const r = t.$proxies || (t.$proxies = {}), o = r[n];
    if (!o)
      return;
    ({
      attach: Bd,
      detach: Bd,
      resize: Bd
    }[n] || Q2)(t, n, o), r[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, n, r, o) {
    return qk(t, n, r, o);
  }
  isAttached(t) {
    const n = Wp(t);
    return !!(n && n.isConnected);
  }
}
function aD(e) {
  return !Dx() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? K2 : iD;
}
var Yl;
let xs = (Yl = class {
  constructor() {
    ce(this, "x");
    ce(this, "y");
    ce(this, "active", !1);
    ce(this, "options");
    ce(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: n, y: r } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: n,
      y: r
    };
  }
  hasValue() {
    return ga(this.x) && ga(this.y);
  }
  getProps(t, n) {
    const r = this.$animations;
    if (!n || !r)
      return this;
    const o = {};
    return t.forEach((s) => {
      o[s] = r[s] && r[s].active() ? r[s]._to : this[s];
    }), o;
  }
}, ce(Yl, "defaults", {}), ce(Yl, "defaultRoutes"), Yl);
function lD(e, t) {
  const n = e.options.ticks, r = cD(e), o = Math.min(n.maxTicksLimit || r, r), s = n.major.enabled ? dD(t) : [], i = s.length, a = s[0], l = s[i - 1], c = [];
  if (i > o)
    return fD(t, c, s, i / o), c;
  const u = uD(s, t, o);
  if (i > 0) {
    let d, f;
    const h = i > 1 ? Math.round((l - a) / (i - 1)) : null;
    for (_l(t, c, u, St(h) ? 0 : a - h, a), d = 0, f = i - 1; d < f; d++)
      _l(t, c, u, s[d], s[d + 1]);
    return _l(t, c, u, l, St(h) ? t.length : l + h), c;
  }
  return _l(t, c, u), c;
}
function cD(e) {
  const t = e.options.offset, n = e._tickSize(), r = e._length / n + (t ? 0 : 1), o = e._maxLength / n;
  return Math.floor(Math.min(r, o));
}
function uD(e, t, n) {
  const r = hD(e), o = t.length / n;
  if (!r)
    return Math.max(o, 1);
  const s = XI(r);
  for (let i = 0, a = s.length - 1; i < a; i++) {
    const l = s[i];
    if (l > o)
      return l;
  }
  return Math.max(o, 1);
}
function dD(e) {
  const t = [];
  let n, r;
  for (n = 0, r = e.length; n < r; n++)
    e[n].major && t.push(n);
  return t;
}
function fD(e, t, n, r) {
  let o = 0, s = n[0], i;
  for (r = Math.ceil(r), i = 0; i < e.length; i++)
    i === s && (t.push(e[i]), o++, s = n[o * r]);
}
function _l(e, t, n, r, o) {
  const s = mt(r, 0), i = Math.min(mt(o, e.length), e.length);
  let a = 0, l, c, u;
  for (n = Math.ceil(n), o && (l = o - r, n = l / Math.floor(l / n)), u = s; u < 0; )
    a++, u = Math.round(s + a * n);
  for (c = Math.max(s, 0); c < i; c++)
    c === u && (t.push(e[c]), a++, u = Math.round(s + a * n));
}
function hD(e) {
  const t = e.length;
  let n, r;
  if (t < 2)
    return !1;
  for (r = e[0], n = 1; n < t; ++n)
    if (e[n] - e[n - 1] !== r)
      return !1;
  return r;
}
const pD = (e) => e === "left" ? "right" : e === "right" ? "left" : e, vv = (e, t, n) => t === "top" || t === "left" ? e[t] + n : e[t] - n, yv = (e, t) => Math.min(t || e, e);
function xv(e, t) {
  const n = [], r = e.length / t, o = e.length;
  let s = 0;
  for (; s < o; s += r)
    n.push(e[Math.floor(s)]);
  return n;
}
function gD(e, t, n) {
  const r = e.ticks.length, o = Math.min(t, r - 1), s = e._startPixel, i = e._endPixel, a = 1e-6;
  let l = e.getPixelForTick(o), c;
  if (!(n && (r === 1 ? c = Math.max(l - s, i - l) : t === 0 ? c = (e.getPixelForTick(1) - l) / 2 : c = (l - e.getPixelForTick(o - 1)) / 2, l += o < t ? c : -c, l < s - a || l > i + a)))
    return l;
}
function mD(e, t) {
  _t(e, (n) => {
    const r = n.gc, o = r.length / 2;
    let s;
    if (o > t) {
      for (s = 0; s < o; ++s)
        delete n.data[r[s]];
      r.splice(0, o);
    }
  });
}
function Mi(e) {
  return e.drawTicks ? e.tickLength : 0;
}
function wv(e, t) {
  if (!e.display)
    return 0;
  const n = Kn(e.font, t), r = lr(e.padding);
  return (Xt(e.text) ? e.text.length : 1) * n.lineHeight + r.height;
}
function bD(e, t) {
  return Bo(e, {
    scale: t,
    type: "scale"
  });
}
function vD(e, t, n) {
  return Bo(e, {
    tick: n,
    index: t,
    type: "tick"
  });
}
function yD(e, t, n) {
  let r = ok(e);
  return (n && t !== "right" || !n && t === "right") && (r = pD(r)), r;
}
function xD(e, t, n, r) {
  const { top: o, left: s, bottom: i, right: a, chart: l } = e, { chartArea: c, scales: u } = l;
  let d = 0, f, h, p;
  const g = i - o, m = a - s;
  if (e.isHorizontal()) {
    if (h = zb(r, s, a), ht(n)) {
      const v = Object.keys(n)[0], y = n[v];
      p = u[v].getPixelForValue(y) + g - t;
    } else
      n === "center" ? p = (c.bottom + c.top) / 2 + g - t : p = vv(e, n, t);
    f = a - s;
  } else {
    if (ht(n)) {
      const v = Object.keys(n)[0], y = n[v];
      h = u[v].getPixelForValue(y) - m + t;
    } else
      n === "center" ? h = (c.left + c.right) / 2 - m + t : h = vv(e, n, t);
    p = zb(r, i, o), d = n === "left" ? -on : on;
  }
  return {
    titleX: h,
    titleY: p,
    maxWidth: f,
    rotation: d
  };
}
class ws extends xs {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, n) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: n, _suggestedMin: r, _suggestedMax: o } = this;
    return t = Bn(t, Number.POSITIVE_INFINITY), n = Bn(n, Number.NEGATIVE_INFINITY), r = Bn(r, Number.POSITIVE_INFINITY), o = Bn(o, Number.NEGATIVE_INFINITY), {
      min: Bn(t, r),
      max: Bn(n, o),
      minDefined: En(t),
      maxDefined: En(n)
    };
  }
  getMinMax(t) {
    let { min: n, max: r, minDefined: o, maxDefined: s } = this.getUserBounds(), i;
    if (o && s)
      return {
        min: n,
        max: r
      };
    const a = this.getMatchingVisibleMetas();
    for (let l = 0, c = a.length; l < c; ++l)
      i = a[l].controller.getMinMax(this, t), o || (n = Math.min(n, i.min)), s || (r = Math.max(r, i.max));
    return n = s && n > r ? r : n, r = o && n > r ? n : r, {
      min: Bn(n, Bn(r, n)),
      max: Bn(r, Bn(n, r))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    nn(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, n, r) {
    const { beginAtZero: o, grace: s, ticks: i } = this.options, a = i.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = n, this._margins = r = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, r), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + r.left + r.right : this.height + r.top + r.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = Mk(this, s, o), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = a < this.ticks.length;
    this._convertTicksToLabels(l ? xv(this.ticks, a) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), i.display && (i.autoSkip || i.source === "auto") && (this.ticks = lD(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, n, r;
    this.isHorizontal() ? (n = this.left, r = this.right) : (n = this.top, r = this.bottom, t = !t), this._startPixel = n, this._endPixel = r, this._reversePixels = t, this._length = r - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    nn(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    nn(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    nn(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), nn(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    nn(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const n = this.options.ticks;
    let r, o, s;
    for (r = 0, o = t.length; r < o; r++)
      s = t[r], s.label = nn(n.callback, [
        s.value,
        r,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    nn(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    nn(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, n = t.ticks, r = yv(this.ticks.length, t.ticks.maxTicksLimit), o = n.minRotation || 0, s = n.maxRotation;
    let i = o, a, l, c;
    if (!this._isVisible() || !n.display || o >= s || r <= 1 || !this.isHorizontal()) {
      this.labelRotation = o;
      return;
    }
    const u = this._getLabelSizes(), d = u.widest.width, f = u.highest.height, h = kn(this.chart.width - d, 0, this.maxWidth);
    a = t.offset ? this.maxWidth / r : h / (r - 1), d + 6 > a && (a = h / (r - (t.offset ? 0.5 : 1)), l = this.maxHeight - Mi(t.grid) - n.padding - wv(t.title, this.chart.options.font), c = Math.sqrt(d * d + f * f), i = Dp(Math.min(Math.asin(kn((u.highest.height + 6) / a, -1, 1)), Math.asin(kn(l / c, -1, 1)) - Math.asin(kn(f / c, -1, 1)))), i = Math.max(o, Math.min(s, i))), this.labelRotation = i;
  }
  afterCalculateLabelRotation() {
    nn(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    nn(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: r, title: o, grid: s } } = this, i = this._isVisible(), a = this.isHorizontal();
    if (i) {
      const l = wv(o, n.options.font);
      if (a ? (t.width = this.maxWidth, t.height = Mi(s) + l) : (t.height = this.maxHeight, t.width = Mi(s) + l), r.display && this.ticks.length) {
        const { first: c, last: u, widest: d, highest: f } = this._getLabelSizes(), h = r.padding * 2, p = kr(this.labelRotation), g = Math.cos(p), m = Math.sin(p);
        if (a) {
          const v = r.mirror ? 0 : m * d.width + g * f.height;
          t.height = Math.min(this.maxHeight, t.height + v + h);
        } else {
          const v = r.mirror ? 0 : g * d.width + m * f.height;
          t.width = Math.min(this.maxWidth, t.width + v + h);
        }
        this._calculatePadding(c, u, m, g);
      }
    }
    this._handleMargins(), a ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, n, r, o) {
    const { ticks: { align: s, padding: i }, position: a } = this.options, l = this.labelRotation !== 0, c = a !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let f = 0, h = 0;
      l ? c ? (f = o * t.width, h = r * n.height) : (f = r * t.height, h = o * n.width) : s === "start" ? h = n.width : s === "end" ? f = t.width : s !== "inner" && (f = t.width / 2, h = n.width / 2), this.paddingLeft = Math.max((f - u + i) * this.width / (this.width - u), 0), this.paddingRight = Math.max((h - d + i) * this.width / (this.width - d), 0);
    } else {
      let u = n.height / 2, d = t.height / 2;
      s === "start" ? (u = 0, d = t.height) : s === "end" && (u = n.height, d = 0), this.paddingTop = u + i, this.paddingBottom = d + i;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    nn(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: n } = this.options;
    return n === "top" || n === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let n, r;
    for (n = 0, r = t.length; n < r; n++)
      St(t[n].label) && (t.splice(n, 1), r--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const n = this.options.ticks.sampleSize;
      let r = this.ticks;
      n < r.length && (r = xv(r, n)), this._labelSizes = t = this._computeLabelSizes(r, r.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, n, r) {
    const { ctx: o, _longestTextCache: s } = this, i = [], a = [], l = Math.floor(n / yv(n, r));
    let c = 0, u = 0, d, f, h, p, g, m, v, y, x, C, w;
    for (d = 0; d < n; d += l) {
      if (p = t[d].label, g = this._resolveTickFontOptions(d), o.font = m = g.string, v = s[m] = s[m] || {
        data: {},
        gc: []
      }, y = g.lineHeight, x = C = 0, !St(p) && !Xt(p))
        x = Oc(o, v.data, v.gc, x, p), C = y;
      else if (Xt(p))
        for (f = 0, h = p.length; f < h; ++f)
          w = p[f], !St(w) && !Xt(w) && (x = Oc(o, v.data, v.gc, x, w), C += y);
      i.push(x), a.push(C), c = Math.max(x, c), u = Math.max(C, u);
    }
    mD(s, n);
    const E = i.indexOf(c), S = a.indexOf(u), O = (M) => ({
      width: i[M] || 0,
      height: a[M] || 0
    });
    return {
      first: O(0),
      last: O(n - 1),
      widest: O(E),
      highest: O(S),
      widths: i,
      heights: a
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, n) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const n = this._startPixel + t * this._length;
    return JI(this._alignToPixels ? qo(this.chart, n, 0) : n);
  }
  getDecimalForPixel(t) {
    const n = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: n } = this;
    return t < 0 && n < 0 ? n : t > 0 && n > 0 ? t : 0;
  }
  getContext(t) {
    const n = this.ticks || [];
    if (t >= 0 && t < n.length) {
      const r = n[t];
      return r.$context || (r.$context = vD(this.getContext(), t, r));
    }
    return this.$context || (this.$context = bD(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, n = kr(this.labelRotation), r = Math.abs(Math.cos(n)), o = Math.abs(Math.sin(n)), s = this._getLabelSizes(), i = t.autoSkipPadding || 0, a = s ? s.widest.width + i : 0, l = s ? s.highest.height + i : 0;
    return this.isHorizontal() ? l * r > a * o ? a / r : l / o : l * o < a * r ? l / r : a / o;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const n = this.axis, r = this.chart, o = this.options, { grid: s, position: i, border: a } = o, l = s.offset, c = this.isHorizontal(), d = this.ticks.length + (l ? 1 : 0), f = Mi(s), h = [], p = a.setContext(this.getContext()), g = p.display ? p.width : 0, m = g / 2, v = function($) {
      return qo(r, $, g);
    };
    let y, x, C, w, E, S, O, M, T, P, I, R;
    if (i === "top")
      y = v(this.bottom), S = this.bottom - f, M = y - m, P = v(t.top) + m, R = t.bottom;
    else if (i === "bottom")
      y = v(this.top), P = t.top, R = v(t.bottom) - m, S = y + m, M = this.top + f;
    else if (i === "left")
      y = v(this.right), E = this.right - f, O = y - m, T = v(t.left) + m, I = t.right;
    else if (i === "right")
      y = v(this.left), T = t.left, I = v(t.right) - m, E = y + m, O = this.left + f;
    else if (n === "x") {
      if (i === "center")
        y = v((t.top + t.bottom) / 2 + 0.5);
      else if (ht(i)) {
        const $ = Object.keys(i)[0], L = i[$];
        y = v(this.chart.scales[$].getPixelForValue(L));
      }
      P = t.top, R = t.bottom, S = y + m, M = S + f;
    } else if (n === "y") {
      if (i === "center")
        y = v((t.left + t.right) / 2);
      else if (ht(i)) {
        const $ = Object.keys(i)[0], L = i[$];
        y = v(this.chart.scales[$].getPixelForValue(L));
      }
      E = y - m, O = E - f, T = t.left, I = t.right;
    }
    const D = mt(o.ticks.maxTicksLimit, d), k = Math.max(1, Math.ceil(d / D));
    for (x = 0; x < d; x += k) {
      const $ = this.getContext(x), L = s.setContext($), A = a.setContext($), F = L.lineWidth, N = L.color, V = A.dash || [], K = A.dashOffset, Y = L.tickWidth, U = L.tickColor, j = L.tickBorderDash || [], H = L.tickBorderDashOffset;
      C = gD(this, x, l), C !== void 0 && (w = qo(r, C, F), c ? E = O = T = I = w : S = M = P = R = w, h.push({
        tx1: E,
        ty1: S,
        tx2: O,
        ty2: M,
        x1: T,
        y1: P,
        x2: I,
        y2: R,
        width: F,
        color: N,
        borderDash: V,
        borderDashOffset: K,
        tickWidth: Y,
        tickColor: U,
        tickBorderDash: j,
        tickBorderDashOffset: H
      }));
    }
    return this._ticksLength = d, this._borderValue = y, h;
  }
  _computeLabelItems(t) {
    const n = this.axis, r = this.options, { position: o, ticks: s } = r, i = this.isHorizontal(), a = this.ticks, { align: l, crossAlign: c, padding: u, mirror: d } = s, f = Mi(r.grid), h = f + u, p = d ? -u : h, g = -kr(this.labelRotation), m = [];
    let v, y, x, C, w, E, S, O, M, T, P, I, R = "middle";
    if (o === "top")
      E = this.bottom - p, S = this._getXAxisLabelAlignment();
    else if (o === "bottom")
      E = this.top + p, S = this._getXAxisLabelAlignment();
    else if (o === "left") {
      const k = this._getYAxisLabelAlignment(f);
      S = k.textAlign, w = k.x;
    } else if (o === "right") {
      const k = this._getYAxisLabelAlignment(f);
      S = k.textAlign, w = k.x;
    } else if (n === "x") {
      if (o === "center")
        E = (t.top + t.bottom) / 2 + h;
      else if (ht(o)) {
        const k = Object.keys(o)[0], $ = o[k];
        E = this.chart.scales[k].getPixelForValue($) + h;
      }
      S = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (o === "center")
        w = (t.left + t.right) / 2 - h;
      else if (ht(o)) {
        const k = Object.keys(o)[0], $ = o[k];
        w = this.chart.scales[k].getPixelForValue($);
      }
      S = this._getYAxisLabelAlignment(f).textAlign;
    }
    n === "y" && (l === "start" ? R = "top" : l === "end" && (R = "bottom"));
    const D = this._getLabelSizes();
    for (v = 0, y = a.length; v < y; ++v) {
      x = a[v], C = x.label;
      const k = s.setContext(this.getContext(v));
      O = this.getPixelForTick(v) + s.labelOffset, M = this._resolveTickFontOptions(v), T = M.lineHeight, P = Xt(C) ? C.length : 1;
      const $ = P / 2, L = k.color, A = k.textStrokeColor, F = k.textStrokeWidth;
      let N = S;
      i ? (w = O, S === "inner" && (v === y - 1 ? N = this.options.reverse ? "left" : "right" : v === 0 ? N = this.options.reverse ? "right" : "left" : N = "center"), o === "top" ? c === "near" || g !== 0 ? I = -P * T + T / 2 : c === "center" ? I = -D.highest.height / 2 - $ * T + T : I = -D.highest.height + T / 2 : c === "near" || g !== 0 ? I = T / 2 : c === "center" ? I = D.highest.height / 2 - $ * T : I = D.highest.height - P * T, d && (I *= -1), g !== 0 && !k.showLabelBackdrop && (w += T / 2 * Math.sin(g))) : (E = O, I = (1 - P) * T / 2);
      let V;
      if (k.showLabelBackdrop) {
        const K = lr(k.backdropPadding), Y = D.heights[v], U = D.widths[v];
        let j = I - K.top, H = 0 - K.left;
        switch (R) {
          case "middle":
            j -= Y / 2;
            break;
          case "bottom":
            j -= Y;
            break;
        }
        switch (S) {
          case "center":
            H -= U / 2;
            break;
          case "right":
            H -= U;
            break;
        }
        V = {
          left: H,
          top: j,
          width: U + K.width,
          height: Y + K.height,
          color: k.backdropColor
        };
      }
      m.push({
        label: C,
        font: M,
        textOffset: I,
        options: {
          rotation: g,
          color: L,
          strokeColor: A,
          strokeWidth: F,
          textAlign: N,
          textBaseline: R,
          translation: [
            w,
            E
          ],
          backdrop: V
        }
      });
    }
    return m;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: n } = this.options;
    if (-kr(this.labelRotation))
      return t === "top" ? "left" : "right";
    let o = "center";
    return n.align === "start" ? o = "left" : n.align === "end" ? o = "right" : n.align === "inner" && (o = "inner"), o;
  }
  _getYAxisLabelAlignment(t) {
    const { position: n, ticks: { crossAlign: r, mirror: o, padding: s } } = this.options, i = this._getLabelSizes(), a = t + s, l = i.widest.width;
    let c, u;
    return n === "left" ? o ? (u = this.right + s, r === "near" ? c = "left" : r === "center" ? (c = "center", u += l / 2) : (c = "right", u += l)) : (u = this.right - a, r === "near" ? c = "right" : r === "center" ? (c = "center", u -= l / 2) : (c = "left", u = this.left)) : n === "right" ? o ? (u = this.left + s, r === "near" ? c = "right" : r === "center" ? (c = "center", u -= l / 2) : (c = "left", u -= l)) : (u = this.left + a, r === "near" ? c = "left" : r === "center" ? (c = "center", u += l / 2) : (c = "right", u = this.right)) : c = "right", {
      textAlign: c,
      x: u
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: n }, left: r, top: o, width: s, height: i } = this;
    n && (t.save(), t.fillStyle = n, t.fillRect(r, o, s, i), t.restore());
  }
  getLineWidthForValue(t) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const o = this.ticks.findIndex((s) => s.value === t);
    return o >= 0 ? n.setContext(this.getContext(o)).lineWidth : 0;
  }
  drawGrid(t) {
    const n = this.options.grid, r = this.ctx, o = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let s, i;
    const a = (l, c, u) => {
      !u.width || !u.color || (r.save(), r.lineWidth = u.width, r.strokeStyle = u.color, r.setLineDash(u.borderDash || []), r.lineDashOffset = u.borderDashOffset, r.beginPath(), r.moveTo(l.x, l.y), r.lineTo(c.x, c.y), r.stroke(), r.restore());
    };
    if (n.display)
      for (s = 0, i = o.length; s < i; ++s) {
        const l = o[s];
        n.drawOnChartArea && a({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), n.drawTicks && a({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: n, options: { border: r, grid: o } } = this, s = r.setContext(this.getContext()), i = r.display ? s.width : 0;
    if (!i)
      return;
    const a = o.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let c, u, d, f;
    this.isHorizontal() ? (c = qo(t, this.left, i) - i / 2, u = qo(t, this.right, a) + a / 2, d = f = l) : (d = qo(t, this.top, i) - i / 2, f = qo(t, this.bottom, a) + a / 2, c = u = l), n.save(), n.lineWidth = s.width, n.strokeStyle = s.color, n.beginPath(), n.moveTo(c, d), n.lineTo(u, f), n.stroke(), n.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const r = this.ctx, o = this._computeLabelArea();
    o && Sx(r, o);
    const s = this.getLabelItems(t);
    for (const i of s) {
      const a = i.options, l = i.font, c = i.label, u = i.textOffset;
      Mc(r, c, 0, u, l, a);
    }
    o && Ox(r);
  }
  drawTitle() {
    const { ctx: t, options: { position: n, title: r, reverse: o } } = this;
    if (!r.display)
      return;
    const s = Kn(r.font), i = lr(r.padding), a = r.align;
    let l = s.lineHeight / 2;
    n === "bottom" || n === "center" || ht(n) ? (l += i.bottom, Xt(r.text) && (l += s.lineHeight * (r.text.length - 1))) : l += i.top;
    const { titleX: c, titleY: u, maxWidth: d, rotation: f } = xD(this, l, n, a);
    Mc(t, r.text, 0, 0, s, {
      color: r.color,
      maxWidth: d,
      rotation: f,
      textAlign: yD(a, n, o),
      textBaseline: "middle",
      translation: [
        c,
        u
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, n = t.ticks && t.ticks.z || 0, r = mt(t.grid && t.grid.z, -1), o = mt(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== ws.prototype.draw ? [
      {
        z: n,
        draw: (s) => {
          this.draw(s);
        }
      }
    ] : [
      {
        z: r,
        draw: (s) => {
          this.drawBackground(), this.drawGrid(s), this.drawTitle();
        }
      },
      {
        z: o,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (s) => {
          this.drawLabels(s);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const n = this.chart.getSortedVisibleDatasetMetas(), r = this.axis + "AxisID", o = [];
    let s, i;
    for (s = 0, i = n.length; s < i; ++s) {
      const a = n[s];
      a[r] === this.id && (!t || a.type === t) && o.push(a);
    }
    return o;
  }
  _resolveTickFontOptions(t) {
    const n = this.options.ticks.setContext(this.getContext(t));
    return Kn(n.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class Sl {
  constructor(t, n, r) {
    this.type = t, this.scope = n, this.override = r, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const n = Object.getPrototypeOf(t);
    let r;
    ED(n) && (r = this.register(n));
    const o = this.items, s = t.id, i = this.scope + "." + s;
    if (!s)
      throw new Error("class does not have id: " + t);
    return s in o || (o[s] = t, wD(t, i, r), this.override && ln.override(t.id, t.overrides)), i;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const n = this.items, r = t.id, o = this.scope;
    r in n && delete n[r], o && r in ln[o] && (delete ln[o][r], this.override && delete hs[r]);
  }
}
function wD(e, t, n) {
  const r = ha(/* @__PURE__ */ Object.create(null), [
    n ? ln.get(n) : {},
    ln.get(t),
    e.defaults
  ]);
  ln.set(t, r), e.defaultRoutes && CD(t, e.defaultRoutes), e.descriptors && ln.describe(t, e.descriptors);
}
function CD(e, t) {
  Object.keys(t).forEach((n) => {
    const r = n.split("."), o = r.pop(), s = [
      e
    ].concat(r).join("."), i = t[n].split("."), a = i.pop(), l = i.join(".");
    ln.route(s, o, l, a);
  });
}
function ED(e) {
  return "id" in e && "defaults" in e;
}
class _D {
  constructor() {
    this.controllers = new Sl(us, "datasets", !0), this.elements = new Sl(xs, "elements"), this.plugins = new Sl(Object, "plugins"), this.scales = new Sl(ws, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, n, r) {
    [
      ...n
    ].forEach((o) => {
      const s = r || this._getRegistryForType(o);
      r || s.isForType(o) || s === this.plugins && o.id ? this._exec(t, s, o) : _t(o, (i) => {
        const a = r || this._getRegistryForType(i);
        this._exec(t, a, i);
      });
    });
  }
  _exec(t, n, r) {
    const o = kp(t);
    nn(r["before" + o], [], r), n[t](r), nn(r["after" + o], [], r);
  }
  _getRegistryForType(t) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const r = this._typedRegistries[n];
      if (r.isForType(t))
        return r;
    }
    return this.plugins;
  }
  _get(t, n, r) {
    const o = n.get(t);
    if (o === void 0)
      throw new Error('"' + t + '" is not a registered ' + r + ".");
    return o;
  }
}
var Or = /* @__PURE__ */ new _D();
class SD {
  constructor() {
    this._init = [];
  }
  notify(t, n, r, o) {
    n === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const s = o ? this._descriptors(t).filter(o) : this._descriptors(t), i = this._notify(s, t, n, r);
    return n === "afterDestroy" && (this._notify(s, t, "stop"), this._notify(this._init, t, "uninstall")), i;
  }
  _notify(t, n, r, o) {
    o = o || {};
    for (const s of t) {
      const i = s.plugin, a = i[r], l = [
        n,
        o,
        s.options
      ];
      if (nn(a, l, i) === !1 && o.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    St(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), n;
  }
  _createDescriptors(t, n) {
    const r = t && t.config, o = mt(r.options && r.options.plugins, {}), s = OD(r);
    return o === !1 && !n ? [] : TD(t, s, o, n);
  }
  _notifyStateChanges(t) {
    const n = this._oldCache || [], r = this._cache, o = (s, i) => s.filter((a) => !i.some((l) => a.plugin.id === l.plugin.id));
    this._notify(o(n, r), t, "stop"), this._notify(o(r, n), t, "start");
  }
}
function OD(e) {
  const t = {}, n = [], r = Object.keys(Or.plugins.items);
  for (let s = 0; s < r.length; s++)
    n.push(Or.getPlugin(r[s]));
  const o = e.plugins || [];
  for (let s = 0; s < o.length; s++) {
    const i = o[s];
    n.indexOf(i) === -1 && (n.push(i), t[i.id] = !0);
  }
  return {
    plugins: n,
    localIds: t
  };
}
function MD(e, t) {
  return !t && e === !1 ? null : e === !0 ? {} : e;
}
function TD(e, { plugins: t, localIds: n }, r, o) {
  const s = [], i = e.getContext();
  for (const a of t) {
    const l = a.id, c = MD(r[l], o);
    c !== null && s.push({
      plugin: a,
      options: RD(e.config, {
        plugin: a,
        local: n[l]
      }, c, i)
    });
  }
  return s;
}
function RD(e, { plugin: t, local: n }, r, o) {
  const s = e.pluginScopeKeys(t), i = e.getOptionScopes(r, s);
  return n && t.defaults && i.push(t.defaults), e.createResolver(i, o, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function qf(e, t) {
  const n = ln.datasets[e] || {};
  return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || n.indexAxis || "x";
}
function PD(e, t) {
  let n = e;
  return e === "_index_" ? n = t : e === "_value_" && (n = t === "x" ? "y" : "x"), n;
}
function ID(e, t) {
  return e === t ? "_index_" : "_value_";
}
function Cv(e) {
  if (e === "x" || e === "y" || e === "r")
    return e;
}
function kD(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
function Xf(e, ...t) {
  if (Cv(e))
    return e;
  for (const n of t) {
    const r = n.axis || kD(n.position) || e.length > 1 && Cv(e[0].toLowerCase());
    if (r)
      return r;
  }
  throw new Error(`Cannot determine type of '${e}' axis. Please provide 'axis' or 'position' option.`);
}
function Ev(e, t, n) {
  if (n[t + "AxisID"] === e)
    return {
      axis: t
    };
}
function DD(e, t) {
  if (t.data && t.data.datasets) {
    const n = t.data.datasets.filter((r) => r.xAxisID === e || r.yAxisID === e);
    if (n.length)
      return Ev(e, "x", n[0]) || Ev(e, "y", n[0]);
  }
  return {};
}
function ND(e, t) {
  const n = hs[e.type] || {
    scales: {}
  }, r = t.scales || {}, o = qf(e.type, t), s = /* @__PURE__ */ Object.create(null);
  return Object.keys(r).forEach((i) => {
    const a = r[i];
    if (!ht(a))
      return console.error(`Invalid scale configuration for scale: ${i}`);
    if (a._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${i}`);
    const l = Xf(i, a, DD(i, e), ln.scales[a.type]), c = ID(l, o), u = n.scales || {};
    s[i] = Qi(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      a,
      u[l],
      u[c]
    ]);
  }), e.data.datasets.forEach((i) => {
    const a = i.type || e.type, l = i.indexAxis || qf(a, t), u = (hs[a] || {}).scales || {};
    Object.keys(u).forEach((d) => {
      const f = PD(d, l), h = i[f + "AxisID"] || f;
      s[h] = s[h] || /* @__PURE__ */ Object.create(null), Qi(s[h], [
        {
          axis: f
        },
        r[h],
        u[d]
      ]);
    });
  }), Object.keys(s).forEach((i) => {
    const a = s[i];
    Qi(a, [
      ln.scales[a.type],
      ln.scale
    ]);
  }), s;
}
function Yx(e) {
  const t = e.options || (e.options = {});
  t.plugins = mt(t.plugins, {}), t.scales = ND(e, t);
}
function jx(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function AD(e) {
  return e = e || {}, e.data = jx(e.data), Yx(e), e;
}
const _v = /* @__PURE__ */ new Map(), Ux = /* @__PURE__ */ new Set();
function Ol(e, t) {
  let n = _v.get(e);
  return n || (n = t(), _v.set(e, n), Ux.add(n)), n;
}
const Ti = (e, t, n) => {
  const r = fs(t, n);
  r !== void 0 && e.add(r);
};
class $D {
  constructor(t) {
    this._config = AD(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = jx(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), Yx(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return Ol(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, n) {
    return Ol(`${t}.transition.${n}`, () => [
      [
        `datasets.${t}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, n) {
    return Ol(`${t}-${n}`, () => [
      [
        `datasets.${t}.elements.${n}`,
        `datasets.${t}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const n = t.id, r = this.type;
    return Ol(`${r}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, n) {
    const r = this._scopeCache;
    let o = r.get(t);
    return (!o || n) && (o = /* @__PURE__ */ new Map(), r.set(t, o)), o;
  }
  getOptionScopes(t, n, r) {
    const { options: o, type: s } = this, i = this._cachedScopes(t, r), a = i.get(n);
    if (a)
      return a;
    const l = /* @__PURE__ */ new Set();
    n.forEach((u) => {
      t && (l.add(t), u.forEach((d) => Ti(l, t, d))), u.forEach((d) => Ti(l, o, d)), u.forEach((d) => Ti(l, hs[s] || {}, d)), u.forEach((d) => Ti(l, ln, d)), u.forEach((d) => Ti(l, Gf, d));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), Ux.has(n) && i.set(n, c), c;
  }
  chartOptionScopes() {
    const { options: t, type: n } = this;
    return [
      t,
      hs[n] || {},
      ln.datasets[n] || {},
      {
        type: n
      },
      ln,
      Gf
    ];
  }
  resolveNamedOptions(t, n, r, o = [
    ""
  ]) {
    const s = {
      $shared: !0
    }, { resolver: i, subPrefixes: a } = Sv(this._resolverCache, t, o);
    let l = i;
    if (LD(i, n)) {
      s.$shared = !1, r = Do(r) ? r() : r;
      const c = this.createResolver(t, r, a);
      l = Js(i, r, c);
    }
    for (const c of n)
      s[c] = l[c];
    return s;
  }
  createResolver(t, n, r = [
    ""
  ], o) {
    const { resolver: s } = Sv(this._resolverCache, t, r);
    return ht(n) ? Js(s, n, void 0, o) : s;
  }
}
function Sv(e, t, n) {
  let r = e.get(t);
  r || (r = /* @__PURE__ */ new Map(), e.set(t, r));
  const o = n.join();
  let s = r.get(o);
  return s || (s = {
    resolver: Fp(t, n),
    subPrefixes: n.filter((a) => !a.toLowerCase().includes("hover"))
  }, r.set(o, s)), s;
}
const FD = (e) => ht(e) && Object.getOwnPropertyNames(e).reduce((t, n) => t || Do(e[n]), !1);
function LD(e, t) {
  const { isScriptable: n, isIndexable: r } = Tx(e);
  for (const o of t) {
    const s = n(o), i = r(o), a = (i || s) && e[o];
    if (s && (Do(a) || FD(a)) || i && Xt(a))
      return !0;
  }
  return !1;
}
var VD = "4.3.3";
const WD = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function Ov(e, t) {
  return e === "top" || e === "bottom" || WD.indexOf(e) === -1 && t === "x";
}
function Mv(e, t) {
  return function(n, r) {
    return n[e] === r[e] ? n[t] - r[t] : n[e] - r[e];
  };
}
function Tv(e) {
  const t = e.chart, n = t.options.animation;
  t.notifyPlugins("afterRender"), nn(n && n.onComplete, [
    e
  ], t);
}
function HD(e) {
  const t = e.chart, n = t.options.animation;
  nn(n && n.onProgress, [
    e
  ], t);
}
function Gx(e) {
  return Dx() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
const Zl = {}, Rv = (e) => {
  const t = Gx(e);
  return Object.values(Zl).filter((n) => n.canvas === t).pop();
};
function BD(e, t, n) {
  const r = Object.keys(e);
  for (const o of r) {
    const s = +o;
    if (s >= t) {
      const i = e[o];
      delete e[o], (n > 0 || s > t) && (e[s + n] = i);
    }
  }
}
function zD(e, t, n, r) {
  return !n || e.type === "mouseout" ? null : r ? t : e;
}
function YD(e) {
  const { xScale: t, yScale: n } = e;
  if (t && n)
    return {
      left: t.left,
      right: t.right,
      top: n.top,
      bottom: n.bottom
    };
}
var vo;
let Fu = (vo = class {
  static register(...t) {
    Or.add(...t), Pv();
  }
  static unregister(...t) {
    Or.remove(...t), Pv();
  }
  constructor(t, n) {
    const r = this.config = new $D(n), o = Gx(t), s = Rv(o);
    if (s)
      throw new Error("Canvas is already in use. Chart with ID '" + s.id + "' must be destroyed before the canvas with ID '" + s.canvas.id + "' can be reused.");
    const i = r.createResolver(r.chartOptionScopes(), this.getContext());
    this.platform = new (r.platform || aD(o))(), this.platform.updateConfig(r);
    const a = this.platform.acquireContext(o, i.aspectRatio), l = a && a.canvas, c = l && l.height, u = l && l.width;
    if (this.id = HI(), this.ctx = a, this.canvas = l, this.width = u, this.height = c, this._options = i, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new SD(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = rk((d) => this.update(d), i.resizeDelay || 0), this._dataChanges = [], Zl[this.id] = this, !a || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    jr.listen(this, "complete", Tv), jr.listen(this, "progress", HD), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: n }, width: r, height: o, _aspectRatio: s } = this;
    return St(t) ? n && s ? s : o ? r / o : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return Or;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : Zb(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return Kb(this.canvas, this.ctx), this;
  }
  stop() {
    return jr.stop(this), this;
  }
  resize(t, n) {
    jr.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: n
    } : this._resize(t, n);
  }
  _resize(t, n) {
    const r = this.options, o = this.canvas, s = r.maintainAspectRatio && this.aspectRatio, i = this.platform.getMaximumSize(o, t, n, s), a = r.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = i.width, this.height = i.height, this._aspectRatio = this.aspectRatio, Zb(this, a, !0) && (this.notifyPlugins("resize", {
      size: i
    }), nn(r.onResize, [
      this,
      i
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    _t(n, (r, o) => {
      r.id = o;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, n = t.scales, r = this.scales, o = Object.keys(r).reduce((i, a) => (i[a] = !1, i), {});
    let s = [];
    n && (s = s.concat(Object.keys(n).map((i) => {
      const a = n[i], l = Xf(i, a), c = l === "r", u = l === "x";
      return {
        options: a,
        dposition: c ? "chartArea" : u ? "bottom" : "left",
        dtype: c ? "radialLinear" : u ? "category" : "linear"
      };
    }))), _t(s, (i) => {
      const a = i.options, l = a.id, c = Xf(l, a), u = mt(a.type, i.dtype);
      (a.position === void 0 || Ov(a.position, c) !== Ov(i.dposition)) && (a.position = i.dposition), o[l] = !0;
      let d = null;
      if (l in r && r[l].type === u)
        d = r[l];
      else {
        const f = Or.getScale(u);
        d = new f({
          id: l,
          type: u,
          ctx: this.ctx,
          chart: this
        }), r[d.id] = d;
      }
      d.init(a, t);
    }), _t(o, (i, a) => {
      i || delete r[a];
    }), _t(r, (i) => {
      El.configure(this, i, i.options), El.addBox(this, i);
    });
  }
  _updateMetasets() {
    const t = this._metasets, n = this.data.datasets.length, r = t.length;
    if (t.sort((o, s) => o.index - s.index), r > n) {
      for (let o = n; o < r; ++o)
        this._destroyDatasetMeta(o);
      t.splice(n, r - n);
    }
    this._sortedMetasets = t.slice(0).sort(Mv("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: n } } = this;
    t.length > n.length && delete this._stacks, t.forEach((r, o) => {
      n.filter((s) => s === r._dataset).length === 0 && this._destroyDatasetMeta(o);
    });
  }
  buildOrUpdateControllers() {
    const t = [], n = this.data.datasets;
    let r, o;
    for (this._removeUnreferencedMetasets(), r = 0, o = n.length; r < o; r++) {
      const s = n[r];
      let i = this.getDatasetMeta(r);
      const a = s.type || this.config.type;
      if (i.type && i.type !== a && (this._destroyDatasetMeta(r), i = this.getDatasetMeta(r)), i.type = a, i.indexAxis = s.indexAxis || qf(a, this.options), i.order = s.order || 0, i.index = r, i.label = "" + s.label, i.visible = this.isDatasetVisible(r), i.controller)
        i.controller.updateIndex(r), i.controller.linkScales();
      else {
        const l = Or.getController(a), { datasetElementType: c, dataElementType: u } = ln.datasets[a];
        Object.assign(l, {
          dataElementType: Or.getElement(u),
          datasetElementType: c && Or.getElement(c)
        }), i.controller = new l(this, r), t.push(i.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    _t(this.data.datasets, (t, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const n = this.config;
    n.update();
    const r = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), o = this._animationsDisabled = !r.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const s = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let i = 0;
    for (let c = 0, u = this.data.datasets.length; c < u; c++) {
      const { controller: d } = this.getDatasetMeta(c), f = !o && s.indexOf(d) === -1;
      d.buildOrUpdateElements(f), i = Math.max(+d.getMaxOverflow(), i);
    }
    i = this._minPadding = r.layout.autoPadding ? i : 0, this._updateLayout(i), o || _t(s, (c) => {
      c.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(Mv("z", "_idx"));
    const { _active: a, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : a.length && this._updateHoverStyles(a, a, !0), this.render();
  }
  _updateScales() {
    _t(this.scales, (t) => {
      El.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, n = new Set(Object.keys(this._listeners)), r = new Set(t.events);
    (!Lb(n, r) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, n = this._getUniformDataChanges() || [];
    for (const { method: r, start: o, count: s } of n) {
      const i = r === "_removeElements" ? -s : s;
      BD(t, o, i);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, r = (s) => new Set(t.filter((i) => i[0] === s).map((i, a) => a + "," + i.splice(1).join(","))), o = r(0);
    for (let s = 1; s < n; s++)
      if (!Lb(o, r(s)))
        return;
    return Array.from(o).map((s) => s.split(",")).map((s) => ({
      method: s[1],
      start: +s[2],
      count: +s[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    El.update(this, this.width, this.height, t);
    const n = this.chartArea, r = n.width <= 0 || n.height <= 0;
    this._layers = [], _t(this.boxes, (o) => {
      r && o.position === "chartArea" || (o.configure && o.configure(), this._layers.push(...o._layers()));
    }, this), this._layers.forEach((o, s) => {
      o._idx = s;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this._updateDataset(n, Do(t) ? t({
          datasetIndex: n
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, n) {
    const r = this.getDatasetMeta(t), o = {
      meta: r,
      index: t,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", o) !== !1 && (r.controller._update(n), o.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", o));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (jr.has(this) ? this.attached && !jr.running(this) && jr.start(this) : (this.draw(), Tv({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: r, height: o } = this._resizeBeforeDraw;
      this._resize(r, o), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (t = 0; t < n.length && n[t].z <= 0; ++t)
      n[t].draw(this.chartArea);
    for (this._drawDatasets(); t < n.length; ++t)
      n[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const n = this._sortedMetasets, r = [];
    let o, s;
    for (o = 0, s = n.length; o < s; ++o) {
      const i = n[o];
      (!t || i.visible) && r.push(i);
    }
    return r;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let n = t.length - 1; n >= 0; --n)
      this._drawDataset(t[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const n = this.ctx, r = t._clip, o = !r.disabled, s = YD(t) || this.chartArea, i = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", i) !== !1 && (o && Sx(n, {
      left: r.left === !1 ? 0 : s.left - r.left,
      right: r.right === !1 ? this.width : s.right + r.right,
      top: r.top === !1 ? 0 : s.top - r.top,
      bottom: r.bottom === !1 ? this.height : s.bottom + r.bottom
    }), t.controller.draw(), o && Ox(n), i.cancelable = !1, this.notifyPlugins("afterDatasetDraw", i));
  }
  isPointInArea(t) {
    return qr(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, n, r, o) {
    const s = W2.modes[n];
    return typeof s == "function" ? s(this, t, r, o) : [];
  }
  getDatasetMeta(t) {
    const n = this.data.datasets[t], r = this._metasets;
    let o = r.filter((s) => s && s._dataset === n).pop();
    return o || (o = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: t,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, r.push(o)), o;
  }
  getContext() {
    return this.$context || (this.$context = Bo(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const n = this.data.datasets[t];
    if (!n)
      return !1;
    const r = this.getDatasetMeta(t);
    return typeof r.hidden == "boolean" ? !r.hidden : !n.hidden;
  }
  setDatasetVisibility(t, n) {
    const r = this.getDatasetMeta(t);
    r.hidden = !n;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, n, r) {
    const o = r ? "show" : "hide", s = this.getDatasetMeta(t), i = s.controller._resolveAnimations(void 0, o);
    pa(n) ? (s.data[n].hidden = !r, this.update()) : (this.setDatasetVisibility(t, r), i.update(s, {
      visible: r
    }), this.update((a) => a.datasetIndex === t ? o : void 0));
  }
  hide(t, n) {
    this._updateVisibility(t, n, !1);
  }
  show(t, n) {
    this._updateVisibility(t, n, !0);
  }
  _destroyDatasetMeta(t) {
    const n = this._metasets[t];
    n && n.controller && n.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, n;
    for (this.stop(), jr.remove(this), t = 0, n = this.data.datasets.length; t < n; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: n } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), Kb(t, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete Zl[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, n = this.platform, r = (s, i) => {
      n.addEventListener(this, s, i), t[s] = i;
    }, o = (s, i, a) => {
      s.offsetX = i, s.offsetY = a, this._eventHandler(s);
    };
    _t(this.options.events, (s) => r(s, o));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, n = this.platform, r = (l, c) => {
      n.addEventListener(this, l, c), t[l] = c;
    }, o = (l, c) => {
      t[l] && (n.removeEventListener(this, l, c), delete t[l]);
    }, s = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let i;
    const a = () => {
      o("attach", a), this.attached = !0, this.resize(), r("resize", s), r("detach", i);
    };
    i = () => {
      this.attached = !1, o("resize", s), this._stop(), this._resize(0, 0), r("attach", a);
    }, n.isAttached(this.canvas) ? a() : i();
  }
  unbindEvents() {
    _t(this._listeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._listeners = {}, _t(this._responsiveListeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, n, r) {
    const o = r ? "set" : "remove";
    let s, i, a, l;
    for (n === "dataset" && (s = this.getDatasetMeta(t[0].datasetIndex), s.controller["_" + o + "DatasetHoverStyle"]()), a = 0, l = t.length; a < l; ++a) {
      i = t[a];
      const c = i && this.getDatasetMeta(i.datasetIndex).controller;
      c && c[o + "HoverStyle"](i.element, i.datasetIndex, i.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const n = this._active || [], r = t.map(({ datasetIndex: s, index: i }) => {
      const a = this.getDatasetMeta(s);
      if (!a)
        throw new Error("No dataset found at index " + s);
      return {
        datasetIndex: s,
        element: a.data[i],
        index: i
      };
    });
    !Cc(r, n) && (this._active = r, this._lastEvent = null, this._updateHoverStyles(r, n));
  }
  notifyPlugins(t, n, r) {
    return this._plugins.notify(this, t, n, r);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((n) => n.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, n, r) {
    const o = this.options.hover, s = (l, c) => l.filter((u) => !c.some((d) => u.datasetIndex === d.datasetIndex && u.index === d.index)), i = s(n, t), a = r ? t : s(t, n);
    i.length && this.updateHoverStyle(i, o.mode, !1), a.length && o.mode && this.updateHoverStyle(a, o.mode, !0);
  }
  _eventHandler(t, n) {
    const r = {
      event: t,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, o = (i) => (i.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", r, o) === !1)
      return;
    const s = this._handleEvent(t, n, r.inChartArea);
    return r.cancelable = !1, this.notifyPlugins("afterEvent", r, o), (s || r.changed) && this.render(), this;
  }
  _handleEvent(t, n, r) {
    const { _active: o = [], options: s } = this, i = n, a = this._getActiveElements(t, o, r, i), l = GI(t), c = zD(t, this._lastEvent, r, l);
    r && (this._lastEvent = null, nn(s.onHover, [
      t,
      a,
      this
    ], this), l && nn(s.onClick, [
      t,
      a,
      this
    ], this));
    const u = !Cc(a, o);
    return (u || n) && (this._active = a, this._updateHoverStyles(a, o, n)), this._lastEvent = c, u;
  }
  _getActiveElements(t, n, r, o) {
    if (t.type === "mouseout")
      return [];
    if (!r)
      return n;
    const s = this.options.hover;
    return this.getElementsAtEventForMode(t, s.mode, s, o);
  }
}, ce(vo, "defaults", ln), ce(vo, "instances", Zl), ce(vo, "overrides", hs), ce(vo, "registry", Or), ce(vo, "version", VD), ce(vo, "getChart", Rv), vo);
function Pv() {
  return _t(Fu.instances, (e) => e._plugins.invalidate());
}
function jD(e, t, n) {
  const { startAngle: r, pixelMargin: o, x: s, y: i, outerRadius: a, innerRadius: l } = t;
  let c = o / a;
  e.beginPath(), e.arc(s, i, a, r - c, n + c), l > o ? (c = o / l, e.arc(s, i, l, n + c, r - c, !0)) : e.arc(s, i, o, n + on, r - on), e.closePath(), e.clip();
}
function UD(e) {
  return $p(e, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function GD(e, t, n, r) {
  const o = UD(e.options.borderRadius), s = (n - t) / 2, i = Math.min(s, r * t / 2), a = (l) => {
    const c = (n - Math.min(s, l)) * r / 2;
    return kn(l, 0, Math.min(s, c));
  };
  return {
    outerStart: a(o.outerStart),
    outerEnd: a(o.outerEnd),
    innerStart: kn(o.innerStart, 0, i),
    innerEnd: kn(o.innerEnd, 0, i)
  };
}
function Ts(e, t, n, r) {
  return {
    x: n + e * Math.cos(t),
    y: r + e * Math.sin(t)
  };
}
function Ic(e, t, n, r, o, s) {
  const { x: i, y: a, startAngle: l, pixelMargin: c, innerRadius: u } = t, d = Math.max(t.outerRadius + r + n - c, 0), f = u > 0 ? u + r + n + c : 0;
  let h = 0;
  const p = o - l;
  if (r) {
    const k = u > 0 ? u - r : 0, $ = d > 0 ? d - r : 0, L = (k + $) / 2, A = L !== 0 ? p * L / (L + r) : p;
    h = (p - A) / 2;
  }
  const g = Math.max(1e-3, p * d - n / dn) / d, m = (p - g) / 2, v = l + m + h, y = o - m - h, { outerStart: x, outerEnd: C, innerStart: w, innerEnd: E } = GD(t, f, d, y - v), S = d - x, O = d - C, M = v + x / S, T = y - C / O, P = f + w, I = f + E, R = v + w / P, D = y - E / I;
  if (e.beginPath(), s) {
    const k = (M + T) / 2;
    if (e.arc(i, a, d, M, k), e.arc(i, a, d, k, T), C > 0) {
      const F = Ts(O, T, i, a);
      e.arc(F.x, F.y, C, T, y + on);
    }
    const $ = Ts(I, y, i, a);
    if (e.lineTo($.x, $.y), E > 0) {
      const F = Ts(I, D, i, a);
      e.arc(F.x, F.y, E, y + on, D + Math.PI);
    }
    const L = (y - E / f + (v + w / f)) / 2;
    if (e.arc(i, a, f, y - E / f, L, !0), e.arc(i, a, f, L, v + w / f, !0), w > 0) {
      const F = Ts(P, R, i, a);
      e.arc(F.x, F.y, w, R + Math.PI, v - on);
    }
    const A = Ts(S, v, i, a);
    if (e.lineTo(A.x, A.y), x > 0) {
      const F = Ts(S, M, i, a);
      e.arc(F.x, F.y, x, v - on, M);
    }
  } else {
    e.moveTo(i, a);
    const k = Math.cos(M) * d + i, $ = Math.sin(M) * d + a;
    e.lineTo(k, $);
    const L = Math.cos(T) * d + i, A = Math.sin(T) * d + a;
    e.lineTo(L, A);
  }
  e.closePath();
}
function KD(e, t, n, r, o) {
  const { fullCircles: s, startAngle: i, circumference: a } = t;
  let l = t.endAngle;
  if (s) {
    Ic(e, t, n, r, l, o);
    for (let c = 0; c < s; ++c)
      e.fill();
    isNaN(a) || (l = i + (a % Ut || Ut));
  }
  return Ic(e, t, n, r, l, o), e.fill(), l;
}
function qD(e, t, n, r, o) {
  const { fullCircles: s, startAngle: i, circumference: a, options: l } = t, { borderWidth: c, borderJoinStyle: u, borderDash: d, borderDashOffset: f } = l, h = l.borderAlign === "inner";
  if (!c)
    return;
  e.setLineDash(d || []), e.lineDashOffset = f, h ? (e.lineWidth = c * 2, e.lineJoin = u || "round") : (e.lineWidth = c, e.lineJoin = u || "bevel");
  let p = t.endAngle;
  if (s) {
    Ic(e, t, n, r, p, o);
    for (let g = 0; g < s; ++g)
      e.stroke();
    isNaN(a) || (p = i + (a % Ut || Ut));
  }
  h && jD(e, t, p), s || (Ic(e, t, n, r, p, o), e.stroke());
}
class zi extends xs {
  constructor(n) {
    super();
    ce(this, "circumference");
    ce(this, "endAngle");
    ce(this, "fullCircles");
    ce(this, "innerRadius");
    ce(this, "outerRadius");
    ce(this, "pixelMargin");
    ce(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, n && Object.assign(this, n);
  }
  inRange(n, r, o) {
    const s = this.getProps([
      "x",
      "y"
    ], o), { angle: i, distance: a } = yx(s, {
      x: n,
      y: r
    }), { startAngle: l, endAngle: c, innerRadius: u, outerRadius: d, circumference: f } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], o), h = (this.options.spacing + this.options.borderWidth) / 2, g = mt(f, c - l) >= Ut || ma(i, l, c), m = Sc(a, u + h, d + h);
    return g && m;
  }
  getCenterPoint(n) {
    const { x: r, y: o, startAngle: s, endAngle: i, innerRadius: a, outerRadius: l } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], n), { offset: c, spacing: u } = this.options, d = (s + i) / 2, f = (a + l + u + c) / 2;
    return {
      x: r + Math.cos(d) * f,
      y: o + Math.sin(d) * f
    };
  }
  tooltipPosition(n) {
    return this.getCenterPoint(n);
  }
  draw(n) {
    const { options: r, circumference: o } = this, s = (r.offset || 0) / 4, i = (r.spacing || 0) / 2, a = r.circular;
    if (this.pixelMargin = r.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = o > Ut ? Math.floor(o / Ut) : 0, o === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    n.save();
    const l = (this.startAngle + this.endAngle) / 2;
    n.translate(Math.cos(l) * s, Math.sin(l) * s);
    const c = 1 - Math.sin(Math.min(dn, o || 0)), u = s * c;
    n.fillStyle = r.backgroundColor, n.strokeStyle = r.borderColor, KD(n, this, u, i, a), qD(n, this, u, i, a), n.restore();
  }
}
ce(zi, "id", "arc"), ce(zi, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), ce(zi, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), ce(zi, "descriptors", {
  _scriptable: !0,
  _indexable: (n) => n !== "borderDash"
});
function Kx(e, t, n = t) {
  e.lineCap = mt(n.borderCapStyle, t.borderCapStyle), e.setLineDash(mt(n.borderDash, t.borderDash)), e.lineDashOffset = mt(n.borderDashOffset, t.borderDashOffset), e.lineJoin = mt(n.borderJoinStyle, t.borderJoinStyle), e.lineWidth = mt(n.borderWidth, t.borderWidth), e.strokeStyle = mt(n.borderColor, t.borderColor);
}
function XD(e, t, n) {
  e.lineTo(n.x, n.y);
}
function ZD(e) {
  return e.stepped ? vk : e.tension || e.cubicInterpolationMode === "monotone" ? yk : XD;
}
function qx(e, t, n = {}) {
  const r = e.length, { start: o = 0, end: s = r - 1 } = n, { start: i, end: a } = t, l = Math.max(o, i), c = Math.min(s, a), u = o < i && s < i || o > a && s > a;
  return {
    count: r,
    start: l,
    loop: t.loop,
    ilen: c < l && !u ? r + c - l : c - l
  };
}
function QD(e, t, n, r) {
  const { points: o, options: s } = t, { count: i, start: a, loop: l, ilen: c } = qx(o, n, r), u = ZD(s);
  let { move: d = !0, reverse: f } = r || {}, h, p, g;
  for (h = 0; h <= c; ++h)
    p = o[(a + (f ? c - h : h)) % i], !p.skip && (d ? (e.moveTo(p.x, p.y), d = !1) : u(e, g, p, f, s.stepped), g = p);
  return l && (p = o[(a + (f ? c : 0)) % i], u(e, g, p, f, s.stepped)), !!l;
}
function JD(e, t, n, r) {
  const o = t.points, { count: s, start: i, ilen: a } = qx(o, n, r), { move: l = !0, reverse: c } = r || {};
  let u = 0, d = 0, f, h, p, g, m, v;
  const y = (C) => (i + (c ? a - C : C)) % s, x = () => {
    g !== m && (e.lineTo(u, m), e.lineTo(u, g), e.lineTo(u, v));
  };
  for (l && (h = o[y(0)], e.moveTo(h.x, h.y)), f = 0; f <= a; ++f) {
    if (h = o[y(f)], h.skip)
      continue;
    const C = h.x, w = h.y, E = C | 0;
    E === p ? (w < g ? g = w : w > m && (m = w), u = (d * u + C) / ++d) : (x(), e.lineTo(C, w), p = E, d = 0, g = m = w), v = w;
  }
  x();
}
function Zf(e) {
  const t = e.options, n = t.borderDash && t.borderDash.length;
  return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !n ? JD : QD;
}
function eN(e) {
  return e.stepped ? Zk : e.tension || e.cubicInterpolationMode === "monotone" ? Qk : Jo;
}
function tN(e, t, n, r) {
  let o = t._path;
  o || (o = t._path = new Path2D(), t.path(o, n, r) && o.closePath()), Kx(e, t.options), e.stroke(o);
}
function nN(e, t, n, r) {
  const { segments: o, options: s } = t, i = Zf(t);
  for (const a of o)
    Kx(e, s, a.style), e.beginPath(), i(e, t, a, {
      start: n,
      end: n + r - 1
    }) && e.closePath(), e.stroke();
}
const rN = typeof Path2D == "function";
function oN(e, t, n, r) {
  rN && !t.options.segment ? tN(e, t, n, r) : nN(e, t, n, r);
}
class Yi extends xs {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, n) {
    const r = this.options;
    if ((r.tension || r.cubicInterpolationMode === "monotone") && !r.stepped && !this._pointsUpdated) {
      const o = r.spanGaps ? this._loop : this._fullLoop;
      zk(this._points, r, t, o, n), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = l2(this, this.options.segment));
  }
  first() {
    const t = this.segments, n = this.points;
    return t.length && n[t[0].start];
  }
  last() {
    const t = this.segments, n = this.points, r = t.length;
    return r && n[t[r - 1].end];
  }
  interpolate(t, n) {
    const r = this.options, o = t[n], s = this.points, i = s2(this, {
      property: n,
      start: o,
      end: o
    });
    if (!i.length)
      return;
    const a = [], l = eN(r);
    let c, u;
    for (c = 0, u = i.length; c < u; ++c) {
      const { start: d, end: f } = i[c], h = s[d], p = s[f];
      if (h === p) {
        a.push(h);
        continue;
      }
      const g = Math.abs((o - h[n]) / (p[n] - h[n])), m = l(h, p, g, r.stepped);
      m[n] = t[n], a.push(m);
    }
    return a.length === 1 ? a[0] : a;
  }
  pathSegment(t, n, r) {
    return Zf(this)(t, this, n, r);
  }
  path(t, n, r) {
    const o = this.segments, s = Zf(this);
    let i = this._loop;
    n = n || 0, r = r || this.points.length - n;
    for (const a of o)
      i &= s(t, this, a, {
        start: n,
        end: n + r - 1
      });
    return !!i;
  }
  draw(t, n, r, o) {
    const s = this.options || {};
    (this.points || []).length && s.borderWidth && (t.save(), oN(t, this, r, o), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
ce(Yi, "id", "line"), ce(Yi, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), ce(Yi, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), ce(Yi, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash" && t !== "fill"
});
function Iv(e, t, n, r) {
  const o = e.options, { [n]: s } = e.getProps([
    n
  ], r);
  return Math.abs(t - s) < o.radius + o.hitRadius;
}
class Ql extends xs {
  constructor(n) {
    super();
    ce(this, "parsed");
    ce(this, "skip");
    ce(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, n && Object.assign(this, n);
  }
  inRange(n, r, o) {
    const s = this.options, { x: i, y: a } = this.getProps([
      "x",
      "y"
    ], o);
    return Math.pow(n - i, 2) + Math.pow(r - a, 2) < Math.pow(s.hitRadius + s.radius, 2);
  }
  inXRange(n, r) {
    return Iv(this, n, "x", r);
  }
  inYRange(n, r) {
    return Iv(this, n, "y", r);
  }
  getCenterPoint(n) {
    const { x: r, y: o } = this.getProps([
      "x",
      "y"
    ], n);
    return {
      x: r,
      y: o
    };
  }
  size(n) {
    n = n || this.options || {};
    let r = n.radius || 0;
    r = Math.max(r, r && n.hoverRadius || 0);
    const o = r && n.borderWidth || 0;
    return (r + o) * 2;
  }
  draw(n, r) {
    const o = this.options;
    this.skip || o.radius < 0.1 || !qr(this, r, this.size(o) / 2) || (n.strokeStyle = o.borderColor, n.lineWidth = o.borderWidth, n.fillStyle = o.backgroundColor, Kf(n, o, this.x, this.y));
  }
  getRange() {
    const n = this.options || {};
    return n.radius + n.hitRadius;
  }
}
ce(Ql, "id", "point"), /**
* @type {any}
*/
ce(Ql, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
ce(Ql, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function Xx(e, t) {
  const { x: n, y: r, base: o, width: s, height: i } = e.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let a, l, c, u, d;
  return e.horizontal ? (d = i / 2, a = Math.min(n, o), l = Math.max(n, o), c = r - d, u = r + d) : (d = s / 2, a = n - d, l = n + d, c = Math.min(r, o), u = Math.max(r, o)), {
    left: a,
    top: c,
    right: l,
    bottom: u
  };
}
function Eo(e, t, n, r) {
  return e ? 0 : kn(t, n, r);
}
function sN(e, t, n) {
  const r = e.options.borderWidth, o = e.borderSkipped, s = Mx(r);
  return {
    t: Eo(o.top, s.top, 0, n),
    r: Eo(o.right, s.right, 0, t),
    b: Eo(o.bottom, s.bottom, 0, n),
    l: Eo(o.left, s.left, 0, t)
  };
}
function iN(e, t, n) {
  const { enableBorderRadius: r } = e.getProps([
    "enableBorderRadius"
  ]), o = e.options.borderRadius, s = Us(o), i = Math.min(t, n), a = e.borderSkipped, l = r || ht(o);
  return {
    topLeft: Eo(!l || a.top || a.left, s.topLeft, 0, i),
    topRight: Eo(!l || a.top || a.right, s.topRight, 0, i),
    bottomLeft: Eo(!l || a.bottom || a.left, s.bottomLeft, 0, i),
    bottomRight: Eo(!l || a.bottom || a.right, s.bottomRight, 0, i)
  };
}
function aN(e) {
  const t = Xx(e), n = t.right - t.left, r = t.bottom - t.top, o = sN(e, n / 2, r / 2), s = iN(e, n / 2, r / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: n,
      h: r,
      radius: s
    },
    inner: {
      x: t.left + o.l,
      y: t.top + o.t,
      w: n - o.l - o.r,
      h: r - o.t - o.b,
      radius: {
        topLeft: Math.max(0, s.topLeft - Math.max(o.t, o.l)),
        topRight: Math.max(0, s.topRight - Math.max(o.t, o.r)),
        bottomLeft: Math.max(0, s.bottomLeft - Math.max(o.b, o.l)),
        bottomRight: Math.max(0, s.bottomRight - Math.max(o.b, o.r))
      }
    }
  };
}
function zd(e, t, n, r) {
  const o = t === null, s = n === null, a = e && !(o && s) && Xx(e, r);
  return a && (o || Sc(t, a.left, a.right)) && (s || Sc(n, a.top, a.bottom));
}
function lN(e) {
  return e.topLeft || e.topRight || e.bottomLeft || e.bottomRight;
}
function cN(e, t) {
  e.rect(t.x, t.y, t.w, t.h);
}
function Yd(e, t, n = {}) {
  const r = e.x !== n.x ? -t : 0, o = e.y !== n.y ? -t : 0, s = (e.x + e.w !== n.x + n.w ? t : 0) - r, i = (e.y + e.h !== n.y + n.h ? t : 0) - o;
  return {
    x: e.x + r,
    y: e.y + o,
    w: e.w + s,
    h: e.h + i,
    radius: e.radius
  };
}
class Jl extends xs {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: n, options: { borderColor: r, backgroundColor: o } } = this, { inner: s, outer: i } = aN(this), a = lN(i.radius) ? Tc : cN;
    t.save(), (i.w !== s.w || i.h !== s.h) && (t.beginPath(), a(t, Yd(i, n, s)), t.clip(), a(t, Yd(s, -n, i)), t.fillStyle = r, t.fill("evenodd")), t.beginPath(), a(t, Yd(s, n)), t.fillStyle = o, t.fill(), t.restore();
  }
  inRange(t, n, r) {
    return zd(this, t, n, r);
  }
  inXRange(t, n) {
    return zd(this, t, null, n);
  }
  inYRange(t, n) {
    return zd(this, null, t, n);
  }
  getCenterPoint(t) {
    const { x: n, y: r, base: o, horizontal: s } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: s ? (n + o) / 2 : n,
      y: s ? r : (r + o) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
ce(Jl, "id", "bar"), ce(Jl, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), ce(Jl, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
const ji = {
  average(e) {
    if (!e.length)
      return !1;
    let t, n, r = 0, o = 0, s = 0;
    for (t = 0, n = e.length; t < n; ++t) {
      const i = e[t].element;
      if (i && i.hasValue()) {
        const a = i.tooltipPosition();
        r += a.x, o += a.y, ++s;
      }
    }
    return {
      x: r / s,
      y: o / s
    };
  },
  nearest(e, t) {
    if (!e.length)
      return !1;
    let n = t.x, r = t.y, o = Number.POSITIVE_INFINITY, s, i, a;
    for (s = 0, i = e.length; s < i; ++s) {
      const l = e[s].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), u = Uf(t, c);
        u < o && (o = u, a = l);
      }
    }
    if (a) {
      const l = a.tooltipPosition();
      n = l.x, r = l.y;
    }
    return {
      x: n,
      y: r
    };
  }
};
function _r(e, t) {
  return t && (Xt(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
function Ur(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
function uN(e, t) {
  const { element: n, datasetIndex: r, index: o } = t, s = e.getDatasetMeta(r).controller, { label: i, value: a } = s.getLabelAndValue(o);
  return {
    chart: e,
    label: i,
    parsed: s.getParsed(o),
    raw: e.data.datasets[r].data[o],
    formattedValue: a,
    dataset: s.getDataset(),
    dataIndex: o,
    datasetIndex: r,
    element: n
  };
}
function kv(e, t) {
  const n = e.chart.ctx, { body: r, footer: o, title: s } = e, { boxWidth: i, boxHeight: a } = t, l = Kn(t.bodyFont), c = Kn(t.titleFont), u = Kn(t.footerFont), d = s.length, f = o.length, h = r.length, p = lr(t.padding);
  let g = p.height, m = 0, v = r.reduce((C, w) => C + w.before.length + w.lines.length + w.after.length, 0);
  if (v += e.beforeBody.length + e.afterBody.length, d && (g += d * c.lineHeight + (d - 1) * t.titleSpacing + t.titleMarginBottom), v) {
    const C = t.displayColors ? Math.max(a, l.lineHeight) : l.lineHeight;
    g += h * C + (v - h) * l.lineHeight + (v - 1) * t.bodySpacing;
  }
  f && (g += t.footerMarginTop + f * u.lineHeight + (f - 1) * t.footerSpacing);
  let y = 0;
  const x = function(C) {
    m = Math.max(m, n.measureText(C).width + y);
  };
  return n.save(), n.font = c.string, _t(e.title, x), n.font = l.string, _t(e.beforeBody.concat(e.afterBody), x), y = t.displayColors ? i + 2 + t.boxPadding : 0, _t(r, (C) => {
    _t(C.before, x), _t(C.lines, x), _t(C.after, x);
  }), y = 0, n.font = u.string, _t(e.footer, x), n.restore(), m += p.width, {
    width: m,
    height: g
  };
}
function dN(e, t) {
  const { y: n, height: r } = t;
  return n < r / 2 ? "top" : n > e.height - r / 2 ? "bottom" : "center";
}
function fN(e, t, n, r) {
  const { x: o, width: s } = r, i = n.caretSize + n.caretPadding;
  if (e === "left" && o + s + i > t.width || e === "right" && o - s - i < 0)
    return !0;
}
function hN(e, t, n, r) {
  const { x: o, width: s } = n, { width: i, chartArea: { left: a, right: l } } = e;
  let c = "center";
  return r === "center" ? c = o <= (a + l) / 2 ? "left" : "right" : o <= s / 2 ? c = "left" : o >= i - s / 2 && (c = "right"), fN(c, e, t, n) && (c = "center"), c;
}
function Dv(e, t, n) {
  const r = n.yAlign || t.yAlign || dN(e, n);
  return {
    xAlign: n.xAlign || t.xAlign || hN(e, t, n, r),
    yAlign: r
  };
}
function pN(e, t) {
  let { x: n, width: r } = e;
  return t === "right" ? n -= r : t === "center" && (n -= r / 2), n;
}
function gN(e, t, n) {
  let { y: r, height: o } = e;
  return t === "top" ? r += n : t === "bottom" ? r -= o + n : r -= o / 2, r;
}
function Nv(e, t, n, r) {
  const { caretSize: o, caretPadding: s, cornerRadius: i } = e, { xAlign: a, yAlign: l } = n, c = o + s, { topLeft: u, topRight: d, bottomLeft: f, bottomRight: h } = Us(i);
  let p = pN(t, a);
  const g = gN(t, l, c);
  return l === "center" ? a === "left" ? p += c : a === "right" && (p -= c) : a === "left" ? p -= Math.max(u, f) + o : a === "right" && (p += Math.max(d, h) + o), {
    x: kn(p, 0, r.width - t.width),
    y: kn(g, 0, r.height - t.height)
  };
}
function Ml(e, t, n) {
  const r = lr(n.padding);
  return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - r.right : e.x + r.left;
}
function Av(e) {
  return _r([], Ur(e));
}
function mN(e, t, n) {
  return Bo(e, {
    tooltip: t,
    tooltipItems: n,
    type: "tooltip"
  });
}
function $v(e, t) {
  const n = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return n ? e.override(n) : e;
}
const Zx = {
  beforeTitle: zr,
  title(e) {
    if (e.length > 0) {
      const t = e[0], n = t.chart.data.labels, r = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (r > 0 && t.dataIndex < r)
        return n[t.dataIndex];
    }
    return "";
  },
  afterTitle: zr,
  beforeBody: zr,
  beforeLabel: zr,
  label(e) {
    if (this && this.options && this.options.mode === "dataset")
      return e.label + ": " + e.formattedValue || e.formattedValue;
    let t = e.dataset.label || "";
    t && (t += ": ");
    const n = e.formattedValue;
    return St(n) || (t += n), t;
  },
  labelColor(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: zr,
  afterBody: zr,
  beforeFooter: zr,
  footer: zr,
  afterFooter: zr
};
function Nn(e, t, n, r) {
  const o = e[t].call(n, r);
  return typeof o > "u" ? Zx[t].call(n, r) : o;
}
class Qf extends xs {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const n = this.chart, r = this.options.setContext(this.getContext()), o = r.enabled && n.options.animation && r.animations, s = new Ax(this.chart, o);
    return o._cacheable && (this._cachedAnimations = Object.freeze(s)), s;
  }
  getContext() {
    return this.$context || (this.$context = mN(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, n) {
    const { callbacks: r } = n, o = Nn(r, "beforeTitle", this, t), s = Nn(r, "title", this, t), i = Nn(r, "afterTitle", this, t);
    let a = [];
    return a = _r(a, Ur(o)), a = _r(a, Ur(s)), a = _r(a, Ur(i)), a;
  }
  getBeforeBody(t, n) {
    return Av(Nn(n.callbacks, "beforeBody", this, t));
  }
  getBody(t, n) {
    const { callbacks: r } = n, o = [];
    return _t(t, (s) => {
      const i = {
        before: [],
        lines: [],
        after: []
      }, a = $v(r, s);
      _r(i.before, Ur(Nn(a, "beforeLabel", this, s))), _r(i.lines, Nn(a, "label", this, s)), _r(i.after, Ur(Nn(a, "afterLabel", this, s))), o.push(i);
    }), o;
  }
  getAfterBody(t, n) {
    return Av(Nn(n.callbacks, "afterBody", this, t));
  }
  getFooter(t, n) {
    const { callbacks: r } = n, o = Nn(r, "beforeFooter", this, t), s = Nn(r, "footer", this, t), i = Nn(r, "afterFooter", this, t);
    let a = [];
    return a = _r(a, Ur(o)), a = _r(a, Ur(s)), a = _r(a, Ur(i)), a;
  }
  _createItems(t) {
    const n = this._active, r = this.chart.data, o = [], s = [], i = [];
    let a = [], l, c;
    for (l = 0, c = n.length; l < c; ++l)
      a.push(uN(this.chart, n[l]));
    return t.filter && (a = a.filter((u, d, f) => t.filter(u, d, f, r))), t.itemSort && (a = a.sort((u, d) => t.itemSort(u, d, r))), _t(a, (u) => {
      const d = $v(t.callbacks, u);
      o.push(Nn(d, "labelColor", this, u)), s.push(Nn(d, "labelPointStyle", this, u)), i.push(Nn(d, "labelTextColor", this, u));
    }), this.labelColors = o, this.labelPointStyles = s, this.labelTextColors = i, this.dataPoints = a, a;
  }
  update(t, n) {
    const r = this.options.setContext(this.getContext()), o = this._active;
    let s, i = [];
    if (!o.length)
      this.opacity !== 0 && (s = {
        opacity: 0
      });
    else {
      const a = ji[r.position].call(this, o, this._eventPosition);
      i = this._createItems(r), this.title = this.getTitle(i, r), this.beforeBody = this.getBeforeBody(i, r), this.body = this.getBody(i, r), this.afterBody = this.getAfterBody(i, r), this.footer = this.getFooter(i, r);
      const l = this._size = kv(this, r), c = Object.assign({}, a, l), u = Dv(this.chart, r, c), d = Nv(r, c, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, s = {
        opacity: 1,
        x: d.x,
        y: d.y,
        width: l.width,
        height: l.height,
        caretX: a.x,
        caretY: a.y
      };
    }
    this._tooltipItems = i, this.$context = void 0, s && this._resolveAnimations().update(this, s), t && r.external && r.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(t, n, r, o) {
    const s = this.getCaretPosition(t, r, o);
    n.lineTo(s.x1, s.y1), n.lineTo(s.x2, s.y2), n.lineTo(s.x3, s.y3);
  }
  getCaretPosition(t, n, r) {
    const { xAlign: o, yAlign: s } = this, { caretSize: i, cornerRadius: a } = r, { topLeft: l, topRight: c, bottomLeft: u, bottomRight: d } = Us(a), { x: f, y: h } = t, { width: p, height: g } = n;
    let m, v, y, x, C, w;
    return s === "center" ? (C = h + g / 2, o === "left" ? (m = f, v = m - i, x = C + i, w = C - i) : (m = f + p, v = m + i, x = C - i, w = C + i), y = m) : (o === "left" ? v = f + Math.max(l, u) + i : o === "right" ? v = f + p - Math.max(c, d) - i : v = this.caretX, s === "top" ? (x = h, C = x - i, m = v - i, y = v + i) : (x = h + g, C = x + i, m = v + i, y = v - i), w = x), {
      x1: m,
      x2: v,
      x3: y,
      y1: x,
      y2: C,
      y3: w
    };
  }
  drawTitle(t, n, r) {
    const o = this.title, s = o.length;
    let i, a, l;
    if (s) {
      const c = $d(r.rtl, this.x, this.width);
      for (t.x = Ml(this, r.titleAlign, r), n.textAlign = c.textAlign(r.titleAlign), n.textBaseline = "middle", i = Kn(r.titleFont), a = r.titleSpacing, n.fillStyle = r.titleColor, n.font = i.string, l = 0; l < s; ++l)
        n.fillText(o[l], c.x(t.x), t.y + i.lineHeight / 2), t.y += i.lineHeight + a, l + 1 === s && (t.y += r.titleMarginBottom - a);
    }
  }
  _drawColorBox(t, n, r, o, s) {
    const i = this.labelColors[r], a = this.labelPointStyles[r], { boxHeight: l, boxWidth: c } = s, u = Kn(s.bodyFont), d = Ml(this, "left", s), f = o.x(d), h = l < u.lineHeight ? (u.lineHeight - l) / 2 : 0, p = n.y + h;
    if (s.usePointStyle) {
      const g = {
        radius: Math.min(c, l) / 2,
        pointStyle: a.pointStyle,
        rotation: a.rotation,
        borderWidth: 1
      }, m = o.leftForLtr(f, c) + c / 2, v = p + l / 2;
      t.strokeStyle = s.multiKeyBackground, t.fillStyle = s.multiKeyBackground, Kf(t, g, m, v), t.strokeStyle = i.borderColor, t.fillStyle = i.backgroundColor, Kf(t, g, m, v);
    } else {
      t.lineWidth = ht(i.borderWidth) ? Math.max(...Object.values(i.borderWidth)) : i.borderWidth || 1, t.strokeStyle = i.borderColor, t.setLineDash(i.borderDash || []), t.lineDashOffset = i.borderDashOffset || 0;
      const g = o.leftForLtr(f, c), m = o.leftForLtr(o.xPlus(f, 1), c - 2), v = Us(i.borderRadius);
      Object.values(v).some((y) => y !== 0) ? (t.beginPath(), t.fillStyle = s.multiKeyBackground, Tc(t, {
        x: g,
        y: p,
        w: c,
        h: l,
        radius: v
      }), t.fill(), t.stroke(), t.fillStyle = i.backgroundColor, t.beginPath(), Tc(t, {
        x: m,
        y: p + 1,
        w: c - 2,
        h: l - 2,
        radius: v
      }), t.fill()) : (t.fillStyle = s.multiKeyBackground, t.fillRect(g, p, c, l), t.strokeRect(g, p, c, l), t.fillStyle = i.backgroundColor, t.fillRect(m, p + 1, c - 2, l - 2));
    }
    t.fillStyle = this.labelTextColors[r];
  }
  drawBody(t, n, r) {
    const { body: o } = this, { bodySpacing: s, bodyAlign: i, displayColors: a, boxHeight: l, boxWidth: c, boxPadding: u } = r, d = Kn(r.bodyFont);
    let f = d.lineHeight, h = 0;
    const p = $d(r.rtl, this.x, this.width), g = function(O) {
      n.fillText(O, p.x(t.x + h), t.y + f / 2), t.y += f + s;
    }, m = p.textAlign(i);
    let v, y, x, C, w, E, S;
    for (n.textAlign = i, n.textBaseline = "middle", n.font = d.string, t.x = Ml(this, m, r), n.fillStyle = r.bodyColor, _t(this.beforeBody, g), h = a && m !== "right" ? i === "center" ? c / 2 + u : c + 2 + u : 0, C = 0, E = o.length; C < E; ++C) {
      for (v = o[C], y = this.labelTextColors[C], n.fillStyle = y, _t(v.before, g), x = v.lines, a && x.length && (this._drawColorBox(n, t, C, p, r), f = Math.max(d.lineHeight, l)), w = 0, S = x.length; w < S; ++w)
        g(x[w]), f = d.lineHeight;
      _t(v.after, g);
    }
    h = 0, f = d.lineHeight, _t(this.afterBody, g), t.y -= s;
  }
  drawFooter(t, n, r) {
    const o = this.footer, s = o.length;
    let i, a;
    if (s) {
      const l = $d(r.rtl, this.x, this.width);
      for (t.x = Ml(this, r.footerAlign, r), t.y += r.footerMarginTop, n.textAlign = l.textAlign(r.footerAlign), n.textBaseline = "middle", i = Kn(r.footerFont), n.fillStyle = r.footerColor, n.font = i.string, a = 0; a < s; ++a)
        n.fillText(o[a], l.x(t.x), t.y + i.lineHeight / 2), t.y += i.lineHeight + r.footerSpacing;
    }
  }
  drawBackground(t, n, r, o) {
    const { xAlign: s, yAlign: i } = this, { x: a, y: l } = t, { width: c, height: u } = r, { topLeft: d, topRight: f, bottomLeft: h, bottomRight: p } = Us(o.cornerRadius);
    n.fillStyle = o.backgroundColor, n.strokeStyle = o.borderColor, n.lineWidth = o.borderWidth, n.beginPath(), n.moveTo(a + d, l), i === "top" && this.drawCaret(t, n, r, o), n.lineTo(a + c - f, l), n.quadraticCurveTo(a + c, l, a + c, l + f), i === "center" && s === "right" && this.drawCaret(t, n, r, o), n.lineTo(a + c, l + u - p), n.quadraticCurveTo(a + c, l + u, a + c - p, l + u), i === "bottom" && this.drawCaret(t, n, r, o), n.lineTo(a + h, l + u), n.quadraticCurveTo(a, l + u, a, l + u - h), i === "center" && s === "left" && this.drawCaret(t, n, r, o), n.lineTo(a, l + d), n.quadraticCurveTo(a, l, a + d, l), n.closePath(), n.fill(), o.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(t) {
    const n = this.chart, r = this.$animations, o = r && r.x, s = r && r.y;
    if (o || s) {
      const i = ji[t.position].call(this, this._active, this._eventPosition);
      if (!i)
        return;
      const a = this._size = kv(this, t), l = Object.assign({}, i, this._size), c = Dv(n, t, l), u = Nv(t, l, c, n);
      (o._to !== u.x || s._to !== u.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = a.width, this.height = a.height, this.caretX = i.x, this.caretY = i.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const n = this.options.setContext(this.getContext());
    let r = this.opacity;
    if (!r)
      return;
    this._updateAnimationTarget(n);
    const o = {
      width: this.width,
      height: this.height
    }, s = {
      x: this.x,
      y: this.y
    };
    r = Math.abs(r) < 1e-3 ? 0 : r;
    const i = lr(n.padding), a = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && a && (t.save(), t.globalAlpha = r, this.drawBackground(s, t, o, n), t2(t, n.textDirection), s.y += i.top, this.drawTitle(s, t, n), this.drawBody(s, t, n), this.drawFooter(s, t, n), n2(t, n.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, n) {
    const r = this._active, o = t.map(({ datasetIndex: a, index: l }) => {
      const c = this.chart.getDatasetMeta(a);
      if (!c)
        throw new Error("Cannot find a dataset at index " + a);
      return {
        datasetIndex: a,
        element: c.data[l],
        index: l
      };
    }), s = !Cc(r, o), i = this._positionChanged(o, n);
    (s || i) && (this._active = o, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, n, r = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const o = this.options, s = this._active || [], i = this._getActiveElements(t, s, n, r), a = this._positionChanged(i, t), l = n || !Cc(i, s) || a;
    return l && (this._active = i, (o.enabled || o.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, n))), l;
  }
  _getActiveElements(t, n, r, o) {
    const s = this.options;
    if (t.type === "mouseout")
      return [];
    if (!o)
      return n;
    const i = this.chart.getElementsAtEventForMode(t, s.mode, s, r);
    return s.reverse && i.reverse(), i;
  }
  _positionChanged(t, n) {
    const { caretX: r, caretY: o, options: s } = this, i = ji[s.position].call(this, t, n);
    return i !== !1 && (r !== i.x || o !== i.y);
  }
}
ce(Qf, "positioners", ji);
var bN = {
  id: "tooltip",
  _element: Qf,
  positioners: ji,
  afterInit(e, t, n) {
    n && (e.tooltip = new Qf({
      chart: e,
      options: n
    }));
  },
  beforeUpdate(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  reset(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  afterDraw(e) {
    const t = e.tooltip;
    if (t && t._willRender()) {
      const n = {
        tooltip: t
      };
      if (e.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(e, t) {
    if (e.tooltip) {
      const n = t.replay;
      e.tooltip.handleEvent(t.event, n, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (e, t) => t.bodyFont.size,
    boxWidth: (e, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: Zx
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const vN = (e, t, n, r) => (typeof t == "string" ? (n = e.push(t) - 1, r.unshift({
  index: n,
  label: t
})) : isNaN(t) && (n = null), n);
function yN(e, t, n, r) {
  const o = e.indexOf(t);
  if (o === -1)
    return vN(e, t, n, r);
  const s = e.lastIndexOf(t);
  return o !== s ? n : o;
}
const xN = (e, t) => e === null ? null : kn(Math.round(e), 0, t);
function Fv(e) {
  const t = this.getLabels();
  return e >= 0 && e < t.length ? t[e] : e;
}
class Jf extends ws {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const n = this._addedLabels;
    if (n.length) {
      const r = this.getLabels();
      for (const { index: o, label: s } of n)
        r[o] === s && r.splice(o, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, n) {
    if (St(t))
      return null;
    const r = this.getLabels();
    return n = isFinite(n) && r[n] === t ? n : yN(r, t, mt(n, t), this._addedLabels), xN(n, r.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let { min: r, max: o } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (r = 0), n || (o = this.getLabels().length - 1)), this.min = r, this.max = o;
  }
  buildTicks() {
    const t = this.min, n = this.max, r = this.options.offset, o = [];
    let s = this.getLabels();
    s = t === 0 && n === s.length - 1 ? s : s.slice(t, n + 1), this._valueRange = Math.max(s.length - (r ? 0 : 1), 1), this._startValue = this.min - (r ? 0.5 : 0);
    for (let i = t; i <= n; i++)
      o.push({
        value: i
      });
    return o;
  }
  getLabelForValue(t) {
    return Fv.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
ce(Jf, "id", "category"), ce(Jf, "defaults", {
  ticks: {
    callback: Fv
  }
});
function wN(e, t) {
  const n = [], { bounds: o, step: s, min: i, max: a, precision: l, count: c, maxTicks: u, maxDigits: d, includeBounds: f } = e, h = s || 1, p = u - 1, { min: g, max: m } = t, v = !St(i), y = !St(a), x = !St(c), C = (m - g) / (d + 1);
  let w = Wb((m - g) / p / h) * h, E, S, O, M;
  if (w < 1e-14 && !v && !y)
    return [
      {
        value: g
      },
      {
        value: m
      }
    ];
  M = Math.ceil(m / w) - Math.floor(g / w), M > p && (w = Wb(M * w / p / h) * h), St(l) || (E = Math.pow(10, l), w = Math.ceil(w * E) / E), o === "ticks" ? (S = Math.floor(g / w) * w, O = Math.ceil(m / w) * w) : (S = g, O = m), v && y && s && ZI((a - i) / s, w / 1e3) ? (M = Math.round(Math.min((a - i) / w, u)), w = (a - i) / M, S = i, O = a) : x ? (S = v ? i : S, O = y ? a : O, M = c - 1, w = (O - S) / M) : (M = (O - S) / w, Ji(M, Math.round(M), w / 1e3) ? M = Math.round(M) : M = Math.ceil(M));
  const T = Math.max(Hb(w), Hb(S));
  E = Math.pow(10, St(l) ? T : l), S = Math.round(S * E) / E, O = Math.round(O * E) / E;
  let P = 0;
  for (v && (f && S !== i ? (n.push({
    value: i
  }), S < i && P++, Ji(Math.round((S + P * w) * E) / E, i, Lv(i, C, e)) && P++) : S < i && P++); P < M; ++P) {
    const I = Math.round((S + P * w) * E) / E;
    if (y && I > a)
      break;
    n.push({
      value: I
    });
  }
  return y && f && O !== a ? n.length && Ji(n[n.length - 1].value, a, Lv(a, C, e)) ? n[n.length - 1].value = a : n.push({
    value: a
  }) : (!y || O === a) && n.push({
    value: O
  }), n;
}
function Lv(e, t, { horizontal: n, minRotation: r }) {
  const o = kr(r), s = (n ? Math.sin(o) : Math.cos(o)) || 1e-3, i = 0.75 * t * ("" + e).length;
  return Math.min(t / s, i);
}
class kc extends ws {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    return St(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: n, maxDefined: r } = this.getUserBounds();
    let { min: o, max: s } = this;
    const i = (l) => o = n ? o : l, a = (l) => s = r ? s : l;
    if (t) {
      const l = $r(o), c = $r(s);
      l < 0 && c < 0 ? a(0) : l > 0 && c > 0 && i(0);
    }
    if (o === s) {
      let l = s === 0 ? 1 : Math.abs(s * 0.05);
      a(s + l), t || i(o - l);
    }
    this.min = o, this.max = s;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: n, stepSize: r } = t, o;
    return r ? (o = Math.ceil(this.max / r) - Math.floor(this.min / r) + 1, o > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${r} would result generating up to ${o} ticks. Limiting to 1000.`), o = 1e3)) : (o = this.computeTickLimit(), n = n || 11), n && (o = Math.min(n, o)), o;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, n = t.ticks;
    let r = this.getTickLimit();
    r = Math.max(2, r);
    const o = {
      maxTicks: r,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, s = this._range || this, i = wN(o, s);
    return t.bounds === "ticks" && vx(i, this, "value"), t.reverse ? (i.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), i;
  }
  configure() {
    const t = this.ticks;
    let n = this.min, r = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const o = (r - n) / Math.max(t.length - 1, 1) / 2;
      n -= o, r += o;
    }
    this._startValue = n, this._endValue = r, this._valueRange = r - n;
  }
  getLabelForValue(t) {
    return Nu(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class eh extends kc {
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = En(t) ? t : 0, this.max = En(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), n = t ? this.width : this.height, r = kr(this.options.ticks.minRotation), o = (t ? Math.sin(r) : Math.cos(r)) || 1e-3, s = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, s.lineHeight / o));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
ce(eh, "id", "linear"), ce(eh, "defaults", {
  ticks: {
    callback: Au.formatters.numeric
  }
});
const va = (e) => Math.floor(Co(e)), Zo = (e, t) => Math.pow(10, va(e) + t);
function Vv(e) {
  return e / Math.pow(10, va(e)) === 1;
}
function Wv(e, t, n) {
  const r = Math.pow(10, n), o = Math.floor(e / r);
  return Math.ceil(t / r) - o;
}
function CN(e, t) {
  const n = t - e;
  let r = va(n);
  for (; Wv(e, t, r) > 10; )
    r++;
  for (; Wv(e, t, r) < 10; )
    r--;
  return Math.min(r, va(e));
}
function EN(e, { min: t, max: n }) {
  t = Bn(e.min, t);
  const r = [], o = va(t);
  let s = CN(t, n), i = s < 0 ? Math.pow(10, Math.abs(s)) : 1;
  const a = Math.pow(10, s), l = o > s ? Math.pow(10, o) : 0, c = Math.round((t - l) * i) / i, u = Math.floor((t - l) / a / 10) * a * 10;
  let d = Math.floor((c - u) / Math.pow(10, s)), f = Bn(e.min, Math.round((l + u + d * Math.pow(10, s)) * i) / i);
  for (; f < n; )
    r.push({
      value: f,
      major: Vv(f),
      significand: d
    }), d >= 10 ? d = d < 15 ? 15 : 20 : d++, d >= 20 && (s++, d = 2, i = s >= 0 ? 1 : i), f = Math.round((l + u + d * Math.pow(10, s)) * i) / i;
  const h = Bn(e.max, f);
  return r.push({
    value: h,
    major: Vv(h),
    significand: d
  }), r;
}
class Hv extends ws {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    const r = kc.prototype.parse.apply(this, [
      t,
      n
    ]);
    if (r === 0) {
      this._zero = !0;
      return;
    }
    return En(r) && r > 0 ? r : null;
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = En(t) ? Math.max(0, t) : null, this.max = En(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !En(this._userMin) && (this.min = t === Zo(this.min, 0) ? Zo(this.min, -1) : Zo(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let r = this.min, o = this.max;
    const s = (a) => r = t ? r : a, i = (a) => o = n ? o : a;
    r === o && (r <= 0 ? (s(1), i(10)) : (s(Zo(r, -1)), i(Zo(o, 1)))), r <= 0 && s(Zo(o, -1)), o <= 0 && i(Zo(r, 1)), this.min = r, this.max = o;
  }
  buildTicks() {
    const t = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, r = EN(n, this);
    return t.bounds === "ticks" && vx(r, this, "value"), t.reverse ? (r.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), r;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : Nu(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = Co(t), this._valueRange = Co(this.max) - Co(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (Co(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const n = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
ce(Hv, "id", "logarithmic"), ce(Hv, "defaults", {
  ticks: {
    callback: Au.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function th(e) {
  const t = e.ticks;
  if (t.display && e.display) {
    const n = lr(t.backdropPadding);
    return mt(t.font && t.font.size, ln.font.size) + n.height;
  }
  return 0;
}
function _N(e, t, n) {
  return n = Xt(n) ? n : [
    n
  ], {
    w: mk(e, t.string, n),
    h: n.length * t.lineHeight
  };
}
function Bv(e, t, n, r, o) {
  return e === r || e === o ? {
    start: t - n / 2,
    end: t + n / 2
  } : e < r || e > o ? {
    start: t - n,
    end: t
  } : {
    start: t,
    end: t + n
  };
}
function SN(e) {
  const t = {
    l: e.left + e._padding.left,
    r: e.right - e._padding.right,
    t: e.top + e._padding.top,
    b: e.bottom - e._padding.bottom
  }, n = Object.assign({}, t), r = [], o = [], s = e._pointLabels.length, i = e.options.pointLabels, a = i.centerPointLabels ? dn / s : 0;
  for (let l = 0; l < s; l++) {
    const c = i.setContext(e.getPointLabelContext(l));
    o[l] = c.padding;
    const u = e.getPointPosition(l, e.drawingArea + o[l], a), d = Kn(c.font), f = _N(e.ctx, d, e._pointLabels[l]);
    r[l] = f;
    const h = pr(e.getIndexAngle(l) + a), p = Math.round(Dp(h)), g = Bv(p, u.x, f.w, 0, 180), m = Bv(p, u.y, f.h, 90, 270);
    ON(n, t, h, g, m);
  }
  e.setCenterPoint(t.l - n.l, n.r - t.r, t.t - n.t, n.b - t.b), e._pointLabelItems = RN(e, r, o);
}
function ON(e, t, n, r, o) {
  const s = Math.abs(Math.sin(n)), i = Math.abs(Math.cos(n));
  let a = 0, l = 0;
  r.start < t.l ? (a = (t.l - r.start) / s, e.l = Math.min(e.l, t.l - a)) : r.end > t.r && (a = (r.end - t.r) / s, e.r = Math.max(e.r, t.r + a)), o.start < t.t ? (l = (t.t - o.start) / i, e.t = Math.min(e.t, t.t - l)) : o.end > t.b && (l = (o.end - t.b) / i, e.b = Math.max(e.b, t.b + l));
}
function MN(e, t, n) {
  const r = e.drawingArea, { extra: o, additionalAngle: s, padding: i, size: a } = n, l = e.getPointPosition(t, r + o + i, s), c = Math.round(Dp(pr(l.angle + on))), u = kN(l.y, a.h, c), d = PN(c), f = IN(l.x, a.w, d);
  return {
    visible: !0,
    x: l.x,
    y: u,
    textAlign: d,
    left: f,
    top: u,
    right: f + a.w,
    bottom: u + a.h
  };
}
function TN(e, t) {
  if (!t)
    return !0;
  const { left: n, top: r, right: o, bottom: s } = e;
  return !(qr({
    x: n,
    y: r
  }, t) || qr({
    x: n,
    y: s
  }, t) || qr({
    x: o,
    y: r
  }, t) || qr({
    x: o,
    y: s
  }, t));
}
function RN(e, t, n) {
  const r = [], o = e._pointLabels.length, s = e.options, { centerPointLabels: i, display: a } = s.pointLabels, l = {
    extra: th(s) / 2,
    additionalAngle: i ? dn / o : 0
  };
  let c;
  for (let u = 0; u < o; u++) {
    l.padding = n[u], l.size = t[u];
    const d = MN(e, u, l);
    r.push(d), a === "auto" && (d.visible = TN(d, c), d.visible && (c = d));
  }
  return r;
}
function PN(e) {
  return e === 0 || e === 180 ? "center" : e < 180 ? "left" : "right";
}
function IN(e, t, n) {
  return n === "right" ? e -= t : n === "center" && (e -= t / 2), e;
}
function kN(e, t, n) {
  return n === 90 || n === 270 ? e -= t / 2 : (n > 270 || n < 90) && (e -= t), e;
}
function DN(e, t, n) {
  const { left: r, top: o, right: s, bottom: i } = n, { backdropColor: a } = t;
  if (!St(a)) {
    const l = Us(t.borderRadius), c = lr(t.backdropPadding);
    e.fillStyle = a;
    const u = r - c.left, d = o - c.top, f = s - r + c.width, h = i - o + c.height;
    Object.values(l).some((p) => p !== 0) ? (e.beginPath(), Tc(e, {
      x: u,
      y: d,
      w: f,
      h,
      radius: l
    }), e.fill()) : e.fillRect(u, d, f, h);
  }
}
function NN(e, t) {
  const { ctx: n, options: { pointLabels: r } } = e;
  for (let o = t - 1; o >= 0; o--) {
    const s = e._pointLabelItems[o];
    if (!s.visible)
      continue;
    const i = r.setContext(e.getPointLabelContext(o));
    DN(n, i, s);
    const a = Kn(i.font), { x: l, y: c, textAlign: u } = s;
    Mc(n, e._pointLabels[o], l, c + a.lineHeight / 2, a, {
      color: i.color,
      textAlign: u,
      textBaseline: "middle"
    });
  }
}
function Qx(e, t, n, r) {
  const { ctx: o } = e;
  if (n)
    o.arc(e.xCenter, e.yCenter, t, 0, Ut);
  else {
    let s = e.getPointPosition(0, t);
    o.moveTo(s.x, s.y);
    for (let i = 1; i < r; i++)
      s = e.getPointPosition(i, t), o.lineTo(s.x, s.y);
  }
}
function AN(e, t, n, r, o) {
  const s = e.ctx, i = t.circular, { color: a, lineWidth: l } = t;
  !i && !r || !a || !l || n < 0 || (s.save(), s.strokeStyle = a, s.lineWidth = l, s.setLineDash(o.dash), s.lineDashOffset = o.dashOffset, s.beginPath(), Qx(e, n, i, r), s.closePath(), s.stroke(), s.restore());
}
function $N(e, t, n) {
  return Bo(e, {
    label: n,
    index: t,
    type: "pointLabel"
  });
}
class Tl extends kc {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = lr(th(this.options) / 2), n = this.width = this.maxWidth - t.width, r = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + n / 2 + t.left), this.yCenter = Math.floor(this.top + r / 2 + t.top), this.drawingArea = Math.floor(Math.min(n, r) / 2);
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!1);
    this.min = En(t) && !isNaN(t) ? t : 0, this.max = En(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / th(this.options));
  }
  generateTickLabels(t) {
    kc.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((n, r) => {
      const o = nn(this.options.pointLabels.callback, [
        n,
        r
      ], this);
      return o || o === 0 ? o : "";
    }).filter((n, r) => this.chart.getDataVisibility(r));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? SN(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, n, r, o) {
    this.xCenter += Math.floor((t - n) / 2), this.yCenter += Math.floor((r - o) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, n, r, o));
  }
  getIndexAngle(t) {
    const n = Ut / (this._pointLabels.length || 1), r = this.options.startAngle || 0;
    return pr(t * n + kr(r));
  }
  getDistanceFromCenterForValue(t) {
    if (St(t))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * n : (t - this.min) * n;
  }
  getValueForDistanceFromCenter(t) {
    if (St(t))
      return NaN;
    const n = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(t) {
    const n = this._pointLabels || [];
    if (t >= 0 && t < n.length) {
      const r = n[t];
      return $N(this.getContext(), t, r);
    }
  }
  getPointPosition(t, n, r = 0) {
    const o = this.getIndexAngle(t) - on + r;
    return {
      x: Math.cos(o) * n + this.xCenter,
      y: Math.sin(o) * n + this.yCenter,
      angle: o
    };
  }
  getPointPositionForValue(t, n) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: n, top: r, right: o, bottom: s } = this._pointLabelItems[t];
    return {
      left: n,
      top: r,
      right: o,
      bottom: s
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: n } } = this.options;
    if (t) {
      const r = this.ctx;
      r.save(), r.beginPath(), Qx(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), r.closePath(), r.fillStyle = t, r.fill(), r.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, n = this.options, { angleLines: r, grid: o, border: s } = n, i = this._pointLabels.length;
    let a, l, c;
    if (n.pointLabels.display && NN(this, i), o.display && this.ticks.forEach((u, d) => {
      if (d !== 0) {
        l = this.getDistanceFromCenterForValue(u.value);
        const f = this.getContext(d), h = o.setContext(f), p = s.setContext(f);
        AN(this, h, l, i, p);
      }
    }), r.display) {
      for (t.save(), a = i - 1; a >= 0; a--) {
        const u = r.setContext(this.getPointLabelContext(a)), { color: d, lineWidth: f } = u;
        !f || !d || (t.lineWidth = f, t.strokeStyle = d, t.setLineDash(u.borderDash), t.lineDashOffset = u.borderDashOffset, l = this.getDistanceFromCenterForValue(n.ticks.reverse ? this.min : this.max), c = this.getPointPosition(a, l), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(c.x, c.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, n = this.options, r = n.ticks;
    if (!r.display)
      return;
    const o = this.getIndexAngle(0);
    let s, i;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(o), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((a, l) => {
      if (l === 0 && !n.reverse)
        return;
      const c = r.setContext(this.getContext(l)), u = Kn(c.font);
      if (s = this.getDistanceFromCenterForValue(this.ticks[l].value), c.showLabelBackdrop) {
        t.font = u.string, i = t.measureText(a.label).width, t.fillStyle = c.backdropColor;
        const d = lr(c.backdropPadding);
        t.fillRect(-i / 2 - d.left, -s - u.size / 2 - d.top, i + d.width, u.size + d.height);
      }
      Mc(t, a.label, 0, -s, u, {
        color: c.color,
        strokeColor: c.textStrokeColor,
        strokeWidth: c.textStrokeWidth
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
ce(Tl, "id", "radialLinear"), ce(Tl, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: Au.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(t) {
      return t;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), ce(Tl, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), ce(Tl, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const Lu = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, $n = /* @__PURE__ */ Object.keys(Lu);
function zv(e, t) {
  return e - t;
}
function Yv(e, t) {
  if (St(t))
    return null;
  const n = e._adapter, { parser: r, round: o, isoWeekday: s } = e._parseOpts;
  let i = t;
  return typeof r == "function" && (i = r(i)), En(i) || (i = typeof r == "string" ? n.parse(i, r) : n.parse(i)), i === null ? null : (o && (i = o === "week" && (ga(s) || s === !0) ? n.startOf(i, "isoWeek", s) : n.startOf(i, o)), +i);
}
function jv(e, t, n, r) {
  const o = $n.length;
  for (let s = $n.indexOf(e); s < o - 1; ++s) {
    const i = Lu[$n[s]], a = i.steps ? i.steps : Number.MAX_SAFE_INTEGER;
    if (i.common && Math.ceil((n - t) / (a * i.size)) <= r)
      return $n[s];
  }
  return $n[o - 1];
}
function FN(e, t, n, r, o) {
  for (let s = $n.length - 1; s >= $n.indexOf(n); s--) {
    const i = $n[s];
    if (Lu[i].common && e._adapter.diff(o, r, i) >= t - 1)
      return i;
  }
  return $n[n ? $n.indexOf(n) : 0];
}
function LN(e) {
  for (let t = $n.indexOf(e) + 1, n = $n.length; t < n; ++t)
    if (Lu[$n[t]].common)
      return $n[t];
}
function Uv(e, t, n) {
  if (!n)
    e[t] = !0;
  else if (n.length) {
    const { lo: r, hi: o } = Np(n, t), s = n[r] >= t ? n[r] : n[o];
    e[s] = !0;
  }
}
function VN(e, t, n, r) {
  const o = e._adapter, s = +o.startOf(t[0].value, r), i = t[t.length - 1].value;
  let a, l;
  for (a = s; a <= i; a = +o.add(a, 1, r))
    l = n[a], l >= 0 && (t[l].major = !0);
  return t;
}
function Gv(e, t, n) {
  const r = [], o = {}, s = t.length;
  let i, a;
  for (i = 0; i < s; ++i)
    a = t[i], o[a] = i, r.push({
      value: a,
      major: !1
    });
  return s === 0 || !n ? r : VN(e, r, o, n);
}
class ya extends ws {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, n = {}) {
    const r = t.time || (t.time = {}), o = this._adapter = new Lx._date(t.adapters.date);
    o.init(n), Qi(r.displayFormats, o.formats()), this._parseOpts = {
      parser: r.parser,
      round: r.round,
      isoWeekday: r.isoWeekday
    }, super.init(t), this._normalized = n.normalized;
  }
  parse(t, n) {
    return t === void 0 ? null : Yv(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, n = this._adapter, r = t.time.unit || "day";
    let { min: o, max: s, minDefined: i, maxDefined: a } = this.getUserBounds();
    function l(c) {
      !i && !isNaN(c.min) && (o = Math.min(o, c.min)), !a && !isNaN(c.max) && (s = Math.max(s, c.max));
    }
    (!i || !a) && (l(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && l(this.getMinMax(!1))), o = En(o) && !isNaN(o) ? o : +n.startOf(Date.now(), r), s = En(s) && !isNaN(s) ? s : +n.endOf(Date.now(), r) + 1, this.min = Math.min(o, s - 1), this.max = Math.max(o + 1, s);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, r = Number.NEGATIVE_INFINITY;
    return t.length && (n = t[0], r = t[t.length - 1]), {
      min: n,
      max: r
    };
  }
  buildTicks() {
    const t = this.options, n = t.time, r = t.ticks, o = r.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && o.length && (this.min = this._userMin || o[0], this.max = this._userMax || o[o.length - 1]);
    const s = this.min, i = this.max, a = tk(o, s, i);
    return this._unit = n.unit || (r.autoSkip ? jv(n.minUnit, this.min, this.max, this._getLabelCapacity(s)) : FN(this, a.length, n.minUnit, this.min, this.max)), this._majorUnit = !r.major.enabled || this._unit === "year" ? void 0 : LN(this._unit), this.initOffsets(o), t.reverse && a.reverse(), Gv(this, a, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let n = 0, r = 0, o, s;
    this.options.offset && t.length && (o = this.getDecimalForValue(t[0]), t.length === 1 ? n = 1 - o : n = (this.getDecimalForValue(t[1]) - o) / 2, s = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? r = s : r = (s - this.getDecimalForValue(t[t.length - 2])) / 2);
    const i = t.length < 3 ? 0.5 : 0.25;
    n = kn(n, 0, i), r = kn(r, 0, i), this._offsets = {
      start: n,
      end: r,
      factor: 1 / (n + 1 + r)
    };
  }
  _generate() {
    const t = this._adapter, n = this.min, r = this.max, o = this.options, s = o.time, i = s.unit || jv(s.minUnit, n, r, this._getLabelCapacity(n)), a = mt(o.ticks.stepSize, 1), l = i === "week" ? s.isoWeekday : !1, c = ga(l) || l === !0, u = {};
    let d = n, f, h;
    if (c && (d = +t.startOf(d, "isoWeek", l)), d = +t.startOf(d, c ? "day" : i), t.diff(r, n, i) > 1e5 * a)
      throw new Error(n + " and " + r + " are too far apart with stepSize of " + a + " " + i);
    const p = o.ticks.source === "data" && this.getDataTimestamps();
    for (f = d, h = 0; f < r; f = +t.add(f, a, i), h++)
      Uv(u, f, p);
    return (f === r || o.bounds === "ticks" || h === 1) && Uv(u, f, p), Object.keys(u).sort(zv).map((g) => +g);
  }
  getLabelForValue(t) {
    const n = this._adapter, r = this.options.time;
    return r.tooltipFormat ? n.format(t, r.tooltipFormat) : n.format(t, r.displayFormats.datetime);
  }
  format(t, n) {
    const o = this.options.time.displayFormats, s = this._unit, i = n || o[s];
    return this._adapter.format(t, i);
  }
  _tickFormatFunction(t, n, r, o) {
    const s = this.options, i = s.ticks.callback;
    if (i)
      return nn(i, [
        t,
        n,
        r
      ], this);
    const a = s.time.displayFormats, l = this._unit, c = this._majorUnit, u = l && a[l], d = c && a[c], f = r[n], h = c && d && f && f.major;
    return this._adapter.format(t, o || (h ? d : u));
  }
  generateTickLabels(t) {
    let n, r, o;
    for (n = 0, r = t.length; n < r; ++n)
      o = t[n], o.label = this._tickFormatFunction(o.value, n, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const n = this._offsets, r = this.getDecimalForValue(t);
    return this.getPixelForDecimal((n.start + r) * n.factor);
  }
  getValueForPixel(t) {
    const n = this._offsets, r = this.getDecimalForPixel(t) / n.factor - n.end;
    return this.min + r * (this.max - this.min);
  }
  _getLabelSize(t) {
    const n = this.options.ticks, r = this.ctx.measureText(t).width, o = kr(this.isHorizontal() ? n.maxRotation : n.minRotation), s = Math.cos(o), i = Math.sin(o), a = this._resolveTickFontOptions(0).size;
    return {
      w: r * s + a * i,
      h: r * i + a * s
    };
  }
  _getLabelCapacity(t) {
    const n = this.options.time, r = n.displayFormats, o = r[n.unit] || r.millisecond, s = this._tickFormatFunction(t, 0, Gv(this, [
      t
    ], this._majorUnit), o), i = this._getLabelSize(s), a = Math.floor(this.isHorizontal() ? this.width / i.w : this.height / i.h) - 1;
    return a > 0 ? a : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], n, r;
    if (t.length)
      return t;
    const o = this.getMatchingVisibleMetas();
    if (this._normalized && o.length)
      return this._cache.data = o[0].controller.getAllParsedValues(this);
    for (n = 0, r = o.length; n < r; ++n)
      t = t.concat(o[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let n, r;
    if (t.length)
      return t;
    const o = this.getLabels();
    for (n = 0, r = o.length; n < r; ++n)
      t.push(Yv(this, o[n]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return wx(t.sort(zv));
  }
}
ce(ya, "id", "time"), ce(ya, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function Rl(e, t, n) {
  let r = 0, o = e.length - 1, s, i, a, l;
  n ? (t >= e[r].pos && t <= e[o].pos && ({ lo: r, hi: o } = ss(e, "pos", t)), { pos: s, time: a } = e[r], { pos: i, time: l } = e[o]) : (t >= e[r].time && t <= e[o].time && ({ lo: r, hi: o } = ss(e, "time", t)), { time: s, pos: a } = e[r], { time: i, pos: l } = e[o]);
  const c = i - s;
  return c ? a + (l - a) * (t - s) / c : a;
}
class Kv extends ya {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(t);
    this._minPos = Rl(n, this.min), this._tableRange = Rl(n, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: n, max: r } = this, o = [], s = [];
    let i, a, l, c, u;
    for (i = 0, a = t.length; i < a; ++i)
      c = t[i], c >= n && c <= r && o.push(c);
    if (o.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: r,
          pos: 1
        }
      ];
    for (i = 0, a = o.length; i < a; ++i)
      u = o[i + 1], l = o[i - 1], c = o[i], Math.round((u + l) / 2) !== c && s.push({
        time: c,
        pos: i / (a - 1)
      });
    return s;
  }
  _generate() {
    const t = this.min, n = this.max;
    let r = super.getDataTimestamps();
    return (!r.includes(t) || !r.length) && r.splice(0, 0, t), (!r.includes(n) || r.length === 1) && r.push(n), r.sort((o, s) => o - s);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const n = this.getDataTimestamps(), r = this.getLabelTimestamps();
    return n.length && r.length ? t = this.normalize(n.concat(r)) : t = n.length ? n : r, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (Rl(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const n = this._offsets, r = this.getDecimalForPixel(t) / n.factor - n.end;
    return Rl(this._table, r * this._tableRange + this._minPos, !0);
  }
}
ce(Kv, "id", "timeseries"), ce(Kv, "defaults", ya.defaults);
function oo(e) {
  "@babel/helpers - typeof";
  return oo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oo(e);
}
function jt(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function He(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function ze(e) {
  He(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || oo(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Jx(e, t) {
  He(2, arguments);
  var n = ze(e), r = jt(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function Bp(e, t) {
  He(2, arguments);
  var n = ze(e), r = jt(t);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var o = n.getDate(), s = new Date(n.getTime());
  s.setMonth(n.getMonth() + r + 1, 0);
  var i = s.getDate();
  return o >= i ? s : (n.setFullYear(s.getFullYear(), s.getMonth(), o), n);
}
function Ba(e, t) {
  He(2, arguments);
  var n = ze(e).getTime(), r = jt(t);
  return new Date(n + r);
}
var WN = 36e5;
function HN(e, t) {
  He(2, arguments);
  var n = jt(t);
  return Ba(e, n * WN);
}
var BN = {};
function zo() {
  return BN;
}
function qv(e, t) {
  var n, r, o, s, i, a, l, c;
  He(1, arguments);
  var u = zo(), d = jt((n = (r = (o = (s = t == null ? void 0 : t.weekStartsOn) !== null && s !== void 0 ? s : t == null || (i = t.locale) === null || i === void 0 || (a = i.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = ze(e), h = f.getDay(), p = (h < d ? 7 : 0) + h - d;
  return f.setDate(f.getDate() - p), f.setHours(0, 0, 0, 0), f;
}
function Dc(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function nh(e) {
  He(1, arguments);
  var t = ze(e);
  return t.setHours(0, 0, 0, 0), t;
}
var zN = 864e5;
function rh(e, t) {
  He(2, arguments);
  var n = nh(e), r = nh(t), o = n.getTime() - Dc(n), s = r.getTime() - Dc(r);
  return Math.round((o - s) / zN);
}
var YN = 6e4;
function jN(e, t) {
  He(2, arguments);
  var n = jt(t);
  return Ba(e, n * YN);
}
function UN(e, t) {
  He(2, arguments);
  var n = jt(t), r = n * 3;
  return Bp(e, r);
}
function GN(e, t) {
  He(2, arguments);
  var n = jt(t);
  return Ba(e, n * 1e3);
}
function KN(e, t) {
  He(2, arguments);
  var n = jt(t), r = n * 7;
  return Jx(e, r);
}
function qN(e, t) {
  He(2, arguments);
  var n = jt(t);
  return Bp(e, n * 12);
}
function na(e, t) {
  He(2, arguments);
  var n = ze(e), r = ze(t), o = n.getTime() - r.getTime();
  return o < 0 ? -1 : o > 0 ? 1 : o;
}
var Vu = 6e4, Wu = 36e5, XN = 1e3;
function ZN(e) {
  return He(1, arguments), e instanceof Date || oo(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function zp(e) {
  if (He(1, arguments), !ZN(e) && typeof e != "number")
    return !1;
  var t = ze(e);
  return !isNaN(Number(t));
}
function QN(e, t) {
  He(2, arguments);
  var n = ze(e), r = ze(t), o = n.getFullYear() - r.getFullYear(), s = n.getMonth() - r.getMonth();
  return o * 12 + s;
}
function JN(e, t) {
  He(2, arguments);
  var n = ze(e), r = ze(t);
  return n.getFullYear() - r.getFullYear();
}
function Xv(e, t) {
  var n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function ew(e, t) {
  He(2, arguments);
  var n = ze(e), r = ze(t), o = Xv(n, r), s = Math.abs(rh(n, r));
  n.setDate(n.getDate() - o * s);
  var i = +(Xv(n, r) === -o), a = o * (s - i);
  return a === 0 ? 0 : a;
}
function Hu(e, t) {
  return He(2, arguments), ze(e).getTime() - ze(t).getTime();
}
var Zv = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
  }
  // Math.trunc is not supported by IE
}, e5 = "trunc";
function za(e) {
  return e ? Zv[e] : Zv[e5];
}
function t5(e, t, n) {
  He(2, arguments);
  var r = Hu(e, t) / Wu;
  return za(n == null ? void 0 : n.roundingMethod)(r);
}
function n5(e, t, n) {
  He(2, arguments);
  var r = Hu(e, t) / Vu;
  return za(n == null ? void 0 : n.roundingMethod)(r);
}
function tw(e) {
  He(1, arguments);
  var t = ze(e);
  return t.setHours(23, 59, 59, 999), t;
}
function nw(e) {
  He(1, arguments);
  var t = ze(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function r5(e) {
  He(1, arguments);
  var t = ze(e);
  return tw(t).getTime() === nw(t).getTime();
}
function rw(e, t) {
  He(2, arguments);
  var n = ze(e), r = ze(t), o = na(n, r), s = Math.abs(QN(n, r)), i;
  if (s < 1)
    i = 0;
  else {
    n.getMonth() === 1 && n.getDate() > 27 && n.setDate(30), n.setMonth(n.getMonth() - o * s);
    var a = na(n, r) === -o;
    r5(ze(e)) && s === 1 && na(e, r) === 1 && (a = !1), i = o * (s - Number(a));
  }
  return i === 0 ? 0 : i;
}
function o5(e, t, n) {
  He(2, arguments);
  var r = rw(e, t) / 3;
  return za(n == null ? void 0 : n.roundingMethod)(r);
}
function s5(e, t, n) {
  He(2, arguments);
  var r = Hu(e, t) / 1e3;
  return za(n == null ? void 0 : n.roundingMethod)(r);
}
function i5(e, t, n) {
  He(2, arguments);
  var r = ew(e, t) / 7;
  return za(n == null ? void 0 : n.roundingMethod)(r);
}
function a5(e, t) {
  He(2, arguments);
  var n = ze(e), r = ze(t), o = na(n, r), s = Math.abs(JN(n, r));
  n.setFullYear(1584), r.setFullYear(1584);
  var i = na(n, r) === -o, a = o * (s - Number(i));
  return a === 0 ? 0 : a;
}
function l5(e) {
  He(1, arguments);
  var t = ze(e);
  return t.setSeconds(0, 0), t;
}
function c5(e) {
  He(1, arguments);
  var t = ze(e), n = t.getMonth(), r = n - n % 3;
  return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
}
function ec(e) {
  He(1, arguments);
  var t = ze(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function u5(e) {
  He(1, arguments);
  var t = ze(e), n = t.getFullYear();
  return t.setFullYear(n + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function d5(e) {
  He(1, arguments);
  var t = ze(e), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function f5(e) {
  He(1, arguments);
  var t = ze(e);
  return t.setMinutes(59, 59, 999), t;
}
function h5(e, t) {
  var n, r, o, s, i, a, l, c;
  He(1, arguments);
  var u = zo(), d = jt((n = (r = (o = (s = t == null ? void 0 : t.weekStartsOn) !== null && s !== void 0 ? s : t == null || (i = t.locale) === null || i === void 0 || (a = i.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = ze(e), h = f.getDay(), p = (h < d ? -7 : 0) + 6 - (h - d);
  return f.setDate(f.getDate() + p), f.setHours(23, 59, 59, 999), f;
}
function p5(e) {
  He(1, arguments);
  var t = ze(e);
  return t.setSeconds(59, 999), t;
}
function g5(e) {
  He(1, arguments);
  var t = ze(e), n = t.getMonth(), r = n - n % 3 + 3;
  return t.setMonth(r, 0), t.setHours(23, 59, 59, 999), t;
}
function m5(e) {
  He(1, arguments);
  var t = ze(e);
  return t.setMilliseconds(999), t;
}
function ow(e, t) {
  He(2, arguments);
  var n = jt(t);
  return Ba(e, -n);
}
var b5 = 864e5;
function v5(e) {
  He(1, arguments);
  var t = ze(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), o = n - r;
  return Math.floor(o / b5) + 1;
}
function ti(e) {
  He(1, arguments);
  var t = 1, n = ze(e), r = n.getUTCDay(), o = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - o), n.setUTCHours(0, 0, 0, 0), n;
}
function sw(e) {
  He(1, arguments);
  var t = ze(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var o = ti(r), s = /* @__PURE__ */ new Date(0);
  s.setUTCFullYear(n, 0, 4), s.setUTCHours(0, 0, 0, 0);
  var i = ti(s);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function y5(e) {
  He(1, arguments);
  var t = sw(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = ti(n);
  return r;
}
var x5 = 6048e5;
function iw(e) {
  He(1, arguments);
  var t = ze(e), n = ti(t).getTime() - y5(t).getTime();
  return Math.round(n / x5) + 1;
}
function ps(e, t) {
  var n, r, o, s, i, a, l, c;
  He(1, arguments);
  var u = zo(), d = jt((n = (r = (o = (s = t == null ? void 0 : t.weekStartsOn) !== null && s !== void 0 ? s : t == null || (i = t.locale) === null || i === void 0 || (a = i.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = ze(e), h = f.getUTCDay(), p = (h < d ? 7 : 0) + h - d;
  return f.setUTCDate(f.getUTCDate() - p), f.setUTCHours(0, 0, 0, 0), f;
}
function Yp(e, t) {
  var n, r, o, s, i, a, l, c;
  He(1, arguments);
  var u = ze(e), d = u.getUTCFullYear(), f = zo(), h = jt((n = (r = (o = (s = t == null ? void 0 : t.firstWeekContainsDate) !== null && s !== void 0 ? s : t == null || (i = t.locale) === null || i === void 0 || (a = i.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(d + 1, 0, h), p.setUTCHours(0, 0, 0, 0);
  var g = ps(p, t), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(d, 0, h), m.setUTCHours(0, 0, 0, 0);
  var v = ps(m, t);
  return u.getTime() >= g.getTime() ? d + 1 : u.getTime() >= v.getTime() ? d : d - 1;
}
function w5(e, t) {
  var n, r, o, s, i, a, l, c;
  He(1, arguments);
  var u = zo(), d = jt((n = (r = (o = (s = t == null ? void 0 : t.firstWeekContainsDate) !== null && s !== void 0 ? s : t == null || (i = t.locale) === null || i === void 0 || (a = i.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), f = Yp(e, t), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(f, 0, d), h.setUTCHours(0, 0, 0, 0);
  var p = ps(h, t);
  return p;
}
var C5 = 6048e5;
function aw(e, t) {
  He(1, arguments);
  var n = ze(e), r = ps(n, t).getTime() - w5(n, t).getTime();
  return Math.round(r / C5) + 1;
}
function Ct(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var E5 = {
  // Year
  y: function(t, n) {
    var r = t.getUTCFullYear(), o = r > 0 ? r : 1 - r;
    return Ct(n === "yy" ? o % 100 : o, n.length);
  },
  // Month
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : Ct(r + 1, 2);
  },
  // Day of the month
  d: function(t, n) {
    return Ct(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, n) {
    return Ct(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(t, n) {
    return Ct(t.getUTCHours(), n.length);
  },
  // Minute
  m: function(t, n) {
    return Ct(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function(t, n) {
    return Ct(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(t, n) {
    var r = n.length, o = t.getUTCMilliseconds(), s = Math.floor(o * Math.pow(10, r - 3));
    return Ct(s, n.length);
  }
};
const mo = E5;
var Rs = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, _5 = {
  // Era
  G: function(t, n, r) {
    var o = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(o, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(o, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(o, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, n, r) {
    if (n === "yo") {
      var o = t.getUTCFullYear(), s = o > 0 ? o : 1 - o;
      return r.ordinalNumber(s, {
        unit: "year"
      });
    }
    return mo.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, r, o) {
    var s = Yp(t, o), i = s > 0 ? s : 1 - s;
    if (n === "YY") {
      var a = i % 100;
      return Ct(a, 2);
    }
    return n === "Yo" ? r.ordinalNumber(i, {
      unit: "year"
    }) : Ct(i, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    var r = sw(t);
    return Ct(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return Ct(r, n.length);
  },
  // Quarter
  Q: function(t, n, r) {
    var o = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(o);
      case "QQ":
        return Ct(o, 2);
      case "Qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, r) {
    var o = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(o);
      case "qq":
        return Ct(o, 2);
      case "qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, r) {
    var o = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return mo.M(t, n);
      case "Mo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(o, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, n, r) {
    var o = t.getUTCMonth();
    switch (n) {
      case "L":
        return String(o + 1);
      case "LL":
        return Ct(o + 1, 2);
      case "Lo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(o, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, n, r, o) {
    var s = aw(t, o);
    return n === "wo" ? r.ordinalNumber(s, {
      unit: "week"
    }) : Ct(s, n.length);
  },
  // ISO week of year
  I: function(t, n, r) {
    var o = iw(t);
    return n === "Io" ? r.ordinalNumber(o, {
      unit: "week"
    }) : Ct(o, n.length);
  },
  // Day of the month
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : mo.d(t, n);
  },
  // Day of year
  D: function(t, n, r) {
    var o = v5(t);
    return n === "Do" ? r.ordinalNumber(o, {
      unit: "dayOfYear"
    }) : Ct(o, n.length);
  },
  // Day of week
  E: function(t, n, r) {
    var o = t.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, r, o) {
    var s = t.getUTCDay(), i = (s - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(i);
      case "ee":
        return Ct(i, 2);
      case "eo":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return r.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(s, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, r, o) {
    var s = t.getUTCDay(), i = (s - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(i);
      case "cc":
        return Ct(i, n.length);
      case "co":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return r.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(s, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(s, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, r) {
    var o = t.getUTCDay(), s = o === 0 ? 7 : o;
    switch (n) {
      case "i":
        return String(s);
      case "ii":
        return Ct(s, n.length);
      case "io":
        return r.ordinalNumber(s, {
          unit: "day"
        });
      case "iii":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, r) {
    var o = t.getUTCHours(), s = o / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, r) {
    var o = t.getUTCHours(), s;
    switch (o === 12 ? s = Rs.noon : o === 0 ? s = Rs.midnight : s = o / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, r) {
    var o = t.getUTCHours(), s;
    switch (o >= 17 ? s = Rs.evening : o >= 12 ? s = Rs.afternoon : o >= 4 ? s = Rs.morning : s = Rs.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, r) {
    if (n === "ho") {
      var o = t.getUTCHours() % 12;
      return o === 0 && (o = 12), r.ordinalNumber(o, {
        unit: "hour"
      });
    }
    return mo.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : mo.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, r) {
    var o = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : Ct(o, n.length);
  },
  // Hour [1-24]
  k: function(t, n, r) {
    var o = t.getUTCHours();
    return o === 0 && (o = 24), n === "ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : Ct(o, n.length);
  },
  // Minute
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : mo.m(t, n);
  },
  // Second
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : mo.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return mo.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, r, o) {
    var s = o._originalDate || t, i = s.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (n) {
      case "X":
        return Jv(i);
      case "XXXX":
      case "XX":
        return es(i);
      case "XXXXX":
      case "XXX":
      default:
        return es(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, r, o) {
    var s = o._originalDate || t, i = s.getTimezoneOffset();
    switch (n) {
      case "x":
        return Jv(i);
      case "xxxx":
      case "xx":
        return es(i);
      case "xxxxx":
      case "xxx":
      default:
        return es(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, r, o) {
    var s = o._originalDate || t, i = s.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Qv(i, ":");
      case "OOOO":
      default:
        return "GMT" + es(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, r, o) {
    var s = o._originalDate || t, i = s.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Qv(i, ":");
      case "zzzz":
      default:
        return "GMT" + es(i, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, r, o) {
    var s = o._originalDate || t, i = Math.floor(s.getTime() / 1e3);
    return Ct(i, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, r, o) {
    var s = o._originalDate || t, i = s.getTime();
    return Ct(i, n.length);
  }
};
function Qv(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.floor(r / 60), s = r % 60;
  if (s === 0)
    return n + String(o);
  var i = t || "";
  return n + String(o) + i + Ct(s, 2);
}
function Jv(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + Ct(Math.abs(e) / 60, 2);
  }
  return es(e, t);
}
function es(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", o = Math.abs(e), s = Ct(Math.floor(o / 60), 2), i = Ct(o % 60, 2);
  return r + s + n + i;
}
const S5 = _5;
var e0 = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, lw = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, O5 = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], o = r[1], s = r[2];
  if (!s)
    return e0(t, n);
  var i;
  switch (o) {
    case "P":
      i = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = n.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", e0(o, n)).replace("{{time}}", lw(s, n));
}, M5 = {
  p: lw,
  P: O5
};
const oh = M5;
var T5 = ["D", "DD"], R5 = ["YY", "YYYY"];
function cw(e) {
  return T5.indexOf(e) !== -1;
}
function uw(e) {
  return R5.indexOf(e) !== -1;
}
function Nc(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var P5 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, I5 = function(t, n, r) {
  var o, s = P5[t];
  return typeof s == "string" ? o = s : n === 1 ? o = s.one : o = s.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + o : o + " ago" : o;
};
const k5 = I5;
function jd(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var D5 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, N5 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, A5 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, $5 = {
  date: jd({
    formats: D5,
    defaultWidth: "full"
  }),
  time: jd({
    formats: N5,
    defaultWidth: "full"
  }),
  dateTime: jd({
    formats: A5,
    defaultWidth: "full"
  })
};
const F5 = $5;
var L5 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, V5 = function(t, n, r, o) {
  return L5[t];
};
const W5 = V5;
function Ri(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", o;
    if (r === "formatting" && e.formattingValues) {
      var s = e.defaultFormattingWidth || e.defaultWidth, i = n != null && n.width ? String(n.width) : s;
      o = e.formattingValues[i] || e.formattingValues[s];
    } else {
      var a = e.defaultWidth, l = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[l] || e.values[a];
    }
    var c = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[c];
  };
}
var H5 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, B5 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, z5 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Y5 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, j5 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, U5 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, G5 = function(t, n) {
  var r = Number(t), o = r % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, K5 = {
  ordinalNumber: G5,
  era: Ri({
    values: H5,
    defaultWidth: "wide"
  }),
  quarter: Ri({
    values: B5,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Ri({
    values: z5,
    defaultWidth: "wide"
  }),
  day: Ri({
    values: Y5,
    defaultWidth: "wide"
  }),
  dayPeriod: Ri({
    values: j5,
    defaultWidth: "wide",
    formattingValues: U5,
    defaultFormattingWidth: "wide"
  })
};
const q5 = K5;
function Pi(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], s = t.match(o);
    if (!s)
      return null;
    var i = s[0], a = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(a) ? Z5(a, function(d) {
      return d.test(i);
    }) : X5(a, function(d) {
      return d.test(i);
    }), c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? n.valueCallback(c) : c;
    var u = t.slice(i.length);
    return {
      value: c,
      rest: u
    };
  };
}
function X5(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function Z5(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function Q5(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var o = r[0], s = t.match(e.parsePattern);
    if (!s)
      return null;
    var i = e.valueCallback ? e.valueCallback(s[0]) : s[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    var a = t.slice(o.length);
    return {
      value: i,
      rest: a
    };
  };
}
var J5 = /^(\d+)(th|st|nd|rd)?/i, e6 = /\d+/i, t6 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, n6 = {
  any: [/^b/i, /^(a|c)/i]
}, r6 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, o6 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, s6 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, i6 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, a6 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, l6 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, c6 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, u6 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, d6 = {
  ordinalNumber: Q5({
    matchPattern: J5,
    parsePattern: e6,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Pi({
    matchPatterns: t6,
    defaultMatchWidth: "wide",
    parsePatterns: n6,
    defaultParseWidth: "any"
  }),
  quarter: Pi({
    matchPatterns: r6,
    defaultMatchWidth: "wide",
    parsePatterns: o6,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Pi({
    matchPatterns: s6,
    defaultMatchWidth: "wide",
    parsePatterns: i6,
    defaultParseWidth: "any"
  }),
  day: Pi({
    matchPatterns: a6,
    defaultMatchWidth: "wide",
    parsePatterns: l6,
    defaultParseWidth: "any"
  }),
  dayPeriod: Pi({
    matchPatterns: c6,
    defaultMatchWidth: "any",
    parsePatterns: u6,
    defaultParseWidth: "any"
  })
};
const f6 = d6;
var h6 = {
  code: "en-US",
  formatDistance: k5,
  formatLong: F5,
  formatRelative: W5,
  localize: q5,
  match: f6,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const dw = h6;
var p6 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, g6 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, m6 = /^'([^]*?)'?$/, b6 = /''/g, v6 = /[a-zA-Z]/;
function no(e, t, n) {
  var r, o, s, i, a, l, c, u, d, f, h, p, g, m, v, y, x, C;
  He(2, arguments);
  var w = String(t), E = zo(), S = (r = (o = n == null ? void 0 : n.locale) !== null && o !== void 0 ? o : E.locale) !== null && r !== void 0 ? r : dw, O = jt((s = (i = (a = (l = n == null ? void 0 : n.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (c = n.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && a !== void 0 ? a : E.firstWeekContainsDate) !== null && i !== void 0 ? i : (d = E.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && s !== void 0 ? s : 1);
  if (!(O >= 1 && O <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var M = jt((h = (p = (g = (m = n == null ? void 0 : n.weekStartsOn) !== null && m !== void 0 ? m : n == null || (v = n.locale) === null || v === void 0 || (y = v.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && g !== void 0 ? g : E.weekStartsOn) !== null && p !== void 0 ? p : (x = E.locale) === null || x === void 0 || (C = x.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(M >= 0 && M <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!S.localize)
    throw new RangeError("locale must contain localize property");
  if (!S.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var T = ze(e);
  if (!zp(T))
    throw new RangeError("Invalid time value");
  var P = Dc(T), I = ow(T, P), R = {
    firstWeekContainsDate: O,
    weekStartsOn: M,
    locale: S,
    _originalDate: T
  }, D = w.match(g6).map(function(k) {
    var $ = k[0];
    if ($ === "p" || $ === "P") {
      var L = oh[$];
      return L(k, S.formatLong);
    }
    return k;
  }).join("").match(p6).map(function(k) {
    if (k === "''")
      return "'";
    var $ = k[0];
    if ($ === "'")
      return y6(k);
    var L = S5[$];
    if (L)
      return !(n != null && n.useAdditionalWeekYearTokens) && uw(k) && Nc(k, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && cw(k) && Nc(k, t, String(e)), L(I, k, S.localize, R);
    if ($.match(v6))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + $ + "`");
    return k;
  }).join("");
  return D;
}
function y6(e) {
  var t = e.match(m6);
  return t ? t[1].replace(b6, "'") : e;
}
function x6(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e;
}
function w6(e, t) {
  He(2, arguments);
  var n = ze(e), r = ze(t);
  return n.getTime() > r.getTime();
}
function C6(e, t) {
  He(2, arguments);
  var n = ze(e), r = ze(t);
  return n.getTime() < r.getTime();
}
function t0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function E6(e, t) {
  if (e) {
    if (typeof e == "string")
      return t0(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return t0(e, t);
  }
}
function n0(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = E6(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var r = 0, o = function() {
      };
      return {
        s: o,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: o
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var s = !0, i = !1, a;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var c = n.next();
      return s = c.done, c;
    },
    e: function(c) {
      i = !0, a = c;
    },
    f: function() {
      try {
        !s && n.return != null && n.return();
      } finally {
        if (i)
          throw a;
      }
    }
  };
}
function Fe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function sh(e, t) {
  return sh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, sh(e, t);
}
function pt(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && sh(e, t);
}
function Ac(e) {
  return Ac = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ac(e);
}
function _6() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function S6(e, t) {
  if (t && (oo(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Fe(e);
}
function gt(e) {
  var t = _6();
  return function() {
    var r = Ac(e), o;
    if (t) {
      var s = Ac(this).constructor;
      o = Reflect.construct(r, arguments, s);
    } else
      o = r.apply(this, arguments);
    return S6(this, o);
  };
}
function ut(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function O6(e, t) {
  if (oo(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (oo(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function fw(e) {
  var t = O6(e, "string");
  return oo(t) === "symbol" ? t : String(t);
}
function r0(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, fw(r.key), r);
  }
}
function dt(e, t, n) {
  return t && r0(e.prototype, t), n && r0(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ke(e, t, n) {
  return t = fw(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var M6 = 10, hw = /* @__PURE__ */ function() {
  function e() {
    ut(this, e), ke(this, "priority", void 0), ke(this, "subPriority", 0);
  }
  return dt(e, [{
    key: "validate",
    value: function(n, r) {
      return !0;
    }
  }]), e;
}(), T6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n(r, o, s, i, a) {
    var l;
    return ut(this, n), l = t.call(this), l.value = r, l.validateValue = o, l.setValue = s, l.priority = i, a && (l.subPriority = a), l;
  }
  return dt(n, [{
    key: "validate",
    value: function(o, s) {
      return this.validateValue(o, this.value, s);
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return this.setValue(o, s, this.value, i);
    }
  }]), n;
}(hw), R6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", M6), ke(Fe(r), "subPriority", -1), r;
  }
  return dt(n, [{
    key: "set",
    value: function(o, s) {
      if (s.timestampIsSet)
        return o;
      var i = /* @__PURE__ */ new Date(0);
      return i.setFullYear(o.getUTCFullYear(), o.getUTCMonth(), o.getUTCDate()), i.setHours(o.getUTCHours(), o.getUTCMinutes(), o.getUTCSeconds(), o.getUTCMilliseconds()), i;
    }
  }]), n;
}(hw), bt = /* @__PURE__ */ function() {
  function e() {
    ut(this, e), ke(this, "incompatibleTokens", void 0), ke(this, "priority", void 0), ke(this, "subPriority", void 0);
  }
  return dt(e, [{
    key: "run",
    value: function(n, r, o, s) {
      var i = this.parse(n, r, o, s);
      return i ? {
        setter: new T6(i.value, this.validate, this.set, this.priority, this.subPriority),
        rest: i.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, r, o) {
      return !0;
    }
  }]), e;
}(), P6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 140), ke(Fe(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "G":
        case "GG":
        case "GGG":
          return i.era(o, {
            width: "abbreviated"
          }) || i.era(o, {
            width: "narrow"
          });
        case "GGGGG":
          return i.era(o, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return i.era(o, {
            width: "wide"
          }) || i.era(o, {
            width: "abbreviated"
          }) || i.era(o, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return s.era = i, o.setUTCFullYear(i, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(bt), cn = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Rr = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function un(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Zt(e, t) {
  var n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function Pr(e, t) {
  var n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, s = n[3] ? parseInt(n[3], 10) : 0, i = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * Wu + s * Vu + i * XN),
    rest: t.slice(n[0].length)
  };
}
function pw(e) {
  return Zt(cn.anyDigitsSigned, e);
}
function sn(e, t) {
  switch (e) {
    case 1:
      return Zt(cn.singleDigit, t);
    case 2:
      return Zt(cn.twoDigits, t);
    case 3:
      return Zt(cn.threeDigits, t);
    case 4:
      return Zt(cn.fourDigits, t);
    default:
      return Zt(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function $c(e, t) {
  switch (e) {
    case 1:
      return Zt(cn.singleDigitSigned, t);
    case 2:
      return Zt(cn.twoDigitsSigned, t);
    case 3:
      return Zt(cn.threeDigitsSigned, t);
    case 4:
      return Zt(cn.fourDigitsSigned, t);
    default:
      return Zt(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function jp(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function gw(e, t) {
  var n = t > 0, r = n ? t : 1 - t, o;
  if (r <= 50)
    o = e || 100;
  else {
    var s = r + 50, i = Math.floor(s / 100) * 100, a = e >= s % 100;
    o = e + i - (a ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function mw(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var I6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 130), ke(Fe(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      var a = function(c) {
        return {
          year: c,
          isTwoDigitYear: s === "yy"
        };
      };
      switch (s) {
        case "y":
          return un(sn(4, o), a);
        case "yo":
          return un(i.ordinalNumber(o, {
            unit: "year"
          }), a);
        default:
          return un(sn(s.length, o), a);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s.isTwoDigitYear || s.year > 0;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      var a = o.getUTCFullYear();
      if (i.isTwoDigitYear) {
        var l = gw(i.year, a);
        return o.setUTCFullYear(l, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
      }
      var c = !("era" in s) || s.era === 1 ? i.year : 1 - i.year;
      return o.setUTCFullYear(c, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(bt), k6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 130), ke(Fe(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      var a = function(c) {
        return {
          year: c,
          isTwoDigitYear: s === "YY"
        };
      };
      switch (s) {
        case "Y":
          return un(sn(4, o), a);
        case "Yo":
          return un(i.ordinalNumber(o, {
            unit: "year"
          }), a);
        default:
          return un(sn(s.length, o), a);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s.isTwoDigitYear || s.year > 0;
    }
  }, {
    key: "set",
    value: function(o, s, i, a) {
      var l = Yp(o, a);
      if (i.isTwoDigitYear) {
        var c = gw(i.year, l);
        return o.setUTCFullYear(c, 0, a.firstWeekContainsDate), o.setUTCHours(0, 0, 0, 0), ps(o, a);
      }
      var u = !("era" in s) || s.era === 1 ? i.year : 1 - i.year;
      return o.setUTCFullYear(u, 0, a.firstWeekContainsDate), o.setUTCHours(0, 0, 0, 0), ps(o, a);
    }
  }]), n;
}(bt), D6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 130), ke(Fe(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s) {
      return $c(s === "R" ? 4 : s.length, o);
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      var a = /* @__PURE__ */ new Date(0);
      return a.setUTCFullYear(i, 0, 4), a.setUTCHours(0, 0, 0, 0), ti(a);
    }
  }]), n;
}(bt), N6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 130), ke(Fe(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s) {
      return $c(s === "u" ? 4 : s.length, o);
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCFullYear(i, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(bt), A6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 120), ke(Fe(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "Q":
        case "QQ":
          return sn(s.length, o);
        case "Qo":
          return i.ordinalNumber(o, {
            unit: "quarter"
          });
        case "QQQ":
          return i.quarter(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return i.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return i.quarter(o, {
            width: "wide",
            context: "formatting"
          }) || i.quarter(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 1 && s <= 4;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCMonth((i - 1) * 3, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(bt), $6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 120), ke(Fe(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "q":
        case "qq":
          return sn(s.length, o);
        case "qo":
          return i.ordinalNumber(o, {
            unit: "quarter"
          });
        case "qqq":
          return i.quarter(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return i.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return i.quarter(o, {
            width: "wide",
            context: "standalone"
          }) || i.quarter(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 1 && s <= 4;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCMonth((i - 1) * 3, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(bt), F6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), ke(Fe(r), "priority", 110), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      var a = function(c) {
        return c - 1;
      };
      switch (s) {
        case "M":
          return un(Zt(cn.month, o), a);
        case "MM":
          return un(sn(2, o), a);
        case "Mo":
          return un(i.ordinalNumber(o, {
            unit: "month"
          }), a);
        case "MMM":
          return i.month(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(o, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return i.month(o, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return i.month(o, {
            width: "wide",
            context: "formatting"
          }) || i.month(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 11;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCMonth(i, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(bt), L6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 110), ke(Fe(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      var a = function(c) {
        return c - 1;
      };
      switch (s) {
        case "L":
          return un(Zt(cn.month, o), a);
        case "LL":
          return un(sn(2, o), a);
        case "Lo":
          return un(i.ordinalNumber(o, {
            unit: "month"
          }), a);
        case "LLL":
          return i.month(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(o, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return i.month(o, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return i.month(o, {
            width: "wide",
            context: "standalone"
          }) || i.month(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 11;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCMonth(i, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(bt);
function V6(e, t, n) {
  He(2, arguments);
  var r = ze(e), o = jt(t), s = aw(r, n) - o;
  return r.setUTCDate(r.getUTCDate() - s * 7), r;
}
var W6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 100), ke(Fe(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "w":
          return Zt(cn.week, o);
        case "wo":
          return i.ordinalNumber(o, {
            unit: "week"
          });
        default:
          return sn(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 1 && s <= 53;
    }
  }, {
    key: "set",
    value: function(o, s, i, a) {
      return ps(V6(o, i, a), a);
    }
  }]), n;
}(bt);
function H6(e, t) {
  He(2, arguments);
  var n = ze(e), r = jt(t), o = iw(n) - r;
  return n.setUTCDate(n.getUTCDate() - o * 7), n;
}
var B6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 100), ke(Fe(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "I":
          return Zt(cn.week, o);
        case "Io":
          return i.ordinalNumber(o, {
            unit: "week"
          });
        default:
          return sn(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 1 && s <= 53;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return ti(H6(o, i));
    }
  }]), n;
}(bt), z6 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Y6 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], j6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 90), ke(Fe(r), "subPriority", 1), ke(Fe(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "d":
          return Zt(cn.date, o);
        case "do":
          return i.ordinalNumber(o, {
            unit: "date"
          });
        default:
          return sn(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      var i = o.getUTCFullYear(), a = mw(i), l = o.getUTCMonth();
      return a ? s >= 1 && s <= Y6[l] : s >= 1 && s <= z6[l];
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCDate(i), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(bt), U6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 90), ke(Fe(r), "subpriority", 1), ke(Fe(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "D":
        case "DD":
          return Zt(cn.dayOfYear, o);
        case "Do":
          return i.ordinalNumber(o, {
            unit: "date"
          });
        default:
          return sn(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      var i = o.getUTCFullYear(), a = mw(i);
      return a ? s >= 1 && s <= 366 : s >= 1 && s <= 365;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCMonth(0, i), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(bt);
function Up(e, t, n) {
  var r, o, s, i, a, l, c, u;
  He(2, arguments);
  var d = zo(), f = jt((r = (o = (s = (i = n == null ? void 0 : n.weekStartsOn) !== null && i !== void 0 ? i : n == null || (a = n.locale) === null || a === void 0 || (l = a.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && s !== void 0 ? s : d.weekStartsOn) !== null && o !== void 0 ? o : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = ze(e), p = jt(t), g = h.getUTCDay(), m = p % 7, v = (m + 7) % 7, y = (v < f ? 7 : 0) + p - g;
  return h.setUTCDate(h.getUTCDate() + y), h;
}
var G6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 90), ke(Fe(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "E":
        case "EE":
        case "EEE":
          return i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return i.day(o, {
            width: "wide",
            context: "formatting"
          }) || i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 6;
    }
  }, {
    key: "set",
    value: function(o, s, i, a) {
      return o = Up(o, i, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(bt), K6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 90), ke(Fe(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i, a) {
      var l = function(u) {
        var d = Math.floor((u - 1) / 7) * 7;
        return (u + a.weekStartsOn + 6) % 7 + d;
      };
      switch (s) {
        case "e":
        case "ee":
          return un(sn(s.length, o), l);
        case "eo":
          return un(i.ordinalNumber(o, {
            unit: "day"
          }), l);
        case "eee":
          return i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return i.day(o, {
            width: "wide",
            context: "formatting"
          }) || i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 6;
    }
  }, {
    key: "set",
    value: function(o, s, i, a) {
      return o = Up(o, i, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(bt), q6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 90), ke(Fe(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i, a) {
      var l = function(u) {
        var d = Math.floor((u - 1) / 7) * 7;
        return (u + a.weekStartsOn + 6) % 7 + d;
      };
      switch (s) {
        case "c":
        case "cc":
          return un(sn(s.length, o), l);
        case "co":
          return un(i.ordinalNumber(o, {
            unit: "day"
          }), l);
        case "ccc":
          return i.day(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(o, {
            width: "short",
            context: "standalone"
          }) || i.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return i.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return i.day(o, {
            width: "short",
            context: "standalone"
          }) || i.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return i.day(o, {
            width: "wide",
            context: "standalone"
          }) || i.day(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(o, {
            width: "short",
            context: "standalone"
          }) || i.day(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 6;
    }
  }, {
    key: "set",
    value: function(o, s, i, a) {
      return o = Up(o, i, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(bt);
function X6(e, t) {
  He(2, arguments);
  var n = jt(t);
  n % 7 === 0 && (n = n - 7);
  var r = 1, o = ze(e), s = o.getUTCDay(), i = n % 7, a = (i + 7) % 7, l = (a < r ? 7 : 0) + n - s;
  return o.setUTCDate(o.getUTCDate() + l), o;
}
var Z6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 90), ke(Fe(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      var a = function(c) {
        return c === 0 ? 7 : c;
      };
      switch (s) {
        case "i":
        case "ii":
          return sn(s.length, o);
        case "io":
          return i.ordinalNumber(o, {
            unit: "day"
          });
        case "iii":
          return un(i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiiii":
          return un(i.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiiiii":
          return un(i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiii":
        default:
          return un(i.day(o, {
            width: "wide",
            context: "formatting"
          }) || i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 1 && s <= 7;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o = X6(o, i), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(bt), Q6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 80), ke(Fe(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "a":
        case "aa":
        case "aaa":
          return i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return i.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCHours(jp(i), 0, 0, 0), o;
    }
  }]), n;
}(bt), J6 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 80), ke(Fe(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "b":
        case "bb":
        case "bbb":
          return i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return i.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCHours(jp(i), 0, 0, 0), o;
    }
  }]), n;
}(bt), e3 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 80), ke(Fe(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "B":
        case "BB":
        case "BBB":
          return i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return i.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCHours(jp(i), 0, 0, 0), o;
    }
  }]), n;
}(bt), t3 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 70), ke(Fe(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "h":
          return Zt(cn.hour12h, o);
        case "ho":
          return i.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return sn(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 1 && s <= 12;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      var a = o.getUTCHours() >= 12;
      return a && i < 12 ? o.setUTCHours(i + 12, 0, 0, 0) : !a && i === 12 ? o.setUTCHours(0, 0, 0, 0) : o.setUTCHours(i, 0, 0, 0), o;
    }
  }]), n;
}(bt), n3 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 70), ke(Fe(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "H":
          return Zt(cn.hour23h, o);
        case "Ho":
          return i.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return sn(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 23;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCHours(i, 0, 0, 0), o;
    }
  }]), n;
}(bt), r3 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 70), ke(Fe(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "K":
          return Zt(cn.hour11h, o);
        case "Ko":
          return i.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return sn(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 11;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      var a = o.getUTCHours() >= 12;
      return a && i < 12 ? o.setUTCHours(i + 12, 0, 0, 0) : o.setUTCHours(i, 0, 0, 0), o;
    }
  }]), n;
}(bt), o3 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 70), ke(Fe(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "k":
          return Zt(cn.hour24h, o);
        case "ko":
          return i.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return sn(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 1 && s <= 24;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      var a = i <= 24 ? i % 24 : i;
      return o.setUTCHours(a, 0, 0, 0), o;
    }
  }]), n;
}(bt), s3 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 60), ke(Fe(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "m":
          return Zt(cn.minute, o);
        case "mo":
          return i.ordinalNumber(o, {
            unit: "minute"
          });
        default:
          return sn(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 59;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCMinutes(i, 0, 0), o;
    }
  }]), n;
}(bt), i3 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 50), ke(Fe(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "s":
          return Zt(cn.second, o);
        case "so":
          return i.ordinalNumber(o, {
            unit: "second"
          });
        default:
          return sn(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 59;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCSeconds(i, 0), o;
    }
  }]), n;
}(bt), a3 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 30), ke(Fe(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s) {
      var i = function(l) {
        return Math.floor(l * Math.pow(10, -s.length + 3));
      };
      return un(sn(s.length, o), i);
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCMilliseconds(i), o;
    }
  }]), n;
}(bt), l3 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 10), ke(Fe(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s) {
      switch (s) {
        case "X":
          return Pr(Rr.basicOptionalMinutes, o);
        case "XX":
          return Pr(Rr.basic, o);
        case "XXXX":
          return Pr(Rr.basicOptionalSeconds, o);
        case "XXXXX":
          return Pr(Rr.extendedOptionalSeconds, o);
        case "XXX":
        default:
          return Pr(Rr.extended, o);
      }
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return s.timestampIsSet ? o : new Date(o.getTime() - i);
    }
  }]), n;
}(bt), c3 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 10), ke(Fe(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o, s) {
      switch (s) {
        case "x":
          return Pr(Rr.basicOptionalMinutes, o);
        case "xx":
          return Pr(Rr.basic, o);
        case "xxxx":
          return Pr(Rr.basicOptionalSeconds, o);
        case "xxxxx":
          return Pr(Rr.extendedOptionalSeconds, o);
        case "xxx":
        default:
          return Pr(Rr.extended, o);
      }
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return s.timestampIsSet ? o : new Date(o.getTime() - i);
    }
  }]), n;
}(bt), u3 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 40), ke(Fe(r), "incompatibleTokens", "*"), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o) {
      return pw(o);
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return [new Date(i * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(bt), d3 = /* @__PURE__ */ function(e) {
  pt(n, e);
  var t = gt(n);
  function n() {
    var r;
    ut(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), ke(Fe(r), "priority", 20), ke(Fe(r), "incompatibleTokens", "*"), r;
  }
  return dt(n, [{
    key: "parse",
    value: function(o) {
      return pw(o);
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return [new Date(i), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(bt), f3 = {
  G: new P6(),
  y: new I6(),
  Y: new k6(),
  R: new D6(),
  u: new N6(),
  Q: new A6(),
  q: new $6(),
  M: new F6(),
  L: new L6(),
  w: new W6(),
  I: new B6(),
  d: new j6(),
  D: new U6(),
  E: new G6(),
  e: new K6(),
  c: new q6(),
  i: new Z6(),
  a: new Q6(),
  b: new J6(),
  B: new e3(),
  h: new t3(),
  H: new n3(),
  K: new r3(),
  k: new o3(),
  m: new s3(),
  s: new i3(),
  S: new a3(),
  X: new l3(),
  x: new c3(),
  t: new u3(),
  T: new d3()
}, h3 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, p3 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, g3 = /^'([^]*?)'?$/, m3 = /''/g, b3 = /\S/, v3 = /[a-zA-Z]/;
function Vs(e, t, n, r) {
  var o, s, i, a, l, c, u, d, f, h, p, g, m, v, y, x, C, w;
  He(3, arguments);
  var E = String(e), S = String(t), O = zo(), M = (o = (s = r == null ? void 0 : r.locale) !== null && s !== void 0 ? s : O.locale) !== null && o !== void 0 ? o : dw;
  if (!M.match)
    throw new RangeError("locale must contain match property");
  var T = jt((i = (a = (l = (c = r == null ? void 0 : r.firstWeekContainsDate) !== null && c !== void 0 ? c : r == null || (u = r.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && l !== void 0 ? l : O.firstWeekContainsDate) !== null && a !== void 0 ? a : (f = O.locale) === null || f === void 0 || (h = f.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(T >= 1 && T <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var P = jt((p = (g = (m = (v = r == null ? void 0 : r.weekStartsOn) !== null && v !== void 0 ? v : r == null || (y = r.locale) === null || y === void 0 || (x = y.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && m !== void 0 ? m : O.weekStartsOn) !== null && g !== void 0 ? g : (C = O.locale) === null || C === void 0 || (w = C.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && p !== void 0 ? p : 0);
  if (!(P >= 0 && P <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (S === "")
    return E === "" ? ze(n) : /* @__PURE__ */ new Date(NaN);
  var I = {
    firstWeekContainsDate: T,
    weekStartsOn: P,
    locale: M
  }, R = [new R6()], D = S.match(p3).map(function(B) {
    var X = B[0];
    if (X in oh) {
      var te = oh[X];
      return te(B, M.formatLong);
    }
    return B;
  }).join("").match(h3), k = [], $ = n0(D), L;
  try {
    var A = function() {
      var X = L.value;
      !(r != null && r.useAdditionalWeekYearTokens) && uw(X) && Nc(X, S, e), !(r != null && r.useAdditionalDayOfYearTokens) && cw(X) && Nc(X, S, e);
      var te = X[0], J = f3[te];
      if (J) {
        var G = J.incompatibleTokens;
        if (Array.isArray(G)) {
          var ne = k.find(function(re) {
            return G.includes(re.token) || re.token === te;
          });
          if (ne)
            throw new RangeError("The format string mustn't contain `".concat(ne.fullToken, "` and `").concat(X, "` at the same time"));
        } else if (J.incompatibleTokens === "*" && k.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(X, "` and any other token at the same time"));
        k.push({
          token: te,
          fullToken: X
        });
        var Q = J.run(E, X, M.match, I);
        if (!Q)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        R.push(Q.setter), E = Q.rest;
      } else {
        if (te.match(v3))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + te + "`");
        if (X === "''" ? X = "'" : te === "'" && (X = y3(X)), E.indexOf(X) === 0)
          E = E.slice(X.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for ($.s(); !(L = $.n()).done; ) {
      var F = A();
      if (oo(F) === "object")
        return F.v;
    }
  } catch (B) {
    $.e(B);
  } finally {
    $.f();
  }
  if (E.length > 0 && b3.test(E))
    return /* @__PURE__ */ new Date(NaN);
  var N = R.map(function(B) {
    return B.priority;
  }).sort(function(B, X) {
    return X - B;
  }).filter(function(B, X, te) {
    return te.indexOf(B) === X;
  }).map(function(B) {
    return R.filter(function(X) {
      return X.priority === B;
    }).sort(function(X, te) {
      return te.subPriority - X.subPriority;
    });
  }).map(function(B) {
    return B[0];
  }), V = ze(n);
  if (isNaN(V.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var K = ow(V, Dc(V)), Y = {}, U = n0(N), j;
  try {
    for (U.s(); !(j = U.n()).done; ) {
      var H = j.value;
      if (!H.validate(K, I))
        return /* @__PURE__ */ new Date(NaN);
      var q = H.set(K, Y, I);
      Array.isArray(q) ? (K = q[0], x6(Y, q[1])) : K = q;
    }
  } catch (B) {
    U.e(B);
  } finally {
    U.f();
  }
  return K;
}
function y3(e) {
  return e.match(g3)[1].replace(m3, "'");
}
function x3(e) {
  He(1, arguments);
  var t = ze(e);
  return t.setMinutes(0, 0, 0), t;
}
function w3(e) {
  He(1, arguments);
  var t = ze(e);
  return t.setMilliseconds(0), t;
}
function C3(e, t) {
  var n;
  He(1, arguments);
  var r = jt((n = t == null ? void 0 : t.additionalDigits) !== null && n !== void 0 ? n : 2);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var o = O3(e), s;
  if (o.date) {
    var i = M3(o.date, r);
    s = T3(i.restDateString, i.year);
  }
  if (!s || isNaN(s.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var a = s.getTime(), l = 0, c;
  if (o.time && (l = R3(o.time), isNaN(l)))
    return /* @__PURE__ */ new Date(NaN);
  if (o.timezone) {
    if (c = P3(o.timezone), isNaN(c))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var u = new Date(a + l), d = /* @__PURE__ */ new Date(0);
    return d.setFullYear(u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()), d.setHours(u.getUTCHours(), u.getUTCMinutes(), u.getUTCSeconds(), u.getUTCMilliseconds()), d;
  }
  return new Date(a + l + c);
}
var Pl = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, E3 = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, _3 = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, S3 = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function O3(e) {
  var t = {}, n = e.split(Pl.dateTimeDelimiter), r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], Pl.timeZoneDelimiter.test(t.date) && (t.date = e.split(Pl.timeZoneDelimiter)[0], r = e.substr(t.date.length, e.length))), r) {
    var o = Pl.timezone.exec(r);
    o ? (t.time = r.replace(o[1], ""), t.timezone = o[1]) : t.time = r;
  }
  return t;
}
function M3(e, t) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), r = e.match(n);
  if (!r)
    return {
      year: NaN,
      restDateString: ""
    };
  var o = r[1] ? parseInt(r[1]) : null, s = r[2] ? parseInt(r[2]) : null;
  return {
    year: s === null ? o : s * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function T3(e, t) {
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = e.match(E3);
  if (!n)
    return /* @__PURE__ */ new Date(NaN);
  var r = !!n[4], o = Ii(n[1]), s = Ii(n[2]) - 1, i = Ii(n[3]), a = Ii(n[4]), l = Ii(n[5]) - 1;
  if (r)
    return A3(t, a, l) ? I3(t, a, l) : /* @__PURE__ */ new Date(NaN);
  var c = /* @__PURE__ */ new Date(0);
  return !D3(t, s, i) || !N3(t, o) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(t, s, Math.max(o, i)), c);
}
function Ii(e) {
  return e ? parseInt(e) : 1;
}
function R3(e) {
  var t = e.match(_3);
  if (!t)
    return NaN;
  var n = Ud(t[1]), r = Ud(t[2]), o = Ud(t[3]);
  return $3(n, r, o) ? n * Wu + r * Vu + o * 1e3 : NaN;
}
function Ud(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function P3(e) {
  if (e === "Z")
    return 0;
  var t = e.match(S3);
  if (!t)
    return 0;
  var n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), o = t[3] && parseInt(t[3]) || 0;
  return F3(r, o) ? n * (r * Wu + o * Vu) : NaN;
}
function I3(e, t, n) {
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  var o = r.getUTCDay() || 7, s = (t - 1) * 7 + n + 1 - o;
  return r.setUTCDate(r.getUTCDate() + s), r;
}
var k3 = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function bw(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function D3(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (k3[t] || (bw(e) ? 29 : 28));
}
function N3(e, t) {
  return t >= 1 && t <= (bw(e) ? 366 : 365);
}
function A3(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function $3(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function F3(e, t) {
  return t >= 0 && t <= 59;
}
/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */
const L3 = {
  datetime: "MMM d, yyyy, h:mm:ss aaaa",
  millisecond: "h:mm:ss.SSS aaaa",
  second: "h:mm:ss aaaa",
  minute: "h:mm aaaa",
  hour: "ha",
  day: "MMM d",
  week: "PP",
  month: "MMM yyyy",
  quarter: "qqq - yyyy",
  year: "yyyy"
};
Lx._date.override({
  _id: "date-fns",
  // DEBUG
  formats: function() {
    return L3;
  },
  parse: function(e, t) {
    if (e === null || typeof e > "u")
      return null;
    const n = typeof e;
    return n === "number" || e instanceof Date ? e = ze(e) : n === "string" && (typeof t == "string" ? e = Vs(e, t, /* @__PURE__ */ new Date(), this.options) : e = C3(e, this.options)), zp(e) ? e.getTime() : null;
  },
  format: function(e, t) {
    return no(e, t, this.options);
  },
  add: function(e, t, n) {
    switch (n) {
      case "millisecond":
        return Ba(e, t);
      case "second":
        return GN(e, t);
      case "minute":
        return jN(e, t);
      case "hour":
        return HN(e, t);
      case "day":
        return Jx(e, t);
      case "week":
        return KN(e, t);
      case "month":
        return Bp(e, t);
      case "quarter":
        return UN(e, t);
      case "year":
        return qN(e, t);
      default:
        return e;
    }
  },
  diff: function(e, t, n) {
    switch (n) {
      case "millisecond":
        return Hu(e, t);
      case "second":
        return s5(e, t);
      case "minute":
        return n5(e, t);
      case "hour":
        return t5(e, t);
      case "day":
        return ew(e, t);
      case "week":
        return i5(e, t);
      case "month":
        return rw(e, t);
      case "quarter":
        return o5(e, t);
      case "year":
        return a5(e, t);
      default:
        return 0;
    }
  },
  startOf: function(e, t, n) {
    switch (t) {
      case "second":
        return w3(e);
      case "minute":
        return l5(e);
      case "hour":
        return x3(e);
      case "day":
        return nh(e);
      case "week":
        return qv(e);
      case "isoWeek":
        return qv(e, { weekStartsOn: +n });
      case "month":
        return ec(e);
      case "quarter":
        return c5(e);
      case "year":
        return d5(e);
      default:
        return e;
    }
  },
  endOf: function(e, t) {
    switch (t) {
      case "second":
        return m5(e);
      case "minute":
        return p5(e);
      case "hour":
        return f5(e);
      case "day":
        return tw(e);
      case "week":
        return h5(e);
      case "month":
        return nw(e);
      case "quarter":
        return g5(e);
      case "year":
        return u5(e);
      default:
        return e;
    }
  }
});
function Xr(e, t) {
  const { format: n = "rgba" } = t || {}, r = `rgba(${getComputedStyle(
    document.documentElement
  ).getPropertyValue(e)})`;
  return n === "hex" ? V3(r) : r;
}
const V3 = (e) => {
  const t = e.replace(/^rgba?\(|\s+|\)$/g, "").split(","), n = parseInt(t[0], 10), r = parseInt(t[1], 10), o = parseInt(t[2], 10), s = Math.round(parseFloat(t[3]) * 255), i = (a) => a.toString(16).padStart(2, "0");
  return `#${i(n)}${i(r)}${i(o)}${Number.isNaN(s) ? "" : i(s)}`;
}, vw = () => /* @__PURE__ */ ee("div", { className: "relative flex h-52 w-full flex-1 flex-col justify-between", children: [
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-foundations-subtlest" }),
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-foundations-subtlest" }),
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-foundations-subtlest" }),
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-foundations-subtlest" }),
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-foundations-subtlest" }),
  /* @__PURE__ */ ee("div", { className: "absolute inset-0 flex flex-col items-center justify-center space-y-2.5", children: [
    /* @__PURE__ */ _(yw, {}),
    /* @__PURE__ */ _("p", { className: "text-xs font-medium text-foundations-boldest", children: "No data in this period" })
  ] })
] }), yw = ({ className: e }) => /* @__PURE__ */ ee(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "84",
    viewBox: "0 0 112 84",
    fill: "none",
    className: e,
    children: [
      /* @__PURE__ */ _(
        "path",
        {
          d: "M56.7368 84C79.9328 84 98.7368 65.196 98.7368 42C98.7368 18.804 79.9328 0 56.7368 0C33.5409 0 14.7368 18.804 14.7368 42C14.7368 65.196 33.5409 84 56.7368 84Z",
          className: "fill-[theme(backgroundColor.foundations-subtlest)]"
        }
      ),
      /* @__PURE__ */ _("g", { filter: "url(#filter0_d_18659_25530)", children: /* @__PURE__ */ _(
        "path",
        {
          d: "M8.19249 29.5547H103.392C104.328 29.5547 105.224 29.9262 105.886 30.5874C106.547 31.2486 106.918 32.1455 106.918 33.0806V50.7102C106.918 51.6454 106.547 52.5422 105.886 53.2034C105.224 53.8647 104.328 54.2362 103.392 54.2362H8.19249C7.25736 54.2362 6.36052 53.8647 5.69928 53.2034C5.03805 52.5422 4.66656 51.6454 4.66656 50.7102V33.0806C4.66656 32.1455 5.03805 31.2486 5.69928 30.5874C6.36052 29.9262 7.25736 29.5547 8.19249 29.5547V29.5547Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ) }),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M53.324 35.1953H34.9892C33.8208 35.1953 32.8736 36.1425 32.8736 37.3109C32.8736 38.4793 33.8208 39.4264 34.9892 39.4264H53.324C54.4924 39.4264 55.4395 38.4793 55.4395 37.3109C55.4395 36.1425 54.4924 35.1953 53.324 35.1953Z",
          className: "fill-[theme(backgroundColor.chart-categorical-8-subtler)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M66.0171 44.3633H34.989C33.8206 44.3633 32.8734 45.3104 32.8734 46.4788C32.8734 47.6472 33.8206 48.5944 34.989 48.5944H66.0171C67.1855 48.5944 68.1327 47.6472 68.1327 46.4788C68.1327 45.3104 67.1855 44.3633 66.0171 44.3633Z",
          className: "fill-[theme(backgroundColor.chart-categorical-8-subtler)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M27.2341 41.8951C27.2341 36.2479 22.6562 31.6699 17.0089 31.6699C11.3617 31.6699 6.78375 36.2479 6.78375 41.8951C6.78375 47.5423 11.3617 52.1203 17.0089 52.1203C22.6562 52.1203 27.2341 47.5423 27.2341 41.8951Z",
          className: "fill-[theme(backgroundColor.chart-neutral)]"
        }
      ),
      /* @__PURE__ */ ee("g", { clipPath: "url(#clip0_18659_25530)", children: [
        /* @__PURE__ */ _(
          "path",
          {
            d: "M12.1339 42.6223C12.1339 42.2787 12.4124 42.0001 12.7561 42.0001H14.0005C14.3442 42.0001 14.6227 42.2787 14.6227 42.6223V45.7334C14.6227 46.0771 14.3442 46.3556 14.0005 46.3556H12.7561C12.4124 46.3556 12.1339 46.0771 12.1339 45.7334V42.6223Z",
            className: "fill-[theme(backgroundColor.foundations-default)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            d: "M15.8672 40.1334C15.8672 39.7898 16.1458 39.5112 16.4894 39.5112H17.7338C18.0775 39.5112 18.3561 39.7898 18.3561 40.1334V45.7334C18.3561 46.0771 18.0775 46.3556 17.7338 46.3556H16.4894C16.1458 46.3556 15.8672 46.0771 15.8672 45.7334V40.1334Z",
            className: "fill-[theme(backgroundColor.foundations-default)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            d: "M19.6005 38.2668C19.6005 37.9231 19.8791 37.6445 20.2227 37.6445H21.4672C21.8108 37.6445 22.0894 37.9231 22.0894 38.2668V45.7334C22.0894 46.0771 21.8108 46.3556 21.4672 46.3556H20.2227C19.8791 46.3556 19.6005 46.0771 19.6005 45.7334V38.2668Z",
            className: "fill-[theme(backgroundColor.foundations-default)]"
          }
        )
      ] }),
      /* @__PURE__ */ ee("defs", { children: [
        /* @__PURE__ */ ee(
          "filter",
          {
            id: "filter0_d_18659_25530",
            x: "0.435454",
            y: "27.4391",
            width: "110.714",
            height: "33.1439",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ _(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ _("feOffset", { dy: "2.11556" }),
              /* @__PURE__ */ _("feGaussianBlur", { stdDeviation: "2.11556" }),
              /* @__PURE__ */ _(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
                }
              ),
              /* @__PURE__ */ _(
                "feBlend",
                {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_18659_25530"
                }
              ),
              /* @__PURE__ */ _(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow_18659_25530",
                  result: "shape"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ _("clipPath", { id: "clip0_18659_25530", children: /* @__PURE__ */ _(
          "rect",
          {
            width: "12.4444",
            height: "12.4444",
            className: "fill-[theme(backgroundColor.foundations-default)]",
            transform: "translate(10.8894 35.7773)"
          }
        ) })
      ] })
    ]
  }
), xw = b.createContext(null);
function Ya() {
  const e = b.useContext(xw);
  if (!e)
    throw new Error(
      "Chart compound components must be used within a <Chart> component"
    );
  return e;
}
const W3 = ({
  children: e,
  type: t,
  labels: n,
  datasets: r
}) => {
  const [o, s] = b.useState(null), i = b.useRef(null), a = n.length > 50, l = b.useMemo(
    () => ({
      chart: o,
      setChart: s,
      type: t,
      labels: n,
      datasets: r,
      tooltipRef: i,
      isLargeDataSet: a
    }),
    [o, t, n, r, a]
  );
  return /* @__PURE__ */ _(xw.Provider, { value: l, children: e });
}, ww = "label";
function o0(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function H3(e, t) {
  const n = e.options;
  n && t && Object.assign(n, t);
}
function Cw(e, t) {
  e.labels = t;
}
function Ew(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ww;
  const r = [];
  e.datasets = t.map((o) => {
    const s = e.datasets.find((i) => i[n] === o[n]);
    return !s || !o.data || r.includes(s) ? {
      ...o
    } : (r.push(s), Object.assign(s, o), s);
  });
}
function B3(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ww;
  const n = {
    labels: [],
    datasets: []
  };
  return Cw(n, e.labels), Ew(n, e.datasets, t), n;
}
function z3(e, t) {
  const { height: n = 150, width: r = 300, redraw: o = !1, datasetIdKey: s, type: i, data: a, options: l, plugins: c = [], fallbackContent: u, updateMode: d, ...f } = e, h = et(null), p = et(), g = () => {
    h.current && (p.current = new Fu(h.current, {
      type: i,
      data: B3(a, s),
      options: l && {
        ...l
      },
      plugins: c
    }), o0(t, p.current));
  }, m = () => {
    o0(t, null), p.current && (p.current.destroy(), p.current = null);
  };
  return st(() => {
    !o && p.current && l && H3(p.current, l);
  }, [
    o,
    l
  ]), st(() => {
    !o && p.current && Cw(p.current.config.data, a.labels);
  }, [
    o,
    a.labels
  ]), st(() => {
    !o && p.current && a.datasets && Ew(p.current.config.data, a.datasets, s);
  }, [
    o,
    a.datasets
  ]), st(() => {
    p.current && (o ? (m(), setTimeout(g)) : p.current.update(d));
  }, [
    o,
    l,
    a.labels,
    a.datasets,
    d
  ]), st(() => {
    p.current && (m(), setTimeout(g));
  }, [
    i
  ]), st(() => (g(), () => m()), []), /* @__PURE__ */ Oe.createElement("canvas", Object.assign({
    ref: h,
    role: "img",
    height: n,
    width: r
  }, f), u);
}
const Y3 = /* @__PURE__ */ pn(z3), j3 = (e) => {
  let t = null;
  return {
    id: "hover-label",
    afterEvent(r, { inChartArea: o, event: s }) {
      var a, l;
      if (!o) {
        t = null;
        return;
      }
      const [i] = r.getElementsAtEventForMode(
        //@ts-expect-error
        s,
        "nearest",
        { intersect: !1, axis: (l = (a = r.config.options) == null ? void 0 : a.interaction) == null ? void 0 : l.axis },
        !0
      );
      t = (i == null ? void 0 : i.index) ?? null;
    },
    afterDatasetDraw(r) {
      var x;
      const o = r.config.type;
      if (o === "doughnut" || o === "pie")
        return;
      const {
        ctx: s,
        chartArea: { top: i, bottom: a },
        scales: { x: l }
      } = r;
      if (s.save(), t == null)
        return;
      const c = (x = r.data.labels) == null ? void 0 : x[t], d = r.getDatasetMeta(0).data[t], f = d ? d.x : l.getPixelForValue(new Date(c).getTime()), h = 1;
      s.beginPath(), s.setLineDash([3, 3]), s.strokeStyle = Xr("--border-foundations-bolder"), s.lineWidth = h;
      const p = f - h / 2;
      s.moveTo(p, i), s.lineTo(p, a), s.stroke();
      const g = 8, m = new Date(c).getTime(), v = no(m, e), y = s.measureText(`${v}`).width + g;
      s.fillStyle = Xr(
        "--background-foundations-subtlest"
      ), s.roundRect(f - y / 2, a + 12, y, 20, 4), s.fill(), s.font = "500 12px 'DM Sans', Arial", s.fillStyle = Xr("--text-foundations-boldest"), s.fillText(
        v,
        f - y / 2 + g / 2,
        a + 12 + 20 / 2 + 5
      ), s.restore();
    }
  };
}, U3 = {
  id: "fully-rendered",
  afterRender: function(e) {
    e.$rendered || (e.$rendered = !0);
  }
}, G3 = (e, t) => ({
  id: "center-text",
  afterDatasetDraw(n) {
    const { ctx: r, chartArea: o } = n, s = (o.left + o.right) / 2, i = (o.top + o.bottom) / 2;
    r.save(), r.textAlign = "center", r.textBaseline = "middle", r.font = `${(t == null ? void 0 : t.fontWeight) || "700"} ${(t == null ? void 0 : t.fontSize) || "32px"} 'DM Sans', Arial`, r.fillStyle = (t == null ? void 0 : t.color) || Xr("--text-foundations-boldest"), r.fillText(e, s, i), r.restore();
  }
}), _w = ({
  horizontal: e = !1,
  extraScales: t,
  scaleXWeekFormat: n = !1,
  disableAnimation: r = !1,
  maxYValue: o,
  formatXLabel: s,
  formatYLabel: i,
  crossHairTooltipFormat: a = "MMM d, yyy",
  className: l,
  centerText: c
} = {}) => {
  const { setChart: u, type: d, labels: f, datasets: h, tooltipRef: p } = Ya();
  return /* @__PURE__ */ _("div", { className: de("h-full", l), children: /* @__PURE__ */ _(
    Y3,
    {
      ref: u,
      width: "100%",
      type: d,
      data: {
        labels: f,
        datasets: h
      },
      options: {
        layout: d === "doughnut" || d === "pie" ? {
          padding: 0
        } : {
          padding: {
            right: 40
          }
        },
        animation: r ? !1 : d === "doughnut" || d === "pie" ? {
          animateRotate: !0,
          animateScale: !1
        } : !0,
        transitions: {
          active: {
            animation: {
              duration: 0
            }
          }
        },
        responsive: !0,
        maintainAspectRatio: !1,
        indexAxis: e ? "y" : "x",
        interaction: d === "doughnut" || d === "pie" ? {
          intersect: !0,
          mode: "point"
        } : {
          intersect: !1,
          axis: "x",
          mode: "nearest"
        },
        elements: {
          point: {
            radius: f.length === 1 ? 4 : 0,
            hitRadius: 4,
            pointStyle: "circle"
          },
          line: {
            borderWidth: 2,
            tension: 0.02
          }
        },
        cutout: "70%",
        plugins: {
          tooltip: d === "doughnut" || d === "pie" ? {
            mode: "point",
            intersect: !0,
            enabled: !1,
            external: (g) => {
              var x, C;
              if (!g.chart.$rendered)
                return;
              const m = g.tooltip;
              if (m.opacity === 0) {
                (x = p.current) == null || x.updateTooltip({
                  opacity: 0,
                  top: void 0,
                  left: void 0,
                  xAlign: void 0
                });
                return;
              }
              const v = g.chart.canvas.getBoundingClientRect(), y = {
                opacity: 1,
                left: v.left + m.caretX + window.scrollX,
                top: v.top + m.caretY + window.scrollY,
                xAlign: m.xAlign,
                dataPoints: m.dataPoints.map(
                  (w) => {
                    var E;
                    return {
                      label: w.label,
                      dataset: w.dataset,
                      raw: w.raw,
                      rawLabel: (E = w.chart.data.labels) == null ? void 0 : E[w.dataIndex],
                      dataIndex: w.dataIndex
                    };
                  }
                )
              };
              (C = p.current) == null || C.updateTooltip(y);
            }
          } : {
            mode: "nearest",
            intersect: !1,
            enabled: !1,
            external: (g) => {
              var x, C;
              if (!g.chart.$rendered)
                return;
              const m = g.tooltip;
              if (m.opacity === 0) {
                (x = p.current) == null || x.updateTooltip({
                  opacity: 0,
                  top: void 0,
                  left: void 0,
                  xAlign: void 0
                });
                return;
              }
              const v = g.chart.canvas.getBoundingClientRect(), y = {
                opacity: 1,
                left: v.left + m.caretX + window.scrollX,
                top: v.top + m.caretY + window.scrollY,
                xAlign: m.xAlign,
                dataPoints: m.dataPoints.map(
                  (w) => {
                    var E;
                    return {
                      label: w.label,
                      dataset: w.dataset,
                      raw: w.raw,
                      rawLabel: (E = w.chart.data.labels) == null ? void 0 : E[w.dataIndex],
                      dataIndex: w.dataIndex
                    };
                  }
                )
              };
              (C = p.current) == null || C.updateTooltip(y);
            }
          }
        },
        ...d !== "doughnut" && d !== "pie" ? {
          scales: {
            y: {
              beginAtZero: !0,
              grace: "5%",
              grid: {
                display: !1
              },
              ticks: {
                padding: 8,
                color: Xr(
                  "--text-foundations-bold"
                ),
                count: 2,
                callback: i
              },
              border: {
                display: !1
              },
              max: o
            },
            x: {
              offset: !0,
              type: "time",
              time: {
                unit: "day",
                displayFormats: {
                  day: n ? "E" : "MMM d"
                },
                tooltipFormat: "MMM d, yyy"
              },
              grid: {
                color: "transparent",
                tickColor: Xr(
                  "--border-foundations-bold"
                ),
                offset: !1
              },
              ticks: {
                padding: 8,
                color: Xr(
                  "--text-foundations-bold"
                ),
                align: "center",
                autoSkip: !1,
                maxRotation: 0,
                minRotation: 0,
                source: "labels",
                callback(g, m) {
                  return m === 0 || m === f.length - 1 ? s ? s(g, m) : no(g, "MMM d, yyy") : void 0;
                }
              },
              border: {
                color: Xr(
                  "--border-foundations-bold"
                )
              }
            },
            ...t
          }
        } : {}
      },
      plugins: [
        b.useMemo(
          () => j3(a || "MMM d, yyy"),
          [a]
        ),
        U3,
        ...c && (d === "doughnut" || d === "pie") ? [
          b.useMemo(
            () => G3(c.text, {
              fontSize: c.fontSize,
              fontWeight: c.fontWeight,
              color: c.color
            }),
            [
              c.text,
              c.fontSize,
              c.fontWeight,
              c.color
            ]
          )
        ] : []
      ]
    }
  ) });
};
_w.displayName = "Chart.Canvas";
function Sw() {
  const [e, t] = b.useReducer((n) => !n, !1);
  return t;
}
function xa(e) {
  const t = b.useRef(e);
  return b.useEffect(() => {
    t.current = e;
  }), b.useMemo(
    () => (...n) => {
      var r;
      return (r = t.current) == null ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function Ow({
  chart: e,
  total: t,
  startHiddenFromIndex: n,
  hideItem: r
}) {
  const o = xa(r), [s, i] = b.useState(
    () => new Set(
      n !== void 0 ? Array.from(
        { length: t - n },
        (l, c) => c + n
      ) : []
    )
  ), a = b.useRef(!1);
  return b.useEffect(() => {
    !e || a.current || (a.current = !0, s.size !== 0 && (s.forEach(o), e.update()));
  }, [e, s, o]), [s, i];
}
const K3 = ({
  variant: e = "row",
  className: t,
  labelFormatter: n,
  descriptionFormatter: r,
  initialVisibleDatasets: o
}) => {
  const { chart: s, datasets: i } = Ya(), [a, l] = b.useState(null), [c, u] = Ow({
    chart: s,
    total: i.length,
    startHiddenFromIndex: o,
    hideItem: (h) => s == null ? void 0 : s.setDatasetVisibility(h, !1)
  }), d = Sw();
  if (!s)
    return null;
  const f = b.useCallback(
    (h) => {
      c.has(h) ? (u((g) => {
        const m = new Set(g);
        return m.delete(h), m;
      }), s.setDatasetVisibility(h, !0)) : (u((g) => new Set(g).add(h)), s.setDatasetVisibility(h, !1)), s.update(), d();
    },
    [s, c, d, u]
  );
  return /* @__PURE__ */ _(
    "div",
    {
      className: de(
        "flex flex-wrap justify-center gap-2",
        e === "column" && "flex-col items-start",
        t
      ),
      children: i.map((h, p) => {
        var g;
        return /* @__PURE__ */ _(
          "button",
          {
            className: de(
              "flex items-center space-x-1 p-1 transition-opacity duration-300",
              a !== null && a !== p && "opacity-20",
              c.has(p) && "line-through opacity-50"
            ),
            onClick: () => f(p),
            onMouseEnter: () => {
              c.has(p) || (l(p), s.config.data.datasets.forEach((m, v) => {
                var y, x, C, w;
                if (!c.has(v)) {
                  if (p === v) {
                    s.config.data.datasets[p].backgroundColor = m.backgroundColor, s.config.data.datasets[p].borderColor = m.borderColor;
                    return;
                  }
                  m.backgroundColor = (x = (y = m.backgroundColor) == null ? void 0 : y.replace) == null ? void 0 : x.call(y, ")", ", 0.3)"), m.borderColor = (w = (C = m.borderColor) == null ? void 0 : C.replace) == null ? void 0 : w.call(
                    C,
                    ")",
                    ", 0.3)"
                  );
                }
              }), s.update(), d());
            },
            onMouseLeave: () => {
              l(null), s.config.data.datasets.forEach((m, v) => {
                c.has(v) || (m.backgroundColor = m.backgroundColor = i[v].backgroundColor, m.borderColor = m.borderColor = i[v].borderColor);
              }), s.update(), d();
            },
            children: /* @__PURE__ */ ee("div", { className: "flex flex-1 flex-col items-start gap-0.5", children: [
              /* @__PURE__ */ ee("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ _(
                  "div",
                  {
                    className: de(
                      "h-2 w-2 shrink-0 rounded-full bg-foundations-subtle transition-opacity duration-300",
                      c.has(p) && "opacity-30"
                    ),
                    style: {
                      backgroundColor: ((g = h.backgroundColor) == null ? void 0 : g.toString()) || void 0
                    }
                  }
                ),
                /* @__PURE__ */ _("span", { className: "text-xs font-medium text-foundations-bolder", children: n ? n(h.label || "", p) : h.label })
              ] }),
              r && /* @__PURE__ */ _("span", { className: "text-xs font-medium text-foundations-bold", children: r(h.label || "", p) })
            ] })
          },
          h.label
        );
      })
    }
  );
}, q3 = ({
  variant: e = "row",
  className: t,
  labelFormatter: n,
  descriptionFormatter: r,
  initialVisibleDatasets: o
}) => {
  const { chart: s, labels: i, datasets: a } = Ya(), [l, c] = b.useState(null), [u, d] = Ow({
    chart: s,
    total: i.length,
    startHiddenFromIndex: o,
    hideItem: (g) => s == null ? void 0 : s.toggleDataVisibility(g)
  }), f = Sw();
  if (!s)
    return null;
  const h = b.useCallback(
    (g) => {
      u.has(g) ? (d((v) => {
        const y = new Set(v);
        return y.delete(g), y;
      }), s.toggleDataVisibility(g)) : (d((v) => new Set(v).add(g)), s.toggleDataVisibility(g)), s.update(), f();
    },
    [s, u, f, d]
  ), p = (g) => {
    const v = a[0].backgroundColor;
    return Array.isArray(v) ? v[g] : v;
  };
  return /* @__PURE__ */ _(
    "div",
    {
      className: de(
        "flex flex-wrap justify-center gap-2 pt-4",
        e === "column" && "flex-col items-start",
        t
      ),
      children: i.map((g, m) => {
        const v = u.has(m), y = p(m);
        return /* @__PURE__ */ _(
          "button",
          {
            className: de(
              "flex p-1 transition-opacity duration-300",
              l !== null && l !== m && "opacity-20",
              v && "line-through opacity-50"
            ),
            onClick: () => h(m),
            onMouseEnter: () => {
              if (v)
                return;
              c(m);
              const x = s.config.data.datasets[0], C = x.backgroundColor, w = x.borderColor;
              Array.isArray(C) && (x.backgroundColor = C.map(
                (E, S) => S === m || u.has(S) ? E : E.replace(")", ", 0.3)")
              )), Array.isArray(w) && (x.borderColor = w.map(
                (E, S) => S === m || u.has(S) ? E : E.replace(")", ", 0.3)")
              )), s.update(), f();
            },
            onMouseLeave: () => {
              c(null);
              const x = s.config.data.datasets[0];
              x.backgroundColor = a[0].backgroundColor, x.borderColor = a[0].borderColor, s.update(), f();
            },
            children: /* @__PURE__ */ ee("div", { className: "flex flex-1 flex-col items-start gap-0.5", children: [
              /* @__PURE__ */ ee("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ _(
                  "div",
                  {
                    className: de(
                      "h-2 w-2 shrink-0 rounded-full transition-opacity duration-300",
                      v && "opacity-30"
                    ),
                    style: {
                      backgroundColor: (y == null ? void 0 : y.toString()) || void 0
                    }
                  }
                ),
                /* @__PURE__ */ _("span", { className: "text-xs font-medium text-foundations-bolder", children: n ? n(g, m) : g })
              ] }),
              r && /* @__PURE__ */ _("span", { className: "text-xs font-medium text-foundations-bold", children: r(g, m) })
            ] })
          },
          `${g}-${m}`
        );
      })
    }
  );
}, Mw = ({
  variant: e = "row",
  className: t,
  labelFormatter: n,
  descriptionFormatter: r,
  initialVisibleDatasets: o,
  showSingleDataset: s = !1
} = {}) => {
  const { type: i, chart: a, datasets: l } = Ya();
  return a ? i === "doughnut" || i === "pie" ? /* @__PURE__ */ _(
    q3,
    {
      variant: e,
      className: t,
      labelFormatter: n,
      descriptionFormatter: r,
      initialVisibleDatasets: o
    }
  ) : l.length <= 1 && !s ? null : /* @__PURE__ */ _(
    K3,
    {
      variant: e,
      className: t,
      labelFormatter: n,
      descriptionFormatter: r,
      initialVisibleDatasets: o
    }
  ) : null;
};
Mw.displayName = "Chart.Legend";
function an() {
  return an = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, an.apply(this, arguments);
}
function X3(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Tw(...e) {
  return (t) => e.forEach(
    (n) => X3(n, t)
  );
}
function Cs(...e) {
  return ot(Tw(...e), e);
}
const Bu = /* @__PURE__ */ pn((e, t) => {
  const { children: n, ...r } = e, o = Hs.toArray(n), s = o.find(Q3);
  if (s) {
    const i = s.props.children, a = o.map((l) => l === s ? Hs.count(i) > 1 ? Hs.only(null) : /* @__PURE__ */ ic(i) ? i.props.children : null : l);
    return /* @__PURE__ */ it(ih, an({}, r, {
      ref: t
    }), /* @__PURE__ */ ic(i) ? /* @__PURE__ */ Zc(i, void 0, a) : null);
  }
  return /* @__PURE__ */ it(ih, an({}, r, {
    ref: t
  }), n);
});
Bu.displayName = "Slot";
const ih = /* @__PURE__ */ pn((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ ic(n) ? /* @__PURE__ */ Zc(n, {
    ...J3(r, n.props),
    ref: t ? Tw(t, n.ref) : n.ref
  }) : Hs.count(n) > 1 ? Hs.only(null) : null;
});
ih.displayName = "SlotClone";
const Z3 = ({ children: e }) => /* @__PURE__ */ it(zO, null, e);
function Q3(e) {
  return /* @__PURE__ */ ic(e) && e.type === Z3;
}
function J3(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      s(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...s
    } : r === "className" && (n[r] = [
      o,
      s
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const eA = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Yo = eA.reduce((e, t) => {
  const n = /* @__PURE__ */ pn((r, o) => {
    const { asChild: s, ...i } = r, a = s ? Bu : t;
    return st(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ it(a, an({}, i, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function tA(e, t) {
  e && Sh(
    () => e.dispatchEvent(t)
  );
}
const Rw = /* @__PURE__ */ pn((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ jO.createPortal(/* @__PURE__ */ it(Yo.div, an({}, o, {
    ref: t
  })), r) : null;
}), nA = Rw, rA = ({ children: e }) => /* @__PURE__ */ _(nA, { asChild: !0, children: e }), Pw = b.memo(
  b.forwardRef(
    ({
      isLargeDataSet: e,
      tooltipLabelFormatter: t,
      tooltipValueFormatter: n,
      showLabel: r,
      tooltipVariant: o,
      showTotal: s
    }, i) => {
      const [a, l] = b.useState({
        opacity: 0,
        top: 0,
        left: 0,
        xAlign: ""
      });
      b.useImperativeHandle(i, () => ({
        updateTooltip: (p) => {
          a.opacity === p.opacity && a.left === p.left && a.top === p.top || l((g) => ({
            opacity: p.opacity,
            top: p.top ?? g.top,
            left: p.left ?? g.left,
            xAlign: p.xAlign ?? g.xAlign,
            dataPoints: p.dataPoints ?? g.dataPoints
          }));
        }
      }));
      const { top: c, left: u, opacity: d, xAlign: f, dataPoints: h } = a;
      return /* @__PURE__ */ _(
        "div",
        {
          className: de(
            "pointer-events-none fixed z-50 -translate-y-[calc(100%-8px)] space-y-2 rounded-lg border border-foundations-subtle bg-foundations-default shadow-3 transition-all",
            f === "left" ? "translate-x-[calc(8px+6px)]" : "-translate-x-[calc(100%+8px+6px)]",
            o === "line" ? "px-3 py-2" : "p-4",
            e ? "duration-100" : "duration-200"
          ),
          style: {
            top: c,
            left: u,
            opacity: d
          },
          children: h && h.length > 1 ? (
            // Multiple points (any variant): show the shared label once as a
            // header, then list each point compactly. Indicator shape follows
            // the variant (bar for line, dot for circle).
            /* @__PURE__ */ ee(In, { children: [
              h[0] && /* @__PURE__ */ _("p", { className: "text-[11px] uppercase text-foundations-bold", children: t ? t(
                h[0].rawLabel,
                h[0].dataIndex
              ) : h[0].label }),
              /* @__PURE__ */ ee("div", { className: "space-y-1", children: [
                h.map((p) => {
                  const g = p.dataset.backgroundColor, m = Array.isArray(g) ? g[p.dataIndex] : g;
                  return /* @__PURE__ */ ee(
                    "div",
                    {
                      className: "flex items-center gap-2 whitespace-nowrap text-xs font-medium text-foundations-boldest",
                      children: [
                        /* @__PURE__ */ _(
                          "span",
                          {
                            className: de(
                              "shrink-0 rounded-full",
                              o === "line" ? "h-3.5 w-[3px]" : "size-2"
                            ),
                            style: { backgroundColor: m }
                          }
                        ),
                        r && /* @__PURE__ */ _("span", { className: "text-foundations-bold", children: p.dataset.label }),
                        /* @__PURE__ */ _("span", { className: "ml-auto pl-6", children: n ? n(
                          p.raw,
                          p.dataIndex
                        ) : String(p.raw) })
                      ]
                    },
                    p.dataset.label ?? p.label
                  );
                }),
                s && /* @__PURE__ */ ee("div", { className: "flex items-center gap-2 whitespace-nowrap border-t border-foundations-subtle pt-1 text-xs font-medium text-foundations-boldest", children: [
                  /* @__PURE__ */ _("span", { className: "text-foundations-bold", children: "Total" }),
                  /* @__PURE__ */ _("span", { className: "ml-auto pl-6", children: (() => {
                    const p = h.reduce(
                      (g, m) => g + (Number(m.raw) || 0),
                      0
                    );
                    return n ? n(p, h[0].dataIndex) : String(p);
                  })() })
                ] })
              ] })
            ] })
          ) : o === "line" ? (
            // Single series (line): stacked label / value layout.
            h == null ? void 0 : h.map((p) => {
              const g = p.dataset.backgroundColor, m = Array.isArray(g) ? g[p.dataIndex] : g;
              return /* @__PURE__ */ ee(
                "div",
                {
                  className: "flex items-stretch gap-2 whitespace-nowrap",
                  children: [
                    /* @__PURE__ */ _(
                      "div",
                      {
                        className: "w-[3px] rounded-full",
                        style: { backgroundColor: m }
                      }
                    ),
                    /* @__PURE__ */ ee("div", { className: "flex flex-col gap-1 text-xs font-medium text-foundations-boldest", children: [
                      r && /* @__PURE__ */ _("p", { children: p.dataset.label }),
                      /* @__PURE__ */ _("p", { className: "text-[11px] uppercase text-foundations-subtle", children: t ? t(
                        p.rawLabel,
                        p.dataIndex
                      ) : p.label }),
                      /* @__PURE__ */ _("p", { className: "text-current", children: n ? n(
                        p.raw,
                        p.dataIndex
                      ) : String(p.raw) })
                    ] })
                  ]
                },
                p.dataset.label ?? p.label
              );
            })
          ) : (
            // Single point (circle / doughnut): inline layout.
            h == null ? void 0 : h.map((p) => {
              const g = p.dataset.backgroundColor, m = Array.isArray(g) ? g[p.dataIndex] : g;
              return /* @__PURE__ */ ee(
                "div",
                {
                  className: "flex items-center gap-2 whitespace-nowrap",
                  children: [
                    /* @__PURE__ */ _(
                      "div",
                      {
                        className: "rounded-full size-2",
                        style: { backgroundColor: m }
                      }
                    ),
                    /* @__PURE__ */ ee("div", { className: "flex flex-row gap-4 text-xs font-medium text-foundations-boldest", children: [
                      r && /* @__PURE__ */ _("p", { children: p.dataset.label }),
                      /* @__PURE__ */ _("p", { className: "text-[11px] uppercase text-current", children: t ? t(
                        p.rawLabel,
                        p.dataIndex
                      ) : p.label }),
                      /* @__PURE__ */ _("p", { className: "text-foundations-subtle", children: n ? n(
                        p.raw,
                        p.dataIndex
                      ) : String(p.raw) })
                    ] })
                  ]
                },
                p.dataset.label ?? p.label
              );
            })
          )
        }
      );
    }
  )
);
Pw.displayName = "TooltipInternal";
const Iw = ({
  labelFormatter: e,
  valueFormatter: t,
  variant: n = "line",
  showTotal: r = !1
} = {}) => {
  const { tooltipRef: o, isLargeDataSet: s, datasets: i } = Ya();
  return /* @__PURE__ */ _(rA, { children: /* @__PURE__ */ _(
    Pw,
    {
      ref: o,
      tooltipVariant: n,
      tooltipLabelFormatter: e && xa(e),
      tooltipValueFormatter: t && xa(t),
      isLargeDataSet: s,
      showLabel: i.length > 1,
      showTotal: r
    }
  ) });
};
Iw.displayName = "Chart.Tooltip";
Fu.register(
  Jf,
  eh,
  ya,
  Jl,
  Yi,
  Ql,
  ql,
  Kl,
  zi,
  Hi,
  bN
);
Fu.defaults.datasets.line.clip = !1;
const kw = ({
  type: e,
  labels: t,
  datasets: n,
  children: r,
  className: o
}) => t.length === 0 ? /* @__PURE__ */ _(vw, {}) : /* @__PURE__ */ _(W3, { type: e, labels: t, datasets: n, children: /* @__PURE__ */ _("div", { className: de("relative flex flex-col", o), children: r }) });
kw.displayName = "Chart";
const nB = Object.assign(kw, {
  Canvas: _w,
  Legend: Mw,
  Tooltip: Iw
});
function rB(e) {
  return {
    grace: "5%",
    grid: {
      drawOnChartArea: !1,
      drawTicks: !1
    },
    ticks: {
      padding: 8,
      color: Xr("--text-foundations-subtle")
    },
    border: {
      display: !1
    },
    ...e
  };
}
const oA = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ArrowNarrowShortUp/solid"
}, e), /* @__PURE__ */ b.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.293 9.707a1 1 0 0 1 0-1.414l4.005-4a1.002 1.002 0 0 1 1.416 0l4.005 4a1 1 0 0 1-1.416 1.414l-2.296-2.293V15a1 1 0 0 1-1.001 1 1.002 1.002 0 0 1-1.001-1V7.414L6.709 9.707a1.002 1.002 0 0 1-1.416 0Z",
  clipRule: "evenodd"
})), Gp = (e) => Number(e.toFixed(2)), sA = Qn(
  "transition-all duration-1000 stroke-neutral-300",
  {
    variants: {
      variant: {
        success: "stroke-[theme(backgroundColor.chart-categorical-2-subtle)]",
        danger: "stroke-[theme(backgroundColor.chart-categorical-3-subtle)]",
        primary: "stroke-[theme(backgroundColor.info-bold)]"
      }
    }
  }
), Dw = b.forwardRef(
  ({
    variant: e,
    value: t,
    size: n = 170,
    strokeWidth: r = 10,
    strokeClassName: o,
    strokeLinecap: s = "round"
  }, i) => {
    const l = n / 2 - r, c = 2 * Math.PI * l, u = c * ((100 - (t || 0)) / 100);
    return /* @__PURE__ */ ee("svg", { ref: i, width: n, height: n, children: [
      /* @__PURE__ */ _(
        "circle",
        {
          className: de("stroke-neutral-100", o),
          fill: "none",
          strokeWidth: r,
          r: l,
          cx: n / 2,
          cy: n / 2
        }
      ),
      /* @__PURE__ */ _(
        "circle",
        {
          className: de(
            "stroke-[theme(backgroundColor.chart-neutral)]",
            sA({ variant: e })
          ),
          fill: "none",
          strokeWidth: r,
          r: l,
          cx: n / 2,
          cy: n / 2,
          strokeDasharray: c,
          strokeDashoffset: u,
          strokeLinecap: s,
          transform: "rotate(-90)",
          "transform-origin": "center"
        }
      )
    ] });
  }
), iA = b.forwardRef(
  ({
    variant: e,
    value: t,
    size: n = 170,
    strokeWidth: r = 10,
    strokeClassName: o,
    className: s,
    children: i
  }, a) => /* @__PURE__ */ ee("div", { ref: a, className: de("relative inline-flex", s), children: [
    /* @__PURE__ */ _(
      Dw,
      {
        value: t,
        variant: e,
        size: n,
        strokeWidth: r,
        strokeClassName: o
      }
    ),
    /* @__PURE__ */ _("div", { className: "absolute inset-0 flex flex-col items-center justify-center space-y-1.5", children: t === null ? /* @__PURE__ */ ee("div", { className: "flex scale-[0.8] flex-col items-center", children: [
      /* @__PURE__ */ _(yw, {}),
      /* @__PURE__ */ _("p", { className: "-mt-4 text-xs font-medium text-foundations-boldest", children: "No data in this period" })
    ] }) : /* @__PURE__ */ ee(In, { children: [
      /* @__PURE__ */ ee("p", { className: "text-xl font-bold text-foundations-boldest", children: [
        Gp(t),
        "%"
      ] }),
      i
    ] }) })
  ] })
);
iA.displayName = "CircleChart";
const aA = Qn(
  "flex items-center justify-center rounded-md border border-foundations-bold bg-foundations-subtlest px-1.5 py-0.5 text-foundations-boldest",
  {
    variants: {
      variant: {
        success: "border-success-subtle bg-success-subtler",
        danger: "border-danger-subtle bg-danger-subtler"
      }
    }
  }
), oB = b.forwardRef(({ diffPercentage: e, variant: t, className: n, ...r }, o) => /* @__PURE__ */ ee(
  "span",
  {
    ref: o,
    className: de(aA({ variant: t }), n),
    ...r,
    children: [
      !!e && /* @__PURE__ */ _(
        oA,
        {
          className: de("h-4 w-4", e < 0 && " rotate-180")
        }
      ),
      /* @__PURE__ */ ee("span", { className: "text-xs font-medium", children: [
        Gp(Math.abs(e)),
        "%"
      ] })
    ]
  }
)), lA = ({
  items: e,
  formatValue: t,
  onBarHover: n
}) => {
  const r = b.useMemo(
    () => Math.max(...e.map((o) => o.value)),
    [e]
  );
  return e.length === 0 ? /* @__PURE__ */ _(vw, {}) : /* @__PURE__ */ _("div", { className: "space-y-4 text-xs font-medium", children: e.map((o) => {
    const s = (t == null ? void 0 : t(o)) || o.value;
    return /* @__PURE__ */ ee("div", { children: [
      /* @__PURE__ */ _("p", { className: "uppercase text-foundations-bold", children: o.label }),
      /* @__PURE__ */ ee(
        "div",
        {
          className: "mt-0.5 flex items-center space-x-2",
          style: {
            width: `${o.value ? o.value / r * 100 : 0}%`
          },
          children: [
            /* @__PURE__ */ ee(
              Lt,
              {
                onOpenChangeComplete: (i) => {
                  n == null || n(i, o);
                },
                disableHoverablePopup: !0,
                children: [
                  /* @__PURE__ */ _(
                    Lt.Trigger,
                    {
                      delay: 0,
                      render: /* @__PURE__ */ _(
                        "div",
                        {
                          className: "h-2 min-w-[2px] flex-1 bg-neutral-200",
                          style: {
                            backgroundColor: o.color
                          }
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ ee(
                    Lt.Popup,
                    {
                      variant: "light",
                      className: "flex items-center gap-2 whitespace-nowrap shadow-3",
                      hideArrow: !0,
                      children: [
                        /* @__PURE__ */ _(
                          "div",
                          {
                            className: "rounded-full size-2",
                            style: {
                              backgroundColor: o.color
                            }
                          }
                        ),
                        /* @__PURE__ */ ee("div", { className: "flex gap-4 text-xs font-medium text-foundations-boldest", children: [
                          /* @__PURE__ */ _("p", { className: "uppercase", children: o.label }),
                          /* @__PURE__ */ ee("p", { className: "text-foundations-subtle", children: [
                            s,
                            " ",
                            o.percentage && /* @__PURE__ */ ee("span", { children: [
                              "(",
                              Gp(o.percentage),
                              "%)"
                            ] })
                          ] })
                        ] })
                      ]
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ _("span", { className: "tabular-nums text-foundations-subtle", children: s })
          ]
        }
      )
    ] }, o.label);
  }) });
};
lA.displayName = "HorizontalBarsChart";
function Fr({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: o
  } = b.useRef(e !== void 0), [s, i] = b.useState(t), a = o ? e : s;
  if (process.env.NODE_ENV !== "production") {
    b.useEffect(() => {
      o !== (e !== void 0) && da([`A component is changing the ${o ? "" : "un"}controlled ${r} state of ${n} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: c
    } = b.useRef(t);
    b.useEffect(() => {
      !o && s0(c) !== s0(t) && da([`A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [t]);
  }
  const l = b.useCallback((c) => {
    o || i(c);
  }, []);
  return [a, l];
}
function s0(e) {
  let t = 0;
  const n = /* @__PURE__ */ new WeakMap();
  try {
    return JSON.stringify(e, function(s, i) {
      if (!(s === "_owner" && this != null && typeof this == "object" && "$$typeof" in this)) {
        if (typeof i == "bigint")
          return `__bigint__:${i}`;
        if (i !== null && typeof i == "object") {
          const a = n.get(i);
          if (a !== void 0)
            return `__object__:${a}`;
          n.set(i, t), t += 1;
        }
        return i;
      }
    }) ?? `__top__:${typeof e}`;
  } catch {
    return "__unserializable__";
  }
}
const Kp = /* @__PURE__ */ b.createContext({
  register: () => {
  },
  unregister: () => {
  },
  subscribeMapChange: () => () => {
  },
  nextIndexRef: {
    current: 0
  }
});
process.env.NODE_ENV !== "production" && (Kp.displayName = "CompositeListContext");
function cA() {
  return b.useContext(Kp);
}
function zu(e) {
  const {
    children: t,
    elementsRef: n,
    labelsRef: r,
    onMapChange: o
  } = e, s = ye(o), [, i] = b.useState(!1), a = bn(dA).current, l = bn(uA).current, c = b.useRef(0), u = b.useRef(!0), d = b.useRef([]), f = b.useRef(null), h = ye(() => {
    u.current || (u.current = !0, i((w) => !w));
  }), p = ye((w, E) => {
    l.set(w, E), h();
  }), g = ye((w) => {
    l.delete(w), h();
  }), m = ye((w) => {
    const E = /* @__PURE__ */ new Map();
    return n.current.length = 0, r && (r.current.length = 0), w.forEach((S) => {
      var O, M;
      E.set(S.element, {
        ...S.registration.metadata ?? {},
        index: S.index
      }), n.current[S.index] = S.element, r && (r.current[S.index] = S.registration.label !== void 0 ? S.registration.label : ((M = (O = S.registration.textRef) == null ? void 0 : O.current) == null ? void 0 : M.textContent) ?? S.element.textContent);
    }), c.current = n.current.length, E;
  });
  function v(w) {
    var O;
    if ((O = f.current) == null || O.disconnect(), f.current = null, typeof MutationObserver != "function" || w.length < 2)
      return;
    const E = new MutationObserver((M) => {
      if (!pA(M))
        return;
      let T = null;
      for (const P of w)
        if (P.isConnected) {
          if (T && Nw(T, P) > 0) {
            E.disconnect(), h();
            return;
          }
          T = P;
        }
    });
    f.current = E;
    const S = /* @__PURE__ */ new Set();
    for (let M = 1; M < w.length; M += 1) {
      const T = hA(w[M - 1], w[M]);
      T && S.add(T);
    }
    S.forEach((M) => E.observe(M, {
      childList: !0
    }));
  }
  const y = ye(() => {
    const [w, E] = fA(l), S = m(w);
    v(E), d.current = w, u.current = !1, a.forEach((O) => O(S)), s(S);
  });
  pe(() => (u.current || m(d.current), () => {
    n.current = [], r && (r.current = []);
  }), [n, r, m]), pe(() => {
    u.current && y();
  }), pe(() => () => {
    var w;
    (w = f.current) == null || w.disconnect(), u.current = !0;
  }, []);
  const x = ye((w) => (a.add(w), () => {
    a.delete(w);
  })), C = b.useMemo(() => ({
    register: p,
    unregister: g,
    subscribeMapChange: x,
    nextIndexRef: c
  }), [p, g, x, c]);
  return /* @__PURE__ */ _(Kp.Provider, {
    value: C,
    children: t
  });
}
function uA() {
  return /* @__PURE__ */ new Map();
}
function dA() {
  return /* @__PURE__ */ new Set();
}
function fA(e) {
  const t = /* @__PURE__ */ new Set(), n = [], r = [];
  e.forEach((s, i) => {
    if (!i.isConnected)
      return;
    const a = s.index, l = {
      index: a ?? -1,
      element: i,
      registration: s
    };
    a === null ? r.push(l) : a >= 0 && (t.add(a), n.push(l));
  });
  let o = 0;
  return r.sort((s, i) => Nw(s.element, i.element)), r.forEach((s) => {
    for (; t.has(o); )
      o += 1;
    s.index = o, n.push(s), o += 1;
  }), t.size > 0 && n.sort((s, i) => s.index - i.index), [n, r.map((s) => s.element)];
}
function hA(e, t) {
  let n = e.parentElement;
  for (; n && !n.contains(t); )
    n = n.parentElement;
  return n;
}
function pA(e) {
  for (const t of e)
    for (let n = 0; n < t.removedNodes.length; n += 1)
      if (t.removedNodes[n].isConnected)
        return !0;
  return !1;
}
function Nw(e, t) {
  return e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
}
function gA(e) {
  const {
    open: t,
    defaultOpen: n,
    onOpenChange: r,
    disabled: o
  } = e, [s, i] = Fr({
    controlled: t,
    default: n,
    name: "Collapsible",
    state: "open"
  }), {
    mounted: a,
    setMounted: l,
    transitionStatus: c
  } = vs(s, !0, !0), u = gn(), [d, f] = b.useState(), h = d === null ? void 0 : d ?? u, p = ye((g) => {
    const m = !s, v = Ne(Lr, g.nativeEvent);
    r(m, v), !v.isCanceled && i(m);
  });
  return b.useMemo(() => ({
    defaultPanelId: u,
    disabled: o,
    handleTrigger: p,
    mounted: a,
    open: s,
    panelId: h,
    setMounted: l,
    setOpen: i,
    setPanelIdState: f,
    transitionStatus: c
  }), [u, o, p, a, s, h, l, i, f, c]);
}
const qp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (qp.displayName = "CollapsibleRootContext");
function Aw() {
  const e = b.useContext(qp);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CollapsibleRootContext is missing. Collapsible parts must be placed within <Collapsible.Root>." : tt(15));
  return e;
}
function Es(e = {}) {
  const {
    guess: t,
    label: n,
    metadata: r,
    textRef: o,
    index: s
  } = e, {
    register: i,
    unregister: a,
    subscribeMapChange: l,
    nextIndexRef: c
  } = cA(), u = b.useRef(-1), [d, f] = b.useState(s == null && t ? () => {
    if (u.current === -1) {
      const m = c.current;
      c.current += 1, u.current = m;
    }
    return u.current;
  } : -1), h = s ?? d, p = b.useRef(null), g = b.useCallback((m) => {
    const v = p.current;
    v && a(v), p.current = m, m && i(m, {
      metadata: r ?? null,
      index: s ?? null,
      label: n,
      textRef: o
    });
  }, [s, i, a, r, n, o]);
  return pe(() => {
    if (s == null)
      return l((m) => {
        var y;
        const v = p.current ? (y = m.get(p.current)) == null ? void 0 : y.index : null;
        v != null && f(v);
      });
  }, [s, l]), {
    ref: g,
    index: h
  };
}
let Xp = function(e) {
  return e.open = "data-open", e.closed = "data-closed", e[e.startingStyle = xc.startingStyle] = "startingStyle", e[e.endingStyle = xc.endingStyle] = "endingStyle", e;
}({}), mA = /* @__PURE__ */ function(e) {
  return e.panelOpen = "data-panel-open", e;
}({});
const bA = {
  [Xp.open]: ""
}, vA = {
  [Xp.closed]: ""
}, yA = {
  open(e) {
    return e ? {
      [mA.panelOpen]: ""
    } : null;
  }
}, xA = {
  open(e) {
    return e ? bA : vA;
  }
}, ki = {
  height: void 0,
  width: void 0
};
function wA(e) {
  const {
    externalRef: t,
    hiddenUntilFound: n,
    id: r,
    keepMounted: o,
    mounted: s,
    onOpenChange: i,
    open: a,
    setMounted: l,
    setOpen: c,
    transitionStatus: u
  } = e, d = b.useRef(null), f = b.useRef(null), [h, p] = b.useState(ki), g = b.useRef(ki), m = b.useRef(!1), v = b.useRef(a), y = b.useRef(!1), [x, C] = b.useState(!1), w = b.useRef(null), E = ar(t, d), S = rn(a), O = hu(d), M = !a && !s, T = x ? "idle" : u, P = a && // These 2 refs are safe to read in render, they are only written from committed
  // layout/effect paths and gate one-shot motion suppression for the next open
  // lifecycle. They intentionally expose the last committed motion snapshot.
  (v.current || y.current), I = !a && s && // These 2 refs are also safe to read in render, both hold the last committed
  // animation mode and measurement. This fallback only restores a previously
  // measured pixel size after the live dimensions state has been reset back to `auto`.
  f.current === "css-animation" && h.height === void 0 && h.width === void 0 ? g.current : h, R = n && M && f.current !== "css-animation", D = ye((F, N = !0) => {
    N && (g.current = F), p(F);
  }), k = ye(() => {
    var F;
    (F = w.current) == null || F.call(w), w.current = null;
  }), $ = ye((F) => {
    k(), w.current = () => {
      w.current = null, F();
    };
  }), L = ye(() => {
    a && s && f.current === "css-animation" && (y.current = !0);
  });
  pe(() => {
    !x || u === "starting" || C(!1);
  }, [x, u]), b.useEffect(() => () => {
    L(), k();
  }, [L, k]), pe(() => {
    const F = d.current;
    if (!F)
      return;
    !a && w.current && k();
    const N = CA(F, P);
    if (f.current = N, a && u === "idle" && v.current && N === "css-animation") {
      g.current = Ps(F);
      return;
    }
    if (a && u === "starting") {
      const Y = m.current;
      if (m.current = !1, N === "none") {
        D(Ps(F)), C(!0);
        return;
      }
      if (N === "css-transition") {
        const H = EA(F);
        if (D(Ps(F)), !Y)
          return H;
        const q = Il(F, "transition-duration", "0s");
        return $(q), C(!0), H;
      }
      D(Ps(F));
      const U = Il(F, "animation-name", "none");
      if (!Y) {
        U();
        return;
      }
      const j = Il(F, "animation-duration", "0s");
      U(), $(j), C(!0);
      return;
    }
    if (!a && s && (u === "idle" || u === "starting")) {
      if (v.current = !1, y.current = !1, N === "none") {
        D(ki, !1), l(!1);
        return;
      }
      D(Ps(F));
      return;
    }
    if (u !== "ending")
      return;
    if (N === "none") {
      l(!1);
      return;
    }
    const V = Ps(F);
    if (!(V.height > 0 || V.width > 0)) {
      l(!1);
      return;
    }
    D(V), N === "css-animation" && Il(F, "animation-name", "none")();
  }, [s, a, k, D, l, $, P, u]), Jn({
    enabled: a && s && T === "idle",
    open: !0,
    ref: d,
    onComplete() {
      a && D(ki, !1);
    }
  }), b.useEffect(() => {
    if (a || !s || T !== "ending" || !d.current)
      return;
    const N = new AbortController();
    let V = -1;
    function K() {
      S.current || (l(!1), D(ki, !1));
    }
    return V = An.request(() => {
      O(K, N.signal);
    }), () => {
      An.cancel(V), N.abort();
    };
  }, [S, s, a, T, O, D, l]), pe(() => {
    const F = d.current;
    !F || !n || !M || F.setAttribute("hidden", "until-found");
  }, [M, n]), b.useEffect(function() {
    const N = d.current;
    if (!N)
      return;
    function V(K) {
      const Y = Ne(Cn, K);
      i(!0, Y), !Y.isCanceled && (m.current = !0, c(!0));
    }
    return qe(N, "beforematch", V);
  }, [i, c]);
  const A = o || n || s || a;
  return {
    height: I.height,
    props: {
      ...R ? {
        [Xp.startingStyle]: ""
      } : void 0,
      hidden: M,
      id: r
    },
    ref: E,
    shouldPreventOpenAnimation: P,
    shouldRender: A,
    transitionStatus: T,
    width: I.width
  };
}
function Ps(e) {
  return {
    height: e.scrollHeight,
    width: e.scrollWidth
  };
}
function CA(e, t) {
  const n = Ht(e).getComputedStyle(e), r = (n.animationName.split(",").map((s) => s.trim()).some((s) => s !== "" && s !== "none") || t) && i0(n.animationDuration), o = i0(n.transitionDuration);
  return r && o ? (process.env.NODE_ENV !== "production" && Qc("CSS transitions and CSS animations both detected on Collapsible or Accordion panel.", "Only one of either animation type should be used."), "css-transition") : o ? "css-transition" : r ? "css-animation" : "none";
}
function i0(e) {
  return e.split(",").map((t) => t.trim()).some((t) => t !== "" && Number.parseFloat(t) > 0);
}
function Il(e, t, n) {
  const r = e.style.getPropertyValue(t), o = e.style.getPropertyPriority(t);
  return e.style.setProperty(t, n), () => {
    if (r === "") {
      e.style.removeProperty(t);
      return;
    }
    e.style.setProperty(t, r, o);
  };
}
function EA(e) {
  const t = {
    "justify-content": e.style.justifyContent,
    "align-items": e.style.alignItems,
    "align-content": e.style.alignContent,
    "justify-items": e.style.justifyItems
  };
  Object.keys(t).forEach((o) => {
    e.style.setProperty(o, "initial", "important");
  });
  function n() {
    Object.entries(t).forEach(([o, s]) => {
      if (s === "") {
        e.style.removeProperty(o);
        return;
      }
      e.style.setProperty(o, s);
    });
  }
  const r = An.request(n);
  return () => {
    An.cancel(r), n();
  };
}
function _A(e) {
  const t = b.useRef(!0);
  t.current && (t.current = !1, e());
}
function SA(e, t, n, r, o, s, i, a, l, c = 2) {
  const u = OT(n.current, {
    event: e,
    orientation: r,
    loopFocus: o,
    rtl: s,
    cols: c,
    disabledIndices: i,
    minIndex: a,
    maxIndex: l,
    // An out-of-range previous index falls back to the first enabled item.
    prevIndex: t > l ? a : t,
    stopEvent: !0
  });
  return So(n.current, u) ? void 0 : u;
}
const Zp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Zp.displayName = "ComboboxRootContext");
const Qp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Qp.displayName = "ComboboxFloatingContext");
const Jp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Jp.displayName = "ComboboxDerivedItemsContext");
const eg = /* @__PURE__ */ b.createContext(!1);
process.env.NODE_ENV !== "production" && (eg.displayName = "ComboboxHasItemsContext");
const tg = /* @__PURE__ */ b.createContext("");
process.env.NODE_ENV !== "production" && (tg.displayName = "ComboboxInputValueContext");
function ur() {
  const e = b.useContext(Zp);
  if (!e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxRootContext is missing. Combobox parts must be placed within <Combobox.Root>." : tt(22));
  return e;
}
function Yu() {
  const e = b.useContext(Qp);
  if (!e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxFloatingContext is missing. Combobox parts must be placed within <Combobox.Root>." : tt(23));
  return e;
}
function fi() {
  const e = b.useContext(Jp);
  if (!e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxItemsContext is missing. Combobox parts must be placed within <Combobox.Root>." : tt(24));
  return e;
}
function $w() {
  return b.useContext(tg);
}
function OA() {
  return b.useContext(eg);
}
const MA = (e, t) => Object.is(e, t);
function No(e, t, n) {
  return e == null || t == null ? Object.is(e, t) : n(e, t);
}
function TA(e, t, n) {
  return !e || e.length === 0 ? !1 : e.some((r) => r === void 0 ? !1 : No(t, r, n));
}
function Fw(e, t, n) {
  return !e || e.length === 0 ? -1 : e.findIndex((r) => r === void 0 ? !1 : No(r, t, n));
}
function Gd(e, t, n, r) {
  const o = r && Array.isArray(t) ? t[t.length - 1] : t, s = Fw(e, o, n);
  return s === -1 ? null : s;
}
function RA(e, t, n) {
  return e.filter((r) => !No(t, r, n));
}
function ah(e) {
  if (e == null)
    return "";
  if (typeof e == "string")
    return e;
  try {
    return JSON.stringify(e);
  } catch {
    return String(e);
  }
}
function Lw(e) {
  return e != null && e.length > 0 && typeof e[0] == "object" && e[0] != null && "items" in e[0];
}
function PA(e) {
  if (!Array.isArray(e))
    return e != null && "null" in e;
  const t = e;
  if (Lw(t)) {
    for (const n of t)
      for (const r of n.items)
        if (r && r.value == null && r.label != null)
          return !0;
    return !1;
  }
  for (const n of t)
    if (n && n.value == null && n.label != null)
      return !0;
  return !1;
}
function Tr(e, t) {
  if (t && e != null)
    return t(e) ?? "";
  if (e && typeof e == "object") {
    if ("label" in e && e.label != null)
      return String(e.label);
    if ("value" in e)
      return String(e.value);
  }
  return ah(e);
}
function Di(e, t) {
  return t && e != null ? t(e) ?? "" : e && typeof e == "object" && "value" in e && "label" in e ? ah(e.value) : ah(e);
}
const Ce = {
  id: (e) => e.id,
  labelId: (e) => e.labelId,
  items: (e) => e.items,
  selectedValue: (e) => e.selectedValue,
  hasSelectionChips: (e) => {
    const t = e.selectedValue;
    return Array.isArray(t) && t.length > 0;
  },
  hasSelectedValue: (e) => {
    const {
      selectedValue: t,
      selectionMode: n
    } = e;
    return t == null ? !1 : n === "multiple" && Array.isArray(t) ? t.length > 0 : !0;
  },
  hasNullItemLabel: (e, t) => t ? PA(e.items) : !1,
  open: (e) => e.open,
  mounted: (e) => e.mounted,
  forceMounted: (e) => e.forceMounted,
  inline: (e) => e.inline,
  activeIndex: (e) => e.activeIndex,
  selectedIndex: (e) => e.selectedIndex,
  isActive: (e, t) => e.activeIndex === t,
  isSelected: (e, t) => {
    const n = e.isItemEqualToValue, r = e.selectedValue;
    return Array.isArray(r) ? r.some((o) => No(t, o, n)) : No(t, r, n);
  },
  transitionStatus: (e) => e.transitionStatus,
  popupProps: (e) => e.popupProps,
  listProps: (e) => e.listProps,
  inputProps: (e) => e.inputProps,
  triggerProps: (e) => e.triggerProps,
  itemProps: (e) => e.itemProps,
  positionerElement: (e) => e.positionerElement,
  listElement: (e) => e.listElement,
  popupId: (e) => e.popupId,
  triggerElement: (e) => e.triggerElement,
  inputElement: (e) => e.inputElement,
  inputGroupElement: (e) => e.inputGroupElement,
  popupSide: (e) => e.popupSide,
  openMethod: (e) => e.openMethod,
  inputInsidePopup: (e) => e.inputInsidePopup,
  inputOwnsFormValue: (e) => e.inputOwnsFormValue,
  selectionMode: (e) => e.selectionMode,
  name: (e) => e.name,
  form: (e) => e.form,
  disabled: (e) => e.disabled,
  readOnly: (e) => e.readOnly,
  required: (e) => e.required,
  grid: (e) => e.grid,
  virtualized: (e) => e.virtualized,
  itemToStringLabel: (e) => e.itemToStringLabel,
  isItemEqualToValue: (e) => e.isItemEqualToValue,
  modal: (e) => e.modal,
  autoHighlight: (e) => e.autoHighlight
}, IA = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: null,
  valueMissing: !1
}, Vw = {
  valid: null,
  touched: !1,
  dirty: !1,
  filled: !1,
  focused: !1
}, kA = {
  disabled: !1,
  ...Vw
}, Ww = {
  valid(e) {
    return e === null ? null : e ? {
      "data-valid": ""
    } : {
      "data-invalid": ""
    };
  }
}, Hw = {
  invalid: void 0,
  name: void 0,
  validityData: {
    state: IA,
    errors: [],
    error: "",
    value: "",
    initialValue: null
  },
  setValidityData: Nt,
  disabled: void 0,
  setTouched: Nt,
  setDirty: Nt,
  setFilled: Nt,
  setFocused: Nt,
  validationMode: "onSubmit",
  shouldValidateOnChange: () => !1,
  state: kA,
  registerFieldControl: Nt,
  validation: {
    getValidationProps: (e, t = At) => t,
    inputRef: {
      current: null
    },
    registeredInputs: /* @__PURE__ */ new Map(),
    registerInput: Nt,
    getInputControl: () => null,
    commit: async () => {
    },
    change: Nt
  }
}, ng = /* @__PURE__ */ b.createContext(Hw);
process.env.NODE_ENV !== "production" && (ng.displayName = "FieldRootContext");
function hi(e = !0) {
  const t = b.useContext(ng);
  if (t.setValidityData === Nt && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldRootContext is missing. Field parts must be placed within <Field.Root>." : tt(28));
  return t;
}
function Bw(e, t, n, r, o = !0, s) {
  const {
    registerFieldControl: i
  } = hi(), a = bn(() => Symbol());
  pe(() => {
    const l = a.current;
    if (!o) {
      i(l, void 0);
      return;
    }
    i(l, {
      controlRef: e,
      getValue: r,
      id: t,
      name: s,
      value: n
    });
  }, [e, o, r, t, s, i, a, n]), pe(() => {
    const l = a.current;
    return () => {
      i(l, void 0);
    };
  }, [i, a]);
}
const zw = /* @__PURE__ */ b.createContext({
  elementRef: {
    current: null
  },
  formRef: {
    current: {
      fields: /* @__PURE__ */ new Map()
    }
  },
  errors: {},
  clearErrors: Nt,
  validationMode: "onSubmit",
  submitAttemptedRef: {
    current: !1
  }
});
process.env.NODE_ENV !== "production" && (zw.displayName = "FormContext");
function Yw() {
  return b.useContext(zw);
}
const jw = /* @__PURE__ */ b.createContext({
  controlId: void 0,
  registerControlId: Nt,
  labelId: void 0,
  setLabelId: Nt,
  messageIds: [],
  setMessageIds: Nt,
  getDescriptionProps: (e) => e
});
process.env.NODE_ENV !== "production" && (jw.displayName = "LabelableContext");
function ju() {
  return b.useContext(jw);
}
function rg(e = {}) {
  const {
    id: t,
    implicit: n = !1,
    controlRef: r
  } = e, {
    controlId: o,
    registerControlId: s
  } = ju(), i = gn(t), a = n ? o : void 0, l = bn(() => Symbol()), c = b.useRef(!1), u = b.useRef(t != null), d = ye(() => {
    !c.current || s === Nt || (c.current = !1, s(l.current, void 0));
  });
  return pe(() => {
    if (s === Nt)
      return;
    let f;
    if (n) {
      const h = r == null ? void 0 : r.current;
      Qe(h) && h.closest("label") != null ? f = t ?? null : f = a ?? i;
    } else if (t != null)
      u.current = !0, f = t;
    else if (u.current)
      f = i;
    else {
      d();
      return;
    }
    if (f === void 0) {
      d();
      return;
    }
    c.current = !0, s(l.current, f);
  }, [t, r, a, s, n, i, l, d]), b.useEffect(() => d, [d]), o ?? i;
}
function Uw(e) {
  return e == null ? void 0 : `${e}-popup`;
}
function DA(e, t) {
  return (n, r) => n == null ? !1 : e.contains(n, r, t);
}
function og(e) {
  return Array.isArray(e) ? e.map((t) => og(t)).join(",") : e == null ? "" : String(e);
}
const a0 = /* @__PURE__ */ new Map();
function NA(e = {}) {
  const t = {
    usage: "search",
    sensitivity: "base",
    ignorePunctuation: !0,
    ...e
  }, n = `${og(e.locale)}|${JSON.stringify(t)}`, r = a0.get(n);
  if (r)
    return r;
  const o = new Intl.Collator(e.locale, t), s = {
    contains(i, a, l) {
      if (!a)
        return !0;
      const c = Tr(i, l);
      for (let u = 0; u <= c.length - a.length; u += 1)
        if (o.compare(c.slice(u, u + a.length), a) === 0)
          return !0;
      return !1;
    },
    startsWith(i, a, l) {
      if (!a)
        return !0;
      const c = Tr(i, l);
      return o.compare(c.slice(0, a.length), a) === 0;
    },
    endsWith(i, a, l) {
      if (!a)
        return !0;
      const c = Tr(i, l), u = a.length;
      return c.length >= u && o.compare(c.slice(c.length - u), a) === 0;
    }
  };
  return a0.set(n, s), s;
}
const AA = NA;
function $A(e, t = !1) {
  const {
    overflowY: n
  } = Vn(e);
  return n !== "auto" && n !== "scroll" ? !1 : t ? e.clientHeight > 0 : e.scrollHeight > e.clientHeight;
}
function FA(e, t, n = (r, o) => r === o) {
  return e.length === t.length && e.every((r, o) => n(r, t[o]));
}
const Gw = Symbol("none"), Kd = {
  value: Gw,
  index: -1
};
function LA(e) {
  const {
    id: t,
    onOpenChangeComplete: n,
    defaultSelectedValue: r = null,
    selectedValue: o,
    onSelectedValueChange: s,
    defaultInputValue: i,
    inputValue: a,
    open: l,
    defaultOpen: c = !1,
    selectionMode: u,
    onItemHighlighted: d,
    name: f,
    form: h,
    disabled: p = !1,
    readOnly: g = !1,
    required: m = !1,
    inputRef: v,
    grid: y = !1,
    items: x,
    filteredItems: C,
    filter: w,
    openOnInputClick: E = !0,
    autoHighlight: S = !1,
    keepHighlight: O = !1,
    highlightItemOnHover: M = !0,
    loopFocus: T = !0,
    itemToStringLabel: P,
    itemToStringValue: I,
    isItemEqualToValue: R = MA,
    virtualized: D = !1,
    inline: k = !1,
    fillInputOnItemPress: $ = !0,
    modal: L = !1,
    limit: A = -1,
    autoComplete: F = "list",
    formAutoComplete: N,
    locale: V,
    submitOnItemClick: K = !1
  } = e, {
    clearErrors: Y
  } = Yw(), {
    setDirty: U,
    validityData: j,
    setFilled: H,
    name: q,
    disabled: B,
    setTouched: X,
    setFocused: te,
    validationMode: J,
    validation: G
  } = hi(), ne = Fa(), Q = rg({
    id: t
  }), re = AA({
    locale: V
  }), [fe, le] = b.useState(!1), [Ee, se] = b.useState(null), _e = b.useRef([]), xe = b.useRef([]), ge = b.useRef(null), ae = b.useRef(null), W = b.useRef(null), Z = b.useRef(null), me = b.useRef(null), ie = b.useRef(!0), oe = b.useRef(!1), he = b.useRef(null), Re = b.useRef(null), Ae = b.useRef(null), Ue = b.useRef(Kd), Ke = b.useRef(null), Be = b.useRef([]), nt = b.useRef(null), at = B || p, Wt = q ?? f, Mt = u === "multiple", Bt = u === "single", Qt = a !== void 0 || i !== void 0, Pe = x !== void 0, Ge = C !== void 0;
  let Le;
  S === "always" ? Le = "always" : Le = S ? "input-change" : !1;
  const [be, Ye] = Fr({
    controlled: o,
    default: Mt ? r ?? Gn : r,
    name: "Combobox",
    state: "selectedValue"
  }), Tt = b.useMemo(() => w === null ? () => !0 : w !== void 0 ? w : DA(re, P), [w, re, P]), je = bn(() => Qt ? i ?? "" : Bt ? Tr(be, P) : "").current, [Rt, On] = Fr({
    controlled: a,
    default: je,
    name: "Combobox",
    state: "inputValue"
  }), [vt, er] = Fr({
    controlled: l,
    default: c,
    name: "Combobox",
    state: "open"
  }), Jt = Lw(x), vn = Ee ?? String(Rt).trim(), ho = Bt ? Tr(be, P) : "", po = Bt && !fe && vn !== "" && ho.length === vn.length && re.contains(ho, vn), vr = po ? "" : vn, z = Pe && Ge && po, ue = b.useMemo(() => x ? Jt ? x.flatMap((Me) => Me.items) : x : Gn, [x, Jt]), Te = b.useMemo(() => {
    if (C && !z)
      return C;
    if (!x)
      return Gn;
    if (Jt) {
      const De = x, ft = [];
      let Pt = 0;
      for (const en of De) {
        if (A > -1 && Pt >= A)
          break;
        const dr = A > -1 ? A - Pt : 1 / 0, tn = vr === "" ? en.items.slice(0, dr) : [];
        if (vr !== "")
          for (const yn of en.items) {
            if (tn.length >= dr)
              break;
            Tt(yn, vr, P) && tn.push(yn);
          }
        if (tn.length > 0) {
          const yn = {
            ...en,
            items: tn
          };
          ft.push(yn), Pt += tn.length;
        }
      }
      return ft;
    }
    if (vr === "")
      return A > -1 ? ue.slice(0, A) : (
        // The cast here is done as `flatItems` is readonly.
        // valuesRef.current, a mutable ref, can be set to `flatFilteredItems`, which may
        // reference this exact readonly value, creating a mutation risk.
        // However, <Combobox.Item> can never mutate this value as the mutating effect
        // bails early when `items` is provided, and this is only ever returned
        // when `items` is provided due to the early return at the top of this hook.
        ue
      );
    const Me = [];
    for (const De of ue) {
      if (A > -1 && Me.length >= A)
        break;
      Tt(De, vr, P) && Me.push(De);
    }
    return Me;
  }, [C, z, x, Jt, vr, A, Tt, P, ue]), Ve = b.useMemo(() => Jt ? Te.flatMap((De) => De.items) : Te, [Te, Jt]), Se = bn(() => {
    let Me = null;
    return k && vt && Pe && u !== "none" && (Me = Gd(Ve, be, R, Mt)), new $1({
      id: Q,
      labelId: void 0,
      selectedValue: be,
      open: vt,
      items: x,
      selectionMode: u,
      listRef: _e,
      labelsRef: xe,
      popupRef: ge,
      emptyRef: me,
      inputRef: ae,
      startDismissRef: W,
      endDismissRef: Z,
      keyboardActiveRef: ie,
      chipsContainerRef: he,
      clearRef: Re,
      valuesRef: Be,
      pointerDownItemRef: nt,
      selectionEventRef: Ae,
      name: Wt,
      form: h,
      disabled: at,
      readOnly: g,
      required: m,
      grid: y,
      virtualized: D,
      openOnInputClick: E,
      itemToStringLabel: P,
      isItemEqualToValue: R,
      modal: L,
      autoHighlight: Le,
      submitOnItemClick: K,
      hasInputValue: Qt,
      mounted: !1,
      forceMounted: !1,
      transitionStatus: "idle",
      inline: k,
      activeIndex: null,
      selectedIndex: Me,
      popupProps: {},
      listProps: {},
      inputProps: {},
      triggerProps: {},
      itemProps: At,
      positionerElement: null,
      listElement: null,
      popupId: void 0,
      triggerElement: null,
      inputElement: null,
      inputGroupElement: null,
      popupSide: null,
      openMethod: null,
      inputInsidePopup: !0,
      // Avoid duplicate names in the server HTML. Popup inputs aren't rendered
      // until after hydration, so the hidden input takes over then if needed.
      inputOwnsFormValue: u === "none",
      // Placeholder callbacks replaced on first render
      onOpenChangeComplete: Nt,
      setOpen: Nt,
      setInputValue: Nt,
      setSelectedValue: Nt,
      setIndices: Nt,
      handleSelection: Nt,
      forceMount: Nt,
      requestSubmit: Nt
    });
  }).current, lt = u === "none" ? Rt : be, rt = b.useMemo(() => u === "none" ? lt : Array.isArray(be) ? be.map((Me) => Di(Me, I)) : Di(be, I), [lt, I, u, be]), Je = ye(d), Gt = ye(n), Ft = we(Se, Ce.activeIndex), zt = we(Se, Ce.selectedIndex), Mn = we(Se, Ce.positionerElement), Hn = we(Se, Ce.listElement), yr = we(Se, Ce.triggerElement), Pn = we(Se, Ce.inputElement), _O = we(Se, Ce.inputGroupElement), Dn = we(Se, Ce.inline), xr = we(Se, Ce.inputInsidePopup), SO = we(Se, Ce.inputOwnsFormValue), OO = rn(yr), {
    mounted: gm,
    setMounted: MO,
    transitionStatus: ld
  } = vs(vt), {
    openMethod: mm,
    triggerProps: cd
  } = lx(vt), TO = ye(() => rt);
  Bw(xr ? OO : ae, Q, lt, TO, !at, f);
  const bm = ye(() => {
    x ? xe.current = Ve.map((Me) => Tr(Me, P)) : Se.set("forceMounted", !0);
  }), _s = ye((Me, De, ft) => {
    if (De === -1) {
      if (Ue.current === Kd)
        return;
      Ue.current = Kd;
    } else
      Ue.current = {
        value: Me,
        index: De
      };
    Je(Me, cT(ft, void 0, {
      index: De
    }));
  }), wr = ye((Me) => {
    Se.update(Me);
    const De = Me.activeIndex;
    if (De === void 0)
      return;
    const ft = Me.type || Cn;
    De === null ? _s(void 0, -1, ft) : _s(Be.current[De], De, ft);
  }), Cr = ye((Me, De) => {
    var ft;
    if (oe.current = De.reason === Sr, (ft = e.onInputValueChange) == null || ft.call(e, Me, De), !De.isCanceled) {
      if (De.reason === qi) {
        vt && Ee !== null && se(null);
        const Pt = De.event, en = Pt.inputType;
        if (Pt.type === "compositionend" || en != null && en !== "" && en !== "insertReplacementText") {
          const tn = Me.trim() !== "";
          tn && le(!0), Ke.current = {
            hasQuery: tn
          };
          const yn = Se.state.listElement;
          if (!Se.state.virtualized && yn) {
            const Uo = ge.current;
            for (const tr of Xs(yn.firstElementChild ?? yn)) {
              if (!wt(tr) || (Uo ? !Ie(Uo, tr) : tr.getAttribute("role") === "dialog"))
                break;
              if ($A(tr)) {
                tr.scrollTop = 0;
                break;
              }
            }
          }
          tn && Le && Se.state.activeIndex == null && (vt || Dn) && Se.set("activeIndex", 0);
        }
      } else
        De.reason === Sr && Me === "" && Se.state.inputInsidePopup && (Ke.current = {
          hasQuery: !1,
          selection: !0
        });
      On(Me);
    }
  }), bi = ye((Me, De) => {
    var ft;
    if (vt !== Me && (De.reason === bs && Pe && Ve.length === 0 && !me.current && De.allowPropagation(), (ft = e.onOpenChange) == null || ft.call(e, Me, De), !De.isCanceled && (Me && xr && !Dn && Ee !== null && (le(!1), se(null), Rt !== "" && De.reason !== qi && Cr("", Ne(Sr, De.event))), !Me && fe && (Bt ? (Dn || se(vn), vn === "" && le(!1)) : Mt && (Dn || se(vn), xr && wr({
      activeIndex: null
    }), (!xr || Dn) && Cr("", Ne(Sr, De.event)))), er(Me), !Me && xr && (De.reason === Ro || De.reason === iu) && (X(!0), te(!1), J === "onBlur")))) {
      const Pt = u === "none" ? Rt : be;
      G.commit(Pt);
    }
  }), Ss = ye((Me, De) => {
    if (s == null || s(Me, De), De.isCanceled)
      return;
    Ye(Me), (u === "none" && ge.current && $ || Bt && !Se.state.inputInsidePopup) && Cr(Tr(Me, P), Ne(De.reason, De.event));
  }), RO = ye((Me, De) => {
    var tn;
    const ft = Ot(Me), Pt = Ae.current ?? Me;
    Ae.current = null;
    const en = Ne(Ra, Pt), dr = (tn = ft == null ? void 0 : ft.closest("a")) == null ? void 0 : tn.getAttribute("href");
    if (dr) {
      dr.startsWith("#") && bi(!1, en);
      return;
    }
    if (Mt) {
      const yn = Array.isArray(be) ? be : [], tr = TA(yn, De, R) ? RA(yn, De, R) : [...yn, De];
      if (Ss(tr, en), en.isCanceled || !(ae.current ? ae.current.value.trim() !== "" : !1))
        return;
      Se.state.inputInsidePopup ? Cr("", Ne(Sr, en.event)) : bi(!1, en);
    } else {
      if (Ss(De, en), en.isCanceled)
        return;
      bi(!1, en);
    }
  }), PO = ye(() => {
    var De, ft;
    const Me = ((De = G.inputRef.current) == null ? void 0 : De.form) ?? ((ft = Se.state.inputElement) == null ? void 0 : ft.form);
    Me && typeof Me.requestSubmit == "function" && Me.requestSubmit();
  }), ud = ye(() => {
    if (MO(!1), Gt == null || Gt(!1), le(!1), se(null), wr(u === "none" ? {
      activeIndex: null,
      selectedIndex: null
    } : {
      activeIndex: null
    }), Mt && ae.current && ae.current.value !== "" && !oe.current && Cr("", Ne(Sr)), Bt)
      if (Se.state.inputInsidePopup)
        ae.current && ae.current.value !== "" && Cr("", Ne(Sr));
      else {
        const Me = Tr(be, P);
        ae.current && ae.current.value !== Me && Cr(Me, Ne(Me === "" ? Sr : Cn));
      }
  }), IO = b.useMemo(() => Dn && Mn ? {
    current: Mn.closest('[role="dialog"]')
  } : ge, [Dn, Mn]);
  Jn({
    enabled: !e.actionsRef,
    open: vt,
    ref: IO,
    onComplete() {
      vt || ud();
    }
  }), b.useImperativeHandle(e.actionsRef, () => ({
    unmount: ud
  }), [ud]), pe(function() {
    if (vt || (nt.current = null, u === "none"))
      return;
    const De = Pe ? ue : Be.current;
    wr({
      selectedIndex: Gd(De, be, R, Mt)
    });
  }, [vt, be, u, Mt, Pe, ue, R, wr]), pe(() => {
    x && (Be.current = Ve, _e.current.length = Ve.length);
  }, [x, Ve]), pe(() => {
    var yn;
    const Me = Ke.current;
    if (Me) {
      const Uo = vt || Dn || ((yn = Se.state.positionerElement) == null ? void 0 : yn.hidden) === !1;
      if (Me.hasQuery)
        Le && Uo && Se.set("activeIndex", 0), Ke.current = null;
      else if (String(Rt).trim() === "" && (Ke.current = null, Uo)) {
        const tr = Me.selection;
        Le === "always" && !tr && Se.state.selectionMode === "none" && Se.set("activeIndex", 0), queueMicrotask(() => {
          if (!Se.state.open && !Se.state.inline || ae.current && ae.current.value.trim() !== "")
            return;
          const Br = Se.state.selectedValue, Cm = Se.state.selectionMode === "multiple", VO = Cm && Array.isArray(Br) ? Br[Br.length - 1] : Br, Em = Se.state.selectionMode !== "none" && VO != null;
          if (Em || tr) {
            const WO = Pe || Ge ? Ve : Be.current;
            Se.set("activeIndex", Em ? Gd(WO, Br, Se.state.isItemEqualToValue, Cm) : null);
          } else
            Le === "always" && Se.set("activeIndex", 0);
        });
      }
    }
    if (!vt && !Dn)
      return;
    const ft = Pe || Ge ? Ve : Be.current, Pt = Se.state.activeIndex;
    if (Pt == null) {
      if (Le === "always" && ft.length > 0) {
        Se.set("activeIndex", 0);
        return;
      }
      _s(void 0, -1, Cn);
      return;
    }
    if (Pt >= ft.length) {
      _s(void 0, -1, Cn), Se.set("activeIndex", null);
      return;
    }
    const en = ft[Pt], dr = Ue.current.value, tn = dr !== Gw && No(en, dr, Se.state.isItemEqualToValue);
    (Ue.current.index !== Pt || !tn) && _s(en, Pt, Cn);
  }, [
    Ft,
    Le,
    _s,
    Ge,
    Pe,
    Ve,
    Dn,
    vt,
    Se,
    // Reruns the effect when the query changes without affecting the deps above, such as
    // clearing the input when no items are filtered out (individually rendered items).
    Rt
  ]), pe(() => {
    if (u === "none") {
      H(String(Rt) !== "");
      return;
    }
    H(Mt ? Array.isArray(be) && be.length > 0 : be != null);
  }, [H, u, Rt, be, Mt]), b.useEffect(() => {
    Pe && Le && Ve.length === 0 && wr({
      activeIndex: null
    });
  }, [Pe, Le, Ve.length, wr]);
  function kO(Me) {
    const De = j.initialValue;
    return Array.isArray(Me) && Array.isArray(De) ? !FA(Me, De, (ft, Pt) => No(ft, Pt, R)) : Me !== De;
  }
  Ls(vn, () => {
    !vt || vn === "" || vn === String(je) || le(!0);
  });
  function vm() {
    const Me = Tr(be, P);
    Rt !== Me && Cr(Me, Ne(Cn));
  }
  Ls(be, () => {
    u !== "none" && (Y(Wt), U(kO(be)), G.change(be), Bt && !Qt && !xr && vm());
  }), Ls(Rt, () => {
    u === "none" && (Y(Wt), U(Rt !== j.initialValue), G.change(Rt));
  }), Ls(x, () => {
    !Bt || Qt || xr || fe || vm();
  });
  const el = nP({
    open: Dn ? !0 : vt,
    onOpenChange: bi,
    elements: {
      reference: xr ? yr : Pn,
      floating: Mn
    }
  }), ym = y ? "grid" : "listbox", tl = vt || Dn, xm = tl ? "true" : "false", nl = b.useMemo(() => {
    const Me = (Pn == null ? void 0 : Pn.tagName) === "INPUT", De = Pn == null || Me, ft = De || tl, Pt = De ? {
      autoComplete: "off",
      spellCheck: "false",
      autoCorrect: "off",
      autoCapitalize: "none"
    } : {};
    return ft && (Pt.role = "combobox", Pt["aria-expanded"] = xm, Pt["aria-haspopup"] = ym, Pt["aria-controls"] = tl ? Hn == null ? void 0 : Hn.id : void 0, Pt["aria-autocomplete"] = F), {
      reference: Pt,
      floating: {
        role: "presentation"
      }
    };
  }, [Pn, tl, xm, ym, Hn == null ? void 0 : Hn.id, F]), wm = li(el, {
    enabled: !g && !at && E,
    event: "mousedown-only",
    toggle: !1,
    // Apply a small delay for touch to let mobile viewport/keyboard positioning settle.
    // This avoids top-bottom flip flickers if the preferred position is "top" when first tapping.
    touchOpenDelay: xr ? 0 : 100,
    reason: r1
  }), rl = Da(el, {
    enabled: !g && !at && !Dn,
    outsidePressEvent: {
      mouse: "sloppy",
      // The visual viewport (affected by the mobile software keyboard) can be
      // somewhat small. The user may want to scroll the screen to see more of
      // the popup.
      touch: "intentional"
    },
    // Without a popup, let the Escape key bubble the event up to other popups' handlers.
    bubbles: Dn ? !0 : void 0,
    outsidePress(Me) {
      const De = Ot(Me);
      return !Ie(yr, De) && !Ie(Re.current, De) && !Ie(he.current, De) && !Ie(_O, De);
    }
  }), Os = Y1(el, {
    enabled: !g && !at,
    id: Q,
    listRef: _e,
    activeIndex: Ft,
    selectedIndex: zt,
    virtual: !0,
    loopFocus: T,
    allowEscape: T && !Le,
    focusItemOnOpen: fe || u === "none" && !Le ? !1 : "auto",
    focusItemOnHover: M,
    resetOnPointerLeave: !O,
    orientation: y ? "horizontal" : void 0,
    rtl: ne === "rtl",
    disabledIndices: Gn,
    grid: y ? SA : void 0,
    onNavigate(Me, De) {
      !De && !vt || ld === "ending" || wr(De ? {
        activeIndex: Me,
        type: ie.current ? o1 : s1
      } : {
        activeIndex: Me
      });
    }
  }), dd = b.useMemo(() => _n(Os.reference, {
    onKeyDown(Me) {
      y && Se.state.activeIndex == null && (Me.key === "ArrowLeft" || Me.key === "ArrowRight") && Me.preventBaseUIHandler();
    }
  }, rl.reference, wm.reference, nl.reference), [Os.reference, rl.reference, wm.reference, nl.reference, y, Se]), fd = b.useMemo(() => _n(Na, rl.floating), [rl.floating]), hd = b.useMemo(() => _n(Os.floating, nl.floating), [Os.floating, nl.floating]), pd = b.useMemo(() => {
    const Me = Os.item;
    return Me ? {
      ...Me,
      onFocus: void 0
    } : At;
  }, [Os.item]);
  _A(() => {
    Se.update({
      inline: k,
      popupProps: fd,
      listProps: hd,
      inputProps: dd,
      triggerProps: cd,
      itemProps: pd,
      setOpen: bi,
      setInputValue: Cr,
      setSelectedValue: Ss,
      setIndices: wr,
      handleSelection: RO,
      forceMount: bm,
      requestSubmit: PO,
      onOpenChangeComplete: Gt
    });
  }), pe(() => {
    Se.update({
      id: Q,
      selectedValue: be,
      open: vt,
      mounted: gm,
      transitionStatus: ld,
      items: x,
      inline: k,
      popupProps: fd,
      listProps: hd,
      inputProps: dd,
      triggerProps: cd,
      openMethod: mm,
      itemProps: pd,
      selectionMode: u,
      name: Wt,
      form: h,
      disabled: at,
      readOnly: g,
      required: m,
      grid: y,
      virtualized: D,
      openOnInputClick: E,
      itemToStringLabel: P,
      modal: L,
      autoHighlight: Le,
      isItemEqualToValue: R,
      submitOnItemClick: K,
      hasInputValue: Qt,
      inputOwnsFormValue: u === "none" && (k || !Se.state.inputInsidePopup)
    });
  }, [Se, Q, be, vt, gm, ld, x, fd, hd, dd, pd, mm, cd, u, Wt, at, g, m, y, D, E, P, L, R, K, Qt, k, Le, h]);
  const DO = ar(v, G.inputRef), NO = b.useMemo(() => ({
    query: vn,
    hasItems: Pe,
    filteredItems: Te,
    flatFilteredItems: Ve
  }), [vn, Pe, Te, Ve]), AO = b.useMemo(() => Array.isArray(lt) ? "" : Di(lt, I), [lt, I]), $O = Mt && Array.isArray(be) && be.length > 0, gd = Mt || u === "none" && SO ? void 0 : Wt, FO = b.useMemo(() => !Mt || !Array.isArray(be) || !Wt ? null : be.map((Me) => {
    const De = Di(Me, I);
    return /* @__PURE__ */ _("input", {
      type: "hidden",
      form: h,
      name: Wt,
      value: De,
      disabled: at
    }, De);
  }), [Mt, be, h, Wt, I, at]), LO = /* @__PURE__ */ ee(b.Fragment, {
    children: [e.children, /* @__PURE__ */ _("input", {
      ...G.getValidationProps(at, {
        // Move focus when the hidden input is focused.
        onFocus() {
          var Me;
          if (xr) {
            yr == null || yr.focus();
            return;
          }
          (Me = ae.current || yr) == null || Me.focus();
        },
        // Handle browser autofill.
        onChange(Me) {
          if (Me.nativeEvent.defaultPrevented || at || g)
            return;
          const De = Me.currentTarget.value, ft = De.toLowerCase(), Pt = Ne(Cn, Me.nativeEvent), en = () => Be.current.findIndex((tn) => Di(tn, I).toLowerCase() === ft || Tr(tn, P).toLowerCase() === ft);
          function dr() {
            if (Mt)
              return;
            if (u === "none") {
              Cr(De, Pt);
              return;
            }
            let tn = en();
            tn === -1 && (tn = Be.current.findIndex((Uo, tr) => {
              const Br = xe.current[tr];
              return Br != null && Br.toLowerCase() === ft;
            }));
            const yn = tn === -1 ? void 0 : Be.current[tn];
            yn != null && (Ss == null || Ss(yn, Pt));
          }
          Bt && (bm(), x && en() === -1 && Se.set("forceMounted", !0)), queueMicrotask(dr);
        }
      }),
      id: Q && gd == null ? `${Q}-hidden-input` : void 0,
      form: h,
      name: gd,
      autoComplete: N,
      disabled: at,
      required: m && !$O,
      readOnly: g,
      value: AO,
      ref: DO,
      style: gd ? zh : Pa,
      tabIndex: -1,
      "aria-hidden": !0,
      suppressHydrationWarning: !0
    }), FO]
  });
  return /* @__PURE__ */ _(Zp.Provider, {
    value: Se,
    children: /* @__PURE__ */ _(Qp.Provider, {
      value: el,
      children: /* @__PURE__ */ _(eg.Provider, {
        value: Pe,
        children: /* @__PURE__ */ _(Jp.Provider, {
          value: NO,
          children: /* @__PURE__ */ _(tg.Provider, {
            value: Rt,
            children: LO
          })
        })
      })
    })
  });
}
const sg = {
  ...wc,
  ...Ww,
  popupSide: (e) => e ? {
    "data-popup-side": e
  } : null,
  listEmpty: (e) => e ? {
    "data-list-empty": ""
  } : null
}, kl = 5;
function Kw(e, t) {
  const n = VA(t);
  return e.clientX >= n.left - kl && e.clientX <= n.right + kl && e.clientY >= n.top - kl && e.clientY <= n.bottom + kl;
}
function VA(e) {
  const t = e.getBoundingClientRect(), n = Ht(e);
  if (Ah)
    return t;
  const r = n.getComputedStyle(e, "::before"), o = n.getComputedStyle(e, "::after");
  if (!(r.content !== "none" || o.content !== "none"))
    return t;
  const i = parseFloat(r.width) || 0, a = parseFloat(r.height) || 0, l = parseFloat(o.width) || 0, c = parseFloat(o.height) || 0, u = Math.max(t.width, i, l), d = Math.max(t.height, a, c), f = u - t.width, h = d - t.height;
  return {
    left: t.left - f / 2,
    right: t.right + f / 2,
    top: t.top - h / 2,
    bottom: t.bottom + h / 2
  };
}
function WA(e, t) {
  return e ?? t;
}
function ig(e) {
  const t = we(e, Ce.mounted), n = we(e, Ce.popupSide), r = we(e, Ce.positionerElement);
  return t && r ? n : null;
}
function ja() {
  return fi().filteredItems.length === 0;
}
function HA(e) {
  return e === "rtl" ? ["ArrowRight", "ArrowLeft"] : ["ArrowLeft", "ArrowRight"];
}
function BA(e, t) {
  const n = e >= t - 1 ? t - 2 : e;
  return n >= 0 ? n : void 0;
}
function qw(e, t, n) {
  const r = e.state.listRef.current[t];
  r && (e.state.selectionEventRef.current = n, r.click(), e.state.selectionEventRef.current = null);
}
const lh = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    nativeButton: s = !0,
    disabled: i = !1,
    id: a,
    style: l,
    ...c
  } = t, {
    state: u,
    disabled: d,
    setTouched: f,
    setFocused: h,
    validationMode: p,
    validation: g
  } = hi(), {
    labelId: m
  } = ju(), v = ur(), y = we(v, Ce.selectionMode), x = we(v, Ce.disabled), C = we(v, Ce.readOnly), w = we(v, Ce.required), E = we(v, Ce.positionerElement), S = we(v, Ce.listElement), O = we(v, Ce.popupId), M = we(v, Ce.triggerProps), T = we(v, Ce.inputInsidePopup), P = we(v, Ce.id), I = we(v, Ce.labelId), R = we(v, Ce.open), D = we(v, Ce.selectedValue), k = we(v, Ce.activeIndex), $ = we(v, Ce.selectedIndex), L = we(v, Ce.hasSelectedValue), A = Yu(), F = $w(), N = Sn(), V = d || x || i, K = ja(), Y = ig(v);
  rg({
    id: T ? a : void 0
  });
  const U = T ? a ?? P : a, j = WA(m, I);
  let H;
  R && T ? H = O ?? Uw(P) : R && (H = S == null ? void 0 : S.id);
  const q = b.useRef("");
  function B(fe) {
    q.current = fe.pointerType;
  }
  const {
    reference: X
  } = j1(A, {
    enabled: !R && !C && !x && y === "single",
    listRef: v.state.labelsRef,
    activeIndex: k,
    selectedIndex: $,
    onMatch(fe) {
      const le = v.state.valuesRef.current[fe];
      le !== void 0 && v.state.setSelectedValue(le, Ne(Cn));
    }
  }), {
    reference: te
  } = li(A, {
    enabled: !C && !x,
    event: "mousedown"
  }), {
    buttonRef: J,
    getButtonProps: G
  } = Wn({
    native: s,
    disabled: V
  }), ne = {
    ...u,
    open: R,
    disabled: V,
    popupSide: Y,
    listEmpty: K,
    placeholder: y === "none" ? !1 : !L
  }, Q = ye((fe) => {
    v.set("triggerElement", fe);
  });
  return We("button", t, {
    ref: [n, J, Q],
    state: ne,
    props: [M, te, X, {
      id: U,
      tabIndex: T ? 0 : -1,
      role: T ? "combobox" : void 0,
      "aria-expanded": R,
      "aria-haspopup": T ? "dialog" : "listbox",
      "aria-controls": H,
      "aria-required": T && w || void 0,
      "aria-labelledby": j,
      onPointerDown: B,
      onPointerEnter: B,
      onFocus() {
        h(!0), !(V || C) && N.start(0, v.state.forceMount);
      },
      onBlur(fe) {
        if (!Ie(E, fe.relatedTarget) && (f(!0), h(!1), p === "onBlur")) {
          const le = y === "none" ? F : D;
          g.commit(le);
        }
      },
      onMouseDown(fe) {
        var se;
        if (V || C || (T || A.set("domReferenceElement", fe.currentTarget), v.state.forceMount(), q.current !== "touch" && ((se = v.state.inputRef.current) == null || se.focus(), T || fe.preventDefault()), R))
          return;
        const le = Ze(fe.currentTarget);
        function Ee(_e) {
          const xe = v.state.triggerElement;
          if (!xe)
            return;
          const ge = Ot(_e), ae = v.state.positionerElement, W = v.state.listElement;
          Ie(xe, ge) || Ie(ae, ge) || Ie(W, ge) || Kw(_e, xe) || v.state.setOpen(!1, Ne(i1, _e));
        }
        T && le.addEventListener("mouseup", Ee, {
          once: !0
        });
      },
      onKeyDown(fe) {
        var le;
        C || (fe.key === "ArrowDown" || fe.key === "ArrowUp") && (wn(fe), v.state.setOpen(!0, Ne(la, fe.nativeEvent)), (le = v.state.inputRef.current) == null || le.focus());
      }
    }, g.getValidationProps(V, c), G],
    stateAttributesMapping: sg
  });
});
process.env.NODE_ENV !== "production" && (lh.displayName = "ComboboxTrigger");
const Xw = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Xw.displayName = "ComboboxChipsContext");
function zA() {
  return b.useContext(Xw);
}
const ag = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (ag.displayName = "ComboboxPositionerContext");
function lg(e) {
  const t = b.useContext(ag);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Combobox.Popup> and <Combobox.Arrow> must be used within the <Combobox.Positioner> component" : tt(21));
  return t;
}
const cg = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const r = ur(), {
    buttonRef: o,
    getButtonProps: s
  } = Wn({
    native: !1
  }), i = ar(n, o);
  function a(c) {
    r.state.setOpen(!1, Ne(Hh, c.nativeEvent, c.currentTarget));
  }
  const l = s({
    onClick: a
  });
  return /* @__PURE__ */ _("span", {
    ref: i,
    ...l,
    "aria-label": "Dismiss",
    tabIndex: void 0,
    style: zh
  });
});
process.env.NODE_ENV !== "production" && (cg.displayName = "ComboboxInternalDismissButton");
const ug = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    disabled: s = !1,
    id: i,
    style: a,
    ...l
  } = t, {
    state: c,
    disabled: u,
    setTouched: d,
    setFocused: f,
    validationMode: h,
    validation: p
  } = hi(), {
    labelId: g
  } = ju(), m = zA(), y = !!lg(!0), x = ur(), C = $w(), w = Fa(), E = we(x, Ce.required), S = we(x, Ce.disabled), O = we(x, Ce.readOnly), M = we(x, Ce.name), T = we(x, Ce.form), P = we(x, Ce.selectionMode), I = we(x, Ce.autoHighlight), R = we(x, Ce.inputProps), D = we(x, Ce.triggerProps), k = we(x, Ce.open), $ = we(x, Ce.mounted), L = we(x, Ce.selectedValue), A = we(x, Ce.id), F = we(x, Ce.inline), N = we(x, Ce.modal), V = !!I, K = ig(x), Y = u || S || s, U = ja(), j = y || F, H = !j || N, q = gn(i ?? (j ? void 0 : A)), B = y ? Vw : c, [X, te] = b.useState(null), J = b.useRef(!1), G = b.useRef(null), ne = b.useRef(!1), Q = P === "none" && !y, re = ye((ae) => {
    const W = y || x.state.inline;
    W && !x.state.hasInputValue && x.state.setInputValue("", Ne(Cn)), x.update({
      inputElement: ae,
      inputInsidePopup: W,
      inputOwnsFormValue: Q
    });
  }), fe = y ? l : p.getValidationProps(Y, l);
  function le() {
    x.state.setIndices({
      activeIndex: null,
      selectedIndex: null,
      type: x.state.keyboardActiveRef.current ? o1 : s1
    });
  }
  function Ee() {
    x.state.keyboardActiveRef.current = !1;
  }
  const se = {
    ...B,
    open: k,
    disabled: Y,
    readOnly: O,
    popupSide: K,
    listEmpty: U
  };
  function _e(ae) {
    if (!m)
      return;
    let W;
    const {
      highlightedChipIndex: Z
    } = m, me = m.chipsRef.current.length, [ie, oe] = HA(w);
    return Z !== void 0 ? (ae.key === ie ? (ae.preventDefault(), Z > 0 ? W = Z - 1 : W = void 0) : ae.key === oe ? (ae.preventDefault(), Z < me - 1 ? W = Z + 1 : W = void 0) : (ae.key === "Backspace" || ae.key === "Delete") && (ae.preventDefault(), W = BA(Z, L.length), le()), W) : (ae.key === ie && (ae.currentTarget.selectionStart ?? 0) === 0 && L.length > 0 && (ae.preventDefault(), W = me > 0 ? me - 1 : void 0), W);
  }
  const xe = We("input", t, {
    state: se,
    ref: [n, x.state.inputRef, re],
    props: [R, D, {
      value: X ?? C,
      "aria-readonly": O || void 0,
      "aria-required": E || void 0,
      "aria-labelledby": g,
      disabled: Y,
      readOnly: O,
      required: P === "none" ? E : void 0,
      form: T,
      ...Q && M && {
        name: M
      },
      id: q,
      onFocus() {
        if (f(!0), !F || !ne.current)
          return;
        ne.current = !1;
        const ae = G.current;
        ae == null || // `valuesRef` can be sparse, so guard against restoring a removed slot.
        !Object.hasOwn(x.state.valuesRef.current, ae) || x.state.setIndices({
          activeIndex: ae
        });
      },
      onBlur() {
        d(!0), f(!1);
        const ae = x.state.activeIndex;
        if (F && ae !== null && I !== "always" && (G.current = ae, ne.current = !0, x.state.setIndices({
          activeIndex: null
        })), h === "onBlur") {
          const W = P === "none" ? C : L;
          p.commit(W);
        }
      },
      onCompositionStart(ae) {
        dc || (J.current = !0, te(ae.currentTarget.value));
      },
      onCompositionEnd(ae) {
        J.current = !1;
        const W = ae.currentTarget.value;
        te(null), x.state.setInputValue(W, Ne(qi, ae.nativeEvent));
      },
      onChange(ae) {
        const W = ae.nativeEvent, Z = W.inputType, me = !Z || Z === "insertReplacementText", ie = J.current || !me;
        function oe(Ue) {
          O || Y || !Ue || !ie || (x.state.setOpen(!0, Ne(qi, W)), V || le());
        }
        if (J.current) {
          const Ue = ae.currentTarget.value;
          te(Ue), Ue === "" && !x.state.openOnInputClick && !x.state.inputInsidePopup && x.state.setOpen(!1, Ne(Sr, W));
          const Ke = Ue.trim(), Be = V && Ke !== "";
          oe(Ke), k && x.state.activeIndex !== null && !Be && le();
          return;
        }
        const he = Ne(qi, W);
        if (x.state.setInputValue(ae.currentTarget.value, he), he.isCanceled)
          return;
        const Re = ae.currentTarget.value === "", Ae = Ne(Sr, W);
        Re && !x.state.inputInsidePopup && (P === "single" && x.state.setSelectedValue(null, Ae), x.state.openOnInputClick || x.state.setOpen(!1, Ae)), oe(ae.currentTarget.value.trim()), k && x.state.activeIndex !== null && !V && le();
      },
      onKeyDown(ae) {
        var he, Re;
        if (Y || O || ae.ctrlKey || ae.shiftKey || ae.altKey || ae.metaKey)
          return;
        x.state.keyboardActiveRef.current = !0;
        const W = ae.currentTarget, Z = W.scrollWidth - W.clientWidth, me = w === "rtl";
        if (ae.key === "Home") {
          wn(ae);
          const Ae = Nm && me ? W.value.length : 0;
          W.setSelectionRange(Ae, Ae), W.scrollLeft = 0;
          return;
        }
        if (ae.key === "End") {
          wn(ae);
          const Ae = Nm && me ? 0 : W.value.length;
          W.setSelectionRange(Ae, Ae), W.scrollLeft = me ? -Z : Z;
          return;
        }
        if (!$ && ae.key === "Escape") {
          const Ae = P === "multiple" && Array.isArray(L) ? L.length === 0 : L === null, Ue = Ne(bs, ae.nativeEvent), Ke = P === "multiple" ? [] : null;
          x.state.setInputValue("", Ue), x.state.setSelectedValue(Ke, Ue), !Ae && !x.state.inline && !Ue.isPropagationAllowed && ae.stopPropagation();
          return;
        }
        if (m && ae.key === "Backspace" && W.value === "" && m.highlightedChipIndex === void 0 && Array.isArray(L) && L.length > 0) {
          const Ae = m.chipsRef.current.length, Ue = Ae > 0 ? Ae - 1 : L.length - 1, Ke = L.filter((Be, nt) => nt !== Ue);
          le(), x.state.setSelectedValue(Ke, Ne(Cn, ae.nativeEvent));
          return;
        }
        const ie = (m == null ? void 0 : m.highlightedChipIndex) !== void 0, oe = _e(ae);
        if (m == null || m.setHighlightedChipIndex(oe), oe !== void 0 ? (he = m == null ? void 0 : m.chipsRef.current[oe]) == null || he.focus() : ie && ((Re = x.state.inputRef.current) == null || Re.focus()), ae.which !== 229 && ae.key === "Enter" && k) {
          const Ae = x.state.activeIndex, Ue = ae.nativeEvent;
          if (Ae === null) {
            if (F)
              return;
            x.state.setOpen(!1, Ne(Cn, Ue));
            return;
          }
          wn(ae), qw(x, Ae, Ue);
        }
      },
      onPointerMove: Ee,
      onPointerDown: Ee
    }, fe],
    stateAttributesMapping: sg
  }), ge = y ? /* @__PURE__ */ _(ng.Provider, {
    value: Hw,
    children: xe
  }) : xe;
  return /* @__PURE__ */ ee(b.Fragment, {
    children: [k && H && /* @__PURE__ */ _(cg, {
      ref: x.state.startDismissRef
    }), ge]
  });
});
process.env.NODE_ENV !== "production" && (ug.displayName = "ComboboxInput");
function YA(e, t, n, r, o) {
  var a;
  if (e.baseUIHandlerPrevented || r)
    return;
  const s = Ot(e.nativeEvent), i = Qe(s) ? s : null;
  i !== e.currentTarget && (o != null && o(i) || t1(i)) || (e.preventDefault(), !n && ((a = t.state.inputRef.current) == null || a.focus(), t.state.openOnInputClick && t.state.setOpen(!0, Ne(r1, e.nativeEvent))));
}
const Zw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, {
    state: a
  } = hi(), l = ur(), c = we(l, Ce.open), u = we(l, Ce.disabled), d = we(l, Ce.readOnly), f = we(l, Ce.hasSelectedValue), h = we(l, Ce.selectionMode), p = ig(l), g = u, m = ja(), y = {
    ...a,
    open: c,
    disabled: g,
    readOnly: d,
    popupSide: p,
    listEmpty: m,
    placeholder: h === "none" ? !1 : !f
  }, x = ye((C) => {
    l.set("inputGroupElement", C);
  });
  return We("div", t, {
    ref: [n, x],
    props: [{
      role: "group",
      onMouseDown(C) {
        YA(C, l, g, d, (w) => Ie(l.state.chipsContainerRef.current, w));
      }
    }, i],
    state: y,
    stateAttributesMapping: sg
  });
});
process.env.NODE_ENV !== "production" && (Zw.displayName = "ComboboxInputGroup");
const ch = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t;
  return We("span", t, {
    ref: n,
    props: [{
      "aria-hidden": !0,
      children: "▼"
    }, i]
  });
});
process.env.NODE_ENV !== "production" && (ch.displayName = "ComboboxIcon");
const Qw = /* @__PURE__ */ b.createContext(null);
process.env.NODE_ENV !== "production" && (Qw.displayName = "GroupCollectionContext");
function jA() {
  return b.useContext(Qw);
}
function UA(e) {
  const {
    children: t
  } = e, {
    filteredItems: n
  } = fi(), r = jA(), o = r ? r.items : n;
  return /* @__PURE__ */ _(b.Fragment, {
    children: o.map(t)
  });
}
const Jw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  var r;
  const {
    render: o,
    className: s,
    style: i,
    children: a,
    ...l
  } = t, c = ur(), u = Yu(), d = !!lg(!0), {
    filteredItems: f,
    hasItems: h
  } = fi(), p = we(c, Ce.selectionMode), g = we(c, Ce.grid), m = we(c, Ce.listProps), v = we(c, Ce.virtualized), y = we(c, Ce.forceMounted), x = p === "multiple", C = f.length === 0, w = ye((I) => {
    c.set("positionerElement", I);
  }), E = ye((I) => {
    c.set("listElement", I);
  }), S = b.useMemo(() => typeof a == "function" ? r || (r = /* @__PURE__ */ _(UA, {
    children: a
  })) : a, [a]), O = {
    empty: C
  }, M = u.useState("floatingId"), T = We("div", t, {
    state: O,
    ref: [n, E, d ? null : w],
    props: [m, {
      children: S,
      tabIndex: -1,
      id: M,
      role: g ? "grid" : "listbox",
      "aria-multiselectable": x ? "true" : void 0,
      onKeyDown(I) {
        if (!(c.state.disabled || c.state.readOnly) && I.key === "Enter") {
          const R = c.state.activeIndex;
          if (R == null)
            return;
          wn(I), qw(c, R, I.nativeEvent);
        }
      },
      onKeyDownCapture() {
        c.state.keyboardActiveRef.current = !0;
      },
      onPointerMoveCapture() {
        c.state.keyboardActiveRef.current = !1;
      }
    }, l]
  });
  if (v)
    return T;
  const P = h && !y ? void 0 : c.state.labelsRef;
  return /* @__PURE__ */ _(zu, {
    elementsRef: c.state.listRef,
    labelsRef: P,
    children: T
  });
});
process.env.NODE_ENV !== "production" && (Jw.displayName = "ComboboxList");
const GA = "⁠", KA = 200;
function qA(e) {
  const t = e.ownerDocument.createTreeWalker(e, NodeFilter.SHOW_TEXT);
  let n = null;
  for (; t.nextNode(); ) {
    const r = t.currentNode;
    r.nodeValue !== "" && (n = r);
  }
  return n;
}
function XA() {
  const e = Sn(), t = b.useRef(null);
  return b.useEffect(() => {
    if (Ma)
      return;
    const n = t.current;
    if (n == null)
      return;
    const r = qA(n);
    if (r == null)
      return;
    const o = r.data, s = `${o}${GA}`;
    return r.nodeValue = s, e.start(KA, () => {
      r.nodeValue === s && (r.nodeValue = o);
    }), () => {
      e.clear(), r.nodeValue === s && (r.nodeValue = o);
    };
  }, [t, e]), t;
}
const dg = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (dg.displayName = "ComboboxPortalContext");
function ZA() {
  const e = b.useContext(dg);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Combobox.Portal> is missing." : tt(20));
  return e;
}
const eC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    keepMounted: r = !1,
    ...o
  } = t, s = ur(), i = we(s, Ce.mounted), a = we(s, Ce.forceMounted);
  return i || r || a ? /* @__PURE__ */ _(dg.Provider, {
    value: r,
    children: /* @__PURE__ */ _(ka, {
      ref: n,
      ...o
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (eC.displayName = "ComboboxPortal");
const QA = 20;
function fg(e, t, n, r) {
  const [o, s] = b.useState(!1);
  pe(() => {
    if (!e || !t || n == null) {
      s(!1);
      return;
    }
    const i = Ze(n).documentElement.clientWidth, a = n.offsetWidth;
    s(i > 0 && a > 0 && a >= i - QA);
  }, [e, t, n]), ix(e && (!t || o), r);
}
const tC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    anchor: s,
    // `useAnchorPositioning` applies the same defaults to the undefined values; the names
    // remain destructured to exclude the props from `elementProps`.
    positionMethod: i,
    side: a,
    align: l,
    sideOffset: c,
    alignOffset: u,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f,
    arrowPadding: h,
    sticky: p,
    disableAnchorTracking: g = !1,
    collisionAvoidance: m = E1,
    style: v,
    ...y
  } = t, x = ur(), C = Yu(), w = ZA(), E = we(x, Ce.modal), S = we(x, Ce.open), O = we(x, Ce.mounted), M = we(x, Ce.openMethod), T = we(x, Ce.positionerElement), P = we(x, Ce.triggerElement), I = we(x, Ce.inputElement), R = we(x, Ce.inputGroupElement), D = we(x, Ce.inputInsidePopup), k = we(x, Ce.transitionStatus), $ = ja(), A = Mu({
    anchor: s ?? (D ? P : R ?? I),
    floatingRootContext: C,
    positionMethod: i,
    mounted: O,
    side: a,
    sideOffset: c,
    align: l,
    alignOffset: u,
    arrowPadding: h,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: p,
    disableAnchorTracking: g,
    keepMounted: w,
    collisionAvoidance: m,
    lazyFlip: !0
  });
  fg(S && E, M === "touch", T, P);
  const F = {
    open: S,
    side: A.side,
    align: A.align,
    anchorHidden: A.anchorHidden,
    empty: $
  };
  pe(() => {
    x.set("popupSide", A.side);
  }, [x, A.side]);
  const N = ye((K) => {
    x.set("positionerElement", K);
  }), V = Tu(t, F, {
    styles: A.positionerStyles,
    transitionStatus: k,
    props: y,
    refs: [n, N],
    hidden: !O,
    inert: !S
  });
  return /* @__PURE__ */ ee(ag.Provider, {
    value: A,
    children: [O && E && /* @__PURE__ */ _(Va, {
      inert: di(!S),
      cutout: R ?? I ?? P
    }), V]
  });
});
process.env.NODE_ENV !== "production" && (tC.displayName = "ComboboxPositioner");
const JA = {
  ...Aa,
  ...co
}, nC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    initialFocus: i,
    finalFocus: a,
    ...l
  } = t, c = ur(), u = lg(), d = Yu(), f = we(c, Ce.mounted), h = we(c, Ce.open), p = we(c, Ce.openMethod), g = we(c, Ce.popupProps), m = we(c, Ce.transitionStatus), v = we(c, Ce.inputInsidePopup), y = we(c, Ce.inputElement), x = we(c, Ce.modal), C = we(c, Ce.id), w = ja(), E = l.id ?? (v ? Uw(C) : void 0);
  pe(() => {
    var R;
    return c.set("popupId", ((R = c.state.popupRef.current) == null ? void 0 : R.id) || E), () => {
      c.set("popupId", void 0);
    };
  }, [c, E]), Jn({
    open: h,
    ref: c.state.popupRef,
    onComplete() {
      h && c.state.onOpenChangeComplete(!0);
    }
  });
  const S = {
    open: h,
    side: u.side,
    align: u.align,
    anchorHidden: u.anchorHidden,
    transitionStatus: m,
    empty: w
  }, O = We("div", t, {
    state: S,
    ref: [n, c.state.popupRef],
    props: [g, {
      id: E,
      role: v ? "dialog" : "presentation",
      onFocus(R) {
        var k;
        const D = Ot(R.nativeEvent);
        p !== "touch" && (Ie(c.state.listElement, D) || D === R.currentTarget) && ((k = c.state.inputRef.current) == null || k.focus());
      }
    }, La(m), l],
    stateAttributesMapping: JA
  }), T = i === void 0 ? v ? (R) => R === "touch" ? c.state.popupRef.current : y : !1 : i;
  let P;
  a != null ? P = a : P = v ? void 0 : !1;
  const I = !v || x;
  return /* @__PURE__ */ _(cu, {
    context: d,
    disabled: !f,
    modal: I,
    openInteractionType: p,
    initialFocus: T,
    returnFocus: P,
    getInsideElements: () => [c.state.startDismissRef.current, c.state.endDismissRef.current],
    children: /* @__PURE__ */ ee(b.Fragment, {
      children: [O, I && /* @__PURE__ */ _(cg, {
        ref: c.state.endDismissRef
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (nC.displayName = "ComboboxPopup");
const hg = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (hg.displayName = "ComboboxItemContext");
function rC() {
  const e = b.useContext(hg);
  if (!e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxItemContext is missing. ComboboxItem parts must be placed within <Combobox.Item>." : tt(19));
  return e;
}
const oC = /* @__PURE__ */ b.createContext(!1);
process.env.NODE_ENV !== "production" && (oC.displayName = "ComboboxRowContext");
function e4() {
  return b.useContext(oC);
}
function sC(e) {
  const {
    componentProps: t,
    forwardedRef: n,
    virtualized: r,
    indexFromFilter: o
  } = e, {
    render: s,
    className: i,
    style: a,
    value: l = null,
    index: c,
    disabled: u = !1,
    nativeButton: d = !1,
    ...f
  } = t, h = b.useRef(null), p = Es({
    guess: !0,
    index: c,
    textRef: h
  }), g = ur(), m = e4(), v = OA(), y = we(g, Ce.selectionMode), x = we(g, Ce.disabled), C = we(g, Ce.readOnly), w = we(g, Ce.isItemEqualToValue), E = x || u, S = y !== "none", O = c ?? o ?? p.index, M = O !== -1, T = we(g, Ce.id), P = we(g, Ce.isActive, O), I = we(g, Ce.isSelected, l), R = we(g, Ce.itemProps), D = b.useRef(null), k = T != null && M ? `${T}-${O}` : void 0, $ = I && S;
  pe(() => {
    if (!(M && (r || c != null)))
      return;
    const j = g.state.listRef.current;
    return j[O] = D.current, () => {
      delete j[O];
    };
  }, [M, r, O, c, g]), pe(() => {
    if (!M || v)
      return;
    const U = g.state.valuesRef.current;
    return U[O] = l, () => {
      delete U[O];
    };
  }, [M, v, O, l, g]), pe(() => {
    if (!M || v)
      return;
    const U = g.state.selectedValue, j = Array.isArray(U) ? U[U.length - 1] : U;
    No(l, j, w) && g.set("selectedIndex", O);
  }, [M, v, g, O, l, w]);
  const {
    getButtonProps: L,
    buttonRef: A
  } = Wn({
    disabled: E,
    focusableWhenDisabled: !0,
    native: d,
    composite: !0
  }), F = {
    disabled: E,
    selected: $,
    highlighted: P
  };
  function N(U) {
    function j() {
      g.state.handleSelection(U, l);
    }
    g.state.submitOnItemClick ? (Xn.flushSync(j), g.state.requestSubmit()) : j();
  }
  const V = {
    id: k,
    role: m ? "gridcell" : "option",
    "aria-selected": S ? $ : void 0,
    // Focusable items steal focus from the input upon mouseup.
    // Warn if the user renders a natively focusable element like `<button>`,
    // as it should be a `<div>` instead.
    tabIndex: void 0,
    onPointerDownCapture(U) {
      U.isPrimary && (g.state.pointerDownItemRef.current = U.currentTarget), U.preventDefault();
    },
    onMouseDown(U) {
      U.preventDefault();
    },
    onClick(U) {
      E || C || N(U.nativeEvent);
    },
    onMouseUp(U) {
      const j = g.state.pointerDownItemRef.current === U.currentTarget;
      g.state.pointerDownItemRef.current = null, !(E || C || U.button !== 0 || j || !P) && N(U.nativeEvent);
    }
  }, K = We("div", t, {
    ref: [A, n, p.ref, D],
    state: F,
    props: [R, V, f, L]
  }), Y = b.useMemo(() => ({
    selected: $,
    textRef: h
  }), [$, h]);
  return /* @__PURE__ */ _(hg.Provider, {
    value: Y,
    children: K
  });
}
function t4(e) {
  const {
    componentProps: t,
    forwardedRef: n
  } = e, r = ur(), o = we(r, Ce.isItemEqualToValue), {
    flatFilteredItems: s
  } = fi(), i = Fw(s, t.value ?? null, o);
  return /* @__PURE__ */ _(sC, {
    componentProps: t,
    forwardedRef: n,
    virtualized: !0,
    indexFromFilter: i
  });
}
const iC = /* @__PURE__ */ b.memo(/* @__PURE__ */ b.forwardRef(function(t, n) {
  const r = ur(), o = we(r, Ce.virtualized);
  return o && t.index == null ? /* @__PURE__ */ _(t4, {
    componentProps: t,
    forwardedRef: n
  }) : /* @__PURE__ */ _(sC, {
    componentProps: t,
    forwardedRef: n,
    virtualized: o,
    indexFromFilter: void 0
  });
}));
process.env.NODE_ENV !== "production" && (iC.displayName = "ComboboxItem");
const aC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    children: i,
    ...a
  } = t, {
    filteredItems: l
  } = fi(), c = ur(), u = XA(), d = l.length === 0 ? i : null;
  return We("div", t, {
    ref: [n, c.state.emptyRef, u],
    props: [{
      children: d,
      role: "status",
      "aria-live": "polite",
      "aria-atomic": !0
    }, a]
  });
});
process.env.NODE_ENV !== "production" && (aC.displayName = "ComboboxEmpty");
function n4() {
  return fi().filteredItems;
}
function r4(e, t, n, r = !0, o) {
  const [s, i] = b.useState(), a = gn(o ? `${o}-label` : void 0), l = e ?? t ?? s;
  return pe(() => {
    const c = e || t || !r ? void 0 : o4(n.current, a);
    s !== c && i(c);
  }), l;
}
function o4(e, t) {
  const n = s4(e);
  if (n)
    return !n.id && t && (n.id = t), n.id || void 0;
}
function s4(e) {
  if (!e)
    return;
  const t = e.parentElement;
  if (t && t.tagName === "LABEL")
    return t;
  const n = e.id;
  if (n) {
    const o = e.nextElementSibling;
    if (o && o.htmlFor === n)
      return o;
  }
  const r = e.labels;
  return r && r[0];
}
const lC = {
  ...xA,
  ...co
}, cC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    defaultOpen: s = !1,
    disabled: i = !1,
    onOpenChange: a,
    open: l,
    style: c,
    ...u
  } = t, d = ye(a), f = gA({
    open: l,
    defaultOpen: s,
    onOpenChange: d,
    disabled: i
  }), h = b.useMemo(() => ({
    open: f.open,
    disabled: f.disabled,
    transitionStatus: f.transitionStatus
  }), [f.open, f.disabled, f.transitionStatus]), p = b.useMemo(() => ({
    ...f,
    onOpenChange: d,
    state: h
  }), [f, d, h]), g = We("div", t, {
    state: h,
    ref: n,
    props: u,
    stateAttributesMapping: lC
  });
  return /* @__PURE__ */ _(qp.Provider, {
    value: p,
    children: g
  });
});
process.env.NODE_ENV !== "production" && (cC.displayName = "CollapsibleRoot");
const i4 = {
  ...yA,
  ...co
}, uC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    panelId: r,
    open: o,
    handleTrigger: s,
    state: i,
    disabled: a
  } = Aw(), {
    className: l,
    disabled: c = a,
    render: u,
    nativeButton: d = !0,
    style: f,
    ...h
  } = t, {
    getButtonProps: p,
    buttonRef: g
  } = Wn({
    disabled: c,
    focusableWhenDisabled: !0,
    native: d
  });
  return We("button", t, {
    state: i,
    ref: [n, g],
    props: [{
      "aria-controls": o ? r : void 0,
      "aria-expanded": o,
      onClick: s
    }, h, p],
    stateAttributesMapping: i4
  });
});
process.env.NODE_ENV !== "production" && (uC.displayName = "CollapsibleTrigger");
let l0 = /* @__PURE__ */ function(e) {
  return e.collapsiblePanelHeight = "--collapsible-panel-height", e.collapsiblePanelWidth = "--collapsible-panel-width", e;
}({});
const dC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    className: r,
    hiddenUntilFound: o,
    keepMounted: s,
    render: i,
    id: a,
    style: l,
    ...c
  } = t;
  process.env.NODE_ENV !== "production" && b.useEffect(() => {
    o && s === !1 && Qc("The `keepMounted={false}` prop on `Collapsible.Panel` is ignored when `hiddenUntilFound` is enabled, since the panel must remain mounted while closed.");
  }, [o, s]);
  const {
    defaultPanelId: u,
    mounted: d,
    onOpenChange: f,
    open: h,
    setMounted: p,
    setPanelIdState: g,
    setOpen: m,
    state: v,
    transitionStatus: y
  } = Aw(), x = o ?? !1, C = s ?? !1, w = a || void 0, E = w ?? u;
  pe(() => (g((L) => w ?? (L === null ? void 0 : L)), () => {
    g((L) => L === w ? null : L);
  }), [w, g]);
  const {
    height: S,
    props: O,
    ref: M,
    shouldPreventOpenAnimation: T,
    shouldRender: P,
    transitionStatus: I,
    width: R
  } = wA({
    externalRef: n,
    hiddenUntilFound: x,
    id: E,
    keepMounted: C,
    mounted: d,
    onOpenChange: f,
    open: h,
    setMounted: p,
    setOpen: m,
    transitionStatus: y
  }), D = {
    ...v,
    transitionStatus: I
  }, k = Ly(l, D), $ = We("div", {
    ...t,
    style: void 0
  }, {
    state: D,
    ref: M,
    props: [
      O,
      {
        style: {
          [l0.collapsiblePanelHeight]: S === void 0 ? "auto" : `${S}px`,
          [l0.collapsiblePanelWidth]: R === void 0 ? "auto" : `${R}px`
        }
      },
      c,
      k ? {
        style: k
      } : void 0,
      // Resolve the public `style` prop so temporary `animationName: 'none'`
      // can still win after user's inline styles have been merged.
      T ? {
        style: {
          animationName: "none"
        }
      } : void 0
    ],
    stateAttributesMapping: lC
  });
  return P ? $ : null;
});
process.env.NODE_ENV !== "production" && (dC.displayName = "CollapsiblePanel");
function a4(e) {
  const {
    multiple: t = !1,
    defaultValue: n,
    value: r,
    onValueChange: o,
    autoComplete: s,
    ...i
  } = e;
  return /* @__PURE__ */ _(LA, {
    ...i,
    selectionMode: t ? "multiple" : "single",
    selectedValue: r,
    defaultSelectedValue: n,
    onSelectedValueChange: o,
    formAutoComplete: s
  });
}
function l4(e, t) {
  const n = gn(e);
  return pe(() => (t(n), () => {
    t((r) => r === n ? void 0 : r);
  }), [n, t]), n;
}
const fC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    selected: r
  } = rC();
  return t.keepMounted || r ? /* @__PURE__ */ _(hC, {
    ...t,
    ref: n
  }) : null;
});
process.env.NODE_ENV !== "production" && (fC.displayName = "ComboboxItemIndicator");
const hC = /* @__PURE__ */ b.memo(/* @__PURE__ */ b.forwardRef((e, t) => {
  const {
    render: n,
    className: r,
    style: o,
    keepMounted: s,
    ...i
  } = e, {
    selected: a
  } = rC(), l = b.useRef(null), {
    transitionStatus: c,
    setMounted: u
  } = vs(a), f = We("span", e, {
    ref: [t, l],
    state: {
      selected: a,
      transitionStatus: c
    },
    props: [{
      "aria-hidden": !0,
      children: "✔️"
    }, i],
    stateAttributesMapping: co
  });
  return Jn({
    open: a,
    ref: l,
    onComplete() {
      a || u(!1);
    }
  }), f;
}));
process.env.NODE_ENV !== "production" && (hC.displayName = "Inner");
const pC = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (pC.displayName = "ContextMenuRootContext");
function Uu(e = !0) {
  const t = b.useContext(pC);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ContextMenuRootContext is missing. ContextMenu parts must be placed within <ContextMenu.Root>." : tt(25));
  return t;
}
const pg = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (pg.displayName = "MenuPositionerContext");
function Ua(e) {
  const t = b.useContext(pg);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuPositionerContext is missing. MenuPositioner parts must be placed within <Menu.Positioner>." : tt(33));
  return t;
}
const gg = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (gg.displayName = "MenuRootContext");
function br(e) {
  const t = b.useContext(gg);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRootContext is missing. Menu parts must be placed within <Menu.Root>." : tt(36));
  return t;
}
const gC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, {
    store: a
  } = br(), l = a.useState("open"), c = a.useState("mounted"), u = a.useState("transitionStatus"), d = a.useState("lastOpenChangeReason"), f = Uu(), h = {
    open: l,
    transitionStatus: u
  };
  return We("div", t, {
    ref: f != null && f.backdropRef ? [n, f.backdropRef] : n,
    state: h,
    stateAttributesMapping: $a,
    props: [{
      role: "presentation",
      hidden: !c,
      style: {
        pointerEvents: d === qt ? "none" : void 0,
        userSelect: "none",
        WebkitUserSelect: "none"
      }
    }, i]
  });
});
process.env.NODE_ENV !== "production" && (gC.displayName = "MenuBackdrop");
const mg = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (mg.displayName = "MenuCheckboxItemContext");
function c4() {
  const e = b.useContext(mg);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuCheckboxItemContext is missing. MenuCheckboxItem parts must be placed within <Menu.CheckboxItem>." : tt(30));
  return e;
}
function u4(e) {
  const {
    closeOnClick: t,
    highlighted: n,
    id: r,
    nodeId: o,
    store: s,
    typingRef: i,
    itemRef: a,
    itemMetadata: l
  } = e, {
    events: c
  } = s.useState("floatingTreeRoot"), u = s.useState("open"), d = Uu(!0), f = d !== void 0;
  return b.useMemo(() => ({
    id: r,
    role: "menuitem",
    tabIndex: u && n ? 0 : -1,
    onKeyDown(h) {
      h.key === " " && (i != null && i.current) && h.preventDefault();
    },
    onMouseMove(h) {
      o && c.emit("itemhover", {
        nodeId: o,
        target: h.currentTarget
      });
    },
    onClick(h) {
      t && c.emit("close", {
        domEvent: h,
        reason: Ra
      });
    },
    onMouseUp(h) {
      if (d) {
        const p = d.initialCursorPointRef.current;
        if (d.initialCursorPointRef.current = null, f && p && Math.abs(h.clientX - p.x) <= 1 && Math.abs(h.clientY - p.y) <= 1 || f && !Nh && h.button === 2)
          return;
      }
      a.current && s.context.allowMouseUpTriggerRef.current && (!f || h.button === 2) && l.type === "regular-item" && Zi(a.current, h, {
        detail: 1
      });
    }
  }), [t, n, r, c, o, u, s, i, a, d, f, l]);
}
const bg = {
  type: "regular-item"
};
function Gu(e) {
  const {
    closeOnClick: t,
    disabled: n,
    highlighted: r,
    id: o,
    store: s,
    typingRef: i = s.context.typingRef,
    nativeButton: a,
    itemMetadata: l,
    nodeId: c
  } = e, u = b.useRef(null), {
    getButtonProps: d,
    buttonRef: f
  } = Wn({
    disabled: n,
    focusableWhenDisabled: !0,
    native: a,
    composite: !0
  }), h = u4({
    closeOnClick: t,
    highlighted: r,
    id: o,
    nodeId: c,
    store: s,
    typingRef: i,
    itemRef: u,
    itemMetadata: l
  }), p = b.useCallback((m) => _n(h, {
    onMouseEnter() {
      l.type === "submenu-trigger" && l.setActive();
    }
  }, m, d), [h, d, l]), g = ar(u, f);
  return b.useMemo(() => ({
    getItemProps: p,
    itemRef: g
  }), [p, g]);
}
let c0 = /* @__PURE__ */ function(e) {
  return e.checked = "data-checked", e.unchecked = "data-unchecked", e.disabled = "data-disabled", e.highlighted = "data-highlighted", e;
}({});
const Ku = {
  checked(e) {
    return e ? {
      [c0.checked]: ""
    } : {
      [c0.unchecked]: ""
    };
  },
  ...co
}, mC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    id: s,
    label: i,
    nativeButton: a = !1,
    disabled: l = !1,
    closeOnClick: c = !1,
    checked: u,
    defaultChecked: d,
    onCheckedChange: f,
    style: h,
    ...p
  } = t, g = Es({
    guess: !0,
    label: i
  }), m = Ua(!0), v = gn(s), {
    store: y
  } = br(), x = y.useState("disabled"), C = l || x, w = y.useState("isActive", g.index), E = y.useState("itemProps"), [S, O] = Fr({
    controlled: u,
    default: d ?? !1,
    name: "MenuCheckboxItem",
    state: "checked"
  }), {
    getItemProps: M,
    itemRef: T
  } = Gu({
    closeOnClick: c,
    disabled: C,
    highlighted: w,
    id: v,
    store: y,
    nativeButton: a,
    nodeId: m == null ? void 0 : m.context.nodeId,
    itemMetadata: bg
  }), P = b.useMemo(() => ({
    disabled: C,
    highlighted: w,
    checked: S
  }), [C, w, S]);
  function I(D) {
    const k = Ne(Ra, D.nativeEvent, void 0, {
      preventUnmountOnClose: Nt
    });
    f == null || f(!S, k), !k.isCanceled && O(($) => !$);
  }
  const R = We("div", t, {
    state: P,
    stateAttributesMapping: Ku,
    props: [E, {
      role: "menuitemcheckbox",
      "aria-checked": S,
      onClick: I
    }, p, M],
    ref: [T, n, g.ref]
  });
  return /* @__PURE__ */ _(mg.Provider, {
    value: P,
    children: R
  });
});
process.env.NODE_ENV !== "production" && (mC.displayName = "MenuCheckboxItem");
const bC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    keepMounted: i = !1,
    ...a
  } = t, l = c4(), c = b.useRef(null), {
    transitionStatus: u,
    mounted: d,
    setMounted: f
  } = vs(l.checked);
  Jn({
    open: l.checked,
    ref: c,
    onComplete() {
      l.checked || f(!1);
    }
  });
  const h = {
    checked: l.checked,
    disabled: l.disabled,
    highlighted: l.highlighted,
    transitionStatus: u
  };
  return We("span", t, {
    state: h,
    ref: [n, c],
    stateAttributesMapping: Ku,
    props: {
      "aria-hidden": !0,
      ...a
    },
    enabled: i || d
  });
});
process.env.NODE_ENV !== "production" && (bC.displayName = "MenuCheckboxItemIndicator");
const qu = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (qu.displayName = "MenuGroupContext");
function d4() {
  const e = b.useContext(qu);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuGroupContext is missing. Menu group parts must be used within <Menu.Group> or <Menu.RadioGroup>." : tt(31));
  return e;
}
const vC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, [a, l] = b.useState(void 0), c = We("div", t, {
    ref: n,
    props: {
      role: "group",
      "aria-labelledby": a,
      ...i
    }
  });
  return /* @__PURE__ */ _(qu.Provider, {
    value: l,
    children: c
  });
});
process.env.NODE_ENV !== "production" && (vC.displayName = "MenuGroup");
const yC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    id: i,
    ...a
  } = t, l = gn(i), c = d4();
  return pe(() => (c(l), () => {
    c((u) => u === l ? void 0 : u);
  }), [c, l]), We("div", t, {
    ref: n,
    props: {
      id: l,
      role: "presentation",
      ...a
    }
  });
});
process.env.NODE_ENV !== "production" && (yC.displayName = "MenuGroupLabel");
const xC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    id: s,
    label: i,
    nativeButton: a = !1,
    disabled: l = !1,
    closeOnClick: c = !0,
    style: u,
    ...d
  } = t, f = Es({
    guess: !0,
    label: i
  }), h = Ua(!0), p = gn(s), {
    store: g
  } = br(), m = g.useState("disabled"), v = l || m, y = g.useState("isActive", f.index), x = g.useState("itemProps"), {
    getItemProps: C,
    itemRef: w
  } = Gu({
    closeOnClick: c,
    disabled: v,
    highlighted: y,
    id: p,
    store: g,
    nativeButton: a,
    nodeId: h == null ? void 0 : h.context.nodeId,
    itemMetadata: bg
  });
  return We("div", t, {
    state: {
      disabled: v,
      highlighted: y
    },
    props: [x, d, C],
    ref: [w, n, f.ref]
  });
});
process.env.NODE_ENV !== "production" && (xC.displayName = "MenuItem");
const wC = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (wC.displayName = "ToolbarRootContext");
function vg(e) {
  const t = b.useContext(wC);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ToolbarRootContext is missing. Toolbar parts must be placed within <Toolbar.Root>." : tt(69));
  return t;
}
const CC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    finalFocus: i,
    ...a
  } = t, {
    store: l
  } = br(), {
    side: c,
    align: u
  } = Ua(), d = vg(!0) != null, f = l.useState("open"), h = l.useState("transitionStatus"), p = l.useState("popupProps"), g = l.useState("mounted"), m = l.useState("instantType"), v = l.useState("activeTriggerElement"), y = l.useState("parent"), x = l.useState("lastOpenChangeReason"), C = l.useState("rootId"), w = l.useState("floatingRootContext"), E = l.useState("floatingTreeRoot"), S = l.useState("closeDelay"), O = l.useState("hoverEnabled"), M = l.useState("disabled"), T = l.useState("openMethod"), P = y.type === "context-menu";
  Jn({
    open: f,
    ref: l.context.popupRef,
    onComplete() {
      var $, L;
      f && ((L = ($ = l.context).onOpenChangeComplete) == null || L.call($, !0));
    }
  }), b.useEffect(() => {
    function $(L) {
      l.setOpen(!1, Ne(L.reason, L.domEvent));
    }
    return E.events.on("close", $), () => {
      E.events.off("close", $);
    };
  }, [E.events, l]), up(w, {
    enabled: O && !M && !P && y.type !== "menubar",
    closeDelay: S
  });
  const I = l.useStateSetter("popupElement"), R = {
    transitionStatus: h,
    side: c,
    align: u,
    open: f,
    nested: y.type === "menu",
    instant: m
  }, D = We("div", t, {
    state: R,
    ref: [n, l.context.popupRef, I],
    stateAttributesMapping: $a,
    props: [p, {
      onKeyDown($) {
        d && Iu.has($.key) && $.stopPropagation();
      }
    }, La(h), a, {
      "data-rootownerid": C
    }]
  });
  let k = y.type === void 0 || P;
  return (v || y.type === "menubar" && x !== iu) && (k = !0), /* @__PURE__ */ _(cu, {
    context: w,
    openInteractionType: T,
    modal: P,
    disabled: !g,
    returnFocus: i === void 0 ? k : i,
    initialFocus: y.type !== "menu",
    restoreFocus: !0,
    externalTree: y.type !== "menubar" ? E : void 0,
    previousFocusableElement: v,
    nextFocusableElement: y.type === void 0 ? l.context.triggerFocusTargetRef : void 0,
    beforeContentFocusGuardRef: y.type === void 0 ? l.context.beforeContentFocusGuardRef : void 0,
    children: D
  });
});
process.env.NODE_ENV !== "production" && (CC.displayName = "MenuPopup");
const yg = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (yg.displayName = "MenuPortalContext");
function f4() {
  const e = b.useContext(yg);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Portal> is missing." : tt(32));
  return e;
}
const EC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    keepMounted: r = !1,
    ...o
  } = t, {
    store: s
  } = br();
  return s.useState("mounted") || r ? /* @__PURE__ */ _(yg.Provider, {
    value: r,
    children: /* @__PURE__ */ _(ka, {
      ref: n,
      ...o
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (EC.displayName = "MenuPortal");
const _C = /* @__PURE__ */ b.forwardRef(function(t, n) {
  var _e;
  const {
    anchor: r,
    positionMethod: o = "absolute",
    className: s,
    render: i,
    side: a,
    align: l,
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: h = 5,
    sticky: p = !1,
    disableAnchorTracking: g = !1,
    collisionAvoidance: m = E1,
    style: v,
    ...y
  } = t, {
    store: x
  } = br(), C = f4(), w = Uu(!0), E = x.useState("parent"), S = x.useState("floatingRootContext"), O = x.useState("floatingTreeRoot"), M = x.useState("mounted"), T = x.useState("open"), P = x.useState("modal"), I = x.useState("openMethod"), R = x.useState("activeTriggerElement"), D = x.useState("transitionStatus"), k = x.useState("positionerElement"), $ = x.useState("instantType"), L = x.useState("adaptiveOrigin"), A = x.useState("lastOpenChangeReason"), F = x.useState("floatingNodeId"), N = x.useState("floatingParentNodeId"), V = S.useState("domReferenceElement"), K = b.useRef(null), Y = hu(k);
  let U = r, j = c, H = u, q = l, B = m;
  E.type === "context-menu" && (U = r ?? ((_e = E.context) == null ? void 0 : _e.anchor), q = q ?? "start", !a && q !== "center" && (H = t.alignOffset ?? 2, j = t.sideOffset ?? -5));
  let X = a, te = q;
  E.type === "menu" ? (X = X ?? "inline-end", te = te ?? "start", B = t.collisionAvoidance ?? Xh) : E.type === "menubar" && (X = X ?? (E.context.orientation === "vertical" ? "inline-end" : "bottom"), te = te ?? "start");
  const J = E.type === "context-menu", G = Mu({
    anchor: U,
    floatingRootContext: S,
    positionMethod: w ? "fixed" : o,
    mounted: M,
    side: X,
    sideOffset: j,
    align: te,
    alignOffset: H,
    arrowPadding: J ? 0 : h,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: p,
    nodeId: F,
    keepMounted: C,
    disableAnchorTracking: g,
    collisionAvoidance: B,
    shift: J ? {
      crossAxis: !("side" in B && B.side === "flip"),
      rootBoundary: "layoutViewport"
    } : void 0,
    externalTree: O,
    adaptiveOrigin: L
  });
  b.useEffect(() => {
    function xe(ge) {
      ge.open && (ge.parentNodeId === F && x.set("hoverEnabled", !1), ge.nodeId !== F && ge.parentNodeId === x.select("floatingParentNodeId") && x.setOpen(!1, Ne(Vi)));
    }
    return O.events.on("menuopenchange", xe), () => {
      O.events.off("menuopenchange", xe);
    };
  }, [x, O.events, F]), b.useEffect(() => {
    if (x.select("floatingParentNodeId") == null)
      return;
    function xe(ge) {
      if (ge.open || ge.nodeId !== x.select("floatingParentNodeId"))
        return;
      const ae = ge.reason ?? Vi;
      x.setOpen(!1, Ne(ae));
    }
    return O.events.on("menuopenchange", xe), () => {
      O.events.off("menuopenchange", xe);
    };
  }, [O.events, x]);
  const ne = Sn();
  b.useEffect(() => {
    T || ne.clear();
  }, [T, ne]), b.useEffect(() => {
    function xe(ge) {
      if (!(!T || ge.nodeId !== x.select("floatingParentNodeId")))
        if (ge.target && R && R !== ge.target) {
          const ae = x.select("closeDelay");
          ae > 0 ? ne.isStarted() || ne.start(ae, () => {
            x.setOpen(!1, Ne(Vi));
          }) : x.setOpen(!1, Ne(Vi));
        } else
          ne.clear();
    }
    return O.events.on("itemhover", xe), () => {
      O.events.off("itemhover", xe);
    };
  }, [O.events, T, R, x, ne]), b.useEffect(() => {
    const xe = {
      open: T,
      nodeId: F,
      parentNodeId: N,
      reason: x.select("lastOpenChangeReason")
    };
    O.events.emit("menuopenchange", xe);
  }, [O.events, T, x, F, N]), pe(() => {
    const xe = V, ge = K.current;
    if (xe && (K.current = xe), ge && xe && xe !== ge) {
      x.set("instantType", void 0);
      const ae = new AbortController();
      return Y(() => {
        x.set("instantType", "trigger-change");
      }, ae.signal), () => {
        ae.abort();
      };
    }
  }, [V, Y, x]);
  const Q = {
    open: T,
    side: G.side,
    align: G.align,
    anchorHidden: G.anchorHidden,
    nested: E.type === "menu",
    instant: $
  }, re = E.type === "menubar" && E.context.modal;
  fg(T && (re || P && A !== qt), I === "touch", k, R);
  const le = Tu(t, Q, {
    styles: G.positionerStyles,
    transitionStatus: D,
    props: y,
    refs: [n, x.useStateSetter("positionerElement")],
    hidden: !M,
    inert: !T
  }), Ee = M && E.type !== "menu" && (E.type !== "menubar" && P && A !== qt || E.type === "menubar" && E.context.modal);
  let se = null;
  return E.type === "menubar" ? se = E.context.contentElement : E.type === void 0 && (se = R), /* @__PURE__ */ ee(pg.Provider, {
    value: G,
    children: [Ee && /* @__PURE__ */ _(Va, {
      ref: E.type === "context-menu" || E.type === "nested-context-menu" ? E.context.internalBackdropRef : null,
      inert: di(!T),
      cutout: se
    }), /* @__PURE__ */ _(M1, {
      id: F,
      children: /* @__PURE__ */ _(zu, {
        elementsRef: x.context.itemDomElements,
        labelsRef: x.context.itemLabels,
        children: le
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (_C.displayName = "MenuPositioner");
const xg = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (xg.displayName = "MenuRadioGroupContext");
function h4() {
  const e = b.useContext(xg);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioGroupContext is missing. MenuRadioGroup parts must be placed within <Menu.RadioGroup>." : tt(34));
  return e;
}
const SC = /* @__PURE__ */ b.memo(/* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    value: s,
    defaultValue: i,
    onValueChange: a,
    disabled: l = !1,
    style: c,
    "aria-labelledby": u,
    ...d
  } = t, [f, h] = b.useState(void 0), [p, g] = Fr({
    controlled: s,
    default: i,
    name: "MenuRadioGroup"
  }), m = ye((C, w) => {
    a == null || a(C, w), !w.isCanceled && g(C);
  }), y = We("div", t, {
    state: {
      disabled: l
    },
    ref: n,
    props: {
      role: "group",
      "aria-labelledby": u ?? f,
      "aria-disabled": l || void 0,
      ...d
    }
  }), x = b.useMemo(() => ({
    value: p,
    setValue: m,
    disabled: l
  }), [p, m, l]);
  return /* @__PURE__ */ _(qu.Provider, {
    value: h,
    children: /* @__PURE__ */ _(xg.Provider, {
      value: x,
      children: y
    })
  });
}));
process.env.NODE_ENV !== "production" && (SC.displayName = "MenuRadioGroup");
const wg = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (wg.displayName = "MenuRadioItemContext");
function p4() {
  const e = b.useContext(wg);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioItemContext is missing. MenuRadioItem parts must be placed within <Menu.RadioItem>." : tt(35));
  return e;
}
const OC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    id: s,
    label: i,
    nativeButton: a = !1,
    disabled: l = !1,
    closeOnClick: c = !1,
    value: u,
    style: d,
    ...f
  } = t, h = Es({
    guess: !0,
    label: i
  }), p = Ua(!0), g = gn(s), {
    store: m
  } = br(), v = m.useState("isActive", h.index), y = m.useState("itemProps"), {
    value: x,
    setValue: C,
    disabled: w
  } = h4(), E = m.useState("disabled"), S = l || w || E, O = x === u, {
    getItemProps: M,
    itemRef: T
  } = Gu({
    closeOnClick: c,
    disabled: S,
    highlighted: v,
    id: g,
    store: m,
    nativeButton: a,
    nodeId: p == null ? void 0 : p.context.nodeId,
    itemMetadata: bg
  }), P = b.useMemo(() => ({
    disabled: S,
    highlighted: v,
    checked: O
  }), [S, v, O]);
  function I(D) {
    const k = Ne(Ra, D.nativeEvent, void 0, {
      preventUnmountOnClose: Nt
    });
    C(u, k);
  }
  const R = We("div", t, {
    state: P,
    stateAttributesMapping: Ku,
    props: [y, {
      role: "menuitemradio",
      "aria-checked": O,
      onClick: I
    }, f, M],
    ref: [T, n, h.ref]
  });
  return /* @__PURE__ */ _(wg.Provider, {
    value: P,
    children: R
  });
});
process.env.NODE_ENV !== "production" && (OC.displayName = "MenuRadioItem");
const MC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    keepMounted: i = !1,
    ...a
  } = t, l = p4(), c = b.useRef(null), {
    transitionStatus: u,
    mounted: d,
    setMounted: f
  } = vs(l.checked);
  Jn({
    open: l.checked,
    ref: c,
    onComplete() {
      l.checked || f(!1);
    }
  });
  const h = {
    checked: l.checked,
    disabled: l.disabled,
    highlighted: l.highlighted,
    transitionStatus: u
  };
  return We("span", t, {
    state: h,
    stateAttributesMapping: Ku,
    ref: [n, c],
    props: {
      "aria-hidden": !0,
      ...a
    },
    enabled: i || d
  });
});
process.env.NODE_ENV !== "production" && (MC.displayName = "MenuRadioItemIndicator");
const TC = /* @__PURE__ */ b.createContext(null);
process.env.NODE_ENV !== "production" && (TC.displayName = "MenubarContext");
function RC(e) {
  const t = b.useContext(TC);
  if (t === null && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenubarContext is missing. Menubar parts must be placed within <Menubar>." : tt(5));
  return t;
}
const g4 = {
  ...wu,
  disabled: (e) => e.parent.type === "menubar" && e.parent.context.disabled || e.disabled,
  modal: (e) => (e.parent.type === void 0 || e.parent.type === "context-menu") && (e.modal ?? !0),
  openMethod: (e) => e.openMethod,
  allowMouseEnter: (e) => e.allowMouseEnter,
  highlightItemOnHover: (e) => e.highlightItemOnHover,
  parent: (e) => e.parent,
  rootId: (e) => e.parent.type === "menu" ? e.parent.store.select("rootId") : e.parent.type !== void 0 ? e.parent.context.rootId : e.rootId,
  activeIndex: (e) => e.activeIndex,
  isActive: (e, t) => e.activeIndex === t,
  hoverEnabled: (e) => e.hoverEnabled,
  instantType: (e) => e.instantType,
  lastOpenChangeReason: (e) => e.openChangeReason,
  floatingTreeRoot: (e) => e.parent.type === "menu" ? e.parent.store.select("floatingTreeRoot") : e.floatingTreeRoot,
  floatingNodeId: (e) => e.floatingNodeId,
  floatingParentNodeId: (e) => e.floatingParentNodeId,
  itemProps: (e) => e.itemProps,
  closeDelay: (e) => e.closeDelay,
  adaptiveOrigin: (e) => e.adaptiveOrigin,
  keyboardEventRelay: (e) => {
    if (e.keyboardEventRelay)
      return e.keyboardEventRelay;
    if (e.parent.type === "menu")
      return e.parent.store.select("keyboardEventRelay");
  }
};
class m4 extends ci {
  constructor(n) {
    super({
      ...v4(),
      ...n
    }, b4(), g4);
    ce(this, "unsubscribeParentListener", null);
    this.unsubscribeParentListener = this.observe("parent", (r) => {
      var o;
      if ((o = this.unsubscribeParentListener) == null || o.call(this), r.type === "menu") {
        let s = r.store.select("rootId"), i = r.store.select("floatingTreeRoot"), a = r.store.select("keyboardEventRelay");
        this.unsubscribeParentListener = r.store.subscribe(() => {
          const l = r.store.select("rootId"), c = r.store.select("floatingTreeRoot"), u = r.store.select("keyboardEventRelay");
          s === l && i === c && a === u || (s = l, i = c, a = u, this.notifyAll());
        }), this.context.allowMouseUpTriggerRef = r.store.context.allowMouseUpTriggerRef;
        return;
      }
      r.type !== void 0 && (this.context.allowMouseUpTriggerRef = r.context.allowMouseUpTriggerRef), this.unsubscribeParentListener = null;
    });
  }
  setOpen(n, r) {
    this.state.floatingRootContext.context.events.emit("setOpen", {
      open: n,
      eventDetails: r
    });
  }
}
function b4() {
  return {
    positionerRef: /* @__PURE__ */ b.createRef(),
    popupRef: /* @__PURE__ */ b.createRef(),
    typingRef: {
      current: !1
    },
    itemDomElements: {
      current: []
    },
    itemLabels: {
      current: []
    },
    allowMouseUpTriggerRef: {
      current: !1
    },
    triggerFocusTargetRef: /* @__PURE__ */ b.createRef(),
    beforeContentFocusGuardRef: /* @__PURE__ */ b.createRef(),
    onOpenChangeComplete: void 0,
    triggerElements: new ui()
  };
}
function v4() {
  return {
    ...xu(),
    disabled: !1,
    modal: !0,
    openMethod: null,
    allowMouseEnter: !1,
    highlightItemOnHover: !0,
    parent: {
      type: void 0
    },
    rootId: void 0,
    activeIndex: null,
    hoverEnabled: !0,
    instantType: void 0,
    openChangeReason: null,
    floatingTreeRoot: new Qh(),
    floatingNodeId: void 0,
    floatingParentNodeId: null,
    itemProps: At,
    keyboardEventRelay: void 0,
    closeDelay: 0,
    adaptiveOrigin: void 0
  };
}
const Cg = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Cg.displayName = "MenuSubmenuRootContext");
function PC() {
  return b.useContext(Cg);
}
const Eg = kh(function(t) {
  const {
    children: n,
    open: r,
    onOpenChange: o,
    onOpenChangeComplete: s,
    defaultOpen: i = !1,
    disabled: a = !1,
    modal: l,
    loopFocus: c = !0,
    orientation: u = "vertical",
    actionsRef: d,
    closeParentOnEsc: f = !1,
    handle: h,
    triggerId: p,
    defaultTriggerId: g = null,
    highlightItemOnHover: m = !0
  } = t, v = Uu(!0), y = br(!0), x = RC(!0), C = PC(), w = b.useMemo(() => C && y ? {
    type: "menu",
    store: y.store
  } : x ? {
    type: "menubar",
    context: x
  } : v && !y ? {
    type: "context-menu",
    context: v
  } : {
    type: void 0
  }, [v, y, x, C]), E = y4({
    open: i,
    openProp: r,
    activeTriggerId: g,
    triggerIdProp: p,
    parent: w
  });
  E.useControlledProp("openProp", r), E.useControlledProp("triggerIdProp", p), E.useContextCallback("onOpenChangeComplete", s);
  const S = ko(), O = ko(), M = E.useState("floatingTreeRoot"), T = tp(M), P = Wo(), I = E.useState("open"), R = E.useState("activeTriggerElement"), D = E.useState("positionerElement"), k = E.useState("hoverEnabled"), $ = E.useState("disabled"), L = E.useState("lastOpenChangeReason"), A = E.useState("parent"), F = E.useState("activeIndex"), N = E.useState("payload"), V = E.useState("floatingParentNodeId"), K = b.useRef(null), Y = b.useRef(A.type !== "context-menu"), U = Sn(), j = b.useRef(!0), H = Sn(), q = V != null;
  process.env.NODE_ENV !== "production" && A.type !== void 0 && l !== void 0 && console.warn("Base UI: The `modal` prop is not supported on nested menus. It will be ignored.");
  const {
    openMethod: B,
    triggerProps: X
  } = lx(I);
  E.useSyncedValues({
    disabled: a,
    highlightItemOnHover: m,
    modal: A.type === void 0 ? l : void 0,
    openMethod: B,
    rootId: S
  }), bu(E);
  const {
    forceUnmount: te
  } = vu(I, E, () => {
    E.set("allowMouseEnter", !1);
  });
  pe(() => {
    v && !y ? E.update({
      parent: {
        type: "context-menu",
        context: v
      },
      floatingNodeId: T,
      floatingParentNodeId: P
    }) : y && E.update({
      floatingNodeId: T,
      floatingParentNodeId: P
    });
  }, [v, y, T, P, E]), b.useEffect(() => {
    if (I || (K.current = null), A.type === "context-menu") {
      if (!I) {
        U.clear(), Y.current = !1;
        return;
      }
      U.start(500, () => {
        Y.current = !0;
      });
    }
  }, [U, I, A.type]), pe(() => {
    !I && !k && E.set("hoverEnabled", !0);
  }, [I, k, E]);
  const J = ye((oe, he) => {
    const Re = he.reason;
    if (!oe && !E.select("open") || I === oe && he.trigger === R && L === Re)
      return;
    const Ae = sp(he);
    if (!oe && he.trigger == null && (he.trigger = R ?? void 0), o == null || o(oe, he), he.isCanceled)
      return;
    E.state.floatingRootContext.dispatchOpenChange(oe, he);
    const Ue = he.event;
    if (oe === !1 && (Ue == null ? void 0 : Ue.type) === "click" && Ue.pointerType === "touch" && !j.current)
      return;
    oe && Re === Bs ? (j.current = !1, H.start(300, () => {
      j.current = !0;
    })) : (j.current = !0, H.clear());
    const Ke = (Re === Lr || Re === Ra) && Ue.detail === 0, Be = !oe && (Re === bs || Re == null), nt = {
      open: oe,
      openChangeReason: Re
    };
    K.current = he.event, gu(nt, oe, he.trigger, Ae()), E.update(nt), A.type === "menubar" && (Re === Bs || Re === Ro || Re === qt || Re === la || Re === Vi) ? E.set("instantType", "group") : Ke || Be ? E.set("instantType", Ke ? "click" : "dismiss") : E.set("instantType", void 0);
  }), G = F1({
    popupStore: E,
    floatingId: O,
    nested: P != null,
    onOpenChange: J
  }), ne = G.context.events;
  pe(() => {
    const oe = ({
      open: he,
      eventDetails: Re
    }) => J(he, Re);
    return ne.on("setOpen", oe), () => {
      ne == null || ne.off("setOpen", oe);
    };
  }, [ne, J]);
  const Q = b.useCallback(() => {
    E.setOpen(!1, Ne(au));
  }, [E]);
  b.useImperativeHandle(d, () => ({
    unmount: te,
    close: Q
  }), [te, Q]);
  let re;
  A.type === "context-menu" && (re = A.context), b.useImperativeHandle(re == null ? void 0 : re.positionerRef, () => D, [D]), b.useImperativeHandle(re == null ? void 0 : re.actionsRef, () => ({
    setOpen: J
  }), [J]);
  const fe = Da(G, {
    enabled: !$,
    bubbles: {
      escapeKey: f && A.type === "menu"
    },
    outsidePress() {
      var oe;
      return A.type !== "context-menu" || ((oe = K.current) == null ? void 0 : oe.type) === "contextmenu" ? !0 : Y.current;
    },
    externalTree: q ? M : void 0
  }), le = Fa(), Ee = b.useCallback((oe) => {
    E.select("activeIndex") !== oe && E.set("activeIndex", oe);
  }, [E]), se = Y1(G, {
    enabled: !$,
    listRef: E.context.itemDomElements,
    activeIndex: F,
    nested: A.type !== void 0,
    loopFocus: c,
    orientation: u,
    parentOrientation: A.type === "menubar" ? A.context.orientation : void 0,
    rtl: le === "rtl",
    disabledIndices: Gn,
    onNavigate: Ee,
    openOnArrowKeyDown: A.type !== "context-menu",
    externalTree: q ? M : void 0,
    focusItemOnHover: m
  }), _e = b.useCallback((oe) => {
    E.context.typingRef.current = oe;
  }, [E]), xe = j1(G, {
    enabled: !$,
    listRef: E.context.itemLabels,
    elementsRef: E.context.itemDomElements,
    activeIndex: F,
    resetMs: VT,
    onMatch: (oe) => {
      I && oe !== F && E.set("activeIndex", oe);
    },
    onTyping: _e
  }), ge = b.useMemo(() => {
    const oe = _n(xe.reference, se.reference, fe.reference, {
      onMouseMove() {
        E.set("allowMouseEnter", !0);
      }
    }, X);
    return oe["aria-haspopup"] = "menu", oe["aria-expanded"] = I, oe;
  }, [E, xe.reference, se.reference, fe.reference, X, I]), ae = b.useMemo(() => {
    const oe = _n(se.trigger, fe.trigger, X);
    return oe["aria-haspopup"] = "menu", oe["aria-expanded"] = !1, oe;
  }, [se.trigger, fe.trigger, X]), W = b.useMemo(() => _n(Na, {
    id: O,
    role: "menu",
    "aria-labelledby": R == null ? void 0 : R.id,
    onMouseMove() {
      E.set("allowMouseEnter", !0), A.type === "menu" && E.set("hoverEnabled", !1);
    },
    onClick() {
      E.select("hoverEnabled") && E.set("hoverEnabled", !1);
    },
    onKeyDown(oe) {
      const he = E.select("keyboardEventRelay");
      he && !oe.isPropagationStopped() && he(oe);
    }
  }, xe.floating, se.floating, fe.floating), [R, O, A.type, E, xe.floating, se.floating, fe.floating]), Z = se.item ?? At;
  yu(E, {
    floatingRootContext: G,
    activeTriggerProps: ge,
    inactiveTriggerProps: ae,
    popupProps: W,
    itemProps: Z
  });
  const me = b.useMemo(() => ({
    store: E,
    parent: w
  }), [E, w]), ie = /* @__PURE__ */ ee(gg.Provider, {
    value: me,
    children: [h && /* @__PURE__ */ _(pu, {
      handle: h,
      store: E
    }), typeof n == "function" ? n({
      payload: N
    }) : n]
  });
  return A.type === void 0 || A.type === "context-menu" ? /* @__PURE__ */ _(T1, {
    externalTree: M,
    children: ie
  }) : ie;
});
process.env.NODE_ENV !== "production" && (Eg.displayName = "MenuRoot");
function y4(e) {
  return bn(() => new m4(e)).current;
}
function x4(e) {
  const t = br().store, n = b.useMemo(() => ({
    parentMenu: t
  }), [t]);
  return /* @__PURE__ */ _(Cg.Provider, {
    value: n,
    children: /* @__PURE__ */ _(Eg, {
      ...e
    })
  });
}
function IC(e = {}) {
  const {
    highlightItemOnHover: t,
    highlightedIndex: n,
    onHighlightedIndexChange: r
  } = Ru(), {
    ref: o,
    index: s
  } = Es(e), i = n === s, a = b.useRef(null), l = ar(o, a);
  return {
    compositeProps: {
      tabIndex: i ? 0 : -1,
      onFocus() {
        r(s);
      },
      onMouseMove() {
        const u = a.current;
        if (!t || !u)
          return;
        const d = u.hasAttribute("disabled") || u.ariaDisabled === "true";
        !i && !d && u.focus();
      }
    },
    compositeRef: l,
    index: s
  };
}
function kC(e) {
  const {
    render: t,
    className: n,
    style: r,
    state: o = At,
    props: s = Gn,
    refs: i = Gn,
    metadata: a,
    stateAttributesMapping: l,
    tag: c = "div",
    ...u
  } = e, {
    compositeProps: d,
    compositeRef: f
  } = IC({
    metadata: a
  });
  return We(c, e, {
    state: o,
    // The composite ref attaches first so an outer item wins when nested items share a DOM node.
    ref: [f, ...i],
    props: [d, ...s, u],
    stateAttributesMapping: l
  });
}
function DC(e) {
  if (wt(e) && e.hasAttribute("data-rootownerid"))
    return e.getAttribute("data-rootownerid");
  if (!Jr(e))
    return DC(ro(e));
}
function NC(e, t) {
  const n = b.useRef(null);
  function r(s) {
    Xn.flushSync(() => {
      e.setOpen(!1, Ne(Ro, s.nativeEvent, s.currentTarget));
    });
    const i = NT(n.current);
    i == null || i.focus();
  }
  function o(s) {
    var a;
    const i = e.select("positionerElement");
    if (i && zs(s, i))
      (a = e.context.beforeContentFocusGuardRef.current) == null || a.focus();
    else {
      Xn.flushSync(() => {
        e.setOpen(!1, Ne(Ro, s.nativeEvent, s.currentTarget));
      });
      let l = DT(e.context.triggerFocusTargetRef.current || t.current);
      for (; l !== null && Ie(i, l); ) {
        const c = l;
        if (l = Kh(l), l === c)
          break;
      }
      l == null || l.focus();
    }
  }
  return {
    preFocusGuardRef: n,
    handlePreFocusGuardFocus: r,
    handleFocusTargetFocus: o
  };
}
function w4(e) {
  const {
    enabled: t = !0,
    mouseDownAction: n,
    open: r
  } = e, o = b.useRef(!1);
  return b.useMemo(() => t ? {
    onMouseDown: (s) => {
      (n === "open" && !r || n === "close" && r) && (o.current = !0, Ze(s.currentTarget).addEventListener("click", () => {
        o.current = !1;
      }, {
        once: !0
      }));
    },
    onClick: (s) => {
      o.current && (o.current = !1, s.preventBaseUIHandler());
    }
  } : At, [t, n, r]);
}
const AC = Xy(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    disabled: i = !1,
    nativeButton: a = !0,
    id: l,
    openOnHover: c,
    delay: u = 100,
    closeDelay: d = 0,
    handle: f,
    payload: h,
    ...p
  } = t, g = br(!0), v = Cu(f) ?? (g == null ? void 0 : g.store);
  if (!v)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Trigger> must be either used within a <Menu.Root> component or provided with a handle." : tt(85));
  const y = gn(l), x = v.useState("isTriggerActive", y), C = v.useState("floatingRootContext"), w = v.useState("isOpenedByTrigger", y), E = v.useState("triggerPopupId", y), S = b.useRef(null), O = E4(), M = Ru(!0), T = Ho(), P = b.useMemo(() => T ?? new Qh(), [T]), I = tp(P), R = Wo(), {
    registerTrigger: D,
    isMountedByThisTrigger: k
  } = mu(y, S, v, {
    payload: h,
    closeDelay: d,
    parent: O,
    floatingTreeRoot: P,
    floatingNodeId: I,
    floatingParentNodeId: R,
    keyboardEventRelay: M == null ? void 0 : M.relayKeyboardEvent
  }), $ = O.type === "menubar", L = v.useState("disabled"), A = i || L || $ && O.context.disabled, {
    getButtonProps: F,
    buttonRef: N
  } = Wn({
    disabled: A,
    native: a
  });
  b.useEffect(() => {
    !w && O.type === void 0 && (v.context.allowMouseUpTriggerRef.current = !1);
  }, [v, w, O.type]);
  const V = b.useRef(null), K = Sn(), Y = ye((_e) => {
    if (!V.current)
      return;
    K.clear(), v.context.allowMouseUpTriggerRef.current = !1;
    const xe = _e.target;
    Ie(V.current, xe) || Ie(v.select("positionerElement"), xe) || xe === V.current || xe != null && DC(xe) === v.select("rootId") || Kw(_e, V.current) || P.events.emit("close", {
      domEvent: _e,
      reason: i1
    });
  });
  b.useEffect(() => {
    w && v.select("lastOpenChangeReason") === qt && Ze(V.current).addEventListener("mouseup", Y, {
      once: !0
    });
  }, [w, Y, v]);
  const U = $ && O.context.hasSubmenuOpen, H = Eu(C, {
    enabled: (c ?? U) && !A && (!$ || U && !k),
    handleClose: Su({
      blockPointerEvents: !$
    }),
    mouseOnly: !0,
    move: !1,
    restMs: O.type === void 0 ? u : void 0,
    delay: {
      close: d
    },
    triggerElementRef: S,
    externalTree: P,
    isActiveTrigger: x,
    isClosing: () => v.select("transitionStatus") === "ending"
  }), q = C4(w, v.select("lastOpenChangeReason")), B = li(C, {
    enabled: !A,
    event: w && $ ? "click" : "mousedown",
    toggle: !0,
    ignoreMouse: !1,
    stickIfOpen: O.type === void 0 ? q : !1
  }), X = B1(C, {
    enabled: !A && U
  }), te = w4({
    open: w,
    enabled: $,
    mouseDownAction: "open"
  }), J = b.useMemo(() => _n(X.reference, B.reference), [X.reference, B.reference]), G = v.useState("triggerProps", k), {
    preFocusGuardRef: ne,
    handlePreFocusGuardFocus: Q,
    handleFocusTargetFocus: re
  } = NC(v, S), fe = {
    disabled: A,
    open: w
  }, le = [V, n, N, D, S], Ee = [J, H ?? At, G, {
    "aria-haspopup": "menu",
    "aria-controls": E,
    id: y,
    onMouseDown: (_e) => {
      if (v.select("open"))
        return;
      K.start(200, () => {
        v.context.allowMouseUpTriggerRef.current = !0;
      }), Ze(_e.currentTarget).addEventListener("mouseup", Y, {
        once: !0
      });
    }
  }, $ ? {
    role: "menuitem"
  } : {}, te, p, F], se = We("button", t, {
    enabled: !$,
    stateAttributesMapping: wc,
    state: fe,
    ref: le,
    props: Ee
  });
  return $ ? /* @__PURE__ */ _(kC, {
    tag: "button",
    render: r,
    className: o,
    style: s,
    state: fe,
    refs: le,
    props: Ee,
    stateAttributesMapping: wc
  }) : w ? /* @__PURE__ */ ee(b.Fragment, {
    children: [/* @__PURE__ */ _(Vr, {
      ref: ne,
      onFocus: Q
    }, `${y}-pre-focus-guard`), /* @__PURE__ */ _(b.Fragment, {
      children: se
    }, y), /* @__PURE__ */ _(Vr, {
      ref: v.context.triggerFocusTargetRef,
      onFocus: re
    }, `${y}-post-focus-guard`)]
  }) : /* @__PURE__ */ _(b.Fragment, {
    children: se
  }, y);
});
process.env.NODE_ENV !== "production" && (AC.displayName = "MenuTrigger");
function C4(e, t) {
  const n = Sn(), [r, o] = b.useState(!1);
  return pe(() => {
    e && t === qt ? (o(!0), n.start(C1, () => {
      o(!1);
    })) : e || (n.clear(), o(!1));
  }, [e, t, n]), r;
}
function E4() {
  const e = RC(!0);
  return b.useMemo(() => e ? {
    type: "menubar",
    context: e
  } : {
    type: void 0
  }, [e]);
}
const $C = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    className: r,
    render: o,
    orientation: s = "horizontal",
    style: i,
    ...a
  } = t;
  return We("div", t, {
    state: {
      orientation: s
    },
    ref: n,
    props: [{
      role: "separator",
      "aria-orientation": s
    }, a]
  });
});
process.env.NODE_ENV !== "production" && ($C.displayName = "Separator");
function FC(e) {
  return e == null || e.hasAttribute("disabled") || e.getAttribute("aria-disabled") === "true";
}
const _4 = {
  "aria-expanded": void 0
}, LC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    label: i,
    id: a,
    nativeButton: l = !1,
    openOnHover: c = !0,
    delay: u = 100,
    closeDelay: d = 0,
    disabled: f = !1,
    ...h
  } = t, p = PC();
  if (!(p != null && p.parentMenu))
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.SubmenuTrigger> must be placed in <Menu.SubmenuRoot>." : tt(37));
  const g = Es({
    guess: !0,
    label: i
  }), m = Ua(), {
    store: v
  } = br(), y = gn(a), x = v.useState("open"), C = v.useState("floatingRootContext"), w = v.useState("floatingTreeRoot"), E = v.useState("triggerPopupId", y), S = V1(y, v), O = b.useCallback((J) => {
    const G = S(J);
    return J !== null && v.select("open") && v.select("activeTriggerId") == null && v.update({
      activeTriggerId: y,
      activeTriggerElement: J,
      closeDelay: d
    }), G;
  }, [S, d, v, y]), M = b.useRef(null), T = b.useCallback((J) => {
    M.current = J, v.set("activeTriggerElement", J);
  }, [v]);
  v.useSyncedValue("closeDelay", d);
  const P = p.parentMenu, I = v.useState("disabled"), R = P.useState("disabled"), D = f || I || R;
  process.env.NODE_ENV !== "production" && b.useEffect(() => {
    var G;
    const J = M.current;
    if (J && FC(J) && !D) {
      const ne = ((G = or.captureOwnerStack) == null ? void 0 : G.call(or)) || "";
      Qc(`A disabled element was detected on <Menu.SubmenuTrigger>. To properly disable the trigger, use the \`disabled\` prop on the component instead of setting it on the rendered element.${ne}`);
    }
  });
  const k = P.useState("itemProps"), $ = P.useState("isActive", g.index), L = b.useMemo(() => ({
    type: "submenu-trigger",
    setActive() {
      P.select("highlightItemOnHover") && P.set("activeIndex", g.index);
    }
  }), [P, g.index]), {
    getItemProps: A,
    itemRef: F
  } = Gu({
    closeOnClick: !1,
    disabled: D,
    highlighted: $,
    id: y,
    store: v,
    typingRef: P.context.typingRef,
    nativeButton: l,
    itemMetadata: L,
    nodeId: m == null ? void 0 : m.context.nodeId
  }), N = v.useState("hoverEnabled"), V = Eu(C, {
    enabled: N && c && !D,
    handleClose: Su({
      blockPointerEvents: !0
    }),
    mouseOnly: !0,
    move: !0,
    restMs: u,
    delay: {
      open: u,
      close: d
    },
    shouldOpen: u > 0 ? () => P.select("allowMouseEnter") : void 0,
    triggerElementRef: M,
    externalTree: w,
    isClosing: () => v.select("transitionStatus") === "ending",
    // Chrome can drop the trigger's `mouseleave` during a fast pointer sweep,
    // leaving a stale submenu open (see #5152) — cancel from `mouseout` too.
    guardStaleOpen: !0
  }), Y = li(C, {
    enabled: !D,
    event: "mousedown",
    toggle: !c,
    ignoreMouse: c,
    stickIfOpen: !1
  }).reference ?? At, U = v.useState("triggerProps", !0);
  delete U.id;
  const j = {
    disabled: D,
    highlighted: $,
    open: x
  }, H = v.useState("openMethod"), B = v.useState("lastOpenChangeReason") === la || H === "keyboard";
  return We("div", t, {
    state: j,
    stateAttributesMapping: Ou,
    props: [
      Y,
      V,
      U,
      k,
      // Opening a submenu changes the trigger's expanded state while the trigger still holds
      // focus, and VoiceOver announces that state change instead of the submenu item that focus
      // moves to a moment later, so the first item is never announced. Dropping the state while
      // the submenu is open avoids the announcement without claiming the submenu is collapsed;
      // `aria-haspopup` still conveys that the item opens a submenu.
      x && B && Zy ? _4 : void 0,
      {
        "aria-controls": E,
        tabIndex: x || $ ? 0 : -1,
        onBlur() {
          $ && P.set("activeIndex", null);
        }
      },
      h,
      A
    ],
    ref: [n, g.ref, F, O, T]
  });
});
process.env.NODE_ENV !== "production" && (LC.displayName = "MenuSubmenuTrigger");
function u0(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function qd(e, t, n) {
  switch (e) {
    case "up":
      return -n;
    case "down":
      return n;
    case "left":
      return -t;
    case "right":
      return t;
    default:
      return 0;
  }
}
function S4(e) {
  const n = Ht(e).getComputedStyle(e).transform;
  let r = 0, o = 0, s = 1;
  if (n && n !== "none") {
    const i = n.match(/matrix(?:3d)?\(([^)]+)\)/);
    if (i) {
      const a = i[1].split(", ").map(parseFloat);
      a.length === 6 ? (r = a[4], o = a[5], s = Math.sqrt(a[0] * a[0] + a[1] * a[1])) : a.length === 16 && (r = a[12], o = a[13], s = a[0]);
    }
  }
  return {
    x: r,
    y: o,
    scale: s
  };
}
const VC = "data-composite-item-active", O4 = [];
function M4(e) {
  const {
    loopFocus: t = !0,
    orientation: n = "both",
    grid: r,
    onLoop: o,
    direction: s,
    highlightedIndex: i,
    onHighlightedIndexChange: a,
    rootRef: l,
    enableHomeAndEndKeys: c = !1,
    stopEventPropagation: u,
    disabledIndices: d,
    modifierKeys: f = O4
  } = e, [h, p] = b.useState(0), g = r != null, m = b.useRef(null), v = ar(m, l), y = b.useRef([]), x = b.useRef(!1), C = i ?? h, w = ye((T, P = !1) => {
    if ((a ?? p)(T), P) {
      const I = y.current[T];
      Eb(m.current, I, s, n);
    }
  }), E = ye((T) => {
    var D;
    if (T.size === 0 || x.current)
      return;
    x.current = !0;
    const P = Array.from(T.keys()), I = P.find((k) => k == null ? void 0 : k.hasAttribute(VC)) ?? null, R = I ? ((D = T.get(I)) == null ? void 0 : D.index) ?? -1 : -1;
    if (R !== -1)
      w(R);
    else if (Qs(P, C, d)) {
      const k = xn(P, {
        disabledIndices: d
      });
      So(P, k) || w(k);
    }
    Eb(m.current, I, s, n);
  });
  pe(() => {
    if (d == null || i != null || !x.current)
      return;
    const T = y.current;
    if (Qs(T, C, d)) {
      const P = xn(T, {
        disabledIndices: d
      });
      So(T, P) || w(P);
    }
  }, [d, i, C, y, w]);
  const S = ye((T, P, I) => o ? o(T, P, I, y) : I), O = ye((T) => {
    const P = T.key === zf || T.key === Yf;
    if (!Iu.has(T.key) || !c && P || T4(T, f) || !m.current)
      return;
    const R = s === "rtl", D = R ? Hf : Bf, k = R ? Bf : Hf, $ = n === "vertical" ? Wf : D, L = n === "vertical" ? Vf : k, A = Ot(T.nativeEvent);
    if (A != null && Cb(A) && !FC(A)) {
      const U = A.selectionStart, j = A.selectionEnd, H = A.value;
      if (U == null || T.shiftKey || U !== j || T.key !== L && U < H.length || T.key !== $ && U > 0)
        return;
    }
    let F = C;
    const N = jl(y, d), V = kf(y, d);
    r != null && (F = r({
      disabledIndices: d,
      elementsRef: y,
      event: T,
      highlightedIndex: C,
      loopFocus: t,
      maxIndex: V,
      minIndex: N,
      onLoop: S,
      orientation: n,
      rtl: R
    }));
    const K = n !== "vertical" && T.key === D || n !== "horizontal" && T.key === Wf, Y = n !== "vertical" && T.key === k || n !== "horizontal" && T.key === Vf;
    c && (T.key === zf ? F = N : T.key === Yf && (F = V)), F === C && (K || Y) && (t && F === V && K ? (F = N, o && (F = o(T, C, F, y))) : t && F === N && Y ? (F = V, o && (F = o(T, C, F, y))) : F = xn(y.current, {
      startingIndex: F,
      decrement: Y,
      disabledIndices: d
    })), F !== C && !So(y.current, F) && (u && T.stopPropagation(), (g || P || K || Y) && T.preventDefault(), w(F, !0), queueMicrotask(() => {
      var U;
      (U = y.current[F]) == null || U.focus();
    }));
  });
  return {
    props: {
      ref: v,
      onFocus(T) {
        const P = m.current, I = Ot(T.nativeEvent);
        !P || I == null || !Cb(I) || I.setSelectionRange(0, I.value.length);
      },
      onKeyDown: O
    },
    highlightedIndex: C,
    onHighlightedIndexChange: w,
    elementsRef: y,
    onMapChange: E,
    relayKeyboardEvent: O
  };
}
function T4(e, t) {
  for (const n of WP)
    if (!t.includes(n) && e.getModifierState(n))
      return !0;
  return !1;
}
function WC(e) {
  const {
    render: t,
    className: n,
    style: r,
    refs: o = Gn,
    props: s = Gn,
    state: i = At,
    stateAttributesMapping: a,
    highlightedIndex: l,
    onHighlightedIndexChange: c,
    orientation: u,
    grid: d,
    loopFocus: f,
    onLoop: h,
    enableHomeAndEndKeys: p,
    onMapChange: g,
    stopEventPropagation: m = !0,
    rootRef: v,
    disabledIndices: y,
    modifierKeys: x,
    highlightItemOnHover: C = !1,
    tag: w = "div",
    ...E
  } = e, S = Fa(), {
    props: O,
    highlightedIndex: M,
    onHighlightedIndexChange: T,
    elementsRef: P,
    onMapChange: I,
    relayKeyboardEvent: R
  } = M4({
    grid: d,
    loopFocus: f,
    onLoop: h,
    orientation: u,
    highlightedIndex: l,
    onHighlightedIndexChange: c,
    rootRef: v,
    stopEventPropagation: m,
    enableHomeAndEndKeys: p,
    direction: S,
    disabledIndices: y,
    modifierKeys: x
  }), D = We(w, e, {
    state: i,
    ref: o,
    props: [O, ...s, E],
    stateAttributesMapping: a
  }), k = b.useMemo(() => ({
    highlightedIndex: M,
    onHighlightedIndexChange: T,
    highlightItemOnHover: C,
    relayKeyboardEvent: R
  }), [M, T, C, R]);
  return /* @__PURE__ */ _(bp.Provider, {
    value: k,
    children: /* @__PURE__ */ _(zu, {
      elementsRef: P,
      onMapChange: ($) => {
        g == null || g($), I($);
      },
      children: D
    })
  });
}
const d0 = /* @__PURE__ */ new Map();
function R4(e, t) {
  const n = JSON.stringify({
    locale: og(e),
    options: t
  }), r = d0.get(n);
  if (r)
    return r;
  const o = new Intl.NumberFormat(e, t);
  return d0.set(n, o), o;
}
function f0(e, t, n) {
  return e == null ? "" : R4(t, n).format(e);
}
function P4(e, t, n) {
  return (e - t) * 100 / (n - t);
}
const _g = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (_g.displayName = "PopoverRootContext");
function Ga(e) {
  const t = b.useContext(_g);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverRootContext is missing. Popover parts must be placed within <Popover.Root>." : tt(47));
  return t;
}
const I4 = {
  ...wu,
  disabled: (e) => e.disabled,
  instantType: (e) => e.instantType,
  openMethod: (e) => e.openMethod,
  openChangeReason: (e) => e.openChangeReason,
  modal: (e) => e.modal,
  focusManagerModal: (e) => e.focusManagerModal,
  stickIfOpen: (e) => e.stickIfOpen,
  titleElementId: (e) => e.titleElementId,
  descriptionElementId: (e) => e.descriptionElementId,
  openOnHover: (e) => e.openOnHover,
  closeDelay: (e) => e.closeDelay,
  adaptiveOrigin: (e) => e.adaptiveOrigin
};
class k4 extends ci {
  constructor(n, r, o) {
    const s = new ui();
    super(D4(n, s, r, o), N4(s), I4);
    ce(this, "setOpen", (n, r) => {
      var d, f;
      const o = r.reason === qt, s = r.reason === Lr && r.event.detail === 0, i = !n && (r.reason === bs || r.reason == null), a = sp(r), l = this.select("activeTriggerId");
      if (!n && r.reason === Hh && r.trigger == null && l != null && (r.trigger = this.context.triggerElements.getById(l) ?? this.select("activeTriggerElement") ?? void 0), (f = (d = this.context).onOpenChange) == null || f.call(d, n, r), r.isCanceled)
        return;
      this.state.floatingRootContext.dispatchOpenChange(n, r);
      const c = () => {
        const h = {
          open: n,
          openChangeReason: r.reason
        };
        gu(h, n, r.trigger, a()), this.update(h);
      };
      o ? (this.set("stickIfOpen", !0), this.context.stickIfOpenTimeout.start(C1, () => {
        this.set("stickIfOpen", !1);
      }), Xn.flushSync(c)) : c();
      let u;
      s ? u = "click" : i ? u = "dismiss" : r.reason === Ro && (u = "focus"), this.set("instantType", u);
    });
  }
}
function D4(e, t, n, r = !1) {
  const o = {
    ...xu(),
    disabled: !1,
    modal: !1,
    focusManagerModal: !1,
    instantType: void 0,
    openMethod: null,
    openChangeReason: null,
    titleElementId: void 0,
    descriptionElementId: void 0,
    stickIfOpen: !0,
    openOnHover: !1,
    closeDelay: 0,
    adaptiveOrigin: void 0,
    ...e
  };
  return o.open && (e == null ? void 0 : e.mounted) === void 0 && (o.mounted = !0), o.floatingRootContext = ip(t, n, r), o;
}
function N4(e) {
  return {
    popupRef: /* @__PURE__ */ b.createRef(),
    onOpenChange: void 0,
    onOpenChangeComplete: void 0,
    triggerFocusTargetRef: /* @__PURE__ */ b.createRef(),
    beforeContentFocusGuardRef: /* @__PURE__ */ b.createRef(),
    stickIfOpenTimeout: new Ln(),
    triggerElements: e
  };
}
function h0({
  props: e
}) {
  const {
    children: t,
    open: n,
    defaultOpen: r = !1,
    onOpenChange: o,
    onOpenChangeComplete: s,
    modal: i = !1,
    handle: a,
    triggerId: l,
    defaultTriggerId: c = null
  } = e, u = $4(a, {
    modal: i,
    open: r,
    openProp: n,
    activeTriggerId: c,
    triggerIdProp: l
  });
  u.useControlledProp("openProp", n), u.useControlledProp("triggerIdProp", l);
  const d = u.useState("open"), f = u.useState("mounted"), h = u.useState("payload");
  u.useContextCallback("onOpenChange", o), u.useContextCallback("onOpenChangeComplete", s), W1(u, d), bu(u);
  const {
    forceUnmount: p
  } = vu(d, u, () => {
    u.update({
      stickIfOpen: !0,
      openChangeReason: null
    });
  });
  u.useSyncedValues({
    modal: i
  }), b.useEffect(() => {
    d || u.context.stickIfOpenTimeout.clear();
  }, [u, d]), b.useImperativeHandle(e.actionsRef, () => ({
    unmount: p,
    close: () => u.setOpen(!1, Ne(au))
  }), [p, u]);
  const g = d || f;
  return /* @__PURE__ */ ee(_g.Provider, {
    value: u,
    children: [a && /* @__PURE__ */ _(pu, {
      handle: a,
      store: u
    }), g && /* @__PURE__ */ _(F4, {
      store: u,
      modal: i
    }), typeof t == "function" ? t({
      payload: h
    }) : t]
  });
}
function A4(e) {
  return Ga(!0) ? /* @__PURE__ */ _(h0, {
    props: e
  }) : /* @__PURE__ */ _(T1, {
    children: /* @__PURE__ */ _(h0, {
      props: e
    })
  });
}
function $4(e, t) {
  const n = op((r, o) => new k4(t, r, o));
  return b.useEffect(() => n.context.stickIfOpenTimeout.disposeEffect(), [n]), n;
}
function F4({
  store: e,
  modal: t
}) {
  const n = e.useState("floatingRootContext"), r = Da(n, {
    outsidePressEvent: {
      // Ensure `aria-hidden` on outside elements is removed immediately
      // on outside press when trapping focus.
      mouse: t === "trap-focus" ? "sloppy" : "intentional",
      touch: "sloppy"
    }
  }), o = r.reference, s = r.floating;
  return yu(e, {
    activeTriggerProps: o,
    inactiveTriggerProps: o,
    popupProps: s
  }), null;
}
const L4 = 300, HC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    disabled: i = !1,
    nativeButton: a = !0,
    handle: l,
    payload: c,
    openOnHover: u = !1,
    delay: d = L4,
    closeDelay: f = 0,
    id: h,
    ...p
  } = t, g = Ga(!0), v = Cu(l) ?? g;
  if (!v)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Trigger> must be either used within a <Popover.Root> component or provided with a handle." : tt(74));
  const y = gn(h), x = v.useState("isTriggerActive", y), C = v.useState("floatingRootContext"), w = v.useState("isOpenedByTrigger", y), E = v.useState("triggerPopupId", y), S = b.useRef(null), {
    registerTrigger: O,
    isMountedByThisTrigger: M
  } = mu(y, S, v, {
    payload: c,
    disabled: i,
    openOnHover: u,
    closeDelay: f
  }), T = v.useState("openChangeReason"), P = v.useState("stickIfOpen"), I = v.useState("openMethod"), R = v.useState("focusManagerModal"), D = Eu(C, {
    enabled: !i && u && (I !== "touch" || T !== Lr),
    mouseOnly: !0,
    move: !1,
    handleClose: Su(),
    restMs: d,
    delay: {
      close: f
    },
    triggerElementRef: S,
    isActiveTrigger: x,
    isClosing: () => v.select("transitionStatus") === "ending"
  }), k = li(C, {
    stickIfOpen: P
  }), $ = _p(() => v.select("open"), (q) => {
    v.set("openMethod", q);
  }), L = v.useState("triggerProps", M), {
    getButtonProps: A,
    buttonRef: F
  } = Wn({
    disabled: i,
    native: a
  }), N = {
    open(q) {
      return q && T === Lr ? wc.open(q) : Ou.open(q);
    }
  }, {
    preFocusGuardRef: V,
    handlePreFocusGuardFocus: K,
    handleFocusTargetFocus: Y
  } = NC(v, S), j = We("button", t, {
    state: {
      disabled: i,
      open: w
    },
    ref: [F, n, O, S],
    props: [k.reference, D, L, $, {
      [qh]: "",
      id: y,
      "aria-haspopup": "dialog",
      "aria-expanded": w,
      "aria-controls": E
    }, p, A],
    stateAttributesMapping: N
  }), H = /* @__PURE__ */ _(b.Fragment, {
    children: j
  }, y);
  return M && !R ? /* @__PURE__ */ ee(b.Fragment, {
    children: [/* @__PURE__ */ _(Vr, {
      ref: V,
      onFocus: K
    }), H, /* @__PURE__ */ _(Vr, {
      ref: v.context.triggerFocusTargetRef,
      onFocus: Y
    })]
  }) : H;
});
process.env.NODE_ENV !== "production" && (HC.displayName = "PopoverTrigger");
const Sg = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Sg.displayName = "PopoverPortalContext");
function V4() {
  const e = b.useContext(Sg);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Portal> is missing." : tt(45));
  return e;
}
const BC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    keepMounted: r = !1,
    ...o
  } = t;
  return Ga().useState("mounted") || r ? /* @__PURE__ */ _(Sg.Provider, {
    value: r,
    children: /* @__PURE__ */ _(ka, {
      ref: n,
      ...o
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (BC.displayName = "PopoverPortal");
const Og = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Og.displayName = "PopoverPositionerContext");
function W4() {
  const e = b.useContext(Og);
  if (!e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverPositionerContext is missing. PopoverPositioner parts must be placed within <Popover.Positioner>." : tt(46));
  return e;
}
const zC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    anchor: i,
    // `useAnchorPositioning` applies the same defaults to the undefined values; the names
    // remain destructured to exclude the props from `elementProps`.
    positionMethod: a,
    side: l,
    align: c,
    sideOffset: u,
    alignOffset: d,
    collisionBoundary: f = "clipping-ancestors",
    collisionPadding: h,
    arrowPadding: p,
    sticky: g,
    disableAnchorTracking: m = !1,
    collisionAvoidance: v = Xh,
    ...y
  } = t, x = Ga(), C = V4(), w = tp(), E = x.useState("floatingRootContext"), S = x.useState("mounted"), O = x.useState("open"), M = x.useState("openChangeReason"), T = x.useState("activeTriggerElement"), P = x.useState("modal"), I = x.useState("openMethod"), R = x.useState("positionerElement"), D = x.useState("instantType"), k = x.useState("transitionStatus"), $ = x.useState("adaptiveOrigin"), L = b.useRef(null), A = hu(R), F = Mu({
    anchor: i,
    floatingRootContext: E,
    positionMethod: a,
    mounted: S,
    side: l,
    sideOffset: u,
    align: c,
    alignOffset: d,
    arrowPadding: p,
    collisionBoundary: f,
    collisionPadding: h,
    sticky: g,
    disableAnchorTracking: m,
    keepMounted: C,
    nodeId: w,
    collisionAvoidance: v,
    adaptiveOrigin: $
  }), N = E.useState("domReferenceElement");
  pe(() => {
    const j = N, H = L.current;
    if (j && (L.current = j), H && j && j !== H) {
      x.set("instantType", void 0);
      const q = new AbortController();
      return A(() => {
        x.set("instantType", "trigger-change");
      }, q.signal), () => {
        q.abort();
      };
    }
  }, [N, A, x]);
  const V = P === !0 && M !== qt;
  fg(O && V, I === "touch", R, T);
  const K = x.useStateSetter("positionerElement"), Y = {
    open: O,
    side: F.side,
    align: F.align,
    anchorHidden: F.anchorHidden,
    instant: D
  }, U = Tu(t, Y, {
    styles: F.positionerStyles,
    transitionStatus: k,
    props: y,
    refs: [n, K],
    hidden: !S,
    inert: !O
  });
  return /* @__PURE__ */ ee(Og.Provider, {
    value: F,
    children: [S && V && /* @__PURE__ */ _(Va, {
      inert: di(!O),
      cutout: T
    }), /* @__PURE__ */ _(M1, {
      id: w,
      children: U
    })]
  });
});
process.env.NODE_ENV !== "production" && (zC.displayName = "PopoverPositioner");
const YC = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (YC.displayName = "ClosePartContext");
function H4() {
  const [e, t] = b.useState(0), n = ye(() => (t((o) => o + 1), () => {
    t((o) => Math.max(0, o - 1));
  }));
  return {
    context: b.useMemo(() => ({
      register: n
    }), [n]),
    hasClosePart: e > 0
  };
}
const jC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    initialFocus: i,
    finalFocus: a,
    ...l
  } = t, c = Ga(), u = W4(), d = vg(!0) != null, {
    context: f,
    hasClosePart: h
  } = H4(), p = c.useState("open"), g = c.useState("openMethod"), m = c.useState("instantType"), v = c.useState("transitionStatus"), y = c.useState("popupProps"), x = c.useState("titleElementId"), C = c.useState("descriptionElementId"), w = c.useState("modal"), E = c.useState("mounted"), S = c.useState("openChangeReason"), O = c.useState("activeTriggerElement"), M = c.useState("floatingRootContext"), T = M.useState("floatingId"), P = c.useState("disabled"), I = c.useState("openOnHover"), R = c.useState("closeDelay");
  Jn({
    open: p,
    ref: c.context.popupRef,
    onComplete() {
      var F, N;
      p && ((N = (F = c.context).onOpenChangeComplete) == null || N.call(F, !0));
    }
  }), up(M, {
    enabled: I && !P,
    closeDelay: R
  });
  const D = i === void 0 ? L1(c.context.popupRef) : i, k = w !== !1 && h;
  c.useSyncedValue("focusManagerModal", k);
  const $ = c.useStateSetter("popupElement"), L = {
    open: p,
    side: u.side,
    align: u.align,
    instant: m,
    transitionStatus: v
  }, A = We("div", t, {
    state: L,
    ref: [n, c.context.popupRef, $],
    props: [y, {
      id: T,
      role: "dialog",
      ...Na,
      "aria-labelledby": x,
      "aria-describedby": C,
      onKeyDown(F) {
        d && Iu.has(F.key) && F.stopPropagation();
      }
    }, La(v), l],
    stateAttributesMapping: $a
  });
  return /* @__PURE__ */ _(cu, {
    context: M,
    openInteractionType: g,
    modal: k,
    disabled: !E || S === qt,
    initialFocus: D,
    returnFocus: a,
    restoreFocus: "popup",
    previousFocusableElement: wt(O) ? O : void 0,
    nextFocusableElement: c.context.triggerFocusTargetRef,
    beforeContentFocusGuardRef: c.context.beforeContentFocusGuardRef,
    children: /* @__PURE__ */ _(YC.Provider, {
      value: f,
      children: A
    })
  });
});
process.env.NODE_ENV !== "production" && (jC.displayName = "PopoverPopup");
const Mg = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Mg.displayName = "ProgressRootContext");
function Xu() {
  const e = b.useContext(Mg);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ProgressRootContext is missing. Progress parts must be placed within <Progress.Root>." : tt(51));
  return e;
}
const Ka = {
  status(e) {
    return {
      [`data-${e}`]: ""
    };
  }
}, UC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    format: r,
    getAriaValueText: o,
    locale: s,
    max: i = 100,
    min: a = 0,
    value: l,
    render: c,
    className: u,
    children: d,
    style: f,
    ...h
  } = t, [p, g] = b.useState();
  let m = "indeterminate", v = null, y = null, x = "", C = "indeterminate progress";
  if (l != null && Number.isFinite(l)) {
    const M = P4(l, a, i);
    v = u0(Number.isNaN(M) ? 0 : M, 0, 100), y = u0(l, a, i), m = y === i ? "complete" : "progressing", x = r ? f0(y, s, r) : f0(v / 100, s, {
      style: "percent"
    }), C = x;
  }
  const w = b.useMemo(() => ({
    status: m
  }), [m]), E = {
    "aria-labelledby": p,
    "aria-valuemax": i,
    "aria-valuemin": a,
    "aria-valuenow": y ?? void 0,
    "aria-valuetext": o ? o(x, l) : C,
    role: "progressbar",
    children: /* @__PURE__ */ ee(b.Fragment, {
      children: [d, /* @__PURE__ */ _("span", {
        role: "presentation",
        style: Pa,
        children: "x"
      })]
    })
  }, S = b.useMemo(() => ({
    formattedValue: x,
    percentageValue: v,
    setLabelId: g,
    state: w,
    value: l
  }), [x, v, g, w, l]), O = We("div", t, {
    state: w,
    ref: n,
    props: [E, h],
    stateAttributesMapping: Ka
  });
  return /* @__PURE__ */ _(Mg.Provider, {
    value: S,
    children: O
  });
});
process.env.NODE_ENV !== "production" && (UC.displayName = "ProgressRoot");
const GC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, {
    state: a
  } = Xu();
  return We("div", t, {
    state: a,
    ref: n,
    props: i,
    stateAttributesMapping: Ka
  });
});
process.env.NODE_ENV !== "production" && (GC.displayName = "ProgressTrack");
const KC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, {
    percentageValue: a,
    state: l
  } = Xu(), c = a == null ? {} : {
    insetInlineStart: 0,
    height: "inherit",
    width: `${a}%`
  };
  return We("div", t, {
    state: l,
    ref: n,
    props: [{
      style: c
    }, i],
    stateAttributesMapping: Ka
  });
});
process.env.NODE_ENV !== "production" && (KC.displayName = "ProgressIndicator");
const qC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    className: r,
    render: o,
    children: s,
    style: i,
    ...a
  } = t, {
    value: l,
    formattedValue: c,
    state: u
  } = Xu(), d = u.status === "indeterminate";
  return We("span", t, {
    state: u,
    ref: n,
    props: [{
      "aria-hidden": !0,
      children: typeof s == "function" ? s(d ? "indeterminate" : c, l) : d ? null : c
    }, a],
    stateAttributesMapping: Ka
  });
});
process.env.NODE_ENV !== "production" && (qC.displayName = "ProgressValue");
const XC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    id: i,
    ...a
  } = t, {
    setLabelId: l,
    state: c
  } = Xu(), u = l4(i, l);
  return We("span", t, {
    state: c,
    ref: n,
    props: [{
      id: u,
      role: "presentation"
    }, a],
    stateAttributesMapping: Ka
  });
});
process.env.NODE_ENV !== "production" && (XC.displayName = "ProgressLabel");
const Tg = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Tg.displayName = "SwitchRootContext");
function B4() {
  const e = b.useContext(Tg);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SwitchRootContext is missing. Switch parts must be placed within <Switch.Root>." : tt(63));
  return e;
}
const ZC = {
  ...Ww,
  checked(e) {
    return e ? {
      "data-checked": ""
    } : {
      "data-unchecked": ""
    };
  }
}, QC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    checked: r,
    className: o,
    defaultChecked: s,
    "aria-labelledby": i,
    form: a,
    id: l,
    inputRef: c,
    name: u,
    nativeButton: d = !1,
    onCheckedChange: f,
    readOnly: h = !1,
    required: p = !1,
    disabled: g = !1,
    render: m,
    uncheckedValue: v,
    value: y,
    style: x,
    ...C
  } = t, {
    clearErrors: w
  } = Yw(), {
    state: E,
    setTouched: S,
    setDirty: O,
    validityData: M,
    setFilled: T,
    setFocused: P,
    validationMode: I,
    disabled: R,
    name: D,
    validation: k
  } = hi(), {
    labelId: $
  } = ju(), L = R || g, A = D ?? u, F = b.useRef(null), N = ar(F, c, k.inputRef), V = b.useRef(null), K = gn(), Y = rg({
    id: l,
    implicit: !1,
    controlRef: V
  }), U = d ? void 0 : Y, [j, H] = Fr({
    controlled: r,
    default: !!s,
    name: "Switch",
    state: "checked"
  });
  Bw(V, K, j, void 0, !L, u), pe(() => {
    F.current && T(F.current.checked);
  }, [T]), Ls(j, () => {
    w(A), O(j !== M.initialValue), T(j), k.change(j);
  });
  const {
    getButtonProps: q,
    buttonRef: B
  } = Wn({
    disabled: L,
    native: d
  }), X = r4(i, $, F, !d, U), te = {
    id: d ? Y : K,
    role: "switch",
    "aria-checked": j,
    "aria-readonly": h || void 0,
    "aria-required": p || void 0,
    "aria-labelledby": X,
    onFocus() {
      L || P(!0);
    },
    onBlur() {
      const Q = F.current;
      !Q || L || (S(!0), P(!1), I === "onBlur" && k.commit(Q.checked));
    },
    onClick(Q) {
      if (h || L)
        return;
      Q.preventDefault();
      const re = F.current;
      re && Zi(re, Q);
    }
  }, J = {
    ...k.getValidationProps(L),
    checked: j,
    disabled: L,
    form: a,
    id: U,
    name: A,
    required: p,
    style: A ? zh : Pa,
    tabIndex: -1,
    type: "checkbox",
    "aria-hidden": !0,
    ref: N,
    onChange(Q) {
      if (Q.nativeEvent.defaultPrevented)
        return;
      if (h) {
        Q.preventDefault();
        return;
      }
      const re = Q.currentTarget.checked, fe = Ne(Cn, Q.nativeEvent);
      f == null || f(re, fe), !fe.isCanceled && H(re);
    },
    onClick(Q) {
      Q.stopPropagation();
    },
    onFocus() {
      var Q;
      (Q = V.current) == null || Q.focus();
    },
    // React <19 sets an empty value if `undefined` is passed explicitly
    // To avoid this, we only set the value if it's defined
    ...y !== void 0 ? {
      value: y
    } : At
  }, G = b.useMemo(() => ({
    ...E,
    checked: j,
    disabled: L,
    readOnly: h,
    required: p
  }), [E, j, L, h, p]), ne = We("span", t, {
    state: G,
    ref: [n, V, B],
    props: [te, C, q, (Q) => k.getValidationProps(L, Q)],
    stateAttributesMapping: ZC
  });
  return /* @__PURE__ */ ee(Tg.Provider, {
    value: G,
    children: [ne, !j && A && v !== void 0 && /* @__PURE__ */ _("input", {
      type: "hidden",
      form: a,
      name: A,
      value: v,
      disabled: L
    }), /* @__PURE__ */ _("input", {
      ...J,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (QC.displayName = "SwitchRoot");
const JC = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, a = B4();
  return We("span", t, {
    state: a,
    ref: n,
    stateAttributesMapping: ZC,
    props: i
  });
});
process.env.NODE_ENV !== "production" && (JC.displayName = "SwitchThumb");
const Rg = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Rg.displayName = "TabsRootContext");
function Pg() {
  const e = b.useContext(Rg);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsRootContext is missing. Tabs parts must be placed within <Tabs.Root>." : tt(64));
  return e;
}
const Zu = {
  tabActivationDirection: (e) => ({
    "data-activation-direction": e
  })
}, eE = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    className: r,
    defaultValue: o = 0,
    onValueChange: s,
    orientation: i = "horizontal",
    render: a,
    value: l,
    style: c,
    ...u
  } = t, d = t.defaultValue !== void 0, f = b.useRef([]), [h, p] = b.useState(() => /* @__PURE__ */ new Map()), [g, m] = Fr({
    controlled: l,
    default: o,
    name: "Tabs",
    state: "value"
  }), v = l !== void 0, [y, x] = b.useState(() => /* @__PURE__ */ new Map()), C = b.useRef(void 0), w = b.useCallback((B) => uh(y, B), [y]), [E, S] = b.useState(() => ({
    previousValue: g,
    tabActivationDirection: "none"
  })), {
    previousValue: O,
    tabActivationDirection: M
  } = E;
  let T = M, P = !1;
  O !== g && (T = p0(O, g, i, y), P = O != null && g != null && w(g) == null);
  const I = P ? O : g, R = O !== I || M !== T;
  pe(() => {
    R && S({
      previousValue: I,
      tabActivationDirection: T
    });
  }, [I, R, T]);
  const D = ye((B, X) => {
    const te = p0(g, B, i, y);
    X.activationDirection = te, s == null || s(B, X), !X.isCanceled && m(B);
  }), k = ye((B, X) => {
    s == null || s(B, Ne(X, void 0, void 0, {
      activationDirection: "none"
    }));
  }), $ = ye((B, X) => (p((te) => {
    const J = new Map(te);
    return J.set(B, X), J;
  }), () => {
    p((te) => {
      if (te.get(B) !== X)
        return te;
      const J = new Map(te);
      return J.delete(B), J;
    });
  })), L = b.useCallback((B) => h.get(B), [h]), A = b.useCallback((B) => {
    for (const X of y.values())
      if (B === X.value)
        return X.id;
  }, [y]), F = b.useMemo(() => ({
    getTabElementBySelectedValue: w,
    getTabIdByPanelValue: A,
    getTabPanelIdByValue: L,
    onValueChange: D,
    orientation: i,
    registerMountedTabPanel: $,
    setTabMap: x,
    tabActivationDirection: T,
    value: g
  }), [w, A, L, D, i, $, x, T, g]), N = b.useMemo(() => {
    for (const B of y.values())
      if (B.value === g)
        return B;
  }, [y, g]), V = b.useMemo(() => {
    for (const B of y.values())
      if (!B.disabled)
        return B.value;
  }, [y]), K = b.useRef(!d), Y = b.useRef(o), U = b.useRef(d), j = b.useRef(!1);
  pe(() => {
    var G;
    if (v)
      return;
    function B(ne, Q) {
      m(ne), S({
        previousValue: ne,
        tabActivationDirection: "none"
      }), k(ne, Q), K.current = !1;
    }
    if (y.size === 0) {
      j.current && g !== null && !((G = C.current) != null && G.isConnected) && B(null, $m);
      return;
    }
    j.current = !0, C.current = y.keys().next().value;
    const X = N == null ? void 0 : N.disabled, te = N == null && g !== null;
    if (!X && g === Y.current && (U.current = !1), U.current && X && g === Y.current)
      return;
    const J = K.current;
    if (X || te) {
      const ne = V ?? null;
      if (g === ne) {
        K.current = !1;
        return;
      }
      let Q = $m;
      J ? Q = Fm : X && (Q = a1), B(ne, Q);
      return;
    }
    J && N != null && (k(g, Fm), K.current = !1);
  }, [V, v, k, N, m, y, g]);
  const q = We("div", t, {
    state: {
      orientation: i,
      tabActivationDirection: T
    },
    ref: n,
    props: u,
    stateAttributesMapping: Zu
  });
  return /* @__PURE__ */ _(Rg.Provider, {
    value: F,
    children: /* @__PURE__ */ _(zu, {
      elementsRef: f,
      children: q
    })
  });
});
process.env.NODE_ENV !== "production" && (eE.displayName = "TabsRoot");
function uh(e, t) {
  for (const [n, r] of e.entries())
    if (t === r.value)
      return n;
  return null;
}
function p0(e, t, n, r) {
  if (e == null || t == null)
    return "none";
  const [o, s, i] = n === "horizontal" ? ["left", "left", "right"] : ["top", "up", "down"], a = uh(r, e), l = uh(r, t);
  if (a == null || l == null)
    return a !== l && (typeof e == "number" || typeof e == "string") && typeof e == typeof t ? t > e ? i : s : "none";
  const c = a.getBoundingClientRect()[o], u = l.getBoundingClientRect()[o];
  return u < c ? s : u > c ? i : "none";
}
const Ig = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ig.displayName = "TabsListContext");
function z4() {
  const e = b.useContext(Ig);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsListContext is missing. TabsList parts must be placed within <Tabs.List>." : tt(65));
  return e;
}
const tE = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    className: r,
    disabled: o = !1,
    render: s,
    value: i,
    id: a,
    nativeButton: l = !0,
    style: c,
    ...u
  } = t, {
    value: d,
    getTabPanelIdByValue: f,
    onValueChange: h,
    orientation: p,
    tabActivationDirection: g
  } = Pg(), {
    activateOnFocus: m,
    registerTabResizeObserverElement: v,
    tabsListElement: y
  } = z4(), {
    highlightedIndex: x,
    onHighlightedIndexChange: C
  } = Ru(), w = gn(a), E = b.useMemo(() => ({
    disabled: o,
    id: w,
    value: i
  }), [o, w, i]), {
    compositeProps: S,
    compositeRef: O,
    index: M
    // hook is used instead of the CompositeItem component
    // because the index is needed for Tab internals
  } = IC({
    metadata: E
  }), T = i === d, P = b.useRef(!1), I = b.useRef(null), R = ye((j) => {
    var H;
    (H = I.current) == null || H.call(I), I.current = j ? v(j) : null;
  });
  pe(() => {
    if (P.current) {
      P.current = !1;
      return;
    }
    if (!(T && M > -1 && x !== M))
      return;
    const j = y;
    if (j != null) {
      const H = fn(Ze(j));
      if (H && Ie(j, H))
        return;
    }
    o || C(M);
  }, [T, M, x, C, o, y]);
  const {
    getButtonProps: D,
    buttonRef: k
  } = Wn({
    disabled: o,
    native: l,
    focusableWhenDisabled: !0
  }), $ = f(i), L = b.useRef(!1), A = b.useRef(!1);
  function F(j) {
    h(i, Ne(Cn, j.nativeEvent, void 0, {
      activationDirection: "none"
    }));
  }
  function N(j) {
    T || o || F(j);
  }
  function V(j) {
    T || o || m && (!L.current || // keyboard or touch focus
    A.current) && F(j);
  }
  function K(j) {
    if (T || o)
      return;
    L.current = !0, A.current = j.button === 0;
    const H = Ze(j.currentTarget);
    function q() {
      L.current = !1, A.current = !1, H.removeEventListener("pointerup", q), H.removeEventListener("pointercancel", q);
    }
    H.addEventListener("pointerup", q), H.addEventListener("pointercancel", q);
  }
  return We("button", t, {
    state: {
      disabled: o,
      active: T,
      orientation: p,
      tabActivationDirection: g
    },
    ref: [n, k, O, R],
    props: [S, {
      role: "tab",
      "aria-controls": $,
      "aria-selected": T,
      id: w,
      onClick: N,
      onFocus: V,
      onPointerDown: K,
      [VC]: T ? "" : void 0,
      onKeyDownCapture() {
        P.current = !0;
      }
    }, u, D],
    stateAttributesMapping: Zu
  });
});
process.env.NODE_ENV !== "production" && (tE.displayName = "TabsTab");
const Y4 = {
  ...Zu,
  ...co
}, nE = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    className: r,
    value: o,
    render: s,
    keepMounted: i = !1,
    style: a,
    ...l
  } = t, {
    value: c,
    getTabIdByPanelValue: u,
    orientation: d,
    tabActivationDirection: f,
    registerMountedTabPanel: h
  } = Pg(), p = gn(), {
    ref: g,
    index: m
  } = Es(), v = o === c, {
    mounted: y,
    transitionStatus: x,
    setMounted: C
  } = vs(v), w = !y, E = u(o), S = {
    hidden: w,
    orientation: d,
    tabActivationDirection: f,
    transitionStatus: x
  }, O = b.useRef(null), M = We("div", t, {
    state: S,
    ref: [n, g, O],
    props: [{
      "aria-labelledby": E,
      hidden: w,
      id: p,
      role: "tabpanel",
      tabIndex: v ? 0 : -1,
      inert: di(!v),
      // Computed key: a plain literal key fails the DOM-props excess property check.
      "data-index": m
    }, l],
    stateAttributesMapping: Y4
  });
  return Jn({
    open: v,
    ref: O,
    onComplete() {
      v || C(!1);
    }
  }), pe(() => {
    if (!(p == null || w && !i))
      return h(o, p);
  }, [w, i, o, p, h]), i || y ? M : null;
});
process.env.NODE_ENV !== "production" && (nE.displayName = "TabsPanel");
const rE = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    activateOnFocus: r = !1,
    className: o,
    loopFocus: s = !0,
    render: i,
    style: a,
    ...l
  } = t, {
    orientation: c,
    setTabMap: u,
    tabActivationDirection: d
  } = Pg(), [f, h] = b.useState(0), [p, g] = b.useState(null), m = b.useRef(/* @__PURE__ */ new Set()), v = b.useRef(/* @__PURE__ */ new Set()), y = b.useRef(null);
  pe(() => {
    if (typeof ResizeObserver > "u")
      return;
    const O = new ResizeObserver(() => {
      m.current.forEach((M) => {
        M();
      });
    });
    return y.current = O, p && O.observe(p), v.current.forEach((M) => {
      O.observe(M);
    }), () => {
      O.disconnect(), y.current = null;
    };
  }, [p]);
  const x = ye((O) => (m.current.add(O), () => {
    m.current.delete(O);
  })), C = ye((O) => {
    var M;
    return v.current.add(O), (M = y.current) == null || M.observe(O), () => {
      var T;
      v.current.delete(O), (T = y.current) == null || T.unobserve(O);
    };
  }), w = {
    orientation: c,
    tabActivationDirection: d
  }, E = {
    "aria-orientation": c === "vertical" ? "vertical" : void 0,
    role: "tablist"
  }, S = b.useMemo(() => ({
    activateOnFocus: r,
    registerIndicatorUpdateListener: x,
    registerTabResizeObserverElement: C,
    tabsListElement: p
  }), [r, x, C, p]);
  return /* @__PURE__ */ _(Ig.Provider, {
    value: S,
    children: /* @__PURE__ */ _(WC, {
      render: i,
      className: o,
      style: a,
      state: w,
      refs: [n, g],
      props: [E, l],
      stateAttributesMapping: Zu,
      highlightedIndex: f,
      enableHomeAndEndKeys: !0,
      loopFocus: s,
      orientation: c,
      onHighlightedIndexChange: h,
      onMapChange: u,
      disabledIndices: Gn
    })
  });
});
process.env.NODE_ENV !== "production" && (rE.displayName = "TabsList");
const kg = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (kg.displayName = "ToastContext");
function Qu() {
  const e = b.useContext(kg);
  if (!e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: useToastManager must be used within <Toast.Provider>." : tt(73));
  return e;
}
let g0 = 0;
function oE(e) {
  return g0 += 1, `${e}-${Math.random().toString(36).slice(2, 6)}-${g0}`;
}
function Xd(e, t) {
  if (typeof e == "string")
    return {
      description: e
    };
  if (typeof e == "function") {
    const n = e(t);
    return typeof n == "string" ? {
      description: n
    } : n;
  }
  return e;
}
function Zd(e) {
  const t = /* @__PURE__ */ new Map();
  let n = 0, r = 0;
  return e.forEach((o, s) => {
    const i = o.transitionStatus === "ending";
    t.set(o.id, {
      value: o,
      domIndex: s,
      visibleIndex: i ? -1 : n,
      offsetY: r
    }), r += o.height || 0, i || (n += 1);
  }), t;
}
function Qd(e, t) {
  let n = 0;
  return e.map((r) => {
    if (r.transitionStatus === "ending")
      return r;
    const o = n >= t;
    return n += 1, r.limited === o ? r : {
      ...r,
      limited: o
    };
  });
}
const Er = {
  toasts: (e) => e.toasts,
  isEmpty: (e) => e.toasts.length === 0,
  toast: (e, t) => {
    var n;
    return (n = e.toastMetadata.get(t)) == null ? void 0 : n.value;
  },
  toastIndex: (e, t) => {
    var n;
    return ((n = e.toastMetadata.get(t)) == null ? void 0 : n.domIndex) ?? -1;
  },
  toastOffsetY: (e, t) => {
    var n;
    return ((n = e.toastMetadata.get(t)) == null ? void 0 : n.offsetY) ?? 0;
  },
  toastVisibleIndex: (e, t) => {
    var n;
    return ((n = e.toastMetadata.get(t)) == null ? void 0 : n.visibleIndex) ?? -1;
  },
  focused: (e) => e.focused,
  expanded: (e) => e.hovering || e.focused,
  expandedOrOutOfFocus: (e) => e.hovering || e.focused || !e.isWindowFocused,
  prevFocusElement: (e) => e.prevFocusElement
};
class j4 extends ci {
  constructor(n) {
    super({
      ...n,
      toastMetadata: Zd(n.toasts)
    }, {}, Er);
    ce(this, "timers", /* @__PURE__ */ new Map());
    ce(this, "areTimersPaused", !1);
    ce(this, "setViewport", (n) => {
      this.set("viewport", n);
    });
    ce(this, "disposeEffect", () => () => {
      this.timers.forEach((n) => {
        var r;
        (r = n.timeout) == null || r.clear();
      }), this.timers.clear();
    });
    ce(this, "addToast", (n) => {
      const {
        timeout: r,
        limit: o
      } = this.state, s = n.id || oE("toast");
      if (n.id) {
        const c = Er.toast(this.state, n.id);
        if (c)
          if (c.transitionStatus === "ending")
            this.removeToast(n.id, !0);
          else {
            const {
              id: u,
              transitionStatus: d,
              ...f
            } = n;
            return this.updateToastInternal(n.id, f, !0, !0), n.id;
          }
      }
      const i = {
        ...n,
        id: s,
        updateKey: 0,
        transitionStatus: "starting"
      }, a = [i, ...this.state.toasts];
      this.setToasts(Qd(a, o));
      const l = i.timeout ?? r;
      return i.type !== "loading" && l > 0 && this.scheduleTimer(s, l, () => this.closeToast(s)), Er.expandedOrOutOfFocus(this.state) && this.pauseTimers(), s;
    });
    ce(this, "updateToast", (n, r) => {
      this.updateToastInternal(n, r, !1, !0);
    });
    ce(this, "updateToastInternal", (n, r, o = !1, s = !1) => {
      const {
        timeout: i,
        toasts: a
      } = this.state, l = Er.toast(this.state, n);
      if (!l || l.transitionStatus === "ending")
        return;
      const c = {
        ...l,
        ...r,
        ...s && {
          updateKey: l.updateKey + 1
        }
      };
      this.setToasts(a.map((v) => v.id === n ? c : v));
      const u = c.timeout ?? i, d = l.timeout ?? i, f = Object.hasOwn(r, "timeout"), h = c.transitionStatus !== "ending" && c.type !== "loading" && u > 0, p = this.timers.has(n), g = d !== u, m = l.type === "loading";
      if (!h && p) {
        this.clearTimer(n);
        return;
      }
      h && (!p || g || f || m || o) && (this.clearTimer(n), this.scheduleTimer(n, u, () => this.closeToast(n)), Er.expandedOrOutOfFocus(this.state) && this.pauseTimers());
    });
    ce(this, "closeToast", (n) => {
      const r = n === void 0, {
        limit: o,
        toasts: s
      } = this.state;
      let i;
      if (r)
        i = s, this.clearTimers();
      else {
        const c = Er.toast(this.state, n);
        if (!c)
          return;
        i = [c], this.clearTimer(n);
      }
      const a = s.map((c) => r || c.id === n ? {
        ...c,
        transitionStatus: "ending",
        height: 0
      } : c), l = Qd(a, o);
      this.setToasts(l, !l.some((c) => c.transitionStatus !== "ending")), i.forEach((c) => {
        var u;
        c.transitionStatus !== "ending" && ((u = c.onClose) == null || u.call(c));
      }), this.handleFocusManagement(n);
    });
    ce(this, "promiseToast", (n, r) => {
      const o = Xd(r.loading), s = this.addToast({
        ...o,
        type: "loading"
      }), i = n.then((a) => {
        const l = Xd(r.success, a);
        return this.updateToast(s, {
          ...l,
          type: "success",
          timeout: l.timeout
        }), a;
      }).catch((a) => {
        const l = Xd(r.error, a);
        return this.updateToast(s, {
          ...l,
          type: "error",
          timeout: l.timeout
        }), Promise.reject(a);
      });
      return {}.hasOwnProperty.call(r, "setPromise") && r.setPromise(i), i;
    });
    ce(this, "handleDocumentPointerDown", (n) => {
      if (n.pointerType !== "touch")
        return;
      const r = Ot(n);
      Ie(this.state.viewport, r) || (this.resumeTimers(), this.update({
        hovering: !1,
        focused: !1
      }));
    });
  }
  syncProviderProps(n, r) {
    const o = this.state.limit !== r;
    if (this.state.timeout === n && !o)
      return;
    const s = {
      timeout: n,
      limit: r
    };
    if (o) {
      const i = Qd(this.state.toasts, r);
      s.toasts = i, s.toastMetadata = Zd(i);
    }
    this.update(s);
  }
  removeToast(n, r = !1) {
    var a;
    const o = Er.toastIndex(this.state, n);
    if (o === -1)
      return;
    const s = this.state.toasts[o];
    r || (a = s == null ? void 0 : s.onRemove) == null || a.call(s);
    const i = [...this.state.toasts];
    i.splice(o, 1), this.setToasts(i);
  }
  pauseTimers() {
    this.areTimersPaused || (this.areTimersPaused = !0, this.timers.forEach((n) => {
      n.timeout && (n.timeout.clear(), n.remaining = Math.max(n.remaining - (Date.now() - n.start), 0));
    }));
  }
  resumeTimers() {
    this.areTimersPaused && (this.areTimersPaused = !1, this.timers.forEach((n, r) => {
      n.remaining = n.remaining > 0 ? n.remaining : n.delay, n.timeout ?? (n.timeout = Ln.create()), n.timeout.start(n.remaining, () => {
        this.handleTimerFired(r), n.callback();
      }), n.start = Date.now();
    }));
  }
  restoreFocusToPrevElement() {
    var n;
    (n = this.state.prevFocusElement) == null || n.focus({
      preventScroll: !0
    });
  }
  scheduleTimer(n, r, o) {
    const s = Date.now(), a = !Er.expandedOrOutOfFocus(this.state) ? Ln.create() : void 0;
    a == null || a.start(r, () => {
      this.handleTimerFired(n), o();
    }), this.timers.set(n, {
      timeout: a,
      start: s,
      delay: r,
      remaining: r,
      callback: o
    });
  }
  clearTimers() {
    this.timers.forEach((n) => {
      var r;
      (r = n.timeout) == null || r.clear();
    }), this.timers.clear(), this.areTimersPaused = !1;
  }
  clearTimer(n) {
    var o;
    const r = this.timers.get(n);
    (o = r == null ? void 0 : r.timeout) == null || o.clear(), this.timers.delete(n), this.resetPausedStateIfNoTimersRemain();
  }
  handleTimerFired(n) {
    this.timers.delete(n), this.resetPausedStateIfNoTimersRemain();
  }
  resetPausedStateIfNoTimersRemain() {
    this.timers.size === 0 && (this.areTimersPaused = !1);
  }
  setToasts(n, r = n.length === 0) {
    const o = {
      toasts: n,
      toastMetadata: Zd(n)
    };
    r && (o.hovering = !1, o.focused = !1), this.update(o);
  }
  handleFocusManagement(n) {
    var l, c;
    const r = fn(Ze(this.state.viewport));
    if (!this.state.viewport || !Ie(this.state.viewport, r) || !hc(r))
      return;
    if (n === void 0) {
      this.restoreFocusToPrevElement();
      return;
    }
    const o = Er.toasts(this.state), s = Er.toastIndex(this.state, n), i = (u, d) => {
      for (let f = u; f >= 0 && f < o.length; f += d)
        if (o[f].transitionStatus !== "ending")
          return o[f];
      return null;
    }, a = i(s + 1, 1) ?? i(s - 1, -1);
    a ? (c = (l = a.ref) == null ? void 0 : l.current) == null || c.focus() : this.restoreFocusToPrevElement();
  }
}
const sE = function(t) {
  const {
    children: n,
    timeout: r = 5e3,
    limit: o = 3,
    toastManager: s
  } = t, i = bn(() => new j4({
    timeout: r,
    limit: o,
    viewport: null,
    toasts: [],
    hovering: !1,
    focused: !1,
    isWindowFocused: !0,
    prevFocusElement: null
  })).current;
  return Jc(i.disposeEffect), b.useEffect(function() {
    return s ? s[" subscribe"](({
      action: c,
      options: u
    }) => {
      const d = u.id;
      c === "promise" && u.promise ? i.promiseToast(u.promise, u) : c === "update" && d ? i.updateToast(d, u) : c === "close" ? i.closeToast(d) : i.addToast(u);
    }) : void 0;
  }, [i, s]), /* @__PURE__ */ ee(kg.Provider, {
    value: i,
    children: [/* @__PURE__ */ _(U4, {
      store: i,
      timeout: r,
      limit: o
    }), n]
  });
};
process.env.NODE_ENV !== "production" && (sE.displayName = "ToastProvider");
function U4(e) {
  const {
    store: t,
    timeout: n,
    limit: r
  } = e;
  return pe(() => {
    t.syncProviderProps(n, r);
  }, [t, n, r]), null;
}
const iE = /* @__PURE__ */ b.forwardRef(function(t, n) {
  var F;
  const {
    render: r,
    className: o,
    style: s,
    children: i,
    ...a
  } = t, l = Qu(), c = Sn(), u = b.useRef(!1), d = b.useRef(!1), f = b.useRef(!1), h = l.useState("isEmpty"), p = l.useState("toasts"), g = l.useState("focused"), m = l.useState("expanded"), v = l.useState("prevFocusElement"), y = (F = p[0]) == null ? void 0 : F.height, x = p.some((N) => N.transitionStatus === "ending"), C = p.filter((N) => N.priority === "high");
  b.useEffect(() => {
    const N = l.state.viewport;
    if (!N || h)
      return;
    const V = Ht(N), K = Ze(N);
    function Y(H) {
      H.key === "F6" && Ot(H) !== N && (H.preventDefault(), l.set("prevFocusElement", fn(K)), N == null || N.focus({
        preventScroll: !0
      }), l.pauseTimers(), l.set("focused", !0));
    }
    function U(H) {
      Ot(H) === V && (l.set("isWindowFocused", !1), l.pauseTimers());
    }
    function j(H) {
      if (H.relatedTarget)
        return;
      const q = Ot(H), B = fn(Ze(N));
      (q === V || !Ie(N, q) || !hc(B)) && l.resumeTimers(), c.start(0, () => l.set("isWindowFocused", !0));
    }
    return mr(qe(V, "keydown", Y), qe(V, "blur", U, !0), qe(V, "focus", j, !0), qe(K, "pointerdown", l.handleDocumentPointerDown, !0));
  }, [l, c, h]);
  function w(N) {
    var K, Y;
    u.current = !0;
    const V = N.relatedTarget === l.state.viewport ? p.find((U) => U.transitionStatus !== "ending" && !U.limited) : void 0;
    V ? (Y = (K = V.ref) == null ? void 0 : K.current) == null || Y.focus() : l.restoreFocusToPrevElement();
  }
  function E(N) {
    N.key === "Tab" && N.shiftKey && Ot(N.nativeEvent) === l.state.viewport && (N.preventDefault(), l.restoreFocusToPrevElement());
  }
  function S() {
    l.state.toasts.some((V) => V.transitionStatus === "ending") || f.current || !d.current || (l.state.isWindowFocused && l.resumeTimers(), l.set("hovering", !1), d.current = !1);
  }
  b.useEffect(S, [x, l]);
  function O() {
    l.pauseTimers(), l.set("hovering", !0), d.current = !1;
  }
  function M() {
    l.state.isWindowFocused && l.resumeTimers();
  }
  function T() {
    d.current = !0, S();
  }
  function P(N) {
    N.pointerType === "touch" && (f.current = !0);
  }
  function I(N) {
    N.pointerType === "touch" && (f.current = !1, S());
  }
  function R() {
    if (u.current) {
      u.current = !1;
      return;
    }
    g || hc(fn(Ze(l.state.viewport))) && (l.set("focused", !0), l.pauseTimers());
  }
  function D(N) {
    !g || Ie(l.state.viewport, N.relatedTarget) || (l.set("focused", !1), M());
  }
  const k = {
    tabIndex: -1,
    role: "region",
    "aria-live": "polite",
    "aria-atomic": !1,
    "aria-relevant": "additions text",
    "aria-label": "Notifications",
    onMouseEnter: O,
    onMouseMove: O,
    onMouseLeave: T,
    onFocus: R,
    onBlur: D,
    onKeyDown: E,
    onClick: R,
    onPointerDown: P,
    onPointerUp: I,
    onPointerCancel: I,
    style: {
      "--toast-frontmost-height": y ? `${y}px` : void 0
    }
  }, $ = {
    expanded: m
  }, L = !h && v && /* @__PURE__ */ _(Vr, {
    onFocus: w
  }), A = We("div", t, {
    ref: [n, l.setViewport],
    state: $,
    props: [k, a, {
      children: /* @__PURE__ */ ee(b.Fragment, {
        children: [L, i, L]
      })
    }]
  });
  return /* @__PURE__ */ ee(b.Fragment, {
    children: [L, A, !g && C.length > 0 && /* @__PURE__ */ _("div", {
      style: Pa,
      children: C.map((N) => /* @__PURE__ */ ee("div", {
        role: "alert",
        "aria-atomic": !0,
        children: [/* @__PURE__ */ _("div", {
          children: N.title
        }), /* @__PURE__ */ _("div", {
          children: N.description
        })]
      }, N.id))
    })]
  });
});
process.env.NODE_ENV !== "production" && (iE.displayName = "ToastViewport");
const Dg = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Dg.displayName = "ToastRootContext");
function Ju() {
  const e = b.useContext(Dg);
  if (!e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ToastRootContext is missing. Toast parts must be used within <Toast.Root>." : tt(66));
  return e;
}
const G4 = {
  ...co,
  swipeDirection(e) {
    return e ? {
      "data-swipe-direction": e
    } : null;
  }
}, m0 = 40, K4 = 10, b0 = 0.5, q4 = 1, X4 = `${zT},${YT}`, aE = /* @__PURE__ */ b.forwardRef(function(t, n) {
  var ae;
  const {
    toast: r,
    render: o,
    className: s,
    swipeDirection: i = ["down", "right"],
    style: a,
    ...l
  } = t, c = ((ae = r.positionerProps) == null ? void 0 : ae.anchor) !== void 0;
  let u = [];
  c || (u = Array.isArray(i) ? i : [i]);
  const d = u.length > 0, f = Qu(), [h, p] = b.useState(void 0), [g, m] = b.useState(!1), [v, y] = b.useState(!1), [x, C] = b.useState({
    x: 0,
    y: 0
  }), [w, E] = b.useState({
    x: 0,
    y: 0,
    scale: 1
  }), [S, O] = b.useState(), [M, T] = b.useState(), [P, I] = b.useState(null), R = b.useRef(null), D = b.useRef(void 0), k = b.useRef({
    x: 0,
    y: 0
  }), $ = b.useRef({
    x: 0,
    y: 0,
    scale: 1
  }), L = b.useRef(void 0), A = b.useRef(0), F = b.useRef(!1), N = b.useRef({
    x: 0,
    y: 0
  }), V = b.useRef(!1), K = b.useRef({
    x: 0,
    y: 0
  }), Y = b.useRef(null), U = b.useRef(null), j = f.useState("toastIndex", r.id), H = f.useState("toastVisibleIndex", r.id), q = f.useState("toastOffsetY", r.id), B = f.useState("focused"), X = f.useState("expanded");
  Jn({
    open: r.transitionStatus !== "ending",
    ref: R,
    onComplete() {
      r.transitionStatus === "ending" && f.removeToast(r.id);
    }
  });
  const te = ye((W = !1) => {
    const Z = R.current;
    if (!Z)
      return;
    const me = Z.style.height;
    Z.style.height = "auto";
    const ie = Z.offsetHeight;
    Z.style.height = me;
    function oe() {
      f.updateToastInternal(r.id, {
        ref: R,
        height: ie,
        transitionStatus: void 0
      });
    }
    W ? Xn.flushSync(oe) : oe();
  });
  pe(() => {
    const W = D.current;
    r.transitionStatus !== "starting" && W === r.id || (W !== void 0 && (p(void 0), E({
      x: 0,
      y: 0,
      scale: 1
    }), J({
      x: 0,
      y: 0
    })), D.current = r.id, te());
  }, [te, r.id, r.transitionStatus]);
  function J(W) {
    K.current = W, C(W);
  }
  pe(() => () => {
    var W;
    (W = U.current) == null || W.abort();
  }, []);
  function G(W, Z) {
    const me = (he) => he > 0 ? he ** b0 : -(Math.abs(he) ** b0), ie = W > 0 && !u.includes("right") || W < 0 && !u.includes("left"), oe = Z > 0 && !u.includes("down") || Z < 0 && !u.includes("up");
    return {
      x: ie ? me(W) : W,
      y: oe ? me(Z) : Z
    };
  }
  const ne = ye((W) => {
    var Re;
    if (W.pointerId !== Y.current)
      return;
    Y.current = null, (Re = U.current) == null || Re.abort(), U.current = null, m(!1), y(!1), I(null);
    const Z = $.current;
    if (W.type === "pointercancel" || F.current) {
      J({
        x: Z.x,
        y: Z.y
      }), p(void 0);
      return;
    }
    const me = K.current, ie = me.x - Z.x, oe = me.y - Z.y;
    let he;
    for (const Ae of u)
      if (qd(Ae, ie, oe) > m0) {
        he = Ae;
        break;
      }
    he ? (p(he), f.closeToast(r.id)) : (J({
      x: Z.x,
      y: Z.y
    }), p(void 0));
  });
  function Q(W) {
    var Ae, Ue;
    if (W.button !== 0)
      return;
    W.pointerType === "touch" && f.pauseTimers();
    const Z = Ot(W.nativeEvent);
    if (Z == null ? void 0 : Z.closest(`button,a,input,textarea,[role="button"],${X4}`))
      return;
    F.current = !1, L.current = void 0, A.current = 0, Y.current = W.pointerId, k.current = {
      x: W.clientX,
      y: W.clientY
    }, N.current = k.current;
    const ie = W.currentTarget, oe = S4(ie);
    $.current = oe, E(oe), J({
      x: oe.x,
      y: oe.y
    }), f.set("hovering", !0), m(!0), y(!1), I(null), V.current = !0, (Ae = U.current) == null || Ae.abort();
    const he = new AbortController();
    U.current = he;
    const Re = Ze(ie);
    Re.addEventListener("pointerup", ne, {
      signal: he.signal
    }), Re.addEventListener("pointercancel", ne, {
      signal: he.signal
    }), (Ue = ie.setPointerCapture) == null || Ue.call(ie, W.pointerId);
  }
  function re(W) {
    if (W.pointerId !== Y.current)
      return;
    W.preventDefault(), V.current && (k.current = {
      x: W.clientX,
      y: W.clientY
    }, V.current = !1);
    const {
      clientY: Z,
      clientX: me,
      movementX: ie,
      movementY: oe
    } = W;
    (oe < 0 && Z > N.current.y || oe > 0 && Z < N.current.y) && (N.current = {
      x: N.current.x,
      y: Z
    }), (ie < 0 && me > N.current.x || ie > 0 && me < N.current.x) && (N.current = {
      x: me,
      y: N.current.y
    });
    const he = me - k.current.x, Re = Z - k.current.y, Ae = Z - N.current.y, Ue = me - N.current.x;
    let Ke = P;
    if (!v && Math.sqrt(he * he + Re * Re) >= q4) {
      y(!0);
      const Pe = u.includes("left") || u.includes("right"), Ge = u.includes("up") || u.includes("down");
      if (Pe && Ge) {
        const Le = Math.abs(he), be = Math.abs(Re);
        Ke = Le > be ? "horizontal" : "vertical", I(Ke);
      }
    }
    let Be;
    if (!L.current)
      Ke === "vertical" ? Re > 0 ? Be = "down" : Re < 0 && (Be = "up") : Ke === "horizontal" ? he > 0 ? Be = "right" : he < 0 && (Be = "left") : Math.abs(he) >= Math.abs(Re) ? Be = he > 0 ? "right" : "left" : Be = Re > 0 ? "down" : "up", Be && u.includes(Be) && (L.current = Be, A.current = qd(Be, he, Re), p(Be));
    else {
      const Qt = L.current, Pe = qd(Qt, Ue, Ae);
      Pe > m0 ? (F.current = !1, p(Qt)) : !(u.includes("left") && u.includes("right")) && !(u.includes("up") && u.includes("down")) && A.current - Pe >= K4 && (F.current = !0);
    }
    const nt = G(he, Re);
    let at = $.current.x, Wt = $.current.y;
    const Mt = u.includes("left") || u.includes("right"), Bt = u.includes("up") || u.includes("down");
    Ke !== "vertical" && Mt && (at += nt.x), Ke !== "horizontal" && Bt && (Wt += nt.y), J({
      x: at,
      y: Wt
    });
  }
  function fe(W) {
    if (W.key === "Escape") {
      if (!R.current || !Ie(R.current, fn(Ze(R.current))))
        return;
      f.closeToast(r.id);
    }
  }
  b.useEffect(() => {
    const W = R.current;
    if (!d || !W)
      return;
    function Z(me) {
      Y.current === null || !Ie(W, Ot(me)) || me.preventDefault();
    }
    return qe(W, "touchmove", Z, {
      passive: !1
    });
  }, [d]);
  function le() {
    const W = x.x - w.x, Z = x.y - w.y;
    return {
      transition: g ? "none" : void 0,
      // While swiping, freeze the element at its current visual transform so it doesn't snap to the
      // end position.
      transform: g ? `translateX(${x.x}px) translateY(${x.y}px) scale(${w.scale})` : void 0,
      "--toast-swipe-movement-x": `${W}px`,
      "--toast-swipe-movement-y": `${Z}px`
    };
  }
  const Ee = r.priority === "high", se = {
    role: Ee ? "alertdialog" : "dialog",
    tabIndex: 0,
    "aria-modal": !1,
    "aria-labelledby": S,
    "aria-describedby": M,
    "aria-hidden": Ee && !B ? !0 : void 0,
    onPointerDown: d ? Q : void 0,
    onPointerMove: d ? re : void 0,
    onPointerUp: d ? ne : void 0,
    onPointerCancel: d ? ne : void 0,
    onKeyDown: fe,
    inert: di(r.limited),
    style: {
      ...le(),
      "--toast-index": r.transitionStatus === "ending" ? j : H,
      "--toast-offset-y": `${q}px`,
      "--toast-height": r.height ? `${r.height}px` : void 0
    }
  }, _e = b.useMemo(() => ({
    toast: r,
    setTitleId: O,
    setDescriptionId: T,
    recalculateHeight: te,
    visibleIndex: H,
    expanded: X
  }), [r, O, T, te, H, X]), xe = {
    transitionStatus: r.transitionStatus,
    expanded: X,
    limited: r.limited || !1,
    type: r.type,
    swiping: g,
    swipeDirection: h
  }, ge = We("div", t, {
    ref: [n, R],
    state: xe,
    stateAttributesMapping: G4,
    props: [se, l]
  });
  return /* @__PURE__ */ _(Dg.Provider, {
    value: _e,
    children: ge
  });
});
process.env.NODE_ENV !== "production" && (aE.displayName = "ToastRoot");
const lE = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, {
    visibleIndex: a,
    expanded: l,
    recalculateHeight: c
  } = Ju(), u = b.useRef(null);
  pe(() => {
    c();
    const h = u.current;
    if (!h || typeof ResizeObserver != "function" || typeof MutationObserver != "function")
      return;
    const p = new ResizeObserver(() => c(!0)), g = new MutationObserver(() => c(!0));
    return p.observe(h), g.observe(h, {
      childList: !0,
      subtree: !0,
      characterData: !0
    }), () => {
      p.disconnect(), g.disconnect();
    };
  }, [c]);
  const d = a > 0;
  return We("div", t, {
    ref: [n, u],
    state: {
      expanded: l,
      behind: d
    },
    props: i
  });
});
process.env.NODE_ENV !== "production" && (lE.displayName = "ToastContent");
function cE(e) {
  return e == null || typeof e == "boolean" || e === "" ? !1 : Array.isArray(e) ? e.some(cE) : !0;
}
function uE(e) {
  return /* @__PURE__ */ b.isValidElement(e) && cE(e.props.children);
}
function dE(e, t, n) {
  const {
    toast: r,
    setTitleId: o,
    setDescriptionId: s
  } = Ju(), i = n === "title" ? o : s, a = t ?? (n === "title" ? r.title : r.description);
  return {
    id: ko(e),
    children: a,
    type: r.type,
    setId: i
  };
}
function fE(e, t, n) {
  const r = uE(e);
  return pe(() => {
    if (r)
      return n(t), () => {
        n((o) => o === t ? void 0 : o);
      };
  }, [r, t, n]), r ? e : null;
}
const hE = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    id: i,
    children: a,
    ...l
  } = t, {
    id: c,
    children: u,
    type: d,
    setId: f
  } = dE(i, a, "description"), p = We("p", t, {
    ref: n,
    state: {
      type: d
    },
    props: {
      ...l,
      id: c,
      children: u
    }
  });
  return fE(p, c, f);
});
process.env.NODE_ENV !== "production" && (hE.displayName = "ToastDescription");
const pE = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    id: i,
    children: a,
    ...l
  } = t, {
    id: c,
    children: u,
    type: d,
    setId: f
  } = dE(i, a, "title"), p = We("h2", t, {
    ref: n,
    state: {
      type: d
    },
    props: {
      ...l,
      id: c,
      children: u
    }
  });
  return fE(p, c, f);
});
process.env.NODE_ENV !== "production" && (pE.displayName = "ToastTitle");
const gE = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    disabled: i,
    nativeButton: a = !0,
    ...l
  } = t, c = Qu(), {
    toast: u,
    expanded: d
  } = Ju(), [f, h] = b.useState(!1), {
    getButtonProps: p,
    buttonRef: g
  } = Wn({
    disabled: i,
    native: a
  }), m = {
    type: u.type
  };
  return We("button", t, {
    ref: [n, g],
    state: m,
    props: [{
      "aria-hidden": !d && !f,
      onClick() {
        c.closeToast(u.id);
      },
      onFocus() {
        h(!0);
      },
      onBlur() {
        h(!1);
      }
    }, l, p]
  });
});
process.env.NODE_ENV !== "production" && (gE.displayName = "ToastClose");
const mE = /* @__PURE__ */ b.forwardRef(function(t, n) {
  var g;
  const {
    render: r,
    className: o,
    style: s,
    disabled: i,
    nativeButton: a = !0,
    ...l
  } = t, {
    toast: c
  } = Ju(), u = ((g = c.actionProps) == null ? void 0 : g.children) ?? l.children, {
    getButtonProps: d,
    buttonRef: f
  } = Wn({
    disabled: i,
    native: a
  }), h = {
    type: c.type
  }, p = We("button", t, {
    ref: [n, f],
    state: h,
    props: [l, c.actionProps, d, {
      children: u
    }]
  });
  return uE(p) ? p : null;
});
process.env.NODE_ENV !== "production" && (mE.displayName = "ToastAction");
const bE = /* @__PURE__ */ b.forwardRef(function(t, n) {
  return /* @__PURE__ */ _(hp, {
    ref: n,
    ...t
  });
});
process.env.NODE_ENV !== "production" && (bE.displayName = "ToastPortal");
function Z4() {
  const e = Qu(), t = e.useState("toasts");
  return b.useMemo(() => ({
    toasts: t,
    add: e.addToast,
    close: e.closeToast,
    update: e.updateToast,
    promise: e.promiseToast
  }), [t, e]);
}
function Q4() {
  const e = /* @__PURE__ */ new Set();
  function t(n) {
    e.forEach((r) => r(n));
  }
  return {
    // This should be private aside from ToastProvider needing to access it.
    // https://x.com/drosenwasser/status/1816947740032872664
    " subscribe": function(r) {
      return e.add(r), () => {
        e.delete(r);
      };
    },
    add(n) {
      const r = n.id || oE("toast"), o = {
        ...n,
        id: r,
        transitionStatus: "starting"
      };
      return t({
        action: "add",
        options: o
      }), r;
    },
    close(n) {
      t({
        action: "close",
        options: {
          id: n
        }
      });
    },
    update(n, r) {
      t({
        action: "update",
        options: {
          ...r,
          id: n
        }
      });
    },
    promise(n, r) {
      let o = n;
      return t({
        action: "promise",
        options: {
          ...r,
          promise: n,
          setPromise(s) {
            o = s;
          }
        }
      }), o;
    }
  };
}
const Ng = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ng.displayName = "ToggleGroupContext");
function J4() {
  return b.useContext(Ng);
}
const vE = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    className: r,
    defaultPressed: o = !1,
    disabled: s = !1,
    form: i,
    // never participates in form validation
    onPressedChange: a,
    pressed: l,
    render: c,
    type: u,
    // cannot change button type
    value: d,
    nativeButton: f = !0,
    style: h,
    ...p
  } = t, g = gn(d || void 0), m = J4(), v = (m == null ? void 0 : m.value) ?? [], y = m ? void 0 : o, x = (s || (m == null ? void 0 : m.disabled)) ?? !1;
  process.env.NODE_ENV !== "production" && b.useEffect(() => {
    m && d === void 0 && m.isValueInitialized && da("A `<Toggle>` component rendered in a `<ToggleGroup>` has no explicit `value` prop.", "This will cause issues between the Toggle Group and Toggle values.", "Provide the `<Toggle>` with a `value` prop matching the `<ToggleGroup>` values prop type.");
  }, [m, d, m == null ? void 0 : m.isValueInitialized]);
  const [C, w] = Fr({
    controlled: m ? g !== void 0 && v.indexOf(g) > -1 : l,
    default: y,
    name: "Toggle",
    state: "pressed"
  }), {
    getButtonProps: E,
    buttonRef: S
  } = Wn({
    disabled: x,
    native: f
  }), O = {
    disabled: x,
    pressed: C
  }, M = [S, n], T = [{
    "aria-pressed": C,
    onClick(R) {
      var $;
      const D = !C, k = Ne(Cn, R.nativeEvent);
      a == null || a(D, k), !k.isCanceled && (g && (($ = m == null ? void 0 : m.setGroupValue) == null || $.call(m, g, D, k)), !k.isCanceled && w(D));
    }
  }, p, E], P = We("button", t, {
    enabled: !m,
    state: O,
    ref: M,
    props: T
  }), I = b.useMemo(() => ({
    disabled: x,
    focusableWhenDisabled: !1
  }), [x]);
  return m ? /* @__PURE__ */ _(kC, {
    tag: "button",
    render: c,
    className: r,
    style: h,
    metadata: I,
    state: O,
    refs: M,
    props: T
  }) : P;
});
process.env.NODE_ENV !== "production" && (vE.displayName = "Toggle");
const yE = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (yE.displayName = "ToolbarGroupContext");
function e9() {
  return b.useContext(yE);
}
const xE = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    defaultValue: r,
    disabled: o = !1,
    loopFocus: s = !0,
    onValueChange: i,
    orientation: a = "horizontal",
    multiple: l = !1,
    value: c,
    className: u,
    render: d,
    style: f,
    ...h
  } = t, p = vg(!0), g = e9(), m = c !== void 0 || r !== void 0, v = ((p == null ? void 0 : p.disabled) ?? !1) || ((g == null ? void 0 : g.disabled) ?? !1) || o, [y, x] = Fr({
    controlled: c,
    default: c === void 0 ? r ?? Gn : void 0,
    name: "ToggleGroup",
    state: "value"
  }), C = ye((M, T, P) => {
    let I;
    l ? (I = y.slice(), T ? I.push(M) : I.splice(y.indexOf(M), 1)) : I = T ? [M] : [], i == null || i(I, P), !P.isCanceled && x(I);
  }), w = {
    disabled: v,
    multiple: l,
    orientation: a
  }, E = b.useMemo(() => ({
    disabled: v,
    setGroupValue: C,
    value: y,
    isValueInitialized: m
  }), [v, C, y, m]), S = {
    role: "group"
  }, O = We("div", t, {
    enabled: !!p,
    state: w,
    ref: n,
    props: [S, h]
  });
  return /* @__PURE__ */ _(Ng.Provider, {
    value: E,
    children: p ? O : /* @__PURE__ */ _(WC, {
      render: d,
      className: u,
      style: f,
      state: w,
      refs: [n],
      props: [S, h],
      loopFocus: s,
      enableHomeAndEndKeys: !0,
      orientation: a
    })
  });
});
process.env.NODE_ENV !== "production" && (xE.displayName = "ToggleGroup");
const t9 = Qn(
  "inline-flex flex-shrink-0 items-center py-0.5 text-xs font-medium text-foundations-bolder",
  {
    variants: {
      variant: {
        primary: "border border-info-subtle bg-info-subtler",
        secondary: "bg-gold-400 text-white",
        warning: "border border-warning-subtle bg-warning-subtler text-warning",
        dimmed: "bg-foundations-bolder text-white",
        default: "border border-foundations-subtle bg-foundations-subtlest text-foundations-subtle",
        success: "border border-success-subtle bg-success-subtler",
        danger: "border border-danger-subtle bg-danger-subtler",
        pending: "bg-warning-subtler text-gold-400"
      },
      size: {
        sm: "px-2",
        md: "px-2.5"
      },
      shape: {
        pill: "rounded-full",
        square: "rounded-md"
      }
    },
    defaultVariants: {
      size: "md",
      shape: "pill",
      variant: "default"
    }
  }
), n9 = Oe.forwardRef(
  ({ variant: e, size: t, shape: n, className: r, render: o, ...s }, i) => {
    const a = {
      className: de(t9({ variant: e, size: t, shape: n, className: r })),
      "data-slot": "badge"
    };
    return ai({
      defaultTagName: "div",
      render: o,
      ref: i,
      props: _n(a, s)
    });
  }
);
n9.displayName = "Badge";
const r9 = Qn(
  "relative flex w-full flex-shrink-0 items-center overflow-hidden rounded-md p-4",
  {
    variants: {
      state: {
        success: "",
        danger: "",
        informative: "",
        warning: "",
        neutral: ""
      },
      contrast: {
        low: "border text-foundations-boldest [&_.close-btn]:text-foundations-subtle [&_.icon]:h-5 [&_.icon]:w-5 [&_.icon_svg]:h-4 [&_.icon_svg]:w-4",
        medium: "text-foundations-inverse shadow-2 [&_.icon]:h-8 [&_.icon]:w-8 [&_.icon_svg]:h-6 [&_.icon_svg]:w-6"
      },
      fullWidth: {
        true: "",
        false: "max-w-[25rem]"
      }
    },
    defaultVariants: {
      state: "informative",
      contrast: "low",
      fullWidth: !1
    },
    compoundVariants: [
      {
        state: "success",
        contrast: "low",
        className: "border-success-subtle bg-success-subtler [&_.icon]:bg-success-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "danger",
        contrast: "low",
        className: "border-danger-subtle bg-danger-subtler [&_.icon]:bg-danger-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "informative",
        contrast: "low",
        className: "border-info-subtle bg-info-subtler [&_.icon]:bg-info-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "warning",
        contrast: "low",
        className: "border-warning-subtle bg-warning-subtler [&_.icon]:bg-warning-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "neutral",
        contrast: "low",
        className: "border-foundations-subtle bg-foundations-subtelst-02 text-foundations-subtle [&_.icon]:bg-transparent [&_.icon]:text-foundations-subtle"
      },
      {
        state: "success",
        contrast: "medium",
        className: "bg-success-subtle text-foundations-boldest [&_.icon]:bg-success-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "danger",
        contrast: "medium",
        className: "bg-danger-subtle text-foundations-boldest [&_.icon]:bg-danger-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "informative",
        contrast: "medium",
        className: "bg-info-subtle text-foundations-boldest [&_.icon]:bg-info-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "warning",
        contrast: "medium",
        className: "bg-warning-subtle text-foundations-boldest [&_.icon]:bg-warning-bold [&_.icon]:text-foundations-inverse"
      }
    ]
  }
), o9 = b.forwardRef(
  ({
    title: e,
    state: t = "neutral",
    contrast: n,
    fullWidth: r,
    className: o,
    onClose: s,
    actions: i,
    content: a,
    Icon: l,
    ...c
  }, u) => /* @__PURE__ */ ee(
    "div",
    {
      ref: u,
      className: de(r9({ state: t, contrast: n, fullWidth: r }), o),
      ...c,
      children: [
        /* @__PURE__ */ _(wE, { state: t, CustomIcon: l }),
        /* @__PURE__ */ ee("div", { className: "ml-4 flex-1", children: [
          /* @__PURE__ */ _("div", { className: "text-sm font-medium", children: e }),
          a && /* @__PURE__ */ _("div", { className: "mt-2", children: a })
        ] }),
        i && /* @__PURE__ */ _("div", { className: "ml-4 space-x-2", children: i }),
        s && /* @__PURE__ */ _(
          "button",
          {
            onClick: s,
            className: "close-btn ml-2 flex-shrink-0 rounded-sm hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500",
            children: /* @__PURE__ */ _(Du, { className: "h-4 w-4 " })
          }
        )
      ]
    }
  )
);
o9.displayName = "Alert";
const s9 = {
  success: ys,
  danger: kd,
  informative: Mp,
  warning: kd,
  neutral: kd
}, wE = ({
  state: e,
  CustomIcon: t
}) => {
  const n = s9[e];
  return /* @__PURE__ */ _("div", { className: "icon flex flex-shrink-0 items-center justify-center rounded-full", children: t ? /* @__PURE__ */ _(t, {}) : /* @__PURE__ */ _(n, {}) });
};
wE.displayName = "AlertIcon";
const i9 = b.forwardRef(
  ({ className: e, disableHover: t, render: n, ...r }, o) => {
    const s = {
      className: de(
        "block rounded-lg border border-foundations-subtle bg-foundations-default p-6 transition-colors focus:border-info-bold focus:outline-none focus:ring-1 focus:ring-info-bold [&:has(.link-overlay:focus)]:border-info-bold [&:has(.link-overlay:focus)]:ring-1 [&:has(.link-overlay:focus)]:ring-info-bold",
        !t && "hover:border-foundations-bold hover:shadow-3",
        e
      ),
      "data-slot": "card"
    };
    return ai({
      defaultTagName: "div",
      render: n,
      ref: o,
      props: _n(s, r)
    });
  }
);
i9.displayName = "Card";
const a9 = b.forwardRef(
  ({ asChild: e, className: t, ...n }, r) => /* @__PURE__ */ _(
    e ? Bu : "div",
    {
      ref: r,
      className: de(
        "relative [&_button]:relative [&_button]:z-[1] [&_a:not(.link-overlay)]:relative [&_a:not(.link-overlay)]:z-[1]",
        t
      ),
      ...n
    }
  )
);
a9.displayName = "LinkBox";
const l9 = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "a",
  {
    ref: n,
    className: de(
      "link-overlay before:absolute before:inset-0 focus:outline-none",
      e
    ),
    ...t
  }
));
l9.displayName = "LinkOverlay";
const v0 = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 66,
    viewBox: "0 0 184 150",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ ee("g", { id: "Illustrations/Empty States/08", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 653",
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ ee("g", { id: "Mask Group 3", children: [
        /* @__PURE__ */ ee("g", { id: "Group 26805", children: [
          /* @__PURE__ */ _("g", { id: "Group", children: /* @__PURE__ */ _(
            "path",
            {
              id: "Path 25918",
              d: "M39.5 30.6754C38.3371 30.9512 37.2627 31.5449 36.4038 32.4038C35.1848 33.6228 34.5 35.2761 34.5 37V62C34.5 63.7239 35.1848 65.3772 36.4038 66.5962C37.6228 67.8152 39.2761 68.5 41 68.5H176C177.724 68.5 179.377 67.8152 180.596 66.5962C181.815 65.3772 182.5 63.7239 182.5 62V37C182.5 35.2761 181.815 33.6228 180.596 32.4038C179.377 31.1848 177.724 30.5 176 30.5H41H39.5V30.6754Z",
              className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]",
              strokeWidth: 3
            }
          ) }),
          /* @__PURE__ */ ee("g", { id: "Group 26775", children: [
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5617",
                d: "M105 40H79C77.3431 40 76 41.3431 76 43C76 44.6569 77.3431 46 79 46H105C106.657 46 108 44.6569 108 43C108 41.3431 106.657 40 105 40Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5618",
                d: "M123 53H79C77.3431 53 76 54.3431 76 56C76 57.6569 77.3431 59 79 59H123C124.657 59 126 57.6569 126 56C126 54.3431 124.657 53 123 53Z",
                className: "fill-[theme(backgroundColor.foundations-subtle)]"
              }
            )
          ] }),
          /* @__PURE__ */ ee("g", { id: "Group 26804", children: [
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5624",
                d: "M68 49.5C68 41.4919 61.5081 35 53.5 35C45.4919 35 39 41.4919 39 49.5C39 57.5081 45.4919 64 53.5 64C61.5081 64 68 57.5081 68 49.5Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ _("g", { id: "bx-search", children: /* @__PURE__ */ _(
              "path",
              {
                id: "Path 25920",
                d: "M52.6007 54.194C53.842 54.1939 55.0477 53.7785 56.0257 53.014L59.1007 56.089L60.0897 55.1L57.0137 52.024C57.7865 51.0248 58.1981 49.7934 58.1815 48.5303C58.1648 47.2672 57.7208 46.047 56.9219 45.0686C56.123 44.0901 55.0162 43.4111 53.782 43.1422C52.5478 42.8733 51.2588 43.0303 50.1253 43.5877C48.9917 44.1451 48.0804 45.07 47.5398 46.2117C46.9992 47.3533 46.8612 48.6444 47.1483 49.8746C47.4354 51.1047 48.1306 52.2013 49.1208 52.9857C50.1109 53.7701 51.3375 54.196 52.6007 54.194ZM52.6007 44.4C53.4314 44.4 54.2434 44.6464 54.9341 45.1079C55.6248 45.5694 56.1631 46.2253 56.481 46.9928C56.7989 47.7602 56.8821 48.6047 56.72 49.4194C56.5579 50.2341 56.1579 50.9825 55.5705 51.5699C54.9832 52.1573 54.2348 52.5573 53.4201 52.7193C52.6054 52.8814 51.7609 52.7982 50.9934 52.4803C50.226 52.1624 49.57 51.6241 49.1085 50.9334C48.647 50.2427 48.4007 49.4307 48.4007 48.6C48.4007 47.4861 48.8432 46.4178 49.6308 45.6302C50.4185 44.8425 51.4868 44.4 52.6007 44.4Z",
                className: "fill-[theme(backgroundColor.foundations-default)]"
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ ee("g", { id: "Group 26784", children: [
          /* @__PURE__ */ _("g", { id: "Group_2", children: /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5623",
              d: "M161 81.5H26C22.4101 81.5 19.5 84.4101 19.5 88V113C19.5 116.59 22.4101 119.5 26 119.5H161C164.59 119.5 167.5 116.59 167.5 113V88C167.5 84.4102 164.59 81.5 161 81.5Z",
              className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]",
              strokeWidth: 3
            }
          ) }),
          /* @__PURE__ */ ee("g", { id: "Group 26775_2", children: [
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5617_2",
                d: "M90 91H64C62.3431 91 61 92.3431 61 94C61 95.6569 62.3431 97 64 97H90C91.6569 97 93 95.6569 93 94C93 92.3431 91.6569 91 90 91Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5618_2",
                d: "M108 104H64C62.3431 104 61 105.343 61 107C61 108.657 62.3431 110 64 110H108C109.657 110 111 108.657 111 107C111 105.343 109.657 104 108 104Z",
                className: "fill-[theme(backgroundColor.foundations-subtle)]"
              }
            )
          ] }),
          /* @__PURE__ */ ee("g", { id: "Group 26807", children: [
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5624_2",
                d: "M53 100.5C53 92.4919 46.5081 86 38.5 86C30.4919 86 24 92.4919 24 100.5C24 108.508 30.4919 115 38.5 115C46.5081 115 53 108.508 53 100.5Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ _("g", { id: "bx-search_2", children: /* @__PURE__ */ _(
              "path",
              {
                id: "Path 25920_2",
                d: "M37.6007 105.194C38.842 105.194 40.0477 104.778 41.0257 104.014L44.1007 107.089L45.0897 106.1L42.0137 103.024C42.7865 102.025 43.1981 100.793 43.1815 99.5303C43.1648 98.2672 42.7208 97.047 41.9219 96.0686C41.123 95.0901 40.0162 94.4111 38.782 94.1422C37.5478 93.8733 36.2588 94.0303 35.1253 94.5877C33.9917 95.1451 33.0804 96.07 32.5398 97.2117C31.9992 98.3533 31.8612 99.6444 32.1483 100.875C32.4354 102.105 33.1306 103.201 34.1208 103.986C35.1109 104.77 36.3375 105.196 37.6007 105.194ZM37.6007 95.4C38.4314 95.4 39.2434 95.6464 39.9341 96.1079C40.6248 96.5694 41.1631 97.2253 41.481 97.9928C41.7989 98.7602 41.8821 99.6047 41.72 100.419C41.5579 101.234 41.1579 101.983 40.5705 102.57C39.9832 103.157 39.2348 103.557 38.4201 103.719C37.6054 103.881 36.7609 103.798 35.9934 103.48C35.226 103.162 34.57 102.624 34.1085 101.933C33.647 101.243 33.4007 100.431 33.4007 99.6C33.4007 98.4861 33.8432 97.4178 34.6308 96.6302C35.4185 95.8425 36.4868 95.4 37.6007 95.4Z",
                className: "fill-[theme(backgroundColor.foundations-default)]"
              }
            ) })
          ] })
        ] })
      ] })
    ] })
  }
), c9 = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 150 153",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ ee("g", { id: "Illustrations/Empty States/07", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 653",
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Subtraction 1",
          d: "M109.755 47.2509L109.748 47.2439C108.398 45.9026 107.328 44.3068 106.599 42.549C106.102 41.3514 105.77 40.0949 105.61 38.8138C105.395 37.0834 103.972 35.5 101.996 35.5H47.9978C46.0262 35.5 44.6038 37.0766 44.3853 38.8043C43.9832 41.9829 42.5372 44.9584 40.2478 47.2478C37.9584 49.5372 34.9829 50.9832 31.8043 51.3853C30.0766 51.6038 28.5 53.0262 28.5 54.9978V148C28.5 149.933 30.067 151.5 32 151.5H118C119.933 151.5 121.5 149.933 121.5 148V55.0044C121.5 53.0279 119.916 51.6052 118.186 51.3897C116.905 51.2301 115.648 50.8984 114.45 50.4015C112.692 49.6721 111.097 48.6013 109.755 47.2509Z",
          strokeWidth: 3,
          className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 665",
          d: "M75 102C88.2548 102 99 91.2548 99 78C99 64.7452 88.2548 54 75 54C61.7452 54 51 64.7452 51 78C51 91.2548 61.7452 102 75 102Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ),
      /* @__PURE__ */ _("g", { id: "ic_add_48px", children: /* @__PURE__ */ _(
        "path",
        {
          id: "Path 25936",
          d: "M84.8995 87.8997C84.1184 88.6807 82.8521 88.6807 82.0711 87.8997L76.4142 82.2428C75.6332 81.4618 74.3668 81.4618 73.5858 82.2428L67.9289 87.8997C67.1479 88.6807 65.8816 88.6807 65.1005 87.8997C64.3195 87.1186 64.3195 85.8523 65.1005 85.0712L70.7574 79.4144C71.5384 78.6333 71.5384 77.367 70.7574 76.5859L65.1005 70.9291C64.3195 70.148 64.3195 68.8817 65.1005 68.1007C65.8816 67.3196 67.1479 67.3196 67.9289 68.1007L73.5858 73.7575C74.3668 74.5386 75.6332 74.5386 76.4142 73.7575L82.0711 68.1007C82.8521 67.3196 84.1184 67.3196 84.8995 68.1007C85.6805 68.8817 85.6805 70.148 84.8995 70.9291L79.2426 76.5859C78.4616 77.367 78.4616 78.6333 79.2426 79.4144L84.8995 85.0712C85.6805 85.8523 85.6805 87.1186 84.8995 87.8997Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ) }),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5617",
          d: "M88 108H62C60.3431 108 59 109.343 59 111C59 112.657 60.3431 114 62 114H88C89.6569 114 91 112.657 91 111C91 109.343 89.6569 108 88 108Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5618",
          d: "M97 120H53C51.3431 120 50 121.343 50 123C50 124.657 51.3431 126 53 126H97C98.6569 126 100 124.657 100 123C100 121.343 98.6569 120 97 120Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      )
    ] })
  }
), sB = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ ee("g", { id: "Illustrations/Empty States/10", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 653",
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ ee("g", { id: "Group 1489", children: [
        /* @__PURE__ */ ee("g", { id: "Group 3", children: [
          /* @__PURE__ */ _(
            "rect",
            {
              id: "Rectangle 1",
              x: 34,
              y: 46,
              width: 67,
              height: 39,
              rx: 3,
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ _(
            "circle",
            {
              id: "Ellipse 1",
              cx: 68,
              cy: 65,
              r: 12,
              className: "fill-[theme(backgroundColor.foundations-subtlest)]"
            }
          )
        ] }),
        /* @__PURE__ */ ee("g", { id: "Group 1", children: [
          /* @__PURE__ */ _(
            "rect",
            {
              id: "Rectangle 1_2",
              x: 49,
              y: 65,
              width: 67,
              height: 39,
              rx: 3,
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "circle",
            {
              id: "Ellipse 1_2",
              cx: 83,
              cy: 84,
              r: 12,
              className: "fill-[theme(backgroundColor.foundations-default)]"
            }
          )
        ] })
      ] })
    ] })
  }
), iB = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 194,
    height: 168,
    viewBox: "0 0 194 168",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ ee("g", { id: "Illustrations/Empty States/01", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5625",
          d: "M159 0H39C33.4772 0 29 5.37258 29 12V156C29 162.627 33.4772 168 39 168H159C164.523 168 169 162.627 169 156V12C169 5.37258 164.523 0 159 0Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ ee("g", { id: "Group 26800", children: [
        /* @__PURE__ */ _("g", { id: "Group", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Path 25918",
            d: "M49.5 64.6754C48.3371 64.9512 47.2627 65.5449 46.4038 66.4038C45.1848 67.6228 44.5 69.2761 44.5 71V96C44.5 97.7239 45.1848 99.3772 46.4038 100.596C47.6228 101.815 49.2761 102.5 51 102.5H186C187.724 102.5 189.377 101.815 190.596 100.596C191.815 99.3772 192.5 97.7239 192.5 96V71C192.5 69.2761 191.815 67.6228 190.596 66.4038C189.377 65.1848 187.724 64.5 186 64.5H51H49.5V64.6754Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ ee("g", { id: "Group 26775", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617",
              d: "M125 74H99C97.3431 74 96 75.3431 96 77C96 78.6569 97.3431 80 99 80H125C126.657 80 128 78.6569 128 77C128 75.3431 126.657 74 125 74Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618",
              d: "M143 87H99C97.3431 87 96 88.3431 96 90C96 91.6569 97.3431 93 99 93H143C144.657 93 146 91.6569 146 90C146 88.3431 144.657 87 143 87Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] }),
        /* @__PURE__ */ _("g", { id: "Group 26799", children: /* @__PURE__ */ _("g", { id: "Group 26756", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 647",
            d: "M76.5 93C81.7467 93 86 88.7467 86 83.5C86 78.2533 81.7467 74 76.5 74C71.2533 74 67 78.2533 67 83.5C67 88.7467 71.2533 93 76.5 93Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ) }) })
      ] }),
      /* @__PURE__ */ ee("g", { id: "Group 26798", children: [
        /* @__PURE__ */ _("g", { id: "Group_2", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Path 25919",
            d: "M6.5 112.675C5.33714 112.951 4.26267 113.545 3.40381 114.404C2.18482 115.623 1.5 117.276 1.5 119V144C1.5 145.724 2.18482 147.377 3.40381 148.596C4.62279 149.815 6.27609 150.5 8 150.5H143C144.724 150.5 146.377 149.815 147.596 148.596C148.815 147.377 149.5 145.724 149.5 144V119C149.5 117.276 148.815 115.623 147.596 114.404C146.377 113.185 144.724 112.5 143 112.5H8H6.5V112.675Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ ee("g", { id: "Group 26775_2", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_2",
              d: "M68 122H42C40.3431 122 39 123.343 39 125C39 126.657 40.3431 128 42 128H68C69.6569 128 71 126.657 71 125C71 123.343 69.6569 122 68 122Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_2",
              d: "M86 135H42C40.3431 135 39 136.343 39 138C39 139.657 40.3431 141 42 141H86C87.6569 141 89 139.657 89 138C89 136.343 87.6569 135 86 135Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] }),
        /* @__PURE__ */ _("g", { id: "Group 26796", children: /* @__PURE__ */ _("g", { id: "Group 26757", children: /* @__PURE__ */ _("g", { id: "Ellipse 648", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Vector",
            d: "M20.5 141C25.7467 141 30 136.747 30 131.5C30 126.253 25.7467 122 20.5 122C15.2533 122 11 126.253 11 131.5C11 136.747 15.2533 141 20.5 141Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ) }) }) })
      ] }),
      /* @__PURE__ */ ee("g", { id: "Group 26802", children: [
        /* @__PURE__ */ _("g", { id: "Group_3", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Rectangle 5623",
            d: "M143 16.5H8C4.41015 16.5 1.5 19.4101 1.5 23V48C1.5 51.5899 4.41015 54.5 8 54.5H143C146.59 54.5 149.5 51.5899 149.5 48V23C149.5 19.4102 146.59 16.5 143 16.5Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ ee("g", { id: "Group 26775_3", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_3",
              d: "M80 26H54C52.3431 26 51 27.3431 51 29C51 30.6569 52.3431 32 54 32H80C81.6569 32 83 30.6569 83 29C83 27.3431 81.6569 26 80 26Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_3",
              d: "M98 39H54C52.3431 39 51 40.3431 51 42C51 43.6569 52.3431 45 54 45H98C99.6569 45 101 43.6569 101 42C101 40.3431 99.6569 39 98 39Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] }),
        /* @__PURE__ */ _("g", { id: "Group 26801", children: /* @__PURE__ */ _("g", { id: "Group 26756_2", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 647_2",
            d: "M33.5 45C38.7467 45 43 40.7467 43 35.5C43 30.2533 38.7467 26 33.5 26C28.2533 26 24 30.2533 24 35.5C24 40.7467 28.2533 45 33.5 45Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ) }) })
      ] })
    ] })
  }
), aB = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 169,
    viewBox: "0 0 150 169",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ ee("g", { id: "Illustrations/Empty States/02", children: [
      /* @__PURE__ */ ee("g", { id: "Mask Group 1", children: [
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 652",
            d: "M75 158C116.421 158 150 124.421 150 83C150 41.5786 116.421 8 75 8C33.5786 8 0 41.5786 0 83C0 124.421 33.5786 158 75 158Z",
            className: "fill-[theme(backgroundColor.foundations-subtler)]"
          }
        ),
        /* @__PURE__ */ _("g", { id: "Group", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Rectangle 5615",
            d: "M118 49.5H32C28.4101 49.5 25.5 52.4101 25.5 56V161C25.5 164.59 28.4101 167.5 32 167.5H118C121.59 167.5 124.5 164.59 124.5 161V56C124.5 52.4101 121.59 49.5 118 49.5Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ ee("g", { id: "Group 26776", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617",
              d: "M65 66H39C37.3431 66 36 67.3431 36 69C36 70.6569 37.3431 72 39 72H65C66.6569 72 68 70.6569 68 69C68 67.3431 66.6569 66 65 66Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618",
              d: "M83 79H39C37.3431 79 36 80.3431 36 82C36 83.6569 37.3431 85 39 85H83C84.6569 85 86 83.6569 86 82C86 80.3431 84.6569 79 83 79Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          )
        ] }),
        /* @__PURE__ */ ee("g", { id: "Group 26777", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_2",
              d: "M65 93H39C37.3431 93 36 94.3431 36 96C36 97.6569 37.3431 99 39 99H65C66.6569 99 68 97.6569 68 96C68 94.3431 66.6569 93 65 93Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_2",
              d: "M83 106H39C37.3431 106 36 107.343 36 109C36 110.657 37.3431 112 39 112H83C84.6569 112 86 110.657 86 109C86 107.343 84.6569 106 83 106Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          )
        ] }),
        /* @__PURE__ */ ee("g", { id: "Group 26778", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_3",
              d: "M65 120H39C37.3431 120 36 121.343 36 123C36 124.657 37.3431 126 39 126H65C66.6569 126 68 124.657 68 123C68 121.343 66.6569 120 65 120Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_3",
              d: "M83 133H39C37.3431 133 36 134.343 36 136C36 137.657 37.3431 139 39 139H83C84.6569 139 86 137.657 86 136C86 134.343 84.6569 133 83 133Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ ee("g", { id: "Group 26779", children: [
        /* @__PURE__ */ _("g", { id: "Group_2", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Rectangle 5616",
            d: "M118 0H32C29.2386 0 27 2.23858 27 5V35C27 37.7614 29.2386 40 32 40H118C120.761 40 123 37.7614 123 35V5C123 2.23858 120.761 0 118 0Z",
            className: "fill-[theme(backgroundColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ ee("g", { id: "Group 26775", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_4",
              d: "M65 11H39C37.3431 11 36 12.3431 36 14C36 15.6569 37.3431 17 39 17H65C66.6569 17 68 15.6569 68 14C68 12.3431 66.6569 11 65 11Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_4",
              d: "M83 24H39C37.3431 24 36 25.3431 36 27C36 28.6569 37.3431 30 39 30H83C84.6569 30 86 28.6569 86 27C86 25.3431 84.6569 24 83 24Z",
              className: "fill-[theme(backgroundColor.foundations-subtlest)]"
            }
          )
        ] })
      ] })
    ] })
  }
), lB = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 158,
    height: 169,
    viewBox: "0 0 158 169",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ ee("g", { id: "Illustrations/Empty States/03", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 652",
          d: "M79 158C122.63 158 158 122.63 158 79C158 35.3695 122.63 0 79 0C35.3695 0 0 35.3695 0 79C0 122.63 35.3695 158 79 158Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ _("g", { id: "Group", children: /* @__PURE__ */ _("g", { id: "Mask Group", children: /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5615",
          d: "M122 49.5H36C32.4101 49.5 29.5 52.4101 29.5 56V161C29.5 164.59 32.4101 167.5 36 167.5H122C125.59 167.5 128.5 164.59 128.5 161V56C128.5 52.4101 125.59 49.5 122 49.5Z",
          strokeWidth: 3,
          className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
        }
      ) }) }),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5617",
          d: "M70 61H44C42.3431 61 41 62.3431 41 64C41 65.6569 42.3431 67 44 67H70C71.6569 67 73 65.6569 73 64C73 62.3431 71.6569 61 70 61Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5620",
          d: "M70 103H44C42.3431 103 41 104.343 41 106C41 107.657 42.3431 109 44 109H70C71.6569 109 73 107.657 73 106C73 104.343 71.6569 103 70 103Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _("g", { id: "Rectangle 5618", children: /* @__PURE__ */ _(
        "path",
        {
          id: "Vector",
          d: "M112 76H46C43.7909 76 42 77.7909 42 80V90C42 92.2091 43.7909 94 46 94H112C114.209 94 116 92.2091 116 90V80C116 77.7909 114.209 76 112 76Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ) }),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5619",
          d: "M112 117H46C43.2386 117 41 119.239 41 122V130C41 132.761 43.2386 135 46 135H112C114.761 135 117 132.761 117 130V122C117 119.239 114.761 117 112 117Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ),
      /* @__PURE__ */ ee("g", { id: "Group 26781", children: [
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 654",
            d: "M57 40C59.2091 40 61 38.2091 61 36C61 33.7909 59.2091 32 57 32C54.7909 32 53 33.7909 53 36C53 38.2091 54.7909 40 57 40Z",
            className: "fill-[theme(backgroundColor.foundations-subtle)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 655",
            d: "M79 40C81.2091 40 83 38.2091 83 36C83 33.7909 81.2091 32 79 32C76.7909 32 75 33.7909 75 36C75 38.2091 76.7909 40 79 40Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 656",
            d: "M101 40C103.209 40 105 38.2091 105 36C105 33.7909 103.209 32 101 32C98.7909 32 97 33.7909 97 36C97 38.2091 98.7909 40 101 40Z",
            className: "fill-[theme(backgroundColor.foundations-subtle)]"
          }
        )
      ] }),
      /* @__PURE__ */ ee("g", { id: "Group 26782", children: [
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 658",
            d: "M90 96C92.7614 96 95 93.7614 95 91C95 88.2386 92.7614 86 90 86C87.2386 86 85 88.2386 85 91C85 93.7614 87.2386 96 90 96Z",
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            id: "Path 25916",
            d: "M93.9071 112.37C93.1071 112.37 92.3601 112.37 91.6801 112.327C90.8425 112.27 90.0367 111.984 89.3515 111.499C88.6662 111.014 88.128 110.349 87.7961 109.578L83.5771 101.24C83.2676 100.88 83.1131 100.412 83.1472 99.938C83.1813 99.4643 83.4012 99.0233 83.7591 98.711C84.0522 98.4754 84.418 98.3485 84.7941 98.352C85.071 98.3601 85.3428 98.4281 85.5909 98.5513C85.839 98.6746 86.0574 98.8502 86.2311 99.066L88.1471 101.681L88.1761 101.715V91.78C88.1761 91.2871 88.3719 90.8144 88.7204 90.4659C89.069 90.1173 89.5417 89.9215 90.0346 89.9215C90.5275 89.9215 91.0002 90.1173 91.3487 90.4659C91.6973 90.8144 91.8931 91.2871 91.8931 91.78V98.28C91.8715 98.0408 91.9 97.7998 91.9767 97.5722C92.0534 97.3446 92.1767 97.1355 92.3387 96.9582C92.5007 96.781 92.6979 96.6394 92.9176 96.5425C93.1374 96.4456 93.3749 96.3956 93.6151 96.3956C93.8552 96.3956 94.0928 96.4456 94.3125 96.5425C94.5323 96.6394 94.7294 96.781 94.8914 96.9582C95.0534 97.1355 95.1767 97.3446 95.2535 97.5722C95.3302 97.7998 95.3587 98.0408 95.3371 98.28V99.635C95.3155 99.3958 95.344 99.1548 95.4207 98.9272C95.4974 98.6996 95.6207 98.4905 95.7827 98.3132C95.9447 98.136 96.1419 97.9944 96.3616 97.8975C96.5814 97.8006 96.8189 97.7506 97.0591 97.7506C97.2992 97.7506 97.5368 97.8006 97.7565 97.8975C97.9763 97.9944 98.1734 98.136 98.3354 98.3132C98.4974 98.4905 98.6207 98.6996 98.6975 98.9272C98.7742 99.1548 98.8027 99.3958 98.7811 99.635V100.679C98.7595 100.44 98.788 100.199 98.8647 99.9712C98.9414 99.7436 99.0647 99.5345 99.2267 99.3572C99.3887 99.18 99.5859 99.0384 99.8056 98.9415C100.025 98.8446 100.263 98.7946 100.503 98.7946C100.743 98.7946 100.981 98.8446 101.201 98.9415C101.42 99.0384 101.617 99.18 101.779 99.3572C101.941 99.5345 102.065 99.7436 102.141 99.9712C102.218 100.199 102.247 100.44 102.225 100.679V107.016C102.191 108.965 101.31 112.251 98.2111 112.251C97.9861 112.261 96.0801 112.371 93.9111 112.371L93.9071 112.37Z",
            className: "fill-[theme(backgroundColor.foundations-bold)] stroke-[theme(backgroundColor.foundations-default)]"
          }
        )
      ] })
    ] })
  }
), cB = (e) => /* @__PURE__ */ ee(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ...e,
    children: [
      /* @__PURE__ */ _(
        "rect",
        {
          width: 150,
          height: 150,
          rx: 75,
          className: "fill-[theme(backgroundColor.foundations-subtlest)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M48.334 91.6667H65.0007H85.0007H101.667L96.9842 86.9836C95.7142 85.7135 95.0007 83.991 95.0007 82.1948V71.6667C95.0007 62.9586 89.4353 55.5503 81.6673 52.8047V51.6667C81.6673 47.9848 78.6826 45 75.0007 45C71.3188 45 68.334 47.9848 68.334 51.6667V52.8047C60.566 55.5503 55.0007 62.9586 55.0007 71.6667V82.1948C55.0007 83.991 54.2871 85.7135 53.0171 86.9836L48.334 91.6667Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M75.0005 105.001C80.5233 105.001 85.0005 100.524 85.0005 95.0013V91.668H65.0005V95.0013C65.0005 100.524 69.4776 105.001 75.0005 105.001Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      )
    ]
  }
), uB = (e) => /* @__PURE__ */ ee(
  "svg",
  {
    width: "150",
    height: "150",
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ _(
        "path",
        {
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtlest)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M120 150H30V53C34.242 52.9952 38.3089 51.308 41.3084 48.3085C44.308 45.3089 45.9952 41.242 46 37H104C103.996 39.1014 104.408 41.1828 105.213 43.1238C106.018 45.0648 107.2 46.8268 108.691 48.308C110.172 49.7991 111.934 50.9816 113.875 51.787C115.817 52.5924 117.898 53.0047 120 53V150Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M75 102C88.2548 102 99 91.2548 99 78C99 64.7452 88.2548 54 75 54C61.7452 54 51 64.7452 51 78C51 91.2548 61.7452 102 75 102Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ),
      /* @__PURE__ */ _("g", { clipPath: "url(#clip0_22879_245463)", children: /* @__PURE__ */ _(
        "path",
        {
          d: "M73.4 66.7992C73.4 65.9156 74.1163 65.1992 75 65.1992C75.8837 65.1992 76.6 65.9156 76.6 66.7992V75.5992C76.6 76.041 76.9582 76.3992 77.4 76.3992C77.8418 76.3992 78.2 76.041 78.2 75.5992V68.3992C78.2 67.5156 78.9163 66.7992 79.8 66.7992C80.6837 66.7992 81.4 67.5156 81.4 68.3992V75.5992C81.4 76.041 81.7582 76.3992 82.2 76.3992C82.6418 76.3992 83 76.041 83 75.5992V71.5992C83 70.7156 83.7163 69.9992 84.6 69.9992C85.4837 69.9992 86.2 70.7156 86.2 71.5992V79.5992C86.2 85.7848 81.1856 90.7992 75 90.7992C68.8144 90.7992 63.8 85.7848 63.8 79.5992V76.3992C63.8 75.5156 64.5163 74.7992 65.4 74.7992C66.2837 74.7992 67 75.5156 67 76.3992V80.3992C67 80.841 67.3582 81.1992 67.8 81.1992C68.2418 81.1992 68.6 80.841 68.6 80.3992V68.3992C68.6 67.5156 69.3163 66.7992 70.2 66.7992C71.0837 66.7992 71.8 67.5156 71.8 68.3992V75.5992C71.8 76.041 72.1582 76.3992 72.6 76.3992C73.0418 76.3992 73.4 76.041 73.4 75.5992V66.7992Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ) }),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M88 108H62C60.3431 108 59 109.343 59 111C59 112.657 60.3431 114 62 114H88C89.6569 114 91 112.657 91 111C91 109.343 89.6569 108 88 108Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M97 120H53C51.3431 120 50 121.343 50 123C50 124.657 51.3431 126 53 126H97C98.6569 126 100 124.657 100 123C100 121.343 98.6569 120 97 120Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ _("defs", { children: /* @__PURE__ */ _("clipPath", { id: "clip0_22879_245463", children: /* @__PURE__ */ _(
        "rect",
        {
          width: "32",
          height: "32",
          className: "fill-[theme(backgroundColor.foundations-default)]",
          transform: "translate(59 62)"
        }
      ) }) })
    ]
  }
), u9 = (e, t = 5, n = "*") => {
  const r = String(e), o = n.repeat(
    Math.max(r.length - t, 3)
  );
  return r.slice(0, t) + o;
};
function d9(e, t) {
  return /* @__PURE__ */ b.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ b.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 13l4 4L19 7"
  }));
}
const f9 = b.forwardRef(d9), h9 = f9, CE = () => {
  const [e, t] = Vt(null), [n, r] = Vt(!1);
  return st(() => {
    if (!n)
      return;
    const s = setTimeout(() => {
      r(!1);
    }, 1500);
    return () => clearTimeout(s);
  }, [n]), { copiedText: e, copy: async (s) => {
    try {
      return await navigator.clipboard.writeText(s), t(s), r(!0), !0;
    } catch (i) {
      return console.warn("Copy failed", i), t(null), !1;
    }
  }, isCopied: n };
}, p9 = ({
  text: e,
  className: t,
  size: n,
  iconClassName: r
}) => {
  const [o, s] = b.useState(!1), { copy: i, isCopied: a } = CE();
  return /* @__PURE__ */ ee(Lt, { open: o, children: [
    /* @__PURE__ */ _(
      Lt.Trigger,
      {
        delay: 0,
        render: /* @__PURE__ */ _(
          ia,
          {
            size: n,
            className: de("inline-flex shrink-0 px-1 py-0.5", t),
            onMouseEnter: () => s(!0),
            onMouseLeave: () => s(!1),
            onFocus: () => s(!0),
            onBlur: () => s(!1),
            variant: "tertiary",
            onClick: (l) => {
              l.stopPropagation(), a || i(e);
            }
          }
        ),
        children: a ? /* @__PURE__ */ _(h9, { className: de("text-success", r) }) : /* @__PURE__ */ _(cx, { className: r })
      }
    ),
    /* @__PURE__ */ _(Lt.Popup, { size: "sm", children: a ? "Copied!" : "Copy" })
  ] });
}, EE = pn(
  ({
    type: e = "text",
    value: t,
    defaultValue: n,
    name: r,
    label: o,
    helpText: s,
    onChange: i,
    onFocus: a,
    onBlur: l,
    icon: c,
    className: u,
    containerClassName: d,
    readOnly: f,
    copyable: h,
    encrypted: p,
    nativeChangeEvent: g,
    ...m
  }, v) => {
    const [y, x] = Vt(
      !(t || n)
    ), [C, w] = Vt(!1), [E, S] = Vt(!1), [O, M] = Vt(!1), T = p && !y, P = e === "password", I = Ar(
      () => T ? u9(t || "") : t,
      [T, t]
    );
    return /* @__PURE__ */ ee("div", { className: d, children: [
      o && /* @__PURE__ */ _(
        "label",
        {
          htmlFor: r,
          className: "mb-4 block text-sm font-medium text-foundations-bold",
          children: o
        }
      ),
      /* @__PURE__ */ ee("div", { className: "relative block", children: [
        /* @__PURE__ */ _(
          "input",
          {
            type: T || P && O ? "text" : e,
            name: r,
            id: r,
            ref: v,
            defaultValue: n,
            value: I,
            placeholder: "Type your method...",
            onChange: (D) => {
              g ? i(D) : i(D.currentTarget.value, D);
            },
            className: de(
              "peer block w-full min-w-0 flex-1 rounded-md border-foundations-bold bg-foundations-default text-foundations-bolder placeholder:text-foundations-subtle focus:border-info-bold focus:outline-none focus:ring-info-bold sm:text-sm",
              c ? "pl-8" : "",
              h && p ? "pr-[68px] truncate" : h || p || P ? "pr-9 truncate" : "",
              u
            ),
            readOnly: f || T,
            onFocus: (D) => {
              a == null || a(D), S(!0), y || w(!0);
            },
            onBlur: (D) => {
              l == null || l(D), S(!1);
            },
            ...m
          }
        ),
        /* @__PURE__ */ _("span", { className: "pointer-events-none absolute inset-y-0 left-2 flex transform items-center text-foundations-subtler peer-focus:text-blue-500", children: c }),
        (h || p || P) && /* @__PURE__ */ ee("div", { className: "absolute inset-y-0 right-2 flex items-center justify-center gap-2 text-foundations-subtler peer-focus:text-blue-500", children: [
          P && /* @__PURE__ */ ee(Lt, { children: [
            /* @__PURE__ */ _(
              Lt.Trigger,
              {
                type: "button",
                onClick: () => M((D) => !D),
                "data-testid": "reveal-password",
                "aria-label": O ? "Hide password" : "Show password",
                children: O ? /* @__PURE__ */ _(Pb, { className: "h-5 w-5" }) : /* @__PURE__ */ _(Ib, { className: "h-5 w-5" })
              }
            ),
            /* @__PURE__ */ _(Lt.Popup, { size: "sm", children: O ? "Hide" : "Reveal" })
          ] }),
          p && /* @__PURE__ */ ee(
            Lt,
            {
              open: C,
              onOpenChange: (D) => w(D),
              children: [
                /* @__PURE__ */ _(
                  Lt.Trigger,
                  {
                    onClick: () => {
                      w(!1), x((D) => !D);
                    },
                    "data-testid": "reveal-input",
                    children: y ? /* @__PURE__ */ _(Pb, { className: "h-5 w-5" }) : /* @__PURE__ */ _(Ib, { className: "h-5 w-5" })
                  }
                ),
                /* @__PURE__ */ _(Lt.Popup, { size: "sm", children: E && !y ? "Reveal first to be able to edit" : y ? "Hide" : "Reveal" })
              ]
            }
          ),
          h && /* @__PURE__ */ _(p9, { text: t ?? "", iconClassName: "h-5 w-5" })
        ] })
      ] }),
      s && /* @__PURE__ */ _(
        "p",
        {
          className: "mt-2 text-sm text-foundations-subtler",
          id: "email-description",
          children: s
        }
      )
    ] });
  }
);
EE.displayName = "Input";
var g9 = Object.defineProperty, m9 = Object.defineProperties, b9 = Object.getOwnPropertyDescriptors, Fc = Object.getOwnPropertySymbols, _E = Object.prototype.hasOwnProperty, SE = Object.prototype.propertyIsEnumerable, y0 = (e, t, n) => t in e ? g9(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, v9 = (e, t) => {
  for (var n in t || (t = {}))
    _E.call(t, n) && y0(e, n, t[n]);
  if (Fc)
    for (var n of Fc(t))
      SE.call(t, n) && y0(e, n, t[n]);
  return e;
}, y9 = (e, t) => m9(e, b9(t)), x9 = (e, t) => {
  var n = {};
  for (var r in e)
    _E.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && Fc)
    for (var r of Fc(e))
      t.indexOf(r) < 0 && SE.call(e, r) && (n[r] = e[r]);
  return n;
};
function w9(e) {
  let t = setTimeout(e, 0), n = setTimeout(e, 10), r = setTimeout(e, 50);
  return [t, n, r];
}
function C9(e) {
  let t = b.useRef();
  return b.useEffect(() => {
    t.current = e;
  }), t.current;
}
var E9 = 18, OE = 40, _9 = `${OE}px`, S9 = ["[data-lastpass-icon-root]", "com-1password-button", "[data-dashlanecreated]", '[style$="2147483647 !important;"]'].join(",");
function O9({ containerRef: e, inputRef: t, pushPasswordManagerStrategy: n, isFocused: r }) {
  let [o, s] = b.useState(!1), [i, a] = b.useState(!1), [l, c] = b.useState(!1), u = b.useMemo(() => n === "none" ? !1 : (n === "increase-width" || n === "experimental-no-flickering") && o && i, [o, i, n]), d = b.useCallback(() => {
    let f = e.current, h = t.current;
    if (!f || !h || l || n === "none")
      return;
    let p = f, g = p.getBoundingClientRect().left + p.offsetWidth, m = p.getBoundingClientRect().top + p.offsetHeight / 2, v = g - E9, y = m;
    document.querySelectorAll(S9).length === 0 && document.elementFromPoint(v, y) === f || (s(!0), c(!0));
  }, [e, t, l, n]);
  return b.useEffect(() => {
    let f = e.current;
    if (!f || n === "none")
      return;
    function h() {
      let g = window.innerWidth - f.getBoundingClientRect().right;
      a(g >= OE);
    }
    h();
    let p = setInterval(h, 1e3);
    return () => {
      clearInterval(p);
    };
  }, [e, n]), b.useEffect(() => {
    let f = r || document.activeElement === t.current;
    if (n === "none" || !f)
      return;
    let h = setTimeout(d, 0), p = setTimeout(d, 2e3), g = setTimeout(d, 5e3), m = setTimeout(() => {
      c(!0);
    }, 6e3);
    return () => {
      clearTimeout(h), clearTimeout(p), clearTimeout(g), clearTimeout(m);
    };
  }, [t, r, n, d]), { hasPWMBadge: o, willPushPWMBadge: u, PWM_BADGE_SPACE_WIDTH: _9 };
}
var M9 = b.createContext({}), ME = b.forwardRef((e, t) => {
  var n = e, { value: r, onChange: o, maxLength: s, textAlign: i = "left", pattern: a, placeholder: l, inputMode: c = "numeric", onComplete: u, pushPasswordManagerStrategy: d = "increase-width", pasteTransformer: f, containerClassName: h, noScriptCSSFallback: p = T9, render: g, children: m } = n, v = x9(n, ["value", "onChange", "maxLength", "textAlign", "pattern", "placeholder", "inputMode", "onComplete", "pushPasswordManagerStrategy", "pasteTransformer", "containerClassName", "noScriptCSSFallback", "render", "children"]), y, x, C, w, E;
  let [S, O] = b.useState(typeof v.defaultValue == "string" ? v.defaultValue : ""), M = r ?? S, T = C9(M), P = b.useCallback((Q) => {
    o == null || o(Q), O(Q);
  }, [o]), I = b.useMemo(() => a ? typeof a == "string" ? new RegExp(a) : a : null, [a]), R = b.useRef(null), D = b.useRef(null), k = b.useRef({ value: M, onChange: P, isIOS: typeof window < "u" && ((x = (y = window == null ? void 0 : window.CSS) == null ? void 0 : y.supports) == null ? void 0 : x.call(y, "-webkit-touch-callout", "none")) }), $ = b.useRef({ prev: [(C = R.current) == null ? void 0 : C.selectionStart, (w = R.current) == null ? void 0 : w.selectionEnd, (E = R.current) == null ? void 0 : E.selectionDirection] });
  b.useImperativeHandle(t, () => R.current, []), b.useEffect(() => {
    let Q = R.current, re = D.current;
    if (!Q || !re)
      return;
    k.current.value !== Q.value && k.current.onChange(Q.value), $.current.prev = [Q.selectionStart, Q.selectionEnd, Q.selectionDirection];
    function fe() {
      if (document.activeElement !== Q) {
        K(null), U(null);
        return;
      }
      let se = Q.selectionStart, _e = Q.selectionEnd, xe = Q.selectionDirection, ge = Q.maxLength, ae = Q.value, W = $.current.prev, Z = -1, me = -1, ie;
      if (ae.length !== 0 && se !== null && _e !== null) {
        let Ae = se === _e, Ue = se === ae.length && ae.length < ge;
        if (Ae && !Ue) {
          let Ke = se;
          if (Ke === 0)
            Z = 0, me = 1, ie = "forward";
          else if (Ke === ge)
            Z = Ke - 1, me = Ke, ie = "backward";
          else if (ge > 1 && ae.length > 1) {
            let Be = 0;
            if (W[0] !== null && W[1] !== null) {
              ie = Ke < W[1] ? "backward" : "forward";
              let nt = W[0] === W[1] && W[0] < ge;
              ie === "backward" && !nt && (Be = -1);
            }
            Z = Be + Ke, me = Be + Ke + 1;
          }
        }
        Z !== -1 && me !== -1 && Z !== me && R.current.setSelectionRange(Z, me, ie);
      }
      let oe = Z !== -1 ? Z : se, he = me !== -1 ? me : _e, Re = ie ?? xe;
      K(oe), U(he), $.current.prev = [oe, he, Re];
    }
    if (document.addEventListener("selectionchange", fe, { capture: !0 }), fe(), document.activeElement === Q && N(!0), !document.getElementById("input-otp-style")) {
      let se = document.createElement("style");
      if (se.id = "input-otp-style", document.head.appendChild(se), se.sheet) {
        let _e = "background: transparent !important; color: transparent !important; border-color: transparent !important; opacity: 0 !important; box-shadow: none !important; -webkit-box-shadow: none !important; -webkit-text-fill-color: transparent !important;";
        Ni(se.sheet, "[data-input-otp]::selection { background: transparent !important; color: transparent !important; }"), Ni(se.sheet, `[data-input-otp]:autofill { ${_e} }`), Ni(se.sheet, `[data-input-otp]:-webkit-autofill { ${_e} }`), Ni(se.sheet, "@supports (-webkit-touch-callout: none) { [data-input-otp] { letter-spacing: -.6em !important; font-weight: 100 !important; font-stretch: ultra-condensed; font-optical-sizing: none !important; left: -1px !important; right: 1px !important; } }"), Ni(se.sheet, "[data-input-otp] + * { pointer-events: all !important; }");
      }
    }
    let le = () => {
      re && re.style.setProperty("--root-height", `${Q.clientHeight}px`);
    };
    le();
    let Ee = new ResizeObserver(le);
    return Ee.observe(Q), () => {
      document.removeEventListener("selectionchange", fe, { capture: !0 }), Ee.disconnect();
    };
  }, []);
  let [L, A] = b.useState(!1), [F, N] = b.useState(!1), [V, K] = b.useState(null), [Y, U] = b.useState(null);
  b.useEffect(() => {
    w9(() => {
      var Q, re, fe, le;
      (Q = R.current) == null || Q.dispatchEvent(new Event("input"));
      let Ee = (re = R.current) == null ? void 0 : re.selectionStart, se = (fe = R.current) == null ? void 0 : fe.selectionEnd, _e = (le = R.current) == null ? void 0 : le.selectionDirection;
      Ee !== null && se !== null && (K(Ee), U(se), $.current.prev = [Ee, se, _e]);
    });
  }, [M, F]), b.useEffect(() => {
    T !== void 0 && M !== T && T.length < s && M.length === s && (u == null || u(M));
  }, [s, u, T, M]);
  let j = O9({ containerRef: D, inputRef: R, pushPasswordManagerStrategy: d, isFocused: F }), H = b.useCallback((Q) => {
    let re = Q.currentTarget.value.slice(0, s);
    if (re.length > 0 && I && !I.test(re)) {
      Q.preventDefault();
      return;
    }
    typeof T == "string" && re.length < T.length && document.dispatchEvent(new Event("selectionchange")), P(re);
  }, [s, P, T, I]), q = b.useCallback(() => {
    var Q;
    if (R.current) {
      let re = Math.min(R.current.value.length, s - 1), fe = R.current.value.length;
      (Q = R.current) == null || Q.setSelectionRange(re, fe), K(re), U(fe);
    }
    N(!0);
  }, [s]), B = b.useCallback((Q) => {
    var re, fe;
    let le = R.current;
    if (!f && (!k.current.isIOS || !Q.clipboardData || !le))
      return;
    let Ee = Q.clipboardData.getData("text/plain"), se = f ? f(Ee) : Ee;
    Q.preventDefault();
    let _e = (re = R.current) == null ? void 0 : re.selectionStart, xe = (fe = R.current) == null ? void 0 : fe.selectionEnd, ge = (_e !== xe ? M.slice(0, _e) + se + M.slice(xe) : M.slice(0, _e) + se + M.slice(_e)).slice(0, s);
    if (ge.length > 0 && I && !I.test(ge))
      return;
    le.value = ge, P(ge);
    let ae = Math.min(ge.length, s - 1), W = ge.length;
    le.setSelectionRange(ae, W), K(ae), U(W);
  }, [s, P, I, M]), X = b.useMemo(() => ({ position: "relative", cursor: v.disabled ? "default" : "text", userSelect: "none", WebkitUserSelect: "none", pointerEvents: "none" }), [v.disabled]), te = b.useMemo(() => ({ position: "absolute", inset: 0, width: j.willPushPWMBadge ? `calc(100% + ${j.PWM_BADGE_SPACE_WIDTH})` : "100%", clipPath: j.willPushPWMBadge ? `inset(0 ${j.PWM_BADGE_SPACE_WIDTH} 0 0)` : void 0, height: "100%", display: "flex", textAlign: i, opacity: "1", color: "transparent", pointerEvents: "all", background: "transparent", caretColor: "transparent", border: "0 solid transparent", outline: "0 solid transparent", boxShadow: "none", lineHeight: "1", letterSpacing: "-.5em", fontSize: "var(--root-height)", fontFamily: "monospace", fontVariantNumeric: "tabular-nums" }), [j.PWM_BADGE_SPACE_WIDTH, j.willPushPWMBadge, i]), J = b.useMemo(() => b.createElement("input", y9(v9({ autoComplete: v.autoComplete || "one-time-code" }, v), { "data-input-otp": !0, "data-input-otp-placeholder-shown": M.length === 0 || void 0, "data-input-otp-mss": V, "data-input-otp-mse": Y, inputMode: c, pattern: I == null ? void 0 : I.source, "aria-placeholder": l, style: te, maxLength: s, value: M, ref: R, onPaste: (Q) => {
    var re;
    B(Q), (re = v.onPaste) == null || re.call(v, Q);
  }, onChange: H, onMouseOver: (Q) => {
    var re;
    A(!0), (re = v.onMouseOver) == null || re.call(v, Q);
  }, onMouseLeave: (Q) => {
    var re;
    A(!1), (re = v.onMouseLeave) == null || re.call(v, Q);
  }, onFocus: (Q) => {
    var re;
    q(), (re = v.onFocus) == null || re.call(v, Q);
  }, onBlur: (Q) => {
    var re;
    N(!1), (re = v.onBlur) == null || re.call(v, Q);
  } })), [H, q, B, c, te, s, Y, V, v, I == null ? void 0 : I.source, M]), G = b.useMemo(() => ({ slots: Array.from({ length: s }).map((Q, re) => {
    var fe;
    let le = F && V !== null && Y !== null && (V === Y && re === V || re >= V && re < Y), Ee = M[re] !== void 0 ? M[re] : null, se = M[0] !== void 0 ? null : (fe = l == null ? void 0 : l[re]) != null ? fe : null;
    return { char: Ee, placeholderChar: se, isActive: le, hasFakeCaret: le && Ee === null };
  }), isFocused: F, isHovering: !v.disabled && L }), [F, L, s, Y, V, v.disabled, M]), ne = b.useMemo(() => g ? g(G) : b.createElement(M9.Provider, { value: G }, m), [m, G, g]);
  return b.createElement(b.Fragment, null, p !== null && b.createElement("noscript", null, b.createElement("style", null, p)), b.createElement("div", { ref: D, "data-input-otp-container": !0, style: X, className: h }, ne, b.createElement("div", { style: { position: "absolute", inset: 0, pointerEvents: "none" } }, J)));
});
ME.displayName = "Input";
function Ni(e, t) {
  try {
    e.insertRule(t);
  } catch {
    console.error("input-otp could not insert CSS rule:", t);
  }
}
var T9 = `
[data-input-otp] {
  --nojs-bg: white !important;
  --nojs-fg: black !important;

  background-color: var(--nojs-bg) !important;
  color: var(--nojs-fg) !important;
  caret-color: var(--nojs-fg) !important;
  letter-spacing: .25em !important;
  text-align: center !important;
  border: 1px solid var(--nojs-fg) !important;
  border-radius: 4px !important;
  width: 100% !important;
}
@media (prefers-color-scheme: dark) {
  [data-input-otp] {
    --nojs-bg: black !important;
    --nojs-fg: white !important;
  }
}`, R9 = "^\\d+$";
const P9 = b.forwardRef(
  ({
    maxLength: e = 6,
    pattern: t = R9,
    value: n,
    onChange: r,
    id: o = b.useId(),
    name: s,
    disabled: i,
    inputMode: a,
    className: l,
    slotClassName: c,
    autoFocus: u = !1,
    onBlur: d,
    onFocus: f
  }, h) => /* @__PURE__ */ _(
    ME,
    {
      "data-slot": "input-otp",
      ref: h,
      id: o,
      name: s,
      maxLength: e,
      pattern: t,
      value: n,
      onChange: r,
      disabled: i,
      inputMode: a,
      autoFocus: u,
      containerClassName: de("flex items-center gap-2", l),
      className: "disabled:cursor-not-allowed",
      render: ({ slots: p }) => p.map((g, m) => /* @__PURE__ */ _(I9, { ...g, className: c }, m)),
      onFocus: f,
      onBlur: d
    }
  )
);
P9.displayName = "InputOTP";
function I9({
  char: e,
  hasFakeCaret: t,
  isActive: n,
  placeholderChar: r,
  className: o
}) {
  return /* @__PURE__ */ ee(
    "div",
    {
      "data-slot": "input-otp-slot",
      "data-active": n,
      className: de(
        "border-input relative flex h-9 w-9 items-center justify-center rounded-md border border-foundations-bold bg-foundations-default text-foundations-boldest outline-none transition-all data-[active=true]:border-info-bold data-[active=true]:ring-1 data-[active=true]:ring-info-bold",
        o
      ),
      children: [
        e || r,
        t && /* @__PURE__ */ _("div", { className: "pointer-events-none absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ _("div", { className: "h-4 w-px animate-caret-blink bg-foundations-bolder duration-1000" }) })
      ]
    }
  );
}
function k9(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
const D9 = Qn(
  "cursor-pointer rounded focus:ring-2 focus:ring-offset-0",
  {
    variants: {
      variant: {
        primary: "checked:bg-info-bold indeterminate:bg-info-bold hover:checked:bg-info-bold hover:indeterminate:bg-info-bold focus:checked:bg-info-bold focus:indeterminate:bg-info-bold",
        dark: "checked:bg-foundations-boldest indeterminate:bg-foundations-boldest hover:checked:bg-foundations-boldest hover:indeterminate:bg-foundations-boldest focus:checked:bg-foundations-boldest focus:indeterminate:bg-foundations-boldest"
      }
    },
    defaultVariants: {
      variant: "primary"
    }
  }
), TE = b.forwardRef(
  ({
    disabled: e,
    readOnly: t,
    className: n,
    containerClassName: r,
    label: o,
    description: s,
    isIndeterminate: i = !1,
    variant: a,
    ...l
  }, c) => {
    const u = b.useRef(null);
    return b.useEffect(() => {
      u.current && (u.current.indeterminate = i);
    }, [i]), /* @__PURE__ */ ee(
      "label",
      {
        className: de("flex space-x-2", r),
        "aria-disabled": e,
        children: [
          /* @__PURE__ */ _(
            "input",
            {
              ref: k9([u, c]),
              className: de(
                D9({ variant: a }),
                o && "mt-0.5",
                e && "cursor-not-allowed border-foundations-subtle checked:bg-foundations-subtle indeterminate:bg-foundations-subtle hover:checked:bg-foundations-subtle hover:indeterminate:bg-foundations-subtle focus:checked:bg-foundations-subtle focus:indeterminate:bg-foundations-subtle",
                n
              ),
              type: "checkbox",
              disabled: e || t,
              readOnly: t,
              ...l
            }
          ),
          (o || s) && /* @__PURE__ */ ee(
            "div",
            {
              className: de(
                "flex flex-col text-sm",
                e && "cursor-not-allowed opacity-50"
              ),
              children: [
                o && /* @__PURE__ */ _(In, { children: typeof o == "string" ? /* @__PURE__ */ _("span", { className: "font-medium text-foundations-boldest", children: o }) : o }),
                s && /* @__PURE__ */ _("span", { className: "text-foundations-subtle", children: s })
              ]
            }
          )
        ]
      }
    );
  }
);
TE.displayName = "Checkbox";
const N9 = Qn(
  "group/switch relative inline-flex rounded-full border-2 border-transparent bg-foundations-bold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-info-bold focus:ring-offset-2 focus:ring-offset-[theme(backgroundColor.foundations-default)] aria-[disabled=true]:cursor-not-allowed aria-[disabled=true]:bg-foundations-subtlest data-[checked]:bg-info-bold",
  {
    variants: {
      size: {
        default: "h-6 w-11",
        sm: "h-4 w-[30px]"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), A9 = Qn(
  "block translate-x-0 rounded-full bg-white transition-transform duration-200 will-change-transform",
  {
    variants: {
      size: {
        default: "h-5 w-5",
        sm: "h-3 w-3"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), dB = b.forwardRef(({ className: e, children: t, size: n = "default", ...r }, o) => {
  const s = !!t;
  return /* @__PURE__ */ ee(
    QC,
    {
      "data-slot": "switch",
      ref: o,
      className: de(
        N9({ size: n }),
        s && (n === "sm" ? "w-[38px]" : "w-14"),
        e
      ),
      ...r,
      children: [
        t && /* @__PURE__ */ _(
          "span",
          {
            className: de(
              "absolute inset-y-0 left-auto z-0 inline-flex items-center font-medium tracking-wider text-foundations-subtle group-data-[checked]/switch:left-1 group-data-[checked]/switch:right-auto group-data-[checked]/switch:text-neutral-white",
              n === "sm" ? "right-0.5 text-[10px]" : "right-1 text-xs"
            ),
            children: t
          }
        ),
        /* @__PURE__ */ _(
          JC,
          {
            "data-slot": "switch-thumb",
            className: de(
              A9({ size: n }),
              s ? n === "sm" ? "data-[checked]:translate-x-[22px]" : "data-[checked]:translate-x-8" : n === "sm" ? "data-[checked]:translate-x-[14px]" : "data-[checked]:translate-x-5"
            )
          }
        )
      ]
    }
  );
}), $9 = b.forwardRef(
  ({ className: e, label: t, description: n, ...r }, o) => /* @__PURE__ */ ee("label", { className: "flex space-x-2", children: [
    /* @__PURE__ */ _(
      "input",
      {
        ref: o,
        className: de(
          "cursor-pointer border-foundations-subtle checked:border-info-bold checked:bg-info-bold hover:border-foundations-bold hover:checked:bg-info-bolder focus:ring-offset-[theme(backgroundColor.foundations-default)]",
          t && "mt-0.5",
          e
        ),
        type: "radio",
        ...r
      }
    ),
    /* @__PURE__ */ ee("div", { className: "flex flex-col text-sm", children: [
      t && /* @__PURE__ */ _(In, { children: typeof t == "string" ? /* @__PURE__ */ _("span", { className: "font-medium text-foundations-bolder", children: t }) : t }),
      n && /* @__PURE__ */ _("span", { className: "text-foundations-subtle", children: n })
    ] })
  ] })
);
$9.displayName = "Radio";
const F9 = Qn(
  "group/link inline-flex items-center space-x-1 font-medium transition-colors focus:text-info",
  {
    variants: {
      variant: {
        inline: "text-info underline hover:text-link-hovered",
        standalone: "text-info hover:text-link-hovered hover:underline focus:underline"
      },
      size: {
        sm: "text-xs",
        md: "text-sm",
        lg: "text-base"
      }
    },
    defaultVariants: {
      size: "md",
      variant: "standalone"
    }
  }
), Ag = b.forwardRef(
  ({
    className: e,
    children: t,
    size: n,
    variant: r = "standalone",
    showExternalIcon: o = !0,
    truncate: s = !1,
    render: i,
    ...a
  }, l) => {
    const c = {
      className: de(F9({ variant: r, size: n }), e, {
        "max-w-full overflow-hidden": s
      }),
      children: /* @__PURE__ */ ee(In, { children: [
        /* @__PURE__ */ _(rx, { size: "sm", render: /* @__PURE__ */ _("span", {}), children: t }),
        o && /* @__PURE__ */ _(iI, { className: "h-4 w-4 flex-shrink-0" })
      ] }),
      "data-slot": "link"
    };
    return ai({
      defaultTagName: "a",
      ref: l,
      render: i,
      props: _n(c, a)
    });
  }
);
Ag.displayName = "Link";
const L9 = Qn(
  "rounded px-2 py-1 text-sm text-foundations-subtle focus:bg-foundations-subtlest focus:outline-none enabled:hover:bg-foundations-subtlest enabled:hover:text-foundations-bold",
  {
    variants: {
      style: {
        default: "data-[pressed]:!bg-info-bold data-[pressed]:!text-foundations-inverse",
        minimal: "data-[pressed]:!bg-info-subtler data-[pressed]:!text-info"
      }
    },
    defaultVariants: {
      style: "default"
    }
  }
), RE = b.createContext("default"), V9 = b.forwardRef(
  ({
    value: e,
    onValueChange: t,
    className: n,
    canReset: r = !1,
    error: o,
    style: s = "default",
    disabled: i,
    loop: a = !0,
    children: l
  }, c) => /* @__PURE__ */ _(RE.Provider, { value: s, children: /* @__PURE__ */ _(
    xE,
    {
      ref: c,
      className: de(
        "inline-flex flex-shrink-0 space-x-2 rounded-md border border-foundations-subtle p-1",
        o && "border-red-500 focus:border-red-500 focus:ring-red-500",
        n
      ),
      value: e ? [e] : [],
      disabled: i,
      loopFocus: a,
      onValueChange: (u) => {
        const d = u[0] ?? "";
        (d || r) && t(d);
      },
      children: l
    }
  ) })
);
V9.displayName = "OptionsGroup";
const W9 = b.forwardRef(
  ({ className: e, ...t }, n) => {
    const r = b.useContext(RE);
    return /* @__PURE__ */ _(
      vE,
      {
        ref: n,
        className: de(L9({ style: r }), e),
        ...t
      }
    );
  }
);
W9.displayName = "Option";
function H9(e, t, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: n
  }).format(t).split(/\s/g).slice(2).join(" ");
}
const Jd = {}, Ui = {};
function Kr(e, t) {
  try {
    const r = (Jd[e] || (Jd[e] = new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format))(t).split("GMT")[1];
    return r in Ui ? Ui[r] : x0(r, r.split(":"));
  } catch {
    if (e in Ui)
      return Ui[e];
    const n = e == null ? void 0 : e.match(B9);
    return n ? x0(e, n.slice(1)) : NaN;
  }
}
const B9 = /([+-]\d\d):?(\d\d)?/;
function x0(e, t) {
  const n = +(t[0] || 0), r = +(t[1] || 0), o = +(t[2] || 0) / 60;
  return Ui[e] = n * 60 + r > 0 ? n * 60 + r + o : n * 60 - r - o;
}
class Dr extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(Kr(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), PE(this, t)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new Dr(...n, t) : new Dr(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new Dr(+this, t);
  }
  getTimezoneOffset() {
    const t = -Kr(this.timeZone, this);
    return t > 0 ? Math.floor(t) : Math.ceil(t);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), Lc(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Dr(+new Date(t), this.timeZone);
  }
  //#endregion
}
const w0 = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!w0.test(e))
    return;
  const t = e.replace(w0, "$1UTC");
  Dr.prototype[t] && (e.startsWith("get") ? Dr.prototype[e] = function() {
    return this.internal[t]();
  } : (Dr.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), z9(this), +this;
  }, Dr.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), Lc(this), +this;
  }));
});
function Lc(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - // Round after converting minutes to seconds to avoid fractional offset
  // precision errors from historical offsets.
  Math.round(-Kr(e.timeZone, e) * 60));
}
function z9(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), PE(e);
}
function PE(e, t) {
  const n = Array.isArray(t) ? Y9(t) : +e.internal, r = Kr(e.timeZone, e), o = r > 0 ? Math.floor(r) : Math.ceil(r), s = /* @__PURE__ */ new Date(+e);
  s.setUTCHours(s.getUTCHours() - 1);
  const i = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), a = -(/* @__PURE__ */ new Date(+s)).getTimezoneOffset(), l = i - a;
  let c = i;
  if (l && i !== o) {
    const M = Date.prototype.getHours.apply(e), T = Array.isArray(t) ? t[3] || 0 : e.internal.getUTCHours();
    if (M !== T) {
      const P = /* @__PURE__ */ new Date(+e), I = i - o;
      I && P.setUTCMinutes(P.getUTCMinutes() + I);
      const R = Kr(e.timeZone, P);
      (R > 0 ? Math.floor(R) : Math.ceil(R)) === o && (c = a);
    }
  }
  const u = c - o;
  u && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + u);
  const d = /* @__PURE__ */ new Date(+e);
  d.setUTCSeconds(0);
  const f = i > 0 ? d.getSeconds() : (d.getSeconds() - 60) % 60, h = Math.round(-(Kr(e.timeZone, e) * 60)) % 60;
  (h || f) && Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + h + f);
  const p = Kr(e.timeZone, e), g = p > 0 ? Math.floor(p) : Math.ceil(p), v = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - g, y = g !== o, x = v - u, C = g - o, w = n - g * 60 * 1e3, E = C > 0 && C0(e) - n === C * 60 * 1e3 && C0(e, w) !== n;
  if (y && x && !E) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + x);
    const M = Kr(e.timeZone, e), T = M > 0 ? Math.floor(M) : Math.ceil(M), P = g - T;
    P && x < 0 && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + P);
  }
  Lc(e);
  const O = (t ? n : n + h * 1e3) - +e.internal;
  O && Math.abs(O) < 30 * 60 * 1e3 && (Date.prototype.setTime.call(e, +e + O), Lc(e));
}
function Y9(e) {
  return Date.UTC(e[0], e.length > 1 ? e[1] : 0, e.length > 2 ? e[2] : 1, ...e.slice(3));
}
function C0(e, t) {
  const n = new Date(t ?? +e);
  return n.setUTCSeconds(n.getUTCSeconds() - Math.round(-Kr(e.timeZone, n) * 60)), +n;
}
class Tn extends Dr {
  //#region static
  static tz(t, ...n) {
    return n.length ? new Tn(...n, t) : new Tn(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), o = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + o;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, o] = this.internal.toUTCString().split(" ");
    return `${t == null ? void 0 : t.slice(0, -1)} ${r} ${n} ${o}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, o] = this.tzComponents();
    return `${t} GMT${n}${r}${o} (${H9(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), o = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, o];
  }
  //#endregion
  withTimeZone(t) {
    return new Tn(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Tn(+new Date(t), this.timeZone);
  }
  //#endregion
}
const IE = 6048e5, j9 = 864e5, E0 = Symbol.for("constructDateFrom");
function hn(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && E0 in e ? e[E0](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function $t(e, t) {
  return hn(t || e, e);
}
function kE(e, t, n) {
  const r = $t(e, n == null ? void 0 : n.in);
  return isNaN(t) ? hn((n == null ? void 0 : n.in) || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function DE(e, t, n) {
  const r = $t(e, n == null ? void 0 : n.in);
  if (isNaN(t))
    return hn((n == null ? void 0 : n.in) || e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), s = hn((n == null ? void 0 : n.in) || e, r.getTime());
  s.setMonth(r.getMonth() + t + 1, 0);
  const i = s.getDate();
  return o >= i ? s : (r.setFullYear(
    s.getFullYear(),
    s.getMonth(),
    o
  ), r);
}
let U9 = {};
function qa() {
  return U9;
}
function ni(e, t) {
  var a, l, c, u;
  const n = qa(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = $t(e, t == null ? void 0 : t.in), s = o.getDay(), i = (s < r ? 7 : 0) + s - r;
  return o.setDate(o.getDate() - i), o.setHours(0, 0, 0, 0), o;
}
function wa(e, t) {
  return ni(e, { ...t, weekStartsOn: 1 });
}
function NE(e, t) {
  const n = $t(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = hn(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const s = wa(o), i = hn(n, 0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const a = wa(i);
  return n.getTime() >= s.getTime() ? r + 1 : n.getTime() >= a.getTime() ? r : r - 1;
}
function _0(e) {
  const t = $t(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function pi(e, ...t) {
  const n = hn.bind(
    null,
    e || t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function Ca(e, t) {
  const n = $t(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function $g(e, t, n) {
  const [r, o] = pi(
    n == null ? void 0 : n.in,
    e,
    t
  ), s = Ca(r), i = Ca(o), a = +s - _0(s), l = +i - _0(i);
  return Math.round((a - l) / j9);
}
function G9(e, t) {
  const n = NE(e, t), r = hn((t == null ? void 0 : t.in) || e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), wa(r);
}
function K9(e, t, n) {
  return kE(e, t * 7, n);
}
function q9(e, t, n) {
  return DE(e, t * 12, n);
}
function X9(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = hn.bind(null, o));
    const s = $t(o, r);
    (!n || n < s || isNaN(+s)) && (n = s);
  }), hn(r, n || NaN);
}
function Z9(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = hn.bind(null, o));
    const s = $t(o, r);
    (!n || n > s || isNaN(+s)) && (n = s);
  }), hn(r, n || NaN);
}
function Q9(e, t, n) {
  const [r, o] = pi(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +Ca(r) == +Ca(o);
}
function AE(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function J9(e) {
  return !(!AE(e) && typeof e != "number" || isNaN(+$t(e)));
}
function $E(e, t, n) {
  const [r, o] = pi(
    n == null ? void 0 : n.in,
    e,
    t
  ), s = r.getFullYear() - o.getFullYear(), i = r.getMonth() - o.getMonth();
  return s * 12 + i;
}
function e7(e, t) {
  const n = $t(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function FE(e, t) {
  const [n, r] = pi(e, t.start, t.end);
  return { start: n, end: r };
}
function t7(e, t) {
  const { start: n, end: r } = FE(t == null ? void 0 : t.in, e);
  let o = +n > +r;
  const s = o ? +n : +r, i = o ? r : n;
  i.setHours(0, 0, 0, 0), i.setDate(1);
  let a = (t == null ? void 0 : t.step) ?? 1;
  if (!a)
    return [];
  a < 0 && (a = -a, o = !o);
  const l = [];
  for (; +i <= s; )
    l.push(hn(n, i)), i.setMonth(i.getMonth() + a);
  return o ? l.reverse() : l;
}
function n7(e, t) {
  const n = $t(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function r7(e, t) {
  const n = $t(e, t == null ? void 0 : t.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function LE(e, t) {
  const n = $t(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function o7(e, t) {
  const { start: n, end: r } = FE(t == null ? void 0 : t.in, e);
  let o = +n > +r;
  const s = o ? +n : +r, i = o ? r : n;
  i.setHours(0, 0, 0, 0), i.setMonth(0, 1);
  let a = (t == null ? void 0 : t.step) ?? 1;
  if (!a)
    return [];
  a < 0 && (a = -a, o = !o);
  const l = [];
  for (; +i <= s; )
    l.push(hn(n, i)), i.setFullYear(i.getFullYear() + a);
  return o ? l.reverse() : l;
}
function VE(e, t) {
  var a, l, c, u;
  const n = qa(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = $t(e, t == null ? void 0 : t.in), s = o.getDay(), i = (s < r ? -7 : 0) + 6 - (s - r);
  return o.setDate(o.getDate() + i), o.setHours(23, 59, 59, 999), o;
}
function s7(e, t) {
  return VE(e, { ...t, weekStartsOn: 1 });
}
const i7 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, a7 = (e, t, n) => {
  let r;
  const o = i7[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function ef(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const l7 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, c7 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, u7 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, d7 = {
  date: ef({
    formats: l7,
    defaultWidth: "full"
  }),
  time: ef({
    formats: c7,
    defaultWidth: "full"
  }),
  dateTime: ef({
    formats: u7,
    defaultWidth: "full"
  })
}, f7 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, h7 = (e, t, n, r) => f7[e];
function Ai(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : i;
      o = e.formattingValues[a] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, a = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[a] || e.values[i];
    }
    const s = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[s];
  };
}
const p7 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, g7 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, m7 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, b7 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, v7 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, y7 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, x7 = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, w7 = {
  ordinalNumber: x7,
  era: Ai({
    values: p7,
    defaultWidth: "wide"
  }),
  quarter: Ai({
    values: g7,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ai({
    values: m7,
    defaultWidth: "wide"
  }),
  day: Ai({
    values: b7,
    defaultWidth: "wide"
  }),
  dayPeriod: Ai({
    values: v7,
    defaultWidth: "wide",
    formattingValues: y7,
    defaultFormattingWidth: "wide"
  })
};
function $i(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], s = t.match(o);
    if (!s)
      return null;
    const i = s[0], a = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(a) ? E7(a, (d) => d.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      C7(a, (d) => d.test(i))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = t.slice(i.length);
    return { value: c, rest: u };
  };
}
function C7(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function E7(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function _7(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r)
      return null;
    const o = r[0], s = t.match(e.parsePattern);
    if (!s)
      return null;
    let i = e.valueCallback ? e.valueCallback(s[0]) : s[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const a = t.slice(o.length);
    return { value: i, rest: a };
  };
}
const S7 = /^(\d+)(th|st|nd|rd)?/i, O7 = /\d+/i, M7 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, T7 = {
  any: [/^b/i, /^(a|c)/i]
}, R7 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, P7 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, I7 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, k7 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, D7 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, N7 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, A7 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, $7 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, F7 = {
  ordinalNumber: _7({
    matchPattern: S7,
    parsePattern: O7,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: $i({
    matchPatterns: M7,
    defaultMatchWidth: "wide",
    parsePatterns: T7,
    defaultParseWidth: "any"
  }),
  quarter: $i({
    matchPatterns: R7,
    defaultMatchWidth: "wide",
    parsePatterns: P7,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: $i({
    matchPatterns: I7,
    defaultMatchWidth: "wide",
    parsePatterns: k7,
    defaultParseWidth: "any"
  }),
  day: $i({
    matchPatterns: D7,
    defaultMatchWidth: "wide",
    parsePatterns: N7,
    defaultParseWidth: "any"
  }),
  dayPeriod: $i({
    matchPatterns: A7,
    defaultMatchWidth: "any",
    parsePatterns: $7,
    defaultParseWidth: "any"
  })
}, Fs = {
  code: "en-US",
  formatDistance: a7,
  formatLong: d7,
  formatRelative: h7,
  localize: w7,
  match: F7,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function L7(e, t) {
  const n = $t(e, t == null ? void 0 : t.in);
  return $g(n, LE(n)) + 1;
}
function Fg(e, t) {
  const n = $t(e, t == null ? void 0 : t.in), r = +wa(n) - +G9(n);
  return Math.round(r / IE) + 1;
}
function WE(e, t) {
  var u, d, f, h;
  const n = $t(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = qa(), s = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((h = (f = o.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = hn((t == null ? void 0 : t.in) || e, 0);
  i.setFullYear(r + 1, 0, s), i.setHours(0, 0, 0, 0);
  const a = ni(i, t), l = hn((t == null ? void 0 : t.in) || e, 0);
  l.setFullYear(r, 0, s), l.setHours(0, 0, 0, 0);
  const c = ni(l, t);
  return +n >= +a ? r + 1 : +n >= +c ? r : r - 1;
}
function V7(e, t) {
  var a, l, c, u;
  const n = qa(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, o = WE(e, t), s = hn((t == null ? void 0 : t.in) || e, 0);
  return s.setFullYear(o, 0, r), s.setHours(0, 0, 0, 0), ni(s, t);
}
function Lg(e, t) {
  const n = $t(e, t == null ? void 0 : t.in), r = +ni(n, t) - +V7(n, t);
  return Math.round(r / IE) + 1;
}
function Et(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const bo = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Et(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Et(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Et(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Et(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Et(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Et(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Et(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Et(o, t.length);
  }
}, Is = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, S0 = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return bo.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = WE(e, r), s = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const i = s % 100;
      return Et(i, 2);
    }
    return t === "Yo" ? n.ordinalNumber(s, { unit: "year" }) : Et(s, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = NE(e);
    return Et(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Et(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return Et(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return Et(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return bo.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return Et(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = Lg(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : Et(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = Fg(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Et(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : bo.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = L7(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Et(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), s = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(s);
      case "ee":
        return Et(s, 2);
      case "eo":
        return n.ordinalNumber(s, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), s = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(s);
      case "cc":
        return Et(s, t.length);
      case "co":
        return n.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return Et(o, t.length);
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = Is.noon : r === 0 ? o = Is.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = Is.evening : r >= 12 ? o = Is.afternoon : r >= 4 ? o = Is.morning : o = Is.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return bo.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : bo.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Et(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Et(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : bo.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : bo.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return bo.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return M0(r);
      case "XXXX":
      case "XX":
        return ts(r);
      case "XXXXX":
      case "XXX":
      default:
        return ts(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return M0(r);
      case "xxxx":
      case "xx":
        return ts(r);
      case "xxxxx":
      case "xxx":
      default:
        return ts(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + O0(r, ":");
      case "OOOO":
      default:
        return "GMT" + ts(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + O0(r, ":");
      case "zzzz":
      default:
        return "GMT" + ts(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return Et(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return Et(+e, t.length);
  }
};
function O0(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), s = r % 60;
  return s === 0 ? n + String(o) : n + String(o) + t + Et(s, 2);
}
function M0(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Et(Math.abs(e) / 60, 2) : ts(e, t);
}
function ts(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Et(Math.trunc(r / 60), 2), s = Et(r % 60, 2);
  return n + o + t + s;
}
const T0 = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, HE = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, W7 = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return T0(e, t);
  let s;
  switch (r) {
    case "P":
      s = t.dateTime({ width: "short" });
      break;
    case "PP":
      s = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      s = t.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", T0(r, t)).replace("{{time}}", HE(o, t));
}, H7 = {
  p: HE,
  P: W7
}, B7 = /^D+$/, z7 = /^Y+$/, Y7 = ["D", "DD", "YY", "YYYY"];
function j7(e) {
  return B7.test(e);
}
function U7(e) {
  return z7.test(e);
}
function G7(e, t, n) {
  const r = K7(e, t, n);
  if (console.warn(r), Y7.includes(e))
    throw new RangeError(r);
}
function K7(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const q7 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, X7 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Z7 = /^'([^]*?)'?$/, Q7 = /''/g, J7 = /[a-zA-Z]/;
function Gi(e, t, n) {
  var u, d, f, h, p, g, m, v;
  const r = qa(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? Fs, s = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (p = n == null ? void 0 : n.locale) == null ? void 0 : p.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((v = (m = r.locale) == null ? void 0 : m.options) == null ? void 0 : v.weekStartsOn) ?? 0, a = $t(e, n == null ? void 0 : n.in);
  if (!J9(a))
    throw new RangeError("Invalid time value");
  let l = t.match(X7).map((y) => {
    const x = y[0];
    if (x === "p" || x === "P") {
      const C = H7[x];
      return C(y, o.formatLong);
    }
    return y;
  }).join("").match(q7).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const x = y[0];
    if (x === "'")
      return { isToken: !1, value: e8(y) };
    if (S0[x])
      return { isToken: !0, value: y };
    if (x.match(J7))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + x + "`"
      );
    return { isToken: !1, value: y };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(a, l));
  const c = {
    firstWeekContainsDate: s,
    weekStartsOn: i,
    locale: o
  };
  return l.map((y) => {
    if (!y.isToken)
      return y.value;
    const x = y.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && U7(x) || !(n != null && n.useAdditionalDayOfYearTokens) && j7(x)) && G7(x, t, String(e));
    const C = S0[x[0]];
    return C(a, x, o.localize, c);
  }).join("");
}
function e8(e) {
  const t = e.match(Z7);
  return t ? t[1].replace(Q7, "'") : e;
}
function t8(e, t) {
  const n = $t(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = n.getMonth(), s = hn(n, 0);
  return s.setFullYear(r, o + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function n8(e, t) {
  return $t(e, t == null ? void 0 : t.in).getMonth();
}
function r8(e, t) {
  return $t(e, t == null ? void 0 : t.in).getFullYear();
}
function o8(e, t) {
  return +$t(e) > +$t(t);
}
function s8(e, t) {
  return +$t(e) < +$t(t);
}
function i8(e, t, n) {
  const [r, o] = pi(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function a8(e, t, n) {
  const [r, o] = pi(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear();
}
function l8(e, t, n) {
  const r = $t(e, n == null ? void 0 : n.in), o = r.getFullYear(), s = r.getDate(), i = hn((n == null ? void 0 : n.in) || e, 0);
  i.setFullYear(o, t, 15), i.setHours(0, 0, 0, 0);
  const a = t8(i);
  return r.setMonth(t, Math.min(s, a)), r;
}
function c8(e, t, n) {
  const r = $t(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? hn((n == null ? void 0 : n.in) || e, NaN) : (r.setFullYear(t), r);
}
const R0 = 5, u8 = 4;
function d8(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, o = t.addDays(e, -r + 1), s = t.addDays(o, R0 * 7 - 1);
  return t.getMonth(e) === t.getMonth(s) ? R0 : u8;
}
function BE(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -1 * 6) : t.addDays(n, -1 * (r - 1));
}
function f8(e, t) {
  const n = BE(e, t), r = d8(e, t);
  return t.addDays(n, r * 7 - 1);
}
const zE = {
  ...Fs,
  labels: {
    labelDayButton: (e, t, n, r) => {
      let o;
      r && typeof r.format == "function" ? o = r.format.bind(r) : o = (i, a) => Gi(i, a, { locale: Fs, ...n });
      let s = o(e, "PPPP");
      return t.today && (s = `Today, ${s}`), t.selected && (s = `${s}, selected`), s;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (e) => `Week ${e}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (e, t, n) => {
      let r;
      return n && typeof n.format == "function" ? r = n.format.bind(n) : r = (o, s) => Gi(o, s, { locale: Fs, ...t }), r(e, "LLLL yyyy");
    },
    labelGridcell: (e, t, n, r) => {
      let o;
      r && typeof r.format == "function" ? o = r.format.bind(r) : o = (i, a) => Gi(i, a, { locale: Fs, ...n });
      let s = o(e, "PPPP");
      return t != null && t.today && (s = `Today, ${s}`), s;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (e, t, n) => {
      let r;
      return n && typeof n.format == "function" ? r = n.format.bind(n) : r = (o, s) => Gi(o, s, { locale: Fs, ...t }), r(e, "cccc");
    }
  }
};
class Zn {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.today = () => {
      var o;
      if ((o = this.overrides) != null && o.today)
        return this.overrides.today();
      if (this.options.timeZone)
        return Tn.tz(this.options.timeZone);
      const r = this.options.Date ?? Date;
      return new r();
    }, this.newDate = (r, o, s) => {
      var i;
      return (i = this.overrides) != null && i.newDate ? this.overrides.newDate(r, o, s) : this.options.timeZone ? new Tn(r, o, s, this.options.timeZone) : new Date(r, o, s);
    }, this.addDays = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.addDays ? this.overrides.addDays(r, o) : kE(r, o);
    }, this.addMonths = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.addMonths ? this.overrides.addMonths(r, o) : DE(r, o);
    }, this.addWeeks = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.addWeeks ? this.overrides.addWeeks(r, o) : K9(r, o);
    }, this.addYears = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.addYears ? this.overrides.addYears(r, o) : q9(r, o);
    }, this.differenceInCalendarDays = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, o) : $g(r, o);
    }, this.differenceInCalendarMonths = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, o) : $E(r, o);
    }, this.eachMonthOfInterval = (r) => {
      var o;
      return (o = this.overrides) != null && o.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : t7(r);
    }, this.eachYearOfInterval = (r) => {
      var a;
      const o = (a = this.overrides) != null && a.eachYearOfInterval ? this.overrides.eachYearOfInterval(r) : o7(r), s = new Set(o.map((l) => this.getYear(l)));
      if (s.size === o.length)
        return o;
      const i = [];
      return s.forEach((l) => {
        i.push(new Date(l, 0, 1));
      }), i;
    }, this.endOfBroadcastWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : f8(r, this);
    }, this.endOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfISOWeek ? this.overrides.endOfISOWeek(r) : s7(r);
    }, this.endOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfMonth ? this.overrides.endOfMonth(r) : e7(r);
    }, this.endOfWeek = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.endOfWeek ? this.overrides.endOfWeek(r, o) : VE(r, this.options);
    }, this.endOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfYear ? this.overrides.endOfYear(r) : r7(r);
    }, this.format = (r, o, s) => {
      var a;
      const i = (a = this.overrides) != null && a.format ? this.overrides.format(r, o, this.options) : Gi(r, o, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(i) : i;
    }, this.getISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.getISOWeek ? this.overrides.getISOWeek(r) : Fg(r);
    }, this.getMonth = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.getMonth ? this.overrides.getMonth(r, this.options) : n8(r, this.options);
    }, this.getYear = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.getYear ? this.overrides.getYear(r, this.options) : r8(r, this.options);
    }, this.getWeek = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.getWeek ? this.overrides.getWeek(r, this.options) : Lg(r, this.options);
    }, this.isAfter = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.isAfter ? this.overrides.isAfter(r, o) : o8(r, o);
    }, this.isBefore = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.isBefore ? this.overrides.isBefore(r, o) : s8(r, o);
    }, this.isDate = (r) => {
      var o;
      return (o = this.overrides) != null && o.isDate ? this.overrides.isDate(r) : AE(r);
    }, this.isSameDay = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.isSameDay ? this.overrides.isSameDay(r, o) : Q9(r, o);
    }, this.isSameMonth = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.isSameMonth ? this.overrides.isSameMonth(r, o) : i8(r, o);
    }, this.isSameYear = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.isSameYear ? this.overrides.isSameYear(r, o) : a8(r, o);
    }, this.max = (r) => {
      var o;
      return (o = this.overrides) != null && o.max ? this.overrides.max(r) : X9(r);
    }, this.min = (r) => {
      var o;
      return (o = this.overrides) != null && o.min ? this.overrides.min(r) : Z9(r);
    }, this.setMonth = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.setMonth ? this.overrides.setMonth(r, o) : l8(r, o);
    }, this.setYear = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.setYear ? this.overrides.setYear(r, o) : c8(r, o);
    }, this.startOfBroadcastWeek = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : BE(r, this);
    }, this.startOfDay = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfDay ? this.overrides.startOfDay(r) : Ca(r);
    }, this.startOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfISOWeek ? this.overrides.startOfISOWeek(r) : wa(r);
    }, this.startOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfMonth ? this.overrides.startOfMonth(r) : n7(r);
    }, this.startOfWeek = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.startOfWeek ? this.overrides.startOfWeek(r, this.options) : ni(r, this.options);
    }, this.startOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfYear ? this.overrides.startOfYear(r) : LE(r);
    }, this.options = { locale: zE, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), r = {};
    for (let o = 0; o < 10; o++)
      r[o.toString()] = n.format(o);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    var n;
    const t = (n = this.options.locale) == null ? void 0 : n.code;
    return t && Zn.yearFirstLocales.has(t) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(t) {
    const { locale: n, timeZone: r, numerals: o } = this.options, s = n == null ? void 0 : n.code;
    if (s && Zn.yearFirstLocales.has(s))
      try {
        return new Intl.DateTimeFormat(s, {
          month: "long",
          year: "numeric",
          timeZone: r,
          numberingSystem: o
        }).format(t);
      } catch {
      }
    const i = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(t, i);
  }
}
Zn.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const Hr = new Zn();
class YE {
  constructor(t, n, r = Hr) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r, this.isoDate = r.format(t, "yyyy-MM-dd"), this.displayMonthId = r.format(n, "yyyy-MM"), this.dateMonthId = r.format(t, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class h8 {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class p8 {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function g8(e) {
  return Oe.createElement("span", { ...e });
}
function m8(e) {
  const { size: t = 24, orientation: n = "left", className: r, style: o } = e;
  return Oe.createElement(
    "svg",
    { className: r, style: o, width: t, height: t, viewBox: "0 0 24 24" },
    n === "up" && Oe.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && Oe.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && Oe.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && Oe.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
  );
}
function b8(e) {
  const { day: t, modifiers: n, ...r } = e;
  return Oe.createElement("td", { ...r });
}
function v8(e) {
  const { day: t, modifiers: n, ...r } = e, o = Oe.useRef(null);
  return Oe.useEffect(() => {
    var s;
    n.focused && ((s = o.current) == null || s.focus());
  }, [n.focused]), Oe.createElement("button", { ref: o, ...r });
}
var $e;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})($e || ($e = {}));
var Kt;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(Kt || (Kt = {}));
var gr;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(gr || (gr = {}));
var Yn;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(Yn || (Yn = {}));
const jE = ac(void 0);
function Xa() {
  const e = _h(jE);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function y8(e) {
  const { options: t, className: n, ...r } = e, { classNames: o, components: s, styles: i } = Xa(), a = [o[$e.Dropdown], n].join(" "), l = t == null ? void 0 : t.find(({ value: c }) => c === r.value);
  return Oe.createElement(
    "span",
    { "data-disabled": r.disabled, className: o[$e.DropdownRoot], style: i == null ? void 0 : i[$e.DropdownRoot] },
    Oe.createElement(s.Select, { className: a, ...r }, t == null ? void 0 : t.map(({ value: c, label: u, disabled: d }) => Oe.createElement(s.Option, { key: c, value: c, disabled: d }, u))),
    Oe.createElement(
      "span",
      { className: o[$e.CaptionLabel], style: i == null ? void 0 : i[$e.CaptionLabel], "aria-hidden": !0 },
      l == null ? void 0 : l.label,
      Oe.createElement(s.Chevron, { orientation: "down", size: 18, className: o[$e.Chevron], style: i == null ? void 0 : i[$e.Chevron] })
    )
  );
}
function x8(e) {
  return Oe.createElement("div", { ...e });
}
function w8(e) {
  return Oe.createElement("div", { ...e });
}
function C8(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return Oe.createElement("div", { ...r }, e.children);
}
function E8(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return Oe.createElement("div", { ...r });
}
function _8(e) {
  return Oe.createElement("table", { ...e });
}
function S8(e) {
  return Oe.createElement("div", { ...e });
}
function O8(e) {
  const { components: t } = Xa();
  return Oe.createElement(t.Dropdown, { ...e });
}
function M8(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: o, ...s } = e, { components: i, classNames: a, styles: l, labels: { labelPrevious: c, labelNext: u } } = Xa(), d = ot((h) => {
    o && (n == null || n(h));
  }, [o, n]), f = ot((h) => {
    r && (t == null || t(h));
  }, [r, t]);
  return Oe.createElement(
    "nav",
    { ...s },
    Oe.createElement(
      i.PreviousMonthButton,
      { type: "button", className: a[$e.PreviousMonthButton], style: l == null ? void 0 : l[$e.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": c(r), onClick: f },
      Oe.createElement(i.Chevron, { disabled: r ? void 0 : !0, className: a[$e.Chevron], style: l == null ? void 0 : l[$e.Chevron], orientation: "left" })
    ),
    Oe.createElement(
      i.NextMonthButton,
      { type: "button", className: a[$e.NextMonthButton], style: l == null ? void 0 : l[$e.NextMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": u(o), onClick: d },
      Oe.createElement(i.Chevron, { disabled: o ? void 0 : !0, orientation: "right", className: a[$e.Chevron], style: l == null ? void 0 : l[$e.Chevron] })
    )
  );
}
function T8(e) {
  return Oe.createElement("button", { ...e });
}
function R8(e) {
  return Oe.createElement("option", { ...e });
}
function P8(e) {
  return Oe.createElement("button", { ...e });
}
function I8(e) {
  const { rootRef: t, ...n } = e;
  return Oe.createElement("div", { ...n, ref: t });
}
function k8(e) {
  return Oe.createElement("select", { ...e });
}
function D8(e) {
  const { week: t, ...n } = e;
  return Oe.createElement("tr", { ...n });
}
function N8(e) {
  return Oe.createElement("th", { ...e });
}
function A8(e) {
  return Oe.createElement(
    "thead",
    { "aria-hidden": !0 },
    Oe.createElement("tr", { ...e })
  );
}
function $8(e) {
  const { week: t, ...n } = e;
  return Oe.createElement("th", { ...n });
}
function F8(e) {
  return Oe.createElement("th", { ...e });
}
function L8(e) {
  return Oe.createElement("tbody", { ...e });
}
function V8(e) {
  const { components: t } = Xa();
  return Oe.createElement(t.Dropdown, { ...e });
}
const W8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CaptionLabel: g8,
  Chevron: m8,
  Day: b8,
  DayButton: v8,
  Dropdown: y8,
  DropdownNav: x8,
  Footer: w8,
  Month: C8,
  MonthCaption: E8,
  MonthGrid: _8,
  Months: S8,
  MonthsDropdown: O8,
  Nav: M8,
  NextMonthButton: T8,
  Option: R8,
  PreviousMonthButton: P8,
  Root: I8,
  Select: k8,
  Week: D8,
  WeekNumber: $8,
  WeekNumberHeader: F8,
  Weekday: N8,
  Weekdays: A8,
  Weeks: L8,
  YearsDropdown: V8
}, Symbol.toStringTag, { value: "Module" }));
function Zr(e, t, n = !1, r = Hr) {
  let { from: o, to: s } = e;
  const { differenceInCalendarDays: i, isSameDay: a } = r;
  return o && s ? (i(s, o) < 0 && ([o, s] = [s, o]), i(t, o) >= (n ? 1 : 0) && i(s, t) >= (n ? 1 : 0)) : !n && s ? a(s, t) : !n && o ? a(o, t) : !1;
}
function Vg(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function ed(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function Wg(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function Hg(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function UE(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function GE(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function Qr(e, t, n = Hr) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: o, differenceInCalendarDays: s, isAfter: i } = n;
  return r.some((a) => {
    if (typeof a == "boolean")
      return a;
    if (n.isDate(a))
      return o(e, a);
    if (GE(a, n))
      return a.some((l) => o(e, l));
    if (ed(a))
      return Zr(a, e, !1, n);
    if (UE(a))
      return Array.isArray(a.dayOfWeek) ? a.dayOfWeek.includes(e.getDay()) : a.dayOfWeek === e.getDay();
    if (Vg(a)) {
      const l = s(a.before, e), c = s(a.after, e), u = l > 0, d = c < 0;
      return i(a.before, a.after) ? d && u : u || d;
    }
    return Wg(a) ? s(e, a.after) > 0 : Hg(a) ? s(a.before, e) > 0 : typeof a == "function" ? a(e) : !1;
  });
}
function H8(e, t, n, r, o) {
  const { disabled: s, hidden: i, modifiers: a, showOutsideDays: l, broadcastCalendar: c, today: u = o.today() } = t, { isSameDay: d, isSameMonth: f, startOfMonth: h, isBefore: p, endOfMonth: g, isAfter: m } = o, v = n && h(n), y = r && g(r), x = {
    [Kt.focused]: [],
    [Kt.outside]: [],
    [Kt.disabled]: [],
    [Kt.hidden]: [],
    [Kt.today]: []
  }, C = {};
  for (const w of e) {
    const { date: E, displayMonth: S } = w, O = !!(S && !f(E, S)), M = !!(v && p(E, v)), T = !!(y && m(E, y)), P = !!(s && Qr(E, s, o)), I = !!(i && Qr(E, i, o)) || M || T || // Broadcast calendar will show outside days as default
    !c && !l && O || c && l === !1 && O, R = d(E, u);
    O && x.outside.push(w), P && x.disabled.push(w), I && x.hidden.push(w), R && x.today.push(w), a && Object.keys(a).forEach((D) => {
      const k = a == null ? void 0 : a[D];
      k && Qr(E, k, o) && (C[D] ? C[D].push(w) : C[D] = [w]);
    });
  }
  return (w) => {
    const E = {
      [Kt.focused]: !1,
      [Kt.disabled]: !1,
      [Kt.hidden]: !1,
      [Kt.outside]: !1,
      [Kt.today]: !1
    }, S = {};
    for (const O in x) {
      const M = x[O];
      E[O] = M.some((T) => T === w);
    }
    for (const O in C)
      S[O] = C[O].some((M) => M === w);
    return {
      ...E,
      // custom modifiers should override all the previous ones
      ...S
    };
  };
}
function B8(e, t, n = {}) {
  return Object.entries(e).filter(([, o]) => o === !0).reduce((o, [s]) => (n[s] ? o.push(n[s]) : t[Kt[s]] ? o.push(t[Kt[s]]) : t[gr[s]] && o.push(t[gr[s]]), o), [t[$e.Day]]);
}
function z8(e) {
  return {
    ...W8,
    ...e
  };
}
function Y8(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function j8() {
  const e = {};
  for (const t in $e)
    e[$e[t]] = `rdp-${$e[t]}`;
  for (const t in Kt)
    e[Kt[t]] = `rdp-${Kt[t]}`;
  for (const t in gr)
    e[gr[t]] = `rdp-${gr[t]}`;
  for (const t in Yn)
    e[Yn[t]] = `rdp-${Yn[t]}`;
  return e;
}
function U8(e, t, n) {
  return (n ?? new Zn(t)).formatMonthYear(e);
}
function G8(e, t, n) {
  return (n ?? new Zn(t)).format(e, "d");
}
function K8(e, t = Hr) {
  return t.format(e, "LLLL");
}
function q8(e, t, n) {
  return (n ?? new Zn(t)).format(e, "cccccc");
}
function X8(e, t = Hr) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function Z8() {
  return "";
}
function Q8(e, t = Hr) {
  return t.format(e, "yyyy");
}
const J8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: U8,
  formatDay: G8,
  formatMonthDropdown: K8,
  formatWeekNumber: X8,
  formatWeekNumberHeader: Z8,
  formatWeekdayName: q8,
  formatYearDropdown: Q8
}, Symbol.toStringTag, { value: "Module" }));
function e$(e) {
  return {
    ...J8,
    ...e
  };
}
function KE(e, t, n, r) {
  let o = (r ?? new Zn(n)).format(e, "PPPP");
  return t.today && (o = `Today, ${o}`), t.selected && (o = `${o}, selected`), o;
}
function qE(e, t, n) {
  return (n ?? new Zn(t)).formatMonthYear(e);
}
function XE(e, t, n, r) {
  let o = (r ?? new Zn(n)).format(e, "PPPP");
  return t != null && t.today && (o = `Today, ${o}`), o;
}
function ZE(e) {
  return "Choose the Month";
}
function QE() {
  return "";
}
const t$ = "Go to the Next Month";
function JE(e, t) {
  return t$;
}
function e_(e) {
  return "Go to the Previous Month";
}
function t_(e, t, n) {
  return (n ?? new Zn(t)).format(e, "cccc");
}
function n_(e, t) {
  return `Week ${e}`;
}
function r_(e) {
  return "Week Number";
}
function o_(e) {
  return "Choose the Year";
}
const n$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelDayButton: KE,
  labelGrid: qE,
  labelGridcell: XE,
  labelMonthDropdown: ZE,
  labelNav: QE,
  labelNext: JE,
  labelPrevious: e_,
  labelWeekNumber: n_,
  labelWeekNumberHeader: r_,
  labelWeekday: t_,
  labelYearDropdown: o_
}, Symbol.toStringTag, { value: "Module" })), hr = (e, t, n) => t || (n ? typeof n == "function" ? n : (...r) => n : e);
function r$(e, t) {
  var r;
  const n = ((r = t.locale) == null ? void 0 : r.labels) ?? {};
  return {
    ...n$,
    ...e ?? {},
    labelDayButton: hr(KE, e == null ? void 0 : e.labelDayButton, n.labelDayButton),
    labelMonthDropdown: hr(ZE, e == null ? void 0 : e.labelMonthDropdown, n.labelMonthDropdown),
    labelNext: hr(JE, e == null ? void 0 : e.labelNext, n.labelNext),
    labelPrevious: hr(e_, e == null ? void 0 : e.labelPrevious, n.labelPrevious),
    labelWeekNumber: hr(n_, e == null ? void 0 : e.labelWeekNumber, n.labelWeekNumber),
    labelYearDropdown: hr(o_, e == null ? void 0 : e.labelYearDropdown, n.labelYearDropdown),
    labelGrid: hr(qE, e == null ? void 0 : e.labelGrid, n.labelGrid),
    labelGridcell: hr(XE, e == null ? void 0 : e.labelGridcell, n.labelGridcell),
    labelNav: hr(QE, e == null ? void 0 : e.labelNav, n.labelNav),
    labelWeekNumberHeader: hr(r_, e == null ? void 0 : e.labelWeekNumberHeader, n.labelWeekNumberHeader),
    labelWeekday: hr(t_, e == null ? void 0 : e.labelWeekday, n.labelWeekday)
  };
}
function o$(e, t, n, r, o) {
  const { startOfMonth: s, startOfYear: i, endOfYear: a, eachMonthOfInterval: l, getMonth: c } = o;
  return l({
    start: i(e),
    end: a(e)
  }).map((f) => {
    const h = r.formatMonthDropdown(f, o), p = c(f), g = t && f < s(t) || n && f > s(n) || !1;
    return { value: p, label: h, disabled: g };
  });
}
function s$(e, t = {}, n = {}) {
  let r = { ...t == null ? void 0 : t[$e.Day] };
  return Object.entries(e).filter(([, o]) => o === !0).forEach(([o]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[o]
    };
  }), r;
}
function i$(e, t, n, r) {
  const o = r ?? e.today(), s = n ? e.startOfBroadcastWeek(o, e) : t ? e.startOfISOWeek(o) : e.startOfWeek(o), i = [];
  for (let a = 0; a < 7; a++) {
    const l = e.addDays(s, a);
    i.push(l);
  }
  return i;
}
function a$(e, t, n, r, o = !1) {
  if (!e || !t)
    return;
  const { startOfYear: s, endOfYear: i, eachYearOfInterval: a, getYear: l } = r, c = s(e), u = i(t), d = a({ start: c, end: u });
  return o && d.reverse(), d.map((f) => {
    const h = n.formatYearDropdown(f, r);
    return {
      value: l(f),
      label: h,
      disabled: !1
    };
  });
}
function l$(e, t = {}) {
  var a;
  const { weekStartsOn: n, locale: r } = t, o = n ?? ((a = r == null ? void 0 : r.options) == null ? void 0 : a.weekStartsOn) ?? 0, s = (l) => {
    const c = typeof l == "number" || typeof l == "string" ? new Date(l) : l;
    return new Tn(c.getFullYear(), c.getMonth(), c.getDate(), 12, 0, 0, e);
  }, i = (l) => {
    const c = s(l);
    return new Date(c.getFullYear(), c.getMonth(), c.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => s(Tn.tz(e)),
    newDate: (l, c, u) => new Tn(l, c, u, 12, 0, 0, e),
    startOfDay: (l) => s(l),
    startOfWeek: (l, c) => {
      const u = s(l), d = (c == null ? void 0 : c.weekStartsOn) ?? o, f = (u.getDay() - d + 7) % 7;
      return u.setDate(u.getDate() - f), u;
    },
    startOfISOWeek: (l) => {
      const c = s(l), u = (c.getDay() - 1 + 7) % 7;
      return c.setDate(c.getDate() - u), c;
    },
    startOfMonth: (l) => {
      const c = s(l);
      return c.setDate(1), c;
    },
    startOfYear: (l) => {
      const c = s(l);
      return c.setMonth(0, 1), c;
    },
    endOfWeek: (l, c) => {
      const u = s(l), h = ((((c == null ? void 0 : c.weekStartsOn) ?? o) + 6) % 7 - u.getDay() + 7) % 7;
      return u.setDate(u.getDate() + h), u;
    },
    endOfISOWeek: (l) => {
      const c = s(l), u = (7 - c.getDay()) % 7;
      return c.setDate(c.getDate() + u), c;
    },
    endOfMonth: (l) => {
      const c = s(l);
      return c.setMonth(c.getMonth() + 1, 0), c;
    },
    endOfYear: (l) => {
      const c = s(l);
      return c.setMonth(11, 31), c;
    },
    eachMonthOfInterval: (l) => {
      const c = s(l.start), u = s(l.end), d = [], f = new Tn(c.getFullYear(), c.getMonth(), 1, 12, 0, 0, e), h = u.getFullYear() * 12 + u.getMonth();
      for (; f.getFullYear() * 12 + f.getMonth() <= h; )
        d.push(new Tn(f, e)), f.setMonth(f.getMonth() + 1, 1);
      return d;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (l, c) => {
      const u = s(l);
      return u.setDate(u.getDate() + c), u;
    },
    addWeeks: (l, c) => {
      const u = s(l);
      return u.setDate(u.getDate() + c * 7), u;
    },
    addMonths: (l, c) => {
      const u = s(l);
      return u.setMonth(u.getMonth() + c), u;
    },
    addYears: (l, c) => {
      const u = s(l);
      return u.setFullYear(u.getFullYear() + c), u;
    },
    eachYearOfInterval: (l) => {
      const c = s(l.start), u = s(l.end), d = [], f = new Tn(c.getFullYear(), 0, 1, 12, 0, 0, e);
      for (; f.getFullYear() <= u.getFullYear(); )
        d.push(new Tn(f, e)), f.setFullYear(f.getFullYear() + 1, 0, 1);
      return d;
    },
    getWeek: (l, c) => {
      var d;
      const u = i(l);
      return Lg(u, {
        weekStartsOn: (c == null ? void 0 : c.weekStartsOn) ?? o,
        firstWeekContainsDate: (c == null ? void 0 : c.firstWeekContainsDate) ?? ((d = r == null ? void 0 : r.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1
      });
    },
    getISOWeek: (l) => {
      const c = i(l);
      return Fg(c);
    },
    differenceInCalendarDays: (l, c) => {
      const u = i(l), d = i(c);
      return $g(u, d);
    },
    differenceInCalendarMonths: (l, c) => {
      const u = i(l), d = i(c);
      return $E(u, d);
    }
  };
}
const Za = (e) => e instanceof HTMLElement ? e : null, tf = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], c$ = (e) => Za(e.querySelector("[data-animated-month]")), nf = (e) => Za(e.querySelector("[data-animated-caption]")), rf = (e) => Za(e.querySelector("[data-animated-weeks]")), u$ = (e) => Za(e.querySelector("[data-animated-nav]")), d$ = (e) => Za(e.querySelector("[data-animated-weekdays]"));
function f$(e, t, { classNames: n, months: r, focused: o, dateLib: s }) {
  const i = et(null), a = et(r), l = et(!1);
  ii(() => {
    const c = a.current;
    if (a.current = r, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || c.length === 0 || r.length !== c.length)
      return;
    const u = s.isSameMonth(r[0].date, c[0].date), d = s.isAfter(r[0].date, c[0].date), f = d ? n[Yn.caption_after_enter] : n[Yn.caption_before_enter], h = d ? n[Yn.weeks_after_enter] : n[Yn.weeks_before_enter], p = i.current, g = e.current.cloneNode(!0);
    if (g instanceof HTMLElement ? (tf(g).forEach((x) => {
      if (!(x instanceof HTMLElement))
        return;
      const C = c$(x);
      C && x.contains(C) && x.removeChild(C);
      const w = nf(x);
      w && w.classList.remove(f);
      const E = rf(x);
      E && E.classList.remove(h);
    }), i.current = g) : i.current = null, l.current || u || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    o)
      return;
    const m = p instanceof HTMLElement ? tf(p) : [], v = tf(e.current);
    if (v != null && v.every((y) => y instanceof HTMLElement) && (m != null && m.every((y) => y instanceof HTMLElement))) {
      l.current = !0, e.current.style.isolation = "isolate";
      const y = u$(e.current);
      y && (y.style.zIndex = "1"), v.forEach((x, C) => {
        const w = m[C];
        if (!w)
          return;
        x.style.position = "relative", x.style.overflow = "hidden";
        const E = nf(x);
        E && E.classList.add(f);
        const S = rf(x);
        S && S.classList.add(h);
        const O = () => {
          l.current = !1, e.current && (e.current.style.isolation = ""), y && (y.style.zIndex = ""), E && E.classList.remove(f), S && S.classList.remove(h), x.style.position = "", x.style.overflow = "", x.contains(w) && x.removeChild(w);
        };
        w.style.pointerEvents = "none", w.style.position = "absolute", w.style.overflow = "hidden", w.setAttribute("aria-hidden", "true");
        const M = d$(w);
        M && (M.style.opacity = "0");
        const T = nf(w);
        T && (T.classList.add(d ? n[Yn.caption_before_exit] : n[Yn.caption_after_exit]), T.addEventListener("animationend", O));
        const P = rf(w);
        P && P.classList.add(d ? n[Yn.weeks_before_exit] : n[Yn.weeks_after_exit]), x.insertBefore(w, x.firstChild);
      });
    }
  });
}
function h$(e, t, n, r) {
  const o = e[0], s = e[e.length - 1], { ISOWeek: i, fixedWeeks: a, broadcastCalendar: l } = n ?? {}, { addDays: c, differenceInCalendarDays: u, differenceInCalendarMonths: d, endOfBroadcastWeek: f, endOfISOWeek: h, endOfMonth: p, endOfWeek: g, isAfter: m, startOfBroadcastWeek: v, startOfISOWeek: y, startOfWeek: x } = r, C = l ? v(o, r) : i ? y(o) : x(o), w = l ? f(s) : i ? h(p(s)) : g(p(s)), E = t && (l ? f(t) : i ? h(t) : g(t)), S = E && m(w, E) ? E : w, O = u(S, C), M = d(s, o) + 1, T = [];
  for (let R = 0; R <= O; R++) {
    const D = c(C, R);
    T.push(D);
  }
  const I = (l ? 35 : 42) * M;
  if (a && T.length < I) {
    const R = I - T.length;
    for (let D = 0; D < R; D++) {
      const k = c(T[T.length - 1], 1);
      T.push(k);
    }
  }
  return T;
}
function p$(e) {
  const t = [];
  return e.reduce((n, r) => {
    const o = r.weeks.reduce((s, i) => s.concat(i.days.slice()), t.slice());
    return n.concat(o.slice());
  }, t.slice());
}
function g$(e, t, n, r) {
  const { numberOfMonths: o = 1 } = n, s = [];
  for (let i = 0; i < o; i++) {
    const a = r.addMonths(e, i);
    if (t && a > t)
      break;
    s.push(a);
  }
  return s;
}
function P0(e, t, n, r) {
  const { month: o, defaultMonth: s, today: i = r.today(), numberOfMonths: a = 1 } = e;
  let l = o || s || i;
  const { differenceInCalendarMonths: c, addMonths: u, startOfMonth: d } = r;
  if (n && c(n, l) < a - 1) {
    const f = -1 * (a - 1);
    l = u(n, f);
  }
  return t && c(l, t) < 0 && (l = t), d(l);
}
function m$(e, t, n, r) {
  const { addDays: o, endOfBroadcastWeek: s, endOfISOWeek: i, endOfMonth: a, endOfWeek: l, getISOWeek: c, getWeek: u, startOfBroadcastWeek: d, startOfISOWeek: f, startOfWeek: h } = r, p = e.reduce((g, m) => {
    const v = n.broadcastCalendar ? d(m, r) : n.ISOWeek ? f(m) : h(m), y = n.broadcastCalendar ? s(m) : n.ISOWeek ? i(a(m)) : l(a(m)), x = t.filter((S) => S >= v && S <= y), C = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && x.length < C) {
      const S = t.filter((O) => {
        const M = C - x.length;
        return O > y && O <= o(y, M);
      });
      x.push(...S);
    }
    const w = x.reduce((S, O) => {
      const M = n.ISOWeek ? c(O) : u(O), T = S.find((I) => I.weekNumber === M), P = new YE(O, m, r);
      return T ? T.days.push(P) : S.push(new p8(M, [P])), S;
    }, []), E = new h8(m, w);
    return g.push(E), g;
  }, []);
  return n.reverseMonths ? p.reverse() : p;
}
function b$(e, t) {
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: o, startOfDay: s, startOfMonth: i, endOfMonth: a, addYears: l, endOfYear: c, today: u } = t, d = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = i(n) : !n && d && (n = o(l(e.today ?? u(), -100))), r ? r = a(r) : !r && d && (r = c(e.today ?? u())), [
    n && s(n),
    r && s(r)
  ];
}
function v$(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: s = 1 } = n, { startOfMonth: i, addMonths: a, differenceInCalendarMonths: l } = r, c = o ? s : 1, u = i(e);
  if (!t)
    return a(u, c);
  if (!(l(t, e) < s))
    return a(u, c);
}
function y$(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: s } = n, { startOfMonth: i, addMonths: a, differenceInCalendarMonths: l } = r, c = o ? s ?? 1 : 1, u = i(e);
  if (!t)
    return a(u, -c);
  if (!(l(u, t) <= 0))
    return a(u, -c);
}
function x$(e) {
  const t = [];
  return e.reduce((n, r) => n.concat(r.weeks.slice()), t.slice());
}
function td(e, t) {
  const [n, r] = Vt(e);
  return [t === void 0 ? n : t, r];
}
function w$(e, t) {
  var C;
  const [n, r] = b$(e, t), { startOfMonth: o, endOfMonth: s } = t, i = P0(e, n, r, t), [a, l] = td(
    i,
    // initialMonth is always computed from props.month if provided
    e.month ? i : void 0
  );
  st(() => {
    const w = P0(e, n, r, t);
    l(w);
  }, [e.timeZone]);
  const { months: c, weeks: u, days: d, previousMonth: f, nextMonth: h } = Ar(() => {
    const w = g$(a, r, { numberOfMonths: e.numberOfMonths }, t), E = h$(w, e.endMonth ? s(e.endMonth) : void 0, {
      ISOWeek: e.ISOWeek,
      fixedWeeks: e.fixedWeeks,
      broadcastCalendar: e.broadcastCalendar
    }, t), S = m$(w, E, {
      broadcastCalendar: e.broadcastCalendar,
      fixedWeeks: e.fixedWeeks,
      ISOWeek: e.ISOWeek,
      reverseMonths: e.reverseMonths
    }, t), O = x$(S), M = p$(S), T = y$(a, n, e, t), P = v$(a, r, e, t);
    return {
      months: S,
      weeks: O,
      days: M,
      previousMonth: T,
      nextMonth: P
    };
  }, [
    t,
    a.getTime(),
    r == null ? void 0 : r.getTime(),
    n == null ? void 0 : n.getTime(),
    e.disableNavigation,
    e.broadcastCalendar,
    (C = e.endMonth) == null ? void 0 : C.getTime(),
    e.fixedWeeks,
    e.ISOWeek,
    e.numberOfMonths,
    e.pagedNavigation,
    e.reverseMonths
  ]), { disableNavigation: p, onMonthChange: g } = e, m = (w) => u.some((E) => E.days.some((S) => S.isEqualTo(w))), v = (w) => {
    if (p)
      return;
    let E = o(w);
    n && E < o(n) && (E = o(n)), r && E > o(r) && (E = o(r)), l(E), g == null || g(E);
  };
  return {
    months: c,
    weeks: u,
    days: d,
    navStart: n,
    navEnd: r,
    previousMonth: f,
    nextMonth: h,
    goToMonth: v,
    goToDay: (w) => {
      m(w) || v(w.date);
    }
  };
}
var Mr;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(Mr || (Mr = {}));
function I0(e) {
  return !e[Kt.disabled] && !e[Kt.hidden] && !e[Kt.outside];
}
function C$(e, t, n, r) {
  let o, s = -1;
  for (const i of e) {
    const a = t(i);
    I0(a) && (a[Kt.focused] && s < Mr.FocusedModifier ? (o = i, s = Mr.FocusedModifier) : r != null && r.isEqualTo(i) && s < Mr.LastFocused ? (o = i, s = Mr.LastFocused) : n(i.date) && s < Mr.Selected ? (o = i, s = Mr.Selected) : a[Kt.today] && s < Mr.Today && (o = i, s = Mr.Today));
  }
  return o || (o = e.find((i) => I0(t(i)))), o;
}
function E$(e, t, n, r, o, s, i) {
  const { ISOWeek: a, broadcastCalendar: l } = s, { addDays: c, addMonths: u, addWeeks: d, addYears: f, endOfBroadcastWeek: h, endOfISOWeek: p, endOfWeek: g, max: m, min: v, startOfBroadcastWeek: y, startOfISOWeek: x, startOfWeek: C } = i;
  let E = {
    day: c,
    week: d,
    month: u,
    year: f,
    startOfWeek: (S) => l ? y(S, i) : a ? x(S) : C(S),
    endOfWeek: (S) => l ? h(S) : a ? p(S) : g(S)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? E = m([r, E]) : t === "after" && o && (E = v([o, E])), E;
}
function s_(e, t, n, r, o, s, i, a = 0) {
  if (a > 365)
    return;
  const l = E$(e, t, n.date, r, o, s, i), c = !!(s.disabled && Qr(l, s.disabled, i)), u = !!(s.hidden && Qr(l, s.hidden, i)), d = l, f = new YE(l, d, i);
  return !c && !u ? f : s_(e, t, f, r, o, s, i, a + 1);
}
function _$(e, t, n, r, o) {
  const { autoFocus: s } = e, [i, a] = Vt(), l = C$(t.days, n, r || (() => !1), i), [c, u] = Vt(s ? l : void 0);
  return {
    isFocusTarget: (g) => !!(l != null && l.isEqualTo(g)),
    setFocused: u,
    focused: c,
    blur: () => {
      a(c), u(void 0);
    },
    moveFocus: (g, m) => {
      if (!c)
        return;
      const v = s_(g, m, c, t.navStart, t.navEnd, e, o);
      v && (e.disableNavigation && !t.days.some((x) => x.isEqualTo(v)) || (t.goToDay(v), u(v)));
    }
  };
}
function S$(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [s, i] = td(n, o ? n : void 0), a = o ? n : s, { isSameDay: l } = t, c = (h) => (a == null ? void 0 : a.some((p) => l(p, h))) ?? !1, { min: u, max: d } = e;
  return {
    selected: a,
    select: (h, p, g) => {
      let m = [...a ?? []];
      if (c(h)) {
        if ((a == null ? void 0 : a.length) === u || r && (a == null ? void 0 : a.length) === 1)
          return;
        m = a == null ? void 0 : a.filter((v) => !l(v, h));
      } else
        (a == null ? void 0 : a.length) === d ? m = [h] : m = [...m, h];
      return o || i(m), o == null || o(m, h, p, g), m;
    },
    isSelected: c
  };
}
function O$(e, t, n = 0, r = 0, o = !1, s = Hr) {
  const { from: i, to: a } = t || {}, { isSameDay: l, isAfter: c, isBefore: u } = s;
  let d;
  if (!i && !a)
    d = { from: e, to: n > 0 ? void 0 : e };
  else if (i && !a)
    l(i, e) ? n === 0 ? d = { from: i, to: e } : o ? d = { from: i, to: void 0 } : d = void 0 : u(e, i) ? d = { from: e, to: i } : d = { from: i, to: e };
  else if (i && a)
    if (l(i, e) && l(a, e))
      o ? d = { from: i, to: a } : d = void 0;
    else if (l(i, e))
      d = { from: i, to: n > 0 ? void 0 : e };
    else if (l(a, e))
      d = { from: e, to: n > 0 ? void 0 : e };
    else if (u(e, i))
      d = { from: e, to: a };
    else if (c(e, i))
      d = { from: i, to: e };
    else if (c(e, a))
      d = { from: i, to: e };
    else
      throw new Error("Invalid range");
  if (d != null && d.from && (d != null && d.to)) {
    const f = s.differenceInCalendarDays(d.to, d.from);
    r > 0 && f > r ? d = { from: e, to: void 0 } : n > 1 && f < n && (d = { from: e, to: void 0 });
  }
  return d;
}
function M$(e, t, n = Hr) {
  const r = Array.isArray(t) ? t : [t];
  let o = e.from;
  const s = n.differenceInCalendarDays(e.to, e.from), i = Math.min(s, 6);
  for (let a = 0; a <= i; a++) {
    if (r.includes(o.getDay()))
      return !0;
    o = n.addDays(o, 1);
  }
  return !1;
}
function k0(e, t, n = Hr) {
  return Zr(e, t.from, !1, n) || Zr(e, t.to, !1, n) || Zr(t, e.from, !1, n) || Zr(t, e.to, !1, n);
}
function T$(e, t, n = Hr) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((a) => typeof a != "function").some((a) => typeof a == "boolean" ? a : n.isDate(a) ? Zr(e, a, !1, n) : GE(a, n) ? a.some((l) => Zr(e, l, !1, n)) : ed(a) ? a.from && a.to ? k0(e, { from: a.from, to: a.to }, n) : !1 : UE(a) ? M$(e, a.dayOfWeek, n) : Vg(a) ? n.isAfter(a.before, a.after) ? k0(e, {
    from: n.addDays(a.after, 1),
    to: n.addDays(a.before, -1)
  }, n) : Qr(e.from, a, n) || Qr(e.to, a, n) : Wg(a) || Hg(a) ? Qr(e.from, a, n) || Qr(e.to, a, n) : !1))
    return !0;
  const i = r.filter((a) => typeof a == "function");
  if (i.length) {
    let a = e.from;
    const l = n.differenceInCalendarDays(e.to, e.from);
    for (let c = 0; c <= l; c++) {
      if (i.some((u) => u(a)))
        return !0;
      a = n.addDays(a, 1);
    }
  }
  return !1;
}
function R$(e, t) {
  const { disabled: n, excludeDisabled: r, resetOnSelect: o, selected: s, required: i, onSelect: a } = e, [l, c] = td(s, a ? s : void 0), u = a ? s : l;
  return {
    selected: u,
    select: (h, p, g) => {
      const { min: m, max: v } = e;
      let y;
      if (h) {
        const x = u == null ? void 0 : u.from, C = u == null ? void 0 : u.to, w = !!x && !!C, E = !!x && !!C && t.isSameDay(x, C) && t.isSameDay(h, x);
        o && (w || !(u != null && u.from)) ? !i && E ? y = void 0 : y = { from: h, to: void 0 } : y = O$(h, u, m, v, i, t);
      }
      return r && n && (y != null && y.from) && y.to && T$({ from: y.from, to: y.to }, n, t) && (y.from = h, y.to = void 0), a || c(y), a == null || a(y, h, p, g), y;
    },
    isSelected: (h) => u && Zr(u, h, !1, t)
  };
}
function P$(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [s, i] = td(n, o ? n : void 0), a = o ? n : s, { isSameDay: l } = t;
  return {
    selected: a,
    select: (d, f, h) => {
      let p = d;
      return !r && a && a && l(d, a) && (p = void 0), o || i(p), o == null || o(p, d, f, h), p;
    },
    isSelected: (d) => a ? l(a, d) : !1
  };
}
function I$(e, t) {
  const n = P$(e, t), r = S$(e, t), o = R$(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return o;
    default:
      return;
  }
}
function zn(e, t) {
  return e instanceof Tn && e.timeZone === t ? e : new Tn(e, t);
}
function ks(e, t, n) {
  if (!n)
    return zn(e, t);
  const r = zn(e, t), o = new Tn(r.getFullYear(), r.getMonth(), r.getDate(), 12, 0, 0, t);
  return new Date(o.getTime());
}
function D0(e, t, n) {
  return typeof e == "boolean" || typeof e == "function" ? e : e instanceof Date ? ks(e, t, n) : Array.isArray(e) ? e.map((r) => r instanceof Date ? ks(r, t, n) : r) : ed(e) ? {
    ...e,
    from: e.from ? zn(e.from, t) : e.from,
    to: e.to ? zn(e.to, t) : e.to
  } : Vg(e) ? {
    before: ks(e.before, t, n),
    after: ks(e.after, t, n)
  } : Wg(e) ? {
    after: ks(e.after, t, n)
  } : Hg(e) ? {
    before: ks(e.before, t, n)
  } : e;
}
function of(e, t, n) {
  return e && (Array.isArray(e) ? e.map((r) => D0(r, t, n)) : D0(e, t, n));
}
function k$(e) {
  var Qt;
  let t = e;
  const n = t.timeZone;
  if (n && (t = {
    ...e,
    timeZone: n
  }, t.today && (t.today = zn(t.today, n)), t.month && (t.month = zn(t.month, n)), t.defaultMonth && (t.defaultMonth = zn(t.defaultMonth, n)), t.startMonth && (t.startMonth = zn(t.startMonth, n)), t.endMonth && (t.endMonth = zn(t.endMonth, n)), t.mode === "single" && t.selected ? t.selected = zn(t.selected, n) : t.mode === "multiple" && t.selected ? t.selected = (Qt = t.selected) == null ? void 0 : Qt.map((Pe) => zn(Pe, n)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? zn(t.selected.from, n) : t.selected.from,
    to: t.selected.to ? zn(t.selected.to, n) : t.selected.to
  }), t.disabled !== void 0 && (t.disabled = of(t.disabled, n)), t.hidden !== void 0 && (t.hidden = of(t.hidden, n)), t.modifiers)) {
    const Pe = {};
    Object.keys(t.modifiers).forEach((Ge) => {
      var Le;
      Pe[Ge] = of((Le = t.modifiers) == null ? void 0 : Le[Ge], n);
    }), t.modifiers = Pe;
  }
  const { components: r, formatters: o, labels: s, dateLib: i, locale: a, classNames: l } = Ar(() => {
    const Pe = { ...zE, ...t.locale }, Ge = t.broadcastCalendar ? 1 : t.weekStartsOn, Le = t.noonSafe && t.timeZone ? l$(t.timeZone, {
      weekStartsOn: Ge,
      locale: Pe
    }) : void 0, be = t.dateLib && Le ? { ...Le, ...t.dateLib } : t.dateLib ?? Le, Ye = new Zn({
      locale: Pe,
      weekStartsOn: Ge,
      firstWeekContainsDate: t.firstWeekContainsDate,
      useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
      timeZone: t.timeZone,
      numerals: t.numerals
    }, be);
    return {
      dateLib: Ye,
      components: z8(t.components),
      formatters: e$(t.formatters),
      labels: r$(t.labels, Ye.options),
      locale: Pe,
      classNames: { ...j8(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.noonSafe,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]);
  t.today || (t = { ...t, today: i.today() });
  const { captionLayout: c, mode: u, navLayout: d, numberOfMonths: f = 1, onDayBlur: h, onDayClick: p, onDayFocus: g, onDayKeyDown: m, onDayMouseEnter: v, onDayMouseLeave: y, onNextClick: x, onPrevClick: C, showWeekNumber: w, styles: E } = t, { formatCaption: S, formatDay: O, formatMonthDropdown: M, formatWeekNumber: T, formatWeekNumberHeader: P, formatWeekdayName: I, formatYearDropdown: R } = o, D = w$(t, i), { days: k, months: $, navStart: L, navEnd: A, previousMonth: F, nextMonth: N, goToMonth: V } = D, K = H8(k, t, L, A, i), { isSelected: Y, select: U, selected: j } = I$(t, i) ?? {}, { blur: H, focused: q, isFocusTarget: B, moveFocus: X, setFocused: te } = _$(t, D, K, Y ?? (() => !1), i), { labelDayButton: J, labelGridcell: G, labelGrid: ne, labelMonthDropdown: Q, labelNav: re, labelPrevious: fe, labelNext: le, labelWeekday: Ee, labelWeekNumber: se, labelWeekNumberHeader: _e, labelYearDropdown: xe } = s, ge = Ar(() => i$(i, t.ISOWeek, t.broadcastCalendar, t.today), [i, t.ISOWeek, t.broadcastCalendar, t.today]), ae = u !== void 0 || p !== void 0, W = ot(() => {
    F && (V(F), C == null || C(F));
  }, [F, V, C]), Z = ot(() => {
    N && (V(N), x == null || x(N));
  }, [V, N, x]), me = ot((Pe, Ge) => (Le) => {
    Le.preventDefault(), Le.stopPropagation(), te(Pe), !Ge.disabled && (U == null || U(Pe.date, Ge, Le), p == null || p(Pe.date, Ge, Le));
  }, [U, p, te]), ie = ot((Pe, Ge) => (Le) => {
    te(Pe), g == null || g(Pe.date, Ge, Le);
  }, [g, te]), oe = ot((Pe, Ge) => (Le) => {
    H(), h == null || h(Pe.date, Ge, Le);
  }, [H, h]), he = ot((Pe, Ge) => (Le) => {
    const be = {
      ArrowLeft: [
        Le.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        Le.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [Le.shiftKey ? "year" : "week", "after"],
      ArrowUp: [Le.shiftKey ? "year" : "week", "before"],
      PageUp: [Le.shiftKey ? "year" : "month", "before"],
      PageDown: [Le.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (be[Le.key]) {
      Le.preventDefault(), Le.stopPropagation();
      const [Ye, Tt] = be[Le.key];
      X(Ye, Tt);
    }
    m == null || m(Pe.date, Ge, Le);
  }, [X, m, t.dir]), Re = ot((Pe, Ge) => (Le) => {
    v == null || v(Pe.date, Ge, Le);
  }, [v]), Ae = ot((Pe, Ge) => (Le) => {
    y == null || y(Pe.date, Ge, Le);
  }, [y]), Ue = ot((Pe, Ge) => (Le) => {
    const be = Number(Le.target.value), Ye = i.setMonth(i.startOfMonth(Pe), be);
    V(i.addMonths(Ye, -Ge));
  }, [i, V]), Ke = ot((Pe, Ge) => (Le) => {
    const be = Number(Le.target.value), Ye = i.setYear(i.startOfMonth(Pe), be);
    V(i.addMonths(Ye, -Ge));
  }, [i, V]), { className: Be, style: nt } = Ar(() => ({
    className: [l[$e.Root], t.className].filter(Boolean).join(" "),
    style: { ...E == null ? void 0 : E[$e.Root], ...t.style }
  }), [l, t.className, t.style, E]), at = Y8(t), Wt = (Pe) => {
    const Ge = E == null ? void 0 : E[$e.Dropdown], Le = E == null ? void 0 : E[Pe];
    if (!(!Ge && !Le))
      return {
        ...Ge,
        ...Le
      };
  }, Mt = et(null);
  f$(Mt, !!t.animate, {
    classNames: l,
    months: $,
    focused: q,
    dateLib: i
  });
  const Bt = {
    dayPickerProps: t,
    selected: j,
    select: U,
    isSelected: Y,
    months: $,
    nextMonth: N,
    previousMonth: F,
    goToMonth: V,
    getModifiers: K,
    components: r,
    classNames: l,
    styles: E,
    labels: s,
    formatters: o
  };
  return Oe.createElement(
    jE.Provider,
    { value: Bt },
    Oe.createElement(
      r.Root,
      { rootRef: t.animate ? Mt : void 0, className: Be, style: nt, dir: t.dir, id: t.id, lang: t.lang ?? a.code, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], "aria-labelledby": t["aria-labelledby"], ...at },
      Oe.createElement(
        r.Months,
        { className: l[$e.Months], style: E == null ? void 0 : E[$e.Months] },
        !t.hideNavigation && !d && Oe.createElement(r.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: l[$e.Nav], style: E == null ? void 0 : E[$e.Nav], "aria-label": re(), onPreviousClick: W, onNextClick: Z, previousMonth: F, nextMonth: N }),
        $.map((Pe, Ge) => {
          const Le = t.reverseMonths ? $.length - 1 - Ge : Ge;
          return Oe.createElement(
            r.Month,
            {
              "data-animated-month": t.animate ? "true" : void 0,
              className: l[$e.Month],
              style: E == null ? void 0 : E[$e.Month],
              // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
              key: Ge,
              displayIndex: Ge,
              calendarMonth: Pe
            },
            d === "around" && !t.hideNavigation && Ge === 0 && Oe.createElement(
              r.PreviousMonthButton,
              { type: "button", className: l[$e.PreviousMonthButton], style: E == null ? void 0 : E[$e.PreviousMonthButton], tabIndex: F ? void 0 : -1, "aria-disabled": F ? void 0 : !0, "aria-label": fe(F), onClick: W, "data-animated-button": t.animate ? "true" : void 0 },
              Oe.createElement(r.Chevron, { disabled: F ? void 0 : !0, className: l[$e.Chevron], style: E == null ? void 0 : E[$e.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
            ),
            Oe.createElement(r.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: l[$e.MonthCaption], style: E == null ? void 0 : E[$e.MonthCaption], calendarMonth: Pe, displayIndex: Ge }, c != null && c.startsWith("dropdown") ? Oe.createElement(
              r.DropdownNav,
              { className: l[$e.Dropdowns], style: E == null ? void 0 : E[$e.Dropdowns] },
              (() => {
                const be = c === "dropdown" || c === "dropdown-months" ? Oe.createElement(r.MonthsDropdown, { key: "month", className: l[$e.MonthsDropdown], "aria-label": Q(), disabled: !!t.disableNavigation, onChange: Ue(Pe.date, Le), options: o$(Pe.date, L, A, o, i), style: Wt($e.MonthsDropdown), value: i.getMonth(Pe.date) }) : Oe.createElement("span", { key: "month" }, M(Pe.date, i)), Ye = c === "dropdown" || c === "dropdown-years" ? Oe.createElement(r.YearsDropdown, { key: "year", className: l[$e.YearsDropdown], "aria-label": xe(i.options), disabled: !!t.disableNavigation, onChange: Ke(Pe.date, Le), options: a$(L, A, o, i, !!t.reverseYears), style: Wt($e.YearsDropdown), value: i.getYear(Pe.date) }) : Oe.createElement("span", { key: "year" }, R(Pe.date, i));
                return i.getMonthYearOrder() === "year-first" ? [Ye, be] : [be, Ye];
              })(),
              Oe.createElement("span", { role: "status", "aria-live": "polite", style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: "1px",
                margin: "-1px",
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: "1px",
                whiteSpace: "nowrap",
                wordWrap: "normal"
              } }, S(Pe.date, i.options, i))
            ) : Oe.createElement(r.CaptionLabel, { className: l[$e.CaptionLabel], style: E == null ? void 0 : E[$e.CaptionLabel], role: "status", "aria-live": "polite" }, S(Pe.date, i.options, i))),
            d === "around" && !t.hideNavigation && Ge === f - 1 && Oe.createElement(
              r.NextMonthButton,
              { type: "button", className: l[$e.NextMonthButton], style: E == null ? void 0 : E[$e.NextMonthButton], tabIndex: N ? void 0 : -1, "aria-disabled": N ? void 0 : !0, "aria-label": le(N), onClick: Z, "data-animated-button": t.animate ? "true" : void 0 },
              Oe.createElement(r.Chevron, { disabled: N ? void 0 : !0, className: l[$e.Chevron], style: E == null ? void 0 : E[$e.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
            ),
            Ge === f - 1 && d === "after" && !t.hideNavigation && Oe.createElement(r.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: l[$e.Nav], style: E == null ? void 0 : E[$e.Nav], "aria-label": re(), onPreviousClick: W, onNextClick: Z, previousMonth: F, nextMonth: N }),
            Oe.createElement(
              r.MonthGrid,
              { role: "grid", "aria-multiselectable": u === "multiple" || u === "range", "aria-label": ne(Pe.date, i.options, i) || void 0, className: l[$e.MonthGrid], style: E == null ? void 0 : E[$e.MonthGrid] },
              !t.hideWeekdays && Oe.createElement(
                r.Weekdays,
                { "data-animated-weekdays": t.animate ? "true" : void 0, className: l[$e.Weekdays], style: E == null ? void 0 : E[$e.Weekdays] },
                w && Oe.createElement(r.WeekNumberHeader, { "aria-label": _e(i.options), className: l[$e.WeekNumberHeader], style: E == null ? void 0 : E[$e.WeekNumberHeader], scope: "col" }, P()),
                ge.map((be) => Oe.createElement(r.Weekday, { "aria-label": Ee(be, i.options, i), className: l[$e.Weekday], key: String(be), style: E == null ? void 0 : E[$e.Weekday], scope: "col" }, I(be, i.options, i)))
              ),
              Oe.createElement(r.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: l[$e.Weeks], style: E == null ? void 0 : E[$e.Weeks] }, Pe.weeks.map((be) => Oe.createElement(
                r.Week,
                { className: l[$e.Week], key: be.weekNumber, style: E == null ? void 0 : E[$e.Week], week: be },
                w && Oe.createElement(r.WeekNumber, { week: be, style: E == null ? void 0 : E[$e.WeekNumber], "aria-label": se(be.weekNumber, {
                  locale: a
                }), className: l[$e.WeekNumber], scope: "row", role: "rowheader" }, T(be.weekNumber, i)),
                be.days.map((Ye) => {
                  const { date: Tt } = Ye, je = K(Ye);
                  if (je[Kt.focused] = !je.hidden && !!(q != null && q.isEqualTo(Ye)), je[gr.selected] = (Y == null ? void 0 : Y(Tt)) || je.selected, ed(j)) {
                    const { from: er, to: Jt } = j;
                    je[gr.range_start] = !!(er && Jt && i.isSameDay(Tt, er)), je[gr.range_end] = !!(er && Jt && i.isSameDay(Tt, Jt)), je[gr.range_middle] = Zr(j, Tt, !0, i);
                  }
                  const Rt = s$(je, E, t.modifiersStyles), On = B8(je, l, t.modifiersClassNames), vt = !ae && !je.hidden ? G(Tt, je, i.options, i) : void 0;
                  return Oe.createElement(r.Day, { key: `${Ye.isoDate}_${Ye.displayMonthId}`, day: Ye, modifiers: je, className: On.join(" "), style: Rt, role: "gridcell", "aria-selected": je.selected || void 0, "aria-label": vt, "data-day": Ye.isoDate, "data-month": Ye.outside ? Ye.dateMonthId : void 0, "data-selected": je.selected || void 0, "data-disabled": je.disabled || void 0, "data-hidden": je.hidden || void 0, "data-outside": Ye.outside || void 0, "data-focused": je.focused || void 0, "data-today": je.today || void 0 }, !je.hidden && ae ? Oe.createElement(r.DayButton, { className: l[$e.DayButton], style: E == null ? void 0 : E[$e.DayButton], type: "button", day: Ye, modifiers: je, disabled: !je.focused && je.disabled || void 0, "aria-disabled": je.focused && je.disabled || void 0, tabIndex: B(Ye) ? 0 : -1, "aria-label": J(Tt, je, i.options, i), onClick: me(Ye, je), onBlur: oe(Ye, je), onFocus: ie(Ye, je), onKeyDown: he(Ye, je), onMouseEnter: Re(Ye, je), onMouseLeave: Ae(Ye, je) }, O(Tt, i.options, i)) : !je.hidden && O(Ye.date, i.options, i));
                })
              )))
            )
          );
        })
      ),
      t.footer && Oe.createElement(r.Footer, { className: l[$e.Footer], style: E == null ? void 0 : E[$e.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
const i_ = b.createContext({}), a_ = ({
  className: e,
  fromDate: t,
  toDate: n,
  initialFocus: r,
  CustomFooter: o,
  ...s
}) => {
  const i = [
    ...t ? [{ before: t }] : [],
    ...n ? [{ after: n }] : []
  ];
  return /* @__PURE__ */ _(i_.Provider, { value: { fromDate: t, toDate: n }, children: /* @__PURE__ */ _(
    k$,
    {
      showOutsideDays: !0,
      fixedWeeks: !0,
      weekStartsOn: 1,
      autoFocus: r,
      hideNavigation: !0,
      ...s.mode === "range" ? { resetOnSelect: !0 } : {},
      disabled: i,
      footer: o,
      className: de(
        "flex rounded-lg bg-foundations-default px-6 py-3",
        e
      ),
      formatters: {
        formatWeekdayName: (a) => no(a, "E")
      },
      classNames: {
        month_grid: "w-full border-collapse space-y-4",
        weekdays: "flex",
        weekday: "w-9 text-xs text-foundations-subtle font-normal uppercase",
        week: "flex w-full mt-2",
        day: "p-0 flex justify-center",
        day_button: "h-9 w-9 p-0 font-normal text-foundations-boldest text-sm rounded-full hover:bg-neutral-100 focus:outline-none focus:ring-2 focus:ring-info-bold focus:z-10",
        selected: "[&>button]:!bg-info-bold [&>button]:!text-neutral-white [&>button]:hover:!bg-info-bolder [&>button]:focus:!bg-info-bolder",
        today: "[&>button]:bg-neutral-100 [&>button]:rounded-full",
        range_start: "start [&>button]:!bg-info-bold [&>button]:!text-neutral-white [&>button]:!rounded-l-full [&:not(:last-child)>button]:!rounded-r-none [&:last-child>button]:!rounded-r-full",
        range_middle: "[&>button]:!bg-info-bold [&>button]:!text-neutral-white [&>button]:!rounded-none [&:first-child>button]:!rounded-l-full [&:last-child>button]:!rounded-r-full",
        range_end: "end [&>button]:!bg-info-bold [&>button]:!text-neutral-white [&>button]:!rounded-r-full [&:not(:first-child)>button]:!rounded-l-none [&:first-child>button]:!rounded-l-full [&.start.end>button]:!rounded-full",
        outside: "[&>button:not(:disabled)]:text-foundations-subtle",
        disabled: "[&>button]:!text-neutral-300 [&>button]:cursor-not-allowed",
        hidden: "invisible"
      },
      components: {
        MonthCaption: D$
      },
      ...s
    }
  ) });
};
a_.displayName = "Calendar";
const D$ = (e) => {
  const { goToMonth: t, nextMonth: n, previousMonth: r } = Xa(), { fromDate: o, toDate: s } = b.useContext(i_), i = ec(e.calendarMonth.date), a = !r || !!o && !w6(i, ec(o)), l = !n || !!s && !C6(i, ec(s));
  return /* @__PURE__ */ ee("div", { className: "mb-4 flex items-center justify-between", children: [
    /* @__PURE__ */ _(
      ia,
      {
        variant: "tertiary",
        size: "xs",
        disabled: a,
        onClick: () => r && t(r),
        "aria-label": "Go to previous month",
        children: /* @__PURE__ */ _(rI, {})
      }
    ),
    /* @__PURE__ */ _(
      "div",
      {
        id: e.id,
        "aria-live": "polite",
        role: "presentation",
        className: "text-sm font-medium text-foundations-boldest",
        children: no(e.calendarMonth.date, "MMMM yyyy")
      }
    ),
    /* @__PURE__ */ _(
      ia,
      {
        variant: "tertiary",
        size: "xs",
        disabled: l,
        onClick: () => n && t(n),
        "aria-label": "Go to next month",
        children: /* @__PURE__ */ _(Op, {})
      }
    )
  ] });
}, N$ = (e) => e.querySelector("input,textarea") || e, nd = {
  mask: /^.*$/,
  preprocessors: [],
  postprocessors: [],
  plugins: [],
  overwriteMode: "shift"
};
class A$ {
  constructor() {
    this.now = null, this.past = [], this.future = [];
  }
  undo() {
    const t = this.past.pop();
    t && this.now && (this.future.push(this.now), this.updateElement(t, "historyUndo"));
  }
  redo() {
    const t = this.future.pop();
    t && this.now && (this.past.push(this.now), this.updateElement(t, "historyRedo"));
  }
  updateHistory(t) {
    if (!this.now) {
      this.now = t;
      return;
    }
    const n = this.now.value !== t.value, r = this.now.selection.some((o, s) => o !== t.selection[s]);
    !n && !r || (n && (this.past.push(this.now), this.future = []), this.now = t);
  }
  updateElement(t, n) {
    this.now = t, this.updateElementState(t, {
      inputType: n,
      data: null
    });
  }
}
function $$(e, ...t) {
  return t.every(({
    value: n
  }) => n === e.value);
}
function F$(e, ...t) {
  return t.every(({
    value: n,
    selection: r
  }) => n === e.value && r[0] === e.selection[0] && r[1] === e.selection[1]);
}
function L$({
  value: e,
  selection: t
}, n, r) {
  const [o, s] = t, i = typeof r == "function" ? r({
    value: e,
    selection: t
  }) : r;
  return {
    value: e,
    selection: i === "replace" ? [o, o + n.length] : [o, s]
  };
}
function rd(e) {
  return typeof e == "string";
}
function N0(e, t, n, r) {
  let o = "";
  for (let s = t.length; s < e.length; s++) {
    const i = e[s], a = (r == null ? void 0 : r.value[s]) === i;
    if (!rd(i) || i === n && !a)
      return o;
    o += i;
  }
  return o;
}
function l_(e, t) {
  return Array.isArray(t) ? e.length === t.length && Array.from(e).every((n, r) => {
    const o = t[r];
    return rd(o) ? n === o : n.match(o);
  }) : t.test(e);
}
function V$(e, t, n) {
  let r = null, o = null;
  const s = Array.from(e.value).reduce((a, l, c) => {
    const u = N0(t, a, l, n), d = a + u, f = t[d.length];
    return rd(f) ? d + f : l.match(f) ? (r === null && c >= e.selection[0] && (r = d.length), o === null && c >= e.selection[1] && (o = d.length), d + l) : d;
  }, ""), i = N0(t, s, "", n);
  return {
    value: l_(s + i, t) ? s + i : s,
    selection: [r ?? s.length, o ?? s.length]
  };
}
function W$({
  value: e,
  selection: t
}, n) {
  const [r, o] = t;
  let s = r, i = o;
  return {
    value: Array.from(e).reduce((l, c, u) => {
      const d = l + c;
      return r === u && (s = l.length), o === u && (i = l.length), d.match(n) ? d : l;
    }, ""),
    selection: [s, i]
  };
}
function Dl(e, t, n = null) {
  if (l_(e.value, t))
    return e;
  const {
    value: r,
    selection: o
  } = Array.isArray(t) ? V$(e, t, n) : W$(e, t);
  return {
    selection: o,
    value: Array.isArray(t) ? r.slice(0, t.length) : r
  };
}
function A0(e, t) {
  if (!Array.isArray(t))
    return e;
  const [n, r] = e.selection, o = [], s = Array.from(e.value).reduce((i, a, l) => {
    const c = t[l];
    return l === n && o.push(i.length), l === r && o.push(i.length), rd(c) && c === a ? i : i + a;
  }, "");
  return o.length < 2 && o.push(...Array(2 - o.length).fill(s.length)), {
    value: s,
    selection: [o[0], o[1]]
  };
}
class dh {
  constructor(t, n) {
    this.initialElementState = t, this.maskOptions = n, this.value = "", this.selection = [0, 0];
    const {
      value: r,
      selection: o
    } = Dl(t, this.getMaskExpression(t));
    this.value = r, this.selection = o;
  }
  addCharacters([t, n], r) {
    const {
      value: o
    } = this, s = this.getMaskExpression({
      value: o.slice(0, t) + r + o.slice(n),
      selection: [t + r.length, t + r.length]
    }), i = {
      value: o,
      selection: [t, n]
    }, a = A0(i, s), [l, c] = L$(a, r, this.maskOptions.overwriteMode).selection, u = a.value.slice(0, l) + r, d = u.length, f = Dl({
      value: u + a.value.slice(c),
      selection: [d, d]
    }, s, i);
    if (o.slice(0, l) === Dl({
      value: u,
      selection: [d, d]
    }, s, i).value || F$(this, f))
      throw new Error("Invalid mask value");
    this.value = f.value, this.selection = f.selection;
  }
  deleteCharacters([t, n]) {
    if (t === n || !n)
      return;
    const {
      value: r
    } = this, o = this.getMaskExpression({
      value: r.slice(0, t) + r.slice(n),
      selection: [t, t]
    }), s = {
      value: r,
      selection: [t, n]
    }, i = A0(s, o), [a, l] = i.selection, c = i.value.slice(0, a) + i.value.slice(l), u = Dl({
      value: c,
      selection: [a, a]
    }, o, s);
    this.value = u.value, this.selection = u.selection;
  }
  getMaskExpression(t) {
    const {
      mask: n
    } = this.maskOptions;
    return typeof n == "function" ? n(t) : n;
  }
}
class H$ {
  constructor(t) {
    this.element = t, this.listeners = [];
  }
  listen(t, n, r) {
    const o = n;
    this.element.addEventListener(t, o, r), this.listeners.push(() => this.element.removeEventListener(t, o));
  }
  destroy() {
    this.listeners.forEach((t) => t());
  }
}
function ra(e, t, n) {
  return e.ctrlKey === !!(t & 1) && e.altKey === !!(t & 2) && e.shiftKey === !!(t & 4) && e.metaKey === !!(t & 8) && e.keyCode === n;
}
function B$(e) {
  return ra(
    e,
    1,
    89
    /* Y */
  ) || // Windows
  ra(
    e,
    5,
    90
    /* Z */
  ) || // Windows & Android
  ra(
    e,
    12,
    90
    /* Z */
  );
}
function z$(e) {
  return ra(
    e,
    1,
    90
    /* Z */
  ) || // Windows & Android
  ra(
    e,
    8,
    90
    /* Z */
  );
}
function Y$(e) {
  return "onbeforeinput" in e;
}
function j$({
  key: e,
  ctrlKey: t,
  metaKey: n,
  altKey: r
}) {
  const o = t || n || r, s = /^.$/u.test(e);
  return !o && e !== "Backspace" && s;
}
function U$({
  value: e,
  selection: t
}, n) {
  const [r, o] = t;
  if (r !== o)
    return [r, o];
  const s = n ? e.slice(r).indexOf(`
`) + 1 || e.length : e.slice(0, o).lastIndexOf(`
`) + 1;
  return [n ? r : s, n ? s : o];
}
function $0({
  value: e,
  selection: t
}, n) {
  const [r, o] = t;
  return r !== o ? [r, o] : (n ? [r, o + 1] : [r - 1, o]).map((i) => Math.min(Math.max(i, 0), e.length));
}
const F0 = /\s+$/g, L0 = /^\s+/g, V0 = /\s/;
function G$({
  value: e,
  selection: t
}, n) {
  const [r, o] = t;
  if (r !== o)
    return [r, o];
  if (n) {
    const l = e.slice(r), [c] = l.match(L0) || [""], u = l.replace(L0, "").search(V0);
    return [r, u !== -1 ? r + c.length + u : e.length];
  }
  const s = e.slice(0, o), [i] = s.match(F0) || [""], a = s.replace(F0, "").split("").reverse().findIndex((l) => l.match(V0));
  return [a !== -1 ? o - i.length - a : 0, o];
}
function Vc(e = []) {
  return (t, ...n) => e.reduce((r, o) => Object.assign(Object.assign({}, r), o(r, ...n)), t);
}
function K$(e, t) {
  const n = Object.assign(Object.assign({}, nd), t), r = Vc(n.preprocessors), o = Vc(n.postprocessors), s = typeof e == "string" ? {
    value: e,
    selection: [0, 0]
  } : e, {
    elementState: i
  } = r({
    elementState: s,
    data: ""
  }, "validation"), a = new dh(i, n), {
    value: l,
    selection: c
  } = o(a, s);
  return typeof e == "string" ? l : {
    value: l,
    selection: c
  };
}
class q$ extends A$ {
  constructor(t, n) {
    super(), this.element = t, this.maskitoOptions = n, this.isTextArea = this.element.nodeName === "TEXTAREA", this.eventListener = new H$(this.element), this.options = Object.assign(Object.assign({}, nd), this.maskitoOptions), this.preprocessor = Vc(this.options.preprocessors), this.postprocessor = Vc(this.options.postprocessors), this.teardowns = this.options.plugins.map((r) => r(this.element, this.options)), this.ensureValueFitsMask(), this.updateHistory(this.elementState), this.eventListener.listen("keydown", (r) => {
      if (B$(r))
        return r.preventDefault(), this.redo();
      if (z$(r))
        return r.preventDefault(), this.undo();
    }), Y$(t) ? this.eventListener.listen("beforeinput", (r) => {
      const o = r.inputType.includes("Forward");
      switch (this.updateHistory(this.elementState), r.inputType) {
        case "historyUndo":
          return r.preventDefault(), this.undo();
        case "historyRedo":
          return r.preventDefault(), this.redo();
        case "deleteByCut":
        case "deleteContentBackward":
        case "deleteContentForward":
          return this.handleDelete({
            event: r,
            isForward: o,
            selection: $0(this.elementState, o)
          });
        case "deleteWordForward":
        case "deleteWordBackward":
          return this.handleDelete({
            event: r,
            isForward: o,
            selection: G$(this.elementState, o),
            force: !0
          });
        case "deleteSoftLineBackward":
        case "deleteSoftLineForward":
        case "deleteHardLineBackward":
        case "deleteHardLineForward":
          return this.handleDelete({
            event: r,
            isForward: o,
            selection: U$(this.elementState, o),
            force: !0
          });
        case "insertLineBreak":
          return this.handleEnter(r);
        case "insertFromPaste":
        case "insertText":
        case "insertFromDrop":
        default:
          return this.handleInsert(r, r.data || "");
      }
    }) : (this.eventListener.listen("keydown", (r) => this.handleKeydown(r)), this.eventListener.listen("paste", (r) => {
      var o;
      return this.handleInsert(r, ((o = r.clipboardData) === null || o === void 0 ? void 0 : o.getData("text/plain")) || "");
    })), this.eventListener.listen("input", () => {
      this.ensureValueFitsMask(), this.updateHistory(this.elementState);
    });
  }
  get elementState() {
    const {
      value: t,
      selectionStart: n,
      selectionEnd: r
    } = this.element;
    return {
      value: t,
      selection: [n || 0, r || 0]
    };
  }
  get maxLength() {
    const {
      maxLength: t
    } = this.element;
    return t === -1 ? 1 / 0 : t;
  }
  destroy() {
    this.eventListener.destroy(), this.teardowns.forEach((t) => t == null ? void 0 : t());
  }
  updateElementState({
    value: t,
    selection: n
  }, r = {
    inputType: "insertText",
    data: null
  }) {
    const o = this.elementState.value;
    this.updateValue(t), this.updateSelectionRange(n), o !== t && this.dispatchInputEvent(r);
  }
  updateSelectionRange([t, n]) {
    var r, o;
    (this.element.selectionStart !== t || this.element.selectionEnd !== n) && ((o = (r = this.element).setSelectionRange) === null || o === void 0 || o.call(r, t, n));
  }
  updateValue(t) {
    this.element.value = t;
  }
  ensureValueFitsMask() {
    this.updateElementState(K$(this.elementState, this.options));
  }
  dispatchInputEvent(t = {
    inputType: "insertText",
    data: null
  }) {
    const n = typeof window < "u" ? window : globalThis;
    n != null && n.InputEvent && this.element.dispatchEvent(new InputEvent("input", Object.assign(Object.assign({}, t), {
      bubbles: !0,
      cancelable: !1
    })));
  }
  handleKeydown(t) {
    const n = t.key, r = n === "Delete";
    switch (n) {
      case "Backspace":
      case "Delete":
        return this.handleDelete({
          event: t,
          isForward: r,
          selection: $0(this.elementState, r)
        });
      case "Enter":
        return this.handleEnter(t);
    }
    j$(t) && this.handleInsert(t, n);
  }
  handleDelete({
    event: t,
    selection: n,
    isForward: r,
    force: o = !1
  }) {
    const s = {
      value: this.elementState.value,
      selection: n
    }, [i, a] = s.selection, {
      elementState: l
    } = this.preprocessor({
      elementState: s,
      data: ""
    }, r ? "deleteForward" : "deleteBackward"), c = new dh(l, this.options), [u, d] = l.selection;
    c.deleteCharacters([u, d]);
    const f = this.postprocessor(c, s);
    if (s.value.slice(0, i) + s.value.slice(a) === f.value && !o)
      return;
    if (t.preventDefault(), $$(s, l, c, f))
      return this.updateSelectionRange(r ? [d, d] : [u, u]);
    const p = r ? "deleteContentForward" : "deleteContentBackward";
    this.updateElementState(f, {
      inputType: "inputType" in t ? t.inputType : p,
      data: null
    }), this.updateHistory(f);
  }
  handleInsert(t, n) {
    const r = this.elementState, {
      elementState: o,
      data: s = n
    } = this.preprocessor({
      data: n,
      elementState: r
    }, "insert"), i = new dh(o, this.options);
    try {
      i.addCharacters(o.selection, s);
    } catch {
      return t.preventDefault();
    }
    const [a, l] = o.selection, c = o.value.slice(0, a) + n + o.value.slice(l), u = this.postprocessor(i, r);
    if (u.value.length > this.maxLength)
      return t.preventDefault();
    c !== u.value && (t.preventDefault(), this.updateElementState(u, {
      data: n,
      inputType: "inputType" in t ? t.inputType : "insertText"
    }), this.updateHistory(u));
  }
  handleEnter(t) {
    this.isTextArea && this.handleInsert(t, `
`);
  }
}
const X$ = /* @__PURE__ */ new Date("0001-01-01"), Z$ = /* @__PURE__ */ new Date("9999-12-31"), Q$ = "–", J$ = "—", eF = "-", tF = "−", nF = [eF, Q$, J$, tF], rF = [":", "."];
function fh(e, t, n) {
  const r = Math.min(Number(n), Math.max(Number(t), Number(e)));
  return e instanceof Date ? new Date(r) : r;
}
const c_ = (e) => {
  var t, n, r;
  return {
    day: ((t = e.match(/d/g)) === null || t === void 0 ? void 0 : t.length) || 0,
    month: ((n = e.match(/m/g)) === null || n === void 0 ? void 0 : n.length) || 0,
    year: ((r = e.match(/y/g)) === null || r === void 0 ? void 0 : r.length) || 0
  };
};
function oF(e) {
  return {
    day: String(e.getDate()).padStart(2, "0"),
    month: String(e.getMonth() + 1).padStart(2, "0"),
    year: String(e.getFullYear()).padStart(4, "0"),
    hours: String(e.getHours()).padStart(2, "0"),
    minutes: String(e.getMinutes()).padStart(2, "0"),
    seconds: String(e.getSeconds()).padStart(2, "0"),
    milliseconds: String(e.getMilliseconds()).padStart(3, "0")
  };
}
function sF(e, t) {
  return e.length < t.length ? !1 : e.split(/\D/).every((n) => !n.match(/^0+$/));
}
function u_(e, t, n) {
  const r = t.replace(/\W/g, "").length;
  return e.replace(n, "").match(new RegExp(`(\\D*\\d[^\\d\\s]*){1,${r}}`, "g")) || [];
}
function d_(e) {
  return e.reduce((t, [n, r]) => Object.assign(Object.assign({}, t), {
    [n]: r
  }), {});
}
function f_(e, t) {
  const n = t.replace(/[^dmy]/g, ""), r = e.replace(/\D+/g, ""), o = {
    day: r.slice(n.indexOf("d"), n.lastIndexOf("d") + 1),
    month: r.slice(n.indexOf("m"), n.lastIndexOf("m") + 1),
    year: r.slice(n.indexOf("y"), n.lastIndexOf("y") + 1)
  };
  return d_(Object.entries(o).filter(([s, i]) => !!i).sort(([s], [i]) => t.toLowerCase().indexOf(s[0]) > t.toLowerCase().indexOf(i[0]) ? 1 : -1));
}
function iF(e, t) {
  var n, r, o, s, i, a, l;
  const c = ((n = e.year) === null || n === void 0 ? void 0 : n.length) === 2 ? `20${e.year}` : e.year, u = new Date(Number(c ?? "0"), Number((r = e.month) !== null && r !== void 0 ? r : "1") - 1, Number((o = e.day) !== null && o !== void 0 ? o : "1"), Number((s = t == null ? void 0 : t.hours) !== null && s !== void 0 ? s : "0"), Number((i = t == null ? void 0 : t.minutes) !== null && i !== void 0 ? i : "0"), Number((a = t == null ? void 0 : t.seconds) !== null && a !== void 0 ? a : "0"), Number((l = t == null ? void 0 : t.milliseconds) !== null && l !== void 0 ? l : "0"));
  return u.setFullYear(Number(c ?? "0")), u;
}
const aF = ", ";
function Wc({
  day: e,
  month: t,
  year: n,
  hours: r,
  minutes: o,
  seconds: s,
  milliseconds: i
}, a, l) {
  var c;
  const u = ((c = a.match(/y/g)) === null || c === void 0 ? void 0 : c.length) === 2 ? n == null ? void 0 : n.slice(-2) : n;
  return (a + (l ? aF + l : "")).replace(/d+/g, e ?? "").replace(/m+/g, t ?? "").replace(/y+/g, u ?? "").replace(/H+/g, r ?? "").replace(/MSS/g, i ?? "").replace(/M+/g, o ?? "").replace(/S+/g, s ?? "").replace(/^\D+/g, "").replace(/\D+$/g, "");
}
function hh(e, t, n = 0) {
  return Number(e.padEnd(t.length, "0")) <= Number(t) ? {
    validatedSegmentValue: e,
    prefixedZeroesCount: n
  } : e.endsWith("0") ? hh(`0${e.slice(0, t.length - 1)}`, t, n + 1) : hh(`${e.slice(0, t.length - 1)}0`, t, n);
}
const lF = {
  day: 31,
  month: 12,
  year: 9999
};
function cF({
  dateString: e,
  dateModeTemplate: t,
  offset: n,
  selection: [r, o]
}) {
  const s = f_(e, t), i = Object.entries(s), a = {};
  let l = 0;
  for (const [d, f] of i) {
    const h = Wc(a, t), p = lF[d], g = h.length && 1, m = n + h.length + g + c_(t)[d], v = m >= r && m === o;
    if (v && Number(f) > Number(p))
      return {
        validatedDateString: "",
        updatedSelection: [r, o]
      };
    if (v && Number(f) < 1)
      return {
        validatedDateString: "",
        updatedSelection: [r, o]
      };
    const {
      validatedSegmentValue: y,
      prefixedZeroesCount: x
    } = hh(f, `${p}`);
    l += x, a[d] = y;
  }
  const c = Wc(a, t), u = c.length - e.length;
  return {
    validatedDateString: c,
    updatedSelection: [r + l + u, o + l + u]
  };
}
const h_ = /[\\^$.*+?()[\]{}|]/g, uF = RegExp(h_.source);
function p_(e) {
  return e && uF.test(e) ? e.replace(h_, "\\$&") : e;
}
function dF({
  activeElement: e
}) {
  if (!(e != null && e.shadowRoot))
    return e;
  let t = e.shadowRoot.activeElement;
  for (; t != null && t.shadowRoot; )
    t = t.shadowRoot.activeElement;
  return t;
}
function fF(e, t) {
  const n = c_(t);
  return d_(Object.entries(e).map(([r, o]) => {
    const s = n[r];
    return [r, o.length === s && o.match(/^0+$/) ? "1".padStart(s, "0") : o];
  }));
}
function hF({
  dateModeTemplate: e,
  min: t = X$,
  max: n = Z$,
  rangeSeparator: r = "",
  dateSegmentSeparator: o = "."
}) {
  return ({
    value: s,
    selection: i
  }) => {
    const a = r && s.endsWith(r), l = u_(s, e, r);
    let c = "";
    for (const u of l) {
      c += c ? r : "";
      const d = f_(u, e);
      if (!sF(u, e)) {
        const p = fF(d, e), g = Wc(p, e), m = u.endsWith(o) ? o : "";
        c += g + m;
        continue;
      }
      const f = iF(d), h = fh(f, t, n);
      c += Wc(oF(h), e);
    }
    return {
      selection: i,
      value: c + (a ? r : "")
    };
  };
}
function pF({
  dateModeTemplate: e,
  dateSegmentsSeparator: t,
  rangeSeparator: n = ""
}) {
  return ({
    elementState: r,
    data: o
  }) => {
    const {
      value: s,
      selection: i
    } = r;
    if (o === t)
      return {
        elementState: r,
        data: i[0] === s.length ? o : ""
      };
    if (nF.includes(o))
      return {
        elementState: r,
        data: n
      };
    const a = o.replace(new RegExp(`[^\\d${p_(t)}${n}]`, "g"), "");
    if (!a)
      return {
        elementState: r,
        data: ""
      };
    const [l, c] = i;
    let u = c + o.length;
    const d = s.slice(0, l) + a + s.slice(u), f = u_(d, e, n);
    let h = "";
    const p = !!n && d.includes(n);
    for (const m of f) {
      const {
        validatedDateString: v,
        updatedSelection: y
      } = cF({
        dateString: m,
        dateModeTemplate: e,
        offset: h ? h.length + n.length : 0,
        selection: [l, u]
      });
      if (m && !v)
        return {
          elementState: r,
          data: ""
        };
      u = y[1], h += p && h ? n + v : v;
    }
    const g = h.slice(l, u);
    return {
      elementState: {
        selection: i,
        value: h.slice(0, l) + g.split(t).map((m) => "0".repeat(m.length)).join(t) + h.slice(u)
      },
      data: g
    };
  };
}
function gF(e) {
  return (t) => {
    const n = t.ownerDocument;
    let r = 0;
    const o = () => r++, s = () => r--, i = () => {
      if (dF(n) !== t)
        return;
      if (r)
        return n.addEventListener("mouseup", i, {
          once: !0,
          passive: !0
        });
      const a = t.selectionStart || 0, l = t.selectionEnd || 0, [c, u] = e(t.value, [a, l]);
      (c > a || u < l) && t.setSelectionRange(fh(a, c, u), fh(l, c, u));
    };
    return n.addEventListener("selectionchange", i, {
      passive: !0
    }), n.addEventListener("mousedown", o, {
      passive: !0
    }), n.addEventListener("mouseup", s, {
      passive: !0
    }), () => {
      n.removeEventListener("selectionchange", i), n.removeEventListener("mousedown", o), n.removeEventListener("mouseup", s);
    };
  };
}
function W0(e, t, n) {
  return (r, o) => {
    const s = () => t(r, o);
    return r.addEventListener(e, s, n), () => r.removeEventListener(e, s, n);
  };
}
function mF(e, t = !1) {
  const n = (s) => {
    for (let i = s.length - 1; i >= 0; i--)
      if (s[i] !== e[i])
        return s.slice(0, i + 1);
    return "";
  }, r = [gF((s) => [0, n(s).length])];
  let o = !1;
  if (t) {
    const s = W0("focus", (a) => {
      o = !0, a.value += e.slice(a.value.length), a.dispatchEvent(new Event("input"));
    }, {
      capture: !0
    }), i = W0("blur", (a) => {
      o = !1, a.value = n(a.value), a.dispatchEvent(new Event("input"));
    }, {
      capture: !0
    });
    r.push(s, i);
  }
  return {
    plugins: r,
    removePlaceholder: n,
    preprocessors: [({
      elementState: s,
      data: i
    }) => {
      const {
        value: a,
        selection: l
      } = s;
      return {
        elementState: {
          selection: l,
          value: n(a)
        },
        data: i
      };
    }],
    postprocessors: [({
      value: s,
      selection: i
    }, a) => a.value && (o || !t) ? {
      value: s + e.slice(s.length),
      selection: i
    } : {
      value: s,
      selection: i
    }]
  };
}
function bF() {
  return ({
    elementState: e
  }, t) => {
    const {
      value: n,
      selection: r
    } = e;
    if (!n || vF(n, r))
      return {
        elementState: e
      };
    const [o, s] = r, i = n.slice(o, s).replace(/\d/g, "0"), a = n.slice(0, o) + i + n.slice(s);
    return t === "validation" || t === "insert" && o === s ? {
      elementState: {
        selection: r,
        value: a
      }
    } : {
      elementState: {
        selection: t === "deleteBackward" || t === "insert" ? [o, o] : [s, s],
        value: a
      }
    };
  };
}
function vF(e, [t, n]) {
  return n === e.length;
}
function yF({
  mode: e,
  separator: t = ".",
  max: n,
  min: r
}) {
  const o = e.split("/").join(t);
  return Object.assign(Object.assign({}, nd), {
    mask: Array.from(o).map((s) => s === t ? s : /\d/),
    overwriteMode: "replace",
    preprocessors: [bF(), pF({
      dateModeTemplate: o,
      dateSegmentsSeparator: t
    })],
    postprocessors: [hF({
      min: r,
      max: n,
      dateModeTemplate: o,
      dateSegmentSeparator: t
    })]
  });
}
new RegExp(`[${rF.map(p_).join("")}]$`);
const xF = typeof window < "u" ? ii : st, wF = ({
  options: e = nd,
  elementPredicate: t = N$
} = {}) => {
  const [n, r] = Vt(null), o = ot((s) => {
    r(s);
  }, []);
  return xF(() => {
    if (!n)
      return;
    const s = new q$(t(n), e);
    return () => {
      s.destroy();
    };
  }, [e, n, t]), o;
};
function Mo(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function g_(e, t = []) {
  let n = [];
  function r(s, i) {
    const a = /* @__PURE__ */ ac(i), l = n.length;
    n = [
      ...n,
      i
    ];
    function c(d) {
      const { scope: f, children: h, ...p } = d, g = (f == null ? void 0 : f[e][l]) || a, m = Ar(
        () => p,
        Object.values(p)
      );
      return /* @__PURE__ */ it(g.Provider, {
        value: m
      }, h);
    }
    function u(d, f) {
      const h = (f == null ? void 0 : f[e][l]) || a, p = _h(h);
      if (p)
        return p;
      if (i !== void 0)
        return i;
      throw new Error(`\`${d}\` must be used within \`${s}\``);
    }
    return c.displayName = s + "Provider", [
      c,
      u
    ];
  }
  const o = () => {
    const s = n.map((i) => /* @__PURE__ */ ac(i));
    return function(a) {
      const l = (a == null ? void 0 : a[e]) || s;
      return Ar(
        () => ({
          [`__scope${e}`]: {
            ...a,
            [e]: l
          }
        }),
        [
          a,
          l
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    CF(o, ...t)
  ];
}
function CF(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(s) {
      const i = r.reduce((a, { useScope: l, scopeName: c }) => {
        const d = l(s)[`__scope${c}`];
        return {
          ...a,
          ...d
        };
      }, {});
      return Ar(
        () => ({
          [`__scope${t.scopeName}`]: i
        }),
        [
          i
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Ao(e) {
  const t = et(e);
  return st(() => {
    t.current = e;
  }), Ar(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function EF(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ao(e);
  st(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const ph = "dismissableLayer.update", _F = "dismissableLayer.pointerDownOutside", SF = "dismissableLayer.focusOutside";
let H0;
const OF = /* @__PURE__ */ ac({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), MF = /* @__PURE__ */ pn((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: s, onFocusOutside: i, onInteractOutside: a, onDismiss: l, ...c } = e, u = _h(OF), [d, f] = Vt(null), h = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, p] = Vt({}), g = Cs(
    t,
    (O) => f(O)
  ), m = Array.from(u.layers), [v] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), y = m.indexOf(v), x = d ? m.indexOf(d) : -1, C = u.layersWithOutsidePointerEventsDisabled.size > 0, w = x >= y, E = TF((O) => {
    const M = O.target, T = [
      ...u.branches
    ].some(
      (P) => P.contains(M)
    );
    !w || T || (s == null || s(O), a == null || a(O), O.defaultPrevented || l == null || l());
  }, h), S = RF((O) => {
    const M = O.target;
    [
      ...u.branches
    ].some(
      (P) => P.contains(M)
    ) || (i == null || i(O), a == null || a(O), O.defaultPrevented || l == null || l());
  }, h);
  return EF((O) => {
    x === u.layers.size - 1 && (o == null || o(O), !O.defaultPrevented && l && (O.preventDefault(), l()));
  }, h), st(() => {
    if (d)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (H0 = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), B0(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = H0);
      };
  }, [
    d,
    h,
    r,
    u
  ]), st(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), B0());
  }, [
    d,
    u
  ]), st(() => {
    const O = () => p({});
    return document.addEventListener(ph, O), () => document.removeEventListener(ph, O);
  }, []), /* @__PURE__ */ it(Yo.div, an({}, c, {
    ref: g,
    style: {
      pointerEvents: C ? w ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Mo(e.onFocusCapture, S.onFocusCapture),
    onBlurCapture: Mo(e.onBlurCapture, S.onBlurCapture),
    onPointerDownCapture: Mo(e.onPointerDownCapture, E.onPointerDownCapture)
  }));
});
function TF(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ao(e), r = et(!1), o = et(() => {
  });
  return st(() => {
    const s = (a) => {
      if (a.target && !r.current) {
        let c = function() {
          m_(_F, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: a
        };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = c, t.addEventListener("click", o.current, {
          once: !0
        })) : c();
      }
      r.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", s), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function RF(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ao(e), r = et(!1);
  return st(() => {
    const o = (s) => {
      s.target && !r.current && m_(SF, n, {
        originalEvent: s
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function B0() {
  const e = new CustomEvent(ph);
  document.dispatchEvent(e);
}
function m_(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, s = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? tA(o, s) : o.dispatchEvent(s);
}
let sf = 0;
function PF() {
  st(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : z0()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : z0()), sf++, () => {
      sf === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), sf--;
    };
  }, []);
}
function z0() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const af = "focusScope.autoFocusOnMount", lf = "focusScope.autoFocusOnUnmount", Y0 = {
  bubbles: !1,
  cancelable: !0
}, IF = /* @__PURE__ */ pn((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: s, ...i } = e, [a, l] = Vt(null), c = Ao(o), u = Ao(s), d = et(null), f = Cs(
    t,
    (g) => l(g)
  ), h = et({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  st(() => {
    if (r) {
      let g = function(x) {
        if (h.paused || !a)
          return;
        const C = x.target;
        a.contains(C) ? d.current = C : yo(d.current, {
          select: !0
        });
      }, m = function(x) {
        if (h.paused || !a)
          return;
        const C = x.relatedTarget;
        C !== null && (a.contains(C) || yo(d.current, {
          select: !0
        }));
      }, v = function(x) {
        const C = document.activeElement;
        for (const w of x)
          w.removedNodes.length > 0 && (a != null && a.contains(C) || yo(a));
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", m);
      const y = new MutationObserver(v);
      return a && y.observe(a, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", m), y.disconnect();
      };
    }
  }, [
    r,
    a,
    h.paused
  ]), st(() => {
    if (a) {
      U0.add(h);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const v = new CustomEvent(af, Y0);
        a.addEventListener(af, c), a.dispatchEvent(v), v.defaultPrevented || (kF(FF(b_(a)), {
          select: !0
        }), document.activeElement === g && yo(a));
      }
      return () => {
        a.removeEventListener(af, c), setTimeout(() => {
          const v = new CustomEvent(lf, Y0);
          a.addEventListener(lf, u), a.dispatchEvent(v), v.defaultPrevented || yo(g ?? document.body, {
            select: !0
          }), a.removeEventListener(lf, u), U0.remove(h);
        }, 0);
      };
    }
  }, [
    a,
    c,
    u,
    h
  ]);
  const p = ot((g) => {
    if (!n && !r || h.paused)
      return;
    const m = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, v = document.activeElement;
    if (m && v) {
      const y = g.currentTarget, [x, C] = DF(y);
      x && C ? !g.shiftKey && v === C ? (g.preventDefault(), n && yo(x, {
        select: !0
      })) : g.shiftKey && v === x && (g.preventDefault(), n && yo(C, {
        select: !0
      })) : v === y && g.preventDefault();
    }
  }, [
    n,
    r,
    h.paused
  ]);
  return /* @__PURE__ */ it(Yo.div, an({
    tabIndex: -1
  }, i, {
    ref: f,
    onKeyDown: p
  }));
});
function kF(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (yo(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function DF(e) {
  const t = b_(e), n = j0(t, e), r = j0(t.reverse(), e);
  return [
    n,
    r
  ];
}
function b_(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function j0(e, t) {
  for (const n of e)
    if (!NF(n, {
      upTo: t
    }))
      return n;
}
function NF(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function AF(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function yo(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && AF(e) && t && e.select();
  }
}
const U0 = $F();
function $F() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = G0(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = G0(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function G0(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function FF(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const ri = globalThis != null && globalThis.document ? ii : () => {
}, LF = b["useId".toString()] || (() => {
});
let VF = 0;
function WF(e) {
  const [t, n] = b.useState(LF());
  return ri(() => {
    e || n(
      (r) => r ?? String(VF++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const HF = ["top", "right", "bottom", "left"], Ea = Math.min, ns = Math.max, BF = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, zF = {
  start: "end",
  end: "start"
};
function gh(e, t, n) {
  return ns(e, Ea(t, n));
}
function so(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function io(e) {
  return e.split("-")[0];
}
function gi(e) {
  return e.split("-")[1];
}
function Bg(e) {
  return e === "x" ? "y" : "x";
}
function zg(e) {
  return e === "y" ? "height" : "width";
}
function mi(e) {
  return ["top", "bottom"].includes(io(e)) ? "y" : "x";
}
function Yg(e) {
  return Bg(mi(e));
}
function YF(e, t, n) {
  n === void 0 && (n = !1);
  const r = gi(e), o = Yg(e), s = zg(o);
  let i = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (i = Hc(i)), [i, Hc(i)];
}
function jF(e) {
  const t = Hc(e);
  return [mh(e), t, mh(t)];
}
function mh(e) {
  return e.replace(/start|end/g, (t) => zF[t]);
}
function UF(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], s = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? s : i;
    default:
      return [];
  }
}
function GF(e, t, n, r) {
  const o = gi(e);
  let s = UF(io(e), n === "start", r);
  return o && (s = s.map((i) => i + "-" + o), t && (s = s.concat(s.map(mh)))), s;
}
function Hc(e) {
  return e.replace(/left|right|bottom|top/g, (t) => BF[t]);
}
function KF(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function v_(e) {
  return typeof e != "number" ? KF(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Bc(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function K0(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const s = mi(t), i = Yg(t), a = zg(i), l = io(t), c = s === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[a] / 2 - o[a] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (gi(t)) {
    case "start":
      h[i] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      h[i] += f * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const qF = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: s = [],
    platform: i
  } = n, a = s.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let c = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = K0(c, r, l), f = r, h = {}, p = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: m,
      fn: v
    } = a[g], {
      x: y,
      y: x,
      data: C,
      reset: w
    } = await v({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: h,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (u = y ?? u, d = x ?? d, h = {
      ...h,
      [m]: {
        ...h[m],
        ...C
      }
    }, w && p <= 50) {
      p++, typeof w == "object" && (w.placement && (f = w.placement), w.rects && (c = w.rects === !0 ? await i.getElementRects({
        reference: e,
        floating: t,
        strategy: o
      }) : w.rects), {
        x: u,
        y: d
      } = K0(c, f, l)), g = -1;
      continue;
    }
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: h
  };
};
async function _a(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: s,
    rects: i,
    elements: a,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = so(t, e), p = v_(h), m = a[f ? d === "floating" ? "reference" : "floating" : d], v = Bc(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(m))) == null || n ? m : m.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), y = d === "floating" ? {
    ...i.floating,
    x: r,
    y: o
  } : i.reference, x = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a.floating)), C = await (s.isElement == null ? void 0 : s.isElement(x)) ? await (s.getScale == null ? void 0 : s.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = Bc(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: y,
    offsetParent: x,
    strategy: l
  }) : y);
  return {
    top: (v.top - w.top + p.top) / C.y,
    bottom: (w.bottom - v.bottom + p.bottom) / C.y,
    left: (v.left - w.left + p.left) / C.x,
    right: (w.right - v.right + p.right) / C.x
  };
}
const q0 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: s,
      platform: i,
      elements: a
    } = t, {
      element: l,
      padding: c = 0
    } = so(e, t) || {};
    if (l == null)
      return {};
    const u = v_(c), d = {
      x: n,
      y: r
    }, f = Yg(o), h = zg(f), p = await i.getDimensions(l), g = f === "y", m = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", x = s.reference[h] + s.reference[f] - d[f] - s.floating[h], C = d[f] - s.reference[f], w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l));
    let E = w ? w[y] : 0;
    (!E || !await (i.isElement == null ? void 0 : i.isElement(w))) && (E = a.floating[y] || s.floating[h]);
    const S = x / 2 - C / 2, O = E / 2 - p[h] / 2 - 1, M = Ea(u[m], O), T = Ea(u[v], O), P = M, I = E - p[h] - T, R = E / 2 - p[h] / 2 + S, D = gh(P, R, I), $ = gi(o) != null && R != D && s.reference[h] / 2 - (R < P ? M : T) - p[h] / 2 < 0 ? R < P ? P - R : I - R : 0;
    return {
      [f]: d[f] - $,
      data: {
        [f]: D,
        centerOffset: R - D + $
      }
    };
  }
}), XF = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n;
      const {
        placement: r,
        middlewareData: o,
        rects: s,
        initialPlacement: i,
        platform: a,
        elements: l
      } = t, {
        mainAxis: c = !0,
        crossAxis: u = !0,
        fallbackPlacements: d,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: p = !0,
        ...g
      } = so(e, t), m = io(r), v = io(i) === i, y = await (a.isRTL == null ? void 0 : a.isRTL(l.floating)), x = d || (v || !p ? [Hc(i)] : jF(i));
      !d && h !== "none" && x.push(...GF(i, p, h, y));
      const C = [i, ...x], w = await _a(t, g), E = [];
      let S = ((n = o.flip) == null ? void 0 : n.overflows) || [];
      if (c && E.push(w[m]), u) {
        const P = YF(r, s, y);
        E.push(w[P[0]], w[P[1]]);
      }
      if (S = [...S, {
        placement: r,
        overflows: E
      }], !E.every((P) => P <= 0)) {
        var O, M;
        const P = (((O = o.flip) == null ? void 0 : O.index) || 0) + 1, I = C[P];
        if (I)
          return {
            data: {
              index: P,
              overflows: S
            },
            reset: {
              placement: I
            }
          };
        let R = (M = S.filter((D) => D.overflows[0] <= 0).sort((D, k) => D.overflows[1] - k.overflows[1])[0]) == null ? void 0 : M.placement;
        if (!R)
          switch (f) {
            case "bestFit": {
              var T;
              const D = (T = S.map((k) => [k.placement, k.overflows.filter(($) => $ > 0).reduce(($, L) => $ + L, 0)]).sort((k, $) => k[1] - $[1])[0]) == null ? void 0 : T[0];
              D && (R = D);
              break;
            }
            case "initialPlacement":
              R = i;
              break;
          }
        if (r !== R)
          return {
            reset: {
              placement: R
            }
          };
      }
      return {};
    }
  };
};
function X0(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Z0(e) {
  return HF.some((t) => e[t] >= 0);
}
const ZF = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = so(e, t);
      switch (r) {
        case "referenceHidden": {
          const s = await _a(t, {
            ...o,
            elementContext: "reference"
          }), i = X0(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: Z0(i)
            }
          };
        }
        case "escaped": {
          const s = await _a(t, {
            ...o,
            altBoundary: !0
          }), i = X0(s, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: Z0(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function QF(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, s = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), i = io(n), a = gi(n), l = mi(n) === "y", c = ["left", "top"].includes(i) ? -1 : 1, u = s && l ? -1 : 1, d = so(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: p
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return a && typeof p == "number" && (h = a === "end" ? p * -1 : p), l ? {
    x: h * u,
    y: f * c
  } : {
    x: f * c,
    y: h * u
  };
}
const JF = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r
      } = t, o = await QF(t, e);
      return {
        x: n + o.x,
        y: r + o.y,
        data: o
      };
    }
  };
}, eL = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: s = !0,
        crossAxis: i = !1,
        limiter: a = {
          fn: (m) => {
            let {
              x: v,
              y
            } = m;
            return {
              x: v,
              y
            };
          }
        },
        ...l
      } = so(e, t), c = {
        x: n,
        y: r
      }, u = await _a(t, l), d = mi(io(o)), f = Bg(d);
      let h = c[f], p = c[d];
      if (s) {
        const m = f === "y" ? "top" : "left", v = f === "y" ? "bottom" : "right", y = h + u[m], x = h - u[v];
        h = gh(y, h, x);
      }
      if (i) {
        const m = d === "y" ? "top" : "left", v = d === "y" ? "bottom" : "right", y = p + u[m], x = p - u[v];
        p = gh(y, p, x);
      }
      const g = a.fn({
        ...t,
        [f]: h,
        [d]: p
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r
        }
      };
    }
  };
}, tL = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: s,
        middlewareData: i
      } = t, {
        offset: a = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = so(e, t), u = {
        x: n,
        y: r
      }, d = mi(o), f = Bg(d);
      let h = u[f], p = u[d];
      const g = so(a, t), m = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const x = f === "y" ? "height" : "width", C = s.reference[f] - s.floating[x] + m.mainAxis, w = s.reference[f] + s.reference[x] - m.mainAxis;
        h < C ? h = C : h > w && (h = w);
      }
      if (c) {
        var v, y;
        const x = f === "y" ? "width" : "height", C = ["top", "left"].includes(io(o)), w = s.reference[d] - s.floating[x] + (C && ((v = i.offset) == null ? void 0 : v[d]) || 0) + (C ? 0 : m.crossAxis), E = s.reference[d] + s.reference[x] + (C ? 0 : ((y = i.offset) == null ? void 0 : y[d]) || 0) - (C ? m.crossAxis : 0);
        p < w ? p = w : p > E && (p = E);
      }
      return {
        [f]: h,
        [d]: p
      };
    }
  };
}, nL = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: s
      } = t, {
        apply: i = () => {
        },
        ...a
      } = so(e, t), l = await _a(t, a), c = io(n), u = gi(n), d = mi(n) === "y", {
        width: f,
        height: h
      } = r.floating;
      let p, g;
      c === "top" || c === "bottom" ? (p = c, g = u === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (g = c, p = u === "end" ? "top" : "bottom");
      const m = h - l[p], v = f - l[g], y = !t.middlewareData.shift;
      let x = m, C = v;
      if (d) {
        const E = f - l.left - l.right;
        C = u || y ? Ea(v, E) : E;
      } else {
        const E = h - l.top - l.bottom;
        x = u || y ? Ea(m, E) : E;
      }
      if (y && !u) {
        const E = ns(l.left, 0), S = ns(l.right, 0), O = ns(l.top, 0), M = ns(l.bottom, 0);
        d ? C = f - 2 * (E !== 0 || S !== 0 ? E + S : ns(l.left, l.right)) : x = h - 2 * (O !== 0 || M !== 0 ? O + M : ns(l.top, l.bottom));
      }
      await i({
        ...t,
        availableWidth: C,
        availableHeight: x
      });
      const w = await o.getDimensions(s.floating);
      return f !== w.width || h !== w.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
}, bh = Math.min, Gs = Math.max, zc = Math.round, Nl = Math.floor, $o = (e) => ({
  x: e,
  y: e
});
function Fo(e) {
  return y_(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function qn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function fo(e) {
  var t;
  return (t = (y_(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function y_(e) {
  return e instanceof Node || e instanceof qn(e).Node;
}
function ao(e) {
  return e instanceof Element || e instanceof qn(e).Element;
}
function Wr(e) {
  return e instanceof HTMLElement || e instanceof qn(e).HTMLElement;
}
function Q0(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof qn(e).ShadowRoot;
}
function Qa(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = cr(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function rL(e) {
  return ["table", "td", "th"].includes(Fo(e));
}
function jg(e) {
  const t = Ug(), n = cr(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function oL(e) {
  let t = oi(e);
  for (; Wr(t) && !od(t); ) {
    if (jg(t))
      return t;
    t = oi(t);
  }
  return null;
}
function Ug() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function od(e) {
  return ["html", "body", "#document"].includes(Fo(e));
}
function cr(e) {
  return qn(e).getComputedStyle(e);
}
function sd(e) {
  return ao(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function oi(e) {
  if (Fo(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Q0(e) && e.host || // Fallback.
    fo(e)
  );
  return Q0(t) ? t.host : t;
}
function x_(e) {
  const t = oi(e);
  return od(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Wr(t) && Qa(t) ? t : x_(t);
}
function Yc(e, t) {
  var n;
  t === void 0 && (t = []);
  const r = x_(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), s = qn(r);
  return o ? t.concat(s, s.visualViewport || [], Qa(r) ? r : []) : t.concat(r, Yc(r));
}
function w_(e) {
  const t = cr(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Wr(e), s = o ? e.offsetWidth : n, i = o ? e.offsetHeight : r, a = zc(n) !== s || zc(r) !== i;
  return a && (n = s, r = i), {
    width: n,
    height: r,
    $: a
  };
}
function Gg(e) {
  return ao(e) ? e : e.contextElement;
}
function Ks(e) {
  const t = Gg(e);
  if (!Wr(t))
    return $o(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: s
  } = w_(t);
  let i = (s ? zc(n.width) : n.width) / r, a = (s ? zc(n.height) : n.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: i,
    y: a
  };
}
const sL = /* @__PURE__ */ $o(0);
function C_(e) {
  const t = qn(e);
  return !Ug() || !t.visualViewport ? sL : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function iL(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== qn(e) ? !1 : t;
}
function gs(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), s = Gg(e);
  let i = $o(1);
  t && (r ? ao(r) && (i = Ks(r)) : i = Ks(e));
  const a = iL(s, n, r) ? C_(s) : $o(0);
  let l = (o.left + a.x) / i.x, c = (o.top + a.y) / i.y, u = o.width / i.x, d = o.height / i.y;
  if (s) {
    const f = qn(s), h = r && ao(r) ? qn(r) : r;
    let p = f.frameElement;
    for (; p && r && h !== f; ) {
      const g = Ks(p), m = p.getBoundingClientRect(), v = cr(p), y = m.left + (p.clientLeft + parseFloat(v.paddingLeft)) * g.x, x = m.top + (p.clientTop + parseFloat(v.paddingTop)) * g.y;
      l *= g.x, c *= g.y, u *= g.x, d *= g.y, l += y, c += x, p = qn(p).frameElement;
    }
  }
  return Bc({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function aL(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const o = Wr(n), s = fo(n);
  if (n === s)
    return t;
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = $o(1);
  const l = $o(0);
  if ((o || !o && r !== "fixed") && ((Fo(n) !== "body" || Qa(s)) && (i = sd(n)), Wr(n))) {
    const c = gs(n);
    a = Ks(n), l.x = c.x + n.clientLeft, l.y = c.y + n.clientTop;
  }
  return {
    width: t.width * a.x,
    height: t.height * a.y,
    x: t.x * a.x - i.scrollLeft * a.x + l.x,
    y: t.y * a.y - i.scrollTop * a.y + l.y
  };
}
function lL(e) {
  return Array.from(e.getClientRects());
}
function E_(e) {
  return gs(fo(e)).left + sd(e).scrollLeft;
}
function cL(e) {
  const t = fo(e), n = sd(e), r = e.ownerDocument.body, o = Gs(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), s = Gs(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let i = -n.scrollLeft + E_(e);
  const a = -n.scrollTop;
  return cr(r).direction === "rtl" && (i += Gs(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: s,
    x: i,
    y: a
  };
}
function uL(e, t) {
  const n = qn(e), r = fo(e), o = n.visualViewport;
  let s = r.clientWidth, i = r.clientHeight, a = 0, l = 0;
  if (o) {
    s = o.width, i = o.height;
    const c = Ug();
    (!c || c && t === "fixed") && (a = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: s,
    height: i,
    x: a,
    y: l
  };
}
function dL(e, t) {
  const n = gs(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, s = Wr(e) ? Ks(e) : $o(1), i = e.clientWidth * s.x, a = e.clientHeight * s.y, l = o * s.x, c = r * s.y;
  return {
    width: i,
    height: a,
    x: l,
    y: c
  };
}
function J0(e, t, n) {
  let r;
  if (t === "viewport")
    r = uL(e, n);
  else if (t === "document")
    r = cL(fo(e));
  else if (ao(t))
    r = dL(t, n);
  else {
    const o = C_(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return Bc(r);
}
function __(e, t) {
  const n = oi(e);
  return n === t || !ao(n) || od(n) ? !1 : cr(n).position === "fixed" || __(n, t);
}
function fL(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Yc(e).filter((a) => ao(a) && Fo(a) !== "body"), o = null;
  const s = cr(e).position === "fixed";
  let i = s ? oi(e) : e;
  for (; ao(i) && !od(i); ) {
    const a = cr(i), l = jg(i);
    !l && a.position === "fixed" && (o = null), (s ? !l && !o : !l && a.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Qa(i) && !l && __(e, i)) ? r = r.filter((u) => u !== i) : o = a, i = oi(i);
  }
  return t.set(e, r), r;
}
function hL(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const i = [...n === "clippingAncestors" ? fL(t, this._c) : [].concat(n), r], a = i[0], l = i.reduce((c, u) => {
    const d = J0(t, u, o);
    return c.top = Gs(d.top, c.top), c.right = bh(d.right, c.right), c.bottom = bh(d.bottom, c.bottom), c.left = Gs(d.left, c.left), c;
  }, J0(t, a, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function pL(e) {
  return w_(e);
}
function gL(e, t, n) {
  const r = Wr(t), o = fo(t), s = n === "fixed", i = gs(e, !0, s, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = $o(0);
  if (r || !r && !s)
    if ((Fo(t) !== "body" || Qa(o)) && (a = sd(t)), r) {
      const c = gs(t, !0, s, t);
      l.x = c.x + t.clientLeft, l.y = c.y + t.clientTop;
    } else
      o && (l.x = E_(o));
  return {
    x: i.left + a.scrollLeft - l.x,
    y: i.top + a.scrollTop - l.y,
    width: i.width,
    height: i.height
  };
}
function ey(e, t) {
  return !Wr(e) || cr(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function S_(e, t) {
  const n = qn(e);
  if (!Wr(e))
    return n;
  let r = ey(e, t);
  for (; r && rL(r) && cr(r).position === "static"; )
    r = ey(r, t);
  return r && (Fo(r) === "html" || Fo(r) === "body" && cr(r).position === "static" && !jg(r)) ? n : r || oL(e) || n;
}
const mL = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: r
  } = e;
  const o = this.getOffsetParent || S_, s = this.getDimensions;
  return {
    reference: gL(t, await o(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await s(n)
    }
  };
};
function bL(e) {
  return cr(e).direction === "rtl";
}
const vL = {
  convertOffsetParentRelativeRectToViewportRelativeRect: aL,
  getDocumentElement: fo,
  getClippingRect: hL,
  getOffsetParent: S_,
  getElementRects: mL,
  getClientRects: lL,
  getDimensions: pL,
  getScale: Ks,
  isElement: ao,
  isRTL: bL
};
function yL(e, t) {
  let n = null, r;
  const o = fo(e);
  function s() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function i(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), s();
    const {
      left: c,
      top: u,
      width: d,
      height: f
    } = e.getBoundingClientRect();
    if (a || t(), !d || !f)
      return;
    const h = Nl(u), p = Nl(o.clientWidth - (c + d)), g = Nl(o.clientHeight - (u + f)), m = Nl(c), y = {
      rootMargin: -h + "px " + -p + "px " + -g + "px " + -m + "px",
      threshold: Gs(0, bh(1, l)) || 1
    };
    let x = !0;
    function C(w) {
      const E = w[0].intersectionRatio;
      if (E !== l) {
        if (!x)
          return i();
        E ? i(!1, E) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 100);
      }
      x = !1;
    }
    try {
      n = new IntersectionObserver(C, {
        ...y,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(C, y);
    }
    n.observe(e);
  }
  return i(!0), s;
}
function xL(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: s = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = Gg(e), u = o || s ? [...c ? Yc(c) : [], ...Yc(t)] : [];
  u.forEach((v) => {
    o && v.addEventListener("scroll", n, {
      passive: !0
    }), s && v.addEventListener("resize", n);
  });
  const d = c && a ? yL(c, n) : null;
  let f = -1, h = null;
  i && (h = new ResizeObserver((v) => {
    let [y] = v;
    y && y.target === c && h && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      h && h.observe(t);
    })), n();
  }), c && !l && h.observe(c), h.observe(t));
  let p, g = l ? gs(e) : null;
  l && m();
  function m() {
    const v = gs(e);
    g && (v.x !== g.x || v.y !== g.y || v.width !== g.width || v.height !== g.height) && n(), g = v, p = requestAnimationFrame(m);
  }
  return n(), () => {
    u.forEach((v) => {
      o && v.removeEventListener("scroll", n), s && v.removeEventListener("resize", n);
    }), d && d(), h && h.disconnect(), h = null, l && cancelAnimationFrame(p);
  };
}
const wL = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: vL,
    ...n
  }, s = {
    ...o.platform,
    _c: r
  };
  return qF(e, t, {
    ...o,
    platform: s
  });
}, CL = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? q0({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? q0({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
};
var tc = typeof document < "u" ? ii : st;
function jc(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!jc(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const s = o[r];
      if (!(s === "_owner" && e.$$typeof) && !jc(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function O_(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ty(e, t) {
  const n = O_(e);
  return Math.round(t * n) / n;
}
function ny(e) {
  const t = b.useRef(e);
  return tc(() => {
    t.current = e;
  }), t;
}
function EL(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: s,
      floating: i
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = b.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = b.useState(r);
  jc(f, r) || h(r);
  const [p, g] = b.useState(null), [m, v] = b.useState(null), y = b.useCallback(($) => {
    $ != E.current && (E.current = $, g($));
  }, [g]), x = b.useCallback(($) => {
    $ !== S.current && (S.current = $, v($));
  }, [v]), C = s || p, w = i || m, E = b.useRef(null), S = b.useRef(null), O = b.useRef(u), M = ny(l), T = ny(o), P = b.useCallback(() => {
    if (!E.current || !S.current)
      return;
    const $ = {
      placement: t,
      strategy: n,
      middleware: f
    };
    T.current && ($.platform = T.current), wL(E.current, S.current, $).then((L) => {
      const A = {
        ...L,
        isPositioned: !0
      };
      I.current && !jc(O.current, A) && (O.current = A, Xn.flushSync(() => {
        d(A);
      }));
    });
  }, [f, t, n, T]);
  tc(() => {
    c === !1 && O.current.isPositioned && (O.current.isPositioned = !1, d(($) => ({
      ...$,
      isPositioned: !1
    })));
  }, [c]);
  const I = b.useRef(!1);
  tc(() => (I.current = !0, () => {
    I.current = !1;
  }), []), tc(() => {
    if (C && (E.current = C), w && (S.current = w), C && w) {
      if (M.current)
        return M.current(C, w, P);
      P();
    }
  }, [C, w, P, M]);
  const R = b.useMemo(() => ({
    reference: E,
    floating: S,
    setReference: y,
    setFloating: x
  }), [y, x]), D = b.useMemo(() => ({
    reference: C,
    floating: w
  }), [C, w]), k = b.useMemo(() => {
    const $ = {
      position: n,
      left: 0,
      top: 0
    };
    if (!D.floating)
      return $;
    const L = ty(D.floating, u.x), A = ty(D.floating, u.y);
    return a ? {
      ...$,
      transform: "translate(" + L + "px, " + A + "px)",
      ...O_(D.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: L,
      top: A
    };
  }, [n, a, D.floating, u.x, u.y]);
  return b.useMemo(() => ({
    ...u,
    update: P,
    refs: R,
    elements: D,
    floatingStyles: k
  }), [u, P, R, D, k]);
}
const _L = /* @__PURE__ */ pn((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...s } = e;
  return /* @__PURE__ */ it(Yo.svg, an({}, s, {
    ref: t,
    width: r,
    height: o,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), e.asChild ? n : /* @__PURE__ */ it("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), SL = _L;
function OL(e) {
  const [t, n] = Vt(void 0);
  return ri(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const s = o[0];
        let i, a;
        if ("borderBoxSize" in s) {
          const l = s.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          i = c.inlineSize, a = c.blockSize;
        } else
          i = e.offsetWidth, a = e.offsetHeight;
        n({
          width: i,
          height: a
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const M_ = "Popper", [T_, R_] = g_(M_), [ML, P_] = T_(M_), TL = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = Vt(null);
  return /* @__PURE__ */ it(ML, {
    scope: t,
    anchor: r,
    onAnchorChange: o
  }, n);
}, RL = "PopperAnchor", PL = /* @__PURE__ */ pn((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...o } = e, s = P_(RL, n), i = et(null), a = Cs(t, i);
  return st(() => {
    s.onAnchorChange((r == null ? void 0 : r.current) || i.current);
  }), r ? null : /* @__PURE__ */ it(Yo.div, an({}, o, {
    ref: a
  }));
}), I_ = "PopperContent", [IL, kL] = T_(I_), DL = /* @__PURE__ */ pn((e, t) => {
  var n, r, o, s, i, a, l, c;
  const { __scopePopper: u, side: d = "bottom", sideOffset: f = 0, align: h = "center", alignOffset: p = 0, arrowPadding: g = 0, collisionBoundary: m = [], collisionPadding: v = 0, sticky: y = "partial", hideWhenDetached: x = !1, avoidCollisions: C = !0, onPlaced: w, ...E } = e, S = P_(I_, u), [O, M] = Vt(null), T = Cs(
    t,
    (Q) => M(Q)
  ), [P, I] = Vt(null), R = OL(P), D = (n = R == null ? void 0 : R.width) !== null && n !== void 0 ? n : 0, k = (r = R == null ? void 0 : R.height) !== null && r !== void 0 ? r : 0, $ = d + (h !== "center" ? "-" + h : ""), L = typeof v == "number" ? v : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...v
  }, A = Array.isArray(m) ? m : [
    m
  ], F = A.length > 0, N = {
    padding: L,
    boundary: A.filter(FL),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: F
  }, { refs: V, floatingStyles: K, placement: Y, isPositioned: U, middlewareData: j } = EL({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: $,
    whileElementsMounted: xL,
    elements: {
      reference: S.anchor
    },
    middleware: [
      JF({
        mainAxis: f + k,
        alignmentAxis: p
      }),
      C && eL({
        mainAxis: !0,
        crossAxis: !1,
        limiter: y === "partial" ? tL() : void 0,
        ...N
      }),
      C && XF({
        ...N
      }),
      nL({
        ...N,
        apply: ({ elements: Q, rects: re, availableWidth: fe, availableHeight: le }) => {
          const { width: Ee, height: se } = re.reference, _e = Q.floating.style;
          _e.setProperty("--radix-popper-available-width", `${fe}px`), _e.setProperty("--radix-popper-available-height", `${le}px`), _e.setProperty("--radix-popper-anchor-width", `${Ee}px`), _e.setProperty("--radix-popper-anchor-height", `${se}px`);
        }
      }),
      P && CL({
        element: P,
        padding: g
      }),
      LL({
        arrowWidth: D,
        arrowHeight: k
      }),
      x && ZF({
        strategy: "referenceHidden"
      })
    ]
  }), [H, q] = k_(Y), B = Ao(w);
  ri(() => {
    U && (B == null || B());
  }, [
    U,
    B
  ]);
  const X = (o = j.arrow) === null || o === void 0 ? void 0 : o.x, te = (s = j.arrow) === null || s === void 0 ? void 0 : s.y, J = ((i = j.arrow) === null || i === void 0 ? void 0 : i.centerOffset) !== 0, [G, ne] = Vt();
  return ri(() => {
    O && ne(window.getComputedStyle(O).zIndex);
  }, [
    O
  ]), /* @__PURE__ */ it("div", {
    ref: V.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...K,
      transform: U ? K.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: G,
      "--radix-popper-transform-origin": [
        (a = j.transformOrigin) === null || a === void 0 ? void 0 : a.x,
        (l = j.transformOrigin) === null || l === void 0 ? void 0 : l.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ it(IL, {
    scope: u,
    placedSide: H,
    onArrowChange: I,
    arrowX: X,
    arrowY: te,
    shouldHideArrow: J
  }, /* @__PURE__ */ it(Yo.div, an({
    "data-side": H,
    "data-align": q
  }, E, {
    ref: T,
    style: {
      ...E.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: U ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (c = j.hide) !== null && c !== void 0 && c.referenceHidden ? 0 : void 0
    }
  }))));
}), NL = "PopperArrow", AL = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, $L = /* @__PURE__ */ pn(function(t, n) {
  const { __scopePopper: r, ...o } = t, s = kL(NL, r), i = AL[s.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ it("span", {
      ref: s.onArrowChange,
      style: {
        position: "absolute",
        left: s.arrowX,
        top: s.arrowY,
        [i]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[s.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[s.placedSide],
        visibility: s.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ it(SL, an({}, o, {
      ref: n,
      style: {
        ...o.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function FL(e) {
  return e !== null;
}
const LL = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, o, s, i;
    const { placement: a, rects: l, middlewareData: c } = t, d = ((n = c.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, f = d ? 0 : e.arrowWidth, h = d ? 0 : e.arrowHeight, [p, g] = k_(a), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[g], v = ((r = (o = c.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + f / 2, y = ((s = (i = c.arrow) === null || i === void 0 ? void 0 : i.y) !== null && s !== void 0 ? s : 0) + h / 2;
    let x = "", C = "";
    return p === "bottom" ? (x = d ? m : `${v}px`, C = `${-h}px`) : p === "top" ? (x = d ? m : `${v}px`, C = `${l.floating.height + h}px`) : p === "right" ? (x = `${-h}px`, C = d ? m : `${y}px`) : p === "left" && (x = `${l.floating.width + h}px`, C = d ? m : `${y}px`), {
      data: {
        x,
        y: C
      }
    };
  }
});
function k_(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const VL = TL, D_ = PL, WL = DL, HL = $L;
function BL(e, t) {
  return Dy((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const Kg = (e) => {
  const { present: t, children: n } = e, r = zL(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : Hs.only(n), s = Cs(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Zc(o, {
    ref: s
  }) : null;
};
Kg.displayName = "Presence";
function zL(e) {
  const [t, n] = Vt(), r = et({}), o = et(e), s = et("none"), i = e ? "mounted" : "unmounted", [a, l] = BL(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return st(() => {
    const c = Al(r.current);
    s.current = a === "mounted" ? c : "none";
  }, [
    a
  ]), ri(() => {
    const c = r.current, u = o.current;
    if (u !== e) {
      const f = s.current, h = Al(c);
      e ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    l
  ]), ri(() => {
    if (t) {
      const c = (d) => {
        const h = Al(r.current).includes(d.animationName);
        d.target === t && h && Sh(
          () => l("ANIMATION_END")
        );
      }, u = (d) => {
        d.target === t && (s.current = Al(r.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", c), t.addEventListener("animationend", c), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", c), t.removeEventListener("animationend", c);
      };
    } else
      l("ANIMATION_END");
  }, [
    t,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(a),
    ref: ot((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function Al(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function YL({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = jL({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, i = s ? e : r, a = Ao(n), l = ot((c) => {
    if (s) {
      const d = typeof c == "function" ? c(e) : c;
      d !== e && a(d);
    } else
      o(c);
  }, [
    s,
    e,
    o,
    a
  ]);
  return [
    i,
    l
  ];
}
function jL({ defaultProp: e, onChange: t }) {
  const n = Vt(e), [r] = n, o = et(r), s = Ao(t);
  return st(() => {
    o.current !== r && (s(r), o.current = r);
  }, [
    r,
    o,
    s
  ]), n;
}
var UL = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Ds = /* @__PURE__ */ new WeakMap(), $l = /* @__PURE__ */ new WeakMap(), Fl = {}, cf = 0, N_ = function(e) {
  return e && (e.host || N_(e.parentNode));
}, GL = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = N_(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, KL = function(e, t, n, r) {
  var o = GL(t, Array.isArray(e) ? e : [e]);
  Fl[n] || (Fl[n] = /* @__PURE__ */ new WeakMap());
  var s = Fl[n], i = [], a = /* @__PURE__ */ new Set(), l = new Set(o), c = function(d) {
    !d || a.has(d) || (a.add(d), c(d.parentNode));
  };
  o.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (a.has(f))
        u(f);
      else {
        var h = f.getAttribute(r), p = h !== null && h !== "false", g = (Ds.get(f) || 0) + 1, m = (s.get(f) || 0) + 1;
        Ds.set(f, g), s.set(f, m), i.push(f), g === 1 && p && $l.set(f, !0), m === 1 && f.setAttribute(n, "true"), p || f.setAttribute(r, "true");
      }
    });
  };
  return u(t), a.clear(), cf++, function() {
    i.forEach(function(d) {
      var f = Ds.get(d) - 1, h = s.get(d) - 1;
      Ds.set(d, f), s.set(d, h), f || ($l.has(d) || d.removeAttribute(r), $l.delete(d)), h || d.removeAttribute(n);
    }), cf--, cf || (Ds = /* @__PURE__ */ new WeakMap(), Ds = /* @__PURE__ */ new WeakMap(), $l = /* @__PURE__ */ new WeakMap(), Fl = {});
  };
}, qL = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || UL(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), KL(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, Fn = function() {
  return Fn = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, Fn.apply(this, arguments);
};
function A_(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function XL(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, s; r < o; r++)
      (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var nc = "right-scroll-bar-position", rc = "width-before-scroll-bar", ZL = "with-scroll-bars-hidden", QL = "--removed-body-scroll-bar-size";
function JL(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function eV(e, t) {
  var n = Vt(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function tV(e, t) {
  return eV(t || null, function(n) {
    return e.forEach(function(r) {
      return JL(r, n);
    });
  });
}
function nV(e) {
  return e;
}
function rV(e, t) {
  t === void 0 && (t = nV);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(s) {
      var i = t(s, r);
      return n.push(i), function() {
        n = n.filter(function(a) {
          return a !== i;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (r = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(s);
      }
      n = {
        push: function(a) {
          return s(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(s) {
      r = !0;
      var i = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(s), i = n;
      }
      var l = function() {
        var u = i;
        i = [], u.forEach(s);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          i.push(u), c();
        },
        filter: function(u) {
          return i = i.filter(u), n;
        }
      };
    }
  };
  return o;
}
function oV(e) {
  e === void 0 && (e = {});
  var t = rV(null);
  return t.options = Fn({ async: !0, ssr: !1 }, e), t;
}
var $_ = function(e) {
  var t = e.sideCar, n = A_(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return b.createElement(r, Fn({}, n));
};
$_.isSideCarExport = !0;
function sV(e, t) {
  return e.useMedium(t), $_;
}
var F_ = oV(), uf = function() {
}, id = b.forwardRef(function(e, t) {
  var n = b.useRef(null), r = b.useState({
    onScrollCapture: uf,
    onWheelCapture: uf,
    onTouchMoveCapture: uf
  }), o = r[0], s = r[1], i = e.forwardProps, a = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, h = e.noIsolation, p = e.inert, g = e.allowPinchZoom, m = e.as, v = m === void 0 ? "div" : m, y = A_(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), x = f, C = tV([n, t]), w = Fn(Fn({}, y), o);
  return b.createElement(
    b.Fragment,
    null,
    u && b.createElement(x, { sideCar: F_, removeScrollBar: c, shards: d, noIsolation: h, inert: p, setCallbacks: s, allowPinchZoom: !!g, lockRef: n }),
    i ? b.cloneElement(b.Children.only(a), Fn(Fn({}, w), { ref: C })) : b.createElement(v, Fn({}, w, { className: l, ref: C }), a)
  );
});
id.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
id.classNames = {
  fullWidth: rc,
  zeroRight: nc
};
var ry, iV = function() {
  if (ry)
    return ry;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function aV() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = iV();
  return t && e.setAttribute("nonce", t), e;
}
function lV(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function cV(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var uV = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = aV()) && (lV(t, n), cV(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, dV = function() {
  var e = uV();
  return function(t, n) {
    b.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, L_ = function() {
  var e = dV(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, fV = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, df = function(e) {
  return parseInt(e || "", 10) || 0;
}, hV = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [df(n), df(r), df(o)];
}, pV = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return fV;
  var t = hV(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, gV = L_(), mV = function(e, t, n, r) {
  var o = e.left, s = e.top, i = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(ZL, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(nc, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(rc, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(nc, " .").concat(nc, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(rc, " .").concat(rc, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(QL, ": ").concat(a, `px;
  }
`);
}, bV = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r, s = b.useMemo(function() {
    return pV(o);
  }, [o]);
  return b.createElement(gV, { styles: mV(s, !t, o, n ? "" : "!important") });
}, vh = !1;
if (typeof window < "u")
  try {
    var Ll = Object.defineProperty({}, "passive", {
      get: function() {
        return vh = !0, !0;
      }
    });
    window.addEventListener("test", Ll, Ll), window.removeEventListener("test", Ll, Ll);
  } catch {
    vh = !1;
  }
var Ns = vh ? { passive: !1 } : !1, vV = function(e) {
  return e.tagName === "TEXTAREA";
}, V_ = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !vV(e) && n[t] === "visible")
  );
}, yV = function(e) {
  return V_(e, "overflowY");
}, xV = function(e) {
  return V_(e, "overflowX");
}, oy = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = W_(e, n);
    if (r) {
      var o = H_(e, n), s = o[1], i = o[2];
      if (s > i)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, wV = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, CV = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, W_ = function(e, t) {
  return e === "v" ? yV(t) : xV(t);
}, H_ = function(e, t) {
  return e === "v" ? wV(t) : CV(t);
}, EV = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, _V = function(e, t, n, r, o) {
  var s = EV(e, window.getComputedStyle(t).direction), i = s * r, a = n.target, l = t.contains(a), c = !1, u = i > 0, d = 0, f = 0;
  do {
    var h = H_(e, a), p = h[0], g = h[1], m = h[2], v = g - m - s * p;
    (p || v) && W_(e, a) && (d += v, f += p), a = a.parentNode;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (t.contains(a) || t === a)
  );
  return (u && (o && d === 0 || !o && i > d) || !u && (o && f === 0 || !o && -i > f)) && (c = !0), c;
}, Vl = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, sy = function(e) {
  return [e.deltaX, e.deltaY];
}, iy = function(e) {
  return e && "current" in e ? e.current : e;
}, SV = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, OV = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, MV = 0, As = [];
function TV(e) {
  var t = b.useRef([]), n = b.useRef([0, 0]), r = b.useRef(), o = b.useState(MV++)[0], s = b.useState(function() {
    return L_();
  })[0], i = b.useRef(e);
  b.useEffect(function() {
    i.current = e;
  }, [e]), b.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = XL([e.lockRef.current], (e.shards || []).map(iy), !0).filter(Boolean);
      return g.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = b.useCallback(function(g, m) {
    if ("touches" in g && g.touches.length === 2)
      return !i.current.allowPinchZoom;
    var v = Vl(g), y = n.current, x = "deltaX" in g ? g.deltaX : y[0] - v[0], C = "deltaY" in g ? g.deltaY : y[1] - v[1], w, E = g.target, S = Math.abs(x) > Math.abs(C) ? "h" : "v";
    if ("touches" in g && S === "h" && E.type === "range")
      return !1;
    var O = oy(S, E);
    if (!O)
      return !0;
    if (O ? w = S : (w = S === "v" ? "h" : "v", O = oy(S, E)), !O)
      return !1;
    if (!r.current && "changedTouches" in g && (x || C) && (r.current = w), !w)
      return !0;
    var M = r.current || w;
    return _V(M, m, g, M === "h" ? x : C, !0);
  }, []), l = b.useCallback(function(g) {
    var m = g;
    if (!(!As.length || As[As.length - 1] !== s)) {
      var v = "deltaY" in m ? sy(m) : Vl(m), y = t.current.filter(function(w) {
        return w.name === m.type && w.target === m.target && SV(w.delta, v);
      })[0];
      if (y && y.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!y) {
        var x = (i.current.shards || []).map(iy).filter(Boolean).filter(function(w) {
          return w.contains(m.target);
        }), C = x.length > 0 ? a(m, x[0]) : !i.current.noIsolation;
        C && m.cancelable && m.preventDefault();
      }
    }
  }, []), c = b.useCallback(function(g, m, v, y) {
    var x = { name: g, delta: m, target: v, should: y };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== x;
      });
    }, 1);
  }, []), u = b.useCallback(function(g) {
    n.current = Vl(g), r.current = void 0;
  }, []), d = b.useCallback(function(g) {
    c(g.type, sy(g), g.target, a(g, e.lockRef.current));
  }, []), f = b.useCallback(function(g) {
    c(g.type, Vl(g), g.target, a(g, e.lockRef.current));
  }, []);
  b.useEffect(function() {
    return As.push(s), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, Ns), document.addEventListener("touchmove", l, Ns), document.addEventListener("touchstart", u, Ns), function() {
      As = As.filter(function(g) {
        return g !== s;
      }), document.removeEventListener("wheel", l, Ns), document.removeEventListener("touchmove", l, Ns), document.removeEventListener("touchstart", u, Ns);
    };
  }, []);
  var h = e.removeScrollBar, p = e.inert;
  return b.createElement(
    b.Fragment,
    null,
    p ? b.createElement(s, { styles: OV(o) }) : null,
    h ? b.createElement(bV, { gapMode: "margin" }) : null
  );
}
const RV = sV(F_, TV);
var B_ = b.forwardRef(function(e, t) {
  return b.createElement(id, Fn({}, e, { ref: t, sideCar: RV }));
});
B_.classNames = id.classNames;
const PV = B_, z_ = "Popover", [Y_, fB] = g_(z_, [
  R_
]), Ja = R_(), [IV, jo] = Y_(z_), kV = (e) => {
  const { __scopePopover: t, children: n, open: r, defaultOpen: o, onOpenChange: s, modal: i = !1 } = e, a = Ja(t), l = et(null), [c, u] = Vt(!1), [d = !1, f] = YL({
    prop: r,
    defaultProp: o,
    onChange: s
  });
  return /* @__PURE__ */ it(VL, a, /* @__PURE__ */ it(IV, {
    scope: t,
    contentId: WF(),
    triggerRef: l,
    open: d,
    onOpenChange: f,
    onOpenToggle: ot(
      () => f(
        (h) => !h
      ),
      [
        f
      ]
    ),
    hasCustomAnchor: c,
    onCustomAnchorAdd: ot(
      () => u(!0),
      []
    ),
    onCustomAnchorRemove: ot(
      () => u(!1),
      []
    ),
    modal: i
  }, n));
}, DV = "PopoverAnchor", NV = /* @__PURE__ */ pn((e, t) => {
  const { __scopePopover: n, ...r } = e, o = jo(DV, n), s = Ja(n), { onCustomAnchorAdd: i, onCustomAnchorRemove: a } = o;
  return st(() => (i(), () => a()), [
    i,
    a
  ]), /* @__PURE__ */ it(D_, an({}, s, r, {
    ref: t
  }));
}), AV = "PopoverTrigger", $V = /* @__PURE__ */ pn((e, t) => {
  const { __scopePopover: n, ...r } = e, o = jo(AV, n), s = Ja(n), i = Cs(t, o.triggerRef), a = /* @__PURE__ */ it(Yo.button, an({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": o.open,
    "aria-controls": o.contentId,
    "data-state": G_(o.open)
  }, r, {
    ref: i,
    onClick: Mo(e.onClick, o.onOpenToggle)
  }));
  return o.hasCustomAnchor ? a : /* @__PURE__ */ it(D_, an({
    asChild: !0
  }, s), a);
}), j_ = "PopoverPortal", [FV, LV] = Y_(j_, {
  forceMount: void 0
}), VV = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, s = jo(j_, t);
  return /* @__PURE__ */ it(FV, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ it(Kg, {
    present: n || s.open
  }, /* @__PURE__ */ it(Rw, {
    asChild: !0,
    container: o
  }, r)));
}, Sa = "PopoverContent", WV = /* @__PURE__ */ pn((e, t) => {
  const n = LV(Sa, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, s = jo(Sa, e.__scopePopover);
  return /* @__PURE__ */ it(Kg, {
    present: r || s.open
  }, s.modal ? /* @__PURE__ */ it(HV, an({}, o, {
    ref: t
  })) : /* @__PURE__ */ it(BV, an({}, o, {
    ref: t
  })));
}), HV = /* @__PURE__ */ pn((e, t) => {
  const n = jo(Sa, e.__scopePopover), r = et(null), o = Cs(t, r), s = et(!1);
  return st(() => {
    const i = r.current;
    if (i)
      return qL(i);
  }, []), /* @__PURE__ */ it(PV, {
    as: Bu,
    allowPinchZoom: !0
  }, /* @__PURE__ */ it(U_, an({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Mo(e.onCloseAutoFocus, (i) => {
      var a;
      i.preventDefault(), s.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: Mo(e.onPointerDownOutside, (i) => {
      const a = i.detail.originalEvent, l = a.button === 0 && a.ctrlKey === !0, c = a.button === 2 || l;
      s.current = c;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: Mo(
      e.onFocusOutside,
      (i) => i.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), BV = /* @__PURE__ */ pn((e, t) => {
  const n = jo(Sa, e.__scopePopover), r = et(!1), o = et(!1);
  return /* @__PURE__ */ it(U_, an({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (s) => {
      var i;
      if ((i = e.onCloseAutoFocus) === null || i === void 0 || i.call(e, s), !s.defaultPrevented) {
        var a;
        r.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus(), s.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (s) => {
      var i, a;
      (i = e.onInteractOutside) === null || i === void 0 || i.call(e, s), s.defaultPrevented || (r.current = !0, s.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const l = s.target;
      ((a = n.triggerRef.current) === null || a === void 0 ? void 0 : a.contains(l)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && o.current && s.preventDefault();
    }
  }));
}), U_ = /* @__PURE__ */ pn((e, t) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: s, disableOutsidePointerEvents: i, onEscapeKeyDown: a, onPointerDownOutside: l, onFocusOutside: c, onInteractOutside: u, ...d } = e, f = jo(Sa, n), h = Ja(n);
  return PF(), /* @__PURE__ */ it(IF, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: s
  }, /* @__PURE__ */ it(MF, {
    asChild: !0,
    disableOutsidePointerEvents: i,
    onInteractOutside: u,
    onEscapeKeyDown: a,
    onPointerDownOutside: l,
    onFocusOutside: c,
    onDismiss: () => f.onOpenChange(!1)
  }, /* @__PURE__ */ it(WL, an({
    "data-state": G_(f.open),
    role: "dialog",
    id: f.contentId
  }, h, d, {
    ref: t,
    style: {
      ...d.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
}), zV = "PopoverClose", YV = /* @__PURE__ */ pn((e, t) => {
  const { __scopePopover: n, ...r } = e, o = jo(zV, n);
  return /* @__PURE__ */ it(Yo.button, an({
    type: "button"
  }, r, {
    ref: t,
    onClick: Mo(
      e.onClick,
      () => o.onOpenChange(!1)
    )
  }));
}), jV = /* @__PURE__ */ pn((e, t) => {
  const { __scopePopover: n, ...r } = e, o = Ja(n);
  return /* @__PURE__ */ it(HL, an({}, o, r, {
    ref: t
  }));
});
function G_(e) {
  return e ? "open" : "closed";
}
const K_ = kV, UV = NV, q_ = $V, X_ = VV, Z_ = WV, GV = YV, KV = jV, qV = ({
  name: e,
  id: t,
  className: n,
  selected: r,
  onSelect: o,
  disablePortal: s = !1,
  fromDate: i,
  toDate: a
}) => {
  const [l, c] = b.useState(!1), { inputRef: u, inputProps: d, setInputValue: f, month: h, setMonth: p } = jn(
    {
      onSelect: o,
      selected: r,
      fromDate: i,
      toDate: a
    }
  ), g = (v) => {
    v ? (o(no(v, jn.valueFormatString)), c(!1)) : (o(""), f(""));
  }, m = s ? b.Fragment : X_;
  return /* @__PURE__ */ ee(K_, { open: l, onOpenChange: c, children: [
    /* @__PURE__ */ _(UV, { asChild: !0, children: /* @__PURE__ */ _(
      QV,
      {
        ref: u,
        icon: /* @__PURE__ */ _(q_, { className: "pointer-events-auto -m-1 rounded p-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500", children: /* @__PURE__ */ _(tI, { className: "h-5 w-5" }) }),
        className: n,
        id: t,
        name: e,
        ...d
      }
    ) }),
    /* @__PURE__ */ _(m, { children: /* @__PURE__ */ _(
      Z_,
      {
        className: "z-10",
        side: "bottom",
        sideOffset: 4,
        collisionPadding: 4,
        children: /* @__PURE__ */ _(
          a_,
          {
            mode: "single",
            className: "shadow-3",
            initialFocus: !0,
            onSelect: g,
            selected: r ? Vs(r, jn.valueFormatString, /* @__PURE__ */ new Date()) : void 0,
            month: h,
            onMonthChange: p,
            fromDate: i,
            toDate: a
          }
        )
      }
    ) })
  ] });
};
qV.displayName = "DatePicker";
const Wl = yF({
  mode: "dd/mm/yyyy",
  separator: "-"
}), { plugins: XV, ...ay } = mF(
  "dd-mm-yyyy",
  !0
), ZV = {
  ...Wl,
  plugins: XV.concat(Wl.plugins || []),
  preprocessors: [
    // Always put it BEFORE all other preprocessors
    ...ay.preprocessors,
    ...Wl.preprocessors
  ],
  postprocessors: [
    ...Wl.postprocessors,
    // Always put it AFTER all other postprocessors
    ...ay.postprocessors
  ]
}, jn = ({
  selected: e,
  onSelect: t,
  fromDate: n,
  toDate: r
}) => {
  const [o, s] = b.useState(""), [i, a] = b.useState(), l = wF({ options: ZV });
  return b.useEffect(() => {
    e && (a(Vs(e, jn.valueFormatString, /* @__PURE__ */ new Date())), s(
      no(
        Vs(e, jn.valueFormatString, /* @__PURE__ */ new Date()),
        jn.inputFormatString
      )
    ));
  }, [e]), {
    inputRef: l,
    setInputValue: s,
    month: i,
    setMonth: a,
    inputProps: {
      value: o,
      onBlur: (c) => {
        if (!c.target.value) {
          t == null || t(""), a(/* @__PURE__ */ new Date());
          return;
        }
        const u = Vs(
          c.target.value,
          jn.inputFormatString,
          /* @__PURE__ */ new Date()
        ), d = n && rh(n, u) > 0, f = r && rh(u, r) > 0;
        if (!zp(u) || d || f) {
          s(
            e ? no(
              Vs(e, jn.valueFormatString, /* @__PURE__ */ new Date()),
              jn.inputFormatString
            ) : ""
          );
          return;
        }
        t == null || t(no(u, jn.valueFormatString)), a(u);
      },
      onChange: () => {
      },
      onInput: (c) => s(c.currentTarget.value)
    }
  };
};
jn.valueFormatString = "yyyy-MM-dd";
jn.inputFormatString = "dd-MM-yyyy";
jn.monthValueFormatString = "yyyy-MM";
const QV = b.forwardRef(({ className: e, icon: t, ...n }, r) => /* @__PURE__ */ _(
  EE,
  {
    ref: r,
    containerClassName: e,
    icon: t,
    type: "text",
    placeholder: "dd-mm-yyyy",
    ...n
  }
)), hB = K_, pB = q_, gB = GV, mB = KV, bB = Oe.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ _(X_, { children: /* @__PURE__ */ _(Z_, { ...t, ref: n, children: e }) })), JV = UC, Q_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  qC,
  {
    ref: n,
    className: de("text-sm font-medium text-foundations-boldest", e),
    "data-slot": "progress-value",
    ...t
  }
));
Q_.displayName = "ProgressValue";
const J_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  GC,
  {
    ref: n,
    className: de("h-2 rounded-sm bg-foundations-subtlest", e),
    "data-slot": "progress-track",
    ...t
  }
));
J_.displayName = "ProgressTrack";
const eS = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  KC,
  {
    ref: n,
    className: de("rounded-sm bg-info-bold", e),
    "data-slot": "progress-indicator",
    ...t
  }
));
eS.displayName = "ProgressIndicator";
const vB = Object.assign(JV, {
  Label: XC,
  Track: J_,
  Indicator: eS,
  Value: Q_
}), eW = A4, tW = HC, tS = Oe.forwardRef(
  ({
    children: e,
    sideOffset: t = 4,
    align: n = "end",
    alignOffset: r = 0,
    side: o = "bottom",
    ...s
  }, i) => /* @__PURE__ */ _(BC, { children: /* @__PURE__ */ _(
    zC,
    {
      align: n,
      alignOffset: r,
      "data-slot": "popover-positioner",
      side: o,
      sideOffset: t,
      children: /* @__PURE__ */ _(jC, { ...s, ref: i, children: e })
    }
  ) })
);
tS.displayName = "PopoverPopup";
const yB = Object.assign(eW, {
  Trigger: tW,
  Popup: tS
});
function ly({
  value: e,
  defaultValue: t,
  finalValue: n,
  onChange: r = () => {
  }
}) {
  const [o, s] = Vt(
    t !== void 0 ? t : n
  ), i = (a, ...l) => {
    s(a), r == null || r(a, ...l);
  };
  return e !== void 0 ? [e, r, !0] : [o, i, !1];
}
function cy({
  prefixText: e,
  prefixIcon: t
}) {
  return e ? /* @__PURE__ */ _(ch, { className: "-my-2 mr-3 flex-shrink-0 border-r border-r-foundations-subtle py-2 pr-3 text-sm text-foundations-subtle", children: e }) : t ? /* @__PURE__ */ _(
    ch,
    {
      render: /* @__PURE__ */ _(t, {}),
      className: "-ml-1 mr-3 size-5 shrink-0 text-foundations-subtle"
    }
  ) : null;
}
function nW({
  mode: e,
  id: t,
  label: n,
  placeholder: r = "Search",
  error: o,
  className: s,
  selectedText: i,
  prefixText: a,
  prefixIcon: l,
  renderTrigger: c,
  onFocus: u,
  onBlur: d,
  fieldRef: f
}) {
  const h = !!(a || l);
  return e === "popup" ? /* @__PURE__ */ ee(
    lh,
    {
      ref: f,
      className: de(
        "group flex w-full select-none items-center rounded-md border border-foundations-bold bg-foundations-default py-2 pl-3 pr-2 text-left text-sm text-foundations-subtle focus:border-info-bold focus:shadow-3 focus:outline-none focus:ring-1 focus:ring-info-bold disabled:cursor-not-allowed disabled:opacity-60 aria-expanded:border-info-bold aria-expanded:shadow-3 aria-expanded:ring-1 aria-expanded:ring-info-bold",
        o && "border-danger-bold focus:border-danger-bold focus:ring-danger-bold",
        s
      ),
      "aria-label": n,
      onFocus: u,
      onBlur: d,
      render: c,
      children: [
        /* @__PURE__ */ _(cy, { prefixText: a, prefixIcon: l }),
        /* @__PURE__ */ _(
          "span",
          {
            className: de(
              "min-w-0 flex-1 truncate text-sm text-foundations-subtle",
              i && "text-foundations-bolder"
            ),
            children: i || n
          }
        ),
        /* @__PURE__ */ _(Rb, { className: "ml-2 size-5 shrink-0 transition-transform group-data-[popup-open]:rotate-180 text-foundations-subtle" })
      ]
    }
  ) : /* @__PURE__ */ ee(
    Zw,
    {
      className: de(
        "relative flex w-full items-center rounded-md border border-foundations-bold bg-foundations-default focus-within:border-info-bold focus-within:shadow-3 focus-within:ring-1 focus-within:ring-info-bold data-[disabled]:cursor-not-allowed data-[disabled]:opacity-60",
        h && "pl-3",
        o && "border-danger-bold focus-within:border-danger-bold focus-within:ring-danger-bold",
        s
      ),
      children: [
        /* @__PURE__ */ _(cy, { prefixText: a, prefixIcon: l }),
        /* @__PURE__ */ _(
          ug,
          {
            ref: f,
            id: t,
            placeholder: r,
            onFocus: u,
            onBlur: d,
            className: de(
              "w-full rounded-md border-0 bg-transparent py-2 pr-8 text-sm text-foundations-bolder outline-none placeholder:text-foundations-subtle focus:ring-0",
              h ? "pl-0" : "pl-3"
            )
          }
        ),
        /* @__PURE__ */ _("div", { className: "absolute inset-y-0 right-0 flex items-center justify-center pr-1.5 text-foundations-subtle", children: /* @__PURE__ */ _(
          lh,
          {
            className: "flex items-center justify-center transition-transform data-[popup-open]:rotate-180",
            "aria-label": "Open popup",
            children: /* @__PURE__ */ _(Rb, { className: "size-5" })
          }
        ) })
      ]
    }
  );
}
function rW({
  id: e,
  label: t,
  placeholder: n,
  inputRef: r,
  onClose: o
}) {
  return /* @__PURE__ */ ee("div", { className: "border-b border-foundations-subtle p-4 pt-3", children: [
    /* @__PURE__ */ ee("div", { className: "flex items-center justify-between space-x-2", children: [
      /* @__PURE__ */ _(
        "label",
        {
          htmlFor: e,
          title: t,
          className: "select-none truncate font-medium text-foundations-bolder",
          children: t
        }
      ),
      /* @__PURE__ */ _(
        "button",
        {
          type: "button",
          onClick: o,
          "aria-label": "Close",
          className: "shrink-0 text-foundations-subtler hover:text-info focus:text-info focus:outline-none",
          children: /* @__PURE__ */ _(Tp, { className: "h-5 w-5" })
        }
      )
    ] }),
    /* @__PURE__ */ ee("div", { className: "relative mt-3", children: [
      /* @__PURE__ */ _(
        ug,
        {
          ref: r,
          id: e,
          placeholder: n,
          className: "w-full rounded-md border border-foundations-bold bg-foundations-default py-1.5 pl-10 pr-2 text-foundations-bolder placeholder:text-foundations-subtle focus:border-info-bold focus:ring-1 focus:ring-info-bold"
        }
      ),
      /* @__PURE__ */ _("div", { className: "pointer-events-none absolute inset-y-0 left-0 inline-flex items-center pl-2", children: /* @__PURE__ */ _(cI, { className: "h-5 w-5 text-foundations-subtler" }) })
    ] })
  ] });
}
function Fi(e, t, n) {
  let r = n.initialDeps ?? [], o;
  return () => {
    var s, i, a, l;
    let c;
    n.key && ((s = n.debug) != null && s.call(n)) && (c = Date.now());
    const u = e();
    if (!(u.length !== r.length || u.some((h, p) => r[p] !== h)))
      return o;
    r = u;
    let f;
    if (n.key && ((i = n.debug) != null && i.call(n)) && (f = Date.now()), o = t(...u), n.key && ((a = n.debug) != null && a.call(n))) {
      const h = Math.round((Date.now() - c) * 100) / 100, p = Math.round((Date.now() - f) * 100) / 100, g = p / 16, m = (v, y) => {
        for (v = String(v); v.length < y; )
          v = " " + v;
        return v;
      };
      console.info(
        `%c⏱ ${m(p, 5)} /${m(h, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * g, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (l = n == null ? void 0 : n.onChange) == null || l.call(n, o), o;
  };
}
function ff(e, t) {
  if (e === void 0)
    throw new Error(`Unexpected undefined${t ? `: ${t}` : ""}`);
  return e;
}
const oW = (e, t) => Math.abs(e - t) < 1, sW = (e, t, n) => {
  let r;
  return function(...o) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, o), n);
  };
}, iW = (e) => e, aW = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let o = t; o <= n; o++)
    r.push(o);
  return r;
}, lW = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const o = (i) => {
    const { width: a, height: l } = i;
    t({ width: Math.round(a), height: Math.round(l) });
  };
  if (o(n.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const s = new r.ResizeObserver((i) => {
    const a = i[0];
    if (a != null && a.borderBoxSize) {
      const l = a.borderBoxSize[0];
      if (l) {
        o({ width: l.inlineSize, height: l.blockSize });
        return;
      }
    }
    o(n.getBoundingClientRect());
  });
  return s.observe(n, { box: "border-box" }), () => {
    s.unobserve(n);
  };
}, uy = {
  passive: !0
}, cW = typeof window > "u" ? !0 : "onscrollend" in window, uW = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  let o = 0;
  const s = cW ? () => {
  } : sW(
    r,
    () => {
      t(o, !1);
    },
    e.options.isScrollingResetDelay
  ), i = (c) => () => {
    o = n[e.options.horizontal ? "scrollLeft" : "scrollTop"], s(), t(o, c);
  }, a = i(!0), l = i(!1);
  return l(), n.addEventListener("scroll", a, uy), n.addEventListener("scrollend", l, uy), () => {
    n.removeEventListener("scroll", a), n.removeEventListener("scrollend", l);
  };
}, dW = (e, t, n) => {
  if (t != null && t.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, fW = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var o, s;
  const i = e + t;
  (s = (o = r.scrollElement) == null ? void 0 : o.scrollTo) == null || s.call(o, {
    [r.options.horizontal ? "left" : "top"]: i,
    behavior: n
  });
};
class hW {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((o) => {
        o.forEach((s) => {
          this._measureElement(s.target, s);
        });
      }));
      return {
        disconnect: () => {
          var o;
          return (o = r()) == null ? void 0 : o.disconnect();
        },
        observe: (o) => {
          var s;
          return (s = r()) == null ? void 0 : s.observe(o, { box: "border-box" });
        },
        unobserve: (o) => {
          var s;
          return (s = r()) == null ? void 0 : s.unobserve(o);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, o]) => {
        typeof o > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: iW,
        rangeExtractor: aW,
        onChange: () => {
        },
        measureElement: dW,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        ...n
      };
    }, this.notify = (n, r) => {
      var o, s;
      const { startIndex: i, endIndex: a } = this.range ?? {
        startIndex: void 0,
        endIndex: void 0
      }, l = this.calculateRange();
      (n || i !== (l == null ? void 0 : l.startIndex) || a !== (l == null ? void 0 : l.endIndex)) && ((s = (o = this.options).onChange) == null || s.call(o, this, r));
    }, this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.observer.disconnect(), this.elementsCache.clear();
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.notify(!1, !1);
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (o) => {
            this.scrollRect = o, this.notify(!1, !1);
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (o, s) => {
            this.scrollAdjustments = 0, this.scrollDirection = s ? this.getScrollOffset() < o ? "forward" : "backward" : null, this.scrollOffset = o;
            const i = this.isScrolling;
            this.isScrolling = s, this.notify(i !== s, s);
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
      for (let i = r - 1; i >= 0; i--) {
        const a = n[i];
        if (o.has(a.lane))
          continue;
        const l = s.get(
          a.lane
        );
        if (l == null || a.end > l.end ? s.set(a.lane, a) : a.end < l.end && o.set(a.lane, !0), o.size === this.options.lanes)
          break;
      }
      return s.size === this.options.lanes ? Array.from(s.values()).sort((i, a) => i.end === a.end ? i.index - a.index : i.end - a.end)[0] : void 0;
    }, this.getMeasurementOptions = Fi(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, o, s, i) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: o,
        getItemKey: s,
        enabled: i
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Fi(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: o, getItemKey: s, enabled: i }, a) => {
        var l;
        if (!i)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((d) => {
          this.itemSizeCache.set(d.key, d.size);
        }));
        const c = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const u = this.measurementsCache.slice(0, c);
        for (let d = c; d < n; d++) {
          let f = (l = this.measurementsCache[d]) == null ? void 0 : l.measureElement;
          f || (f = (C) => {
            const w = s(d), E = this.elementsCache.get(w);
            if (!C) {
              E && (this.observer.unobserve(E), this.elementsCache.delete(w));
              return;
            }
            E !== C && (E && this.observer.unobserve(E), this.observer.observe(C), this.elementsCache.set(w, C)), C.isConnected && this.resizeItem(
              d,
              this.options.measureElement(C, void 0, this)
            );
          });
          const h = s(d), p = this.options.lanes === 1 ? u[d - 1] : this.getFurthestMeasurement(u, d), g = p ? p.end + this.options.gap : r + o, m = a.get(h), v = typeof m == "number" ? m : this.options.estimateSize(d), y = g + v, x = p ? p.lane : d % this.options.lanes;
          u[d] = {
            index: d,
            start: g,
            size: v,
            end: y,
            key: h,
            lane: x,
            measureElement: f
          };
        }
        return this.measurementsCache = u, u;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Fi(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (n, r, o) => this.range = n.length > 0 && r > 0 ? pW({
        measurements: n,
        outerSize: r,
        scrollOffset: o
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = Fi(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (n, r, o, s) => r === null ? [] : n({
        startIndex: r.startIndex,
        endIndex: r.endIndex,
        overscan: o,
        count: s
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, o = n.getAttribute(r);
      return o ? parseInt(o, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const o = this.indexFromElement(n), s = this.getMeasurements()[o];
      if (!s || !n.isConnected) {
        this.elementsCache.forEach((a, l) => {
          a === n && (this.observer.unobserve(n), this.elementsCache.delete(l));
        });
        return;
      }
      const i = this.elementsCache.get(s.key);
      i !== n && (i && this.observer.unobserve(i), this.observer.observe(n), this.elementsCache.set(s.key, n)), this.resizeItem(o, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const o = this.getMeasurements()[n];
      if (!o)
        return;
      const s = this.itemSizeCache.get(o.key) ?? o.size, i = r - s;
      i !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(o, i, this) : o.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", i), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += i,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(o.index), this.itemSizeCache = new Map(this.itemSizeCache.set(o.key, r)), this.notify(!0, !1));
    }, this.measureElement = (n) => {
      n && this._measureElement(n, void 0);
    }, this.getVirtualItems = Fi(
      () => [this.getIndexes(), this.getMeasurements()],
      (n, r) => {
        const o = [];
        for (let s = 0, i = n.length; s < i; s++) {
          const a = n[s], l = r[a];
          o.push(l);
        }
        return o;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return ff(
          r[nS(
            0,
            r.length - 1,
            (o) => ff(r[o]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r) => {
      const o = this.getSize(), s = this.getScrollOffset();
      r === "auto" && (n <= s ? r = "start" : n >= s + o ? r = "end" : r = "start"), r === "start" ? n = n : r === "end" ? n = n - o : r === "center" && (n = n - o / 2);
      const i = this.options.horizontal ? "scrollWidth" : "scrollHeight", l = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[i] : this.scrollElement[i] : 0) - o;
      return Math.max(Math.min(l, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const o = this.getMeasurements()[n];
      if (!o)
        return;
      const s = this.getSize(), i = this.getScrollOffset();
      if (r === "auto")
        if (o.end >= i + s - this.options.scrollPaddingEnd)
          r = "end";
        else if (o.start <= i + this.options.scrollPaddingStart)
          r = "start";
        else
          return [i, r];
      const a = r === "end" ? o.end + this.options.scrollPaddingEnd : o.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(a, r), r];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: r = "start", behavior: o } = {}) => {
      this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: o
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: o } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const s = this.getOffsetForIndex(n, r);
      if (!s)
        return;
      const [i, a] = s;
      this._scrollToOffset(i, { adjustments: void 0, behavior: o }), o !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [c] = ff(
            this.getOffsetForIndex(n, a)
          );
          oW(c, this.getScrollOffset()) || this.scrollToIndex(n, { align: a, behavior: o });
        } else
          this.scrollToIndex(n, { align: a, behavior: o });
      }));
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let o;
      return r.length === 0 ? o = this.options.paddingStart : o = this.options.lanes === 1 ? ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0 : Math.max(
        ...r.slice(-this.options.lanes).map((s) => s.end)
      ), o - this.options.scrollMargin + this.options.paddingEnd;
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: o
    }) => {
      this.options.scrollToFn(n, { behavior: o, adjustments: r }, this);
    }, this.measure = () => {
      var n, r;
      this.itemSizeCache = /* @__PURE__ */ new Map(), (r = (n = this.options).onChange) == null || r.call(n, this, !1);
    }, this.setOptions(t);
  }
}
const nS = (e, t, n, r) => {
  for (; e <= t; ) {
    const o = (e + t) / 2 | 0, s = n(o);
    if (s < r)
      e = o + 1;
    else if (s > r)
      t = o - 1;
    else
      return o;
  }
  return e > 0 ? e - 1 : 0;
};
function pW({
  measurements: e,
  outerSize: t,
  scrollOffset: n
}) {
  const r = e.length - 1, s = nS(0, r, (a) => e[a].start, n);
  let i = s;
  for (; i < r && e[i].end < n + t; )
    i++;
  return { startIndex: s, endIndex: i };
}
const gW = typeof document < "u" ? b.useLayoutEffect : b.useEffect;
function mW(e) {
  const t = b.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (o, s) => {
      var i;
      s ? Sh(t) : t(), (i = e.onChange) == null || i.call(e, o, s);
    }
  }, [r] = b.useState(
    () => new hW(n)
  );
  return r.setOptions(n), b.useEffect(() => r._didMount(), []), gW(() => r._willUpdate()), r;
}
function bW(e) {
  return mW({
    observeElementRect: lW,
    observeElementOffset: uW,
    scrollToFn: fW,
    ...e
  });
}
function vW(e, t, n = []) {
  b.useEffect(() => {
    const r = setTimeout(() => {
      e();
    }, t);
    return () => {
      clearTimeout(r);
    };
  }, [t, ...n]);
}
const ad = "__SELECT_ALL__", rS = "Select All", yW = 'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
function xW(e) {
  return b.useMemo(() => {
    if (e)
      return (t) => {
        if (t.key !== "Tab" || t.defaultPrevented)
          return;
        const n = Array.from(
          t.currentTarget.querySelectorAll(yW)
        ).filter((s) => s.tabIndex !== -1 && s.getClientRects().length > 0);
        if (n.length === 0)
          return;
        const r = n.indexOf(
          document.activeElement
        );
        let o;
        r === -1 ? o = t.shiftKey ? n.length - 1 : 0 : o = t.shiftKey ? (r - 1 + n.length) % n.length : (r + 1) % n.length, t.preventDefault(), n[o].focus();
      };
  }, [e]);
}
function wW({
  ref: e,
  onBlur: t
}) {
  const n = b.useRef(null), r = b.useRef(null), o = ar(n, e), s = b.useCallback(
    (i) => {
      var l, c;
      const a = i.relatedTarget;
      a && ((l = r.current) != null && l.contains(a) || (c = n.current) != null && c.contains(a)) || t == null || t(i);
    },
    [t]
  );
  return { fieldRef: o, popupRef: r, handleBlur: s };
}
const Un = (e) => Array.isArray(e) ? e[0] : e;
function CW(e) {
  return b.useCallback(
    (t) => {
      const n = t == null ? void 0 : t[1];
      return String(
        e && n && typeof n == "object" ? n[e] ?? "" : n ?? ""
      );
    },
    [e]
  );
}
function EW(e) {
  const {
    isLazy: t,
    isOpen: n,
    query: r,
    debounceMs: o,
    dependencies: s,
    disableEmptySearch: i
  } = e, a = xa(e.getOptions), l = xa(e.parseGetOptionsError), [c, u] = b.useState([]), [d, f] = b.useState(!1), [h, p] = b.useState(null);
  vW(
    () => {
      if (!(!t || !n)) {
        if (i && r.trim() === "") {
          u([]), f(!1), p(null);
          return;
        }
        f(!0), a(r).then((m) => {
          u(m), p(null);
        }).catch((m) => {
          const v = l(m);
          p(v ?? (typeof m == "string" ? m : null)), u([]);
        }).finally(() => f(!1));
      }
    },
    o,
    [r, n, t, i, ...s]
  );
  const g = b.useCallback(
    (m) => {
      t && f(!(i && m.trim() === ""));
    },
    [t, i]
  );
  return { lazyOptions: c, isLoading: d, errorMsg: h, markLazyLoading: g };
}
function _W(e) {
  const {
    multiple: t,
    withConfirmation: n,
    resettable: r,
    selected: o,
    onSelect: s,
    staticOptions: i,
    getOptionLabel: a,
    setIsOpen: l
  } = e, c = t ? o ?? [] : o ? [o] : [], [u, d] = b.useState(c), f = n ? u : c, h = n ? f[0] ?? null : o ?? null, p = b.useCallback(
    (S) => f.some(
      (O) => Un(O) === Un(S)
    ),
    [f]
  ), g = t && i.length > 0 && f.length === i.length, m = t && f.length > 0 && !g, v = t ? c.map(a).join(", ") : o ? a(o) : "", y = (S) => {
    n ? d(S) : s == null || s(S);
  }, x = (S, O) => {
    if (O.reason === "input-clear" && !S && !r)
      return;
    if (!t) {
      const T = S, P = h, I = r && T && P && Un(T) === Un(P) ? null : T;
      n ? d(I ? [I] : []) : s == null || s(I);
      return;
    }
    const M = S ?? [];
    if (M.some((T) => Un(T) === ad)) {
      y(g ? [] : i);
      return;
    }
    y(M);
  }, C = () => {
    s == null || s(t ? u : u[0] ?? null), l(!1);
  }, w = () => {
    r && d([]);
  }, E = b.useCallback(() => {
    n && d(c);
  }, [n, c]);
  return {
    committedSelected: c,
    selectedList: f,
    singleSelected: h,
    isOptionSelected: p,
    allSelected: g,
    someSelected: m,
    selectedText: v,
    handleValueChange: x,
    handleApply: C,
    handleReset: w,
    syncBuffer: E
  };
}
function SW(e) {
  const {
    multiple: t,
    isLazy: n,
    disableSelectAll: r,
    staticOptions: o,
    lazyOptions: s,
    query: i,
    getOptionLabel: a
  } = e, [l, c] = b.useState([]), u = n ? s : o, d = b.useMemo(() => {
    if (!t)
      return u;
    const p = new Set(l.map(Un));
    if (n) {
      const g = i.trim().toLowerCase(), m = g ? l.filter(
        (y) => a(y).toLowerCase().includes(g)
      ) : l, v = s.filter(
        (y) => !p.has(Un(y))
      );
      return [...m, ...v];
    }
    return [...o].sort((g, m) => {
      const v = p.has(Un(g)), y = p.has(Un(m));
      return v === y ? 0 : v ? -1 : 1;
    });
  }, [
    t,
    n,
    u,
    o,
    s,
    l,
    i,
    a
  ]), f = t && !r && !n && o.length > 0 && i.trim() === "";
  return { items: b.useMemo(() => f ? [
    [ad, rS],
    ...d
  ] : d, [f, d]), captureSnapshot: c };
}
function OW({
  virtualizerRef: e,
  multiple: t,
  optionsCount: n,
  allSelected: r,
  someSelected: o,
  isOptionSelected: s,
  getOptionLabel: i,
  renderOption: a,
  isItemDisabled: l,
  currentSelection: c
}) {
  const u = n4(), d = b.useRef(null), f = bW({
    // Intentionally not gated on `isOpen`: this list only mounts while the popup
    // is open or animating out, and disabling the virtualizer mid-close empties
    // the rows for the duration of the exit animation (a visible flash).
    count: u.length,
    getScrollElement: () => d.current,
    estimateSize: b.useCallback(() => 36, []),
    overscan: 5,
    paddingStart: 4,
    paddingEnd: 4,
    scrollPaddingEnd: 4,
    scrollPaddingStart: 4,
    gap: 2,
    getItemKey: b.useCallback(
      (p) => {
        var g;
        return ((g = u[p]) == null ? void 0 : g[0]) ?? p;
      },
      [u]
    )
  });
  b.useImperativeHandle(e, () => f, [f]);
  const h = f.getTotalSize();
  return u.length ? /* @__PURE__ */ _(
    "div",
    {
      role: "presentation",
      ref: d,
      className: "min-h-0 flex-1 overflow-y-auto overscroll-contain scroll-py-1",
      children: /* @__PURE__ */ _("div", { role: "presentation", className: "relative w-full", style: { height: h }, children: f.getVirtualItems().map((p) => {
        const g = u[p.index];
        if (!g)
          return null;
        const m = Un(g) === ad, v = !m && !!(l != null && l(g, p.index, c));
        return /* @__PURE__ */ ee(
          iC,
          {
            index: p.index,
            "data-index": p.index,
            ref: f.measureElement,
            value: g,
            disabled: v,
            "aria-setsize": u.length,
            "aria-posinset": p.index + 1,
            className: de(
              "group absolute inset-x-1 flex cursor-default select-none items-center justify-between gap-2 rounded p-2 text-sm text-foundations-bolder outline-none data-[disabled]:cursor-not-allowed data-[disabled]:text-foundations-subtler",
              t ? "data-[highlighted]:bg-foundations-subtlest" : "data-[selected]:bg-info-subtler data-[selected]:text-info data-[highlighted]:bg-info-bold data-[highlighted]:text-foundations-inverse data-[highlighted]:data-[selected]:bg-info-bold data-[highlighted]:data-[selected]:text-foundations-inverse"
            ),
            style: {
              top: 0,
              transform: `translateY(${p.start}px)`
            },
            children: [
              m ? /* @__PURE__ */ _("span", { className: "min-w-0 flex-1 truncate text-xs font-medium text-foundations-subtle", children: `${rS} (${n})` }) : a ? a(g[1]) : /* @__PURE__ */ ee(In, { children: [
                /* @__PURE__ */ _("span", { className: "min-w-0 flex-1", children: i(g) }),
                !t && /* @__PURE__ */ _(oS, {})
              ] }),
              t && /* @__PURE__ */ _(
                TE,
                {
                  tabIndex: -1,
                  readOnly: !0,
                  checked: m ? r : s(g),
                  isIndeterminate: m ? o : !1,
                  className: "pointer-events-none flex-shrink-0 select-none"
                }
              )
            ]
          },
          p.key
        );
      }) })
    }
  ) : null;
}
function oS({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ _(
    fC,
    {
      className: de("flex-shrink-0", e),
      ...n,
      children: t ?? /* @__PURE__ */ _(ys, { className: "size-5" })
    }
  );
}
function MW(e, t) {
  const {
    selected: n,
    onSelect: r,
    label: o,
    name: s,
    id: i,
    placeholder: a = "Search",
    className: l,
    disabled: c,
    error: u,
    renderOption: d,
    renderTrigger: f,
    displayedValueKey: h,
    filterBy: p,
    isItemDisabled: g,
    mode: m = "inline",
    resettable: v = !0,
    multiple: y = !1,
    prefixText: x,
    prefixIcon: C,
    ExtraBodyContent: w,
    ExtraFooterAction: E,
    emptyState: S,
    disableEmptySearch: O = !1,
    side: M,
    align: T = "start",
    sideOffset: P = 6,
    alignOffset: I,
    useAvailableHeight: R = !1,
    popupClassName: D,
    onFocus: k,
    onBlur: $
  } = e, L = e.multiple ? !!e.disableSelectAll : !0, A = !!e.withConfirmation, F = typeof e.getOptions == "function", N = e.options ?? [], [V, K] = ly({
    value: e.isOpen,
    defaultValue: !1,
    onChange: e.onOpenChange
  }), [Y, U] = ly({
    value: e.searchTerm,
    defaultValue: "",
    onChange: e.onSearch
  }), j = b.useRef(null), { fieldRef: H, popupRef: q, handleBlur: B } = wW({
    ref: t,
    onBlur: $
  }), X = b.useRef(null), te = b.useId(), J = i ?? te, G = CW(h), { lazyOptions: ne, isLoading: Q, errorMsg: re, markLazyLoading: fe } = EW({
    isLazy: F,
    isOpen: V,
    query: Y,
    debounceMs: e.debounceMs ?? 500,
    dependencies: e.dependencies ?? [],
    disableEmptySearch: O,
    getOptions: e.getOptions,
    parseGetOptionsError: e.parseGetOptionsError
  }), {
    committedSelected: le,
    selectedList: Ee,
    singleSelected: se,
    isOptionSelected: _e,
    allSelected: xe,
    someSelected: ge,
    selectedText: ae,
    handleValueChange: W,
    handleApply: Z,
    handleReset: me,
    syncBuffer: ie
  } = _W({
    multiple: y,
    withConfirmation: A,
    resettable: v,
    selected: n,
    onSelect: r,
    staticOptions: N,
    getOptionLabel: G,
    setIsOpen: K
  });
  b.useEffect(() => {
    m !== "inline" || V || U(se ? G(se) : "");
  }, [m, V, se, G]);
  const { items: oe, captureSnapshot: he } = SW({
    multiple: y,
    isLazy: F,
    disableSelectAll: L,
    staticOptions: N,
    lazyOptions: ne,
    query: Y,
    getOptionLabel: G
  }), Re = (Be, nt) => {
    !Be && A && !y && (nt == null ? void 0 : nt.reason) === "item-press" || (K(Be), Be && (fe(Y), A && ie(), y && he(le)));
  }, Ae = (Be) => {
    Be || !(y || A) || (U(""), ie());
  }, Ue = (Be, nt) => {
    y && (nt == null ? void 0 : nt.reason) === "input-clear" || (U(Be), fe(Be));
  }, Ke = xW(A);
  return /* @__PURE__ */ ee(
    a4,
    {
      open: V,
      onOpenChange: Re,
      onOpenChangeComplete: Ae,
      multiple: y,
      virtualized: !0,
      onItemHighlighted: (Be, { reason: nt, index: at }) => {
        const Wt = X.current;
        if (at < 0 || !Wt)
          return;
        const Mt = at === 0, Bt = at === Wt.options.count - 1;
        (nt === "none" || nt === "keyboard" && (Mt || Bt)) && queueMicrotask(
          () => Wt.scrollToIndex(at, { align: Bt ? "start" : "end" })
        );
      },
      items: oe,
      value: y ? Ee : se,
      onValueChange: W,
      inputValue: Y,
      onInputValueChange: Ue,
      filter: F ? null : p ? (Be, nt) => {
        const at = Be;
        return Un(at) === ad ? !0 : p(nt, at[1]);
      } : void 0,
      itemToStringLabel: G,
      itemToStringValue: (Be) => Be[0],
      isItemEqualToValue: (Be, nt) => Un(Be) === Un(nt),
      disabled: c,
      name: s,
      children: [
        /* @__PURE__ */ _(
          nW,
          {
            mode: m,
            id: J,
            label: o,
            placeholder: a,
            error: u,
            className: l,
            selectedText: ae,
            prefixText: x,
            prefixIcon: C,
            renderTrigger: f,
            onFocus: k,
            onBlur: B,
            fieldRef: H
          }
        ),
        /* @__PURE__ */ _(eC, { children: /* @__PURE__ */ _(
          tC,
          {
            className: "z-50 outline-none",
            side: M,
            align: T,
            sideOffset: P,
            alignOffset: I,
            children: /* @__PURE__ */ ee(
              nC,
              {
                ref: q,
                initialFocus: m === "popup" ? j : void 0,
                onKeyDown: Ke,
                onBlur: B,
                className: de(
                  "flex w-[var(--anchor-width)] min-w-[min(12rem,var(--available-width))] max-w-[var(--available-width)] origin-[var(--transform-origin)] flex-col overflow-hidden rounded-md border border-foundations-subtle bg-foundations-default text-foundations-bolder shadow-2 transition-[transform,opacity] duration-100 data-[ending-style]:scale-95 data-[starting-style]:scale-95 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0",
                  R ? "max-h-[var(--available-height)]" : "max-h-[min(26rem,var(--available-height))]",
                  D
                ),
                children: [
                  m === "popup" && /* @__PURE__ */ _(
                    rW,
                    {
                      id: J,
                      label: o,
                      placeholder: a,
                      inputRef: j,
                      onClose: () => K(!1)
                    }
                  ),
                  w,
                  F && O && Y.trim() === "" ? /* @__PURE__ */ ee("div", { className: "my-4 flex flex-col items-center gap-4", children: [
                    /* @__PURE__ */ _(v0, {}),
                    /* @__PURE__ */ _("p", { className: "text-center text-sm text-foundations-subtle", children: "Start typing to search" })
                  ] }) : F && Q ? /* @__PURE__ */ _("div", { className: "my-4 flex flex-col items-center", children: /* @__PURE__ */ _(v0, {}) }) : /* @__PURE__ */ ee(In, { children: [
                    /* @__PURE__ */ _(aC, { children: S && !re ? S : /* @__PURE__ */ ee("div", { className: "my-4 flex flex-col items-center gap-4", children: [
                      /* @__PURE__ */ _(c9, {}),
                      /* @__PURE__ */ _("p", { className: "text-center text-sm text-foundations-subtle", children: re || "No matching data available" })
                    ] }) }),
                    /* @__PURE__ */ _(Jw, { className: "flex min-h-0 flex-1 flex-col p-1 outline-none data-[empty]:p-0", children: /* @__PURE__ */ _(
                      OW,
                      {
                        virtualizerRef: X,
                        multiple: y,
                        optionsCount: N.length,
                        allSelected: xe,
                        someSelected: ge,
                        isOptionSelected: _e,
                        getOptionLabel: G,
                        renderOption: d,
                        isItemDisabled: g,
                        currentSelection: y ? Ee : se
                      }
                    ) })
                  ] }),
                  A && /* @__PURE__ */ ee("div", { className: "border-t border-t-foundations-subtle px-6 py-4", children: [
                    E,
                    /* @__PURE__ */ ee("div", { className: "flex gap-4", children: [
                      /* @__PURE__ */ _(
                        uc,
                        {
                          variant: "secondary",
                          className: "flex-1",
                          disabled: !v,
                          onClick: me,
                          children: "Reset"
                        }
                      ),
                      /* @__PURE__ */ _(uc, { className: "flex-1", onClick: Z, children: "Apply" })
                    ] })
                  ] })
                ]
              }
            )
          }
        ) })
      ]
    }
  );
}
const TW = b.forwardRef(MW), xB = Object.assign(TW, {
  ItemIndicator: oS
}), RW = b.forwardRef(
  ({
    savedFileName: e = null,
    multiple: t = !1,
    accept: n,
    showAcceptedFilesHint: r = !0,
    label: o = "",
    hint: s = "",
    uploadingProgress: i = 0,
    uploadedFiles: a = [],
    onFilesChange: l,
    withUploadConfirmation: c = !1,
    onUploadConfirmed: u,
    isUploadButtonDisabled: d = !1,
    isUploadButtonLoading: f = !1,
    isUploadButtonTooltipDisabled: h = !1,
    uploadButtonTooltipText: p = ""
  }, g) => {
    var M;
    const m = i > 0 && i < 100, v = b.useMemo(
      () => `UploadFiles${o.split(" ").join("")}`,
      [o]
    ), [y, x] = b.useState(!1), C = b.useRef(null), w = a.length > 0 || !!e, E = b.useCallback(
      (T) => {
        var P;
        if (x(!1), (P = T.target.files) != null && P.length) {
          if (m)
            return;
          l([...T.target.files]);
        }
      },
      [l]
    ), S = b.useCallback(
      (T) => {
        T.preventDefault(), x(!0);
      },
      []
    ), O = b.useCallback(
      (T) => {
        T.preventDefault(), x(!1);
      },
      []
    );
    return /* @__PURE__ */ ee(In, { children: [
      o && /* @__PURE__ */ ee(
        "label",
        {
          htmlFor: v,
          className: "mb-2 inline-flex items-center gap-2",
          children: [
            /* @__PURE__ */ _("span", { className: "block text-sm font-medium text-foundations-bold", children: o }),
            s && /* @__PURE__ */ _(wb, { delay: 0, children: /* @__PURE__ */ ee(Lt, { children: [
              /* @__PURE__ */ _(
                Lt.Trigger,
                {
                  render: /* @__PURE__ */ _("div", { className: "flex h-6 w-6 items-center justify-center rounded-full bg-neutral-100" }),
                  children: /* @__PURE__ */ _(
                    aI,
                    {
                      width: 16,
                      height: 16,
                      className: " text-foundations-subtler"
                    }
                  )
                }
              ),
              /* @__PURE__ */ _(
                Lt.Popup,
                {
                  variant: "dark",
                  side: "top",
                  size: "sm",
                  collisionPadding: 4,
                  children: s
                }
              )
            ] }) })
          ]
        }
      ),
      /* @__PURE__ */ ee("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ ee(
          "div",
          {
            ref: g,
            className: de(
              "relative flex w-full items-center justify-center gap-2 overflow-hidden rounded border border-dashed border-neutral-300 p-4 text-foundations-subtle transition-all duration-200",
              {
                "border-blue-500 bg-neutral-50 text-blue-500": y,
                "pointer-events-none border-solid border-blue-200": m,
                "pointer-events-none border-solid border-green-200": w,
                "p-2": c
              }
            ),
            children: [
              m ? /* @__PURE__ */ ee(In, { children: [
                /* @__PURE__ */ _(
                  Dw,
                  {
                    variant: "primary",
                    value: i,
                    size: 26,
                    strokeWidth: 4,
                    strokeClassName: "stroke-neutral-800",
                    strokeLinecap: "square"
                  }
                ),
                /* @__PURE__ */ ee("p", { className: "p-1 text-xs font-medium", children: [
                  "Uploading (",
                  i,
                  "%)"
                ] }),
                /* @__PURE__ */ _(
                  "div",
                  {
                    className: "absolute bottom-0 left-0 h-[5px] bg-blue-500",
                    style: { width: `${i}%` }
                  }
                )
              ] }) : /* @__PURE__ */ _(In, { children: w ? /* @__PURE__ */ ee(In, { children: [
                /* @__PURE__ */ _("div", { className: "flex h-6 w-6 items-center justify-center rounded-full bg-green-100", children: /* @__PURE__ */ _(
                  ys,
                  {
                    width: 16,
                    height: 16,
                    className: "text-green-500"
                  }
                ) }),
                /* @__PURE__ */ _("p", { className: "p-1 text-xs font-medium", children: ((M = a[0]) == null ? void 0 : M.name) || e })
              ] }) : /* @__PURE__ */ ee(In, { children: [
                /* @__PURE__ */ _(
                  kb,
                  {
                    width: 20,
                    height: 20,
                    className: "pointer-events-none text-foundations-subtle"
                  }
                ),
                /* @__PURE__ */ ee("p", { className: "pointer-events-none p-1 text-xs font-medium", children: [
                  "Drop file or click here to",
                  " ",
                  c ? "browse" : "upload"
                ] })
              ] }) }),
              /* @__PURE__ */ _(
                "input",
                {
                  id: v,
                  className: "absolute inset-0 cursor-pointer opacity-0",
                  ref: C,
                  type: "file",
                  accept: n,
                  multiple: t,
                  onChange: E,
                  onDragEnter: S,
                  onDragLeave: O
                }
              )
            ]
          }
        ),
        c && /* @__PURE__ */ _(wb, { children: /* @__PURE__ */ ee(
          Lt,
          {
            disabled: !p || h,
            children: [
              /* @__PURE__ */ _(
                Lt.Trigger,
                {
                  render: /* @__PURE__ */ _(
                    uc,
                    {
                      className: "disabled:pointer-events-auto",
                      disabled: d,
                      isLoading: f,
                      onClick: () => u == null ? void 0 : u(a)
                    }
                  ),
                  children: "Upload"
                }
              ),
              /* @__PURE__ */ _(Lt.Popup, { children: p })
            ]
          }
        ) })
      ] }),
      n && r && /* @__PURE__ */ ee("p", { className: "mt-[6px] text-xs text-foundations-subtle", children: [
        "Supported file types: ",
        n.split(",").join(" ")
      ] }),
      w && /* @__PURE__ */ ee(
        "button",
        {
          type: "button",
          className: "flex items-center justify-center gap-2 px-4 py-[6px] text-foundations-subtle",
          onClick: () => {
            var T;
            return (T = C.current) == null ? void 0 : T.click();
          },
          children: [
            /* @__PURE__ */ _(kb, { width: 20, height: 20 }),
            /* @__PURE__ */ _("span", { className: "text-xs font-medium", children: c ? "Browse files" : "Re-upload file" })
          ]
        }
      )
    ] });
  }
);
RW.displayName = "UploadArea";
const PW = Eg, sS = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  AC,
  {
    "data-slot": "menu-trigger",
    className: de("", e),
    ...t
  }
));
sS.displayName = "MenuTrigger";
const qg = b.forwardRef(
  ({
    children: e,
    className: t,
    sideOffset: n = 4,
    align: r = "end",
    alignOffset: o = 0,
    side: s = "bottom",
    ...i
  }, a) => /* @__PURE__ */ ee(EC, { children: [
    /* @__PURE__ */ _(gC, {}),
    /* @__PURE__ */ _(
      _C,
      {
        align: r,
        alignOffset: o,
        className: "z-50",
        "data-slot": "menu-positioner",
        side: s,
        sideOffset: n,
        children: /* @__PURE__ */ _(
          CC,
          {
            ref: a,
            className: de(
              "relative flex max-h-[--available-height] w-56 origin-[--transform-origin] overflow-y-auto overflow-x-hidden rounded-md border border-foundations-subtle bg-foundations-default bg-clip-padding p-2 text-foundations-bolder shadow-lg transition-[scale,opacity] data-[open]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[open]:fade-in-0 data-[closed]:zoom-out-95 data-[open]:zoom-in-95",
              t
            ),
            "data-slot": "menu-popup",
            ...i,
            children: /* @__PURE__ */ _("div", { className: "w-full", children: e })
          }
        )
      }
    )
  ] })
);
qg.displayName = "MenuPopup";
const IW = Qn(
  "relative flex cursor-pointer select-none scroll-m-1 items-center gap-2 rounded px-4 py-2 text-sm text-foundations-bolder outline-none transition-colors data-[disabled]:pointer-events-none data-[highlighted]:bg-foundations-subtlest data-[disabled]:opacity-50",
  {
    variants: {
      variant: {
        destructive: "destructive-menu text-danger"
      }
    }
  }
), iS = b.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ _(
  xC,
  {
    ref: r,
    className: de(IW({ variant: t }), e),
    "data-slot": "menu-item",
    "data-variant": t,
    ...n
  }
));
iS.displayName = "MenuItem";
const kW = (e) => /* @__PURE__ */ _(x4, { "data-slot": "menu-sub", ...e }), aS = b.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ ee(
  LC,
  {
    ref: r,
    className: de(
      "data-disabled:pointer-events-none data-disabled:opacity-64 flex items-center gap-2 rounded-sm px-2 py-1 outline-none data-[highlighted]:bg-foundations-subtlest sm:text-sm",
      e
    ),
    "data-slot": "menu-sub-trigger",
    ...n,
    children: [
      t,
      /* @__PURE__ */ _(Op, { className: "ms-auto h-4 w-4 text-foundations-subtler" })
    ]
  }
));
aS.displayName = "MenuSubTrigger";
const lS = b.forwardRef(
  ({ className: e, sideOffset: t = 0, alignOffset: n = -4, align: r = "start", ...o }, s) => /* @__PURE__ */ _(
    qg,
    {
      ref: s,
      align: r,
      alignOffset: n,
      className: e,
      "data-slot": "menu-sub-content",
      side: "inline-end",
      sideOffset: t,
      ...o
    }
  )
);
lS.displayName = "MenuSubPopup";
const cS = b.forwardRef((e, t) => /* @__PURE__ */ _(vC, { ref: t, "data-slot": "menu-group", ...e }));
cS.displayName = "MenuGroup";
const uS = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  yC,
  {
    ref: n,
    className: de(
      "p-2 text-xs font-medium uppercase text-foundations-subtle",
      e
    ),
    "data-slot": "menu-label",
    ...t
  }
));
uS.displayName = "MenuGroupLabel";
const dS = b.forwardRef((e, t) => /* @__PURE__ */ _(
  SC,
  {
    ref: t,
    "data-slot": "menu-radio-group",
    ...e
  }
));
dS.displayName = "MenuRadioGroup";
const fS = b.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ ee(
  OC,
  {
    ref: r,
    className: de(
      "relative grid cursor-pointer select-none scroll-m-1 grid-cols-[1fr_1rem] items-center gap-2 rounded p-2 ps-2 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[highlighted]:bg-foundations-subtlest data-[checked]:text-info data-[disabled]:opacity-50 sm:text-sm",
      e
    ),
    "data-slot": "menu-radio-item",
    ...n,
    children: [
      /* @__PURE__ */ _("span", { className: "col-start-1", children: t }),
      /* @__PURE__ */ _(MC, { className: "col-start-2", children: /* @__PURE__ */ _(ys, { className: "pointer-events-auto h-4 w-4 shrink-0" }) })
    ]
  }
));
fS.displayName = "MenuRadioItem";
const hS = b.forwardRef(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ ee(
  mC,
  {
    ref: o,
    checked: n,
    className: de(
      "relative grid cursor-pointer select-none scroll-m-1 grid-cols-[1rem_1fr] items-center gap-2 rounded px-4 py-2 pe-4 ps-2 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[highlighted]:bg-foundations-subtlest data-[disabled]:opacity-50 sm:text-sm",
      e
    ),
    "data-slot": "menu-checkbox-item",
    ...r,
    children: [
      /* @__PURE__ */ _(bC, { className: "col-start-1", children: /* @__PURE__ */ _(ys, { className: "pointer-events-auto h-4 w-4 shrink-0" }) }),
      /* @__PURE__ */ _("span", { className: "col-start-2", children: t })
    ]
  }
));
hS.displayName = "MenuCheckboxItem";
const DW = b.forwardRef(({ Icon: e, className: t, ...n }, r) => /* @__PURE__ */ _(
  e,
  {
    ref: r,
    className: de("h-4 w-4", t),
    "aria-hidden": "true",
    ...n
  }
)), NW = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  $C,
  {
    ref: n,
    className: de(
      "-mx-2 my-1.5 border-t border-foundations-subtle",
      e
    ),
    "data-slot": "menu-separator",
    ...t
  }
)), wB = Object.assign(PW, {
  Trigger: sS,
  Popup: qg,
  Group: cS,
  Item: iS,
  Icon: DW,
  CheckboxItem: hS,
  RadioGroup: dS,
  RadioItem: fS,
  GroupLabel: uS,
  Separator: NW,
  Sub: kW,
  SubTrigger: aS,
  SubPopup: lS
}), AW = b.forwardRef(
  ({ steps: e, currentStepIndex: t }, n) => {
    const r = (s) => s === t, o = (s) => s < t;
    return /* @__PURE__ */ _("nav", { ref: n, "aria-label": "progress", children: /* @__PURE__ */ _("ol", { className: "flex flex-wrap", children: e.map((s, i) => /* @__PURE__ */ ee("li", { className: "flex items-center", children: [
      i > 0 && /* @__PURE__ */ _("hr", { className: "mx-2 h-[1px] w-8 bg-foundations-bold" }),
      /* @__PURE__ */ ee("div", { className: "flex flex-wrap items-center justify-center gap-2", children: [
        o(i) ? /* @__PURE__ */ _($W, {}) : /* @__PURE__ */ _(FW, { isActive: r(i) }),
        /* @__PURE__ */ _(
          "span",
          {
            className: de(
              "text-sm font-medium",
              r(i) ? "text-foundations-boldest" : "text-foundations-subtle"
            ),
            children: s
          }
        )
      ] })
    ] }, `${i}-${s}`)) }) });
  }
);
AW.displayName = "Stepper";
const $W = () => /* @__PURE__ */ _("span", { className: "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-info-subtler p-1", children: /* @__PURE__ */ _(ys, { className: "h-4 w-4 text-info" }) }), FW = ({ isActive: e }) => /* @__PURE__ */ _(
  "span",
  {
    className: de(
      "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-foundations-subtlest",
      e ? "bg-info-bold" : "bg-foundations-subtlest"
    ),
    children: /* @__PURE__ */ _(
      "span",
      {
        className: de(
          "h-[10px] w-[10px] rounded-full bg-foundations-subtle",
          e ? "bg-white" : "bg-foundations-subtle"
        )
      }
    )
  }
), pS = b.createContext(null), Xg = () => {
  const e = b.useContext(pS);
  if (!e)
    throw new Error("useSheetContext must be used within <SheetContext />");
  return e;
};
function LW({ noBackdrop: e, container: t, ...n }) {
  return /* @__PURE__ */ _(
    pS.Provider,
    {
      value: {
        noBackdrop: e,
        container: t
      },
      children: /* @__PURE__ */ _(
        ax,
        {
          modal: e ? !1 : n.modal,
          ...n
        }
      )
    }
  );
}
function gS(e) {
  return /* @__PURE__ */ _(wp, { ...e });
}
function VW(e) {
  return /* @__PURE__ */ _(Sp, { "data-slot": "sheet-trigger", ...e });
}
function mS({ className: e, ...t }) {
  return /* @__PURE__ */ ee(
    Pu,
    {
      "data-slot": "sheet-close",
      className: de("shrink-0", e),
      ...t,
      children: [
        /* @__PURE__ */ _(
          Tp,
          {
            className: "h-6 w-6 text-foundations-subtler hover:text-foundations-subtle",
            "aria-hidden": "true"
          }
        ),
        /* @__PURE__ */ _("span", { className: "sr-only", children: "Close" })
      ]
    }
  );
}
function bS({ className: e, ...t }) {
  const { container: n } = Xg();
  return /* @__PURE__ */ _(
    mp,
    {
      className: de(
        "pointer-events-none fixed inset-0 z-50 bg-[rgba(0,0,0,0.40)] transition-opacity duration-300",
        "data-[ending-style]:opacity-0 data-[starting-style]:opacity-0",
        "data-[ending-style]:ease-in data-[starting-style]:ease-out",
        !!n && "absolute",
        e
      ),
      "data-slot": "sheet-backdrop",
      ...t
    }
  );
}
function vS({
  className: e,
  side: t,
  inset: n,
  ...r
}) {
  const { container: o } = Xg();
  return /* @__PURE__ */ _(
    Cp,
    {
      className: de(
        // "grid-rows-[1fr_auto_1fr] justify-items-center p-4",
        "pointer-events-none fixed inset-0 z-50 grid",
        t === "bottom" && "grid grid-rows-[1fr_auto] pt-12",
        t === "top" && "grid grid-rows-[auto_1fr] pb-12",
        t === "left" && "flex justify-start",
        t === "right" && "flex justify-end",
        n && "sm:p-3",
        !!o && "absolute",
        e
      ),
      "data-slot": "sheet-viewport",
      ...r
    }
  );
}
function WW({
  className: e,
  children: t,
  side: n = "right",
  inset: r = !0,
  ...o
}) {
  const { noBackdrop: s, container: i } = Xg();
  return /* @__PURE__ */ ee(gS, { container: i, children: [
    !s && /* @__PURE__ */ _(bS, {}),
    /* @__PURE__ */ _(vS, { side: n, inset: r, children: /* @__PURE__ */ _(
      xp,
      {
        className: de(
          "pointer-events-auto relative flex max-h-full min-h-0 w-full min-w-0 flex-col overflow-hidden border border-foundations-subtle bg-foundations-default bg-clip-padding shadow-xl transition-all duration-300 ease-in-out will-change-transform",
          "before:pointer-events-none before:absolute before:inset-0 before:shadow-[0_1px_--theme(--color-black/6%)]",
          "data-[ending-style]:opacity-0 data-[starting-style]:opacity-0 dark:before:shadow-[0_-1px_--theme(--color-white/6%)] max-sm:before:hidden",
          n === "bottom" && "row-start-2 border-t data-[ending-style]:translate-y-11 data-[starting-style]:translate-y-11",
          n === "top" && "border-b data-[ending-style]:-translate-y-11 data-[starting-style]:-translate-y-11",
          n === "left" && "max-w-md border-r data-[ending-style]:-translate-x-11 data-[starting-style]:-translate-x-11",
          n === "right" && "col-start-2 max-w-md border-l data-[ending-style]:translate-x-11 data-[starting-style]:translate-x-11",
          r && "sm:**:data-[slot=sheet-footer]:rounded-b-[calc(var(--radius-xl)-1px)] before:hidden sm:rounded-xl sm:before:rounded-[calc(var(--radius-xl)-1px)]",
          e
        ),
        "data-slot": "sheet-popup",
        ...o,
        children: t
      }
    ) })
  ] });
}
const yS = b.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ ee(
  "div",
  {
    ref: r,
    className: de(
      "flex items-center justify-between gap-2 border-b border-b-foundations-subtle px-8 py-6 text-lg font-medium text-foundations-boldest",
      e
    ),
    "data-slot": "sheet-header",
    ...n,
    children: [
      /* @__PURE__ */ _("div", { className: "flex min-w-0 flex-1 flex-col gap-1.5", children: t }),
      /* @__PURE__ */ _(mS, { className: "shrink-0" })
    ]
  }
));
yS.displayName = "SheetHeader";
function HW({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: de(
        "mt-auto flex flex-row-reverse gap-4 border-t border-t-foundations-subtle bg-foundations-default px-8 py-6",
        e
      ),
      "data-slot": "sheet-footer",
      ...t
    }
  );
}
const xS = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "span",
  {
    ref: n,
    className: de(
      "text-xs font-medium uppercase leading-6 text-foundations-bold",
      e
    ),
    "data-slot": "sheet-subheading",
    ...t
  }
));
xS.displayName = "SheetSubHeading";
const wS = b.forwardRef(
  ({ className: e, render: t, ...n }, r) => /* @__PURE__ */ _(
    Ep,
    {
      ref: r,
      render: t || /* @__PURE__ */ _("h3", {}),
      className: de(
        "text-lg font-medium leading-6 text-foundations-boldest",
        e
      ),
      "data-slot": "sheet-title",
      ...n
    }
  )
);
wS.displayName = "SheetTitle";
function BW({
  className: e,
  ref: t,
  ...n
}) {
  return /* @__PURE__ */ _(
    vp,
    {
      ref: t,
      className: de("text-sm text-foundations-subtle", e),
      "data-slot": "sheet-description",
      ...n
    }
  );
}
function zW({ className: e, ...t }) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: de("flex-1 overflow-auto p-8", e),
      "data-slot": "sheet-panel",
      ...t
    }
  );
}
const CB = Object.assign(LW, {
  Trigger: VW,
  Portal: gS,
  Close: mS,
  Backdrop: bS,
  Popup: WW,
  Header: yS,
  SubHeading: xS,
  Footer: HW,
  Title: wS,
  Description: BW,
  Panel: zW,
  Viewport: vS
}), EB = Oe.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "div",
  {
    ref: n,
    className: de(
      "pointer-events-none absolute bottom-0 left-0 z-20 h-16 w-full bg-gradient-to-t from-[theme(backgroundColor.foundations-default)] to-transparent",
      e
    ),
    ...t
  }
)), CS = b.forwardRef((e, t) => /* @__PURE__ */ _(cC, { ref: t, "data-slot": "collapsible", ...e }));
CS.displayName = "Collapsible";
const Zg = b.forwardRef((e, t) => /* @__PURE__ */ _(
  uC,
  {
    ref: t,
    "data-slot": "collapsible-trigger",
    ...e
  }
));
Zg.displayName = "CollapsibleTrigger";
const YW = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  dC,
  {
    ref: n,
    "data-slot": "collapsible-panel",
    className: de(
      "h-[--collapsible-panel-height] overflow-hidden transition-[height] duration-200 data-[ending-style]:h-0 data-[starting-style]:h-0",
      e
    ),
    ...t
  }
));
Zg.displayName = "CollapsiblePanel";
const _B = Object.assign(CS, {
  Trigger: Zg,
  Panel: YW
}), SB = ({
  id: e,
  link: t,
  className: n,
  size: r = "sm",
  "data-testid": o
}) => {
  const { name: s, url: i } = t || {};
  return /* @__PURE__ */ ee("div", { className: de("flex min-w-0 items-center gap-1", n), children: [
    /* @__PURE__ */ _(
      rx,
      {
        size: "sm",
        hoverable: !1,
        render: i ? /* @__PURE__ */ _(
          Ag,
          {
            href: i,
            target: "_blank",
            variant: "standalone",
            showExternalIcon: !1,
            size: r,
            className: "block",
            onClick: (a) => a.stopPropagation(),
            children: s || e
          }
        ) : /* @__PURE__ */ _(
          "span",
          {
            className: de(
              "truncate text-foundations-subtle",
              r === "md" ? "text-sm" : "text-xs"
            ),
            children: e
          }
        )
      }
    ),
    /* @__PURE__ */ _(jW, { id: e, dataTestId: o })
  ] });
}, jW = ({
  id: e,
  dataTestId: t
}) => {
  const [n, r] = Vt(!1), { copy: o, isCopied: s } = CE();
  return /* @__PURE__ */ ee(Lt, { open: n, children: [
    /* @__PURE__ */ _(
      Lt.Trigger,
      {
        delay: 0,
        render: /* @__PURE__ */ _(
          ia,
          {
            size: "sm",
            className: "inline-flex shrink-0 px-1 py-0.5",
            onMouseEnter: () => r(!0),
            onMouseLeave: () => r(!1),
            onFocus: () => r(!0),
            onBlur: () => r(!1),
            variant: "tertiary",
            onClick: (i) => {
              i.stopPropagation(), s || o(e);
            },
            "data-testid": t
          }
        ),
        children: s ? /* @__PURE__ */ _(ys, { className: "text-success" }) : /* @__PURE__ */ _(cx, { className: "" })
      }
    ),
    /* @__PURE__ */ _(Lt.Popup, { size: "sm", children: s ? "Copied!" : "Copy ID" })
  ] });
}, ES = b.forwardRef(({ ...e }, t) => /* @__PURE__ */ _("nav", { ref: t, "aria-label": "breadcrumb", "data-slot": "breadcrumb", ...e }));
ES.displayName = "Breadcrumb";
const _S = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "ol",
  {
    ref: n,
    className: de(
      "flex flex-wrap items-center break-words text-sm",
      e
    ),
    "data-slot": "breadcrumb-list",
    ...t
  }
));
_S.displayName = "BreadcrumbList";
const SS = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "li",
  {
    ref: n,
    className: de("inline-flex items-center gap-1.5", e),
    "data-slot": "breadcrumb-item",
    ...t
  }
));
SS.displayName = "BreadcrumbItem";
const OS = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  Ag,
  {
    ref: n,
    showExternalIcon: !1,
    className: de("rounded-md p-2 hover:bg-foundations-subtlest", e),
    ...t
  }
));
OS.displayName = "BreadcrumbLink";
const MS = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "span",
  {
    ref: n,
    "aria-current": "page",
    "aria-disabled": "true",
    className: de("py-2 pl-2 font-medium text-foundations-bolder", e),
    "data-slot": "breadcrumb-page",
    role: "link",
    ...t
  }
));
MS.displayName = "BreadcrumbPage";
const TS = b.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ _(
  "li",
  {
    ref: r,
    "aria-hidden": "true",
    className: de("text-foundations-subtler [&>svg]:size-4", t),
    "data-slot": "breadcrumb-separator",
    role: "presentation",
    ...n,
    children: e ?? /* @__PURE__ */ _(Op, {})
  }
));
TS.displayName = "BreadcrumbSeparator";
const RS = b.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ ee(
  "li",
  {
    ref: r,
    "aria-hidden": "true",
    className: de("text-info", t),
    "data-slot": "breadcrumb-ellipsis",
    role: "presentation",
    ...n,
    children: [
      /* @__PURE__ */ _(oI, { className: "size-4" }),
      /* @__PURE__ */ _("span", { className: "sr-only", children: "More" })
    ]
  }
));
RS.displayName = "BreadcrumbEllipsis";
const OB = Object.assign(ES, {
  List: _S,
  Item: SS,
  Link: OS,
  Page: MS,
  Separator: TS,
  Ellipsis: RS
}), PS = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  eE,
  {
    ref: n,
    className: de("flex flex-col", e),
    "data-slot": "tabs",
    ...t
  }
));
PS.displayName = "Tabs";
const IS = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  rE,
  {
    ref: n,
    className: de(
      "flex items-end gap-4 border-b border-foundations-subtler",
      e
    ),
    "data-slot": "tabs-list",
    ...t
  }
));
IS.displayName = "TabsList";
const kS = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  tE,
  {
    ref: n,
    className: de(
      // general tab styles
      "-mb-px shrink-0 items-center gap-x-1.5 gap-y-1 whitespace-nowrap rounded-t border-b-2 border-b-transparent px-2 pb-1.5 pt-2 text-left text-sm font-medium text-foundations-subtle outline-none first-of-type:pl-0 [&_svg]:pointer-events-none [&_svg]:shrink-0",
      // layout
      "flex items-center [&:has([data-slot='tab-description'])]:grid [&:has([data-slot='tab-description'])]:grid-cols-[auto_auto_1fr]",
      // hover styles
      "hover:border-foundations-bold hover:text-foundations-bold",
      // focus styles
      "focus:border-foundations-subtle focus:text-info",
      // active tab default styles
      "data-[active]:border-b-2 data-[active]:border-info-bold data-[active]:text-foundations-bolder",
      // active tab hover styles
      "hover:data-[active]:border-info-bolder hover:data-[active]:text-foundations-boldest",
      // active tab focus styles
      "focus:data-[active]:border-info-bolder focus:data-[active]:text-info",
      // disabled tab styles
      "data-[disabled]:pointer-events-none data-[disabled]:border-foundations-subtler data-[disabled]:text-foundations-subtler",
      e
    ),
    ...t
  }
));
kS.displayName = "TabsTab";
const DS = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  nE,
  {
    ref: n,
    className: de("flex-1 pt-6", e),
    "data-slot": "tabs-content",
    ...t
  }
));
DS.displayName = "TabsPanel";
const NS = b.forwardRef(({ className: e, variant: t = "light", size: n = "sm", children: r, ...o }, s) => /* @__PURE__ */ ee(Lt, { children: [
  /* @__PURE__ */ _(
    Lt.Trigger,
    {
      ref: s,
      render: /* @__PURE__ */ _(
        "span",
        {
          className: "inline-block rounded-full bg-foundations-subtlest p-0.5",
          "data-slot": "tab-hint"
        }
      ),
      children: /* @__PURE__ */ _(
        Mp,
        {
          "data-slot": "hint-icon",
          className: de("h-4 w-4 text-foundations-subtle", e)
        }
      )
    }
  ),
  /* @__PURE__ */ _(Lt.Popup, { size: n, variant: t, ...o, children: r })
] }));
NS.displayName = "TabsTabHint";
const AS = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "span",
  {
    ref: n,
    "data-slot": "tab-description",
    className: de("col-span-3 text-xs font-normal", e),
    ...t
  }
));
AS.displayName = "TabsTabDescription";
const MB = Object.assign(PS, {
  List: IS,
  Tab: kS,
  Panel: DS,
  Hint: NS,
  Description: AS
}), UW = {
  error: Tp,
  info: Mp,
  loading: lI,
  success: nI,
  warning: sI
};
function GW(e) {
  const t = e.updateKey ?? 0;
  if (t <= 0)
    return;
  const n = t % 2 === 0;
  return e.type === "error" ? n ? "animate-toast-error-even" : "animate-toast-error-odd" : n ? "animate-toast-success-even" : "animate-toast-success-odd";
}
function KW({ position: e }) {
  const { toasts: t } = Z4();
  return /* @__PURE__ */ _(bE, { "data-slot": "toast-portal", children: /* @__PURE__ */ _(
    iE,
    {
      className: de(
        "fixed z-[60] mx-auto flex w-[calc(100%-var(--toast-inset)*2)] max-w-[25rem] [--toast-inset:1rem] sm:[--toast-inset:2rem]",
        // Vertical positioning
        "data-[position*=top]:top-[var(--toast-inset)]",
        "data-[position*=bottom]:bottom-[var(--toast-inset)]",
        // Horizontal positioning
        "data-[position*=left]:left-[var(--toast-inset)]",
        "data-[position*=right]:right-[var(--toast-inset)]",
        "data-[position*=center]:left-1/2 data-[position*=center]:-translate-x-1/2"
      ),
      "data-position": e,
      "data-slot": "toast-viewport",
      children: t.map((n) => {
        const r = n.type ? UW[n.type] : null, o = n.data;
        return /* @__PURE__ */ _(
          aE,
          {
            className: de(
              "absolute z-[calc(9999-var(--toast-index))] h-[var(--toast-calc-height)] w-full select-none rounded-lg border border-foundations-subtle bg-foundations-default bg-clip-padding text-foundations-boldest shadow-lg [transition:transform_.5s_cubic-bezier(.22,1,.36,1),opacity_.5s,height_.15s,background-color_.5s] before:pointer-events-none before:absolute before:inset-0 before:rounded-[calc(0.5rem-1px)] before:shadow-[0_1px_rgba(0,0,0,0.04)] dark:before:shadow-[0_-1px_rgba(255,255,255,0.06)]",
              // Base positioning using data-position
              "data-[position*=right]:left-auto data-[position*=right]:right-0",
              "data-[position*=left]:left-0 data-[position*=left]:right-auto",
              "data-[position*=center]:left-0 data-[position*=center]:right-0",
              "data-[position*=top]:bottom-auto data-[position*=top]:top-0 data-[position*=top]:origin-[50%_calc(50%-50%*min(var(--toast-index,0),1))]",
              "data-[position*=bottom]:bottom-0 data-[position*=bottom]:top-auto data-[position*=bottom]:origin-[50%_calc(50%+50%*min(var(--toast-index,0),1))]",
              // Gap fill for hover
              "after:absolute after:left-0 after:h-[calc(var(--toast-gap)+1px)] after:w-full",
              "data-[position*=top]:after:top-full",
              "data-[position*=bottom]:after:bottom-full",
              // Define some variables
              "[--toast-calc-height:var(--toast-frontmost-height,var(--toast-height))] [--toast-gap:0.75rem] [--toast-peek:0.75rem] [--toast-scale:calc(max(0,1-(var(--toast-index)*.1)))] [--toast-shrink:calc(1-var(--toast-scale))]",
              // Define offset-y variable
              "data-[position*=top]:[--toast-calc-offset-y:calc(var(--toast-offset-y)+var(--toast-index)*var(--toast-gap))]",
              "data-[position*=bottom]:[--toast-calc-offset-y:calc(var(--toast-offset-y)*-1+var(--toast-index)*var(--toast-gap)*-1)]",
              // Default state transform
              "data-[position*=top]:[transform:translateY(calc((var(--toast-index)*var(--toast-peek))+(var(--toast-shrink)*var(--toast-calc-height))))_scale(var(--toast-scale))]",
              "data-[position*=bottom]:[transform:translateY(calc(0px-(var(--toast-index)*var(--toast-peek))-(var(--toast-shrink)*var(--toast-calc-height))))_scale(var(--toast-scale))]",
              // Limited state
              "data-[limited]:opacity-0",
              // Expanded state
              "data-[expanded]:h-[var(--toast-height)]",
              "data-[position]:data-[expanded]:[transform:translateY(var(--toast-calc-offset-y))]",
              // Starting and ending animations
              "data-[position*=top]:data-[starting-style]:[transform:translateY(calc(-100%-var(--toast-inset)))]",
              "data-[position*=bottom]:data-[starting-style]:[transform:translateY(calc(100%+var(--toast-inset)))]",
              "data-[ending-style]:opacity-0",
              // Ending animation — position-aware so top-* exits upward and bottom-* exits downward.
              "[&[data-position*=top][data-ending-style]]:[transform:translateY(calc(-100%-var(--toast-inset)))]",
              "[&[data-position*=bottom][data-ending-style]]:[transform:translateY(calc(100%+var(--toast-inset)))]",
              GW(n)
            ),
            ...o == null ? void 0 : o.rootProps,
            "data-position": e,
            swipeDirection: [],
            toast: n,
            children: /* @__PURE__ */ ee(lE, { className: "duration-[250ms] pointer-events-auto flex items-start justify-between gap-1.5 overflow-hidden px-3.5 py-3 text-sm transition-opacity data-[behind]:opacity-0 data-[expanded]:opacity-100 [&:not(:has([data-slot=toast-description]:not(:empty)))]:items-center [&[data-behind]:not([data-expanded])]:pointer-events-none", children: [
              /* @__PURE__ */ ee("div", { className: "flex min-w-0 gap-2", children: [
                r && /* @__PURE__ */ _(
                  "div",
                  {
                    className: "[&>svg]:h-[1lh] [&>svg]:w-4 [&_svg]:pointer-events-none [&_svg]:shrink-0",
                    "data-slot": "toast-icon",
                    children: /* @__PURE__ */ _(r, { className: "[[data-type=error]_&]:text-danger [[data-type=info]_&]:text-info [[data-type=loading]_&]:animate-spin [[data-type=loading]_&]:opacity-80 [[data-type=success]_&]:text-success [[data-type=warning]_&]:text-warning" })
                  }
                ),
                /* @__PURE__ */ ee("div", { className: "flex min-w-0 flex-col gap-0.5", children: [
                  /* @__PURE__ */ _(
                    pE,
                    {
                      className: "font-medium",
                      "data-slot": "toast-title",
                      render: ({ children: s }) => /* @__PURE__ */ _(In, { children: qW(s) })
                    }
                  ),
                  /* @__PURE__ */ _(
                    hE,
                    {
                      className: "text-foundations-subtler",
                      "data-slot": "toast-description"
                    }
                  ),
                  n.actionProps && /* @__PURE__ */ _(
                    mE,
                    {
                      className: de(
                        Ih({ variant: "tertiary", size: "xs" }),
                        "self-start p-0 hover:bg-transparent"
                      ),
                      "data-slot": "toast-action"
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ _(
                gE,
                {
                  "aria-label": "Close",
                  className: "focus-visible:outline-foundations-bold -mr-1 -mt-1 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-foundations-subtler transition-colors hover:text-foundations-boldest focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 [:not(:has([data-slot=toast-description]:not(:empty)))>&]:mt-0",
                  "data-slot": "toast-close",
                  children: /* @__PURE__ */ _(Du, { className: "h-4 w-4" })
                }
              )
            ] })
          },
          n.id
        );
      })
    }
  ) });
}
const Uc = Q4();
function $s(e, t, n = {}) {
  const { id: r, description: o, duration: s, actionProps: i } = n;
  return Uc.add({
    id: r,
    type: e,
    title: t,
    description: o,
    timeout: s,
    actionProps: i
  });
}
const TB = Object.assign(
  (e, t) => $s(void 0, e, t),
  {
    success: (e, t) => $s("success", e, t),
    error: (e, t) => $s("error", e, t),
    loading: (e, t) => $s("loading", e, t),
    info: (e, t) => $s("info", e, t),
    warning: (e, t) => $s("warning", e, t),
    dismiss: (e) => {
      Uc.close(e);
    },
    promise(e, t, n) {
      const r = {
        id: n == null ? void 0 : n.id,
        timeout: n == null ? void 0 : n.duration,
        actionProps: n == null ? void 0 : n.actionProps
      };
      return Uc.promise(e, {
        loading: { ...r, title: t.loading },
        success: (o) => ({
          ...r,
          title: typeof t.success == "function" ? t.success(o) : t.success
        }),
        error: (o) => ({
          ...r,
          title: typeof t.error == "function" ? t.error(o) : t.error
        })
      });
    }
  }
);
function RB({
  children: e,
  position: t = "bottom-right",
  ...n
}) {
  return /* @__PURE__ */ ee(sE, { toastManager: Uc, ...n, children: [
    e,
    /* @__PURE__ */ _(KW, { position: t })
  ] });
}
const qW = (e) => {
  if (b.isValidElement(e))
    return e;
  if (typeof e == "string")
    return /* @__PURE__ */ _("h2", { className: "truncate whitespace-pre-wrap", title: e, children: e });
  if (e instanceof Object) {
    const t = Object.entries(e);
    return /* @__PURE__ */ _("ul", { children: t.map(([n, r], o) => /* @__PURE__ */ ee("li", { children: [
      n,
      " : ",
      $S(r)
    ] }, o)) });
  }
  return /* @__PURE__ */ _(In, { children: e });
}, $S = (e) => {
  if (typeof e == "string" || typeof (e == null ? void 0 : e[0]) == "string")
    return e;
  if (Array.isArray(e))
    return /* @__PURE__ */ _("ul", { className: "list-disc pl-6", children: e == null ? void 0 : e.map((t) => Object.entries(t).map(([r, o], s) => /* @__PURE__ */ ee("li", { children: [
      r,
      ": ",
      o
    ] }, s))) });
  if (e instanceof Object) {
    const t = Object.entries(e);
    return /* @__PURE__ */ _("ul", { className: "list-disc pl-6", children: t.map(([n, r], o) => /* @__PURE__ */ ee("li", { children: [
      n,
      " : ",
      $S(r)
    ] }, o)) });
  }
  return e;
};
function PB(e) {
  const { fileInputDom: t, accept: n, onSelect: r } = e ?? {}, o = et(null), [s, i] = Vt(null), [a, l] = Vt(!1), [c, u] = Vt(null), d = ot(() => {
    o.current && (o.current.value = "");
  }, []), f = ot(async () => {
    var g, m;
    const p = (m = (g = o.current) == null ? void 0 : g.files) == null ? void 0 : m[0];
    i(p || null);
    try {
      l(!0), p && await (r == null ? void 0 : r(p, d));
    } catch (v) {
      u(v);
    } finally {
      l(!1);
    }
  }, [r]);
  return st(() => {
    o.current || (o.current = t ?? document.createElement("input"), o.current.type = "file", o.current.accept = n ?? "*/*", o.current.disabled = (e == null ? void 0 : e.disabled) ?? !1, o.current.addEventListener("change", f));
  }, [t, f]), { file: s, isLoading: a, error: c, selectFile: () => {
    o.current && o.current.click();
  } };
}
function IB({
  currency: e,
  amount: t,
  compact: n = !1
}) {
  const r = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: e,
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    notation: n ? "compact" : "standard"
  });
  return n ? r.format(t) : r.format(t).replace(/^(\D+)\s*(.+)$/, "$2$1").trim();
}
function kB({
  value: e,
  compact: t = !1
}) {
  return new Intl.NumberFormat(void 0, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    notation: t ? "compact" : "standard"
  }).format(e);
}
function Ir(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, s;
  for (s = 0; s < r.length; s++)
    o = r[s], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function Xe() {
  return Xe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xe.apply(this, arguments);
}
function dy(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function yh(e, t) {
  return yh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, yh(e, t);
}
function XW(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, yh(e, t);
}
var xh = { exports: {} }, Hl = { exports: {} }, yt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fy;
function ZW() {
  if (fy)
    return yt;
  fy = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function x(w) {
    if (typeof w == "object" && w !== null) {
      var E = w.$$typeof;
      switch (E) {
        case t:
          switch (w = w.type, w) {
            case l:
            case c:
            case r:
            case s:
            case o:
            case d:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case a:
                case u:
                case p:
                case h:
                case i:
                  return w;
                default:
                  return E;
              }
          }
        case n:
          return E;
      }
    }
  }
  function C(w) {
    return x(w) === c;
  }
  return yt.AsyncMode = l, yt.ConcurrentMode = c, yt.ContextConsumer = a, yt.ContextProvider = i, yt.Element = t, yt.ForwardRef = u, yt.Fragment = r, yt.Lazy = p, yt.Memo = h, yt.Portal = n, yt.Profiler = s, yt.StrictMode = o, yt.Suspense = d, yt.isAsyncMode = function(w) {
    return C(w) || x(w) === l;
  }, yt.isConcurrentMode = C, yt.isContextConsumer = function(w) {
    return x(w) === a;
  }, yt.isContextProvider = function(w) {
    return x(w) === i;
  }, yt.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, yt.isForwardRef = function(w) {
    return x(w) === u;
  }, yt.isFragment = function(w) {
    return x(w) === r;
  }, yt.isLazy = function(w) {
    return x(w) === p;
  }, yt.isMemo = function(w) {
    return x(w) === h;
  }, yt.isPortal = function(w) {
    return x(w) === n;
  }, yt.isProfiler = function(w) {
    return x(w) === s;
  }, yt.isStrictMode = function(w) {
    return x(w) === o;
  }, yt.isSuspense = function(w) {
    return x(w) === d;
  }, yt.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === c || w === s || w === o || w === d || w === f || typeof w == "object" && w !== null && (w.$$typeof === p || w.$$typeof === h || w.$$typeof === i || w.$$typeof === a || w.$$typeof === u || w.$$typeof === m || w.$$typeof === v || w.$$typeof === y || w.$$typeof === g);
  }, yt.typeOf = x, yt;
}
var xt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hy;
function QW() {
  return hy || (hy = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function x(G) {
      return typeof G == "string" || typeof G == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      G === r || G === c || G === s || G === o || G === d || G === f || typeof G == "object" && G !== null && (G.$$typeof === p || G.$$typeof === h || G.$$typeof === i || G.$$typeof === a || G.$$typeof === u || G.$$typeof === m || G.$$typeof === v || G.$$typeof === y || G.$$typeof === g);
    }
    function C(G) {
      if (typeof G == "object" && G !== null) {
        var ne = G.$$typeof;
        switch (ne) {
          case t:
            var Q = G.type;
            switch (Q) {
              case l:
              case c:
              case r:
              case s:
              case o:
              case d:
                return Q;
              default:
                var re = Q && Q.$$typeof;
                switch (re) {
                  case a:
                  case u:
                  case p:
                  case h:
                  case i:
                    return re;
                  default:
                    return ne;
                }
            }
          case n:
            return ne;
        }
      }
    }
    var w = l, E = c, S = a, O = i, M = t, T = u, P = r, I = p, R = h, D = n, k = s, $ = o, L = d, A = !1;
    function F(G) {
      return A || (A = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), N(G) || C(G) === l;
    }
    function N(G) {
      return C(G) === c;
    }
    function V(G) {
      return C(G) === a;
    }
    function K(G) {
      return C(G) === i;
    }
    function Y(G) {
      return typeof G == "object" && G !== null && G.$$typeof === t;
    }
    function U(G) {
      return C(G) === u;
    }
    function j(G) {
      return C(G) === r;
    }
    function H(G) {
      return C(G) === p;
    }
    function q(G) {
      return C(G) === h;
    }
    function B(G) {
      return C(G) === n;
    }
    function X(G) {
      return C(G) === s;
    }
    function te(G) {
      return C(G) === o;
    }
    function J(G) {
      return C(G) === d;
    }
    xt.AsyncMode = w, xt.ConcurrentMode = E, xt.ContextConsumer = S, xt.ContextProvider = O, xt.Element = M, xt.ForwardRef = T, xt.Fragment = P, xt.Lazy = I, xt.Memo = R, xt.Portal = D, xt.Profiler = k, xt.StrictMode = $, xt.Suspense = L, xt.isAsyncMode = F, xt.isConcurrentMode = N, xt.isContextConsumer = V, xt.isContextProvider = K, xt.isElement = Y, xt.isForwardRef = U, xt.isFragment = j, xt.isLazy = H, xt.isMemo = q, xt.isPortal = B, xt.isProfiler = X, xt.isStrictMode = te, xt.isSuspense = J, xt.isValidElementType = x, xt.typeOf = C;
  }()), xt;
}
var py;
function FS() {
  return py || (py = 1, process.env.NODE_ENV === "production" ? Hl.exports = ZW() : Hl.exports = QW()), Hl.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var hf, gy;
function JW() {
  if (gy)
    return hf;
  gy = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var i = {}, a = 0; a < 10; a++)
        i["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(i).map(function(u) {
        return i[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return hf = o() ? Object.assign : function(s, i) {
    for (var a, l = r(s), c, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var d in a)
        t.call(a, d) && (l[d] = a[d]);
      if (e) {
        c = e(a);
        for (var f = 0; f < c.length; f++)
          n.call(a, c[f]) && (l[c[f]] = a[c[f]]);
      }
    }
    return l;
  }, hf;
}
var pf, my;
function Qg() {
  if (my)
    return pf;
  my = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return pf = e, pf;
}
var gf, by;
function LS() {
  return by || (by = 1, gf = Function.call.bind(Object.prototype.hasOwnProperty)), gf;
}
var mf, vy;
function eH() {
  if (vy)
    return mf;
  vy = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Qg(), n = {}, r = LS();
    e = function(s) {
      var i = "Warning: " + s;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function o(s, i, a, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in s)
        if (r(s, u)) {
          var d;
          try {
            if (typeof s[u] != "function") {
              var f = Error(
                (l || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = s[u](i, u, l, a, null, t);
          } catch (p) {
            d = p;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = c ? c() : "";
            e(
              "Failed " + a + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, mf = o, mf;
}
var bf, yy;
function tH() {
  if (yy)
    return bf;
  yy = 1;
  var e = FS(), t = JW(), n = Qg(), r = LS(), o = eH(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return bf = function(a, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(N) {
      var V = N && (c && N[c] || N[u]);
      if (typeof V == "function")
        return V;
    }
    var f = "<<anonymous>>", h = {
      array: v("array"),
      bigint: v("bigint"),
      bool: v("boolean"),
      func: v("function"),
      number: v("number"),
      object: v("object"),
      string: v("string"),
      symbol: v("symbol"),
      any: y(),
      arrayOf: x,
      element: C(),
      elementType: w(),
      instanceOf: E,
      node: T(),
      objectOf: O,
      oneOf: S,
      oneOfType: M,
      shape: I,
      exact: R
    };
    function p(N, V) {
      return N === V ? N !== 0 || 1 / N === 1 / V : N !== N && V !== V;
    }
    function g(N, V) {
      this.message = N, this.data = V && typeof V == "object" ? V : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function m(N) {
      if (process.env.NODE_ENV !== "production")
        var V = {}, K = 0;
      function Y(j, H, q, B, X, te, J) {
        if (B = B || f, te = te || q, J !== n) {
          if (l) {
            var G = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw G.name = "Invariant Violation", G;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ne = B + ":" + q;
            !V[ne] && // Avoid spamming the console because they are often not actionable except for lib authors
            K < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + te + "` prop on `" + B + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), V[ne] = !0, K++);
          }
        }
        return H[q] == null ? j ? H[q] === null ? new g("The " + X + " `" + te + "` is marked as required " + ("in `" + B + "`, but its value is `null`.")) : new g("The " + X + " `" + te + "` is marked as required in " + ("`" + B + "`, but its value is `undefined`.")) : null : N(H, q, B, X, te);
      }
      var U = Y.bind(null, !1);
      return U.isRequired = Y.bind(null, !0), U;
    }
    function v(N) {
      function V(K, Y, U, j, H, q) {
        var B = K[Y], X = $(B);
        if (X !== N) {
          var te = L(B);
          return new g(
            "Invalid " + j + " `" + H + "` of type " + ("`" + te + "` supplied to `" + U + "`, expected ") + ("`" + N + "`."),
            { expectedType: N }
          );
        }
        return null;
      }
      return m(V);
    }
    function y() {
      return m(i);
    }
    function x(N) {
      function V(K, Y, U, j, H) {
        if (typeof N != "function")
          return new g("Property `" + H + "` of component `" + U + "` has invalid PropType notation inside arrayOf.");
        var q = K[Y];
        if (!Array.isArray(q)) {
          var B = $(q);
          return new g("Invalid " + j + " `" + H + "` of type " + ("`" + B + "` supplied to `" + U + "`, expected an array."));
        }
        for (var X = 0; X < q.length; X++) {
          var te = N(q, X, U, j, H + "[" + X + "]", n);
          if (te instanceof Error)
            return te;
        }
        return null;
      }
      return m(V);
    }
    function C() {
      function N(V, K, Y, U, j) {
        var H = V[K];
        if (!a(H)) {
          var q = $(H);
          return new g("Invalid " + U + " `" + j + "` of type " + ("`" + q + "` supplied to `" + Y + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(N);
    }
    function w() {
      function N(V, K, Y, U, j) {
        var H = V[K];
        if (!e.isValidElementType(H)) {
          var q = $(H);
          return new g("Invalid " + U + " `" + j + "` of type " + ("`" + q + "` supplied to `" + Y + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(N);
    }
    function E(N) {
      function V(K, Y, U, j, H) {
        if (!(K[Y] instanceof N)) {
          var q = N.name || f, B = F(K[Y]);
          return new g("Invalid " + j + " `" + H + "` of type " + ("`" + B + "` supplied to `" + U + "`, expected ") + ("instance of `" + q + "`."));
        }
        return null;
      }
      return m(V);
    }
    function S(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), i;
      function V(K, Y, U, j, H) {
        for (var q = K[Y], B = 0; B < N.length; B++)
          if (p(q, N[B]))
            return null;
        var X = JSON.stringify(N, function(J, G) {
          var ne = L(G);
          return ne === "symbol" ? String(G) : G;
        });
        return new g("Invalid " + j + " `" + H + "` of value `" + String(q) + "` " + ("supplied to `" + U + "`, expected one of " + X + "."));
      }
      return m(V);
    }
    function O(N) {
      function V(K, Y, U, j, H) {
        if (typeof N != "function")
          return new g("Property `" + H + "` of component `" + U + "` has invalid PropType notation inside objectOf.");
        var q = K[Y], B = $(q);
        if (B !== "object")
          return new g("Invalid " + j + " `" + H + "` of type " + ("`" + B + "` supplied to `" + U + "`, expected an object."));
        for (var X in q)
          if (r(q, X)) {
            var te = N(q, X, U, j, H + "." + X, n);
            if (te instanceof Error)
              return te;
          }
        return null;
      }
      return m(V);
    }
    function M(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var V = 0; V < N.length; V++) {
        var K = N[V];
        if (typeof K != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + A(K) + " at index " + V + "."
          ), i;
      }
      function Y(U, j, H, q, B) {
        for (var X = [], te = 0; te < N.length; te++) {
          var J = N[te], G = J(U, j, H, q, B, n);
          if (G == null)
            return null;
          G.data && r(G.data, "expectedType") && X.push(G.data.expectedType);
        }
        var ne = X.length > 0 ? ", expected one of type [" + X.join(", ") + "]" : "";
        return new g("Invalid " + q + " `" + B + "` supplied to " + ("`" + H + "`" + ne + "."));
      }
      return m(Y);
    }
    function T() {
      function N(V, K, Y, U, j) {
        return D(V[K]) ? null : new g("Invalid " + U + " `" + j + "` supplied to " + ("`" + Y + "`, expected a ReactNode."));
      }
      return m(N);
    }
    function P(N, V, K, Y, U) {
      return new g(
        (N || "React class") + ": " + V + " type `" + K + "." + Y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + U + "`."
      );
    }
    function I(N) {
      function V(K, Y, U, j, H) {
        var q = K[Y], B = $(q);
        if (B !== "object")
          return new g("Invalid " + j + " `" + H + "` of type `" + B + "` " + ("supplied to `" + U + "`, expected `object`."));
        for (var X in N) {
          var te = N[X];
          if (typeof te != "function")
            return P(U, j, H, X, L(te));
          var J = te(q, X, U, j, H + "." + X, n);
          if (J)
            return J;
        }
        return null;
      }
      return m(V);
    }
    function R(N) {
      function V(K, Y, U, j, H) {
        var q = K[Y], B = $(q);
        if (B !== "object")
          return new g("Invalid " + j + " `" + H + "` of type `" + B + "` " + ("supplied to `" + U + "`, expected `object`."));
        var X = t({}, K[Y], N);
        for (var te in X) {
          var J = N[te];
          if (r(N, te) && typeof J != "function")
            return P(U, j, H, te, L(J));
          if (!J)
            return new g(
              "Invalid " + j + " `" + H + "` key `" + te + "` supplied to `" + U + "`.\nBad object: " + JSON.stringify(K[Y], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(N), null, "  ")
            );
          var G = J(q, te, U, j, H + "." + te, n);
          if (G)
            return G;
        }
        return null;
      }
      return m(V);
    }
    function D(N) {
      switch (typeof N) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !N;
        case "object":
          if (Array.isArray(N))
            return N.every(D);
          if (N === null || a(N))
            return !0;
          var V = d(N);
          if (V) {
            var K = V.call(N), Y;
            if (V !== N.entries) {
              for (; !(Y = K.next()).done; )
                if (!D(Y.value))
                  return !1;
            } else
              for (; !(Y = K.next()).done; ) {
                var U = Y.value;
                if (U && !D(U[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function k(N, V) {
      return N === "symbol" ? !0 : V ? V["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && V instanceof Symbol : !1;
    }
    function $(N) {
      var V = typeof N;
      return Array.isArray(N) ? "array" : N instanceof RegExp ? "object" : k(V, N) ? "symbol" : V;
    }
    function L(N) {
      if (typeof N > "u" || N === null)
        return "" + N;
      var V = $(N);
      if (V === "object") {
        if (N instanceof Date)
          return "date";
        if (N instanceof RegExp)
          return "regexp";
      }
      return V;
    }
    function A(N) {
      var V = L(N);
      switch (V) {
        case "array":
        case "object":
          return "an " + V;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + V;
        default:
          return V;
      }
    }
    function F(N) {
      return !N.constructor || !N.constructor.name ? f : N.constructor.name;
    }
    return h.checkPropTypes = o, h.resetWarningCache = o.resetWarningCache, h.PropTypes = h, h;
  }, bf;
}
var vf, xy;
function nH() {
  if (xy)
    return vf;
  xy = 1;
  var e = Qg();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, vf = function() {
    function r(i, a, l, c, u, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return s.PropTypes = s, s;
  }, vf;
}
if (process.env.NODE_ENV !== "production") {
  var rH = FS(), oH = !0;
  xh.exports = tH()(rH.isElement, oH);
} else
  xh.exports = nH()();
var sH = xh.exports;
const ve = /* @__PURE__ */ UO(sH);
var wh = { exports: {} }, kt = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wy;
function iH() {
  if (wy)
    return kt;
  wy = 1;
  var e = 60103, t = 60106, n = 60107, r = 60108, o = 60114, s = 60109, i = 60110, a = 60112, l = 60113, c = 60120, u = 60115, d = 60116, f = 60121, h = 60122, p = 60117, g = 60129, m = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var v = Symbol.for;
    e = v("react.element"), t = v("react.portal"), n = v("react.fragment"), r = v("react.strict_mode"), o = v("react.profiler"), s = v("react.provider"), i = v("react.context"), a = v("react.forward_ref"), l = v("react.suspense"), c = v("react.suspense_list"), u = v("react.memo"), d = v("react.lazy"), f = v("react.block"), h = v("react.server.block"), p = v("react.fundamental"), g = v("react.debug_trace_mode"), m = v("react.legacy_hidden");
  }
  function y(R) {
    if (typeof R == "object" && R !== null) {
      var D = R.$$typeof;
      switch (D) {
        case e:
          switch (R = R.type, R) {
            case n:
            case o:
            case r:
            case l:
            case c:
              return R;
            default:
              switch (R = R && R.$$typeof, R) {
                case i:
                case a:
                case d:
                case u:
                case s:
                  return R;
                default:
                  return D;
              }
          }
        case t:
          return D;
      }
    }
  }
  var x = s, C = e, w = a, E = n, S = d, O = u, M = t, T = o, P = r, I = l;
  return kt.ContextConsumer = i, kt.ContextProvider = x, kt.Element = C, kt.ForwardRef = w, kt.Fragment = E, kt.Lazy = S, kt.Memo = O, kt.Portal = M, kt.Profiler = T, kt.StrictMode = P, kt.Suspense = I, kt.isAsyncMode = function() {
    return !1;
  }, kt.isConcurrentMode = function() {
    return !1;
  }, kt.isContextConsumer = function(R) {
    return y(R) === i;
  }, kt.isContextProvider = function(R) {
    return y(R) === s;
  }, kt.isElement = function(R) {
    return typeof R == "object" && R !== null && R.$$typeof === e;
  }, kt.isForwardRef = function(R) {
    return y(R) === a;
  }, kt.isFragment = function(R) {
    return y(R) === n;
  }, kt.isLazy = function(R) {
    return y(R) === d;
  }, kt.isMemo = function(R) {
    return y(R) === u;
  }, kt.isPortal = function(R) {
    return y(R) === t;
  }, kt.isProfiler = function(R) {
    return y(R) === o;
  }, kt.isStrictMode = function(R) {
    return y(R) === r;
  }, kt.isSuspense = function(R) {
    return y(R) === l;
  }, kt.isValidElementType = function(R) {
    return typeof R == "string" || typeof R == "function" || R === n || R === o || R === g || R === r || R === l || R === c || R === m || typeof R == "object" && R !== null && (R.$$typeof === d || R.$$typeof === u || R.$$typeof === s || R.$$typeof === i || R.$$typeof === a || R.$$typeof === p || R.$$typeof === f || R[0] === h);
  }, kt.typeOf = y, kt;
}
var Dt = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cy;
function aH() {
  return Cy || (Cy = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, n = 60107, r = 60108, o = 60114, s = 60109, i = 60110, a = 60112, l = 60113, c = 60120, u = 60115, d = 60116, f = 60121, h = 60122, p = 60117, g = 60129, m = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var v = Symbol.for;
      e = v("react.element"), t = v("react.portal"), n = v("react.fragment"), r = v("react.strict_mode"), o = v("react.profiler"), s = v("react.provider"), i = v("react.context"), a = v("react.forward_ref"), l = v("react.suspense"), c = v("react.suspense_list"), u = v("react.memo"), d = v("react.lazy"), f = v("react.block"), h = v("react.server.block"), p = v("react.fundamental"), v("react.scope"), v("react.opaque.id"), g = v("react.debug_trace_mode"), v("react.offscreen"), m = v("react.legacy_hidden");
    }
    var y = !1;
    function x(J) {
      return !!(typeof J == "string" || typeof J == "function" || J === n || J === o || J === g || J === r || J === l || J === c || J === m || y || typeof J == "object" && J !== null && (J.$$typeof === d || J.$$typeof === u || J.$$typeof === s || J.$$typeof === i || J.$$typeof === a || J.$$typeof === p || J.$$typeof === f || J[0] === h));
    }
    function C(J) {
      if (typeof J == "object" && J !== null) {
        var G = J.$$typeof;
        switch (G) {
          case e:
            var ne = J.type;
            switch (ne) {
              case n:
              case o:
              case r:
              case l:
              case c:
                return ne;
              default:
                var Q = ne && ne.$$typeof;
                switch (Q) {
                  case i:
                  case a:
                  case d:
                  case u:
                  case s:
                    return Q;
                  default:
                    return G;
                }
            }
          case t:
            return G;
        }
      }
    }
    var w = i, E = s, S = e, O = a, M = n, T = d, P = u, I = t, R = o, D = r, k = l, $ = !1, L = !1;
    function A(J) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function F(J) {
      return L || (L = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function N(J) {
      return C(J) === i;
    }
    function V(J) {
      return C(J) === s;
    }
    function K(J) {
      return typeof J == "object" && J !== null && J.$$typeof === e;
    }
    function Y(J) {
      return C(J) === a;
    }
    function U(J) {
      return C(J) === n;
    }
    function j(J) {
      return C(J) === d;
    }
    function H(J) {
      return C(J) === u;
    }
    function q(J) {
      return C(J) === t;
    }
    function B(J) {
      return C(J) === o;
    }
    function X(J) {
      return C(J) === r;
    }
    function te(J) {
      return C(J) === l;
    }
    Dt.ContextConsumer = w, Dt.ContextProvider = E, Dt.Element = S, Dt.ForwardRef = O, Dt.Fragment = M, Dt.Lazy = T, Dt.Memo = P, Dt.Portal = I, Dt.Profiler = R, Dt.StrictMode = D, Dt.Suspense = k, Dt.isAsyncMode = A, Dt.isConcurrentMode = F, Dt.isContextConsumer = N, Dt.isContextProvider = V, Dt.isElement = K, Dt.isForwardRef = Y, Dt.isFragment = U, Dt.isLazy = j, Dt.isMemo = H, Dt.isPortal = q, Dt.isProfiler = B, Dt.isStrictMode = X, Dt.isSuspense = te, Dt.isValidElementType = x, Dt.typeOf = C;
  }()), Dt;
}
process.env.NODE_ENV === "production" ? wh.exports = iH() : wh.exports = aH();
var Ey = wh.exports;
let _y = (e) => typeof e == "object" && e != null && e.nodeType === 1, Sy = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", yf = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    let n = getComputedStyle(e, null);
    return Sy(n.overflowY, t) || Sy(n.overflowX, t) || ((r) => {
      let o = ((s) => {
        if (!s.ownerDocument || !s.ownerDocument.defaultView)
          return null;
        try {
          return s.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(r);
      return !!o && (o.clientHeight < r.scrollHeight || o.clientWidth < r.scrollWidth);
    })(e);
  }
  return !1;
}, Bl = (e, t, n, r, o, s, i, a) => s < e && i > t || s > e && i < t ? 0 : s <= e && a <= n || i >= t && a >= n ? s - e - r : i > t && a < n || s < e && a > n ? i - t + o : 0, lH = (e) => {
  let t = e.parentElement;
  return t ?? (e.getRootNode().host || null);
};
var cH = (e, t) => {
  var n, r, o, s, i, a;
  if (typeof document > "u")
    return [];
  let { scrollMode: l, block: c, inline: u, boundary: d, skipOverflowHiddenElements: f } = t, h = typeof d == "function" ? d : (D) => D !== d;
  if (!_y(e))
    throw new TypeError("Invalid target");
  let p = document.scrollingElement || document.documentElement, g = [], m = e;
  for (; _y(m) && h(m); ) {
    if (m = lH(m), m === p) {
      g.push(m);
      break;
    }
    m != null && m === document.body && yf(m) && !yf(document.documentElement) || m != null && yf(m, f) && g.push(m);
  }
  let v = (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ? r : innerWidth, y = (s = (o = window.visualViewport) == null ? void 0 : o.height) != null ? s : innerHeight, x = (i = window.scrollX) != null ? i : pageXOffset, C = (a = window.scrollY) != null ? a : pageYOffset, { height: w, width: E, top: S, right: O, bottom: M, left: T } = e.getBoundingClientRect(), P = c === "start" || c === "nearest" ? S : c === "end" ? M : S + w / 2, I = u === "center" ? T + E / 2 : u === "end" ? O : T, R = [];
  for (let D = 0; D < g.length; D++) {
    let k = g[D], { height: $, width: L, top: A, right: F, bottom: N, left: V } = k.getBoundingClientRect();
    if (l === "if-needed" && S >= 0 && T >= 0 && M <= y && O <= v && S >= A && M <= N && T >= V && O <= F)
      return R;
    let K = getComputedStyle(k), Y = parseInt(K.borderLeftWidth, 10), U = parseInt(K.borderTopWidth, 10), j = parseInt(K.borderRightWidth, 10), H = parseInt(K.borderBottomWidth, 10), q = 0, B = 0, X = "offsetWidth" in k ? k.offsetWidth - k.clientWidth - Y - j : 0, te = "offsetHeight" in k ? k.offsetHeight - k.clientHeight - U - H : 0, J = "offsetWidth" in k ? k.offsetWidth === 0 ? 0 : L / k.offsetWidth : 0, G = "offsetHeight" in k ? k.offsetHeight === 0 ? 0 : $ / k.offsetHeight : 0;
    if (p === k)
      q = c === "start" ? P : c === "end" ? P - y : c === "nearest" ? Bl(C, C + y, y, U, H, C + P, C + P + w, w) : P - y / 2, B = u === "start" ? I : u === "center" ? I - v / 2 : u === "end" ? I - v : Bl(x, x + v, v, Y, j, x + I, x + I + E, E), q = Math.max(0, q + C), B = Math.max(0, B + x);
    else {
      q = c === "start" ? P - A - U : c === "end" ? P - N + H + te : c === "nearest" ? Bl(A, N, $, U, H + te, P, P + w, w) : P - (A + $ / 2) + te / 2, B = u === "start" ? I - V - Y : u === "center" ? I - (V + L / 2) + X / 2 : u === "end" ? I - F + j + X : Bl(V, F, L, Y, j + X, I, I + E, E);
      let { scrollLeft: ne, scrollTop: Q } = k;
      q = Math.max(0, Math.min(Q + q / G, k.scrollHeight - $ / G + te)), B = Math.max(0, Math.min(ne + B / J, k.scrollWidth - L / J + X)), P += Q - q, I += ne - B;
    }
    R.push({ el: k, top: q, left: B });
  }
  return R;
}, uH = 0;
function Oy(e) {
  return typeof e == "function" ? e : rr;
}
function rr() {
}
function VS(e, t) {
  if (e) {
    var n = cH(e, {
      boundary: t,
      block: "nearest",
      scrollMode: "if-needed"
    });
    n.forEach(function(r) {
      var o = r.el, s = r.top, i = r.left;
      o.scrollTop = s, o.scrollLeft = i;
    });
  }
}
function My(e, t, n) {
  var r = e === t || t instanceof n.Node && e.contains && e.contains(t);
  return r;
}
function Jg(e, t) {
  var n;
  function r() {
    n && clearTimeout(n);
  }
  function o() {
    for (var s = arguments.length, i = new Array(s), a = 0; a < s; a++)
      i[a] = arguments[a];
    r(), n = setTimeout(function() {
      n = null, e.apply(void 0, i);
    }, t);
  }
  return o.cancel = r, o;
}
function mn() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
      s[i - 1] = arguments[i];
    return t.some(function(a) {
      return a && a.apply(void 0, [r].concat(s)), r.preventDownshiftDefault || r.hasOwnProperty("nativeEvent") && r.nativeEvent.preventDownshiftDefault;
    });
  };
}
function Ws() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    t.forEach(function(o) {
      typeof o == "function" ? o(r) : o && (o.current = r);
    });
  };
}
function WS() {
  return String(uH++);
}
function HS(e) {
  var t = e.isOpen, n = e.resultCount, r = e.previousResultCount;
  return t ? n ? n !== r ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function Ty(e, t) {
  return e = Array.isArray(e) ? (
    /* istanbul ignore next (preact) */
    e[0]
  ) : e, !e && t ? t : e;
}
function BS(e) {
  return typeof e.type == "string";
}
function zS(e) {
  return e.props;
}
function dH(e, t) {
  console.error('The property "' + t + '" is required in "' + e + '"');
}
var fH = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function zl(e) {
  e === void 0 && (e = {});
  var t = {};
  return fH.forEach(function(n) {
    e.hasOwnProperty(n) && (t[n] = e[n]);
  }), t;
}
function Gc(e, t) {
  return Object.keys(e).reduce(function(n, r) {
    return n[r] = Kc(t, r) ? t[r] : e[r], n;
  }, {});
}
function Kc(e, t) {
  return e[t] !== void 0;
}
function Ch(e) {
  var t = e.key, n = e.keyCode;
  return n >= 37 && n <= 40 && t.indexOf("Arrow") !== 0 ? "Arrow" + t : t;
}
function hH(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function is(e, t, n, r, o) {
  o === void 0 && (o = !1);
  var s = n.length;
  if (s === 0)
    return -1;
  var i = s - 1;
  (typeof e != "number" || e < 0 || e > i) && (e = t > 0 ? -1 : i + 1);
  var a = e + t;
  a < 0 ? a = o ? i : 0 : a > i && (a = o ? 0 : i);
  var l = si(a, t < 0, n, r, o);
  return l === -1 ? e >= s ? -1 : e : l;
}
function si(e, t, n, r, o) {
  o === void 0 && (o = !1);
  var s = n.length;
  if (t) {
    for (var i = e; i >= 0; i--)
      if (!r(n[i], i))
        return i;
  } else
    for (var a = e; a < s; a++)
      if (!r(n[a], a))
        return a;
  return o ? si(t ? s - 1 : 0, t, n, r) : -1;
}
function qc(e, t, n, r) {
  return r === void 0 && (r = !0), t.some(function(o) {
    return o && (My(o, e, n) || r && My(o, n.document.activeElement, n));
  });
}
var em = rr;
process.env.NODE_ENV !== "production" && (em = function(t, n, r) {
  var o = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(t).forEach(function(s) {
    n[s] !== void 0 && r[s] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + s + '" to be uncontrolled. ' + o) : n[s] === void 0 && r[s] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + s + '" to be controlled. ' + o);
  });
});
var pH = Jg(function(e) {
  jS(e).textContent = "";
}, 500);
function YS(e, t) {
  var n = jS(t);
  e && (n.textContent = e, pH(t));
}
function jS(e) {
  e === void 0 && (e = document);
  var t = e.getElementById("a11y-status-message");
  return t || (t = e.createElement("div"), t.setAttribute("id", "a11y-status-message"), t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-relevant", "additions text"), Object.assign(t.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(t), t);
}
var US = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, GS = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, KS = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, oc = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, sc = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, qS = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, XS = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, ZS = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, QS = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, JS = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, eO = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, tO = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, nO = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, Eh = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, rO = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, oO = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, sO = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, gH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  unknown: US,
  mouseUp: GS,
  itemMouseEnter: KS,
  keyDownArrowUp: oc,
  keyDownArrowDown: sc,
  keyDownEscape: qS,
  keyDownEnter: XS,
  keyDownHome: ZS,
  keyDownEnd: QS,
  clickItem: JS,
  blurInput: eO,
  changeInput: tO,
  keyDownSpaceButton: nO,
  clickButton: Eh,
  blurButton: rO,
  controlledPropUpdatedSelectedItem: oO,
  touchEnd: sO
}), mH = ["refKey", "ref"], bH = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], vH = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], yH = ["refKey", "ref"], xH = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], wH = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ function(t) {
    XW(n, t);
    function n(o) {
      var s;
      s = t.call(this, o) || this, s.id = s.props.id || "downshift-" + WS(), s.menuId = s.props.menuId || s.id + "-menu", s.labelId = s.props.labelId || s.id + "-label", s.inputId = s.props.inputId || s.id + "-input", s.getItemId = s.props.getItemId || function(y) {
        return s.id + "-item-" + y;
      }, s.input = null, s.items = [], s.itemCount = null, s.previousResultCount = 0, s.timeoutIds = [], s.internalSetTimeout = function(y, x) {
        var C = setTimeout(function() {
          s.timeoutIds = s.timeoutIds.filter(function(w) {
            return w !== C;
          }), y();
        }, x);
        s.timeoutIds.push(C);
      }, s.setItemCount = function(y) {
        s.itemCount = y;
      }, s.unsetItemCount = function() {
        s.itemCount = null;
      }, s.isItemDisabled = function(y, x) {
        var C = s.getItemNodeFromIndex(x);
        return C && C.hasAttribute("disabled");
      }, s.setHighlightedIndex = function(y, x) {
        y === void 0 && (y = s.props.defaultHighlightedIndex), x === void 0 && (x = {}), x = zl(x), s.internalSetState(Xe({
          highlightedIndex: y
        }, x));
      }, s.clearSelection = function(y) {
        s.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: s.props.defaultHighlightedIndex,
          isOpen: s.props.defaultIsOpen
        }, y);
      }, s.selectItem = function(y, x, C) {
        x = zl(x), s.internalSetState(Xe({
          isOpen: s.props.defaultIsOpen,
          highlightedIndex: s.props.defaultHighlightedIndex,
          selectedItem: y,
          inputValue: s.props.itemToString(y)
        }, x), C);
      }, s.selectItemAtIndex = function(y, x, C) {
        var w = s.items[y];
        w != null && s.selectItem(w, x, C);
      }, s.selectHighlightedItem = function(y, x) {
        return s.selectItemAtIndex(s.getState().highlightedIndex, y, x);
      }, s.internalSetState = function(y, x) {
        var C, w, E = {}, S = typeof y == "function";
        return !S && y.hasOwnProperty("inputValue") && s.props.onInputValueChange(y.inputValue, Xe({}, s.getStateAndHelpers(), y)), s.setState(function(O) {
          O = s.getState(O);
          var M = S ? y(O) : y;
          M = s.props.stateReducer(O, M), C = M.hasOwnProperty("selectedItem");
          var T = {};
          return C && M.selectedItem !== O.selectedItem && (w = M.selectedItem), M.type = M.type || US, Object.keys(M).forEach(function(P) {
            O[P] !== M[P] && (E[P] = M[P]), P !== "type" && (M[P], Kc(s.props, P) || (T[P] = M[P]));
          }), S && M.hasOwnProperty("inputValue") && s.props.onInputValueChange(M.inputValue, Xe({}, s.getStateAndHelpers(), M)), T;
        }, function() {
          Oy(x)();
          var O = Object.keys(E).length > 1;
          O && s.props.onStateChange(E, s.getStateAndHelpers()), C && s.props.onSelect(y.selectedItem, s.getStateAndHelpers()), w !== void 0 && s.props.onChange(w, s.getStateAndHelpers()), s.props.onUserAction(E, s.getStateAndHelpers());
        });
      }, s.rootRef = function(y) {
        return s._rootNode = y;
      }, s.getRootProps = function(y, x) {
        var C, w = y === void 0 ? {} : y, E = w.refKey, S = E === void 0 ? "ref" : E, O = w.ref, M = Ir(w, mH), T = x === void 0 ? {} : x, P = T.suppressRefError, I = P === void 0 ? !1 : P;
        s.getRootProps.called = !0, s.getRootProps.refKey = S, s.getRootProps.suppressRefError = I;
        var R = s.getState(), D = R.isOpen;
        return Xe((C = {}, C[S] = Ws(O, s.rootRef), C.role = "combobox", C["aria-expanded"] = D, C["aria-haspopup"] = "listbox", C["aria-owns"] = D ? s.menuId : void 0, C["aria-labelledby"] = s.labelId, C), M);
      }, s.keyDownHandlers = {
        ArrowDown: function(x) {
          var C = this;
          if (x.preventDefault(), this.getState().isOpen) {
            var w = x.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(w, {
              type: sc
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: sc
            }, function() {
              var E = C.getItemCount();
              if (E > 0) {
                var S = C.getState(), O = S.highlightedIndex, M = is(O, 1, {
                  length: E
                }, C.isItemDisabled, !0);
                C.setHighlightedIndex(M, {
                  type: sc
                });
              }
            });
        },
        ArrowUp: function(x) {
          var C = this;
          if (x.preventDefault(), this.getState().isOpen) {
            var w = x.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(w, {
              type: oc
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: oc
            }, function() {
              var E = C.getItemCount();
              if (E > 0) {
                var S = C.getState(), O = S.highlightedIndex, M = is(O, -1, {
                  length: E
                }, C.isItemDisabled, !0);
                C.setHighlightedIndex(M, {
                  type: oc
                });
              }
            });
        },
        Enter: function(x) {
          if (x.which !== 229) {
            var C = this.getState(), w = C.isOpen, E = C.highlightedIndex;
            if (w && E != null) {
              x.preventDefault();
              var S = this.items[E], O = this.getItemNodeFromIndex(E);
              if (S == null || O && O.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: XS
              });
            }
          }
        },
        Escape: function(x) {
          x.preventDefault(), this.reset(Xe({
            type: qS
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, s.buttonKeyDownHandlers = Xe({}, s.keyDownHandlers, {
        " ": function(x) {
          x.preventDefault(), this.toggleMenu({
            type: nO
          });
        }
      }), s.inputKeyDownHandlers = Xe({}, s.keyDownHandlers, {
        Home: function(x) {
          var C = this.getState(), w = C.isOpen;
          if (w) {
            x.preventDefault();
            var E = this.getItemCount();
            if (!(E <= 0 || !w)) {
              var S = si(0, !1, {
                length: E
              }, this.isItemDisabled);
              this.setHighlightedIndex(S, {
                type: ZS
              });
            }
          }
        },
        End: function(x) {
          var C = this.getState(), w = C.isOpen;
          if (w) {
            x.preventDefault();
            var E = this.getItemCount();
            if (!(E <= 0 || !w)) {
              var S = si(E - 1, !0, {
                length: E
              }, this.isItemDisabled);
              this.setHighlightedIndex(S, {
                type: QS
              });
            }
          }
        }
      }), s.getToggleButtonProps = function(y) {
        var x = y === void 0 ? {} : y, C = x.onClick;
        x.onPress;
        var w = x.onKeyDown, E = x.onKeyUp, S = x.onBlur, O = Ir(x, bH), M = s.getState(), T = M.isOpen, P = {
          onClick: mn(C, s.buttonHandleClick),
          onKeyDown: mn(w, s.buttonHandleKeyDown),
          onKeyUp: mn(E, s.buttonHandleKeyUp),
          onBlur: mn(S, s.buttonHandleBlur)
        }, I = O.disabled ? {} : P;
        return Xe({
          type: "button",
          role: "button",
          "aria-label": T ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, I, O);
      }, s.buttonHandleKeyUp = function(y) {
        y.preventDefault();
      }, s.buttonHandleKeyDown = function(y) {
        var x = Ch(y);
        s.buttonKeyDownHandlers[x] && s.buttonKeyDownHandlers[x].call(dy(s), y);
      }, s.buttonHandleClick = function(y) {
        y.preventDefault(), s.props.environment.document.activeElement === s.props.environment.document.body && y.target.focus(), process.env.NODE_ENV === "test" ? s.toggleMenu({
          type: Eh
        }) : s.internalSetTimeout(function() {
          return s.toggleMenu({
            type: Eh
          });
        });
      }, s.buttonHandleBlur = function(y) {
        var x = y.target;
        s.internalSetTimeout(function() {
          !s.isMouseDown && (s.props.environment.document.activeElement == null || s.props.environment.document.activeElement.id !== s.inputId) && s.props.environment.document.activeElement !== x && s.reset({
            type: rO
          });
        });
      }, s.getLabelProps = function(y) {
        return Xe({
          htmlFor: s.inputId,
          id: s.labelId
        }, y);
      }, s.getInputProps = function(y) {
        var x = y === void 0 ? {} : y, C = x.onKeyDown, w = x.onBlur, E = x.onChange, S = x.onInput;
        x.onChangeText;
        var O = Ir(x, vH), M, T = {};
        M = "onChange";
        var P = s.getState(), I = P.inputValue, R = P.isOpen, D = P.highlightedIndex;
        if (!O.disabled) {
          var k;
          T = (k = {}, k[M] = mn(E, S, s.inputHandleChange), k.onKeyDown = mn(C, s.inputHandleKeyDown), k.onBlur = mn(w, s.inputHandleBlur), k);
        }
        return Xe({
          "aria-autocomplete": "list",
          "aria-activedescendant": R && typeof D == "number" && D >= 0 ? s.getItemId(D) : void 0,
          "aria-controls": R ? s.menuId : void 0,
          "aria-labelledby": O && O["aria-label"] ? void 0 : s.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: I,
          id: s.inputId
        }, T, O);
      }, s.inputHandleKeyDown = function(y) {
        var x = Ch(y);
        x && s.inputKeyDownHandlers[x] && s.inputKeyDownHandlers[x].call(dy(s), y);
      }, s.inputHandleChange = function(y) {
        s.internalSetState({
          type: tO,
          isOpen: !0,
          inputValue: y.target.value,
          highlightedIndex: s.props.defaultHighlightedIndex
        });
      }, s.inputHandleBlur = function() {
        s.internalSetTimeout(function() {
          var y = s.props.environment.document && !!s.props.environment.document.activeElement && !!s.props.environment.document.activeElement.dataset && s.props.environment.document.activeElement.dataset.toggle && s._rootNode && s._rootNode.contains(s.props.environment.document.activeElement);
          !s.isMouseDown && !y && s.reset({
            type: eO
          });
        });
      }, s.menuRef = function(y) {
        s._menuNode = y;
      }, s.getMenuProps = function(y, x) {
        var C, w = y === void 0 ? {} : y, E = w.refKey, S = E === void 0 ? "ref" : E, O = w.ref, M = Ir(w, yH), T = x === void 0 ? {} : x, P = T.suppressRefError, I = P === void 0 ? !1 : P;
        return s.getMenuProps.called = !0, s.getMenuProps.refKey = S, s.getMenuProps.suppressRefError = I, Xe((C = {}, C[S] = Ws(O, s.menuRef), C.role = "listbox", C["aria-labelledby"] = M && M["aria-label"] ? void 0 : s.labelId, C.id = s.menuId, C), M);
      }, s.getItemProps = function(y) {
        var x, C = y === void 0 ? {} : y, w = C.onMouseMove, E = C.onMouseDown, S = C.onClick;
        C.onPress;
        var O = C.index, M = C.item, T = M === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : dH("getItemProps", "item") : M, P = Ir(C, xH);
        O === void 0 ? (s.items.push(T), O = s.items.indexOf(T)) : s.items[O] = T;
        var I = "onClick", R = S, D = (x = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: mn(w, function() {
            O !== s.getState().highlightedIndex && (s.setHighlightedIndex(O, {
              type: KS
            }), s.avoidScrolling = !0, s.internalSetTimeout(function() {
              return s.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: mn(E, function($) {
            $.preventDefault();
          })
        }, x[I] = mn(R, function() {
          s.selectItemAtIndex(O, {
            type: JS
          });
        }), x), k = P.disabled ? {
          onMouseDown: D.onMouseDown
        } : D;
        return Xe({
          id: s.getItemId(O),
          role: "option",
          "aria-selected": s.getState().highlightedIndex === O
        }, k, P);
      }, s.clearItems = function() {
        s.items = [];
      }, s.reset = function(y, x) {
        y === void 0 && (y = {}), y = zl(y), s.internalSetState(function(C) {
          var w = C.selectedItem;
          return Xe({
            isOpen: s.props.defaultIsOpen,
            highlightedIndex: s.props.defaultHighlightedIndex,
            inputValue: s.props.itemToString(w)
          }, y);
        }, x);
      }, s.toggleMenu = function(y, x) {
        y === void 0 && (y = {}), y = zl(y), s.internalSetState(function(C) {
          var w = C.isOpen;
          return Xe({
            isOpen: !w
          }, w && {
            highlightedIndex: s.props.defaultHighlightedIndex
          }, y);
        }, function() {
          var C = s.getState(), w = C.isOpen, E = C.highlightedIndex;
          w && s.getItemCount() > 0 && typeof E == "number" && s.setHighlightedIndex(E, y), Oy(x)();
        });
      }, s.openMenu = function(y) {
        s.internalSetState({
          isOpen: !0
        }, y);
      }, s.closeMenu = function(y) {
        s.internalSetState({
          isOpen: !1
        }, y);
      }, s.updateStatus = Jg(function() {
        var y = s.getState(), x = s.items[y.highlightedIndex], C = s.getItemCount(), w = s.props.getA11yStatusMessage(Xe({
          itemToString: s.props.itemToString,
          previousResultCount: s.previousResultCount,
          resultCount: C,
          highlightedItem: x
        }, y));
        s.previousResultCount = C, YS(w, s.props.environment.document);
      }, 200);
      var i = s.props, a = i.defaultHighlightedIndex, l = i.initialHighlightedIndex, c = l === void 0 ? a : l, u = i.defaultIsOpen, d = i.initialIsOpen, f = d === void 0 ? u : d, h = i.initialInputValue, p = h === void 0 ? "" : h, g = i.initialSelectedItem, m = g === void 0 ? null : g, v = s.getState({
        highlightedIndex: c,
        isOpen: f,
        inputValue: p,
        selectedItem: m
      });
      return v.selectedItem != null && s.props.initialInputValue === void 0 && (v.inputValue = s.props.itemToString(v.selectedItem)), s.state = v, s;
    }
    var r = n.prototype;
    return r.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(s) {
        clearTimeout(s);
      }), this.timeoutIds = [];
    }, r.getState = function(s) {
      return s === void 0 && (s = this.state), Gc(s, this.props);
    }, r.getItemCount = function() {
      var s = this.items.length;
      return this.itemCount != null ? s = this.itemCount : this.props.itemCount !== void 0 && (s = this.props.itemCount), s;
    }, r.getItemNodeFromIndex = function(s) {
      return this.props.environment.document.getElementById(this.getItemId(s));
    }, r.scrollHighlightedItemIntoView = function() {
      {
        var s = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(s, this._menuNode);
      }
    }, r.moveHighlightedIndex = function(s, i) {
      var a = this.getItemCount(), l = this.getState(), c = l.highlightedIndex;
      if (a > 0) {
        var u = is(c, s, {
          length: a
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(u, i);
      }
    }, r.getStateAndHelpers = function() {
      var s = this.getState(), i = s.highlightedIndex, a = s.inputValue, l = s.selectedItem, c = s.isOpen, u = this.props.itemToString, d = this.id, f = this.getRootProps, h = this.getToggleButtonProps, p = this.getLabelProps, g = this.getMenuProps, m = this.getInputProps, v = this.getItemProps, y = this.openMenu, x = this.closeMenu, C = this.toggleMenu, w = this.selectItem, E = this.selectItemAtIndex, S = this.selectHighlightedItem, O = this.setHighlightedIndex, M = this.clearSelection, T = this.clearItems, P = this.reset, I = this.setItemCount, R = this.unsetItemCount, D = this.internalSetState;
      return {
        // prop getters
        getRootProps: f,
        getToggleButtonProps: h,
        getLabelProps: p,
        getMenuProps: g,
        getInputProps: m,
        getItemProps: v,
        // actions
        reset: P,
        openMenu: y,
        closeMenu: x,
        toggleMenu: C,
        selectItem: w,
        selectItemAtIndex: E,
        selectHighlightedItem: S,
        setHighlightedIndex: O,
        clearSelection: M,
        clearItems: T,
        setItemCount: I,
        unsetItemCount: R,
        setState: D,
        // props
        itemToString: u,
        // derived
        id: d,
        // state
        highlightedIndex: i,
        inputValue: a,
        isOpen: c,
        selectedItem: l
      };
    }, r.componentDidMount = function() {
      var s = this;
      process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && Ry(this._menuNode, this.getMenuProps);
      {
        var i = function() {
          s.isMouseDown = !0;
        }, a = function(h) {
          s.isMouseDown = !1;
          var p = qc(h.target, [s._rootNode, s._menuNode], s.props.environment);
          !p && s.getState().isOpen && s.reset({
            type: GS
          }, function() {
            return s.props.onOuterClick(s.getStateAndHelpers());
          });
        }, l = function() {
          s.isTouchMove = !1;
        }, c = function() {
          s.isTouchMove = !0;
        }, u = function(h) {
          var p = qc(h.target, [s._rootNode, s._menuNode], s.props.environment, !1);
          !s.isTouchMove && !p && s.getState().isOpen && s.reset({
            type: sO
          }, function() {
            return s.props.onOuterClick(s.getStateAndHelpers());
          });
        }, d = this.props.environment;
        d.addEventListener("mousedown", i), d.addEventListener("mouseup", a), d.addEventListener("touchstart", l), d.addEventListener("touchmove", c), d.addEventListener("touchend", u), this.cleanup = function() {
          s.internalClearTimeouts(), s.updateStatus.cancel(), d.removeEventListener("mousedown", i), d.removeEventListener("mouseup", a), d.removeEventListener("touchstart", l), d.removeEventListener("touchmove", c), d.removeEventListener("touchend", u);
        };
      }
    }, r.shouldScroll = function(s, i) {
      var a = this.props.highlightedIndex === void 0 ? this.getState() : this.props, l = a.highlightedIndex, c = i.highlightedIndex === void 0 ? s : i, u = c.highlightedIndex, d = l && this.getState().isOpen && !s.isOpen, f = l !== u;
      return d || f;
    }, r.componentDidUpdate = function(s, i) {
      process.env.NODE_ENV !== "production" && (em(this.state, s, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && Ry(this._menuNode, this.getMenuProps)), Kc(this.props, "selectedItem") && this.props.selectedItemChanged(s.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: oO,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(i, s) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, r.componentWillUnmount = function() {
      this.cleanup();
    }, r.render = function() {
      var s = Ty(this.props.children, rr);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var i = Ty(s(this.getStateAndHelpers()));
      if (!i)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && CH(i, this.getRootProps), i;
      if (BS(i))
        return /* @__PURE__ */ Zc(i, this.getRootProps(zS(i)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, n;
  }(YO);
  return e.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: HS,
    itemToString: function(n) {
      return n == null ? "" : (process.env.NODE_ENV !== "production" && hH(n) && !n.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", n), String(n));
    },
    onStateChange: rr,
    onInputValueChange: rr,
    onUserAction: rr,
    onChange: rr,
    onSelect: rr,
    onOuterClick: rr,
    selectedItemChanged: function(n, r) {
      return n !== r;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? {} : window
    ),
    stateReducer: function(n, r) {
      return r;
    },
    suppressRefError: !1,
    scrollIntoView: VS
  }, e.stateChangeTypes = gH, e;
}();
process.env.NODE_ENV !== "production" && (wH.propTypes = {
  children: ve.func,
  defaultHighlightedIndex: ve.number,
  defaultIsOpen: ve.bool,
  initialHighlightedIndex: ve.number,
  initialSelectedItem: ve.any,
  initialInputValue: ve.string,
  initialIsOpen: ve.bool,
  getA11yStatusMessage: ve.func,
  itemToString: ve.func,
  onChange: ve.func,
  onSelect: ve.func,
  onStateChange: ve.func,
  onInputValueChange: ve.func,
  onUserAction: ve.func,
  onOuterClick: ve.func,
  selectedItemChanged: ve.func,
  stateReducer: ve.func,
  itemCount: ve.number,
  id: ve.string,
  environment: ve.shape({
    addEventListener: ve.func.isRequired,
    removeEventListener: ve.func.isRequired,
    document: ve.shape({
      createElement: ve.func.isRequired,
      getElementById: ve.func.isRequired,
      activeElement: ve.any.isRequired,
      body: ve.any.isRequired
    }).isRequired,
    Node: ve.func.isRequired
  }),
  suppressRefError: ve.bool,
  scrollIntoView: ve.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: ve.any,
  isOpen: ve.bool,
  inputValue: ve.string,
  highlightedIndex: ve.number,
  labelId: ve.string,
  inputId: ve.string,
  menuId: ve.string,
  getItemId: ve.func
  /* eslint-enable react/no-unused-prop-types */
});
function Ry(e, t) {
  var n = t.refKey;
  e || console.error('downshift: The ref prop "' + n + '" from getMenuProps was not applied correctly on your menu element.');
}
function CH(e, t) {
  var n = t.refKey, r = n !== "ref", o = !BS(e);
  o && !r && !Ey.isForwardRef(e) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !o && r && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + n + '"'), !Ey.isForwardRef(e) && !zS(e)[n] && console.error('downshift: You must apply the ref prop "' + n + '" from getRootProps onto your root element.');
}
var EH = ["isInitialMount", "highlightedIndex", "items", "environment"], iO = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function _H(e, t, n) {
  var r = e.props, o = e.type, s = {};
  Object.keys(t).forEach(function(i) {
    SH(i, e, t, n), n[i] !== t[i] && (s[i] = n[i]);
  }), r.onStateChange && Object.keys(s).length && r.onStateChange(Xe({
    type: o
  }, s));
}
function SH(e, t, n, r) {
  var o = t.props, s = t.type, i = "on" + tm(e) + "Change";
  o[i] && r[e] !== void 0 && r[e] !== n[e] && o[i](Xe({
    type: s
  }, r));
}
function OH(e, t) {
  return t.changes;
}
function MH(e) {
  var t = e.selectedItem, n = e.itemToString;
  return t ? n(t) + " has been selected." : "";
}
var TH = Jg(function(e, t) {
  YS(e(), t);
}, 200), RH = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? ii : st, PH = "useId" in Oe ? function(t) {
  var n = t.id, r = t.labelId, o = t.menuId, s = t.getItemId, i = t.toggleButtonId, a = t.inputId, l = "downshift-" + Oe.useId();
  n || (n = l);
  var c = et({
    labelId: r || n + "-label",
    menuId: o || n + "-menu",
    getItemId: s || function(u) {
      return n + "-item-" + u;
    },
    toggleButtonId: i || n + "-toggle-button",
    inputId: a || n + "-input"
  });
  return c.current;
} : function(t) {
  var n = t.id, r = n === void 0 ? "downshift-" + WS() : n, o = t.labelId, s = t.menuId, i = t.getItemId, a = t.toggleButtonId, l = t.inputId, c = et({
    labelId: o || r + "-label",
    menuId: s || r + "-menu",
    getItemId: i || function(u) {
      return r + "-item-" + u;
    },
    toggleButtonId: a || r + "-toggle-button",
    inputId: l || r + "-input"
  });
  return c.current;
};
function IH(e, t, n, r) {
  var o, s;
  if (e === void 0) {
    if (t === void 0)
      throw new Error(r);
    o = n[t], s = t;
  } else
    s = t === void 0 ? n.indexOf(e) : t, o = e;
  return [o, s];
}
function kH(e) {
  return e ? String(e) : "";
}
function tm(e) {
  return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
}
function aO(e) {
  var t = et(e);
  return t.current = e, t;
}
function DH(e, t, n) {
  var r = et(), o = et(), s = ot(function(f, h) {
    o.current = h, f = Gc(f, h.props);
    var p = e(f, h), g = h.props.stateReducer(f, Xe({}, h, {
      changes: p
    }));
    return g;
  }, [e]), i = Dy(s, t), a = i[0], l = i[1], c = aO(n), u = ot(function(f) {
    return l(Xe({
      props: c.current
    }, f));
  }, [c]), d = o.current;
  return st(function() {
    d && r.current && r.current !== a && _H(d, Gc(r.current, d.props), a), r.current = a;
  }, [a, n, d]), [a, u];
}
var oa = {
  itemToString: kH,
  stateReducer: OH,
  getA11ySelectionMessage: MH,
  scrollIntoView: VS,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? {} : window
  )
};
function Nr(e, t, n) {
  n === void 0 && (n = iO);
  var r = e["default" + tm(t)];
  return r !== void 0 ? r : n[t];
}
function Ki(e, t, n) {
  n === void 0 && (n = iO);
  var r = e[t];
  if (r !== void 0)
    return r;
  var o = e["initial" + tm(t)];
  return o !== void 0 ? o : Nr(e, t, n);
}
function NH(e) {
  var t = Ki(e, "selectedItem"), n = Ki(e, "isOpen"), r = Ki(e, "highlightedIndex"), o = Ki(e, "inputValue");
  return {
    highlightedIndex: r < 0 && t && n ? e.items.indexOf(t) : r,
    isOpen: n,
    selectedItem: t,
    inputValue: o
  };
}
function sa(e, t, n) {
  var r = e.items, o = e.initialHighlightedIndex, s = e.defaultHighlightedIndex, i = t.selectedItem, a = t.highlightedIndex;
  return r.length === 0 ? -1 : o !== void 0 && a === o ? o : s !== void 0 ? s : i ? r.indexOf(i) : n === 0 ? -1 : n < 0 ? r.length - 1 : 0;
}
function AH(e, t, n, r) {
  var o = et({
    isMouseDown: !1,
    isTouchMove: !1
  });
  return st(function() {
    if ((n == null ? void 0 : n.addEventListener) != null) {
      var s = function() {
        o.current.isMouseDown = !0;
      }, i = function(d) {
        o.current.isMouseDown = !1, e && !qc(d.target, t.map(function(f) {
          return f.current;
        }), n) && r();
      }, a = function() {
        o.current.isTouchMove = !1;
      }, l = function() {
        o.current.isTouchMove = !0;
      }, c = function(d) {
        e && !o.current.isTouchMove && !qc(d.target, t.map(function(f) {
          return f.current;
        }), n, !1) && r();
      };
      return n.addEventListener("mousedown", s), n.addEventListener("mouseup", i), n.addEventListener("touchstart", a), n.addEventListener("touchmove", l), n.addEventListener("touchend", c), function() {
        n.removeEventListener("mousedown", s), n.removeEventListener("mouseup", i), n.removeEventListener("touchstart", a), n.removeEventListener("touchmove", l), n.removeEventListener("touchend", c);
      };
    }
  }, [e, n]), o;
}
var lO = function() {
  return rr;
};
process.env.NODE_ENV !== "production" && (lO = function() {
  for (var t = et(!0), n = arguments.length, r = new Array(n), o = 0; o < n; o++)
    r[o] = arguments[o];
  var s = et(r.reduce(function(a, l) {
    return a[l] = {}, a;
  }, {}));
  st(function() {
    Object.keys(s.current).forEach(function(a) {
      var l = s.current[a];
      if (t.current && !Object.keys(l).length) {
        console.error("downshift: You forgot to call the " + a + " getter function on your component / element.");
        return;
      }
      var c = l.suppressRefError, u = l.refKey, d = l.elementRef;
      (!d || !d.current) && !c && console.error('downshift: The ref prop "' + u + '" from ' + a + " was not applied correctly on your element.");
    }), t.current = !1;
  });
  var i = ot(function(a, l, c, u) {
    s.current[a] = {
      suppressRefError: l,
      refKey: c,
      elementRef: u
    };
  }, []);
  return i;
});
function Py(e, t, n) {
  var r = n.isInitialMount, o = n.highlightedIndex, s = n.items, i = n.environment, a = Ir(n, EH);
  st(function() {
    r || TH(function() {
      return e(Xe({
        highlightedIndex: o,
        highlightedItem: s[o],
        resultCount: s.length
      }, a));
    }, i.document);
  }, t);
}
function $H(e) {
  var t = e.highlightedIndex, n = e.isOpen, r = e.itemRefs, o = e.getItemNodeFromIndex, s = e.menuElement, i = e.scrollIntoView, a = et(!0);
  return RH(function() {
    t < 0 || !n || !Object.keys(r.current).length || (a.current === !1 ? a.current = !0 : i(o(t), s));
  }, [t]), a;
}
var cO = rr;
process.env.NODE_ENV !== "production" && (cO = function(t) {
  var n = t.isInitialMount, r = t.props, o = t.state, s = et(r);
  st(function() {
    n || (em(o, s.current, r), s.current = r);
  }, [o, r, n]);
});
function Iy(e, t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = ((r = e.items) == null ? void 0 : r.length) && t >= 0;
  return Xe({
    isOpen: !1,
    highlightedIndex: -1
  }, o && Xe({
    selectedItem: e.items[t],
    isOpen: Nr(e, "isOpen"),
    highlightedIndex: Nr(e, "highlightedIndex")
  }, n && {
    inputValue: e.itemToString(e.items[t])
  }));
}
var uO = {
  environment: ve.shape({
    addEventListener: ve.func.isRequired,
    removeEventListener: ve.func.isRequired,
    document: ve.shape({
      createElement: ve.func.isRequired,
      getElementById: ve.func.isRequired,
      activeElement: ve.any.isRequired,
      body: ve.any.isRequired
    }).isRequired,
    Node: ve.func.isRequired
  }),
  itemToString: ve.func,
  stateReducer: ve.func
}, dO = Xe({}, uO, {
  getA11yStatusMessage: ve.func,
  highlightedIndex: ve.number,
  defaultHighlightedIndex: ve.number,
  initialHighlightedIndex: ve.number,
  isOpen: ve.bool,
  defaultIsOpen: ve.bool,
  initialIsOpen: ve.bool,
  selectedItem: ve.any,
  initialSelectedItem: ve.any,
  defaultSelectedItem: ve.any,
  id: ve.string,
  labelId: ve.string,
  menuId: ve.string,
  getItemId: ve.func,
  toggleButtonId: ve.string,
  onSelectedItemChange: ve.func,
  onHighlightedIndexChange: ve.func,
  onStateChange: ve.func,
  onIsOpenChange: ve.func,
  scrollIntoView: ve.func
});
function FH(e, t, n) {
  var r = t.type, o = t.props, s;
  switch (r) {
    case n.ItemMouseMove:
      s = {
        highlightedIndex: t.disabled ? -1 : t.index
      };
      break;
    case n.MenuMouseLeave:
      s = {
        highlightedIndex: -1
      };
      break;
    case n.ToggleButtonClick:
    case n.FunctionToggleMenu:
      s = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : sa(o, e, 0)
      };
      break;
    case n.FunctionOpenMenu:
      s = {
        isOpen: !0,
        highlightedIndex: sa(o, e, 0)
      };
      break;
    case n.FunctionCloseMenu:
      s = {
        isOpen: !1
      };
      break;
    case n.FunctionSetHighlightedIndex:
      s = {
        highlightedIndex: t.highlightedIndex
      };
      break;
    case n.FunctionSetInputValue:
      s = {
        inputValue: t.inputValue
      };
      break;
    case n.FunctionReset:
      s = {
        highlightedIndex: Nr(o, "highlightedIndex"),
        isOpen: Nr(o, "isOpen"),
        selectedItem: Nr(o, "selectedItem"),
        inputValue: Nr(o, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return Xe({}, e, s);
}
Fn(Fn({}, dO), { items: ve.array.isRequired, isItemDisabled: ve.func, getA11ySelectionMessage: ve.func });
function LH(e) {
  var t = e.isOpen, n = e.resultCount, r = e.previousResultCount;
  return t ? n ? n !== r ? "".concat(n, " result").concat(n === 1 ? " is" : "s are", " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.") : "" : "No results are available." : "";
}
Fn(Fn({}, oa), { getA11yStatusMessage: LH, isItemDisabled: function() {
  return !1;
} });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var nm = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, rm = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, om = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, sm = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, im = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, am = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, lm = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, cm = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, um = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, Xc = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, dm = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, fO = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, hO = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, fm = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, pO = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, gO = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, mO = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, bO = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, vO = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, hm = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, yO = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, xO = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, pm = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, wO = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: nm,
  InputKeyDownArrowUp: rm,
  InputKeyDownEscape: om,
  InputKeyDownHome: sm,
  InputKeyDownEnd: im,
  InputKeyDownPageUp: am,
  InputKeyDownPageDown: lm,
  InputKeyDownEnter: cm,
  InputChange: um,
  InputBlur: Xc,
  InputClick: dm,
  MenuMouseLeave: fO,
  ItemMouseMove: hO,
  ItemClick: fm,
  ToggleButtonClick: pO,
  FunctionToggleMenu: gO,
  FunctionOpenMenu: mO,
  FunctionCloseMenu: bO,
  FunctionSetHighlightedIndex: vO,
  FunctionSelectItem: hm,
  FunctionSetInputValue: yO,
  FunctionReset: xO,
  ControlledPropUpdatedSelectedItem: pm
});
function VH(e) {
  var t = NH(e), n = t.selectedItem, r = t.inputValue;
  return r === "" && n && e.defaultInputValue === void 0 && e.initialInputValue === void 0 && e.inputValue === void 0 && (r = e.itemToString(n)), Xe({}, t, {
    inputValue: r
  });
}
var WH = Xe({}, dO, {
  items: ve.array.isRequired,
  isItemDisabled: ve.func,
  selectedItemChanged: ve.func,
  getA11ySelectionMessage: ve.func,
  inputValue: ve.string,
  defaultInputValue: ve.string,
  initialInputValue: ve.string,
  inputId: ve.string,
  onInputValueChange: ve.func
});
function HH(e, t, n) {
  var r = et(), o = DH(e, t, n), s = o[0], i = o[1];
  return st(function() {
    Kc(n, "selectedItem") && (n.selectedItemChanged(r.current, n.selectedItem) && i({
      type: pm,
      inputValue: n.itemToString(n.selectedItem)
    }), r.current = s.selectedItem === r.current ? n.selectedItem : s.selectedItem);
  }, [s.selectedItem, n.selectedItem]), [Gc(s, n), i];
}
var CO = rr;
process.env.NODE_ENV !== "production" && (CO = function(t, n) {
  ve.checkPropTypes(WH, t, "prop", n.name);
});
var BH = Xe({}, oa, {
  selectedItemChanged: function(t, n) {
    return t !== n;
  },
  getA11yStatusMessage: HS,
  isItemDisabled: function() {
    return !1;
  }
});
function zH(e, t) {
  var n, r = t.type, o = t.props, s = t.altKey, i;
  switch (r) {
    case fm:
      i = {
        isOpen: Nr(o, "isOpen"),
        highlightedIndex: Nr(o, "highlightedIndex"),
        selectedItem: o.items[t.index],
        inputValue: o.itemToString(o.items[t.index])
      };
      break;
    case nm:
      e.isOpen ? i = {
        highlightedIndex: is(e.highlightedIndex, 1, o.items, o.isItemDisabled, !0)
      } : i = {
        highlightedIndex: s && e.selectedItem == null ? -1 : sa(o, e, 1),
        isOpen: o.items.length >= 0
      };
      break;
    case rm:
      e.isOpen ? s ? i = Iy(o, e.highlightedIndex) : i = {
        highlightedIndex: is(e.highlightedIndex, -1, o.items, o.isItemDisabled, !0)
      } : i = {
        highlightedIndex: sa(o, e, -1),
        isOpen: o.items.length >= 0
      };
      break;
    case cm:
      i = Iy(o, e.highlightedIndex);
      break;
    case om:
      i = Xe({
        isOpen: !1,
        highlightedIndex: -1
      }, !e.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case am:
      i = {
        highlightedIndex: is(e.highlightedIndex, -10, o.items, o.isItemDisabled, !0)
      };
      break;
    case lm:
      i = {
        highlightedIndex: is(e.highlightedIndex, 10, o.items, o.isItemDisabled, !0)
      };
      break;
    case sm:
      i = {
        highlightedIndex: si(0, !1, o.items, o.isItemDisabled)
      };
      break;
    case im:
      i = {
        highlightedIndex: si(o.items.length - 1, !0, o.items, o.isItemDisabled)
      };
      break;
    case Xc:
      i = Xe({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((n = o.items) == null ? void 0 : n.length) && t.selectItem && {
        selectedItem: o.items[e.highlightedIndex],
        inputValue: o.itemToString(o.items[e.highlightedIndex])
      });
      break;
    case um:
      i = {
        isOpen: !0,
        highlightedIndex: Nr(o, "highlightedIndex"),
        inputValue: t.inputValue
      };
      break;
    case dm:
      i = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : sa(o, e, 0)
      };
      break;
    case hm:
      i = {
        selectedItem: t.selectedItem,
        inputValue: o.itemToString(t.selectedItem)
      };
      break;
    case pm:
      i = {
        inputValue: t.inputValue
      };
      break;
    default:
      return FH(e, t, wO);
  }
  return Xe({}, e, i);
}
var YH = ["onMouseLeave", "refKey", "ref"], jH = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], UH = ["onClick", "onPress", "refKey", "ref"], GH = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
EO.stateChangeTypes = wO;
function EO(e) {
  e === void 0 && (e = {}), CO(e, EO);
  var t = Xe({}, BH, e), n = t.items, r = t.scrollIntoView, o = t.environment, s = t.getA11yStatusMessage, i = t.getA11ySelectionMessage, a = t.itemToString, l = VH(t), c = HH(zH, l, t), u = c[0], d = c[1], f = u.isOpen, h = u.highlightedIndex, p = u.selectedItem, g = u.inputValue, m = et(null), v = et({}), y = et(null), x = et(null), C = et(!0), w = PH(t), E = et(), S = aO({
    state: u,
    props: t
  }), O = ot(function(j) {
    return v.current[w.getItemId(j)];
  }, [w]);
  Py(s, [f, h, g, n], Xe({
    isInitialMount: C.current,
    previousResultCount: E.current,
    items: n,
    environment: o,
    itemToString: a
  }, u)), Py(i, [p], Xe({
    isInitialMount: C.current,
    previousResultCount: E.current,
    items: n,
    environment: o,
    itemToString: a
  }, u));
  var M = $H({
    menuElement: m.current,
    highlightedIndex: h,
    isOpen: f,
    itemRefs: v,
    scrollIntoView: r,
    getItemNodeFromIndex: O
  });
  cO({
    isInitialMount: C.current,
    props: t,
    state: u
  }), st(function() {
    var j = Ki(t, "isOpen");
    j && y.current && y.current.focus();
  }, []), st(function() {
    C.current || (E.current = n.length);
  });
  var T = AH(f, [y, m, x], o, function() {
    d({
      type: Xc,
      selectItem: !1
    });
  }), P = lO("getInputProps", "getMenuProps");
  st(function() {
    return C.current = !1, function() {
      C.current = !0;
    };
  }, []), st(function() {
    var j;
    if (!f)
      v.current = {};
    else if (((j = o.document) == null ? void 0 : j.activeElement) !== y.current) {
      var H;
      y == null || (H = y.current) == null || H.focus();
    }
  }, [f, o]);
  var I = Ar(function() {
    return {
      ArrowDown: function(H) {
        H.preventDefault(), d({
          type: nm,
          altKey: H.altKey
        });
      },
      ArrowUp: function(H) {
        H.preventDefault(), d({
          type: rm,
          altKey: H.altKey
        });
      },
      Home: function(H) {
        S.current.state.isOpen && (H.preventDefault(), d({
          type: sm
        }));
      },
      End: function(H) {
        S.current.state.isOpen && (H.preventDefault(), d({
          type: im
        }));
      },
      Escape: function(H) {
        var q = S.current.state;
        (q.isOpen || q.inputValue || q.selectedItem || q.highlightedIndex > -1) && (H.preventDefault(), d({
          type: om
        }));
      },
      Enter: function(H) {
        var q = S.current.state;
        !q.isOpen || H.which === 229 || (H.preventDefault(), d({
          type: cm
        }));
      },
      PageUp: function(H) {
        S.current.state.isOpen && (H.preventDefault(), d({
          type: am
        }));
      },
      PageDown: function(H) {
        S.current.state.isOpen && (H.preventDefault(), d({
          type: lm
        }));
      }
    };
  }, [d, S]), R = ot(function(j) {
    return Xe({
      id: w.labelId,
      htmlFor: w.inputId
    }, j);
  }, [w]), D = ot(function(j, H) {
    var q, B = j === void 0 ? {} : j, X = B.onMouseLeave, te = B.refKey, J = te === void 0 ? "ref" : te, G = B.ref, ne = Ir(B, YH), Q = H === void 0 ? {} : H, re = Q.suppressRefError, fe = re === void 0 ? !1 : re;
    return P("getMenuProps", fe, J, m), Xe((q = {}, q[J] = Ws(G, function(le) {
      m.current = le;
    }), q.id = w.menuId, q.role = "listbox", q["aria-labelledby"] = ne && ne["aria-label"] ? void 0 : "" + w.labelId, q.onMouseLeave = mn(X, function() {
      d({
        type: fO
      });
    }), q), ne);
  }, [d, P, w]), k = ot(function(j) {
    var H, q, B = j === void 0 ? {} : j, X = B.item, te = B.index, J = B.refKey, G = J === void 0 ? "ref" : J, ne = B.ref, Q = B.onMouseMove, re = B.onMouseDown, fe = B.onClick;
    B.onPress;
    var le = B.disabled, Ee = Ir(B, jH);
    le !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var se = S.current, _e = se.props, xe = se.state, ge = IH(X, te, _e.items, "Pass either item or index to getItemProps!"), ae = ge[0], W = ge[1], Z = _e.isItemDisabled(ae, W), me = "onClick", ie = fe, oe = function() {
      W !== xe.highlightedIndex && (M.current = !1, d({
        type: hO,
        index: W,
        disabled: Z
      }));
    }, he = function() {
      d({
        type: fm,
        index: W
      });
    }, Re = function(Ue) {
      return Ue.preventDefault();
    };
    return Xe((H = {}, H[G] = Ws(ne, function(Ae) {
      Ae && (v.current[w.getItemId(W)] = Ae);
    }), H["aria-disabled"] = Z, H["aria-selected"] = "" + (W === xe.highlightedIndex), H.id = w.getItemId(W), H.role = "option", H), !Z && (q = {}, q[me] = mn(ie, he), q), {
      onMouseMove: mn(Q, oe),
      onMouseDown: mn(re, Re)
    }, Ee);
  }, [d, S, M, w]), $ = ot(function(j) {
    var H, q = j === void 0 ? {} : j, B = q.onClick;
    q.onPress;
    var X = q.refKey, te = X === void 0 ? "ref" : X, J = q.ref, G = Ir(q, UH), ne = S.current.state, Q = function() {
      d({
        type: pO
      });
    };
    return Xe((H = {}, H[te] = Ws(J, function(re) {
      x.current = re;
    }), H["aria-controls"] = w.menuId, H["aria-expanded"] = ne.isOpen, H.id = w.toggleButtonId, H.tabIndex = -1, H), !G.disabled && Xe({}, {
      onClick: mn(B, Q)
    }), G);
  }, [d, S, w]), L = ot(function(j, H) {
    var q, B = j === void 0 ? {} : j, X = B.onKeyDown, te = B.onChange, J = B.onInput, G = B.onBlur;
    B.onChangeText;
    var ne = B.onClick, Q = B.refKey, re = Q === void 0 ? "ref" : Q, fe = B.ref, le = Ir(B, GH), Ee = H === void 0 ? {} : H, se = Ee.suppressRefError, _e = se === void 0 ? !1 : se;
    P("getInputProps", _e, re, y);
    var xe = S.current.state, ge = function(Re) {
      var Ae = Ch(Re);
      Ae && I[Ae] && I[Ae](Re);
    }, ae = function(Re) {
      d({
        type: um,
        inputValue: Re.target.value
      });
    }, W = function(Re) {
      if (xe.isOpen && !T.current.isMouseDown) {
        var Ae = Re.relatedTarget === null && o.document.activeElement !== o.document.body;
        d({
          type: Xc,
          selectItem: !Ae
        });
      }
    }, Z = function() {
      d({
        type: dm
      });
    }, me = "onChange", ie = {};
    if (!le.disabled) {
      var oe;
      ie = (oe = {}, oe[me] = mn(te, J, ae), oe.onKeyDown = mn(X, ge), oe.onBlur = mn(G, W), oe.onClick = mn(ne, Z), oe);
    }
    return Xe((q = {}, q[re] = Ws(fe, function(he) {
      y.current = he;
    }), q["aria-activedescendant"] = xe.isOpen && xe.highlightedIndex > -1 ? w.getItemId(xe.highlightedIndex) : "", q["aria-autocomplete"] = "list", q["aria-controls"] = w.menuId, q["aria-expanded"] = xe.isOpen, q["aria-labelledby"] = le && le["aria-label"] ? void 0 : w.labelId, q.autoComplete = "off", q.id = w.inputId, q.role = "combobox", q.value = xe.inputValue, q), ie, le);
  }, [P, S, w, I, d, T, o]), A = ot(function() {
    d({
      type: gO
    });
  }, [d]), F = ot(function() {
    d({
      type: bO
    });
  }, [d]), N = ot(function() {
    d({
      type: mO
    });
  }, [d]), V = ot(function(j) {
    d({
      type: vO,
      highlightedIndex: j
    });
  }, [d]), K = ot(function(j) {
    d({
      type: hm,
      selectedItem: j
    });
  }, [d]), Y = ot(function(j) {
    d({
      type: yO,
      inputValue: j
    });
  }, [d]), U = ot(function() {
    d({
      type: xO
    });
  }, [d]);
  return {
    // prop getters.
    getItemProps: k,
    getLabelProps: R,
    getMenuProps: D,
    getInputProps: L,
    getToggleButtonProps: $,
    // actions.
    toggleMenu: A,
    openMenu: N,
    closeMenu: F,
    setHighlightedIndex: V,
    setInputValue: Y,
    selectItem: K,
    reset: U,
    // state.
    highlightedIndex: h,
    isOpen: f,
    selectedItem: p,
    inputValue: g
  };
}
function KH(e) {
  var t = e.removedSelectedItem, n = e.itemToString;
  return n(t) + " has been removed.";
}
Xe({}, uO, {
  selectedItems: ve.array,
  initialSelectedItems: ve.array,
  defaultSelectedItems: ve.array,
  getA11yRemovalMessage: ve.func,
  activeIndex: ve.number,
  initialActiveIndex: ve.number,
  defaultActiveIndex: ve.number,
  onActiveIndexChange: ve.func,
  onSelectedItemsChange: ve.func,
  keyNavigationNext: ve.string,
  keyNavigationPrevious: ve.string
});
oa.itemToString, oa.stateReducer, oa.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
export {
  uB as AccessDeniedIllustration,
  o9 as Alert,
  n9 as Badge,
  yB as BasePopover,
  OB as Breadcrumb,
  uc as Button,
  zM as ButtonGroup,
  qy as ButtonSpinner,
  a_ as Calendar,
  i9 as Card,
  nB as Chart,
  Fu as ChartJS,
  W3 as ChartProvider,
  TE as Checkbox,
  iA as CircleChart,
  _B as Collapsible,
  xB as Combobox,
  p9 as CopyIconButton,
  SB as CopyIdButton,
  QV as DateInput,
  qV as DatePicker,
  QH as Dialog,
  oB as DiffPercentageBadge,
  sB as EmptyStateIllustration,
  cB as EmptyStateIllustration10,
  iB as EmptyStateIllustration2,
  aB as EmptyStateIllustration3,
  lB as EmptyStateIllustration4,
  lA as HorizontalBarsChart,
  ia as IconButton,
  EE as Input,
  P9 as InputOTP,
  Ag as Link,
  a9 as LinkBox,
  l9 as LinkOverlay,
  wB as Menu,
  c9 as NoMatchingResultIllustration,
  W9 as Option,
  V9 as OptionsGroup,
  EB as OverflowIndicator,
  rx as OverflowText,
  hB as Popover,
  mB as PopoverArrow,
  gB as PopoverClose,
  bB as PopoverContent,
  pB as PopoverTrigger,
  rA as Portal,
  vB as ProgressBar,
  Dw as ProgressRadial,
  $9 as Radio,
  v0 as SearchIllustration,
  CB as Sheet,
  $P as Skeleton,
  Bu as Slot,
  AW as Stepper,
  dB as Switch,
  MB as Tabs,
  RB as ToastProvider,
  Lt as Tooltip,
  wb as TooltipProvider,
  kP as TooltipRoot,
  RW as UploadArea,
  r9 as alertVariants,
  t9 as badgeVariants,
  Ih as buttonVariants,
  de as cn,
  rB as createScale,
  Qn as cva,
  IB as formatCurrency,
  kB as formatNumber,
  Xr as getColorFromCssVariable,
  YM as iconButtonVariants,
  F9 as linkVariants,
  A9 as switchThumbVariants,
  N9 as switchVariants,
  TB as toast,
  Uc as toastManager,
  xa as useCallbackRef,
  Ya as useChart,
  EO as useCombobox,
  CE as useCopyToClipboard,
  jn as useDateInput,
  ly as useUncontrolled,
  PB as useUploadFile
};
